/* tslint:disable */
/* eslint-disable */
/**
 * Portal Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2026-10-01 14:18:02
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbsenceBulkRequestContainer
 */
export interface AbsenceBulkRequestContainer {
    /**
     * 
     * @type {AbsenceEntry}
     * @memberof AbsenceBulkRequestContainer
     */
    absenceTemplate: AbsenceEntry;
    /**
     * 
     * @type {Array<string>}
     * @memberof AbsenceBulkRequestContainer
     */
    studentIds: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceCategory {
    late = 'Late',
    leftEarly = 'LeftEarly',
    missing = 'Missing'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceCheckFrequency {
    never = 'Never',
    firstLesson = 'FirstLesson',
    everyLesson = 'EveryLesson'
}

/**
 * 
 * @export
 * @interface AbsenceDraftResponse
 */
export interface AbsenceDraftResponse {
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    timePeriod: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    reason?: string | null;
    /**
     * 
     * @type {AbsenceDraftState}
     * @memberof AbsenceDraftResponse
     */
    state?: AbsenceDraftState;
    /**
     * 
     * @type {number}
     * @memberof AbsenceDraftResponse
     */
    timeSlotStart?: number;
    /**
     * 
     * @type {number}
     * @memberof AbsenceDraftResponse
     */
    timeSlotEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    description?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof AbsenceDraftResponse
     */
    student: Person;
    /**
     * 
     * @type {Author}
     * @memberof AbsenceDraftResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    submittedOn?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    className?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceDraftResponse
     */
    gradeName?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceDraftState {
    submitted = 'Submitted',
    accepted = 'Accepted',
    declined = 'Declined',
    sentByMail = 'SentByMail'
}

/**
 * 
 * @export
 * @interface AbsenceEntry
 */
export interface AbsenceEntry {
    /**
     * 
     * @type {string}
     * @memberof AbsenceEntry
     */
    affectedStudent: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceEntry
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceEntry
     */
    offset?: string | null;
    /**
     * 
     * @type {AbsenceReasonIdOnly}
     * @memberof AbsenceEntry
     */
    reason?: AbsenceReasonIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceEntry
     */
    start: string;
}
/**
 * 
 * @export
 * @interface AbsenceOverview
 */
export interface AbsenceOverview {
    /**
     * 
     * @type {number}
     * @memberof AbsenceOverview
     */
    previousSkip?: number;
    /**
     * 
     * @type {number}
     * @memberof AbsenceOverview
     */
    previousTake?: number;
    /**
     * 
     * @type {Array<StudentAbsenceOverview>}
     * @memberof AbsenceOverview
     */
    students: Array<StudentAbsenceOverview>;
    /**
     * 
     * @type {number}
     * @memberof AbsenceOverview
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface AbsencePutEntry
 */
export interface AbsencePutEntry {
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    affectedStudent: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    offset?: string | null;
    /**
     * 
     * @type {AbsenceReasonIdOnly}
     * @memberof AbsencePutEntry
     */
    reason?: AbsenceReasonIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof AbsencePutEntry
     */
    start: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceReasonCategory {
    none = 'None',
    leftEarly = 'LeftEarly',
    late = 'Late'
}

/**
 * 
 * @export
 * @interface AbsenceReasonEmbedded
 */
export interface AbsenceReasonEmbedded {
    /**
     * 
     * @type {AbsenceReasonCategory}
     * @memberof AbsenceReasonEmbedded
     */
    category?: AbsenceReasonCategory;
    /**
     * 
     * @type {ExcuseDefinitionEmbedded}
     * @memberof AbsenceReasonEmbedded
     */
    definition?: ExcuseDefinitionEmbedded | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEmbedded
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEmbedded
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEmbedded
     */
    revisionsId?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEmbedded
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonEmbedded
     */
    includeInStatistics?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEmbedded
     */
    shortName?: string | null;
}
/**
 * 
 * @export
 * @interface AbsenceReasonEntry
 */
export interface AbsenceReasonEntry {
    /**
     * 
     * @type {AbsenceReasonCategory}
     * @memberof AbsenceReasonEntry
     */
    category?: AbsenceReasonCategory;
    /**
     * 
     * @type {ExcuseDefinitionIdOnly}
     * @memberof AbsenceReasonEntry
     */
    definition?: ExcuseDefinitionIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEntry
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonEntry
     */
    includeInStatistics?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonEntry
     */
    shortName?: string | null;
}
/**
 * 
 * @export
 * @interface AbsenceReasonIdOnly
 */
export interface AbsenceReasonIdOnly {
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonIdOnly
     */
    excuseDefinitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonIdOnly
     */
    id: string;
}
/**
 * 
 * @export
 * @interface AbsenceReasonPutEntry
 */
export interface AbsenceReasonPutEntry {
    /**
     * 
     * @type {AbsenceReasonCategory}
     * @memberof AbsenceReasonPutEntry
     */
    category?: AbsenceReasonCategory;
    /**
     * 
     * @type {ExcuseDefinitionIdOnly}
     * @memberof AbsenceReasonPutEntry
     */
    definition?: ExcuseDefinitionIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonPutEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonPutEntry
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonPutEntry
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonPutEntry
     */
    includeInStatistics?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonPutEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonPutEntry
     */
    shortName?: string | null;
}
/**
 * 
 * @export
 * @interface AbsenceReasonResponse
 */
export interface AbsenceReasonResponse {
    /**
     * 
     * @type {AbsenceReasonCategory}
     * @memberof AbsenceReasonResponse
     */
    category?: AbsenceReasonCategory;
    /**
     * 
     * @type {Author}
     * @memberof AbsenceReasonResponse
     */
    createdBy?: Author | null;
    /**
     * 
     * @type {ExcuseDefinitionResponse}
     * @memberof AbsenceReasonResponse
     */
    definition?: ExcuseDefinitionResponse | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonResponse
     */
    includeInStatistics: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AbsenceReasonResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonResponse
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof AbsenceReasonResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface AbsenceResponse
 */
export interface AbsenceResponse {
    /**
     * 
     * @type {AbsenceReasonResponse}
     * @memberof AbsenceResponse
     */
    absenceReason?: AbsenceReasonResponse | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    draftReason?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof AbsenceResponse
     */
    affectedStudent: Person;
    /**
     * 
     * @type {Author}
     * @memberof AbsenceResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AbsenceResponse
     */
    effectiveMissingLessons?: number;
    /**
     * 
     * @type {number}
     * @memberof AbsenceResponse
     */
    effectiveMissingMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    end?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    id?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AbsenceResponse
     */
    lessonIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    offset?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    start?: string | null;
    /**
     * 
     * @type {AbsenceState}
     * @memberof AbsenceResponse
     */
    state: AbsenceState;
    /**
     * 
     * @type {AbsenceDraftState}
     * @memberof AbsenceResponse
     */
    draftState?: AbsenceDraftState | null;
    /**
     * 
     * @type {TimeSlot}
     * @memberof AbsenceResponse
     */
    timeSlotEnd: TimeSlot;
    /**
     * 
     * @type {TimeSlot}
     * @memberof AbsenceResponse
     */
    timeSlotStart: TimeSlot;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    predecessorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    historyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AbsenceResponse
     */
    attachments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    createdAt?: string | null;
    /**
     * 
     * @type {Author}
     * @memberof AbsenceResponse
     */
    modifiedBy: Author;
    /**
     * 
     * @type {string}
     * @memberof AbsenceResponse
     */
    modifiedAt: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceState {
    unchecked = 'Unchecked',
    absent = 'Absent',
    absentExcused = 'AbsentExcused',
    present = 'Present',
    draft = 'Draft'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsenceSubmissionDeadline {
    noRestriction = 'NoRestriction',
    untilLessonStart = 'UntilLessonStart',
    untilEndOfDay = 'UntilEndOfDay',
    oneDayBefore = 'OneDayBefore',
    twoDaysBefore = 'TwoDaysBefore',
    threeDaysBefore = 'ThreeDaysBefore'
}

/**
 * 
 * @export
 * @interface AbsencesAmount
 */
export interface AbsencesAmount {
    /**
     * 
     * @type {number}
     * @memberof AbsencesAmount
     */
    count: number;
}
/**
 * 
 * @export
 * @interface AbsencesCreateOrUpdateLists
 */
export interface AbsencesCreateOrUpdateLists {
    /**
     * 
     * @type {Array<AbsenceEntry>}
     * @memberof AbsencesCreateOrUpdateLists
     */
    creates?: Array<AbsenceEntry> | null;
    /**
     * 
     * @type {Array<AbsencePutEntry>}
     * @memberof AbsencesCreateOrUpdateLists
     */
    updates?: Array<AbsencePutEntry> | null;
}
/**
 * 
 * @export
 * @interface AbsencesDeleteAttachmentRequest
 */
export interface AbsencesDeleteAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof AbsencesDeleteAttachmentRequest
     */
    absenceId: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesDeleteAttachmentRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesDeleteAttachmentRequest
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesDeleteAttachmentRequest
     */
    timePeriod: string;
}
/**
 * 
 * @export
 * @interface AbsencesGetAttachmentRequest
 */
export interface AbsencesGetAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof AbsencesGetAttachmentRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesGetAttachmentRequest
     */
    absenceId: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesGetAttachmentRequest
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof AbsencesGetAttachmentRequest
     */
    timePeriod: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AbsencesGetOfStudentRequestFilter {
    all = 'All',
    absent = 'Absent',
    present = 'Present'
}

/**
 * 
 * @export
 * @interface AccountEnabledOptions
 */
export interface AccountEnabledOptions {
    /**
     * 
     * @type {boolean}
     * @memberof AccountEnabledOptions
     */
    accountEnabled?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ActionState {
    none = 'None',
    pending = 'Pending',
    canceled = 'Canceled',
    active = 'Active',
    done = 'Done',
    failed = 'Failed',
    notSupported = 'NotSupported'
}

/**
 * 
 * @export
 * @interface ActionsResponse
 */
export interface ActionsResponse {
    /**
     * 
     * @type {Array<DeviceActionResponse>}
     * @memberof ActionsResponse
     */
    deviceActions?: Array<DeviceActionResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ActivationState {
    deactivate = 'deactivate',
    activate = 'activate'
}

/**
 * 
 * @export
 * @interface ActivityLogResponse
 */
export interface ActivityLogResponse {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    issueType: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface AddParentRequest
 */
export interface AddParentRequest {
    /**
     * 
     * @type {string}
     * @memberof AddParentRequest
     */
    organizationId: string;
    /**
     * 
     * @type {Parent}
     * @memberof AddParentRequest
     */
    parent: Parent;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AgeGroup {
    /**
    * NO_AGE_GROUP
    */
    none = 'None',
    /**
    * MINOR_AGE_GROUP
    */
    minor = 'Minor',
    /**
    * NOT_ADULT_AGE_GROUP
    */
    notAdult = 'NotAdult',
    /**
    * ADULT_AGE_GROUP
    */
    adult = 'Adult'
}

/**
 * 
 * @export
 * @interface AllowedActions
 */
export interface AllowedActions {
    /**
     * 
     * @type {Array<string>}
     * @memberof AllowedActions
     */
    deviceManagement: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AllowedActions
     */
    directory: Array<string>;
}
/**
 * 
 * @export
 * @interface AllowedActionsGetRequest
 */
export interface AllowedActionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AllowedActionsGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedActionsGetRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface AllowedActionsResponse
 */
export interface AllowedActionsResponse {
    /**
     * 
     * @type {AllowedActions}
     * @memberof AllowedActionsResponse
     */
    current: AllowedActions;
    /**
     * 
     * @type {AllowedActions}
     * @memberof AllowedActionsResponse
     */
    desired: AllowedActions;
}
/**
 * 
 * @export
 * @interface AllowedActionsSyncCheckRequest
 */
export interface AllowedActionsSyncCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof AllowedActionsSyncCheckRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface AllowedActionsSyncRequest
 */
export interface AllowedActionsSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof AllowedActionsSyncRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AllowedName {
    none = 'None',
    /**
    * The user has full rights.
    */
    all = 'All',
    /**
    * The user can reset the password of all users within the entity or any child entity.
    */
    resetPassword = 'ResetPassword',
    /**
    * The user can CUD on UserTemplates. This can only be applied on Organisation or Tenant level.
    */
    manageUserTemplates = 'ManageUserTemplates',
    /**
    * The user can create user accounts. This claim has a suffix of &quot;|{templateId:guid}&quot; to declare which kind of accounts the user can create.
    */
    createUserAccountFromTemplate = 'CreateUserAccountFromTemplate',
    /**
    * Allows a user to promote herself to a member of a user group.
    */
    joinOtherGroup = 'JoinOtherGroup',
    /**
    * Allows a user to manage networks if the corresponding interface is configured.
    */
    networkManager = 'NetworkManager',
    /**
    * Allows a user to manage resources.
    */
    resourcesManager = 'ResourcesManager',
    /**
    * Allows a user to manage users.
    */
    usersManager = 'UsersManager',
    /**
    * Allows a user to manage groups.
    */
    groupsManager = 'GroupsManager',
    /**
    * Allows a user to manage organizations.
    */
    organizationsManager = 'OrganizationsManager',
    /**
    * Allows a user to manage devices.
    */
    devicesManager = 'DevicesManager',
    /**
    * 
    */
    schoolLinksManager = 'SchoolLinksManager'
}

/**
 * 
 * @export
 * @interface AnalyzeRequest
 */
export interface AnalyzeRequest {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeRequest
     */
    timePeriod: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeRequest
     */
    templateId: string;
    /**
     * If true we have to return all users (never managers!) within this organization with status obsolete.
     * @type {boolean}
     * @memberof AnalyzeRequest
     */
    deleteExistingUsers: boolean;
    /**
     * User won\'t be created nor group members won\'t be updated. Instead only the meta-informations for users will be updated accordingly.
     * @type {boolean}
     * @memberof AnalyzeRequest
     */
    addMetadataOnly: boolean;
    /**
     * 
     * @type {Array<AnalyzeUser>}
     * @memberof AnalyzeRequest
     */
    analyzeUsers: Array<AnalyzeUser>;
}
/**
 * 
 * @export
 * @interface AnalyzeResponse
 */
export interface AnalyzeResponse {
    /**
     * 
     * @type {Array<AnalyzedUser>}
     * @memberof AnalyzeResponse
     */
    users: Array<AnalyzedUser>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AnalyzeState {
    unknown = 'Unknown',
    new = 'New',
    matches = 'Matches',
    conflict = 'Conflict',
    obsolete = 'Obsolete',
    failure = 'Failure'
}

/**
 * 
 * @export
 * @interface AnalyzeUser
 */
export interface AnalyzeUser {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    userPrincipalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    referenceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    birthday?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    streetAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    parentalMailAddresses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUser
     */
    emergencyPhoneNumbers?: string | null;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof AnalyzeUser
     */
    groups: Array<Membership>;
}
/**
 * 
 * @export
 * @interface AnalyzeUserAllOf
 */
export interface AnalyzeUserAllOf {
    /**
     * 
     * @type {Array<Membership>}
     * @memberof AnalyzeUserAllOf
     */
    groups: Array<Membership>;
}
/**
 * 
 * @export
 * @interface AnalyzeUserBase
 */
export interface AnalyzeUserBase {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    userPrincipalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    referenceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    birthday?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    streetAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    parentalMailAddresses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzeUserBase
     */
    emergencyPhoneNumbers?: string | null;
}
/**
 * 
 * @export
 * @interface AnalyzedGroupMembership
 */
export interface AnalyzedGroupMembership {
    /**
     * 
     * @type {string}
     * @memberof AnalyzedGroupMembership
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedGroupMembership
     */
    mailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedGroupMembership
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalyzedGroupMembership
     */
    exists?: boolean;
}
/**
 * 
 * @export
 * @interface AnalyzedMembership
 */
export interface AnalyzedMembership {
    /**
     * 
     * @type {string}
     * @memberof AnalyzedMembership
     */
    template?: string | null;
    /**
     * 
     * @type {Array<AnalyzedGroupMembership>}
     * @memberof AnalyzedMembership
     */
    groups?: Array<AnalyzedGroupMembership> | null;
}
/**
 * 
 * @export
 * @interface AnalyzedUser
 */
export interface AnalyzedUser {
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    userPrincipalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    referenceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    birthday?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    streetAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    parentalMailAddresses?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    emergencyPhoneNumbers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUser
     */
    id?: string | null;
    /**
     * 
     * @type {AnalyzeState}
     * @memberof AnalyzedUser
     */
    state?: AnalyzeState;
    /**
     * 
     * @type {Array<ErrorResponse>}
     * @memberof AnalyzedUser
     */
    errors?: Array<ErrorResponse> | null;
    /**
     * 
     * @type {Array<AnalyzedMembership>}
     * @memberof AnalyzedUser
     */
    analyzedMemberships?: Array<AnalyzedMembership> | null;
    /**
     * 
     * @type {Array<AnalyzedGroupMembership>}
     * @memberof AnalyzedUser
     */
    analyzedMembershipRemovements?: Array<AnalyzedGroupMembership> | null;
}
/**
 * 
 * @export
 * @interface AnalyzedUserAllOf
 */
export interface AnalyzedUserAllOf {
    /**
     * 
     * @type {string}
     * @memberof AnalyzedUserAllOf
     */
    id?: string | null;
    /**
     * 
     * @type {AnalyzeState}
     * @memberof AnalyzedUserAllOf
     */
    state?: AnalyzeState;
    /**
     * 
     * @type {Array<ErrorResponse>}
     * @memberof AnalyzedUserAllOf
     */
    errors?: Array<ErrorResponse> | null;
    /**
     * 
     * @type {Array<AnalyzedMembership>}
     * @memberof AnalyzedUserAllOf
     */
    analyzedMemberships?: Array<AnalyzedMembership> | null;
    /**
     * 
     * @type {Array<AnalyzedGroupMembership>}
     * @memberof AnalyzedUserAllOf
     */
    analyzedMembershipRemovements?: Array<AnalyzedGroupMembership> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AndroidDeviceOwnerBatteryPluggedMode {
    notConfigured = 'NotConfigured',
    ac = 'Ac',
    usb = 'Usb',
    wireless = 'Wireless'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AndroidDeviceOwnerCrossProfileDataSharing {
    notConfigured = 'NotConfigured',
    crossProfileDataSharingBlocked = 'CrossProfileDataSharingBlocked',
    dataSharingFromWorkToPersonalBlocked = 'DataSharingFromWorkToPersonalBlocked',
    crossProfileDataSharingAllowed = 'CrossProfileDataSharingAllowed',
    unkownFutureValue = 'UnkownFutureValue'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AndroidDeviceOwnerRequiredPasswordUnlock {
    deviceDefault = 'DeviceDefault',
    daily = 'Daily',
    unkownFutureValue = 'UnkownFutureValue'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum AndroidDeviceOwnerSystemUpdateInstallType {
    deviceDefault = 'DeviceDefault',
    postpone = 'Postpone',
    windowed = 'Windowed',
    automatic = 'Automatic'
}

/**
 * 
 * @export
 * @interface AndroidDeviceRestrictionsEntry
 */
export interface AndroidDeviceRestrictionsEntry {
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    bluetoothBlockConfiguration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    bluetoothContactSharing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    wallpaperUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    dateTimeConfigurationBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    factoryResetBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    googleAccountsBlocked?: boolean;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    passwordRequiredType?: RequiredPasswortType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    personalProfileScreenCaptureBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    personalProfileCameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    usersBlockAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    usersBlockRemove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    storageAllowUsb?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    deviceOwnerLockScreenMessage?: string;
    /**
     * 
     * @type {PasswordMinutesOfInactivityValues}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    passwordMinutesOfInactivityBeforeScreenTimeout?: PasswordMinutesOfInactivityValues;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    accountsBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    securityRequireVerifyApps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    certificateCredentialConfigurationDisabled?: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerCrossProfileDataSharing}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    crossProfilePoliciesAllowDataSharing: AndroidDeviceOwnerCrossProfileDataSharing;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    dataRoamingBlocked?: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerRequiredPasswordUnlock}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    passwordRequireUnlock: AndroidDeviceOwnerRequiredPasswordUnlock;
    /**
     * 
     * @type {Array<AndroidDeviceOwnerBatteryPluggedMode>}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    stayOnModes: Array<AndroidDeviceOwnerBatteryPluggedMode>;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    systemUpdateWindowStartMinutesAfterMidnight?: number;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    systemUpdateWindowEndMinutesAfterMidnight?: number;
    /**
     * 
     * @type {AndroidDeviceOwnerSystemUpdateInstallType}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    systemUpdateInstallType?: AndroidDeviceOwnerSystemUpdateInstallType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    vpnAlwaysOnLockdownMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    vpnAlwaysOnPackageIdentifier?: string;
    /**
     * 
     * @type {PersonalProfilePersonalPlayStoreMode}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    personalProfilePlayStoreMode?: PersonalProfilePersonalPlayStoreMode;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsEntry
     */
    workProfilePasswordRequiredType?: RequiredPasswortType;
}
/**
 * 
 * @export
 * @interface AndroidDeviceRestrictionsEntryAllOf
 */
export interface AndroidDeviceRestrictionsEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    bluetoothBlockConfiguration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    bluetoothContactSharing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    wallpaperUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    dateTimeConfigurationBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    factoryResetBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    googleAccountsBlocked?: boolean;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    passwordRequiredType?: RequiredPasswortType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    personalProfileScreenCaptureBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    personalProfileCameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    usersBlockAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    usersBlockRemove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    storageAllowUsb?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    deviceOwnerLockScreenMessage?: string;
    /**
     * 
     * @type {PasswordMinutesOfInactivityValues}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    passwordMinutesOfInactivityBeforeScreenTimeout?: PasswordMinutesOfInactivityValues;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    accountsBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    securityRequireVerifyApps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    certificateCredentialConfigurationDisabled?: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerCrossProfileDataSharing}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    crossProfilePoliciesAllowDataSharing: AndroidDeviceOwnerCrossProfileDataSharing;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    dataRoamingBlocked?: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerRequiredPasswordUnlock}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    passwordRequireUnlock: AndroidDeviceOwnerRequiredPasswordUnlock;
    /**
     * 
     * @type {Array<AndroidDeviceOwnerBatteryPluggedMode>}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    stayOnModes: Array<AndroidDeviceOwnerBatteryPluggedMode>;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    systemUpdateWindowStartMinutesAfterMidnight?: number;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    systemUpdateWindowEndMinutesAfterMidnight?: number;
    /**
     * 
     * @type {AndroidDeviceOwnerSystemUpdateInstallType}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    systemUpdateInstallType?: AndroidDeviceOwnerSystemUpdateInstallType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    vpnAlwaysOnLockdownMode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    vpnAlwaysOnPackageIdentifier?: string;
    /**
     * 
     * @type {PersonalProfilePersonalPlayStoreMode}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    personalProfilePlayStoreMode?: PersonalProfilePersonalPlayStoreMode;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsEntryAllOf
     */
    workProfilePasswordRequiredType?: RequiredPasswortType;
}
/**
 * 
 * @export
 * @interface AndroidDeviceRestrictionsResponse
 */
export interface AndroidDeviceRestrictionsResponse {
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    assignedGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    bluetoothBlockConfiguration: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    bluetoothContactSharing: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    wallpaperUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    dateTimeConfigurationBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    factoryResetBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    googleAccountsBlocked: boolean;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    passwordRequiredType: RequiredPasswortType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    personalProfileScreenCaptureBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    personalProfileCameraBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    usersBlockAdd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    usersBlockRemove: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    storageAllowUsb: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    deviceOwnerLockScreenMessage: string;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    passwordMinutesOfInactivityBeforeScreenTimeout: number;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    accountsBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    securityRequireVerifyApps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    certificateCredentialConfigurationDisabled: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerCrossProfileDataSharing}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    crossProfilePoliciesAllowDataSharing: AndroidDeviceOwnerCrossProfileDataSharing;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    dataRoamingBlocked: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerRequiredPasswordUnlock}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    passwordRequireUnlock: AndroidDeviceOwnerRequiredPasswordUnlock;
    /**
     * 
     * @type {Array<AndroidDeviceOwnerBatteryPluggedMode>}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    stayOnModes: Array<AndroidDeviceOwnerBatteryPluggedMode>;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    systemUpdateWindowStartMinutesAfterMidnight: number;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    systemUpdateWindowEndMinutesAfterMidnight: number;
    /**
     * 
     * @type {AndroidDeviceOwnerSystemUpdateInstallType}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    systemUpdateInstallType: AndroidDeviceOwnerSystemUpdateInstallType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    vpnAlwaysOnLockdownMode: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    vpnAlwaysOnPackageIdentifier: string;
    /**
     * 
     * @type {PersonalProfilePersonalPlayStoreMode}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    personalProfilePlayStoreMode: PersonalProfilePersonalPlayStoreMode;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsResponse
     */
    workProfilePasswordRequiredType: RequiredPasswortType;
}
/**
 * 
 * @export
 * @interface AndroidDeviceRestrictionsResponseAllOf
 */
export interface AndroidDeviceRestrictionsResponseAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    assignedGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    bluetoothBlockConfiguration: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    bluetoothContactSharing: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    wallpaperUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    dateTimeConfigurationBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    factoryResetBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    googleAccountsBlocked: boolean;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    passwordRequiredType: RequiredPasswortType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    personalProfileScreenCaptureBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    personalProfileCameraBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    usersBlockAdd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    usersBlockRemove: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    storageAllowUsb: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    deviceOwnerLockScreenMessage: string;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    passwordMinutesOfInactivityBeforeScreenTimeout: number;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    accountsBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    securityRequireVerifyApps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    certificateCredentialConfigurationDisabled: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerCrossProfileDataSharing}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    crossProfilePoliciesAllowDataSharing: AndroidDeviceOwnerCrossProfileDataSharing;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    dataRoamingBlocked: boolean;
    /**
     * 
     * @type {AndroidDeviceOwnerRequiredPasswordUnlock}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    passwordRequireUnlock: AndroidDeviceOwnerRequiredPasswordUnlock;
    /**
     * 
     * @type {Array<AndroidDeviceOwnerBatteryPluggedMode>}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    stayOnModes: Array<AndroidDeviceOwnerBatteryPluggedMode>;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    systemUpdateWindowStartMinutesAfterMidnight: number;
    /**
     * 
     * @type {number}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    systemUpdateWindowEndMinutesAfterMidnight: number;
    /**
     * 
     * @type {AndroidDeviceOwnerSystemUpdateInstallType}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    systemUpdateInstallType: AndroidDeviceOwnerSystemUpdateInstallType;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    vpnAlwaysOnLockdownMode: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    vpnAlwaysOnPackageIdentifier: string;
    /**
     * 
     * @type {PersonalProfilePersonalPlayStoreMode}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    personalProfilePlayStoreMode: PersonalProfilePersonalPlayStoreMode;
    /**
     * 
     * @type {RequiredPasswortType}
     * @memberof AndroidDeviceRestrictionsResponseAllOf
     */
    workProfilePasswordRequiredType: RequiredPasswortType;
}
/**
 * 
 * @export
 * @interface AndroidManagedStoreAppResponse
 */
export interface AndroidManagedStoreAppResponse {
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponse
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidManagedStoreAppResponse
     */
    assignedGroupIds: Array<string>;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof AndroidManagedStoreAppResponse
     */
    targetedMobileApps: Array<BasicSoftwareResponse>;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponse
     */
    packageId: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponse
     */
    profileApplicability: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidManagedStoreAppResponse
     */
    appSupportsOemConfig: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidManagedStoreAppResponse
     */
    connectedAppsEnabled: boolean;
    /**
     * 
     * @type {Array<KeyTypedValuePairResponse>}
     * @memberof AndroidManagedStoreAppResponse
     */
    payload: Array<KeyTypedValuePairResponse>;
}
/**
 * 
 * @export
 * @interface AndroidManagedStoreAppResponseAllOf
 */
export interface AndroidManagedStoreAppResponseAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    assignedGroupIds: Array<string>;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    targetedMobileApps: Array<BasicSoftwareResponse>;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    packageId: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    profileApplicability: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    appSupportsOemConfig: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    connectedAppsEnabled: boolean;
    /**
     * 
     * @type {Array<KeyTypedValuePairResponse>}
     * @memberof AndroidManagedStoreAppResponseAllOf
     */
    payload: Array<KeyTypedValuePairResponse>;
}
/**
 * 
 * @export
 * @interface AndroidProfilesAbstractEntry
 */
export interface AndroidProfilesAbstractEntry {
    /**
     * 
     * @type {string}
     * @memberof AndroidProfilesAbstractEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidProfilesAbstractEntry
     */
    description: string;
}
/**
 * 
 * @export
 * @interface AndroidProfilesAbstractResponse
 */
export interface AndroidProfilesAbstractResponse {
    /**
     * 
     * @type {string}
     * @memberof AndroidProfilesAbstractResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidProfilesAbstractResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidProfilesAbstractResponse
     */
    description: string;
}
/**
 * 
 * @export
 * @interface AndroidWiFiConfigurationResponse
 */
export interface AndroidWiFiConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof AndroidWiFiConfigurationResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponse
     */
    connectAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponse
     */
    connectWhenNetworkNameIsHidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    networkName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponse
     */
    wiFiSecurityType: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponse
     */
    preSharedKeyIsSet: boolean;
}
/**
 * 
 * @export
 * @interface AndroidWiFiConfigurationResponseAllOf
 */
export interface AndroidWiFiConfigurationResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    connectAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    connectWhenNetworkNameIsHidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    networkName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    wiFiSecurityType: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWiFiConfigurationResponseAllOf
     */
    preSharedKeyIsSet: boolean;
}
/**
 * 
 * @export
 * @interface AndroidWifiConfigurationEntry
 */
export interface AndroidWifiConfigurationEntry {
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidWifiConfigurationEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntry
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntry
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntry
     */
    networkName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntry
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntry
     */
    preSharedKeyIsSet?: boolean;
}
/**
 * 
 * @export
 * @interface AndroidWifiConfigurationEntryAllOf
 */
export interface AndroidWifiConfigurationEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    networkName: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWifiConfigurationEntryAllOf
     */
    preSharedKeyIsSet?: boolean;
}
/**
 * 
 * @export
 * @interface AnnouncementBasicResponse
 */
export interface AnnouncementBasicResponse {
    /**
     * 
     * @type {Array<Area>}
     * @memberof AnnouncementBasicResponse
     */
    area: Array<Area>;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementBasicResponse
     */
    isEnabled: boolean;
    /**
     * 
     * @type {Limitation}
     * @memberof AnnouncementBasicResponse
     */
    limit: Limitation;
    /**
     * 
     * @type {AnnouncementSeverity}
     * @memberof AnnouncementBasicResponse
     */
    severity: AnnouncementSeverity;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementBasicResponse
     */
    title: string;
}
/**
 * 
 * @export
 * @interface AnnouncementCreate
 */
export interface AnnouncementCreate {
    /**
     * 
     * @type {Array<Area>}
     * @memberof AnnouncementCreate
     */
    area: Array<Area>;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    end: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementCreate
     */
    isEnabled: boolean;
    /**
     * 
     * @type {Limitation}
     * @memberof AnnouncementCreate
     */
    limit?: Limitation;
    /**
     * 
     * @type {RecipientsBasic}
     * @memberof AnnouncementCreate
     */
    recipients: RecipientsBasic;
    /**
     * 
     * @type {AnnouncementSeverity}
     * @memberof AnnouncementCreate
     */
    severity?: AnnouncementSeverity;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementCreate
     */
    title: string;
}
/**
 * 
 * @export
 * @interface AnnouncementResponse
 */
export interface AnnouncementResponse {
    /**
     * 
     * @type {Array<Area>}
     * @memberof AnnouncementResponse
     */
    area: Array<Area>;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementResponse
     */
    isEnabled: boolean;
    /**
     * 
     * @type {Limitation}
     * @memberof AnnouncementResponse
     */
    limit: Limitation;
    /**
     * 
     * @type {Author}
     * @memberof AnnouncementResponse
     */
    owner: Author;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    predecessorId?: string | null;
    /**
     * 
     * @type {Recipients}
     * @memberof AnnouncementResponse
     */
    recipients: Recipients;
    /**
     * 
     * @type {AnnouncementSeverity}
     * @memberof AnnouncementResponse
     */
    severity: AnnouncementSeverity;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementResponse
     */
    title: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AnnouncementSeverity {
    info = 'Info',
    important = 'Important',
    warning = 'Warning'
}

/**
 * 
 * @export
 * @interface AnnouncementUpdate
 */
export interface AnnouncementUpdate {
    /**
     * 
     * @type {Array<Area>}
     * @memberof AnnouncementUpdate
     */
    area: Array<Area>;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnouncementUpdate
     */
    isEnabled: boolean;
    /**
     * 
     * @type {Limitation}
     * @memberof AnnouncementUpdate
     */
    limit?: Limitation;
    /**
     * 
     * @type {Author}
     * @memberof AnnouncementUpdate
     */
    owner: Author;
    /**
     * 
     * @type {RecipientsBasic}
     * @memberof AnnouncementUpdate
     */
    recipients: RecipientsBasic;
    /**
     * 
     * @type {AnnouncementSeverity}
     * @memberof AnnouncementUpdate
     */
    severity?: AnnouncementSeverity;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnouncementUpdate
     */
    title: string;
}
/**
 * 
 * @export
 * @interface AnswerParentalMailInstance
 */
export interface AnswerParentalMailInstance {
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailInstance
     */
    questionId: string;
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailInstance
     */
    wardId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnswerParentalMailInstance
     */
    selectedOptionIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailInstance
     */
    freeTextAnswer?: string | null;
}
/**
 * 
 * @export
 * @interface AnswerParentalMailRequest
 */
export interface AnswerParentalMailRequest {
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailRequest
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnswerParentalMailRequest
     */
    accessToken?: string | null;
    /**
     * 
     * @type {Array<AnswerParentalMailInstance>}
     * @memberof AnswerParentalMailRequest
     */
    answers?: Array<AnswerParentalMailInstance> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnswerParentalMailRequest
     */
    wardIds: Array<string>;
}
/**
 * 
 * @export
 * @interface ApiCourseWithStudents
 */
export interface ApiCourseWithStudents {
    /**
     * 
     * @type {ApiResolvedCourse}
     * @memberof ApiCourseWithStudents
     */
    course: ApiResolvedCourse;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiCourseWithStudents
     */
    studentIds: Array<string>;
}
/**
 * 
 * @export
 * @interface ApiKeyCreateRequest
 */
export interface ApiKeyCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyCreateRequest
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {ApiKeyScope}
     * @memberof ApiKeyCreateRequest
     */
    scope?: ApiKeyScope;
}
/**
 * 
 * @export
 * @interface ApiKeyDeleteRequest
 */
export interface ApiKeyDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyDeleteRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyDeleteRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyDeleteRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyDeleteRequest
     */
    expirationDate?: string;
    /**
     * 
     * @type {ApiKeyScope}
     * @memberof ApiKeyDeleteRequest
     */
    scope?: ApiKeyScope;
}
/**
 * 
 * @export
 * @interface ApiKeyGetAllRequest
 */
export interface ApiKeyGetAllRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGetAllRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface ApiKeyGetHistoryRequest
 */
export interface ApiKeyGetHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGetHistoryRequest
     */
    continuationToken?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApiKeyGetHistoryRequest
     */
    maxSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApiKeyGetHistoryRequest
     */
    pageSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGetHistoryRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface ApiKeyGetHistoryRequestAllOf
 */
export interface ApiKeyGetHistoryRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyGetHistoryRequestAllOf
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface ApiKeyResponse
 */
export interface ApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    expirationDate?: string;
    /**
     * 
     * @type {ApiKeyScope}
     * @memberof ApiKeyResponse
     */
    scope?: ApiKeyScope;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiKeyScope {
    none = 'None',
    hybrid = 'Hybrid',
    appStore = 'AppStore',
    timeTable = 'TimeTable',
    substitutions = 'Substitutions'
}

/**
 * 
 * @export
 * @interface ApiResolvedCourse
 */
export interface ApiResolvedCourse {
    /**
     * 
     * @type {string}
     * @memberof ApiResolvedCourse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResolvedCourse
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface AppConfigurationSettingItemResponse
 */
export interface AppConfigurationSettingItemResponse {
    /**
     * 
     * @type {string}
     * @memberof AppConfigurationSettingItemResponse
     */
    appConfigKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppConfigurationSettingItemResponse
     */
    appConfigKeyValue?: string | null;
}
/**
 * 
 * @export
 * @interface AppConsent
 */
export interface AppConsent {
    /**
     * 
     * @type {boolean}
     * @memberof AppConsent
     */
    isConsentRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppConsent
     */
    consentUrl?: string | null;
}
/**
 * 
 * @export
 * @interface AppListItem
 */
export interface AppListItem {
    /**
     * 
     * @type {string}
     * @memberof AppListItem
     */
    appId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppListItem
     */
    appStoreUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppListItem
     */
    publisher?: string | null;
}
/**
 * 
 * @export
 * @interface AppleSyncStartRequest
 */
export interface AppleSyncStartRequest {
    /**
     * 
     * @type {string}
     * @memberof AppleSyncStartRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface AppleSyncsAvailableRequest
 */
export interface AppleSyncsAvailableRequest {
    /**
     * 
     * @type {string}
     * @memberof AppleSyncsAvailableRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface Appointment
 */
export interface Appointment {
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    end?: string;
    /**
     * 
     * @type {Array<Recipient>}
     * @memberof Appointment
     */
    recipients?: Array<Recipient> | null;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    organizationId?: string;
    /**
     * 
     * @type {UserEmbedded}
     * @memberof Appointment
     */
    createdBy: UserEmbedded;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    createdAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Appointment
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Appointment
     */
    timeZone?: string | null;
}
/**
 * 
 * @export
 * @interface ArchivedAbsenceDraftResponse
 */
export interface ArchivedAbsenceDraftResponse {
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    timePeriod: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    reason?: string | null;
    /**
     * 
     * @type {AbsenceDraftState}
     * @memberof ArchivedAbsenceDraftResponse
     */
    state?: AbsenceDraftState;
    /**
     * 
     * @type {number}
     * @memberof ArchivedAbsenceDraftResponse
     */
    timeSlotStart?: number;
    /**
     * 
     * @type {number}
     * @memberof ArchivedAbsenceDraftResponse
     */
    timeSlotEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    description?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof ArchivedAbsenceDraftResponse
     */
    student: Person;
    /**
     * 
     * @type {Author}
     * @memberof ArchivedAbsenceDraftResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    submittedOn?: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    className?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArchivedAbsenceDraftResponse
     */
    gradeName?: string | null;
    /**
     * 
     * @type {Audit}
     * @memberof ArchivedAbsenceDraftResponse
     */
    processedBy: Audit;
}
/**
 * 
 * @export
 * @interface ArchivedAbsenceDraftResponseAllOf
 */
export interface ArchivedAbsenceDraftResponseAllOf {
    /**
     * 
     * @type {Audit}
     * @memberof ArchivedAbsenceDraftResponseAllOf
     */
    processedBy: Audit;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Area {
    dashboard = 'Dashboard',
    classbook = 'Classbook',
    coursebook = 'Coursebook',
    course = 'Course'
}

/**
 * 
 * @export
 * @interface AssignableSoftwareResponse
 */
export interface AssignableSoftwareResponse {
    /**
     * 
     * @type {Array<GroupRelationshipResponse>}
     * @memberof AssignableSoftwareResponse
     */
    installations: Array<GroupRelationshipResponse>;
    /**
     * 
     * @type {string}
     * @memberof AssignableSoftwareResponse
     */
    displayName: string;
    /**
     * 
     * @type {PlatformType}
     * @memberof AssignableSoftwareResponse
     */
    platformType: PlatformType;
    /**
     * 
     * @type {string}
     * @memberof AssignableSoftwareResponse
     */
    id: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AssignedStatus {
    any = 'Any',
    assigned = 'Assigned',
    notAssigned = 'NotAssigned'
}

/**
 * 
 * @export
 * @interface Assignment
 */
export interface Assignment {
    /**
     * 
     * @type {InstallStatus}
     * @memberof Assignment
     */
    intent: InstallStatus;
    /**
     * 
     * @type {string}
     * @memberof Assignment
     */
    groupId: string;
}
/**
 * 
 * @export
 * @interface Audit
 */
export interface Audit {
    /**
     * 
     * @type {string}
     * @memberof Audit
     */
    at?: string;
    /**
     * 
     * @type {Author}
     * @memberof Audit
     */
    by?: Author;
}
/**
 * 
 * @export
 * @interface Author
 */
export interface Author {
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    mailAddress?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AutomaticUpdateMode {
    notifyDownload = 'NotifyDownload',
    autoInstallAtMaintenanceTime = 'AutoInstallAtMaintenanceTime',
    autoInstallAndRebootAtMaintenanceTime = 'AutoInstallAndRebootAtMaintenanceTime',
    autoInstallAndRebootAtScheduledTime = 'AutoInstallAndRebootAtScheduledTime',
    autoInstallAndRebootWithoutEndUserControl = 'AutoInstallAndRebootWithoutEndUserControl',
    windowsDefault = 'WindowsDefault'
}

/**
 * 
 * @export
 * @interface AvailableFiltersResponse
 */
export interface AvailableFiltersResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableFiltersResponse
     */
    classNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableFiltersResponse
     */
    gradeNames?: Array<string>;
}
/**
 * 
 * @export
 * @interface AvailableUserTemplate
 */
export interface AvailableUserTemplate {
    /**
     * 
     * @type {string}
     * @memberof AvailableUserTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableUserTemplate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableUserTemplate
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableUserTemplate
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableUserTemplate
     */
    emailPrefixRule?: string;
}
/**
 * 
 * @export
 * @interface AzureCourse
 */
export interface AzureCourse {
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    classbookId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    createdDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    hybridSamAccountName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AzureCourse
     */
    isInProvisioningTimeWindow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    mailNickname: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    timePeriod: string;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    webUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    teamsWebUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureCourse
     */
    notebookJobId?: string | null;
}
/**
 * 
 * @export
 * @interface AzureGroup
 */
export interface AzureGroup {
    /**
     * 
     * @type {string}
     * @memberof AzureGroup
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AzureGroup
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AzureGroup
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface AzureGroupAssignmentResponse
 */
export interface AzureGroupAssignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    entityRevisionsId: string;
    /**
     * 
     * @type {LessonGroupMappingType}
     * @memberof AzureGroupAssignmentResponse
     */
    entityType: LessonGroupMappingType;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    azureGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    azureGroupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    azureGroupMail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    suggestedAzureGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentResponse
     */
    suggestedAzureGroupName?: string | null;
}
/**
 * 
 * @export
 * @interface AzureGroupAssignmentUpdateRequestItem
 */
export interface AzureGroupAssignmentUpdateRequestItem {
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentUpdateRequestItem
     */
    entityRevisionsId?: string;
    /**
     * 
     * @type {LessonGroupMappingType}
     * @memberof AzureGroupAssignmentUpdateRequestItem
     */
    entityType?: LessonGroupMappingType;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupAssignmentUpdateRequestItem
     */
    azureGroupId?: string | null;
}
/**
 * 
 * @export
 * @interface AzureGroupInfoResponse
 */
export interface AzureGroupInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof AzureGroupInfoResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupInfoResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof AzureGroupInfoResponse
     */
    mail?: string | null;
}
/**
 * 
 * @export
 * @interface B2CUser
 */
export interface B2CUser {
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    registeredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof B2CUser
     */
    lastLogonAt?: string;
}
/**
 * 
 * @export
 * @interface BaseEntity
 */
export interface BaseEntity {
    /**
     * 
     * @type {string}
     * @memberof BaseEntity
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface BasicDeviceResponse
 */
export interface BasicDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    operatingSystem: string;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    lastContact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicDeviceResponse
     */
    registerProfileName?: string | null;
    /**
     * 
     * @type {DeviceRegistration}
     * @memberof BasicDeviceResponse
     */
    deviceRegistration: DeviceRegistration;
}
/**
 * 
 * @export
 * @interface BasicMdmGroupResponse
 */
export interface BasicMdmGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof BasicMdmGroupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicMdmGroupResponse
     */
    name?: string | null;
    /**
     * 
     * @type {ProfileType}
     * @memberof BasicMdmGroupResponse
     */
    profileType: ProfileType;
    /**
     * 
     * @type {MdmGroupType}
     * @memberof BasicMdmGroupResponse
     */
    groupType: MdmGroupType;
    /**
     * 
     * @type {MdmGroupEntityType}
     * @memberof BasicMdmGroupResponse
     */
    entityType: MdmGroupEntityType;
}
/**
 * 
 * @export
 * @interface BasicSoftwareResponse
 */
export interface BasicSoftwareResponse {
    /**
     * 
     * @type {string}
     * @memberof BasicSoftwareResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicSoftwareResponse
     */
    name: string;
    /**
     * 
     * @type {SoftwareStatus}
     * @memberof BasicSoftwareResponse
     */
    softwareStatus?: SoftwareStatus | null;
    /**
     * 
     * @type {InstallStatus}
     * @memberof BasicSoftwareResponse
     */
    installStatus?: InstallStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof BasicSoftwareResponse
     */
    isAssigned: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasicSoftwareResponse
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof BasicSoftwareResponse
     */
    publisher?: string | null;
}
/**
 * 
 * @export
 * @interface BildungsloginCirclesOfLearningResponse
 */
export interface BildungsloginCirclesOfLearningResponse {
    /**
     * 
     * @type {Array<GroupRole>}
     * @memberof BildungsloginCirclesOfLearningResponse
     */
    circlesOfLearning: Array<GroupRole>;
}
/**
 * 
 * @export
 * @interface BildungsloginRegistration
 */
export interface BildungsloginRegistration {
    /**
     * Contains the url to the consent flow for the third party app.
     * @type {string}
     * @memberof BildungsloginRegistration
     */
    applicationConsentUrl?: string | null;
    /**
     * Represents the 3rd-Party Application to be installed in the customers Tenant.
     * @type {boolean}
     * @memberof BildungsloginRegistration
     */
    isApplicationInstalled?: boolean;
    /**
     * Represents the \"Bildungslogin\" to be finally approved by AixConcept.
     * @type {boolean}
     * @memberof BildungsloginRegistration
     */
    isCompleted?: boolean;
    /**
     * True as soon as the user has confirmed the redirection to the registration process of \"Bildungslogin\".
     * @type {boolean}
     * @memberof BildungsloginRegistration
     */
    isRegistered?: boolean;
    /**
     * Represents the time, the registration was initiated.
     * @type {string}
     * @memberof BildungsloginRegistration
     */
    registeredAt?: string;
    /**
     * Contains the url of the registration process hosted by \"Bildungslogin\", including the tenant id of the organization.
     * @type {string}
     * @memberof BildungsloginRegistration
     */
    registrationUrl?: string | null;
    /**
     * Contains a link to access the user\'s assigned licenses.
     * @type {string}
     * @memberof BildungsloginRegistration
     */
    userAccessUrl?: string | null;
    /**
     * Contains a link to access the license management.
     * @type {string}
     * @memberof BildungsloginRegistration
     */
    licenseManagementUrl?: string | null;
}
/**
 * 
 * @export
 * @interface BitLockerRecoveryKeyResponse
 */
export interface BitLockerRecoveryKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof BitLockerRecoveryKeyResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BitLockerRecoveryKeyResponse
     */
    key: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BoardPosition {
    unkown = 'Unkown',
    top = 'Top',
    right = 'Right',
    bottom = 'Bottom',
    left = 'Left'
}

/**
 * 
 * @export
 * @interface Booking
 */
export interface Booking {
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    id: string;
    /**
     * 
     * @type {BookingOptions}
     * @memberof Booking
     */
    options: BookingOptions;
    /**
     * 
     * @type {BookingResource}
     * @memberof Booking
     */
    resource: BookingResource;
    /**
     * 
     * @type {BookingStatus}
     * @memberof Booking
     */
    status: BookingStatus;
    /**
     * 
     * @type {BookingType}
     * @memberof Booking
     */
    type: BookingType;
    /**
     * 
     * @type {BookingOwner}
     * @memberof Booking
     */
    user?: BookingOwner | null;
}
/**
 * 
 * @export
 * @interface BookingCreateRequest
 */
export interface BookingCreateRequest {
    /**
     * 
     * @type {BookingOptions}
     * @memberof BookingCreateRequest
     */
    booking: BookingOptions;
    /**
     * 
     * @type {string}
     * @memberof BookingCreateRequest
     */
    onBehalfOfUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingCreateRequest
     */
    resourceId: string;
}
/**
 * 
 * @export
 * @interface BookingDeleteRequest
 */
export interface BookingDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingDeleteRequest
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDeleteRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingDeleteRequest
     */
    resourceId: string;
}
/**
 * 
 * @export
 * @interface BookingGetAllRequest
 */
export interface BookingGetAllRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingGetAllRequest
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof BookingGetAllRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingGetAllRequest
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingGetAllRequest
     */
    to: string;
}
/**
 * 
 * @export
 * @interface BookingOptions
 */
export interface BookingOptions {
    /**
     * 
     * @type {string}
     * @memberof BookingOptions
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof BookingOptions
     */
    to: string;
}
/**
 * 
 * @export
 * @interface BookingOwner
 */
export interface BookingOwner {
    /**
     * 
     * @type {string}
     * @memberof BookingOwner
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof BookingOwner
     */
    emailAddress: string;
}
/**
 * 
 * @export
 * @interface BookingPerson
 */
export interface BookingPerson {
    /**
     * 
     * @type {string}
     * @memberof BookingPerson
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof BookingPerson
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof BookingPerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BookingPerson
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BookingPerson
     */
    lastName: string;
    /**
     * 
     * @type {UserRole}
     * @memberof BookingPerson
     */
    role: UserRole;
}
/**
 * 
 * @export
 * @interface BookingResource
 */
export interface BookingResource {
    /**
     * 
     * @type {string}
     * @memberof BookingResource
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResource
     */
    type: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BookingStatus {
    requested = 'Requested',
    accepted = 'Accepted'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum BookingType {
    single = 'Single',
    series = 'Series'
}

/**
 * 
 * @export
 * @interface BookingUpdateRequest
 */
export interface BookingUpdateRequest {
    /**
     * 
     * @type {BookingOptions}
     * @memberof BookingUpdateRequest
     */
    booking: BookingOptions;
    /**
     * 
     * @type {string}
     * @memberof BookingUpdateRequest
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingUpdateRequest
     */
    resourceId: string;
}
/**
 * 
 * @export
 * @interface Calendar
 */
export interface Calendar {
    /**
     * 
     * @type {boolean}
     * @memberof Calendar
     */
    canEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    hexColor: string;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Calendar
     */
    isDefaultCalendar?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Calendar
     */
    owner: string;
    /**
     * 
     * @type {CalendarType}
     * @memberof Calendar
     */
    type?: CalendarType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CalendarType {
    unknown = 'Unknown',
    user = 'User',
    group = 'Group',
    resource = 'Resource'
}

/**
 * 
 * @export
 * @interface ChangePasswordResponse
 */
export interface ChangePasswordResponse {
    /**
     * 
     * @type {ChangedPasswordState}
     * @memberof ChangePasswordResponse
     */
    state: ChangedPasswordState;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordResponse
     */
    errorMessage?: string | null;
}
/**
 * 
 * @export
 * @interface ChangeUserPasswordParameters
 */
export interface ChangeUserPasswordParameters {
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordParameters
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordParameters
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeUserPasswordParameters
     */
    passwordIsPermanentValid: boolean;
}
/**
 * 
 * @export
 * @interface ChangeUserPasswordsParameters
 */
export interface ChangeUserPasswordsParameters {
    /**
     * 
     * @type {string}
     * @memberof ChangeUserPasswordsParameters
     */
    newPassword: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeUserPasswordsParameters
     */
    userIds: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChangedPasswordState {
    succeeded = 'Succeeded',
    requested = 'Requested',
    failed = 'Failed'
}

/**
 * 
 * @export
 * @interface Changelog
 */
export interface Changelog {
    /**
     * 
     * @type {Array<ReleaseNote>}
     * @memberof Changelog
     */
    releaseNotes?: Array<ReleaseNote> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChangelogSource {
    production = 'Production',
    preview = 'Preview'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChassisType {
    unknown = 'Unknown',
    desktop = 'Desktop',
    laptop = 'Laptop',
    worksWorkstation = 'WorksWorkstation',
    enterpriseServer = 'EnterpriseServer',
    phone = 'Phone',
    tablet = 'Tablet',
    mobileOther = 'MobileOther',
    mobileUnknown = 'MobileUnknown'
}

/**
 * 
 * @export
 * @interface ChatAttachmentResponse
 */
export interface ChatAttachmentResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    contentType: string;
    /**
     * 
     * @type {number}
     * @memberof ChatAttachmentResponse
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    urlExpiresOn: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    uploadedOn: string;
    /**
     * 
     * @type {string}
     * @memberof ChatAttachmentResponse
     */
    uploadedBy: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChatLockMode {
    none = 'None',
    timeBased = 'TimeBased',
    locked = 'Locked',
    futureValue = 'FutureValue'
}

/**
 * 
 * @export
 * @interface ChatLockResponse
 */
export interface ChatLockResponse {
    /**
     * 
     * @type {ChatLockMode}
     * @memberof ChatLockResponse
     */
    mode: ChatLockMode;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ChatLockResponse
     */
    allowedDaysOfWeek?: Array<DayOfWeek> | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLockResponse
     */
    openTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLockResponse
     */
    closeTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLockResponse
     */
    timeZone?: string | null;
}
/**
 * 
 * @export
 * @interface ChatMessagePreview
 */
export interface ChatMessagePreview {
    /**
     * 
     * @type {string}
     * @memberof ChatMessagePreview
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessagePreview
     */
    senderDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessagePreview
     */
    sentOn: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChatMessageType {
    text = 'Text',
    html = 'Html',
    topicUpdated = 'TopicUpdated',
    participantAdded = 'ParticipantAdded',
    participantRemoved = 'ParticipantRemoved'
}

/**
 * 
 * @export
 * @interface ChatParticipantResponse
 */
export interface ChatParticipantResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantResponse
     */
    acsUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantResponse
     */
    displayName: string;
    /**
     * 
     * @type {ChatUserType}
     * @memberof ChatParticipantResponse
     */
    userType: ChatUserType;
    /**
     * 
     * @type {ChatParticipantRole}
     * @memberof ChatParticipantResponse
     */
    role: ChatParticipantRole;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipantResponse
     */
    joinedOn: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatParticipantResponse
     */
    wardIds: Array<string>;
    /**
     * 
     * @type {Array<GuardianChatPerson>}
     * @memberof ChatParticipantResponse
     */
    wards: Array<GuardianChatPerson>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChatParticipantRole {
    member = 'Member',
    admin = 'Admin',
    futureValue = 'FutureValue'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChatThreadType {
    direct = 'Direct',
    group = 'Group',
    futureValue = 'FutureValue'
}

/**
 * 
 * @export
 * @interface ChatTokenResponse
 */
export interface ChatTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatTokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ChatTokenResponse
     */
    acsUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatTokenResponse
     */
    expiresOn: string;
    /**
     * 
     * @type {string}
     * @memberof ChatTokenResponse
     */
    acsEndpoint: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ChatUserType {
    teacher = 'Teacher',
    parent = 'Parent',
    ward = 'Ward'
}

/**
 * 
 * @export
 * @interface ClassAbsences
 */
export interface ClassAbsences {
    /**
     * 
     * @type {Array<AbsenceResponse>}
     * @memberof ClassAbsences
     */
    absences: Array<AbsenceResponse>;
    /**
     * 
     * @type {Person}
     * @memberof ClassAbsences
     */
    student: Person;
    /**
     * 
     * @type {Delays}
     * @memberof ClassAbsences
     */
    delays: Delays;
    /**
     * 
     * @type {MissedHours}
     * @memberof ClassAbsences
     */
    missedHours: MissedHours;
    /**
     * 
     * @type {Array<UnclarifiedLessonResponse>}
     * @memberof ClassAbsences
     */
    unclarifiedLessons: Array<UnclarifiedLessonResponse>;
}
/**
 * 
 * @export
 * @interface ClassAbsencesResponse
 */
export interface ClassAbsencesResponse {
    /**
     * 
     * @type {ClassResponse}
     * @memberof ClassAbsencesResponse
     */
    classItem: ClassResponse;
    /**
     * 
     * @type {Array<ClassAbsences>}
     * @memberof ClassAbsencesResponse
     */
    absences: Array<ClassAbsences>;
}
/**
 * 
 * @export
 * @interface ClassBasicResponse
 */
export interface ClassBasicResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof ClassBasicResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {string}
     * @memberof ClassBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassBasicResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ClassCreateEntry
 */
export interface ClassCreateEntry {
    /**
     * 
     * @type {string}
     * @memberof ClassCreateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassCreateEntry
     */
    classTeachers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassCreateEntry
     */
    name: string;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof ClassCreateEntry
     */
    signOffRequirement?: SignOffRequirement | null;
}
/**
 * 
 * @export
 * @interface ClassEmbedded
 */
export interface ClassEmbedded {
    /**
     * 
     * @type {AzureGroup}
     * @memberof ClassEmbedded
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEmbedded
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEmbedded
     */
    revisionsId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassEmbedded
     */
    name?: string;
}
/**
 * Body of the class report request.
 * @export
 * @interface ClassReportRequest
 */
export interface ClassReportRequest {
    /**
     * ID of the class revisions the report is generated for
     * @type {string}
     * @memberof ClassReportRequest
     */
    classRevisionsId: string;
    /**
     * Start of the report period
     * @type {string}
     * @memberof ClassReportRequest
     */
    from: string;
    /**
     * End of the report period
     * @type {string}
     * @memberof ClassReportRequest
     */
    to: string;
    /**
     * Time zone identifier, e.g. \"W. Europe Standard Time\" or \"Europe/Berlin\"
     * @type {string}
     * @memberof ClassReportRequest
     */
    timeZone: string;
    /**
     * Order the students are listed in (FirstName or LastName)
     * @type {StudentSortCriteria}
     * @memberof ClassReportRequest
     */
    sortStudentsBy?: StudentSortCriteria;
}
/**
 * 
 * @export
 * @interface ClassResponse
 */
export interface ClassResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof ClassResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {Array<CourseBasicResponse>}
     * @memberof ClassResponse
     */
    classCourses: Array<CourseBasicResponse>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof ClassResponse
     */
    classTeachers: Array<Person>;
    /**
     * 
     * @type {GradeBasicResponse}
     * @memberof ClassResponse
     */
    grade: GradeBasicResponse;
    /**
     * 
     * @type {string}
     * @memberof ClassResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassResponse
     */
    name: string;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof ClassResponse
     */
    signOffRequirement: SignOffRequirement;
    /**
     * 
     * @type {string}
     * @memberof ClassResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassServiceDefinitionResponse
 */
export interface ClassServiceDefinitionResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassServiceDefinitionResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServiceDefinitionResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServiceDefinitionResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassServiceDefinitionResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassServiceDefinitionResponse
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServiceDefinitionResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassServicesDefinitionEntry
 */
export interface ClassServicesDefinitionEntry {
    /**
     * 
     * @type {string}
     * @memberof ClassServicesDefinitionEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesDefinitionEntry
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassServicesDefinitionEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesDefinitionEntry
     */
    shortName?: string | null;
}
/**
 * 
 * @export
 * @interface ClassServicesDefinitionIdOnly
 */
export interface ClassServicesDefinitionIdOnly {
    /**
     * 
     * @type {string}
     * @memberof ClassServicesDefinitionIdOnly
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface ClassServicesEntry
 */
export interface ClassServicesEntry {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassServicesEntry
     */
    affectedUsers?: Array<string> | null;
    /**
     * 
     * @type {ClassServicesDefinitionIdOnly}
     * @memberof ClassServicesEntry
     */
    definition?: ClassServicesDefinitionIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesEntry
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesEntry
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesEntry
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface ClassServicesPutEntry
 */
export interface ClassServicesPutEntry {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassServicesPutEntry
     */
    affectedUsers?: Array<string> | null;
    /**
     * 
     * @type {ClassServicesDefinitionIdOnly}
     * @memberof ClassServicesPutEntry
     */
    definition?: ClassServicesDefinitionIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesPutEntry
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesPutEntry
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesPutEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesPutEntry
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface ClassServicesResponse
 */
export interface ClassServicesResponse {
    /**
     * 
     * @type {Array<Person>}
     * @memberof ClassServicesResponse
     */
    affectedUsers: Array<Person>;
    /**
     * 
     * @type {ClassServiceDefinitionResponse}
     * @memberof ClassServicesResponse
     */
    definition?: ClassServiceDefinitionResponse | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponse
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassServicesResponseExtended
 */
export interface ClassServicesResponseExtended {
    /**
     * 
     * @type {Array<Person>}
     * @memberof ClassServicesResponseExtended
     */
    affectedUsers: Array<Person>;
    /**
     * 
     * @type {ClassServiceDefinitionResponse}
     * @memberof ClassServicesResponseExtended
     */
    definition?: ClassServiceDefinitionResponse | null;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponseExtended
     */
    end: string;
    /**
     * 
     * @type {Group}
     * @memberof ClassServicesResponseExtended
     */
    group: Group;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponseExtended
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponseExtended
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof ClassServicesResponseExtended
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassUpdateEntry
 */
export interface ClassUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof ClassUpdateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassUpdateEntry
     */
    classTeachers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassUpdateEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassUpdateEntry
     */
    name: string;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof ClassUpdateEntry
     */
    signOffRequirement: SignOffRequirement;
}
/**
 * 
 * @export
 * @interface ClassbookEntity
 */
export interface ClassbookEntity {
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntity
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntity
     */
    id: string;
    /**
     * 
     * @type {EntityType}
     * @memberof ClassbookEntity
     */
    type: EntityType;
}
/**
 * 
 * @export
 * @interface ClassbookEntryCategoryIdOnly
 */
export interface ClassbookEntryCategoryIdOnly {
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryIdOnly
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryCategoryPutRequest
 */
export interface ClassbookEntryCategoryPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryPutRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryPutRequest
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryPutRequest
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryCategoryPutRequest
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryPutRequest
     */
    shortName: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryCategoryRequest
 */
export interface ClassbookEntryCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryRequest
     */
    fullName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryCategoryRequest
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryRequest
     */
    shortName: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryCategoryResponse
 */
export interface ClassbookEntryCategoryResponse {
    /**
     * 
     * @type {Author}
     * @memberof ClassbookEntryCategoryResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryCategoryResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryResponse
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCategoryResponse
     */
    predecessorId?: string | null;
}
/**
 * This ClassbookEntry class is a example input which can be given from outside. It should never contain any sensible data which could manipulate any given entries in the database! same classes are needed for Category and Defintion of the ClassbookEntrys Automapped to corresponding types of ClassRegisterV2
 * @export
 * @interface ClassbookEntryCreateRequest
 */
export interface ClassbookEntryCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassbookEntryCreateRequest
     */
    affectedUsers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCreateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {ClassbookEntryDefinitionIdOnly}
     * @memberof ClassbookEntryCreateRequest
     */
    definition: ClassbookEntryDefinitionIdOnly;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCreateRequest
     */
    expiresAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCreateRequest
     */
    groupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCreateRequest
     */
    lessonId: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryCreateRequest
     */
    occured: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryDefinitionEntry
 */
export interface ClassbookEntryDefinitionEntry {
    /**
     * 
     * @type {ClassbookEntryCategoryIdOnly}
     * @memberof ClassbookEntryDefinitionEntry
     */
    category?: ClassbookEntryCategoryIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionEntry
     */
    fullName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryDefinitionEntry
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionEntry
     */
    shortName: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryDefinitionFullResponse
 */
export interface ClassbookEntryDefinitionFullResponse {
    /**
     * 
     * @type {ClassbookEntryCategoryPutRequest}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    category?: ClassbookEntryCategoryPutRequest | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionFullResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassbookEntryDefinitionIdOnly
 */
export interface ClassbookEntryDefinitionIdOnly {
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionIdOnly
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ClassbookEntryDefinitionResponse
 */
export interface ClassbookEntryDefinitionResponse {
    /**
     * 
     * @type {ClassbookEntryCategoryIdOnly}
     * @memberof ClassbookEntryDefinitionResponse
     */
    category?: ClassbookEntryCategoryIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassbookEntryDefinitionResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionResponse
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryDefinitionResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ClassbookEntryResponse
 */
export interface ClassbookEntryResponse {
    /**
     * 
     * @type {Array<Person>}
     * @memberof ClassbookEntryResponse
     */
    affectedUsers: Array<Person>;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    comment?: string | null;
    /**
     * 
     * @type {Author}
     * @memberof ClassbookEntryResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {ClassbookEntryDefinitionFullResponse}
     * @memberof ClassbookEntryResponse
     */
    definition: ClassbookEntryDefinitionFullResponse;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    expiresAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    lessonId: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryResponse
     */
    occured: string;
}
/**
 * Returns the ClassbookEntry on response, does return its ID Note: this class should never be the written obj! because sensible data like the ID should never be given by any input from outside
 * @export
 * @interface ClassbookEntryUpdateRequest
 */
export interface ClassbookEntryUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassbookEntryUpdateRequest
     */
    affectedUsers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {ClassbookEntryDefinitionIdOnly}
     * @memberof ClassbookEntryUpdateRequest
     */
    definition: ClassbookEntryDefinitionIdOnly;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    expiresAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    groupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    lessonId: string;
    /**
     * 
     * @type {string}
     * @memberof ClassbookEntryUpdateRequest
     */
    occured: string;
}
/**
 * 
 * @export
 * @interface CockpitBannerResponse
 */
export interface CockpitBannerResponse {
    /**
     * 
     * @type {string}
     * @memberof CockpitBannerResponse
     */
    url?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CockpitBannerResponse
     */
    disabled?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CockpitPermission {
    all = 'All',
    teacher = 'Teacher',
    student = 'Student',
    none = 'None'
}

/**
 * 
 * @export
 * @interface CockpitWidgetsConfigurationItem
 */
export interface CockpitWidgetsConfigurationItem {
    /**
     * 
     * @type {{ [key: string]: CockpitPermission; }}
     * @memberof CockpitWidgetsConfigurationItem
     */
    widgets: { [key: string]: CockpitPermission; };
}
/**
 * 
 * @export
 * @interface ConfigurationProfileBasicResponse
 */
export interface ConfigurationProfileBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationProfileBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationProfileBasicResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationProfileBasicResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationProfileBasicResponse
     */
    lastModified?: string | null;
    /**
     * 
     * @type {ConfigurationProfileType}
     * @memberof ConfigurationProfileBasicResponse
     */
    profileType?: ConfigurationProfileType;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationProfileBasicResponse
     */
    isExcluded?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConfigurationProfileType {
    unknown = 'Unknown',
    iosDeviceFeatures = 'IosDeviceFeatures',
    iosDeviceRestrictions = 'IosDeviceRestrictions',
    iosWifiConfiguration = 'IosWifiConfiguration',
    iosMobileAppConfiguration = 'IosMobileAppConfiguration',
    iosUpdateConfiguration = 'IosUpdateConfiguration',
    iosEnrollmentProfile = 'IosEnrollmentProfile',
    windowsUpdatePolicy = 'WindowsUpdatePolicy',
    windowsDeviceRestrictions = 'WindowsDeviceRestrictions',
    windowsWifiConfiguration = 'WindowsWifiConfiguration',
    windowsAdministrativeTemplate = 'WindowsAdministrativeTemplate',
    windowsSharedPolicy = 'WindowsSharedPolicy',
    windowsLocalUserGroupMembership = 'WindowsLocalUserGroupMembership',
    windowsSettingsCatalogue = 'WindowsSettingsCatalogue',
    windowsAutopilotProfile = 'WindowsAutopilotProfile',
    windowsCustomConfiguration = 'WindowsCustomConfiguration',
    androidGeneralDeviceConfiguration = 'AndroidGeneralDeviceConfiguration',
    androidWiFiConfiguration = 'AndroidWiFiConfiguration',
    androidManagedStoreAppConfiguration = 'AndroidManagedStoreAppConfiguration'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConfigureModeAvailability {
    modeAvailable = 'ModeAvailable',
    modeDisabled = 'ModeDisabled',
    modeForced = 'ModeForced'
}

/**
 * 
 * @export
 * @interface ConfirmInvitationResponse
 */
export interface ConfirmInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmInvitationResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmInvitationResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmInvitationResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmInvitationResponse
     */
    mailAddress?: string;
    /**
     * 
     * @type {School}
     * @memberof ConfirmInvitationResponse
     */
    school?: School;
}
/**
 * An Azure AD application the admin still has to grant consent for during sign-up. Returned by the anonymous GET /api/v2/signUp/consentApps/{invitationId} endpoint so the sign-up frontend no longer needs a hard-coded app list.
 * @export
 * @interface ConsentApp
 */
export interface ConsentApp {
    /**
     * The application (client) id used to build the admin-consent url.
     * @type {string}
     * @memberof ConsentApp
     */
    id?: string;
    /**
     * The application display name shown on the consent landing screen.
     * @type {string}
     * @memberof ConsentApp
     */
    name?: string;
    /**
     * The application logo as a data URI (data:{mediaType};base64,{data}), or null when the app has no logo.
     * @type {string}
     * @memberof ConsentApp
     */
    icon?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsentFilterState {
    none = 'None',
    error = 'Error',
    declined = 'Declined',
    accepted = 'Accepted',
    all = 'All'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsentProvidedForMinor {
    /**
    * NO_CONSENT_PROVIDED_FOR_MINOR
    */
    none = 'None',
    /**
    * GRANTED_CONSENT_PROVIDED_FOR_MINOR
    */
    granted = 'Granted',
    /**
    * DENIED_CONSENT_PROVIDED_FOR_MINOR
    */
    denied = 'Denied',
    /**
    * NOT_REQUIRED_CONSENT_PROVIDED_FOR_MINOR
    */
    notRequired = 'NotRequired'
}

/**
 * 
 * @export
 * @interface ConsentResponse
 */
export interface ConsentResponse {
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    parentalMailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    mailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    acceptedAtUtc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    providedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    providedFrom?: string;
    /**
     * 
     * @type {ConsentState}
     * @memberof ConsentResponse
     */
    state?: ConsentState;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsentState {
    pending = 'Pending',
    running = 'Running',
    accepted = 'Accepted',
    acceptedWithError = 'AcceptedWithError',
    declined = 'Declined'
}

/**
 * 
 * @export
 * @interface ConsentUserWithMailAddresses
 */
export interface ConsentUserWithMailAddresses {
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    lastName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConsentUserWithMailAddresses
     */
    mailAddresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    acceptedAtUtc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    providedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentUserWithMailAddresses
     */
    providedFrom?: string;
    /**
     * 
     * @type {ConsentState}
     * @memberof ConsentUserWithMailAddresses
     */
    state?: ConsentState;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CopyType {
    copy = 'Copy',
    move = 'Move'
}

/**
 * 
 * @export
 * @interface CourseAbsences
 */
export interface CourseAbsences {
    /**
     * 
     * @type {Person}
     * @memberof CourseAbsences
     */
    student: Person;
    /**
     * 
     * @type {Delays}
     * @memberof CourseAbsences
     */
    delays: Delays;
    /**
     * 
     * @type {MissedHours}
     * @memberof CourseAbsences
     */
    missedHours: MissedHours;
}
/**
 * 
 * @export
 * @interface CourseAbsencesResponse
 */
export interface CourseAbsencesResponse {
    /**
     * 
     * @type {CourseBasicResponse}
     * @memberof CourseAbsencesResponse
     */
    courseItem: CourseBasicResponse;
    /**
     * 
     * @type {Array<CourseAbsences>}
     * @memberof CourseAbsencesResponse
     */
    absences: Array<CourseAbsences>;
}
/**
 * 
 * @export
 * @interface CourseBasicResponse
 */
export interface CourseBasicResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof CourseBasicResponse
     */
    azureGroup: AzureGroup;
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof CourseBasicResponse
     */
    classes: Array<ClassBasicResponse>;
    /**
     * 
     * @type {string}
     * @memberof CourseBasicResponse
     */
    color?: string | null;
    /**
     * 
     * @type {RoomResponse}
     * @memberof CourseBasicResponse
     */
    room?: RoomResponse | null;
    /**
     * 
     * @type {string}
     * @memberof CourseBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseBasicResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CourseClassDependenciesUpdate
 */
export interface CourseClassDependenciesUpdate {
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseClassDependenciesUpdate
     */
    classDependenciesToAdd?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseClassDependenciesUpdate
     */
    classDependenciesToRemove?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CourseClassDependenciesUpdate
     */
    courseId?: string;
}
/**
 * 
 * @export
 * @interface CourseCombined
 */
export interface CourseCombined {
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    classbookId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    azureGroupId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseCombined
     */
    isUserPartOfAzureGroup?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    timePeriod: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourseCombined
     */
    isInProvisioningTimeWindow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    mailNickname: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCombined
     */
    createdDateTime?: string;
    /**
     * 
     * @type {Array<ClassEmbedded>}
     * @memberof CourseCombined
     */
    classes?: Array<ClassEmbedded>;
}
/**
 * 
 * @export
 * @interface CourseCreateEntry
 */
export interface CourseCreateEntry {
    /**
     * 
     * @type {string}
     * @memberof CourseCreateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseCreateEntry
     */
    classIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CourseCreateEntry
     */
    color?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseCreateEntry
     */
    courseTeachers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CourseCreateEntry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourseCreateEntry
     */
    roomId?: string;
    /**
     * 
     * @type {Array<CourseOccurrence>}
     * @memberof CourseCreateEntry
     */
    occurrences: Array<CourseOccurrence>;
}
/**
 * 
 * @export
 * @interface CourseDriveItemResponse
 */
export interface CourseDriveItemResponse {
    /**
     * 
     * @type {Array<DriveItem>}
     * @memberof CourseDriveItemResponse
     */
    children?: Array<DriveItem>;
    /**
     * 
     * @type {string}
     * @memberof CourseDriveItemResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDriveItemResponse
     */
    driveId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDriveItemResponse
     */
    webUrl?: string;
}
/**
 * 
 * @export
 * @interface CourseEventResponse
 */
export interface CourseEventResponse {
    /**
     * 
     * @type {string}
     * @memberof CourseEventResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseEventResponse
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourseEventResponse
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseEventResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseEventResponse
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseEventResponse
     */
    seriesMasterId?: string;
}
/**
 * 
 * @export
 * @interface CourseEventsGetRequest
 */
export interface CourseEventsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseEventsGetRequest
     */
    end?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseEventsGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseEventsGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseEventsGetRequest
     */
    start?: string | null;
}
/**
 * 
 * @export
 * @interface CourseGetAllForOrganizationCombinedRequest
 */
export interface CourseGetAllForOrganizationCombinedRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationCombinedRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationCombinedRequest
     */
    timePeriod?: string;
}
/**
 * 
 * @export
 * @interface CourseGetAllForOrganizationMembershipsRequest
 */
export interface CourseGetAllForOrganizationMembershipsRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationMembershipsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationMembershipsRequest
     */
    timePeriod?: string;
}
/**
 * 
 * @export
 * @interface CourseGetAllForOrganizationRequest
 */
export interface CourseGetAllForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseGetAllForOrganizationRequest
     */
    timePeriod?: string;
}
/**
 * 
 * @export
 * @interface CourseGetRequest
 */
export interface CourseGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseGetRequest
     */
    timePeriod?: string;
}
/**
 * 
 * @export
 * @interface CourseLinkCreateRequest
 */
export interface CourseLinkCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    courseId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    listId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    category?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseLinkCreateRequest
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkCreateRequest
     */
    imageUrl: string;
}
/**
 * 
 * @export
 * @interface CourseLinkListResponse
 */
export interface CourseLinkListResponse {
    /**
     * 
     * @type {string}
     * @memberof CourseLinkListResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkListResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkListResponse
     */
    url?: string;
    /**
     * 
     * @type {number}
     * @memberof CourseLinkListResponse
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface CourseLinkResponse
 */
export interface CourseLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CourseLinkResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkResponse
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkResponse
     */
    category?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseLinkResponse
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkResponse
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface CourseLinkUpdateRequest
 */
export interface CourseLinkUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    courseId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    listId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    category?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseLinkUpdateRequest
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface CourseLinkUpdateRequestAllOf
 */
export interface CourseLinkUpdateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof CourseLinkUpdateRequestAllOf
     */
    id: string;
}
/**
 * 
 * @export
 * @interface CourseNotebookResponse
 */
export interface CourseNotebookResponse {
    /**
     * 
     * @type {string}
     * @memberof CourseNotebookResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseNotebookResponse
     */
    notebookId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseNotebookResponse
     */
    webUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseNotebookResponse
     */
    clientUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseNotebookResponse
     */
    jobId?: string | null;
    /**
     * 
     * @type {NotebookCreationState}
     * @memberof CourseNotebookResponse
     */
    creationState?: NotebookCreationState;
}
/**
 * 
 * @export
 * @interface CourseOccurrence
 */
export interface CourseOccurrence {
    /**
     * 
     * @type {TimeSlot}
     * @memberof CourseOccurrence
     */
    slot: TimeSlot;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CourseOccurrence
     */
    weekday: DayOfWeek;
}
/**
 * Body of the course report request.
 * @export
 * @interface CourseReportRequest
 */
export interface CourseReportRequest {
    /**
     * ID of the course revisions the report is generated for
     * @type {string}
     * @memberof CourseReportRequest
     */
    courseRevisionsId: string;
    /**
     * Start of the report period
     * @type {string}
     * @memberof CourseReportRequest
     */
    from: string;
    /**
     * End of the report period
     * @type {string}
     * @memberof CourseReportRequest
     */
    to: string;
    /**
     * Time zone identifier, e.g. \"W. Europe Standard Time\" or \"Europe/Berlin\"
     * @type {string}
     * @memberof CourseReportRequest
     */
    timeZone: string;
    /**
     * Order the students are listed in (FirstName or LastName)
     * @type {StudentSortCriteria}
     * @memberof CourseReportRequest
     */
    sortStudentsBy?: StudentSortCriteria;
}
/**
 * 
 * @export
 * @interface CourseResponse
 */
export interface CourseResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof CourseResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof CourseResponse
     */
    classes: Array<ClassBasicResponse>;
    /**
     * 
     * @type {string}
     * @memberof CourseResponse
     */
    color?: string | null;
    /**
     * 
     * @type {RoomResponse}
     * @memberof CourseResponse
     */
    room?: RoomResponse | null;
    /**
     * 
     * @type {Array<CourseTeacher>}
     * @memberof CourseResponse
     */
    courseTeachers?: Array<CourseTeacher> | null;
    /**
     * 
     * @type {string}
     * @memberof CourseResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseResponse
     */
    name: string;
    /**
     * 
     * @type {Array<CourseOccurrence>}
     * @memberof CourseResponse
     */
    occurrences: Array<CourseOccurrence>;
    /**
     * 
     * @type {string}
     * @memberof CourseResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface CourseTeacher
 */
export interface CourseTeacher {
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    mailAddress: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourseTeacher
     */
    isExternal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseTeacher
     */
    abandonedAzureAccount?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseTeacher
     */
    isSubstitution?: boolean;
    /**
     * Date and time when the teacher will be removed from the group.
     * @type {string}
     * @memberof CourseTeacher
     */
    removalDate?: string | null;
}
/**
 * 
 * @export
 * @interface CourseUpdateEntry
 */
export interface CourseUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof CourseUpdateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseUpdateEntry
     */
    classIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CourseUpdateEntry
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseUpdateEntry
     */
    roomId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseUpdateEntry
     */
    courseTeachers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CourseUpdateEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseUpdateEntry
     */
    name?: string | null;
    /**
     * 
     * @type {Array<CourseOccurrence>}
     * @memberof CourseUpdateEntry
     */
    occurrences?: Array<CourseOccurrence> | null;
}
/**
 * 
 * @export
 * @interface CreateAppointmentRequestBody
 */
export interface CreateAppointmentRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    end?: string;
    /**
     * Set to true if the appointment is an all-day event. If true, the time part of Start and End will be ignored.
     * @type {boolean}
     * @memberof CreateAppointmentRequestBody
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequestBody
     */
    timeZone: string;
    /**
     * Null if the whole school should be the recipient
     * @type {Array<string>}
     * @memberof CreateAppointmentRequestBody
     */
    recipients?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CreateChatLockRequest
 */
export interface CreateChatLockRequest {
    /**
     * 
     * @type {ChatLockMode}
     * @memberof CreateChatLockRequest
     */
    mode: ChatLockMode;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof CreateChatLockRequest
     */
    allowedDaysOfWeek?: Array<DayOfWeek> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChatLockRequest
     */
    openTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChatLockRequest
     */
    closeTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateChatLockRequest
     */
    timeZone?: string;
}
/**
 * 
 * @export
 * @interface CreateChatParticipantRequest
 */
export interface CreateChatParticipantRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateChatParticipantRequest
     */
    userId: string;
    /**
     * 
     * @type {ChatUserType}
     * @memberof CreateChatParticipantRequest
     */
    userType: ChatUserType;
}
/**
 * 
 * @export
 * @interface CreateEventBody
 */
export interface CreateEventBody {
    /**
     * 
     * @type {string}
     * @memberof CreateEventBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventBody
     */
    description: string;
    /**
     * Null if the whole school should be the recipient
     * @type {Array<string>}
     * @memberof CreateEventBody
     */
    recipients?: Array<string> | null;
    /**
     * base64-encoded strings
     * @type {Array<string>}
     * @memberof CreateEventBody
     */
    attachments?: Array<string> | null;
    /**
     * Null if it should be published directly and not be planned for the future
     * @type {string}
     * @memberof CreateEventBody
     */
    publishDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventBody
     */
    pushNotification: boolean;
}
/**
 * 
 * @export
 * @interface CreateGuardianContactBody
 */
export interface CreateGuardianContactBody {
    /**
     * the student for which we shall create the guardian contact
     * @type {string}
     * @memberof CreateGuardianContactBody
     */
    studentId: string;
    /**
     * Display name of the guardian contact
     * @type {string}
     * @memberof CreateGuardianContactBody
     */
    displayName: string;
    /**
     * Mail of the guardian contact
     * @type {string}
     * @memberof CreateGuardianContactBody
     */
    email: string;
    /**
     * Array of mobile phone numbers to reach the guardian contact
     * @type {Array<string>}
     * @memberof CreateGuardianContactBody
     */
    phoneNumbers?: Array<string>;
    /**
     * Address of the guardian contact
     * @type {string}
     * @memberof CreateGuardianContactBody
     */
    address?: string | null;
    /**
     * Relationship between the guardian contact and the ward. Possible values are: Unknown, Guardian, Other 
     * @type {Relationship}
     * @memberof CreateGuardianContactBody
     */
    relationship?: Relationship;
    /**
     * Flag indicating if the guardian contact is the primary contact for the ward
     * @type {boolean}
     * @memberof CreateGuardianContactBody
     */
    isPrimaryContact?: boolean;
    /**
     * Links a guardian registering with this e-mail without a QR invitation.
     * @type {boolean}
     * @memberof CreateGuardianContactBody
     */
    canAutoConnect?: boolean;
}
/**
 * 
 * @export
 * @interface CreateNotebookResult
 */
export interface CreateNotebookResult {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateNotebookResult
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {ErrorType}
     * @memberof CreateNotebookResult
     */
    errorCode?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResult
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResult
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof CreateNotebookResult
     */
    details?: Array<ErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResult
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResult
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResult
     */
    jobId?: string | null;
    /**
     * 
     * @type {NotebookCreationState}
     * @memberof CreateNotebookResult
     */
    creationState?: NotebookCreationState;
}
/**
 * 
 * @export
 * @interface CreateNotebookResultAllOf
 */
export interface CreateNotebookResultAllOf {
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResultAllOf
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResultAllOf
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotebookResultAllOf
     */
    jobId?: string | null;
    /**
     * 
     * @type {NotebookCreationState}
     * @memberof CreateNotebookResultAllOf
     */
    creationState?: NotebookCreationState;
}
/**
 * 
 * @export
 * @interface CreateParentInvitationRequest
 */
export interface CreateParentInvitationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateParentInvitationRequest
     */
    oneTimeUse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationRequest
     */
    validFor?: string | null;
}
/**
 * 
 * @export
 * @interface CreateParentInvitationResponse
 */
export interface CreateParentInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    studentId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    organizationId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateParentInvitationResponse
     */
    oneTimeUse: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    qrData: string;
    /**
     * 
     * @type {string}
     * @memberof CreateParentInvitationResponse
     */
    url: string;
}
/**
 * 
 * @export
 * @interface CreatedUserDTO
 */
export interface CreatedUserDTO {
    /**
     * 
     * @type {User}
     * @memberof CreatedUserDTO
     */
    user: User;
    /**
     * 
     * @type {UserPasswordOptions}
     * @memberof CreatedUserDTO
     */
    passwordOptions?: UserPasswordOptions;
}
/**
 * 
 * @export
 * @interface CustomUpdateTimeWindowAsDateTime
 */
export interface CustomUpdateTimeWindowAsDateTime {
    /**
     * 
     * @type {string}
     * @memberof CustomUpdateTimeWindowAsDateTime
     */
    start: string;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CustomUpdateTimeWindowAsDateTime
     */
    startDayOfWeek: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof CustomUpdateTimeWindowAsDateTime
     */
    end: string;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CustomUpdateTimeWindowAsDateTime
     */
    endDayOfWeek: DayOfWeek;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DayOfWeek {
    sunday = 'Sunday',
    monday = 'Monday',
    tuesday = 'Tuesday',
    wednesday = 'Wednesday',
    thursday = 'Thursday',
    friday = 'Friday',
    saturday = 'Saturday'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum DefaultSearchProvider {
    google = 'Google',
    bing = 'Bing',
    yahoo = 'Yahoo'
}

/**
 * 
 * @export
 * @interface Delays
 */
export interface Delays {
    /**
     * 
     * @type {number}
     * @memberof Delays
     */
    totalDelays: number;
    /**
     * 
     * @type {number}
     * @memberof Delays
     */
    unexcusedDelays: number;
}
/**
 * 
 * @export
 * @interface DepOnboardSettingsResponse
 */
export interface DepOnboardSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    appleIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    tokenExpirationDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    lastModifiedDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    lastSuccessfulSyncDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    lastSyncTriggeredDateTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof DepOnboardSettingsResponse
     */
    shareTokenWithSchoolDataSyncService: boolean;
    /**
     * 
     * @type {number}
     * @memberof DepOnboardSettingsResponse
     */
    lastSyncErrorCode: number;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    tokenType: string;
    /**
     * 
     * @type {string}
     * @memberof DepOnboardSettingsResponse
     */
    tokenName: string;
    /**
     * 
     * @type {number}
     * @memberof DepOnboardSettingsResponse
     */
    syncedDeviceCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof DepOnboardSettingsResponse
     */
    dataSharingConsentGranted: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DepOnboardSettingsResponse
     */
    roleScopeTagIds: Array<string>;
}
/**
 * 
 * @export
 * @interface Device
 */
export interface Device {
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    operatingSystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    operatingSystemVersion?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceActionResponse
 */
export interface DeviceActionResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceActionResponse
     */
    actionName: string;
    /**
     * 
     * @type {ActionState}
     * @memberof DeviceActionResponse
     */
    actionState: ActionState;
    /**
     * 
     * @type {string}
     * @memberof DeviceActionResponse
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceActionResponse
     */
    lastUpdatedDateTime?: string | null;
}
/**
 * 
 * @export
 * @interface DeviceConfigurationResponse
 */
export interface DeviceConfigurationResponse {
    /**
     * 
     * @type {EnrollmentProfileBasicResponse}
     * @memberof DeviceConfigurationResponse
     */
    enrollmentProfile?: EnrollmentProfileBasicResponse | null;
    /**
     * 
     * @type {Array<ConfigurationProfileBasicResponse>}
     * @memberof DeviceConfigurationResponse
     */
    configurationProfiles?: Array<ConfigurationProfileBasicResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceOwner {
    unknown = 'Unknown',
    company = 'Company',
    personal = 'Personal'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceRegistration {
    any = 'Any',
    registered = 'Registered',
    managed = 'Managed'
}

/**
 * 
 * @export
 * @interface DeviceResponse
 */
export interface DeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    description: string;
    /**
     * 
     * @type {Array<Person>}
     * @memberof DeviceResponse
     */
    users: Array<Person>;
    /**
     * 
     * @type {ChassisType}
     * @memberof DeviceResponse
     */
    chassisType: ChassisType;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    mainUserId: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    mainUserUPN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    ownerType: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    lastContact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    registeredAt?: string | null;
    /**
     * 
     * @type {HardwareInfoResponse}
     * @memberof DeviceResponse
     */
    hardwareInfo: HardwareInfoResponse;
    /**
     * 
     * @type {Array<BasicMdmGroupResponse>}
     * @memberof DeviceResponse
     */
    groupMemberships?: Array<BasicMdmGroupResponse>;
    /**
     * 
     * @type {DeviceConfigurationResponse}
     * @memberof DeviceResponse
     */
    settings?: DeviceConfigurationResponse;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof DeviceResponse
     */
    basicSoftware?: Array<BasicSoftwareResponse>;
    /**
     * 
     * @type {Array<DeviceActionResponse>}
     * @memberof DeviceResponse
     */
    deviceActions?: Array<DeviceActionResponse>;
}
/**
 * 
 * @export
 * @interface DocumentsGetFilesResponse
 */
export interface DocumentsGetFilesResponse {
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    microsoft_graph_downloadUrl?: string | null;
    /**
     * 
     * @type {ExchangeAuthor}
     * @memberof DocumentsGetFilesResponse
     */
    createdBy: ExchangeAuthor;
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    createdDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    id: string;
    /**
     * 
     * @type {ExchangeAuthor}
     * @memberof DocumentsGetFilesResponse
     */
    lastModifiedBy: ExchangeAuthor;
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    lastModifiedDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    name: string;
    /**
     * 
     * @type {ExchangeParentReference}
     * @memberof DocumentsGetFilesResponse
     */
    parentReference?: ExchangeParentReference | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentsGetFilesResponse
     */
    webUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentsGetFilesResponse
     */
    size?: number;
    /**
     * 
     * @type {ExchangeFile}
     * @memberof DocumentsGetFilesResponse
     */
    file?: ExchangeFile | null;
    /**
     * 
     * @type {ExchangeFolder}
     * @memberof DocumentsGetFilesResponse
     */
    folder?: ExchangeFolder | null;
}
/**
 * 
 * @export
 * @interface DocumentsZipResponse
 */
export interface DocumentsZipResponse {
    /**
     * 
     * @type {string}
     * @memberof DocumentsZipResponse
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface DocumentsZipSelection
 */
export interface DocumentsZipSelection {
    /**
     * 
     * @type {ZipSourceType}
     * @memberof DocumentsZipSelection
     */
    sourceType: ZipSourceType;
    /**
     * Required for Personal and Group, forbidden for SchoolWide, which has no Graph drive.
     * @type {string}
     * @memberof DocumentsZipSelection
     */
    driveId?: string | null;
    /**
     * Graph item ids, or ParentFile Guids for SchoolWide. Whether an entry is a file or a folder is resolved by the backend, never taken from the client.
     * @type {Array<string>}
     * @memberof DocumentsZipSelection
     */
    itemIds: Array<string>;
}
/**
 * 
 * @export
 * @interface DocumentsZipStatusResponse
 */
export interface DocumentsZipStatusResponse {
    /**
     * Set once the archive is ready. Null while the job is still running.
     * @type {string}
     * @memberof DocumentsZipStatusResponse
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentsZipStatusResponse
     */
    message?: string | null;
    /**
     * 
     * @type {Severity}
     * @memberof DocumentsZipStatusResponse
     */
    severity?: Severity | null;
}
/**
 * 
 * @export
 * @interface DriveItem
 */
export interface DriveItem {
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    eTag?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DriveItem
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    lastModifiedDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    createdDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItem
     */
    webUrl?: string | null;
    /**
     * 
     * @type {Array<DriveItem>}
     * @memberof DriveItem
     */
    children?: Array<DriveItem> | null;
    /**
     * 
     * @type {DriveItemFolder}
     * @memberof DriveItem
     */
    folder?: DriveItemFolder | null;
    /**
     * 
     * @type {FileObject}
     * @memberof DriveItem
     */
    file?: FileObject | null;
    /**
     * 
     * @type {ItemReference}
     * @memberof DriveItem
     */
    parentReference?: ItemReference | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof DriveItem
     */
    createdBy?: IdentitySet | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof DriveItem
     */
    lastModifiedBy?: IdentitySet | null;
}
/**
 * 
 * @export
 * @interface DriveItemFolder
 */
export interface DriveItemFolder {
    /**
     * 
     * @type {number}
     * @memberof DriveItemFolder
     */
    childCount?: number;
    /**
     * 
     * @type {DriveItemFolderView}
     * @memberof DriveItemFolder
     */
    folderView?: DriveItemFolderView | null;
}
/**
 * 
 * @export
 * @interface DriveItemFolderView
 */
export interface DriveItemFolderView {
    /**
     * 
     * @type {string}
     * @memberof DriveItemFolderView
     */
    sortBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItemFolderView
     */
    sortOrder?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DriveItemFolderView
     */
    viewType?: string | null;
}
/**
 * 
 * @export
 * @interface DuplicateEntry
 */
export interface DuplicateEntry {
    /**
     * 
     * @type {string}
     * @memberof DuplicateEntry
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateEntry
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface DuplicateSchoolEventMappingError
 */
export interface DuplicateSchoolEventMappingError {
    /**
     * Message of the error
     * @type {string}
     * @memberof DuplicateSchoolEventMappingError
     */
    message?: string | null;
    /**
     * Metadata of the error
     * @type {{ [key: string]: any; }}
     * @memberof DuplicateSchoolEventMappingError
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Get the reasons of an error
     * @type {Array<IError>}
     * @memberof DuplicateSchoolEventMappingError
     */
    reasons?: Array<IError> | null;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof DuplicateSchoolEventMappingError
     */
    statusCode?: HttpStatusCode;
    /**
     * 
     * @type {ErrorType}
     * @memberof DuplicateSchoolEventMappingError
     */
    errorType?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof DuplicateSchoolEventMappingError
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<DuplicateEntry>}
     * @memberof DuplicateSchoolEventMappingError
     */
    duplicateEntries?: Array<DuplicateEntry>;
}
/**
 * 
 * @export
 * @interface DuplicateSchoolEventMappingErrorAllOf
 */
export interface DuplicateSchoolEventMappingErrorAllOf {
    /**
     * 
     * @type {Array<DuplicateEntry>}
     * @memberof DuplicateSchoolEventMappingErrorAllOf
     */
    duplicateEntries?: Array<DuplicateEntry>;
}
/**
 * 
 * @export
 * @interface EditAndNotificationSettingsItem
 */
export interface EditAndNotificationSettingsItem {
    /**
     * 
     * @type {AbsenceCheckFrequency}
     * @memberof EditAndNotificationSettingsItem
     */
    absenceCheckFrequency: AbsenceCheckFrequency;
    /**
     * 
     * @type {number}
     * @memberof EditAndNotificationSettingsItem
     */
    absenceOverdueDays: number;
    /**
     * 
     * @type {number}
     * @memberof EditAndNotificationSettingsItem
     */
    editLessonsFutureDays: number;
    /**
     * 
     * @type {number}
     * @memberof EditAndNotificationSettingsItem
     */
    editLessonsPastDays: number;
    /**
     * 
     * @type {number}
     * @memberof EditAndNotificationSettingsItem
     */
    lessonThemeOverdueDays: number;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof EditAndNotificationSettingsItem
     */
    schoolHeadSignOffRequirement: SignOffRequirement;
    /**
     * 
     * @type {number}
     * @memberof EditAndNotificationSettingsItem
     */
    signOffOverdueDays: number;
}
/**
 * 
 * @export
 * @interface EducationAssignmentAddLinkResourceRequest
 */
export interface EducationAssignmentAddLinkResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddLinkResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {EducationResource}
     * @memberof EducationAssignmentAddLinkResourceRequest
     */
    assignmentResource?: EducationResource | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddLinkResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {DriveItem}
     * @memberof EducationAssignmentAddLinkResourceRequest
     */
    sourceFile?: DriveItem | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentAddResourceRequest
 */
export interface EducationAssignmentAddResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {EducationAssignmentResource}
     * @memberof EducationAssignmentAddResourceRequest
     */
    assignmentResource?: EducationAssignmentResource | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddResourceRequest
     */
    groupId?: string;
}
/**
 * 
 * @export
 * @interface EducationAssignmentAddSubmissionResourceRequest
 */
export interface EducationAssignmentAddSubmissionResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddSubmissionResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {EducationAssignmentResource}
     * @memberof EducationAssignmentAddSubmissionResourceRequest
     */
    assignmentResource?: EducationAssignmentResource | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddSubmissionResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {DriveItem}
     * @memberof EducationAssignmentAddSubmissionResourceRequest
     */
    sourceFile?: DriveItem | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentAddSubmissionResourceRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentCreateRequest
 */
export interface EducationAssignmentCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentCreateRequest
     */
    groupId?: string;
}
/**
 * 
 * @export
 * @interface EducationAssignmentDeleteLinkResourceRequest
 */
export interface EducationAssignmentDeleteLinkResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteLinkResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteLinkResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteLinkResourceRequest
     */
    resourceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteLinkResourceRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentDeleteRequest
 */
export interface EducationAssignmentDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteRequest
     */
    assignmentId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentDeleteResourceRequest
 */
export interface EducationAssignmentDeleteResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteResourceRequest
     */
    resourceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteResourceRequest
     */
    driveItemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteResourceRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentDeleteSubmissionResourceRequest
 */
export interface EducationAssignmentDeleteSubmissionResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteSubmissionResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteSubmissionResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteSubmissionResourceRequest
     */
    resourceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteSubmissionResourceRequest
     */
    submissionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentDeleteSubmissionResourceRequest
     */
    driveItemId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentGetRequest
 */
export interface EducationAssignmentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetRequest
     */
    assignmentId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentGetSubmissionRequest
 */
export interface EducationAssignmentGetSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentGetSubmissionResourcesRequest
 */
export interface EducationAssignmentGetSubmissionResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionResourcesRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionResourcesRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionResourcesRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentGetSubmissionsRequest
 */
export interface EducationAssignmentGetSubmissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionsRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentGetSubmissionsRequest
     */
    assignmentId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentPointsGrade
 */
export interface EducationAssignmentPointsGrade {
    /**
     * 
     * @type {number}
     * @memberof EducationAssignmentPointsGrade
     */
    points?: number;
}
/**
 * 
 * @export
 * @interface EducationAssignmentPublishRequest
 */
export interface EducationAssignmentPublishRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentPublishRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentPublishRequest
     */
    assignmentId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentResource
 */
export interface EducationAssignmentResource {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResource
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EducationAssignmentResource
     */
    distributeForStudentWork?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResource
     */
    assignmentResourceUrl?: string | null;
    /**
     * 
     * @type {EducationResource}
     * @memberof EducationAssignmentResource
     */
    resource?: EducationResource | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentResponse
 */
export interface EducationAssignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    classId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {Instructions}
     * @memberof EducationAssignmentResponse
     */
    instructions?: Instructions | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    dueDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    createdDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    assignDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    assignedDateTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EducationAssignmentResponse
     */
    allowLateSubmissions?: boolean;
    /**
     * 
     * @type {Grading}
     * @memberof EducationAssignmentResponse
     */
    grading?: Grading | null;
    /**
     * 
     * @type {EducationAssignmentStatus}
     * @memberof EducationAssignmentResponse
     */
    status?: EducationAssignmentStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EducationAssignmentResponse
     */
    allowStudentsToAddResourcesToSubmission?: boolean;
    /**
     * 
     * @type {Array<EducationSubmission>}
     * @memberof EducationAssignmentResponse
     */
    submissions?: Array<EducationSubmission> | null;
    /**
     * 
     * @type {Array<EducationAssignmentResource>}
     * @memberof EducationAssignmentResponse
     */
    resources?: Array<EducationAssignmentResource> | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentResponse
     */
    webUrl?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentReturnSubmissionRequest
 */
export interface EducationAssignmentReturnSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentReturnSubmissionRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentReturnSubmissionRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentReturnSubmissionRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentRevertSubmissionRequest
 */
export interface EducationAssignmentRevertSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentRevertSubmissionRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentRevertSubmissionRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentRevertSubmissionRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationAssignmentSendSubmissionRequest
 */
export interface EducationAssignmentSendSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentSendSubmissionRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentSendSubmissionRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentSendSubmissionRequest
     */
    submissionId?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EducationAssignmentStatus {
    draft = 'draft',
    scheduled = 'scheduled',
    published = 'published',
    assigned = 'assigned'
}

/**
 * 
 * @export
 * @interface EducationAssignmentUpdateRequest
 */
export interface EducationAssignmentUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentUpdateRequest
     */
    groupId?: string;
    /**
     * 
     * @type {EducationAssignmentResponse}
     * @memberof EducationAssignmentUpdateRequest
     */
    eduAssignment: EducationAssignmentResponse;
}
/**
 * 
 * @export
 * @interface EducationAssignmentUpdateResourceRequest
 */
export interface EducationAssignmentUpdateResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentUpdateResourceRequest
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentUpdateResourceRequest
     */
    assignmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationAssignmentUpdateResourceRequest
     */
    resourceId?: string | null;
    /**
     * 
     * @type {EducationAssignmentResource}
     * @memberof EducationAssignmentUpdateResourceRequest
     */
    resource?: EducationAssignmentResource | null;
}
/**
 * 
 * @export
 * @interface EducationFeedback
 */
export interface EducationFeedback {
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationFeedback
     */
    feedbackBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationFeedback
     */
    feedbackDateTime?: string;
    /**
     * 
     * @type {EducationItemBody}
     * @memberof EducationFeedback
     */
    text?: EducationItemBody | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EducationFeedbackResourceOutcomeStatus {
    notPublished = 'notPublished',
    pendingPublish = 'pendingPublish',
    published = 'published',
    failedPublish = 'failedPublish'
}

/**
 * 
 * @export
 * @interface EducationItemBody
 */
export interface EducationItemBody {
    /**
     * 
     * @type {string}
     * @memberof EducationItemBody
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationItemBody
     */
    contentType?: string | null;
}
/**
 * 
 * @export
 * @interface EducationOutcome
 */
export interface EducationOutcome {
    /**
     * 
     * @type {EducationFeedback}
     * @memberof EducationOutcome
     */
    feedback?: EducationFeedback | null;
    /**
     * 
     * @type {EducationResource}
     * @memberof EducationOutcome
     */
    feedbackResource?: EducationResource | null;
    /**
     * 
     * @type {string}
     * @memberof EducationOutcome
     */
    id?: string | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationOutcome
     */
    lastModifiedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationOutcome
     */
    lastModifiedDateTime?: string | null;
    /**
     * 
     * @type {EducationAssignmentPointsGrade}
     * @memberof EducationOutcome
     */
    points?: EducationAssignmentPointsGrade | null;
    /**
     * 
     * @type {EducationFeedback}
     * @memberof EducationOutcome
     */
    publishedFeedback?: EducationFeedback | null;
    /**
     * 
     * @type {EducationAssignmentPointsGrade}
     * @memberof EducationOutcome
     */
    publishedPoints?: EducationAssignmentPointsGrade | null;
    /**
     * 
     * @type {EducationFeedbackResourceOutcomeStatus}
     * @memberof EducationOutcome
     */
    resourceStatus?: EducationFeedbackResourceOutcomeStatus;
}
/**
 * 
 * @export
 * @interface EducationResource
 */
export interface EducationResource {
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationResource
     */
    createdBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    createdDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    fileUrl?: string | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationResource
     */
    lastModifiedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    lastModifiedDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    link?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    odata_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationResource
     */
    webUrl?: string | null;
}
/**
 * 
 * @export
 * @interface EducationSubmission
 */
export interface EducationSubmission {
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    id?: string | null;
    /**
     * 
     * @type {Array<EducationOutcome>}
     * @memberof EducationSubmission
     */
    outcomes?: Array<EducationOutcome> | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationSubmission
     */
    reassignedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    reassignedDateTime?: string | null;
    /**
     * 
     * @type {EducationSubmissionRecipient}
     * @memberof EducationSubmission
     */
    recipient?: EducationSubmissionRecipient | null;
    /**
     * 
     * @type {Array<EducationSubmissionResource>}
     * @memberof EducationSubmission
     */
    resources?: Array<EducationSubmissionResource> | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    resourcesFolderUrl?: string | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationSubmission
     */
    returnedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    returnedDateTime?: string | null;
    /**
     * 
     * @type {EducationSubmissionStatus}
     * @memberof EducationSubmission
     */
    status?: EducationSubmissionStatus;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationSubmission
     */
    submittedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    submittedDateTime?: string | null;
    /**
     * 
     * @type {Array<EducationSubmissionResource>}
     * @memberof EducationSubmission
     */
    submittedResources?: Array<EducationSubmissionResource> | null;
    /**
     * 
     * @type {IdentitySet}
     * @memberof EducationSubmission
     */
    unsubmittedBy?: IdentitySet | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmission
     */
    unsubmittedDateTime?: string | null;
}
/**
 * 
 * @export
 * @interface EducationSubmissionRecipient
 */
export interface EducationSubmissionRecipient {
    /**
     * 
     * @type {string}
     * @memberof EducationSubmissionRecipient
     */
    userId?: string | null;
}
/**
 * 
 * @export
 * @interface EducationSubmissionResource
 */
export interface EducationSubmissionResource {
    /**
     * 
     * @type {string}
     * @memberof EducationSubmissionResource
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EducationSubmissionResource
     */
    assignmentResourceUrl?: string | null;
    /**
     * 
     * @type {EducationResource}
     * @memberof EducationSubmissionResource
     */
    resource?: EducationResource | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EducationSubmissionStatus {
    working = 'working',
    submitted = 'submitted',
    released = 'released',
    returned = 'returned',
    reassigned = 'reassigned'
}

/**
 * 
 * @export
 * @interface EffectiveLessonPermissions
 */
export interface EffectiveLessonPermissions {
    /**
     * 
     * @type {boolean}
     * @memberof EffectiveLessonPermissions
     */
    canCreateTeamsAssignment: boolean;
    /**
     * 
     * @type {string}
     * @memberof EffectiveLessonPermissions
     */
    lessonId: string;
}
/**
 * 
 * @export
 * @interface EffectivePermissionsResponse
 */
export interface EffectivePermissionsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof EffectivePermissionsResponse
     */
    permissions: Array<string>;
    /**
     * True if the current user is able to grant the tenant wide admin consent our apps require. Used by the frontend to decide whether the consent hint asks the user to consent or to contact a school administrator.
     * @type {boolean}
     * @memberof EffectivePermissionsResponse
     */
    canGiveAppConsent: boolean;
}
/**
 * 
 * @export
 * @interface ElternappAbsenceDraftResponse
 */
export interface ElternappAbsenceDraftResponse {
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    timePeriod?: string;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof ElternappAbsenceDraftResponse
     */
    student: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    reason?: string;
    /**
     * 
     * @type {ElternappAbsenceDraftState}
     * @memberof ElternappAbsenceDraftResponse
     */
    state?: ElternappAbsenceDraftState;
    /**
     * 
     * @type {number}
     * @memberof ElternappAbsenceDraftResponse
     */
    timeSlotStart?: number;
    /**
     * 
     * @type {number}
     * @memberof ElternappAbsenceDraftResponse
     */
    timeSlotEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappAbsenceDraftResponse
     */
    submittedOn?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ElternappAbsenceDraftState {
    submitted = 'Submitted',
    accepted = 'Accepted',
    declined = 'Declined'
}

/**
 * 
 * @export
 * @interface ElternappGroup
 */
export interface ElternappGroup {
    /**
     * 
     * @type {string}
     * @memberof ElternappGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappGroup
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ElternappPerson
 */
export interface ElternappPerson {
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    lastName: string;
    /**
     * 
     * @type {School}
     * @memberof ElternappPerson
     */
    school: School;
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ElternappPerson
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface EnrollmentProfileBasicResponse
 */
export interface EnrollmentProfileBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentProfileBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentProfileBasicResponse
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentProfileBasicResponse
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentProfileBasicResponse
     */
    requiresUserAuthentication?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentProfileBasicResponse
     */
    configurationEndpointUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentProfileBasicResponse
     */
    enableAuthenticationViaCompanyPortal?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnrollmentProfileBasicResponse
     */
    requireCompanyPortalOnSetupAssistantEnrolledDevices?: boolean | null;
    /**
     * 
     * @type {ConfigurationProfileType}
     * @memberof EnrollmentProfileBasicResponse
     */
    profileType?: ConfigurationProfileType;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EntitledAdmin {
    administrators = 'Administrators',
    remotedesktopUser = 'RemotedesktopUser'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum EntityType {
    none = 'None',
    grade = 'Grade',
    class = 'Class',
    course = 'Course'
}

/**
 * 
 * @export
 * @interface Equipment
 */
export interface Equipment {
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    activeDirectoryId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Equipment
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    id?: string | null;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof Equipment
     */
    resourceStatus?: ResourceStatus;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Equipment
     */
    alias?: string | null;
    /**
     * 
     * @type {PhysicalAddress}
     * @memberof Equipment
     */
    address?: PhysicalAddress | null;
}
/**
 * 
 * @export
 * @interface EquipmentAllOf
 */
export interface EquipmentAllOf {
    /**
     * 
     * @type {string}
     * @memberof EquipmentAllOf
     */
    alias?: string | null;
    /**
     * 
     * @type {PhysicalAddress}
     * @memberof EquipmentAllOf
     */
    address?: PhysicalAddress | null;
}
/**
 * 
 * @export
 * @interface EquipmentOptions
 */
export interface EquipmentOptions {
    /**
     * 
     * @type {PhysicalAddress}
     * @memberof EquipmentOptions
     */
    address?: PhysicalAddress | null;
    /**
     * 
     * @type {string}
     * @memberof EquipmentOptions
     */
    alias?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EquipmentOptions
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentOptions
     */
    displayName?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorDetail
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorDetail
     */
    errorCode?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    message?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorDetailUntranslatable
 */
export interface ErrorDetailUntranslatable {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorDetailUntranslatable
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorDetailUntranslatable
     */
    errorCode?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailUntranslatable
     */
    message?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorResponse
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorResponse
     */
    errorCode?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ErrorResponse
     */
    details?: Array<ErrorDetail>;
}
/**
 * 
 * @export
 * @interface ErrorResponseAllOf
 */
export interface ErrorResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseAllOf
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<ErrorDetail>}
     * @memberof ErrorResponseAllOf
     */
    details?: Array<ErrorDetail>;
}
/**
 * 
 * @export
 * @interface ErrorResponseUntranslatable
 */
export interface ErrorResponseUntranslatable {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorResponseUntranslatable
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorResponseUntranslatable
     */
    errorCode?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseUntranslatable
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseUntranslatable
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<ErrorDetailUntranslatable>}
     * @memberof ErrorResponseUntranslatable
     */
    details?: Array<ErrorDetailUntranslatable> | null;
}
/**
 * 
 * @export
 * @interface ErrorResponseUntranslatableAllOf
 */
export interface ErrorResponseUntranslatableAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseUntranslatableAllOf
     */
    traceId?: string | null;
    /**
     * 
     * @type {Array<ErrorDetailUntranslatable>}
     * @memberof ErrorResponseUntranslatableAllOf
     */
    details?: Array<ErrorDetailUntranslatable> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ErrorType {
    unhandled = 'Unhandled',
    unknown = 'Unknown',
    unknownGraphException = 'UnknownGraphException',
    minVersionMismatch = 'MinVersionMismatch',
    disabledApplication = 'DisabledApplication',
    restoreFailed = 'RestoreFailed',
    restoreTimedOut = 'RestoreTimedOut',
    internal = 'Internal',
    databaseQueryFailed = 'DatabaseQueryFailed',
    invalidModelState = 'InvalidModelState',
    invalidIds = 'InvalidIds',
    invalidTokenFormat = 'InvalidTokenFormat',
    invalidDate = 'InvalidDate',
    formatMismatch = 'FormatMismatch',
    tenantNotFound = 'TenantNotFound',
    tenantRetired = 'TenantRetired',
    organizationNotFound = 'OrganizationNotFound',
    userNotFound = 'UserNotFound',
    photoNotFound = 'PhotoNotFound',
    templateNotFound = 'TemplateNotFound',
    userCreationFailed = 'UserCreationFailed',
    argumentNull = 'ArgumentNull',
    untranslatableError = 'UntranslatableError',
    userPrincipalNameAlreadyExists = 'UserPrincipalNameAlreadyExists',
    usersOneDriveNotProvisioned = 'UsersOneDriveNotProvisioned',
    usersOneDriveProvisioningInProgress = 'UsersOneDriveProvisioningInProgress',
    coursesLoadFailed = 'CoursesLoadFailed',
    entityNotFound = 'EntityNotFound',
    entityDeleted = 'EntityDeleted',
    entityOutdated = 'EntityOutdated',
    entityDisabled = 'EntityDisabled',
    entityAlreadyExisting = 'EntityAlreadyExisting',
    entityNoDeleteDueToDependencies = 'EntityNoDeleteDueToDependencies',
    entityNoDeleteDueToActive = 'EntityNoDeleteDueToActive',
    entityAzureIdAlreadyInUse = 'EntityAzureIdAlreadyInUse',
    entityAzureIdAlreadyInDuplicateUse = 'EntityAzureIdAlreadyInDuplicateUse',
    entityAzureIdNotFound = 'EntityAzureIdNotFound',
    lessonEndNotReached = 'LessonEndNotReached',
    entityNotAllowed = 'EntityNotAllowed',
    entityExternalNotAllowed = 'EntityExternalNotAllowed',
    timePeriodNoDeleteDueToDependencies = 'TimePeriodNoDeleteDueToDependencies',
    azureGroupNotFound = 'AzureGroupNotFound',
    invalidFileType = 'InvalidFileType',
    invalidFileSize = 'InvalidFileSize',
    invalidFileName = 'InvalidFileName',
    cockpitBannerDisabled = 'CockpitBannerDisabled',
    entityNotDeleted = 'EntityNotDeleted',
    userTemplateDuplicateName = 'UserTemplateDuplicateName',
    groupTemplateDuplicateName = 'GroupTemplateDuplicateName',
    entraIdAlreadyInUseForGrade = 'EntraIdAlreadyInUseForGrade',
    entraIdAlreadyInUseForClass = 'EntraIdAlreadyInUseForClass',
    entraIdAlreadyInUseForCourse = 'EntraIdAlreadyInUseForCourse',
    passwordChangeNotAllowedForUser = 'PasswordChangeNotAllowedForUser',
    passwordChangeNotAllowedForUserRole = 'PasswordChangeNotAllowedForUserRole',
    passwordChangeNotAllowedForNonGroupMember = 'PasswordChangeNotAllowedForNonGroupMember',
    passwordChangeGeneralError = 'PasswordChangeGeneralError',
    passwordMethodNotFoundError = 'PasswordMethodNotFoundError',
    bookingTypeNotSupported = 'BookingTypeNotSupported',
    bookingOriginalEventNotFound = 'BookingOriginalEventNotFound',
    bookingNotAllowedForUser = 'BookingNotAllowedForUser',
    bookingOwnerNotFound = 'BookingOwnerNotFound',
    bookingResourceEventNotFound = 'BookingResourceEventNotFound',
    bookingStartRangeError = 'BookingStartRangeError',
    bookingDurationError = 'BookingDurationError',
    bookingCollision = 'BookingCollision',
    permissionsError = 'PermissionsError',
    conflict = 'Conflict',
    noAvailableLicense = 'NoAvailableLicense',
    noActivePeriodFound = 'NoActivePeriodFound',
    timePeriodNotFound = 'TimePeriodNotFound',
    organizationNotDeleted = 'OrganizationNotDeleted',
    timePeriodNotSwitched = 'TimePeriodNotSwitched',
    timePeriodNotUpdated = 'TimePeriodNotUpdated',
    timePeriodOverlapping = 'TimePeriodOverlapping',
    timePeriodNoDeleteDueToActive = 'TimePeriodNoDeleteDueToActive',
    timePeriodSwitchInProgress = 'TimePeriodSwitchInProgress',
    prefixRuleInvalidCharacters = 'PrefixRuleInvalidCharacters',
    prefixRuleInvalidProperties = 'PrefixRuleInvalidProperties',
    prefixRuleDifferentAmountOfBraces = 'PrefixRuleDifferentAmountOfBraces',
    importEmptyFile = 'ImportEmptyFile',
    importMissingUser = 'ImportMissingUser',
    importDuplicatedUserName = 'ImportDuplicatedUserName',
    importDuplicateReferenceId = 'ImportDuplicateReferenceId',
    importUserAlreadyExists = 'ImportUserAlreadyExists',
    importDifferentUserTemplate = 'ImportDifferentUserTemplate',
    importDifferentUserName = 'ImportDifferentUserName',
    importUserNameAlreadyInUse = 'ImportUserNameAlreadyInUse',
    importAnalyze = 'ImportAnalyze',
    importGroupTemplateNotFound = 'ImportGroupTemplateNotFound',
    importGroupCreation = 'ImportGroupCreation',
    importInvalidMailAddress = 'ImportInvalidMailAddress',
    importEmptyGroup = 'ImportEmptyGroup',
    importInvalidCsvFormat = 'ImportInvalidCsvFormat',
    importInvalidCsvData = 'ImportInvalidCsvData',
    cosmosException = 'CosmosException',
    timePatternActiveNotUpdatable = 'TimePatternActiveNotUpdatable',
    timePatternActiveNotDeletable = 'TimePatternActiveNotDeletable',
    timePatternExternalNotUpdatable = 'TimePatternExternalNotUpdatable',
    timePatternScopeNotMatchingLessons = 'TimePatternScopeNotMatchingLessons',
    timePatternSlotsOverlap = 'TimePatternSlotsOverlap',
    notResponsible = 'NotResponsible',
    groupCreation = 'GroupCreation',
    renamingGroup = 'RenamingGroup',
    unknownDomain = 'UnknownDomain',
    duplicateMails = 'DuplicateMails',
    noMailAddressDefined = 'NoMailAddressDefined',
    createdUserNotFound = 'CreatedUserNotFound',
    timeTableDataOfGroupNotFound = 'TimeTableDataOfGroupNotFound',
    timeTableDataOfRoomNotFound = 'TimeTableDataOfRoomNotFound',
    timeTableMaximumForeseeingExceeded = 'TimeTableMaximumForeseeingExceeded',
    signOffNotRequired = 'SignOffNotRequired',
    signOffLevelNotRequired = 'SignOffLevelNotRequired',
    signOffCanNotUnsign = 'SignOffCanNotUnsign',
    signOffUnknownSignLevel = 'SignOffUnknownSignLevel',
    cacheError = 'CacheError',
    invalidIntuneLicense = 'InvalidIntuneLicense',
    hybridRenameMultipleGroupsWithSameTargetName = 'HybridRenameMultipleGroupsWithSameTargetName',
    hybridPeriodNotFound = 'HybridPeriodNotFound',
    hybridActivationInProgress = 'HybridActivationInProgress',
    hybridTenantHeaderMissing = 'HybridTenantHeaderMissing',
    hybridTenantMismatch = 'HybridTenantMismatch',
    hybridApiKeyScopeForbidden = 'HybridApiKeyScopeForbidden',
    appRegistrationAppNotFound = 'AppRegistrationAppNotFound',
    resourceConflict = 'ResourceConflict',
    nameAlreadyInUse = 'NameAlreadyInUse',
    membershipRuleToComplex = 'MembershipRuleToComplex',
    classbookEntryDependencyError = 'ClassbookEntryDependencyError',
    deviceNotFound = 'DeviceNotFound',
    operatingSystemNotMatching = 'OperatingSystemNotMatching',
    locateDeviceNotActive = 'LocateDeviceNotActive',
    locateDevicePending = 'LocateDevicePending',
    locateDeviceNotAvailable = 'LocateDeviceNotAvailable',
    locateDeviceNotSupportedState = 'LocateDeviceNotSupportedState',
    deviceRenaming = 'DeviceRenaming',
    permissionTemplateError = 'PermissionTemplateError',
    substitutionAccessNotFound = 'SubstitutionAccessNotFound',
    importNoDomainsAssigned = 'ImportNoDomainsAssigned',
    appointmentCreation = 'AppointmentCreation',
    appointmentStartRange = 'AppointmentStartRange',
    parentalCommunicationPermission = 'ParentalCommunicationPermission',
    parentalCommunicationSettingNotFound = 'ParentalCommunicationSettingNotFound',
    gradeInUse = 'GradeInUse',
    classInUse = 'ClassInUse',
    duplicateSchoolEventMapping = 'DuplicateSchoolEventMapping',
    notebookCreationError = 'NotebookCreationError',
    teamNotFound = 'TeamNotFound',
    missingUserToken = 'MissingUserToken',
    fileNotShared = 'FileNotShared',
    fileIsDirectory = 'FileIsDirectory',
    folderCreationFailed = 'FolderCreationFailed',
    faviconRetrievalFailed = 'FaviconRetrievalFailed',
    favivonNotFound = 'FavivonNotFound',
    viewableDaysOutOfRange = 'ViewableDaysOutOfRange',
    mutualExclusiveUserRolesError = 'MutualExclusiveUserRolesError',
    parentalMailNotValid = 'ParentalMailNotValid',
    parentalMailNoStudents = 'ParentalMailNoStudents',
    notebookAlreadyExists = 'NotebookAlreadyExists',
    notebookCreationAlreadyInProcess = 'NotebookCreationAlreadyInProcess',
    groupRepairAlreadyInProgress = 'GroupRepairAlreadyInProgress',
    settingsNotFound = 'SettingsNotFound',
    settingsGetByCategoryError = 'SettingsGetByCategoryError',
    settingsCreateOrUpdateError = 'SettingsCreateOrUpdateError',
    settingsCreateOrUpdateMultipleError = 'SettingsCreateOrUpdateMultipleError',
    groupOrganizationMismatch = 'GroupOrganizationMismatch',
    serviceBusSendError = 'ServiceBusSendError',
    chatAcsIdentityMissing = 'ChatAcsIdentityMissing',
    chatAcsProvisioningFailed = 'ChatAcsProvisioningFailed',
    chatAcsTokenFailed = 'ChatAcsTokenFailed',
    chatNotAllowedForRoleError = 'ChatNotAllowedForRoleError',
    chatThreadValidation = 'ChatThreadValidation',
    acsThreadCreationFailed = 'AcsThreadCreationFailed',
    chatLocked = 'ChatLocked',
    chatAcsMessageSendFailed = 'ChatAcsMessageSendFailed',
    chatAcsParticipantAddFailed = 'ChatAcsParticipantAddFailed',
    chatAcsParticipantRemoveFailed = 'ChatAcsParticipantRemoveFailed',
    chatParticipantManagementNotAllowed = 'ChatParticipantManagementNotAllowed',
    featureNotEnabled = 'FeatureNotEnabled',
    absenceSubmissionDeadlinePassed = 'AbsenceSubmissionDeadlinePassed',
    absenceNoteRequired = 'AbsenceNoteRequired',
    absenceOutsideActivePeriod = 'AbsenceOutsideActivePeriod',
    invitationNotFound = 'InvitationNotFound',
    invitationTenantMismatch = 'InvitationTenantMismatch',
    signUpConsentFailed = 'SignUpConsentFailed',
    reportOrganizationMissing = 'ReportOrganizationMissing',
    reportEntityMissing = 'ReportEntityMissing',
    reportPeriodInvalid = 'ReportPeriodInvalid',
    reportTimeZoneUnknown = 'ReportTimeZoneUnknown',
    userNotProvisioned = 'UserNotProvisioned',
    zipSelectionSingleFile = 'ZipSelectionSingleFile',
    zipItemNotAccessible = 'ZipItemNotAccessible',
    zipJobNotFound = 'ZipJobNotFound',
    zipJobSchedulingFailed = 'ZipJobSchedulingFailed',
    graphThrottled = 'GraphThrottled',
    graphTimeout = 'GraphTimeout'
}

/**
 * 
 * @export
 * @interface ErrorTypeError
 */
export interface ErrorTypeError {
    /**
     * Message of the error
     * @type {string}
     * @memberof ErrorTypeError
     */
    message?: string | null;
    /**
     * Metadata of the error
     * @type {{ [key: string]: any; }}
     * @memberof ErrorTypeError
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Get the reasons of an error
     * @type {Array<IError>}
     * @memberof ErrorTypeError
     */
    reasons?: Array<IError> | null;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof ErrorTypeError
     */
    statusCode?: HttpStatusCode;
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorTypeError
     */
    errorType?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorTypeError
     */
    traceId?: string | null;
}
/**
 * 
 * @export
 * @interface ErrorTypeErrorAllOf
 */
export interface ErrorTypeErrorAllOf {
    /**
     * 
     * @type {ErrorType}
     * @memberof ErrorTypeErrorAllOf
     */
    errorType?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof ErrorTypeErrorAllOf
     */
    traceId?: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeAuthor
 */
export interface ExchangeAuthor {
    /**
     * 
     * @type {ExchangeUser}
     * @memberof ExchangeAuthor
     */
    user: ExchangeUser;
}
/**
 * 
 * @export
 * @interface ExchangeFile
 */
export interface ExchangeFile {
    /**
     * 
     * @type {string}
     * @memberof ExchangeFile
     */
    mimeType: string | null;
}
/**
 * 
 * @export
 * @interface ExchangeFolder
 */
export interface ExchangeFolder {
    /**
     * 
     * @type {number}
     * @memberof ExchangeFolder
     */
    childCount?: number | null;
}
/**
 * 
 * @export
 * @interface ExchangeParentReference
 */
export interface ExchangeParentReference {
    /**
     * 
     * @type {string}
     * @memberof ExchangeParentReference
     */
    driveType?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeParentReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeParentReference
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeParentReference
     */
    path: string;
}
/**
 * 
 * @export
 * @interface ExchangeUser
 */
export interface ExchangeUser {
    /**
     * 
     * @type {string}
     * @memberof ExchangeUser
     */
    eMail: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeUser
     */
    displayName: string;
}
/**
 * 
 * @export
 * @interface ExcuseDefinitionEmbedded
 */
export interface ExcuseDefinitionEmbedded {
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionEmbedded
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionEmbedded
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionEmbedded
     */
    isCountingAsExcused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionEmbedded
     */
    shortName?: string;
    /**
     * 
     * @type {StandardButton}
     * @memberof ExcuseDefinitionEmbedded
     */
    standardButton?: StandardButton;
}
/**
 * 
 * @export
 * @interface ExcuseDefinitionEntry
 */
export interface ExcuseDefinitionEntry {
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionEntry
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionEntry
     */
    isCountingAsExcused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionEntry
     */
    shortName?: string | null;
    /**
     * 
     * @type {StandardButton}
     * @memberof ExcuseDefinitionEntry
     */
    standardButton?: StandardButton;
}
/**
 * 
 * @export
 * @interface ExcuseDefinitionIdOnly
 */
export interface ExcuseDefinitionIdOnly {
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionIdOnly
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface ExcuseDefinitionResponse
 */
export interface ExcuseDefinitionResponse {
    /**
     * 
     * @type {Author}
     * @memberof ExcuseDefinitionResponse
     */
    createdBy?: Author | null;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionResponse
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionResponse
     */
    isCountingAsExcused: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionResponse
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionResponse
     */
    shortName: string;
    /**
     * 
     * @type {StandardButton}
     * @memberof ExcuseDefinitionResponse
     */
    standardButton: StandardButton;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface ExcuseDefinitionUpdate
 */
export interface ExcuseDefinitionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionUpdate
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionUpdate
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionUpdate
     */
    isCountingAsExcused: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExcuseDefinitionUpdate
     */
    isDisabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExcuseDefinitionUpdate
     */
    shortName: string;
    /**
     * 
     * @type {StandardButton}
     * @memberof ExcuseDefinitionUpdate
     */
    standardButton?: StandardButton;
}
/**
 * 
 * @export
 * @interface Favourite
 */
export interface Favourite {
    /**
     * 
     * @type {string}
     * @memberof Favourite
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Favourite
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Favourite
     */
    url: string;
}
/**
 * 
 * @export
 * @interface FavouriteEntry
 */
export interface FavouriteEntry {
    /**
     * 
     * @type {string}
     * @memberof FavouriteEntry
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteEntry
     */
    url: string;
}
/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    value: string;
}
/**
 * 
 * @export
 * @interface FeatureResponse
 */
export interface FeatureResponse {
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponse
     */
    type: string;
}
/**
 * 
 * @export
 * @interface FeatureUpdateEntity
 */
export interface FeatureUpdateEntity {
    /**
     * 
     * @type {string}
     * @memberof FeatureUpdateEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureUpdateEntity
     */
    value: string;
}
/**
 * 
 * @export
 * @interface FeaturesGetAllRequest
 */
export interface FeaturesGetAllRequest {
    /**
     * 
     * @type {string}
     * @memberof FeaturesGetAllRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface FeaturesUpdateRequest
 */
export interface FeaturesUpdateRequest {
    /**
     * 
     * @type {Array<FeatureUpdateEntity>}
     * @memberof FeaturesUpdateRequest
     */
    features: Array<FeatureUpdateEntity>;
    /**
     * 
     * @type {string}
     * @memberof FeaturesUpdateRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface FileDownload
 */
export interface FileDownload {
    /**
     * 
     * @type {string}
     * @memberof FileDownload
     */
    uri: string;
    /**
     * 
     * @type {string}
     * @memberof FileDownload
     */
    availability: string;
}
/**
 * 
 * @export
 * @interface FileMetadata
 */
export interface FileMetadata {
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    organizationId: string;
    /**
     * 
     * @type {Audit}
     * @memberof FileMetadata
     */
    created: Audit;
    /**
     * 
     * @type {Audit}
     * @memberof FileMetadata
     */
    modified: Audit;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    path: string;
    /**
     * 
     * @type {Array<RecipientEmbedded>}
     * @memberof FileMetadata
     */
    recipients?: Array<RecipientEmbedded> | null;
    /**
     * 
     * @type {FileType}
     * @memberof FileMetadata
     */
    fileType: FileType;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof FileMetadata
     */
    mimeType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileMetadata
     */
    fileCount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileMetadata
     */
    sharedWithOrganization?: boolean;
}
/**
 * 
 * @export
 * @interface FileObject
 */
export interface FileObject {
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    mimeType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileObject
     */
    processingMetadata?: boolean;
    /**
     * 
     * @type {Hashes}
     * @memberof FileObject
     */
    hashes?: Hashes | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FileType {
    directory = 'Directory',
    file = 'File'
}

/**
 * 
 * @export
 * @interface FindUsersRequest
 */
export interface FindUsersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FindUsersRequest
     */
    organizationIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindUsersRequest
     */
    userIds: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FitlerByConnectedGuardians {
    none = 'None',
    connected = 'Connected',
    unconnected = 'Unconnected'
}

/**
 * 
 * @export
 * @interface FlatLessonContentEntry
 */
export interface FlatLessonContentEntry {
    /**
     * 
     * @type {ApiResolvedCourse}
     * @memberof FlatLessonContentEntry
     */
    course: ApiResolvedCourse;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlatLessonContentEntry
     */
    studentIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FlatLessonContentEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FlatLessonContentEntry
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof FlatLessonContentEntry
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof FlatLessonContentEntry
     */
    end: string;
    /**
     * 
     * @type {LessonTimeSlot}
     * @memberof FlatLessonContentEntry
     */
    timeSlot: LessonTimeSlot | null;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof FlatLessonContentEntry
     */
    teacher: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof FlatLessonContentEntry
     */
    themeDescription: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FolderWritePermissions {
    none = 'None',
    ownersOnly = 'OwnersOnly',
    allUsers = 'AllUsers'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ForceMinimumYouTubeRestrictedMode {
    doNotEnforceRestrictedModeOnYoutube = 'DoNotEnforceRestrictedModeOnYoutube',
    enforceAtLeastModerateRestrictedModeOnYoutube = 'EnforceAtLeastModerateRestrictedModeOnYoutube',
    enforceStrictRestrictedModeForYoutube = 'EnforceStrictRestrictedModeForYoutube'
}

/**
 * 
 * @export
 * @interface FrontendMigrationResponse
 */
export interface FrontendMigrationResponse {
    /**
     * 
     * @type {FrontendMigrationStatus}
     * @memberof FrontendMigrationResponse
     */
    status?: FrontendMigrationStatus;
    /**
     * 
     * @type {string}
     * @memberof FrontendMigrationResponse
     */
    jobId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FrontendMigrationResponse
     */
    canStartMigration?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FrontendMigrationStatus {
    unknown = 'Unknown',
    notStarted = 'NotStarted',
    running = 'Running',
    needsForwarding = 'NeedsForwarding',
    success = 'Success',
    failed = 'Failed'
}

/**
 * 
 * @export
 * @interface GeneralSettingsItem
 */
export interface GeneralSettingsItem {
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    gradeNamePlural?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    gradeNameSingular?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    timeZone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GeneralSettingsItem
     */
    allowMultipleAzureGroupUsage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    removingSubstitutionTeacherFromGroupTime?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    addingSubstitutionTeacherToGroupTime?: string;
    /**
     * 
     * @type {string}
     * @memberof GeneralSettingsItem
     */
    substitutionTeacherStayInGroupTime?: string;
}
/**
 * 
 * @export
 * @interface GetAbsenceDraftsRequest
 */
export interface GetAbsenceDraftsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceDraftsRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceDraftsRequest
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceDraftsRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceDraftsRequest
     */
    to?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAbsenceDraftsRequest
     */
    newest?: number;
}
/**
 * 
 * @export
 * @interface GetAbsenceReasonsRequest
 */
export interface GetAbsenceReasonsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceReasonsRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface GetAbsenceReasonsResponse
 */
export interface GetAbsenceReasonsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAbsenceReasonsResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAbsenceReasonsResponse
     */
    reasons?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetAbsencesOverviewRequest
 */
export interface GetAbsencesOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesOverviewRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesOverviewRequest
     */
    studentId?: string;
}
/**
 * 
 * @export
 * @interface GetAbsencesRequest
 */
export interface GetAbsencesRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesRequest
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesRequest
     */
    to?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAbsencesRequest
     */
    newest?: number;
}
/**
 * 
 * @export
 * @interface GetAbsencesResponse
 */
export interface GetAbsencesResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    timePeriod?: string;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof GetAbsencesResponse
     */
    student: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    end: string;
    /**
     * 
     * @type {AbsenceCategory}
     * @memberof GetAbsencesResponse
     */
    category?: AbsenceCategory;
    /**
     * 
     * @type {boolean}
     * @memberof GetAbsencesResponse
     */
    isExcused?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAbsencesResponse
     */
    effectiveMissingLessons?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesResponse
     */
    offset?: string | null;
}
/**
 * 
 * @export
 * @interface GetAbsencesSettingsRequest
 */
export interface GetAbsencesSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesSettingsRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface GetAbsencesSettingsResponse
 */
export interface GetAbsencesSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAbsencesSettingsResponse
     */
    disclaimerText?: string;
    /**
     * 
     * @type {AbsenceSubmissionDeadline}
     * @memberof GetAbsencesSettingsResponse
     */
    absenceSubmissionDeadline?: AbsenceSubmissionDeadline;
    /**
     * 
     * @type {boolean}
     * @memberof GetAbsencesSettingsResponse
     */
    isNoteMandatory?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GetAllParentalMailSortBy {
    title = 'Title',
    sentAt = 'SentAt',
    recipient = 'Recipient'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum GetAllParentalMailSortDirection {
    ascending = 'Ascending',
    descending = 'Descending'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum GetAllParentalMailWardsSortBy {
    wardName = 'WardName',
    hasParentsApp = 'HasParentsApp',
    hasResponded = 'HasResponded'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum GetAllParentalMailWardsSortDirection {
    ascending = 'Ascending',
    descending = 'Descending'
}

/**
 * 
 * @export
 * @interface GetAppointmentRequest
 */
export interface GetAppointmentRequest {
    /**
     * 
     * @type {GetAppointmentStudentOptions}
     * @memberof GetAppointmentRequest
     */
    mainStudent: GetAppointmentStudentOptions;
    /**
     * 
     * @type {Array<GetAppointmentStudentOptions>}
     * @memberof GetAppointmentRequest
     */
    studentOptions?: Array<GetAppointmentStudentOptions>;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface GetAppointmentStudentOptions
 */
export interface GetAppointmentStudentOptions {
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentStudentOptions
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentStudentOptions
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentStudentOptions
     */
    studentId?: string;
}
/**
 * 
 * @export
 * @interface GetAppointmentsRequest
 */
export interface GetAppointmentsRequest {
    /**
     * 
     * @type {Array<GetAppointmentStudentOptions>}
     * @memberof GetAppointmentsRequest
     */
    studentOptions?: Array<GetAppointmentStudentOptions>;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsRequest
     */
    to?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAppointmentsRequest
     */
    newest?: number;
}
/**
 * 
 * @export
 * @interface GetAppointmentsResponse
 */
export interface GetAppointmentsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    organizationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetAppointmentsResponse
     */
    studentIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    end?: string;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof GetAppointmentsResponse
     */
    createdBy: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentsResponse
     */
    timePeriod: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentsResponse
     */
    isAllDay: boolean;
}
/**
 * 
 * @export
 * @interface GetCourseEventRequest
 */
export interface GetCourseEventRequest {
    /**
     * 
     * @type {Array<GetCourseEventsStudentOptions>}
     * @memberof GetCourseEventRequest
     */
    studentOptions: Array<GetCourseEventsStudentOptions>;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventRequest
     */
    courseEventId: string;
}
/**
 * 
 * @export
 * @interface GetCourseEventsRequest
 */
export interface GetCourseEventsRequest {
    /**
     * 
     * @type {Array<GetCourseEventsStudentOptions>}
     * @memberof GetCourseEventsRequest
     */
    studentOptions: Array<GetCourseEventsStudentOptions>;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsRequest
     */
    to?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCourseEventsRequest
     */
    newest?: number;
}
/**
 * 
 * @export
 * @interface GetCourseEventsResponse
 */
export interface GetCourseEventsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    organizationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCourseEventsResponse
     */
    studentIds?: Array<string>;
    /**
     * 
     * @type {ApiResolvedCourse}
     * @memberof GetCourseEventsResponse
     */
    course: ApiResolvedCourse;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsResponse
     */
    timePeriod: string;
}
/**
 * 
 * @export
 * @interface GetCourseEventsStudentOptions
 */
export interface GetCourseEventsStudentOptions {
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsStudentOptions
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsStudentOptions
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCourseEventsStudentOptions
     */
    studentId?: string;
}
/**
 * 
 * @export
 * @interface GetCoursesRequest
 */
export interface GetCoursesRequest {
    /**
     * 
     * @type {Array<GetLessonContentsStudentOptions>}
     * @memberof GetCoursesRequest
     */
    studentOptions: Array<GetLessonContentsStudentOptions>;
}
/**
 * 
 * @export
 * @interface GetCoursesResponse
 */
export interface GetCoursesResponse {
    /**
     * 
     * @type {Array<ApiCourseWithStudents>}
     * @memberof GetCoursesResponse
     */
    courses: Array<ApiCourseWithStudents>;
}
/**
 * 
 * @export
 * @interface GetFileDownloadRequest
 */
export interface GetFileDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof GetFileDownloadRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetFileDownloadRequest
     */
    fileId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFileDownloadRequest
     */
    studentIdsToCheck: Array<string>;
}
/**
 * 
 * @export
 * @interface GetFilesForOrganizationRequest
 */
export interface GetFilesForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationRequest
     */
    folderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationRequest
     */
    search?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFilesForOrganizationRequest
     */
    studentIdsToCheck: Array<string>;
}
/**
 * 
 * @export
 * @interface GetFilesForOrganizationResponse
 */
export interface GetFilesForOrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    organizationId: string;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof GetFilesForOrganizationResponse
     */
    modifiedBy: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    modifiedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    path: string;
    /**
     * 
     * @type {Array<RecipientEmbedded>}
     * @memberof GetFilesForOrganizationResponse
     */
    recipients?: Array<RecipientEmbedded> | null;
    /**
     * 
     * @type {FileType}
     * @memberof GetFilesForOrganizationResponse
     */
    fileType: FileType;
    /**
     * 
     * @type {number}
     * @memberof GetFilesForOrganizationResponse
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof GetFilesForOrganizationResponse
     */
    mimeType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFilesForOrganizationResponse
     */
    fileCount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetFilesForOrganizationResponse
     */
    sharedWithOrganization?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFilesForOrganizationResponse
     */
    studentIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetGuardianRequest
 */
export interface GetGuardianRequest {
    /**
     * 
     * @type {string}
     * @memberof GetGuardianRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGuardianRequest
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGuardianRequest
     */
    mailAddress: string;
}
/**
 * 
 * @export
 * @interface GetHomeworkOverviewsStudentOptions
 */
export interface GetHomeworkOverviewsStudentOptions {
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkOverviewsStudentOptions
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkOverviewsStudentOptions
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkOverviewsStudentOptions
     */
    studentId?: string;
}
/**
 * 
 * @export
 * @interface GetHomeworkResponse
 */
export interface GetHomeworkResponse {
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    timePeriod?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    deadline?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetHomeworkResponse
     */
    taskChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    taskDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworkResponse
     */
    taskTitle: string;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof GetHomeworkResponse
     */
    teacher: ElternappPerson;
    /**
     * 
     * @type {ElternappGroup}
     * @memberof GetHomeworkResponse
     */
    group: ElternappGroup;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetHomeworkResponse
     */
    studentIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetHomeworksOverviewRequest
 */
export interface GetHomeworksOverviewRequest {
    /**
     * 
     * @type {Array<GetHomeworkOverviewsStudentOptions>}
     * @memberof GetHomeworksOverviewRequest
     */
    studentOptions?: Array<GetHomeworkOverviewsStudentOptions>;
}
/**
 * 
 * @export
 * @interface GetHomeworksOverviewResponse
 */
export interface GetHomeworksOverviewResponse {
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksOverviewResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksOverviewResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksOverviewResponse
     */
    timePeriod?: string;
    /**
     * 
     * @type {number}
     * @memberof GetHomeworksOverviewResponse
     */
    dueTomorrow?: number;
    /**
     * 
     * @type {number}
     * @memberof GetHomeworksOverviewResponse
     */
    totalOpen?: number;
}
/**
 * 
 * @export
 * @interface GetHomeworksRequest
 */
export interface GetHomeworksRequest {
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksRequest
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetHomeworksRequest
     */
    to?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetHomeworksRequest
     */
    studentIdsToCheck?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetLatestLessonContentsRequest
 */
export interface GetLatestLessonContentsRequest {
    /**
     * 
     * @type {Array<GetLessonContentsStudentOptions>}
     * @memberof GetLatestLessonContentsRequest
     */
    studentOptions: Array<GetLessonContentsStudentOptions>;
    /**
     * 
     * @type {number}
     * @memberof GetLatestLessonContentsRequest
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface GetLatestLessonContentsResponse
 */
export interface GetLatestLessonContentsResponse {
    /**
     * 
     * @type {Array<FlatLessonContentEntry>}
     * @memberof GetLatestLessonContentsResponse
     */
    lessonContents: Array<FlatLessonContentEntry>;
}
/**
 * 
 * @export
 * @interface GetLessonContentsRequest
 */
export interface GetLessonContentsRequest {
    /**
     * 
     * @type {Array<GetLessonContentsStudentOptions>}
     * @memberof GetLessonContentsRequest
     */
    studentOptions: Array<GetLessonContentsStudentOptions>;
    /**
     * 
     * @type {number}
     * @memberof GetLessonContentsRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLessonContentsRequest
     */
    daysPerPage?: number;
    /**
     * 
     * @type {string}
     * @memberof GetLessonContentsRequest
     */
    studentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLessonContentsRequest
     */
    courseId?: string | null;
}
/**
 * 
 * @export
 * @interface GetLessonContentsResponse
 */
export interface GetLessonContentsResponse {
    /**
     * 
     * @type {PaginationResponse}
     * @memberof GetLessonContentsResponse
     */
    pagination: PaginationResponse;
    /**
     * 
     * @type {Array<FlatLessonContentEntry>}
     * @memberof GetLessonContentsResponse
     */
    lessonContents: Array<FlatLessonContentEntry>;
}
/**
 * 
 * @export
 * @interface GetLessonContentsStudentOptions
 */
export interface GetLessonContentsStudentOptions {
    /**
     * 
     * @type {string}
     * @memberof GetLessonContentsStudentOptions
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetLessonContentsStudentOptions
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof GetLessonContentsStudentOptions
     */
    studentId: string;
}
/**
 * 
 * @export
 * @interface GetNewsRequest
 */
export interface GetNewsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetNewsRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewsRequest
     */
    studentId?: string;
    /**
     * 
     * @type {number}
     * @memberof GetNewsRequest
     */
    newest?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNewsRequest
     */
    studentIdsToCheck?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetNewsResponse
 */
export interface GetNewsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetNewsResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewsResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewsResponse
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNewsResponse
     */
    recipients?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNewsResponse
     */
    attachments?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetNewsResponse
     */
    publishDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetNewsResponse
     */
    pushNotification?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNewsResponse
     */
    accessibleStudentIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GetNewsSingleRequest
 */
export interface GetNewsSingleRequest {
    /**
     * 
     * @type {string}
     * @memberof GetNewsSingleRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewsSingleRequest
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetNewsSingleRequest
     */
    newsId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNewsSingleRequest
     */
    studentIdsToCheck?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetParentalMailAttachmentDownloadRequest
 */
export interface GetParentalMailAttachmentDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadRequest
     */
    attachmentId: string;
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadRequest
     */
    accessToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadRequest
     */
    mail?: string | null;
}
/**
 * 
 * @export
 * @interface GetParentalMailAttachmentDownloadResponse
 */
export interface GetParentalMailAttachmentDownloadResponse {
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadResponse
     */
    uri: string;
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailAttachmentDownloadResponse
     */
    availability: string;
}
/**
 * 
 * @export
 * @interface GetParentalMailsRequest
 */
export interface GetParentalMailsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailsRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {number}
     * @memberof GetParentalMailsRequest
     */
    newest?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetParentalMailsRequest
     */
    studentIdsToCheck: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetParentalMailsRequest
     */
    parentMail: string;
}
/**
 * 
 * @export
 * @interface GetSchoolsRequest
 */
export interface GetSchoolsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSchoolsRequest
     */
    organizationIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSchoolsResponse
 */
export interface GetSchoolsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSchoolsResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchoolsResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchoolsResponse
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface GetSettingsRequest
 */
export interface GetSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSettingsRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface GetSettingsResponse
 */
export interface GetSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSettingsResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSettingsResponse
     */
    settings?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSingleParentalMailRequest
 */
export interface GetSingleParentalMailRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSingleParentalMailRequest
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSingleParentalMailRequest
     */
    studentIdsToCheck: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSingleParentalMailRequest
     */
    accessToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSingleParentalMailRequest
     */
    parentMail?: string | null;
}
/**
 * 
 * @export
 * @interface GetSubstitutionsRequest
 */
export interface GetSubstitutionsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSubstitutionsRequest
     */
    studentIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsRequest
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsRequest
     */
    to: string;
}
/**
 * 
 * @export
 * @interface GetSubstitutionsResponse
 */
export interface GetSubstitutionsResponse {
    /**
     * 
     * @type {ElternappGroup}
     * @memberof GetSubstitutionsResponse
     */
    course?: ElternappGroup;
    /**
     * 
     * @type {ElternappPerson}
     * @memberof GetSubstitutionsResponse
     */
    substitute?: ElternappPerson;
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsResponse
     */
    room?: string;
    /**
     * 
     * @type {TimeSlot}
     * @memberof GetSubstitutionsResponse
     */
    timeSlot?: TimeSlot;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSubstitutionsResponse
     */
    studentIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsResponse
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSubstitutionsResponse
     */
    remark?: string | null;
}
/**
 * 
 * @export
 * @interface GetTimePatternRequest
 */
export interface GetTimePatternRequest {
    /**
     * 
     * @type {string}
     * @memberof GetTimePatternRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface GetTimeTableRequest
 */
export interface GetTimeTableRequest {
    /**
     * 
     * @type {string}
     * @memberof GetTimeTableRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTimeTableRequest
     */
    studentId: string;
    /**
     * 
     * @type {number}
     * @memberof GetTimeTableRequest
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof GetTimeTableRequest
     */
    start: string;
}
/**
 * 
 * @export
 * @interface GetUpnRequest
 */
export interface GetUpnRequest {
    /**
     * 
     * @type {string}
     * @memberof GetUpnRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpnRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpnRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpnRequest
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUpnRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface GetUserRequestOption
 */
export interface GetUserRequestOption {
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestOption
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestOption
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserRequestOption
     */
    userObjectId: string;
}
/**
 * 
 * @export
 * @interface GetUsersResponse
 */
export interface GetUsersResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponse
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponse
     */
    lastName?: string;
    /**
     * 
     * @type {School}
     * @memberof GetUsersResponse
     */
    school: School;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUsersResponse
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface GradeAbsences
 */
export interface GradeAbsences {
    /**
     * 
     * @type {Delays}
     * @memberof GradeAbsences
     */
    delays: Delays;
    /**
     * 
     * @type {MissedHours}
     * @memberof GradeAbsences
     */
    missedHours: MissedHours;
    /**
     * 
     * @type {Person}
     * @memberof GradeAbsences
     */
    student: Person;
}
/**
 * 
 * @export
 * @interface GradeAbsencesResponse
 */
export interface GradeAbsencesResponse {
    /**
     * 
     * @type {GradeBasicResponse}
     * @memberof GradeAbsencesResponse
     */
    grade: GradeBasicResponse;
    /**
     * 
     * @type {Array<GradeAbsences>}
     * @memberof GradeAbsencesResponse
     */
    absences: Array<GradeAbsences>;
}
/**
 * 
 * @export
 * @interface GradeBasicResponse
 */
export interface GradeBasicResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof GradeBasicResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {string}
     * @memberof GradeBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GradeBasicResponse
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GradeBasicResponse
     */
    gradeManagerIds: Array<string>;
}
/**
 * 
 * @export
 * @interface GradeCreateEntry
 */
export interface GradeCreateEntry {
    /**
     * 
     * @type {string}
     * @memberof GradeCreateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {string}
     * @memberof GradeCreateEntry
     */
    name: string;
    /**
     * 
     * @type {GradeSettingsEntry}
     * @memberof GradeCreateEntry
     */
    settings: GradeSettingsEntry;
}
/**
 * 
 * @export
 * @interface GradeResponse
 */
export interface GradeResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof GradeResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof GradeResponse
     */
    gradeClasses: Array<ClassBasicResponse>;
    /**
     * 
     * @type {string}
     * @memberof GradeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GradeResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GradeResponse
     */
    predecessorId?: string | null;
    /**
     * 
     * @type {GradeSettingsResponse}
     * @memberof GradeResponse
     */
    settings: GradeSettingsResponse;
}
/**
 * 
 * @export
 * @interface GradeSettingsEntry
 */
export interface GradeSettingsEntry {
    /**
     * 
     * @type {Array<string>}
     * @memberof GradeSettingsEntry
     */
    gradeManagers: Array<string>;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof GradeSettingsEntry
     */
    signOffRequirement: SignOffRequirement;
}
/**
 * 
 * @export
 * @interface GradeSettingsResponse
 */
export interface GradeSettingsResponse {
    /**
     * 
     * @type {Array<Person>}
     * @memberof GradeSettingsResponse
     */
    gradeManagers: Array<Person>;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof GradeSettingsResponse
     */
    signOffRequirement: SignOffRequirement;
}
/**
 * 
 * @export
 * @interface GradeUpdateEntry
 */
export interface GradeUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof GradeUpdateEntry
     */
    azureId?: string;
    /**
     * 
     * @type {string}
     * @memberof GradeUpdateEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GradeUpdateEntry
     */
    name: string;
    /**
     * 
     * @type {GradeSettingsEntry}
     * @memberof GradeUpdateEntry
     */
    settings: GradeSettingsEntry;
}
/**
 * 
 * @export
 * @interface Grading
 */
export interface Grading {
    /**
     * 
     * @type {string}
     * @memberof Grading
     */
    odata_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Grading
     */
    maxPoints?: number;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {AzureGroup}
     * @memberof Group
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    classbookId?: string | null;
    /**
     * 
     * @type {Type}
     * @memberof Group
     */
    type?: Type;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GroupAndUserActions {
    addUpdate = 'AddUpdate',
    removeUpdate = 'RemoveUpdate'
}

/**
 * 
 * @export
 * @interface GroupAssignment
 */
export interface GroupAssignment {
    /**
     * 
     * @type {string}
     * @memberof GroupAssignment
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupAssignment
     */
    displayName?: string;
    /**
     * 
     * @type {GroupRoleResponse}
     * @memberof GroupAssignment
     */
    groupRole?: GroupRoleResponse;
}
/**
 * 
 * @export
 * @interface GroupAssignments
 */
export interface GroupAssignments {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupAssignments
     */
    excludedIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupAssignments
     */
    includedIds: Array<string>;
}
/**
 * 
 * @export
 * @interface GroupInformation
 */
export interface GroupInformation {
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    mailNickname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    createdDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    deletedDateTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupInformation
     */
    isInProvisioningTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupInformation
     */
    isDynamicGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupInformation
     */
    isExchangeGroup?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    tenantId?: string;
    /**
     * 
     * @type {GroupRole}
     * @memberof GroupInformation
     */
    role?: GroupRole;
    /**
     * 
     * @type {Origin}
     * @memberof GroupInformation
     */
    origin?: Origin;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    isArchived?: string | null;
    /**
     * 
     * @type {Array<Member>}
     * @memberof GroupInformation
     */
    users?: Array<Member> | null;
    /**
     * 
     * @type {Array<Member>}
     * @memberof GroupInformation
     */
    owners?: Array<Member> | null;
    /**
     * 
     * @type {Array<Member>}
     * @memberof GroupInformation
     */
    groups?: Array<Member> | null;
    /**
     * 
     * @type {Array<Device>}
     * @memberof GroupInformation
     */
    devices?: Array<Device> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupInformation
     */
    proxyAddresses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GroupInformation
     */
    hybridSamAccountName?: string | null;
}
/**
 * 
 * @export
 * @interface GroupRelationshipResponse
 */
export interface GroupRelationshipResponse {
    /**
     * 
     * @type {InstallStatus}
     * @memberof GroupRelationshipResponse
     */
    installStatus: InstallStatus;
    /**
     * 
     * @type {string}
     * @memberof GroupRelationshipResponse
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRelationshipResponse
     */
    groupDisplayName: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupRelationshipResponse
     */
    isAssigned: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupRelationshipResponse
     */
    canBeAssigned: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GroupRole {
    /**
    * NO_ROLE_STATE
    */
    none = 'None',
    /**
    * COURSE_ROLE_STATE
    */
    course = 'Course',
    /**
    * CLASS_ROLE_STATE
    */
    class = 'Class',
    /**
    * WORKGROUP_ROLE_STATE
    */
    workgroup = 'Workgroup',
    /**
    * DEVICEGROUP_ROLE_STATE
    */
    devices = 'Devices',
    /**
    * EXAM_ROLE_STATE
    */
    exam = 'Exam'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum GroupRoleResponse {
    notDefined = 'NotDefined',
    office365 = 'Office365',
    securityGroup = 'SecurityGroup',
    mailEnabled = 'MailEnabled',
    mailEnabledSecurityGroup = 'MailEnabledSecurityGroup'
}

/**
 * 
 * @export
 * @interface GroupTemplateCreateRequest
 */
export interface GroupTemplateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateCreateRequest
     */
    domain?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupTemplateCreateRequest
     */
    internalMailOnly?: boolean;
    /**
     * 
     * @type {GroupType}
     * @memberof GroupTemplateCreateRequest
     */
    groupType?: GroupType;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {GroupRole}
     * @memberof GroupTemplateCreateRequest
     */
    role: GroupRole;
}
/**
 * 
 * @export
 * @interface GroupTemplateResponse
 */
export interface GroupTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateResponse
     */
    domain?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupTemplateResponse
     */
    internalMailOnly?: boolean;
    /**
     * 
     * @type {GroupType}
     * @memberof GroupTemplateResponse
     */
    groupType?: GroupType;
    /**
     * 
     * @type {GroupRole}
     * @memberof GroupTemplateResponse
     */
    role?: GroupRole;
}
/**
 * 
 * @export
 * @interface GroupTemplateUpdateRequest
 */
export interface GroupTemplateUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateUpdateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateUpdateRequest
     */
    domain: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupTemplateUpdateRequest
     */
    internalMailOnly: boolean;
    /**
     * 
     * @type {GroupType}
     * @memberof GroupTemplateUpdateRequest
     */
    groupType: GroupType;
    /**
     * 
     * @type {string}
     * @memberof GroupTemplateUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {GroupRole}
     * @memberof GroupTemplateUpdateRequest
     */
    role: GroupRole;
}
/**
 * 
 * @export
 * @interface GroupToCopyFrom
 */
export interface GroupToCopyFrom {
    /**
     * 
     * @type {boolean}
     * @memberof GroupToCopyFrom
     */
    takeoverConfigurationProfiles: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupToCopyFrom
     */
    takeoverDeviceMemberships: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupToCopyFrom
     */
    takeoverSoftwareMemberships: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupToCopyFrom
     */
    toCopyFromId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GroupType {
    /**
    * 
    */
    notDefined = 'NotDefined',
    /**
    * Unified
    */
    office365 = 'Office365',
    /**
    * Security
    */
    securityGroup = 'SecurityGroup',
    /**
    * MailEnabled
    */
    distributionGroup = 'DistributionGroup',
    /**
    * MailEnabledSecurity
    */
    mailEnabledSecurityGroup = 'MailEnabledSecurityGroup'
}

/**
 * 
 * @export
 * @interface Guardian
 */
export interface Guardian {
    /**
     * 
     * @type {string}
     * @memberof Guardian
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Guardian
     */
    mailAddress?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Guardian
     */
    mobilePhoneNumbers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Guardian
     */
    isEmergencyContact?: boolean;
}
/**
 * 
 * @export
 * @interface GuardianChatCreateThreadRequestContent
 */
export interface GuardianChatCreateThreadRequestContent {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatCreateThreadRequestContent
     */
    topic: string;
    /**
     * 
     * @type {ChatThreadType}
     * @memberof GuardianChatCreateThreadRequestContent
     */
    threadType: ChatThreadType;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatCreateThreadRequestContent
     */
    wardId?: string | null;
    /**
     * 
     * @type {Array<CreateChatParticipantRequest>}
     * @memberof GuardianChatCreateThreadRequestContent
     */
    participants: Array<CreateChatParticipantRequest>;
    /**
     * 
     * @type {CreateChatLockRequest}
     * @memberof GuardianChatCreateThreadRequestContent
     */
    lockConfiguration?: CreateChatLockRequest | null;
}
/**
 * 
 * @export
 * @interface GuardianChatMessageResponse
 */
export interface GuardianChatMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageResponse
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageResponse
     */
    createdOn: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GuardianChatMessageResponse
     */
    metadata?: { [key: string]: string; } | null;
    /**
     * 
     * @type {GuardianChatMessageSender}
     * @memberof GuardianChatMessageResponse
     */
    sender: GuardianChatMessageSender;
    /**
     * 
     * @type {ChatMessageType}
     * @memberof GuardianChatMessageResponse
     */
    type: ChatMessageType;
}
/**
 * 
 * @export
 * @interface GuardianChatMessageSender
 */
export interface GuardianChatMessageSender {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageSender
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageSender
     */
    acsUserId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatMessageSender
     */
    displayName: string;
    /**
     * 
     * @type {ChatUserType}
     * @memberof GuardianChatMessageSender
     */
    chatUserType: ChatUserType;
}
/**
 * 
 * @export
 * @interface GuardianChatParticipantCandidatesResponse
 */
export interface GuardianChatParticipantCandidatesResponse {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatParticipantCandidatesResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatParticipantCandidatesResponse
     */
    displayName: string;
    /**
     * 
     * @type {ChatUserType}
     * @memberof GuardianChatParticipantCandidatesResponse
     */
    userType: ChatUserType;
}
/**
 * 
 * @export
 * @interface GuardianChatPerson
 */
export interface GuardianChatPerson {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatPerson
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatPerson
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatPerson
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatPerson
     */
    displayName: string;
}
/**
 * 
 * @export
 * @interface GuardianChatSendChatMessageRequestContent
 */
export interface GuardianChatSendChatMessageRequestContent {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatSendChatMessageRequestContent
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatSendChatMessageRequestContent
     */
    clientMessageId: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GuardianChatSendChatMessageRequestContent
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuardianChatSendChatMessageRequestContent
     */
    fileIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface GuardianChatThreadItemResponse
 */
export interface GuardianChatThreadItemResponse {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    acsThreadId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    topic: string;
    /**
     * 
     * @type {ChatThreadType}
     * @memberof GuardianChatThreadItemResponse
     */
    threadType: ChatThreadType;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    wardId?: string | null;
    /**
     * 
     * @type {GuardianChatPerson}
     * @memberof GuardianChatThreadItemResponse
     */
    ward?: GuardianChatPerson;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    classId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    organizationId: string;
    /**
     * 
     * @type {ChatMessagePreview}
     * @memberof GuardianChatThreadItemResponse
     */
    lastMessage?: ChatMessagePreview | null;
    /**
     * 
     * @type {number}
     * @memberof GuardianChatThreadItemResponse
     */
    unreadCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianChatThreadItemResponse
     */
    isLocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadItemResponse
     */
    createdById: string;
    /**
     * 
     * @type {GuardianChatPerson}
     * @memberof GuardianChatThreadItemResponse
     */
    createdBy: GuardianChatPerson;
}
/**
 * 
 * @export
 * @interface GuardianChatThreadResponse
 */
export interface GuardianChatThreadResponse {
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    acsThreadId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    topic: string;
    /**
     * 
     * @type {ChatThreadType}
     * @memberof GuardianChatThreadResponse
     */
    threadType: ChatThreadType;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    wardId?: string | null;
    /**
     * 
     * @type {GuardianChatPerson}
     * @memberof GuardianChatThreadResponse
     */
    ward?: GuardianChatPerson;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    createdById: string;
    /**
     * 
     * @type {GuardianChatPerson}
     * @memberof GuardianChatThreadResponse
     */
    createdBy: GuardianChatPerson;
    /**
     * 
     * @type {string}
     * @memberof GuardianChatThreadResponse
     */
    createdOn: string;
    /**
     * 
     * @type {ChatMessagePreview}
     * @memberof GuardianChatThreadResponse
     */
    lastMessage?: ChatMessagePreview | null;
    /**
     * 
     * @type {ChatLockResponse}
     * @memberof GuardianChatThreadResponse
     */
    lockConfiguration?: ChatLockResponse | null;
    /**
     * 
     * @type {Array<ChatParticipantResponse>}
     * @memberof GuardianChatThreadResponse
     */
    participants: Array<ChatParticipantResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianChatThreadResponse
     */
    isArchived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianChatThreadResponse
     */
    isLocked: boolean;
}
/**
 * 
 * @export
 * @interface GuardianContact
 */
export interface GuardianContact {
    /**
     * 
     * @type {string}
     * @memberof GuardianContact
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardianContact
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuardianContact
     */
    email?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuardianContact
     */
    phoneNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GuardianContact
     */
    address?: string | null;
    /**
     * 
     * @type {Relationship}
     * @memberof GuardianContact
     */
    relationship?: Relationship;
    /**
     * Ward specific primary contact status
     * @type {Array<string>}
     * @memberof GuardianContact
     */
    primaryContactWardIds?: Array<string>;
    /**
     * Wards a guardian registering with this e-mail is linked to automatically.
     * @type {Array<string>}
     * @memberof GuardianContact
     */
    autoConnectWardIds?: Array<string>;
    /**
     * Import contact without a real name yet: DisplayName is empty and editing is refused.
     * @type {boolean}
     * @memberof GuardianContact
     */
    isImportPlaceholder?: boolean;
}
/**
 * 
 * @export
 * @interface GuardianContactCreateMailMergeBody
 */
export interface GuardianContactCreateMailMergeBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof GuardianContactCreateMailMergeBody
     */
    studentIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianContactCreateMailMergeBody
     */
    oneTimeUse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactCreateMailMergeBody
     */
    validFor?: string | null;
    /**
     * 
     * @type {MailMergeSortBy}
     * @memberof GuardianContactCreateMailMergeBody
     */
    sort?: MailMergeSortBy;
    /**
     * 
     * @type {MailMergeSortDirection}
     * @memberof GuardianContactCreateMailMergeBody
     */
    sortDirection?: MailMergeSortDirection;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianContactCreateMailMergeBody
     */
    createSingleFiles?: boolean;
}
/**
 * 
 * @export
 * @interface GuardianContactInvitationResponse
 */
export interface GuardianContactInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    organizationId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuardianContactInvitationResponse
     */
    oneTimeUse: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    createdAt: string;
    /**
     * 
     * @type {Audit}
     * @memberof GuardianContactInvitationResponse
     */
    createdBy: Audit;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    qrData: string;
    /**
     * 
     * @type {string}
     * @memberof GuardianContactInvitationResponse
     */
    url: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GuestAccountTypes {
    notConfigured = 'NotConfigured',
    guest = 'Guest',
    domain = 'Domain'
}

/**
 * 
 * @export
 * @interface HardwareInfoResponse
 */
export interface HardwareInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    operatingSystem: string;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    totalStorage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    freeStorage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    ethernetMac?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HardwareInfoResponse
     */
    wlanMac?: string | null;
}
/**
 * 
 * @export
 * @interface Hashes
 */
export interface Hashes {
    /**
     * 
     * @type {string}
     * @memberof Hashes
     */
    crc32Hash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Hashes
     */
    quickXorHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Hashes
     */
    sha1Hash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Hashes
     */
    sha256Hash?: string | null;
}
/**
 * 
 * @export
 * @interface HolidayEntry
 */
export interface HolidayEntry {
    /**
     * 
     * @type {string}
     * @memberof HolidayEntry
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof HolidayEntry
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HolidayEntry
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface HolidayResponse
 */
export interface HolidayResponse {
    /**
     * 
     * @type {string}
     * @memberof HolidayResponse
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof HolidayResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HolidayResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HolidayResponse
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface HomeworkCreate
 */
export interface HomeworkCreate {
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    deadline?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    estimatedEffort?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    lessonId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeworkCreate
     */
    taskChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    taskDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    taskOfTeacher?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    taskTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkCreate
     */
    teamsLink?: string | null;
}
/**
 * 
 * @export
 * @interface HomeworkResponse
 */
export interface HomeworkResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof HomeworkResponse
     */
    courseAzureGroup: AzureGroup;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    courseId: string;
    /**
     * 
     * @type {Author}
     * @memberof HomeworkResponse
     */
    createdBy: Author;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    deadline?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    estimatedEffort?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    lessonId?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    predecessorId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HomeworkResponse
     */
    taskChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    taskDescription: string;
    /**
     * 
     * @type {Person}
     * @memberof HomeworkResponse
     */
    taskOfTeacher: Person;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    taskTitle: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkResponse
     */
    teamsLink?: string | null;
}
/**
 * 
 * @export
 * @interface HomeworkUpdate
 */
export interface HomeworkUpdate {
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    deadline?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    estimatedEffort?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    lessonId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeworkUpdate
     */
    taskChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    taskDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    taskOfTeacher?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    taskTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeworkUpdate
     */
    teamsLink?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum HttpStatusCode {
    continue = 'Continue',
    switchingProtocols = 'SwitchingProtocols',
    processing = 'Processing',
    earlyHints = 'EarlyHints',
    ok = 'OK',
    created = 'Created',
    accepted = 'Accepted',
    nonAuthoritativeInformation = 'NonAuthoritativeInformation',
    noContent = 'NoContent',
    resetContent = 'ResetContent',
    partialContent = 'PartialContent',
    multiStatus = 'MultiStatus',
    alreadyReported = 'AlreadyReported',
    imUsed = 'IMUsed',
    multipleChoices = 'MultipleChoices',
    ambiguous = 'MultipleChoices',
    movedPermanently = 'MovedPermanently',
    moved = 'MovedPermanently',
    found = 'Found',
    redirect = 'Found',
    seeOther = 'SeeOther',
    redirectMethod = 'SeeOther',
    notModified = 'NotModified',
    useProxy = 'UseProxy',
    unused = 'Unused',
    temporaryRedirect = 'RedirectKeepVerb',
    redirectKeepVerb = 'RedirectKeepVerb',
    permanentRedirect = 'PermanentRedirect',
    badRequest = 'BadRequest',
    unauthorized = 'Unauthorized',
    paymentRequired = 'PaymentRequired',
    forbidden = 'Forbidden',
    notFound = 'NotFound',
    methodNotAllowed = 'MethodNotAllowed',
    notAcceptable = 'NotAcceptable',
    proxyAuthenticationRequired = 'ProxyAuthenticationRequired',
    requestTimeout = 'RequestTimeout',
    conflict = 'Conflict',
    gone = 'Gone',
    lengthRequired = 'LengthRequired',
    preconditionFailed = 'PreconditionFailed',
    requestEntityTooLarge = 'RequestEntityTooLarge',
    requestUriTooLong = 'RequestUriTooLong',
    unsupportedMediaType = 'UnsupportedMediaType',
    requestedRangeNotSatisfiable = 'RequestedRangeNotSatisfiable',
    expectationFailed = 'ExpectationFailed',
    misdirectedRequest = 'MisdirectedRequest',
    unprocessableEntity = 'UnprocessableEntity',
    unprocessableContent = 'UnprocessableEntity',
    locked = 'Locked',
    failedDependency = 'FailedDependency',
    upgradeRequired = 'UpgradeRequired',
    preconditionRequired = 'PreconditionRequired',
    tooManyRequests = 'TooManyRequests',
    requestHeaderFieldsTooLarge = 'RequestHeaderFieldsTooLarge',
    unavailableForLegalReasons = 'UnavailableForLegalReasons',
    internalServerError = 'InternalServerError',
    notImplemented = 'NotImplemented',
    badGateway = 'BadGateway',
    serviceUnavailable = 'ServiceUnavailable',
    gatewayTimeout = 'GatewayTimeout',
    httpVersionNotSupported = 'HttpVersionNotSupported',
    variantAlsoNegotiates = 'VariantAlsoNegotiates',
    insufficientStorage = 'InsufficientStorage',
    loopDetected = 'LoopDetected',
    notExtended = 'NotExtended',
    networkAuthenticationRequired = 'NetworkAuthenticationRequired'
}

/**
 * 
 * @export
 * @interface HttpStatusError
 */
export interface HttpStatusError {
    /**
     * Message of the error
     * @type {string}
     * @memberof HttpStatusError
     */
    message?: string | null;
    /**
     * Metadata of the error
     * @type {{ [key: string]: any; }}
     * @memberof HttpStatusError
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Get the reasons of an error
     * @type {Array<IError>}
     * @memberof HttpStatusError
     */
    reasons?: Array<IError> | null;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof HttpStatusError
     */
    statusCode?: HttpStatusCode;
}
/**
 * 
 * @export
 * @interface HttpStatusErrorAllOf
 */
export interface HttpStatusErrorAllOf {
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof HttpStatusErrorAllOf
     */
    statusCode?: HttpStatusCode;
}
/**
 * 
 * @export
 * @interface HybridSyncSettingsGetRequest
 */
export interface HybridSyncSettingsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsGetRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface HybridSyncSettingsResponse
 */
export interface HybridSyncSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HybridSyncSettingsResponse
     */
    syncActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsResponse
     */
    activeHybridSyncPeriodIdentifierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsResponse
     */
    activeHybridSyncPeriodIdentifierName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsResponse
     */
    customErrorMessage?: string | null;
}
/**
 * 
 * @export
 * @interface HybridSyncSettingsUpdate
 */
export interface HybridSyncSettingsUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof HybridSyncSettingsUpdate
     */
    syncActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsUpdate
     */
    activeHybridSyncPeriodIdentifierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HybridSyncSettingsUpdate
     */
    customErrorMessage?: string | null;
}
/**
 * Stores model information in a different location than the object properties. Implementations can provide dirty tracking capabilities, caching capabilities or integration with 3rd party stores.
 * @export
 * @interface IBackingStore
 */
export interface IBackingStore {
    /**
     * 
     * @type {boolean}
     * @memberof IBackingStore
     */
    initializationCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IBackingStore
     */
    returnOnlyChangedValues?: boolean;
}
/**
 * Definition of an error
 * @export
 * @interface IError
 */
export interface IError {
    /**
     * Reasons of the error
     * @type {Array<IError>}
     * @memberof IError
     */
    reasons?: Array<IError> | null;
}
/**
 * 
 * @export
 * @interface IdentifierPasswortCombination
 */
export interface IdentifierPasswortCombination {
    /**
     * 
     * @type {string}
     * @memberof IdentifierPasswortCombination
     */
    ssid?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentifierPasswortCombination
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface Identity
 */
export interface Identity {
    /**
     * 
     * @type {string}
     * @memberof Identity
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Identity
     */
    displayName?: string | null;
}
/**
 * 
 * @export
 * @interface IdentitySet
 */
export interface IdentitySet {
    /**
     * 
     * @type {Identity}
     * @memberof IdentitySet
     */
    application?: Identity | null;
    /**
     * 
     * @type {Identity}
     * @memberof IdentitySet
     */
    user?: Identity | null;
    /**
     * 
     * @type {Identity}
     * @memberof IdentitySet
     */
    device?: Identity | null;
}
/**
 * 
 * @export
 * @interface ImportReportResponse
 */
export interface ImportReportResponse {
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    classes?: ReportChanges | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    courses?: ReportChanges | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    grades?: ReportChanges | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    holidays?: ReportChanges | null;
    /**
     * 
     * @type {string}
     * @memberof ImportReportResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportReportResponse
     */
    importDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportReportResponse
     */
    importerVersion?: string | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    lessons?: ReportChanges | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    rooms?: ReportChanges | null;
    /**
     * 
     * @type {ReportChanges}
     * @memberof ImportReportResponse
     */
    substitutions?: ReportChanges | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImportReportResponse
     */
    timePatternChanged?: boolean;
}
/**
 * 
 * @export
 * @interface ImportRequest
 */
export interface ImportRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportRequest
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportRequest
     */
    period?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRequest
     */
    sendMailWhenFinished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRequest
     */
    requiringConsent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRequest
     */
    deleteExistingUsers: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRequest
     */
    wipeUsersBeforeImport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportRequest
     */
    addMetadataOnly: boolean;
    /**
     * 
     * @type {Array<AnalyzedUser>}
     * @memberof ImportRequest
     */
    analyzedUsers: Array<AnalyzedUser>;
}
/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * Raw CSV content; preferred over the file when both are supplied
     * @type {string}
     * @memberof InlineObject9
     */
    csvContent?: string | null;
    /**
     * The SchILD migration CSV file (text/csv, max. 4 MiB)
     * @type {any}
     * @memberof InlineObject9
     */
    file?: any | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum InstallStatus {
    available = 'Available',
    required = 'Required',
    uninstall = 'Uninstall'
}

/**
 * 
 * @export
 * @interface Instructions
 */
export interface Instructions {
    /**
     * 
     * @type {string}
     * @memberof Instructions
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Instructions
     */
    contentType?: string | null;
}
/**
 * 
 * @export
 * @interface InvitationCreateRequest
 */
export interface InvitationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    usageLocation: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    aixConceptCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationCreateRequest
     */
    shippingNote?: string | null;
    /**
     * 
     * @type {OrganizationContact}
     * @memberof InvitationCreateRequest
     */
    organizationContact?: OrganizationContact | null;
    /**
     * 
     * @type {SecurityManager}
     * @memberof InvitationCreateRequest
     */
    securityManager?: SecurityManager | null;
    /**
     * 
     * @type {Array<InvitationFeature>}
     * @memberof InvitationCreateRequest
     */
    features?: Array<InvitationFeature>;
}
/**
 * 
 * @export
 * @interface InvitationDetailsResponse
 */
export interface InvitationDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailsResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailsResponse
     */
    invitationName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailsResponse
     */
    tenantName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvitationDetailsResponse
     */
    domains: Array<string>;
}
/**
 * 
 * @export
 * @interface InvitationFeature
 */
export interface InvitationFeature {
    /**
     * 
     * @type {string}
     * @memberof InvitationFeature
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationFeature
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationFeature
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationFeature
     */
    value: string;
}
/**
 * 
 * @export
 * @interface InvitationResponse
 */
export interface InvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    aixConceptCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    givenName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    invitationSendDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    invitationAcceptedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    invitationSendBy?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationResponse
     */
    isHybrid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    usageLocation: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    shippingNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationResponse
     */
    attachmentName?: string | null;
    /**
     * 
     * @type {OrganizationContact}
     * @memberof InvitationResponse
     */
    organizationContact: OrganizationContact;
    /**
     * 
     * @type {SecurityManager}
     * @memberof InvitationResponse
     */
    securityManager: SecurityManager;
}
/**
 * 
 * @export
 * @interface InvitationSearchResponse
 */
export interface InvitationSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof InvitationSearchResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationSearchResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationSearchResponse
     */
    customerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationSearchResponse
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationSearchResponse
     */
    shippingNote?: string | null;
}
/**
 * 
 * @export
 * @interface InvitationUpdateRequest
 */
export interface InvitationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    usageLocation: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    aixConceptCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationUpdateRequest
     */
    shippingNote?: string | null;
    /**
     * 
     * @type {OrganizationContact}
     * @memberof InvitationUpdateRequest
     */
    organizationContact?: OrganizationContact | null;
    /**
     * 
     * @type {SecurityManager}
     * @memberof InvitationUpdateRequest
     */
    securityManager?: SecurityManager | null;
    /**
     * 
     * @type {Array<InvitationFeature>}
     * @memberof InvitationUpdateRequest
     */
    features?: Array<InvitationFeature>;
}
/**
 * 
 * @export
 * @interface IosActivationLockBypassCodeResponse
 */
export interface IosActivationLockBypassCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof IosActivationLockBypassCodeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosActivationLockBypassCodeResponse
     */
    serialnumber: string;
    /**
     * 
     * @type {string}
     * @memberof IosActivationLockBypassCodeResponse
     */
    key: string;
}
/**
 * 
 * @export
 * @interface IosProfilesAbstractEntry
 */
export interface IosProfilesAbstractEntry {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAbstractEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAbstractEntry
     */
    description: string;
}
/**
 * 
 * @export
 * @interface IosProfilesAbstractResponse
 */
export interface IosProfilesAbstractResponse {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAbstractResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAbstractResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAbstractResponse
     */
    description: string;
}
/**
 * 
 * @export
 * @interface IosProfilesAppConfigurationResponse
 */
export interface IosProfilesAppConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAppConfigurationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAppConfigurationResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesAppConfigurationResponse
     */
    description: string;
    /**
     * 
     * @type {Array<AppConfigurationSettingItemResponse>}
     * @memberof IosProfilesAppConfigurationResponse
     */
    settings?: Array<AppConfigurationSettingItemResponse>;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof IosProfilesAppConfigurationResponse
     */
    targetedApps?: Array<BasicSoftwareResponse>;
}
/**
 * 
 * @export
 * @interface IosProfilesAppConfigurationResponseAllOf
 */
export interface IosProfilesAppConfigurationResponseAllOf {
    /**
     * 
     * @type {Array<AppConfigurationSettingItemResponse>}
     * @memberof IosProfilesAppConfigurationResponseAllOf
     */
    settings?: Array<AppConfigurationSettingItemResponse>;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof IosProfilesAppConfigurationResponseAllOf
     */
    targetedApps?: Array<BasicSoftwareResponse>;
}
/**
 * 
 * @export
 * @interface IosProfilesFeaturesEntry
 */
export interface IosProfilesFeaturesEntry {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesEntry
     */
    homeScreenGridWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesEntry
     */
    homeScreenGridHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntry
     */
    lockScreenFootnote?: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntry
     */
    assetTagTemplate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesFeaturesEntry
     */
    enableSSO?: boolean;
    /**
     * if set to true all groups that should be assigned should be pool-groups
     * @type {boolean}
     * @memberof IosProfilesFeaturesEntry
     */
    createPoolDeviceConfiguration?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntry
     */
    allowedUrls?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntry
     */
    blockedUrls?: Array<string>;
}
/**
 * 
 * @export
 * @interface IosProfilesFeaturesEntryAllOf
 */
export interface IosProfilesFeaturesEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    homeScreenGridWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    homeScreenGridHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    lockScreenFootnote?: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    assetTagTemplate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    enableSSO?: boolean;
    /**
     * if set to true all groups that should be assigned should be pool-groups
     * @type {boolean}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    createPoolDeviceConfiguration?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    allowedUrls?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesEntryAllOf
     */
    blockedUrls?: Array<string>;
}
/**
 * 
 * @export
 * @interface IosProfilesFeaturesResponse
 */
export interface IosProfilesFeaturesResponse {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosProfilesFeaturesResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesResponse
     */
    homeScreenGridWidth: number;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesResponse
     */
    homeScreenGridHeight: number;
    /**
     * 
     * @type {MimeContent}
     * @memberof IosProfilesFeaturesResponse
     */
    wallpaperImage: MimeContent;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponse
     */
    lockScreenFootnote: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponse
     */
    assetTagTemplate: string;
    /**
     * 
     * @type {IosRedirectSingleSignOnExtensionResponse}
     * @memberof IosProfilesFeaturesResponse
     */
    ssoExtention?: IosRedirectSingleSignOnExtensionResponse | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesResponse
     */
    allowedUrls: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesResponse
     */
    blockedUrls: Array<string>;
}
/**
 * 
 * @export
 * @interface IosProfilesFeaturesResponseAllOf
 */
export interface IosProfilesFeaturesResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    homeScreenGridWidth: number;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    homeScreenGridHeight: number;
    /**
     * 
     * @type {MimeContent}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    wallpaperImage: MimeContent;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    lockScreenFootnote: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    assetTagTemplate: string;
    /**
     * 
     * @type {IosRedirectSingleSignOnExtensionResponse}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    ssoExtention?: IosRedirectSingleSignOnExtensionResponse | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    allowedUrls: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesFeaturesResponseAllOf
     */
    blockedUrls: Array<string>;
}
/**
 * 
 * @export
 * @interface IosProfilesRestrictionsEntry
 */
export interface IosProfilesRestrictionsEntry {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsEntry
     */
    description: string;
    /**
     * 
     * @type {Array<AppListItem>}
     * @memberof IosProfilesRestrictionsEntry
     */
    appsVisibilityList?: Array<AppListItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesRestrictionsEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    classroomAppForceUnpromptedScreenObservation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    classroomAppBlockRemoteScreenObservation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    classroomForceUnpromptedAppAndDeviceLock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    classroomForceRequestPermissionToLeaveClasses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    deviceBlockNameModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    wallpaperBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    appStoreBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    appStoreBlockInAppPurchases?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    iCloudBlockBackup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    iCloudBlockDocumentSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    airDropBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    accountBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    deviceBlockEraseContentAndSettings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    appStoreRequirePassword?: boolean;
    /**
     * 
     * @type {RequiredPasswordType}
     * @memberof IosProfilesRestrictionsEntry
     */
    passcodeRequiredType?: RequiredPasswordType | null;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesRestrictionsEntry
     */
    passcodeMinimumLength?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    passcodeRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    passcodeBlockModification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    autoUnlockBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntry
     */
    sharedDeviceBlockTemporarySessions?: boolean;
}
/**
 * 
 * @export
 * @interface IosProfilesRestrictionsEntryAllOf
 */
export interface IosProfilesRestrictionsEntryAllOf {
    /**
     * 
     * @type {Array<AppListItem>}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    appsVisibilityList?: Array<AppListItem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    classroomAppForceUnpromptedScreenObservation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    classroomAppBlockRemoteScreenObservation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    classroomForceUnpromptedAppAndDeviceLock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    classroomForceRequestPermissionToLeaveClasses?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    deviceBlockNameModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    wallpaperBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    appStoreBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    appStoreBlockInAppPurchases?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    iCloudBlockBackup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    iCloudBlockDocumentSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    airDropBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    accountBlockModification?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    deviceBlockEraseContentAndSettings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    appStoreRequirePassword?: boolean;
    /**
     * 
     * @type {RequiredPasswordType}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    passcodeRequiredType?: RequiredPasswordType | null;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    passcodeMinimumLength?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    passcodeRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    passcodeBlockModification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    autoUnlockBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsEntryAllOf
     */
    sharedDeviceBlockTemporarySessions?: boolean;
}
/**
 * 
 * @export
 * @interface IosProfilesRestrictionsResponse
 */
export interface IosProfilesRestrictionsResponse {
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponse
     */
    description: string;
    /**
     * 
     * @type {Array<AppListItem>}
     * @memberof IosProfilesRestrictionsResponse
     */
    appsVisibilityList: Array<AppListItem>;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosProfilesRestrictionsResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    classroomAppForceUnpromptedScreenObservation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    classroomAppBlockRemoteScreenObservation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    classroomForceUnpromptedAppAndDeviceLock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    classroomForceRequestPermissionToLeaveClasses: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    deviceBlockNameModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    wallpaperBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    cameraBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    appStoreBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    appStoreBlockInAppPurchases: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    iCloudBlockBackup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    iCloudBlockDocumentSync: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    airDropBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    accountBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    deviceBlockEraseContentAndSettings: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    appStoreRequirePassword: boolean;
    /**
     * 
     * @type {RequiredPasswordType}
     * @memberof IosProfilesRestrictionsResponse
     */
    passcodeRequiredType: RequiredPasswordType;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesRestrictionsResponse
     */
    passcodeMinimumLength: number;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    autoUnlockBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    passcodeBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponse
     */
    sharedDeviceBlockTemporarySessions: boolean;
}
/**
 * 
 * @export
 * @interface IosProfilesRestrictionsResponseAllOf
 */
export interface IosProfilesRestrictionsResponseAllOf {
    /**
     * 
     * @type {Array<AppListItem>}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    appsVisibilityList: Array<AppListItem>;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    classroomAppForceUnpromptedScreenObservation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    classroomAppBlockRemoteScreenObservation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    classroomForceUnpromptedAppAndDeviceLock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    classroomForceRequestPermissionToLeaveClasses: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    deviceBlockNameModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    wallpaperBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    cameraBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    appStoreBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    appStoreBlockInAppPurchases: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    iCloudBlockBackup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    iCloudBlockDocumentSync: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    airDropBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    accountBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    deviceBlockEraseContentAndSettings: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    appStoreRequirePassword: boolean;
    /**
     * 
     * @type {RequiredPasswordType}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    passcodeRequiredType: RequiredPasswordType;
    /**
     * 
     * @type {number}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    passcodeMinimumLength: number;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    autoUnlockBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    passcodeBlockModification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosProfilesRestrictionsResponseAllOf
     */
    sharedDeviceBlockTemporarySessions: boolean;
}
/**
 * 
 * @export
 * @interface IosRedirectSingleSignOnExtensionResponse
 */
export interface IosRedirectSingleSignOnExtensionResponse {
    /**
     * 
     * @type {string}
     * @memberof IosRedirectSingleSignOnExtensionResponse
     */
    extensionIdentifier?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosRedirectSingleSignOnExtensionResponse
     */
    urlPrefixes?: Array<string>;
    /**
     * 
     * @type {Array<KeyTypedValuePairResponse>}
     * @memberof IosRedirectSingleSignOnExtensionResponse
     */
    configurations?: Array<KeyTypedValuePairResponse>;
}
/**
 * 
 * @export
 * @interface IosUpdateConfigurationEntry
 */
export interface IosUpdateConfigurationEntry {
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosUpdateConfigurationEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<CustomUpdateTimeWindowAsDateTime>}
     * @memberof IosUpdateConfigurationEntry
     */
    updateSchedules: Array<CustomUpdateTimeWindowAsDateTime>;
    /**
     * !! Attention !! Only use when you are sure of what you can type in here, no specific list from microsoft what can be written in here. Request can fail when value is not known !
     * @type {string}
     * @memberof IosUpdateConfigurationEntry
     */
    desiredOsVersion?: string | null;
}
/**
 * 
 * @export
 * @interface IosUpdateConfigurationEntryAllOf
 */
export interface IosUpdateConfigurationEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof IosUpdateConfigurationEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<CustomUpdateTimeWindowAsDateTime>}
     * @memberof IosUpdateConfigurationEntryAllOf
     */
    updateSchedules: Array<CustomUpdateTimeWindowAsDateTime>;
    /**
     * !! Attention !! Only use when you are sure of what you can type in here, no specific list from microsoft what can be written in here. Request can fail when value is not known !
     * @type {string}
     * @memberof IosUpdateConfigurationEntryAllOf
     */
    desiredOsVersion?: string | null;
}
/**
 * 
 * @export
 * @interface IosUpdateConfigurationResponse
 */
export interface IosUpdateConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationResponse
     */
    description: string;
    /**
     * 
     * @type {Array<CustomUpdateTimeWindowAsDateTime>}
     * @memberof IosUpdateConfigurationResponse
     */
    updateSchedules: Array<CustomUpdateTimeWindowAsDateTime>;
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationResponse
     */
    desiredOsVersion: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosUpdateConfigurationResponse
     */
    groupAssignments: GroupAssignments;
}
/**
 * 
 * @export
 * @interface IosUpdateConfigurationResponseAllOf
 */
export interface IosUpdateConfigurationResponseAllOf {
    /**
     * 
     * @type {Array<CustomUpdateTimeWindowAsDateTime>}
     * @memberof IosUpdateConfigurationResponseAllOf
     */
    updateSchedules: Array<CustomUpdateTimeWindowAsDateTime>;
    /**
     * 
     * @type {string}
     * @memberof IosUpdateConfigurationResponseAllOf
     */
    desiredOsVersion: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosUpdateConfigurationResponseAllOf
     */
    groupAssignments: GroupAssignments;
}
/**
 * 
 * @export
 * @interface IosWlanEntry
 */
export interface IosWlanEntry {
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IosWlanEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanEntry
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanEntry
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    preSharedKey: string;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof IosWlanEntry
     */
    proxySettings?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof IosWlanEntry
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntry
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface IosWlanEntryAllOf
 */
export interface IosWlanEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof IosWlanEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntryAllOf
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanEntryAllOf
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanEntryAllOf
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntryAllOf
     */
    preSharedKey: string;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof IosWlanEntryAllOf
     */
    proxySettings?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof IosWlanEntryAllOf
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntryAllOf
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanEntryAllOf
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface IosWlanResponse
 */
export interface IosWlanResponse {
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosWlanResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanResponse
     */
    connectAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanResponse
     */
    connectWhenNetworkNameIsHidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    preSharedKey: string;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof IosWlanResponse
     */
    proxySettings: WiFiProxySetting;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    proxyAutomaticConfigurationUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IosWlanResponse
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponse
     */
    proxyManualAddress?: string | null;
}
/**
 * 
 * @export
 * @interface IosWlanResponseAllOf
 */
export interface IosWlanResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof IosWlanResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponseAllOf
     */
    ssid: string;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanResponseAllOf
     */
    connectAutomatically: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IosWlanResponseAllOf
     */
    connectWhenNetworkNameIsHidden: boolean;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponseAllOf
     */
    preSharedKey: string;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof IosWlanResponseAllOf
     */
    proxySettings: WiFiProxySetting;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponseAllOf
     */
    proxyAutomaticConfigurationUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IosWlanResponseAllOf
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IosWlanResponseAllOf
     */
    proxyManualAddress?: string | null;
}
/**
 * 
 * @export
 * @interface ItemReference
 */
export interface ItemReference {
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    driveId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    driveType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    shareId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ItemReference
     */
    siteId?: string | null;
}
/**
 * 
 * @export
 * @interface JobResponse
 */
export interface JobResponse {
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    job?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobResponse
     */
    taskStateId?: string | null;
}
/**
 * 
 * @export
 * @interface KeyTypedValuePairResponse
 */
export interface KeyTypedValuePairResponse {
    /**
     * 
     * @type {string}
     * @memberof KeyTypedValuePairResponse
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KeyTypedValuePairResponse
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface LessonBasicResponse
 */
export interface LessonBasicResponse {
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof LessonBasicResponse
     */
    classes: Array<ClassBasicResponse>;
    /**
     * 
     * @type {CourseBasicResponse}
     * @memberof LessonBasicResponse
     */
    course: CourseBasicResponse;
    /**
     * 
     * @type {string}
     * @memberof LessonBasicResponse
     */
    end: string;
    /**
     * 
     * @type {Array<GradeBasicResponse>}
     * @memberof LessonBasicResponse
     */
    grades: Array<GradeBasicResponse>;
    /**
     * 
     * @type {string}
     * @memberof LessonBasicResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LessonBasicResponse
     */
    multiLessonId: string;
    /**
     * 
     * @type {RoomResponse}
     * @memberof LessonBasicResponse
     */
    room: RoomResponse;
    /**
     * 
     * @type {string}
     * @memberof LessonBasicResponse
     */
    start: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LessonGroupMappingType {
    course = 'Course',
    class = 'Class',
    grade = 'Grade'
}

/**
 * 
 * @export
 * @interface LessonNameAndType
 */
export interface LessonNameAndType {
    /**
     * 
     * @type {string}
     * @memberof LessonNameAndType
     */
    lessonName: string;
    /**
     * 
     * @type {LessonGroupMappingType}
     * @memberof LessonNameAndType
     */
    groupType: LessonGroupMappingType;
    /**
     * 
     * @type {string}
     * @memberof LessonNameAndType
     */
    entityRevisionsId: string;
}
/**
 * 
 * @export
 * @interface LessonPattern
 */
export interface LessonPattern {
    /**
     * 
     * @type {string}
     * @memberof LessonPattern
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof LessonPattern
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof LessonPattern
     */
    cardinalNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof LessonPattern
     */
    from?: string;
}
/**
 * 
 * @export
 * @interface LessonResponse
 */
export interface LessonResponse {
    /**
     * 
     * @type {Array<AbsenceResponse>}
     * @memberof LessonResponse
     */
    attendances: Array<AbsenceResponse>;
    /**
     * 
     * @type {Array<ClassbookEntryResponse>}
     * @memberof LessonResponse
     */
    classbookEntries: Array<ClassbookEntryResponse>;
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof LessonResponse
     */
    classes: Array<ClassBasicResponse>;
    /**
     * 
     * @type {SignOffsResponse}
     * @memberof LessonResponse
     */
    classSignOffs: SignOffsResponse;
    /**
     * 
     * @type {CourseBasicResponse}
     * @memberof LessonResponse
     */
    course: CourseBasicResponse;
    /**
     * 
     * @type {string}
     * @memberof LessonResponse
     */
    end: string;
    /**
     * 
     * @type {Array<GradeBasicResponse>}
     * @memberof LessonResponse
     */
    grades: Array<GradeBasicResponse>;
    /**
     * 
     * @type {SignOffsResponse}
     * @memberof LessonResponse
     */
    gradeSignOffs: SignOffsResponse;
    /**
     * 
     * @type {Array<HomeworkResponse>}
     * @memberof LessonResponse
     */
    homework: Array<HomeworkResponse>;
    /**
     * 
     * @type {string}
     * @memberof LessonResponse
     */
    id: string;
    /**
     * 
     * @type {Array<LessonThemeResponse>}
     * @memberof LessonResponse
     */
    lessonThemes: Array<LessonThemeResponse>;
    /**
     * 
     * @type {Overdue}
     * @memberof LessonResponse
     */
    overdue?: Overdue;
    /**
     * 
     * @type {RoomResponse}
     * @memberof LessonResponse
     */
    room: RoomResponse;
    /**
     * 
     * @type {SignOffsResponse}
     * @memberof LessonResponse
     */
    schoolHeadSignOffs: SignOffsResponse;
    /**
     * 
     * @type {string}
     * @memberof LessonResponse
     */
    start: string;
    /**
     * 
     * @type {SubstitutionResponse}
     * @memberof LessonResponse
     */
    substitution?: SubstitutionResponse | null;
    /**
     * 
     * @type {Person}
     * @memberof LessonResponse
     */
    teacher: Person;
    /**
     * 
     * @type {Array<TimeSlotResponse>}
     * @memberof LessonResponse
     */
    timeSlots: Array<TimeSlotResponse>;
    /**
     * 
     * @type {string}
     * @memberof LessonResponse
     */
    multiLessonId: string;
    /**
     * 
     * @type {Array<LessonResponse>}
     * @memberof LessonResponse
     */
    multiLessons?: Array<LessonResponse> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LessonState {
    unknown = 'unknown',
    success = 'success',
    info = 'info',
    warning = 'warning',
    error = 'error'
}

/**
 * 
 * @export
 * @interface LessonThemeCreateEntry
 */
export interface LessonThemeCreateEntry {
    /**
     * 
     * @type {string}
     * @memberof LessonThemeCreateEntry
     */
    lessonId?: string;
    /**
     * 
     * @type {MethodOfTeachingIdOnly}
     * @memberof LessonThemeCreateEntry
     */
    method?: MethodOfTeachingIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeCreateEntry
     */
    themeDescription?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum LessonThemeFilterType {
    none = 'None',
    missingLessonTheme = 'MissingLessonTheme',
    existingLessonTheme = 'ExistingLessonTheme'
}

/**
 * 
 * @export
 * @interface LessonThemeResponse
 */
export interface LessonThemeResponse {
    /**
     * 
     * @type {Author}
     * @memberof LessonThemeResponse
     */
    createdBy?: Author | null;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeResponse
     */
    id?: string;
    /**
     * 
     * @type {MethodOfTeachingResponse}
     * @memberof LessonThemeResponse
     */
    method?: MethodOfTeachingResponse | null;
    /**
     * 
     * @type {Person}
     * @memberof LessonThemeResponse
     */
    teacher?: Person | null;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeResponse
     */
    themeDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface LessonThemeUpdateEntry
 */
export interface LessonThemeUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof LessonThemeUpdateEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeUpdateEntry
     */
    lessonId?: string;
    /**
     * 
     * @type {MethodOfTeachingIdOnly}
     * @memberof LessonThemeUpdateEntry
     */
    method?: MethodOfTeachingIdOnly | null;
    /**
     * 
     * @type {string}
     * @memberof LessonThemeUpdateEntry
     */
    themeDescription?: string | null;
}
/**
 * 
 * @export
 * @interface LessonTimeSlot
 */
export interface LessonTimeSlot {
    /**
     * 
     * @type {number}
     * @memberof LessonTimeSlot
     */
    cardinalNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LessonTimeSlot
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof LessonTimeSlot
     */
    end: string;
}
/**
 * 
 * @export
 * @interface LessonsBreak
 */
export interface LessonsBreak {
    /**
     * 
     * @type {number}
     * @memberof LessonsBreak
     */
    breakAfterLesson?: number;
    /**
     * 
     * @type {string}
     * @memberof LessonsBreak
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof LessonsBreak
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface LessonsSignMultipleResponse
 */
export interface LessonsSignMultipleResponse {
    /**
     * 
     * @type {number}
     * @memberof LessonsSignMultipleResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LessonsSignMultipleResponse
     */
    successfulCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LessonsSignMultipleResponse
     */
    failedCount?: number;
    /**
     * 
     * @type {Array<ErrorTypeError>}
     * @memberof LessonsSignMultipleResponse
     */
    errorDetails?: Array<ErrorTypeError> | null;
}
/**
 * 
 * @export
 * @interface LicenseInfo
 */
export interface LicenseInfo {
    /**
     * 
     * @type {string}
     * @memberof LicenseInfo
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof LicenseInfo
     */
    consumed: number;
    /**
     * 
     * @type {number}
     * @memberof LicenseInfo
     */
    paid: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Limitation {
    none = 'None',
    studentsOnly = 'StudentsOnly',
    teachersOnly = 'TeachersOnly'
}

/**
 * 
 * @export
 * @interface LocalUserGroupEntry
 */
export interface LocalUserGroupEntry {
    /**
     * 
     * @type {Array<EntitledAdmin>}
     * @memberof LocalUserGroupEntry
     */
    entitledAdmins: Array<EntitledAdmin>;
    /**
     * 
     * @type {GroupAndUserActions}
     * @memberof LocalUserGroupEntry
     */
    groupAndUserActions: GroupAndUserActions;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocalUserGroupEntry
     */
    userGroupIds: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MailMergeSortBy {
    firstName = 'FirstName',
    lastName = 'LastName',
    grade = 'Grade',
    class = 'Class'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum MailMergeSortDirection {
    ascending = 'Ascending',
    descending = 'Descending'
}

/**
 * 
 * @export
 * @interface MailMergeWithDownloadLink
 */
export interface MailMergeWithDownloadLink {
    /**
     * 
     * @type {string}
     * @memberof MailMergeWithDownloadLink
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof MailMergeWithDownloadLink
     */
    downloadLink: string;
    /**
     * 
     * @type {string}
     * @memberof MailMergeWithDownloadLink
     */
    validUntil: string;
}
/**
 * 
 * @export
 * @interface MarkLessonsPresent
 */
export interface MarkLessonsPresent {
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkLessonsPresent
     */
    lessonIds: Array<string>;
}
/**
 * 
 * @export
 * @interface MdmGroupCreateEntry
 */
export interface MdmGroupCreateEntry {
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupCreateEntry
     */
    configurationProfileIds?: Array<string> | null;
    /**
     * 
     * @type {InstallStatus}
     * @memberof MdmGroupCreateEntry
     */
    defaultSoftwareInstallStatus: InstallStatus;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupCreateEntry
     */
    deviceIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    displayName: string;
    /**
     * 
     * @type {GroupToCopyFrom}
     * @memberof MdmGroupCreateEntry
     */
    groupToCopyFrom?: GroupToCopyFrom | null;
    /**
     * 
     * @type {GroupType}
     * @memberof MdmGroupCreateEntry
     */
    groupType: GroupType;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    hybridSamAccountName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MdmGroupCreateEntry
     */
    isDefaultPeriod?: boolean;
    /**
     * 
     * @type {MdmGroupType}
     * @memberof MdmGroupCreateEntry
     */
    mdmGroupType: MdmGroupType;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    organizationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupCreateEntry
     */
    owners?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    periodIdentifier?: string | null;
    /**
     * 
     * @type {GroupRole}
     * @memberof MdmGroupCreateEntry
     */
    role: GroupRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupCreateEntry
     */
    softwareIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupCreateEntry
     */
    users?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupCreateEntry
     */
    windowsEnrollmentProfileId?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MdmGroupEntityType {
    unknown = 'Unknown',
    users = 'Users',
    devices = 'Devices'
}

/**
 * 
 * @export
 * @interface MdmGroupResponse
 */
export interface MdmGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof MdmGroupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupResponse
     */
    name?: string | null;
    /**
     * 
     * @type {MdmGroupType}
     * @memberof MdmGroupResponse
     */
    groupType: MdmGroupType;
    /**
     * 
     * @type {MdmGroupEntityType}
     * @memberof MdmGroupResponse
     */
    entityType: MdmGroupEntityType;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof MdmGroupResponse
     */
    software?: Array<BasicSoftwareResponse>;
    /**
     * 
     * @type {Array<BasicDeviceResponse>}
     * @memberof MdmGroupResponse
     */
    devices?: Array<BasicDeviceResponse>;
    /**
     * 
     * @type {DeviceConfigurationResponse}
     * @memberof MdmGroupResponse
     */
    settings?: DeviceConfigurationResponse;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MdmGroupType {
    manual = 'Manual',
    dynamic = 'Dynamic'
}

/**
 * 
 * @export
 * @interface MdmGroupUpdateEntry
 */
export interface MdmGroupUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof MdmGroupUpdateEntry
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupUpdateEntry
     */
    deviceIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupUpdateEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupUpdateEntry
     */
    id: string;
    /**
     * 
     * @type {MdmGroupType}
     * @memberof MdmGroupUpdateEntry
     */
    mdmGroupType?: MdmGroupType;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupUpdateEntry
     */
    usersToAdd?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmGroupUpdateEntry
     */
    usersToRemove?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MdmGroupUpdateEntry
     */
    windowsEnrollmentProfileId?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MdmProfileChoiceOptions {
    notConfigured = 'NotConfigured',
    enabled = 'Enabled',
    disabled = 'Disabled'
}

/**
 * 
 * @export
 * @interface Member
 */
export interface Member {
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    accountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    mail?: string | null;
    /**
     * 
     * @type {UserRole}
     * @memberof Member
     */
    role?: UserRole;
    /**
     * 
     * @type {GroupRole}
     * @memberof Member
     */
    groupRole?: GroupRole;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    userPrincipalName?: string | null;
}
/**
 * 
 * @export
 * @interface MemberUpdateChanges
 */
export interface MemberUpdateChanges {
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberUpdateChanges
     */
    addMemberIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberUpdateChanges
     */
    removeMemberIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    template?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Membership
     */
    names?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    removeFromAllOtherTemplateRoleGroups?: boolean;
}
/**
 * 
 * @export
 * @interface MethodOfTeachingEntry
 */
export interface MethodOfTeachingEntry {
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingEntry
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MethodOfTeachingEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingEntry
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface MethodOfTeachingIdOnly
 */
export interface MethodOfTeachingIdOnly {
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingIdOnly
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface MethodOfTeachingResponse
 */
export interface MethodOfTeachingResponse {
    /**
     * 
     * @type {Author}
     * @memberof MethodOfTeachingResponse
     */
    createdBy?: Author | null;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingResponse
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MethodOfTeachingResponse
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingResponse
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface MethodOfTeachingUpdateEntry
 */
export interface MethodOfTeachingUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingUpdateEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingUpdateEntry
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MethodOfTeachingUpdateEntry
     */
    isDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MethodOfTeachingUpdateEntry
     */
    name?: string | null;
}
/**
 * JSON body for the reference ID migration endpoint when the CSV content is sent as a string instead of a multipart file upload.
 * @export
 * @interface MigrateReferenceIdsCsvBody
 */
export interface MigrateReferenceIdsCsvBody {
    /**
     * Raw content of the SchILD migration CSV file (columns: ID;GU_ID_SVWS;GU_ID_SchILD-NRW;Name;Abgeglichen)
     * @type {string}
     * @memberof MigrateReferenceIdsCsvBody
     */
    csvContent?: string;
}
/**
 * Contains properties for a generic mime content.
 * @export
 * @interface MimeContent
 */
export interface MimeContent {
    /**
     * Stores additional data not described in the OpenAPI description found when deserializing. Can be used for serialization as well.
     * @type {{ [key: string]: any; }}
     * @memberof MimeContent
     */
    additionalData?: { [key: string]: any; } | null;
    /**
     * Stores model information.
     * @type {IBackingStore}
     * @memberof MimeContent
     */
    backingStore?: IBackingStore | null;
    /**
     * The OdataType property
     * @type {string}
     * @memberof MimeContent
     */
    odataType?: string | null;
    /**
     * Indicates the content mime type.
     * @type {string}
     * @memberof MimeContent
     */
    type?: string | null;
    /**
     * The byte array that contains the actual content.
     * @type {string}
     * @memberof MimeContent
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface MissedHours
 */
export interface MissedHours {
    /**
     * 
     * @type {number}
     * @memberof MissedHours
     */
    totalHours: number;
    /**
     * 
     * @type {number}
     * @memberof MissedHours
     */
    unexcusedHours: number;
}
/**
 * 
 * @export
 * @interface MissingQuantity
 */
export interface MissingQuantity {
    /**
     * 
     * @type {number}
     * @memberof MissingQuantity
     */
    lessonsWithoutThemeSum: number;
    /**
     * 
     * @type {number}
     * @memberof MissingQuantity
     */
    notSignedLessonsSum: number;
}
/**
 * Objects from Error class cause a failed result
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Message of the error
     * @type {string}
     * @memberof ModelError
     */
    message?: string | null;
    /**
     * Metadata of the error
     * @type {{ [key: string]: any; }}
     * @memberof ModelError
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Get the reasons of an error
     * @type {Array<IError>}
     * @memberof ModelError
     */
    reasons?: Array<IError> | null;
}
/**
 * 
 * @export
 * @interface ModulePermissions
 */
export interface ModulePermissions {
    /**
     * 
     * @type {string}
     * @memberof ModulePermissions
     */
    module: string;
    /**
     * 
     * @type {string}
     * @memberof ModulePermissions
     */
    moduleDisplayName: string;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof ModulePermissions
     */
    permissions: Array<Permission>;
}
/**
 * 
 * @export
 * @interface ModuleWithUserPermissions
 */
export interface ModuleWithUserPermissions {
    /**
     * 
     * @type {string}
     * @memberof ModuleWithUserPermissions
     */
    displayName?: string;
    /**
     * 
     * @type {Array<UserPermission>}
     * @memberof ModuleWithUserPermissions
     */
    permissions?: Array<UserPermission>;
}
/**
 * 
 * @export
 * @interface MonthlyStatistics
 */
export interface MonthlyStatistics {
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    delaysCount?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyStatistics
     */
    delaysSum?: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    delaysUnexcusedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyStatistics
     */
    delaysUnexcusedSum?: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    lessonsMissedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    lessonsMissedUnexcusedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyStatistics
     */
    year?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NetworkType {
    wLan = 'WLan',
    lan = 'Lan'
}

/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {string}
     * @memberof News
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    description?: string | null;
    /**
     * 
     * @type {Array<Recipient>}
     * @memberof News
     */
    recipients?: Array<Recipient> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof News
     */
    attachments?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    publishDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof News
     */
    pushNotification?: boolean;
}
/**
 * 
 * @export
 * @interface NotAllowedError
 */
export interface NotAllowedError {
    /**
     * Message of the error
     * @type {string}
     * @memberof NotAllowedError
     */
    message?: string | null;
    /**
     * Metadata of the error
     * @type {{ [key: string]: any; }}
     * @memberof NotAllowedError
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Get the reasons of an error
     * @type {Array<IError>}
     * @memberof NotAllowedError
     */
    reasons?: Array<IError> | null;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof NotAllowedError
     */
    statusCode?: HttpStatusCode;
    /**
     * 
     * @type {ErrorType}
     * @memberof NotAllowedError
     */
    errorType?: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof NotAllowedError
     */
    traceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotAllowedError
     */
    resourceId?: string;
}
/**
 * 
 * @export
 * @interface NotAllowedErrorAllOf
 */
export interface NotAllowedErrorAllOf {
    /**
     * 
     * @type {string}
     * @memberof NotAllowedErrorAllOf
     */
    resourceId?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NotebookCreationState {
    unknown = 'Unknown',
    failed = 'Failed',
    pending = 'Pending',
    success = 'Success'
}

/**
 * 
 * @export
 * @interface OmaSettings
 */
export interface OmaSettings {
    /**
     * 
     * @type {string}
     * @memberof OmaSettings
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OmaSettings
     */
    omaUri?: string;
    /**
     * 
     * @type {string}
     * @memberof OmaSettings
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof OmaSettings
     */
    displayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OmaSettings
     */
    isEncrypted?: boolean;
}
/**
 * 
 * @export
 * @interface OmaSettingsXML
 */
export interface OmaSettingsXML {
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXML
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXML
     */
    omaUri?: string;
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXML
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXML
     */
    displayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OmaSettingsXML
     */
    isEncrypted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXML
     */
    fileName?: string;
}
/**
 * 
 * @export
 * @interface OmaSettingsXMLAllOf
 */
export interface OmaSettingsXMLAllOf {
    /**
     * 
     * @type {string}
     * @memberof OmaSettingsXMLAllOf
     */
    fileName?: string;
}
/**
 * 
 * @export
 * @interface OnboardIosNonBoundEntry
 */
export interface OnboardIosNonBoundEntry {
    /**
     * 
     * @type {string}
     * @memberof OnboardIosNonBoundEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardIosNonBoundEntry
     */
    description: string;
    /**
     * the device name template has a specific format, ex. : iPad-{{SERIAL}}
     * @type {string}
     * @memberof OnboardIosNonBoundEntry
     */
    deviceNameTemplate?: string;
}
/**
 * 
 * @export
 * @interface OnboardIosNonBoundEntryAllOf
 */
export interface OnboardIosNonBoundEntryAllOf {
    /**
     * the device name template has a specific format, ex. : iPad-{{SERIAL}}
     * @type {string}
     * @memberof OnboardIosNonBoundEntryAllOf
     */
    deviceNameTemplate?: string;
}
/**
 * 
 * @export
 * @interface OnboardSettingsProfileResponse
 */
export interface OnboardSettingsProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof OnboardSettingsProfileResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardSettingsProfileResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardSettingsProfileResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardSettingsProfileResponse
     */
    deviceNameTemplate: string;
}
/**
 * 
 * @export
 * @interface OnboardSettingsProfileResponseAllOf
 */
export interface OnboardSettingsProfileResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof OnboardSettingsProfileResponseAllOf
     */
    deviceNameTemplate: string;
}
/**
 * 
 * @export
 * @interface OnboardSharedIosEntry
 */
export interface OnboardSharedIosEntry {
    /**
     * 
     * @type {string}
     * @memberof OnboardSharedIosEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardSharedIosEntry
     */
    description: string;
    /**
     * the device name template has a specific format, ex. : iPad-{{SERIAL}}
     * @type {string}
     * @memberof OnboardSharedIosEntry
     */
    deviceNameTemplate?: string;
}
/**
 * 
 * @export
 * @interface OnboardUserBoundIosEntry
 */
export interface OnboardUserBoundIosEntry {
    /**
     * 
     * @type {string}
     * @memberof OnboardUserBoundIosEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardUserBoundIosEntry
     */
    description: string;
    /**
     * the device name template has a specific format, ex. : iPad-{{SERIAL}}
     * @type {string}
     * @memberof OnboardUserBoundIosEntry
     */
    deviceNameTemplate?: string;
}
/**
 * 
 * @export
 * @interface OrganizationContact
 */
export interface OrganizationContact {
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    representative?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContact
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationContactModel
 */
export interface OrganizationContactModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    representative?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactModel
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationContactResponse
 */
export interface OrganizationContactResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    representative?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactResponse
     */
    mailAddress?: string | null;
    /**
     * 
     * @type {SecurityManagerResponse}
     * @memberof OrganizationContactResponse
     */
    securityManager?: SecurityManagerResponse | null;
    /**
     * 
     * @type {UserResponse}
     * @memberof OrganizationContactResponse
     */
    firstAdministrator?: UserResponse | null;
    /**
     * 
     * @type {UserResponse}
     * @memberof OrganizationContactResponse
     */
    secondAdministrator?: UserResponse | null;
}
/**
 * 
 * @export
 * @interface OrganizationContactUpdateRequest
 */
export interface OrganizationContactUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationContactUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {OrganizationContactModel}
     * @memberof OrganizationContactUpdateRequest
     */
    organizationContact: OrganizationContactModel;
    /**
     * 
     * @type {SecurityManagerModel}
     * @memberof OrganizationContactUpdateRequest
     */
    securityManager: SecurityManagerModel;
}
/**
 * 
 * @export
 * @interface OrganizationContactUpdateRequestAllOf
 */
export interface OrganizationContactUpdateRequestAllOf {
    /**
     * 
     * @type {OrganizationContactModel}
     * @memberof OrganizationContactUpdateRequestAllOf
     */
    organizationContact: OrganizationContactModel;
    /**
     * 
     * @type {SecurityManagerModel}
     * @memberof OrganizationContactUpdateRequestAllOf
     */
    securityManager: SecurityManagerModel;
}
/**
 * 
 * @export
 * @interface OrganizationCreateRequest
 */
export interface OrganizationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreateRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationCreateRequest
     */
    domains: Array<string>;
    /**
     * 
     * @type {PeriodCreate}
     * @memberof OrganizationCreateRequest
     */
    period?: PeriodCreate | null;
}
/**
 * 
 * @export
 * @interface OrganizationResetPasswordsRequest
 */
export interface OrganizationResetPasswordsRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResetPasswordsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {UserRole}
     * @memberof OrganizationResetPasswordsRequest
     */
    role: UserRole;
}
/**
 * 
 * @export
 * @interface OrganizationResetPasswordsRequestAllOf
 */
export interface OrganizationResetPasswordsRequestAllOf {
    /**
     * 
     * @type {UserRole}
     * @memberof OrganizationResetPasswordsRequestAllOf
     */
    role: UserRole;
}
/**
 * 
 * @export
 * @interface OrganizationResponse
 */
export interface OrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponse
     */
    groups: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponse
     */
    userTemplates: Array<string>;
    /**
     * 
     * @type {Array<Period>}
     * @memberof OrganizationResponse
     */
    periods: Array<Period>;
    /**
     * 
     * @type {OrganizationContactModel}
     * @memberof OrganizationResponse
     */
    organizationContact?: OrganizationContactModel | null;
    /**
     * 
     * @type {SecurityManagerModel}
     * @memberof OrganizationResponse
     */
    securityManager?: SecurityManagerModel | null;
    /**
     * 
     * @type {OrganizationTimeTableOptionsModel}
     * @memberof OrganizationResponse
     */
    timeTableOptions?: OrganizationTimeTableOptionsModel | null;
}
/**
 * 
 * @export
 * @interface OrganizationSearchResponse
 */
export interface OrganizationSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResponse
     */
    hybridSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResponse
     */
    installationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSearchResponse
     */
    supportContract?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationSearchResponse
     */
    domains?: Array<string> | null;
    /**
     * 
     * @type {OrganizationContactResponse}
     * @memberof OrganizationSearchResponse
     */
    contact?: OrganizationContactResponse | null;
}
/**
 * 
 * @export
 * @interface OrganizationTimeTableOptionsModel
 */
export interface OrganizationTimeTableOptionsModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsModel
     */
    ignoreNotMatchingLessons?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsModel
     */
    ignoreNotMatchingTeachers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsModel
     */
    mailAddresses?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface OrganizationTimeTableOptionsUpdateRequest
 */
export interface OrganizationTimeTableOptionsUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsUpdateRequest
     */
    ignoreNotMatchingLessons?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsUpdateRequest
     */
    ignoreNotMatchingTeachers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationTimeTableOptionsUpdateRequest
     */
    mailAddresses?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface OrganizationUpdateRequest
 */
export interface OrganizationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequest
     */
    installationId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationUpdateRequest
     */
    domains: Array<string>;
}
/**
 * 
 * @export
 * @interface OrganizationUpdateRequestAllOf
 */
export interface OrganizationUpdateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequestAllOf
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdateRequestAllOf
     */
    installationId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationUpdateRequestAllOf
     */
    domains: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Origin {
    aixConcept = 'AixConcept',
    other = 'Other',
    both = 'Both'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum Overdue {
    none = 'None',
    critical = 'Critical'
}

/**
 * 
 * @export
 * @interface PPGKInquiryEntry
 */
export interface PPGKInquiryEntry {
    /**
     * 
     * @type {string}
     * @memberof PPGKInquiryEntry
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PPGKInquiryEntry
     */
    resetDevices?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PPGKInquiryEntry
     */
    allocateToGroup?: string;
    /**
     * 
     * @type {NetworkType}
     * @memberof PPGKInquiryEntry
     */
    networkType?: NetworkType;
    /**
     * 
     * @type {Array<IdentifierPasswortCombination>}
     * @memberof PPGKInquiryEntry
     */
    identifierPasswortCombinations?: Array<IdentifierPasswortCombination>;
    /**
     * 
     * @type {string}
     * @memberof PPGKInquiryEntry
     */
    notes?: string;
}
/**
 * 
 * @export
 * @interface PagedOfAbsenceResponse
 */
export interface PagedOfAbsenceResponse {
    /**
     * 
     * @type {Array<AbsenceResponse>}
     * @memberof PagedOfAbsenceResponse
     */
    items?: Array<AbsenceResponse>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfAbsenceResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfAbsenceResponse
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfAbsenceResponse
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedOfArchivedAbsenceDraftResponse
 */
export interface PagedOfArchivedAbsenceDraftResponse {
    /**
     * 
     * @type {Array<ArchivedAbsenceDraftResponse>}
     * @memberof PagedOfArchivedAbsenceDraftResponse
     */
    items?: Array<ArchivedAbsenceDraftResponse>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfArchivedAbsenceDraftResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfArchivedAbsenceDraftResponse
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfArchivedAbsenceDraftResponse
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedOfParentalMail
 */
export interface PagedOfParentalMail {
    /**
     * 
     * @type {Array<ParentalMail>}
     * @memberof PagedOfParentalMail
     */
    items?: Array<ParentalMail>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMail
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMail
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMail
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedOfParentalMailResponse
 */
export interface PagedOfParentalMailResponse {
    /**
     * 
     * @type {Array<ParentalMailResponse>}
     * @memberof PagedOfParentalMailResponse
     */
    items?: Array<ParentalMailResponse>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailResponse
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailResponse
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedOfParentalMailWardParents
 */
export interface PagedOfParentalMailWardParents {
    /**
     * 
     * @type {Array<ParentalMailWardParents>}
     * @memberof PagedOfParentalMailWardParents
     */
    items?: Array<ParentalMailWardParents>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailWardParents
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailWardParents
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfParentalMailWardParents
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedOfUserGroupResponse
 */
export interface PagedOfUserGroupResponse {
    /**
     * 
     * @type {Array<UserGroupResponse>}
     * @memberof PagedOfUserGroupResponse
     */
    items?: Array<UserGroupResponse>;
    /**
     * 
     * @type {number}
     * @memberof PagedOfUserGroupResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfUserGroupResponse
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedOfUserGroupResponse
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface PagedUsersWithEmbeddedTemplateWithAccessDTO
 */
export interface PagedUsersWithEmbeddedTemplateWithAccessDTO {
    /**
     * 
     * @type {Array<UserEmbeddedTemplateWithAccess>}
     * @memberof PagedUsersWithEmbeddedTemplateWithAccessDTO
     */
    users?: Array<UserEmbeddedTemplateWithAccess>;
    /**
     * 
     * @type {number}
     * @memberof PagedUsersWithEmbeddedTemplateWithAccessDTO
     */
    totalCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PagedUsersWithEmbeddedTemplateWithAccessDTO
     */
    nextLink?: string | null;
}
/**
 * 
 * @export
 * @interface PaginatedOfActivityLogResponse
 */
export interface PaginatedOfActivityLogResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfActivityLogResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfActivityLogResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ActivityLogResponse>}
     * @memberof PaginatedOfActivityLogResponse
     */
    value: Array<ActivityLogResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfBasicDeviceResponse
 */
export interface PaginatedOfBasicDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfBasicDeviceResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfBasicDeviceResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<BasicDeviceResponse>}
     * @memberof PaginatedOfBasicDeviceResponse
     */
    value: Array<BasicDeviceResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfBasicMdmGroupResponse
 */
export interface PaginatedOfBasicMdmGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfBasicMdmGroupResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfBasicMdmGroupResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<BasicMdmGroupResponse>}
     * @memberof PaginatedOfBasicMdmGroupResponse
     */
    value: Array<BasicMdmGroupResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfBasicSoftwareResponse
 */
export interface PaginatedOfBasicSoftwareResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfBasicSoftwareResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfBasicSoftwareResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<BasicSoftwareResponse>}
     * @memberof PaginatedOfBasicSoftwareResponse
     */
    value: Array<BasicSoftwareResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfClassBasicResponse
 */
export interface PaginatedOfClassBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfClassBasicResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfClassBasicResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof PaginatedOfClassBasicResponse
     */
    value: Array<ClassBasicResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfCourseBasicResponse
 */
export interface PaginatedOfCourseBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfCourseBasicResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfCourseBasicResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CourseBasicResponse>}
     * @memberof PaginatedOfCourseBasicResponse
     */
    value: Array<CourseBasicResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfGradeBasicResponse
 */
export interface PaginatedOfGradeBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfGradeBasicResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfGradeBasicResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<GradeBasicResponse>}
     * @memberof PaginatedOfGradeBasicResponse
     */
    value: Array<GradeBasicResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfLessonBasicResponse
 */
export interface PaginatedOfLessonBasicResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfLessonBasicResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfLessonBasicResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LessonBasicResponse>}
     * @memberof PaginatedOfLessonBasicResponse
     */
    value: Array<LessonBasicResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfLessonResponse
 */
export interface PaginatedOfLessonResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfLessonResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfLessonResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LessonResponse>}
     * @memberof PaginatedOfLessonResponse
     */
    value: Array<LessonResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfParentalMailGroupRecipient
 */
export interface PaginatedOfParentalMailGroupRecipient {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfParentalMailGroupRecipient
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfParentalMailGroupRecipient
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ParentalMailGroupRecipient>}
     * @memberof PaginatedOfParentalMailGroupRecipient
     */
    value: Array<ParentalMailGroupRecipient>;
}
/**
 * 
 * @export
 * @interface PaginatedOfPasswordsCoursesResponse
 */
export interface PaginatedOfPasswordsCoursesResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfPasswordsCoursesResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfPasswordsCoursesResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PasswordsCoursesResponse>}
     * @memberof PaginatedOfPasswordsCoursesResponse
     */
    value: Array<PasswordsCoursesResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfPasswordsWorkgroupsResponse
 */
export interface PaginatedOfPasswordsWorkgroupsResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfPasswordsWorkgroupsResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfPasswordsWorkgroupsResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PasswordsWorkgroupsResponse>}
     * @memberof PaginatedOfPasswordsWorkgroupsResponse
     */
    value: Array<PasswordsWorkgroupsResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfUserGroupsDeviceResponse
 */
export interface PaginatedOfUserGroupsDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfUserGroupsDeviceResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfUserGroupsDeviceResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<UserGroupsDeviceResponse>}
     * @memberof PaginatedOfUserGroupsDeviceResponse
     */
    value: Array<UserGroupsDeviceResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfWebinarAixResponse
 */
export interface PaginatedOfWebinarAixResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfWebinarAixResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfWebinarAixResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<WebinarAixResponse>}
     * @memberof PaginatedOfWebinarAixResponse
     */
    value: Array<WebinarAixResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedOfWebinarResponse
 */
export interface PaginatedOfWebinarResponse {
    /**
     * 
     * @type {string}
     * @memberof PaginatedOfWebinarResponse
     */
    nextLink?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOfWebinarResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<WebinarResponse>}
     * @memberof PaginatedOfWebinarResponse
     */
    value: Array<WebinarResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedRequestBase
 */
export interface PaginatedRequestBase {
    /**
     * 
     * @type {string}
     * @memberof PaginatedRequestBase
     */
    continuationToken?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedRequestBase
     */
    maxSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginatedRequestBase
     */
    pageSize?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponse
 */
export interface PaginationResponse {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    daysPerPage: number;
}
/**
 * 
 * @export
 * @interface Parent
 */
export interface Parent {
    /**
     * 
     * @type {string}
     * @memberof Parent
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Parent
     */
    mailAddress?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Parent
     */
    mobilePhoneNumber?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Parent
     */
    isEmergencyContact?: boolean;
}
/**
 * 
 * @export
 * @interface ParentMailInstance
 */
export interface ParentMailInstance {
    /**
     * 
     * @type {string}
     * @memberof ParentMailInstance
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParentMailInstance
     */
    isContact: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ParentMailInstance
     */
    hasApp: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentalCommunicationGroupType {
    class = 'Class',
    grade = 'Grade'
}

/**
 * 
 * @export
 * @interface ParentalCommunicationSettings
 */
export interface ParentalCommunicationSettings {
    /**
     * 
     * @type {string}
     * @memberof ParentalCommunicationSettings
     */
    organizationId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ParentalCommunicationSettings
     */
    settings?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ParentalMail
 */
export interface ParentalMail {
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    timePeriod: string;
    /**
     * 
     * @type {Audit}
     * @memberof ParentalMail
     */
    createdBy?: Audit | null;
    /**
     * 
     * @type {Audit}
     * @memberof ParentalMail
     */
    modifiedBy?: Audit | null;
    /**
     * 
     * @type {ParentalMailCreationStatus}
     * @memberof ParentalMail
     */
    status: ParentalMailCreationStatus;
    /**
     * 
     * @type {Array<ParentalMailRecipient>}
     * @memberof ParentalMail
     */
    recipients?: Array<ParentalMailRecipient>;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestion>}
     * @memberof ParentalMail
     */
    returnQuestions?: Array<ParentalMailReturnQuestion>;
    /**
     * 
     * @type {Array<ParentalMailAttachment>}
     * @memberof ParentalMail
     */
    attachments?: Array<ParentalMailAttachment>;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    sentAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMail
     */
    requiresConfirmation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMail
     */
    wholeSchool?: boolean;
    /**
     * 
     * @type {ParentalMailStats}
     * @memberof ParentalMail
     */
    stats?: ParentalMailStats | null;
    /**
     * 
     * @type {string}
     * @memberof ParentalMail
     */
    csvEndpoint?: string | null;
    /**
     * 
     * @type {ParentalMailRecipient}
     * @memberof ParentalMail
     */
    course?: ParentalMailRecipient | null;
}
/**
 * 
 * @export
 * @interface ParentalMailAdditionalMailUpdateOptions
 */
export interface ParentalMailAdditionalMailUpdateOptions {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAdditionalMailUpdateOptions
     */
    wardId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParentalMailAdditionalMailUpdateOptions
     */
    mails: Array<string>;
}
/**
 * 
 * @export
 * @interface ParentalMailApiResponse
 */
export interface ParentalMailApiResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    signature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    sentAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMailApiResponse
     */
    requiresConfirmation: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailApiResponse
     */
    dueDate: string;
    /**
     * 
     * @type {Array<Person>}
     * @memberof ParentalMailApiResponse
     */
    students: Array<Person>;
    /**
     * 
     * @type {Array<ParentalMailAttachmentResponse>}
     * @memberof ParentalMailApiResponse
     */
    attachments: Array<ParentalMailAttachmentResponse>;
    /**
     * 
     * @type {Array<ParentalMailConfirmationResponse>}
     * @memberof ParentalMailApiResponse
     */
    confirmations?: Array<ParentalMailConfirmationResponse> | null;
    /**
     * 
     * @type {Array<ParentalMailQuestionResponse>}
     * @memberof ParentalMailApiResponse
     */
    questions?: Array<ParentalMailQuestionResponse>;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestionResponseResponse>}
     * @memberof ParentalMailApiResponse
     */
    returnQuestionResponses?: Array<ParentalMailReturnQuestionResponseResponse> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMailApiResponse
     */
    canTranslate?: boolean;
}
/**
 * 
 * @export
 * @interface ParentalMailAttachment
 */
export interface ParentalMailAttachment {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachment
     */
    fileName: string;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailAttachment
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachment
     */
    mimeType?: string | null;
}
/**
 * 
 * @export
 * @interface ParentalMailAttachmentDownload
 */
export interface ParentalMailAttachmentDownload {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachmentDownload
     */
    uri: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachmentDownload
     */
    availability: string;
}
/**
 * 
 * @export
 * @interface ParentalMailAttachmentResponse
 */
export interface ParentalMailAttachmentResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachmentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachmentResponse
     */
    fileName: string;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailAttachmentResponse
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailAttachmentResponse
     */
    mimeType?: string | null;
}
/**
 * 
 * @export
 * @interface ParentalMailConfirmationResponse
 */
export interface ParentalMailConfirmationResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailConfirmationResponse
     */
    confirmedBy: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailConfirmationResponse
     */
    confirmedAtUtc: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailConfirmationResponse
     */
    studentId: string;
}
/**
 * 
 * @export
 * @interface ParentalMailCreateBody
 */
export interface ParentalMailCreateBody {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailCreateBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailCreateBody
     */
    body: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParentalMailCreateBody
     */
    recipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMailCreateBody
     */
    wholeSchool: boolean;
    /**
     * 
     * @type {ParentalMailCreationStatus}
     * @memberof ParentalMailCreateBody
     */
    status: ParentalMailCreationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMailCreateBody
     */
    requiresConfirmation: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailCreateBody
     */
    dueDate: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailCreateBody
     */
    courseId?: string | null;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestionCreateOption>}
     * @memberof ParentalMailCreateBody
     */
    returnQuestions?: Array<ParentalMailReturnQuestionCreateOption> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentalMailCreationStatus {
    draft = 'Draft',
    completed = 'Completed'
}

/**
 * 
 * @export
 * @interface ParentalMailGroupRecipient
 */
export interface ParentalMailGroupRecipient {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailGroupRecipient
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailGroupRecipient
     */
    displayName: string;
    /**
     * 
     * @type {ParentalMailGroupRecipientType}
     * @memberof ParentalMailGroupRecipient
     */
    entityType: ParentalMailGroupRecipientType;
    /**
     * First name of the recipient. Only populated for Student.
     * @type {string}
     * @memberof ParentalMailGroupRecipient
     */
    firstName?: string | null;
    /**
     * Last name of the recipient. Only populated for Student.
     * @type {string}
     * @memberof ParentalMailGroupRecipient
     */
    lastName?: string | null;
    /**
     * Classes the course belongs to. Only populated for Course, so the frontend can compose the classbook-style label \"<subject> (<class names>)\".
     * @type {Array<ParentalMailGroupRecipientClass>}
     * @memberof ParentalMailGroupRecipient
     */
    classes?: Array<ParentalMailGroupRecipientClass>;
}
/**
 * 
 * @export
 * @interface ParentalMailGroupRecipientClass
 */
export interface ParentalMailGroupRecipientClass {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailGroupRecipientClass
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailGroupRecipientClass
     */
    name: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentalMailGroupRecipientType {
    course = 'Course',
    class = 'Class',
    grade = 'Grade',
    student = 'Student'
}

/**
 * 
 * @export
 * @interface ParentalMailQuestionResponse
 */
export interface ParentalMailQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailQuestionResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailQuestionResponse
     */
    title?: string;
    /**
     * 
     * @type {ParentalMailReturnQuestionType}
     * @memberof ParentalMailQuestionResponse
     */
    questionType?: ParentalMailReturnQuestionType;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestionOptionResponse>}
     * @memberof ParentalMailQuestionResponse
     */
    options?: Array<ParentalMailReturnQuestionOptionResponse>;
}
/**
 * 
 * @export
 * @interface ParentalMailRecipient
 */
export interface ParentalMailRecipient {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailRecipient
     */
    id: string;
    /**
     * 
     * @type {ParentalMailRecipientType}
     * @memberof ParentalMailRecipient
     */
    recipientType: ParentalMailRecipientType;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailRecipient
     */
    displayName: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentalMailRecipientType {
    student = 'Student',
    course = 'Course',
    class = 'Class',
    grade = 'Grade'
}

/**
 * 
 * @export
 * @interface ParentalMailResponse
 */
export interface ParentalMailResponse {
    /**
     * 
     * @type {Person}
     * @memberof ParentalMailResponse
     */
    student: Person;
    /**
     * 
     * @type {Array<ParentMailInstance>}
     * @memberof ParentalMailResponse
     */
    parentMails: Array<ParentMailInstance>;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailResponse
     */
    confirmedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailResponse
     */
    confirmedBy?: string | null;
    /**
     * 
     * @type {Array<ParentalMailResponseSingle>}
     * @memberof ParentalMailResponse
     */
    responses?: Array<ParentalMailResponseSingle> | null;
}
/**
 * 
 * @export
 * @interface ParentalMailResponseSingle
 */
export interface ParentalMailResponseSingle {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailResponseSingle
     */
    questionId: string;
    /**
     * 
     * @type {ParentalMailReturnQuestionType}
     * @memberof ParentalMailResponseSingle
     */
    questionType: ParentalMailReturnQuestionType;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParentalMailResponseSingle
     */
    selectedOptions?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailResponseSingle
     */
    freeTextResponse?: string | null;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestion
 */
export interface ParentalMailReturnQuestion {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestion
     */
    title: string;
    /**
     * 
     * @type {ParentalMailReturnQuestionType}
     * @memberof ParentalMailReturnQuestion
     */
    questionType: ParentalMailReturnQuestionType;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestionOption>}
     * @memberof ParentalMailReturnQuestion
     */
    options?: Array<ParentalMailReturnQuestionOption>;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestionCreateOption
 */
export interface ParentalMailReturnQuestionCreateOption {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionCreateOption
     */
    title: string;
    /**
     * 
     * @type {ParentalMailReturnQuestionType}
     * @memberof ParentalMailReturnQuestionCreateOption
     */
    questionType: ParentalMailReturnQuestionType;
    /**
     * 
     * @type {Array<ParentalMailReturnQuestionOptionCreateOption>}
     * @memberof ParentalMailReturnQuestionCreateOption
     */
    options?: Array<ParentalMailReturnQuestionOptionCreateOption> | null;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestionOption
 */
export interface ParentalMailReturnQuestionOption {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionOption
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionOption
     */
    displayText: string;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestionOptionCreateOption
 */
export interface ParentalMailReturnQuestionOptionCreateOption {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionOptionCreateOption
     */
    displayText: string;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestionOptionResponse
 */
export interface ParentalMailReturnQuestionOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionOptionResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionOptionResponse
     */
    displayText?: string;
}
/**
 * 
 * @export
 * @interface ParentalMailReturnQuestionResponseResponse
 */
export interface ParentalMailReturnQuestionResponseResponse {
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    parentalMailReturnQuestionOptionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    parentalMailReturnQuestionId: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    recipientId: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    parentMail: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    responseDate: string;
    /**
     * 
     * @type {string}
     * @memberof ParentalMailReturnQuestionResponseResponse
     */
    responseText?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentalMailReturnQuestionType {
    singleChoice = 'SingleChoice',
    multipleChoice = 'MultipleChoice',
    text = 'Text'
}

/**
 * 
 * @export
 * @interface ParentalMailStats
 */
export interface ParentalMailStats {
    /**
     * 
     * @type {number}
     * @memberof ParentalMailStats
     */
    totalWards?: number;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailStats
     */
    sentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailStats
     */
    wardsWithoutParents?: number;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailStats
     */
    responseCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ParentalMailStats
     */
    pendingCount?: number;
}
/**
 * 
 * @export
 * @interface ParentalMailWardParents
 */
export interface ParentalMailWardParents {
    /**
     * 
     * @type {Person}
     * @memberof ParentalMailWardParents
     */
    ward: Person;
    /**
     * 
     * @type {Array<ParentMailInstance>}
     * @memberof ParentalMailWardParents
     */
    parents: Array<ParentMailInstance>;
    /**
     * 
     * @type {boolean}
     * @memberof ParentalMailWardParents
     */
    anyParentHasApp?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PasswordMinutesOfInactivityValues {
    /**
    * 1
    */
    one = 'One',
    /**
    * 5
    */
    five = 'Five',
    /**
    * 10
    */
    ten = 'Ten',
    /**
    * 15
    */
    fifteen = 'Fifteen',
    /**
    * 30
    */
    thirty = 'Thirty',
    /**
    * 60
    */
    sixty = 'Sixty',
    /**
    * 240
    */
    twoHundredAndForty = 'TwoHundredAndForty',
    /**
    * 480
    */
    fourHundredAndEighty = 'FourHundredAndEighty'
}

/**
 * 
 * @export
 * @interface PasswordsClassResponse
 */
export interface PasswordsClassResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof PasswordsClassResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordsClassResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsClassResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PasswordsCoursesResponse
 */
export interface PasswordsCoursesResponse {
    /**
     * 
     * @type {AzureGroup}
     * @memberof PasswordsCoursesResponse
     */
    azureGroup?: AzureGroup | null;
    /**
     * 
     * @type {Array<PasswordsClassResponse>}
     * @memberof PasswordsCoursesResponse
     */
    classes?: Array<PasswordsClassResponse>;
    /**
     * 
     * @type {string}
     * @memberof PasswordsCoursesResponse
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordsCoursesResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsCoursesResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PasswordsUserResponse
 */
export interface PasswordsUserResponse {
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    userPrincipalName?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    referenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    displayName?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof PasswordsUserResponse
     */
    role?: UserRole;
    /**
     * 
     * @type {string}
     * @memberof PasswordsUserResponse
     */
    templateId?: string;
}
/**
 * 
 * @export
 * @interface PasswordsWorkgroupsResponse
 */
export interface PasswordsWorkgroupsResponse {
    /**
     * 
     * @type {string}
     * @memberof PasswordsWorkgroupsResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsWorkgroupsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordsWorkgroupsResponse
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface Period
 */
export interface Period {
    /**
     * 
     * @type {boolean}
     * @memberof Period
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Period
     */
    canNotBeDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Period
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface PeriodCreate
 */
export interface PeriodCreate {
    /**
     * 
     * @type {string}
     * @memberof PeriodCreate
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof PeriodCreate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PeriodCreate
     */
    start?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PeriodCreate
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PeriodCreate
     */
    cloneClassbookSettings?: boolean;
}
/**
 * 
 * @export
 * @interface PeriodUpdate
 */
export interface PeriodUpdate {
    /**
     * 
     * @type {string}
     * @memberof PeriodUpdate
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof PeriodUpdate
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof Permission
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof Permission
     */
    templateName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Permission
     */
    hasDirectoryRole?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Permission
     */
    hasDeviceManagementRole?: boolean;
}
/**
 * 
 * @export
 * @interface PermissionConsent
 */
export interface PermissionConsent {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionConsent
     */
    isConsentRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionConsent
     */
    consentUrl?: string | null;
}
/**
 * 
 * @export
 * @interface PermissionRoleLight
 */
export interface PermissionRoleLight {
    /**
     * 
     * @type {string}
     * @memberof PermissionRoleLight
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionRoleLight
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PermissionsCacheDeleteRequest
 */
export interface PermissionsCacheDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsCacheDeleteRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface PermissionsEffectiveGetRequest
 */
export interface PermissionsEffectiveGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsEffectiveGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface PermissionsEffectiveOfUserGetRequest
 */
export interface PermissionsEffectiveOfUserGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsEffectiveOfUserGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsEffectiveOfUserGetRequest
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface PermissionsModuleGetRequest
 */
export interface PermissionsModuleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsModuleGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsModuleGetRequest
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PermissionsModulesGetRequest
 */
export interface PermissionsModulesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsModulesGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfAbsences {
    /**
    * Erlaubt das Anzeigen und Bearbeiten der Absenzen aller Kurse und Schüler:innen
    */
    readWriteAll = 'PermissionsOfAbsences.ReadWriteAll',
    /**
    * Erlaubt das Anzeigen und Verwalten von eingereichten Absenzen der eigenen Schüler:innen. Durch die zusätzliche Vergabe des Rechts ‚Verwalter‘ kann diese Einschränkung aufgehoben werden.
    */
    showDrafts = 'PermissionsOfAbsences.ShowDrafts',
    /**
    * Erlaubt das Anzeigen des Moduls und das Anzeigen und Bearbeiten der Absenzen in den Kursen, in denen der Benutzer Mitglied ist.
    */
    showModule = 'PermissionsOfAbsences.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfAnnouncements {
    /**
    * Erlaubt das Anzeigen des Moduls, das Erstellen eigener Ankündigungen sowie das Anzeigen aller verfügbaren Ankündigungen.
    */
    showModule = 'PermissionsOfAnnouncements.ShowModule',
    /**
    * Erlaubt das Erstellen, Bearbeiten und Löschen aller Ankündigungen.
    */
    writeAll = 'PermissionsOfAnnouncements.WriteAll'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfAssignments {
    /**
    * Erlaubt das Anzeigen des Moduls, sowie das Anzeigen und Einreichen der Aufgaben die dem Benutzer direkt oder indirekt zugewiesen sind.
    */
    showModule = 'PermissionsOfAssignments.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfBildungslogin {
    /**
    * Erlaubt dem Benutzer auf die Lizenzverwaltung von Bildungslogin zuzugreifen.
    */
    manageLicenses = 'PermissionsOfBildungslogin.ManageLicenses',
    /**
    * Erlaubt dem Benutzer die einmalige Beantragung/Registrierung des Moduls.
    */
    register = 'PermissionsOfBildungslogin.Register',
    /**
    * Erlaubt dem Benutzer das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfBildungslogin.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfCalendar {
    /**
    * Erlaubt das Anzeigen des Moduls, aller zugehörigen Kalender, sowie das Erstellen und Bearbeiten neuer Termine.
    */
    showModule = 'PermissionsOfCalendar.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfClassbook {
    /**
    * Erlaubt das Exportieren von Klassenbüchern aller Klassen.
    */
    exportClassbooks = 'PermissionsOfClassbook.ExportClassbooks',
    /**
    * Erlaubt das Anzeigen der Revisionshistorie eines Klassenbuch Objekts.
    */
    readRevisions = 'PermissionsOfClassbook.ReadRevisions',
    /**
    * Erlaubt das Anzeigen aller Stufen, Klassen und Kurse, sowie das Bearbeiten aller Unterrichtsstunden.
    */
    readWriteAll = 'PermissionsOfClassbook.ReadWriteAll',
    /**
    * Erlaubt das Anzeigen des Moduls, das Anzeigen der eigenen Stufen, Klassen und Kurse, sowie das Anzeigen und Bearbeiten von Unterrichtsstunden in denen der Benutzer Mitglied ist.
    */
    showModule = 'PermissionsOfClassbook.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfCourses {
    /**
    * Erlaubt das Ändern von Passwörtern eines oder mehrerer Kursteilnehmer.
    */
    changePasswords = 'PermissionsOfCourses.ChangePasswords',
    /**
    * Erlaubt dem Benutzer einem beliebigen fremden Kurs selbstständig beizutreten und zu verlassen.
    */
    joinCourse = 'PermissionsOfCourses.JoinCourse',
    /**
    * Erlaubt dem Benutzer das Anzeigen und Verwalten von Elternbriefen der sichtbaren Kurse.
    */
    parentalLettersReadWrite = 'PermissionsOfCourses.ParentalLettersReadWrite',
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfCourses.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfDeviceManagement {
    /**
    * Erlaubt das endgültige Entfernen von Geräten.
    */
    deleteDevices = 'PermissionsOfDeviceManagement.DeleteDevices',
    /**
    * Erlaubt das Laden und Anzeigen der Geräteverwaltung
    */
    showModule = 'PermissionsOfDeviceManagement.ShowModule',
    /**
    * Erlaubt das Anzeigen von sensiblen Daten wie z. B. primärer Benutzer oder Standort.
    */
    showSensibleInfo = 'PermissionsOfDeviceManagement.ShowSensibleInfo'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfEmails {
    /**
    * Erlaubt das Anzeigen des Moduls, sowie das Lesen, Schreiben und Löschen von E-Mails.
    */
    showModule = 'PermissionsOfEmails.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfFiles {
    /**
    * Erlaubt das zusätzliche Anzeigen aller Gruppen-Dateien in denen der Benutzer Mitglied ist.
    */
    readGroupFiles = 'PermissionsOfFiles.ReadGroupFiles',
    /**
    * Erlaubt das Freigeben von Dateien mit Dritten.
    */
    shareFiles = 'PermissionsOfFiles.ShareFiles',
    /**
    * Erlaubt das Anzeigen des Moduls, der eigenen Dateien, sowie das Erstellen, Löschen und Bearbeiten von Dateien und Ordnern.
    */
    showModule = 'PermissionsOfFiles.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfGroups {
    /**
    * Erlaubt dem Benutzer das Anzeigen und Wiederherstellen von gelöschten Gruppen.
    */
    restoreDeleted = 'PermissionsOfGroups.RestoreDeleted',
    /**
    * Erlaubt dem Benutzer das Anzeigen von Gruppen inkl. deren Mitgliedern und Besitzern.
    */
    showModule = 'PermissionsOfGroups.ShowModule',
    /**
    * Erlaubt das Erstellen, Bearbeiten und Löschen von Gruppen inkl. dem Hinzufügen und Entfernen von Mitgliedern und Besitzern.
    */
    writeAll = 'PermissionsOfGroups.WriteAll'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfInDevelopment {
    /**
    * Erlaubt eine Änderung für alle Benutzer, die mit der Benutzervorlage {{templateName}} erstellt wurden.
    */
    changeSomethingForUserTemplate = 'PermissionsOfInDevelopment.ChangeSomethingForUserTemplate',
    /**
    * Erlaubt das Anzeigen des Moduls für Testzwecke in der Entwicklung
    */
    showModule = 'PermissionsOfInDevelopment.ShowModule',
    /**
    * Gibt Benutzern erweiterte Rechte direkt in Endpoint aka Intune
    */
    withSpecificDeviceManagementRole = 'PermissionsOfInDevelopment.WithSpecificDeviceManagementRole',
    /**
    * Gibt Benutzern erweiterte Rechte direkt in Entra
    */
    withSpecificDirectoryRole = 'PermissionsOfInDevelopment.WithSpecificDirectoryRole',
    /**
    * Gibt Benutzern erweiterte Rechte direkt in Entra UND Endpoint
    */
    withSpecificRoles = 'PermissionsOfInDevelopment.WithSpecificRoles'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfModuleRights {
    /**
    * Erlaubt das Hinzufügen, Ändern und Löschen von Rollen.
    */
    readWriteRoles = 'PermissionsOfModuleRights.ReadWriteRoles',
    /**
    * Erlaubt das Laden und Anzeigen der Modulrechte.
    */
    showModule = 'PermissionsOfModuleRights.ShowModule',
    /**
    * Erlaubt das Hinzufügen und Entfernen von Rollenmitgliedern.
    */
    writeRoleMembers = 'PermissionsOfModuleRights.WriteRoleMembers'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfOrganization {
    /**
    * Erlaubt das Aktivieren von Zeiträumen
    */
    activateTimePeriod = 'PermissionsOfOrganization.ActivateTimePeriod',
    /**
    * Erlaubt das Anpassen eines existierenden Zeitraums
    */
    changePeriod = 'PermissionsOfOrganization.ChangePeriod',
    /**
    * Erlaubt das Anlegen neuer Zeiträume
    */
    createPeriods = 'PermissionsOfOrganization.CreatePeriods',
    /**
    * Erlaubt das löschen von inaktiven Zeiträumen
    */
    deletePeriod = 'PermissionsOfOrganization.DeletePeriod',
    /**
    * Erlaubt das Erstellen, Löschen und Ändern von Organisationen
    */
    manage = 'PermissionsOfOrganization.Manage',
    /**
    * Erlaubt das Anzeigen des Moduls
    */
    showModule = 'PermissionsOfOrganization.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfParentalCommunication {
    /**
    * Erlaubt das Anzeigen des Kalenders.
    */
    calendar = 'PermissionsOfParentalCommunication.Calendar',
    /**
    * Erlaubt das Erstellen, Löschen und Bearbeiten von Terminen.
    */
    calendarWriteAll = 'PermissionsOfParentalCommunication.CalendarWriteAll',
    /**
    * Erlaubt das Anzeigen der Dateien.
    */
    files = 'PermissionsOfParentalCommunication.Files',
    /**
    * Erlaubt das Erstellen, Löschen und Bearbeiten von Dateien und Ordnern.
    */
    filesWriteAll = 'PermissionsOfParentalCommunication.FilesWriteAll',
    /**
    * Erlaubt dem Benutzer das Anzeigen des Moduls Eltern-Lehrer-Chat.
    */
    guardianChat = 'PermissionsOfParentalCommunication.GuardianChat',
    /**
    * Erlaubt das Anzeigen von Elternkontakten.
    */
    guardianContacts = 'PermissionsOfParentalCommunication.GuardianContacts',
    /**
    * Erlaubt das Erstellen und Versenden von Eltern-Einladungen (Serienbrief und QR-Codes).
    */
    guardianContactsInvitations = 'PermissionsOfParentalCommunication.GuardianContactsInvitations',
    /**
    * Erlaubt das Erstellen, Löschen und Bearbeiten von Elternkontakten.
    */
    guardianContactsWriteAll = 'PermissionsOfParentalCommunication.GuardianContactsWriteAll',
    /**
    * Erlaubt das Anzeigen von Neuigkeiten.
    */
    news = 'PermissionsOfParentalCommunication.News',
    /**
    * Erlaubt das Erstellen, Löschen und Bearbeiten von Neuigkeiten für eigene Stufen/Klassen/Kurse.
    */
    newsWrite = 'PermissionsOfParentalCommunication.NewsWrite',
    /**
    * Erlaubt das Erstellen, Löschen und Bearbeiten von Neuigkeiten für alle Stufen und Klassen.
    */
    newsWriteAll = 'PermissionsOfParentalCommunication.NewsWriteAll',
    /**
    * Erlaubt dem Benutzer das Anzeigen des Moduls Elternbriefe.
    */
    parentalLetters = 'PermissionsOfParentalCommunication.ParentalLetters',
    /**
    * Erlaubt dem Benutzer das Anzeigen und Verwalten von Elternbriefen für die eigenen Schüler:innen.
    */
    parentalLettersReadWrite = 'PermissionsOfParentalCommunication.ParentalLettersReadWrite',
    /**
    * Erlaubt dem Benutzer das Anzeigen und Verwalten aller Elternbriefe.
    */
    parentalLettersReadWriteAll = 'PermissionsOfParentalCommunication.ParentalLettersReadWriteAll',
    /**
    * Erlaubt beim Erstellen/Versenden eines Elternbriefs den Versand an alle Schüler:innen der Schule
    */
    parentalLettersWriteAllStudents = 'PermissionsOfParentalCommunication.ParentalLettersWriteAllStudents',
    /**
    * Erlaubt das Anzeigen und Bearbeiten der Einstellungen.
    */
    settings = 'PermissionsOfParentalCommunication.Settings',
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfParentalCommunication.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfPasswords {
    /**
    * Erlaubt das gleichzeitige Ändern von Passwörtern für Mitglieder einer oder mehrerer Gruppen.
    */
    changeGroupMemberPasswords = 'PermissionsOfPasswords.ChangeGroupMemberPasswords',
    /**
    * Erlaubt das Ändern von Passwörtern für einen oder mehrere Benutzer.
    */
    changeUserPasswords = 'PermissionsOfPasswords.ChangeUserPasswords',
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfPasswords.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfReports {
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfReports.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfResources {
    /**
    * Erlaubt dem Benutzer das Erstellen, Ändern und Löschen von Ressourcen, sowie das Erstellen, Ändern und Löschen von allen Buchungen (inkl. nicht eigener Buchungen).
    */
    administrator = 'PermissionsOfResources.Administrator',
    /**
    * Erlaubt dem Benutzer grundlegende Einstellungen für den Betrieb des Moduls vorzunehmen.
    */
    settings = 'PermissionsOfResources.Settings',
    /**
    * Erlaubt dem Benutzer das Anzeigen der Details fremder Buchungen (z.B. den Namen der Person die die Ressource gebucht hat).
    */
    showBookingDetails = 'PermissionsOfResources.ShowBookingDetails',
    /**
    * Erlaubt das Anzeigen des Moduls, sowie das Anzeigen aller Ressourcen, Buchungen und die Möglichkeit eigene Buchungen vorzunehmen.
    */
    showModule = 'PermissionsOfResources.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfSchoolLinks {
    /**
    * Erlaubt das Laden und Anzeigen aller Favoriten-Schullinks
    */
    readFavorites = 'PermissionsOfSchoolLinks.ReadFavorites',
    /**
    * Erlaubt das Erstellen, Ändern, Löschen aller Schullinks
    */
    readWrite = 'PermissionsOfSchoolLinks.ReadWrite',
    /**
    * Erlaubt das Laden und Anzeigen aller Schullinks
    */
    showModule = 'PermissionsOfSchoolLinks.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfSettings {
    /**
    * Erlaubt das Anzeigen und Bearbeiten der Klassenbucheinstellungen.
    */
    classbook = 'PermissionsOfSettings.Classbook',
    /**
    * Erlaubt dem Benutzer die Gestaltung/Verwaltung des AIXONE Cockpits. Dabei kann konfiguriert werden, welche Inhalte für welche Nutzergruppen sichtbar sein sollen.
    */
    cockpit = 'PermissionsOfSettings.Cockpit',
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfSettings.ShowModule',
    /**
    * Erlaubt das Anzeigen und Bearbeiten der Stundenplaneinstellungen.
    */
    timetable = 'PermissionsOfSettings.Timetable',
    /**
    * Erlaubt dem Benutzer das Erstellen und Löschen von API-Schlüsseln.
    */
    writeApiKeys = 'PermissionsOfSettings.WriteApiKeys'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfTemplates {
    /**
    * Erlaubt dem Benutzer das Anzeigen und Verwalten von Profilvorlagen für Benutzer und Gruppen.
    */
    showModule = 'PermissionsOfTemplates.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfTimetable {
    /**
    * Erlaubt dem Benutzer das Erstellen, Bearbeiten und Löschen von Vertretungen im Stundenplan.
    */
    manageSubstitutions = 'PermissionsOfTimetable.ManageSubstitutions',
    /**
    * Erlaubt das Anpassen des Stundenplans über den Planer.
    */
    planner = 'PermissionsOfTimetable.Planner',
    /**
    * Erlaubt das Anzeigen von Stundenplänen aller Benutzer, Räume, Klassen und Gruppen.
    */
    readAll = 'PermissionsOfTimetable.ReadAll',
    /**
    * Erlaubt das Anzeigen des Moduls, sowie das Anzeigen des eigenen Stundenplans.
    */
    showModule = 'PermissionsOfTimetable.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfUsers {
    /**
    * Erlaubt dem Benutzer das Ändern von Passwörtern für Benutzer die mit der Vorlage „{{templateName}}“ erstellt worden sind.
    */
    changePasswordsForUserTemplate = 'PermissionsOfUsers.ChangePasswordsForUserTemplate',
    /**
    * Erlaubt dem Benutzer das Ändern von Passwörtern für Schüler:innen der eigenen verwalteten Stufen, Klassen und Kurse.
    */
    changeStudentsPasswords = 'PermissionsOfUsers.ChangeStudentsPasswords',
    /**
    * Erlaubt dem Benutzer das Bearbeiten von Schüler:innen der eigenen Stufen, Klassen und Kurse.
    */
    editStudents = 'PermissionsOfUsers.EditStudents',
    /**
    * Erlaubt dem Benutzer das Verwalten von Konten über den Import von .csv Dateien von Benutzern die mit der Vorlage „{{templateName}}“ erstellt oder geändert werden sollen.
    */
    importUsersForUserTemplate = 'PermissionsOfUsers.ImportUsersForUserTemplate',
    /**
    * Erlaubt das Ändern von ReferenzIds an allen Benutzern.
    */
    migrateReferenceIds = 'PermissionsOfUsers.MigrateReferenceIds',
    /**
    * Erlaubt dem Benutzer das Anzeigen, Erstellen, Bearbeiten und Löschen von Benutzern, die mit der Vorlage „{{templateName}}“ erstellt worden sind.
    */
    readWriteUsersForUserTemplate = 'PermissionsOfUsers.ReadWriteUsersForUserTemplate',
    /**
    * Erlaubt dem Benutzer das Anzeigen und Wiederherstellen von gelöschten Benutzern.
    */
    restoreDeleted = 'PermissionsOfUsers.RestoreDeleted',
    /**
    * Erlaubt dem Benutzer das Anzeigen des Moduls, sowie das Anzeigen aller Schüler:innen der eigenen verwalteten Stufen, Klassen und Kurse.
    */
    showModule = 'PermissionsOfUsers.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfWebinars {
    /**
    * Erlaubt das Anzeigen des Moduls für AixConcept Webinare, sowie das An- und Abmelden von angebotenen Terminen.
    */
    showModule = 'PermissionsOfWebinars.ShowModule'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PermissionsOfWorkgroups {
    /**
    * Erlaubt das Anzeigen des Moduls.
    */
    showModule = 'PermissionsOfWorkgroups.ShowModule'
}

/**
 * 
 * @export
 * @interface PermissionsRoleDeleteRequest
 */
export interface PermissionsRoleDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleDeleteRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleDeleteRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface PermissionsRoleGetRequest
 */
export interface PermissionsRoleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface PermissionsRoleMembersGetRequest
 */
export interface PermissionsRoleMembersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleMembersGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleMembersGetRequest
     */
    id: string;
}
/**
 * 
 * @export
 * @interface PermissionsRoleMembersUpdateRequest
 */
export interface PermissionsRoleMembersUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleMembersUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {MemberUpdateChanges}
     * @memberof PermissionsRoleMembersUpdateRequest
     */
    membershipChanges?: MemberUpdateChanges | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionsRoleMembersUpdateRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface PermissionsRolesGetRequest
 */
export interface PermissionsRolesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsRolesGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    mailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    abandonedAzureAccount?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PersonalProfilePersonalPlayStoreMode {
    notConfigured = 'NotConfigured',
    blockedApps = 'BlockedApps',
    allowedApps = 'AllowedApps'
}

/**
 * 
 * @export
 * @interface PhysicalAddress
 */
export interface PhysicalAddress {
    /**
     * 
     * @type {string}
     * @memberof PhysicalAddress
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAddress
     */
    countryOrRegion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAddress
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAddress
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicalAddress
     */
    street?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PlanLinkage {
    unknown = 'Unknown',
    owner = 'Owner',
    subscriber = 'Subscriber'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlatformType {
    any = 'Any',
    ios = 'IOS',
    windows = 'Windows',
    android = 'Android',
    chromeOS = 'ChromeOS'
}

/**
 * 
 * @export
 * @interface PositionResponse
 */
export interface PositionResponse {
    /**
     * 
     * @type {Array<DeviceActionResponse>}
     * @memberof PositionResponse
     */
    deviceActions?: Array<DeviceActionResponse>;
    /**
     * 
     * @type {number}
     * @memberof PositionResponse
     */
    longitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionResponse
     */
    latitude?: number | null;
}
/**
 * 
 * @export
 * @interface PositionResponseAllOf
 */
export interface PositionResponseAllOf {
    /**
     * 
     * @type {number}
     * @memberof PositionResponseAllOf
     */
    longitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionResponseAllOf
     */
    latitude?: number | null;
}
/**
 * 
 * @export
 * @interface ProfileResponse
 */
export interface ProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    userPrincipalName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    displayName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileResponse
     */
    role?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProfileType {
    unknown = 'Unknown',
    iosDeviceFeatures = 'IosDeviceFeatures',
    iosDeviceRestrictions = 'IosDeviceRestrictions'
}

/**
 * 
 * @export
 * @interface RecentRequest
 */
export interface RecentRequest {
    /**
     * 
     * @type {string}
     * @memberof RecentRequest
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof RecentRequest
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof RecentRequest
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Recipient
     */
    id?: string;
    /**
     * 
     * @type {ParentalCommunicationGroupType}
     * @memberof Recipient
     */
    type?: ParentalCommunicationGroupType;
}
/**
 * 
 * @export
 * @interface RecipientEmbedded
 */
export interface RecipientEmbedded {
    /**
     * 
     * @type {string}
     * @memberof RecipientEmbedded
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientEmbedded
     */
    name?: string;
    /**
     * 
     * @type {ParentalCommunicationGroupType}
     * @memberof RecipientEmbedded
     */
    type?: ParentalCommunicationGroupType;
    /**
     * 
     * @type {boolean}
     * @memberof RecipientEmbedded
     */
    fromParentFolder?: boolean;
}
/**
 * 
 * @export
 * @interface Recipients
 */
export interface Recipients {
    /**
     * 
     * @type {Array<ClassbookEntity>}
     * @memberof Recipients
     */
    groups: Array<ClassbookEntity>;
    /**
     * 
     * @type {Array<PermissionRoleLight>}
     * @memberof Recipients
     */
    roles: Array<PermissionRoleLight>;
}
/**
 * 
 * @export
 * @interface RecipientsBasic
 */
export interface RecipientsBasic {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecipientsBasic
     */
    groups: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecipientsBasic
     */
    roles: Array<string>;
}
/**
 * Result of matching a single row of a reference ID migration CSV file against the existing users of the organization.
 * @export
 * @interface ReferenceIdMigrationEntryDto
 */
export interface ReferenceIdMigrationEntryDto {
    /**
     * Numeric SchILD ID from the CSV row (null when the column is missing or empty)
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    id?: string | null;
    /**
     * User principal name of the matched user (null if no user was found)
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    loginName?: string | null;
    /**
     * Migration state (MultipleAssignment, NotFound, AlreadyAssigned, Found)
     * @type {ReferenceIdMigrationState}
     * @memberof ReferenceIdMigrationEntryDto
     */
    state?: ReferenceIdMigrationState;
    /**
     * Display name fallback: the matched user\'s display name, or the name from the CSV row when no user was found (the CSV only carries a single name column that cannot be split reliably)
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    userDisplayName?: string | null;
    /**
     * First name of the matched user (null if no user was found — use UserDisplayName as fallback)
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    userFirstName?: string | null;
    /**
     * Last name of the matched user (null if no user was found — use UserDisplayName as fallback)
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    userLastName?: string | null;
    /**
     * The old (V2) reference ID
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    v2Id?: string | null;
    /**
     * The new (V3) reference ID
     * @type {string}
     * @memberof ReferenceIdMigrationEntryDto
     */
    v3Id?: string | null;
}
/**
 * State of a single reference ID migration entry. The enum order defines the sort order of the migration result list (problematic entries first).
 * @export
 * @enum {string}
 */
export enum ReferenceIdMigrationState {
    multipleAssignment = 'MultipleAssignment',
    notFound = 'NotFound',
    alreadyAssigned = 'AlreadyAssigned',
    found = 'Found'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum Relationship {
    unknown = 'Unknown',
    guardian = 'Guardian',
    other = 'Other'
}

/**
 * 
 * @export
 * @interface ReleaseNote
 */
export interface ReleaseNote {
    /**
     * Unique id of the changelog.
     * @type {string}
     * @memberof ReleaseNote
     */
    id: string;
    /**
     * Contains additional images attached to the release note.
     * @type {Array<string>}
     * @memberof ReleaseNote
     */
    imageUrls?: Array<string> | null;
    /**
     * Specifies the daate, the changelogs were officially released.
     * @type {string}
     * @memberof ReleaseNote
     */
    releaseDateUtc: string;
    /**
     * Contains the release notes in a Markdown (.md) format.
     * @type {string}
     * @memberof ReleaseNote
     */
    releaseNotes: string;
    /**
     * Can be set to mark a specific changelog to get pro-actively announced.
     * @type {boolean}
     * @memberof ReleaseNote
     */
    shouldBeAnnounced: boolean;
    /**
     * Title of the Release
     * @type {string}
     * @memberof ReleaseNote
     */
    title: string;
}
/**
 * 
 * @export
 * @interface ReportAvailable
 */
export interface ReportAvailable {
    /**
     * 
     * @type {string}
     * @memberof ReportAvailable
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportAvailable
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportAvailable
     */
    classId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportAvailable
     */
    className?: string | null;
    /**
     * 
     * @type {Audit}
     * @memberof ReportAvailable
     */
    created?: Audit | null;
}
/**
 * 
 * @export
 * @interface ReportChanges
 */
export interface ReportChanges {
    /**
     * 
     * @type {number}
     * @memberof ReportChanges
     */
    added?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportChanges
     */
    removed?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportChanges
     */
    updated?: number;
}
/**
 * 
 * @export
 * @interface ReportResponse
 */
export interface ReportResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResponse
     */
    downloadUrl?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RequiredPasswordType {
    deviceDefault = 'DeviceDefault',
    alphanumeric = 'Alphanumeric',
    numeric = 'Numeric'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum RequiredPasswortType {
    deviceDefault = 'DeviceDefault',
    required = 'Required',
    numeric = 'Numeric',
    numericComplex = 'NumericComplex',
    alphabetic = 'Alphabetic',
    alphanumeric = 'Alphanumeric',
    alphanumericWithSymbols = 'AlphanumericWithSymbols',
    lowSecurityBiometric = 'LowSecurityBiometric',
    customPassword = 'CustomPassword'
}

/**
 * 
 * @export
 * @interface ResolveCourseRequest
 */
export interface ResolveCourseRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveCourseRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolveCourseRequest
     */
    ids?: Array<string>;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    activeDirectoryId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    id?: string | null;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof Resource
     */
    resourceStatus?: ResourceStatus;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    type?: string | null;
}
/**
 * 
 * @export
 * @interface ResourceResponse
 */
export interface ResourceResponse {
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    exchangeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    timeTableId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    timeTableName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResourceResponse
     */
    capacity: number;
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ResourceResponse
     */
    type: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ResourceStatus {
    none = 'None',
    pending = 'Pending',
    completed = 'Completed',
    error = 'Error'
}

/**
 * 
 * @export
 * @interface ResourcesSettings
 */
export interface ResourcesSettings {
    /**
     * 
     * @type {string}
     * @memberof ResourcesSettings
     */
    bookingMaxDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof ResourcesSettings
     */
    bookingMaxFutureDuration?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResourcesSettings
     */
    emailRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcesSettings
     */
    shouldNotifyOnEquipmentBooking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResourcesSettings
     */
    shouldNotifyOnRoomBooking?: boolean;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface RolePermissions
 */
export interface RolePermissions {
    /**
     * 
     * @type {Role}
     * @memberof RolePermissions
     */
    role: Role;
    /**
     * 
     * @type {Array<ModulePermissions>}
     * @memberof RolePermissions
     */
    permissions: Array<ModulePermissions>;
}
/**
 * 
 * @export
 * @interface RolePermissionsCreateEntry
 */
export interface RolePermissionsCreateEntry {
    /**
     * 
     * @type {string}
     * @memberof RolePermissionsCreateEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RolePermissionsCreateEntry
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissionsCreateEntry
     */
    permissionIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface RolePermissionsUpdateEntry
 */
export interface RolePermissionsUpdateEntry {
    /**
     * 
     * @type {string}
     * @memberof RolePermissionsUpdateEntry
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RolePermissionsUpdateEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RolePermissionsUpdateEntry
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RolePermissionsUpdateEntry
     */
    permissionIds?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    activeDirectoryId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    id?: string | null;
    /**
     * 
     * @type {ResourceStatus}
     * @memberof Room
     */
    resourceStatus?: ResourceStatus;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    label?: string | null;
    /**
     * 
     * @type {RoomOrigin}
     * @memberof Room
     */
    origin?: RoomOrigin;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    timetableId?: string | null;
}
/**
 * 
 * @export
 * @interface RoomAllOf
 */
export interface RoomAllOf {
    /**
     * 
     * @type {string}
     * @memberof RoomAllOf
     */
    label?: string | null;
    /**
     * 
     * @type {RoomOrigin}
     * @memberof RoomAllOf
     */
    origin?: RoomOrigin;
    /**
     * 
     * @type {string}
     * @memberof RoomAllOf
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoomAllOf
     */
    timetableId?: string | null;
}
/**
 * 
 * @export
 * @interface RoomCreateRequest
 */
export interface RoomCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {RoomOptions}
     * @memberof RoomCreateRequest
     */
    room: RoomOptions;
}
/**
 * 
 * @export
 * @interface RoomDeleteRequest
 */
export interface RoomDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomDeleteRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDeleteRequest
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDeleteRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface RoomGetAllRequest
 */
export interface RoomGetAllRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomGetAllRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomGetAllRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface RoomGetRequest
 */
export interface RoomGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomGetRequest
     */
    resourceId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomGetRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface RoomOptions
 */
export interface RoomOptions {
    /**
     * Specifies the capacity of the resource (e.g. seats or pieces).
     * @type {number}
     * @memberof RoomOptions
     */
    capacity?: number;
    /**
     * Specifies the capacity of the resource.
     * @type {string}
     * @memberof RoomOptions
     */
    displayName?: string | null;
    /**
     * E-Mail address of the resource.
     * @type {string}
     * @memberof RoomOptions
     */
    emailAddress?: string | null;
    /**
     * Specifies a descriptive label for the room, for example, a number or name.
     * @type {string}
     * @memberof RoomOptions
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoomOptions
     */
    timePeriod: string;
    /**
     * Specifies the room entity id based of existing timetable data.
     * @type {string}
     * @memberof RoomOptions
     */
    timetableId?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RoomOrigin {
    exchange = 'Exchange',
    timetable = 'Timetable'
}

/**
 * 
 * @export
 * @interface RoomResponse
 */
export interface RoomResponse {
    /**
     * 
     * @type {number}
     * @memberof RoomResponse
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoomResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface RoomUpdateRequest
 */
export interface RoomUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof RoomUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RoomUpdateRequest
     */
    resourceId: string;
    /**
     * 
     * @type {RoomOptions}
     * @memberof RoomUpdateRequest
     */
    room: RoomOptions;
}
/**
 * 
 * @export
 * @interface RosterDay
 */
export interface RosterDay {
    /**
     * 
     * @type {string}
     * @memberof RosterDay
     */
    day?: string;
    /**
     * 
     * @type {string}
     * @memberof RosterDay
     */
    holidayName?: string | null;
    /**
     * 
     * @type {Array<TimeTableLesson>}
     * @memberof RosterDay
     */
    data: Array<TimeTableLesson>;
}
/**
 * 
 * @export
 * @interface School
 */
export interface School {
    /**
     * 
     * @type {string}
     * @memberof School
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof School
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof School
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface SchoolContact
 */
export interface SchoolContact {
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    federalState?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    mailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolContact
     */
    zipCode?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolEventMapping
 */
export interface SchoolEventMapping {
    /**
     * 
     * @type {string}
     * @memberof SchoolEventMapping
     */
    sourceText: string;
    /**
     * 
     * @type {string}
     * @memberof SchoolEventMapping
     */
    targetText?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolEventMappingsResponse
 */
export interface SchoolEventMappingsResponse {
    /**
     * 
     * @type {Array<SchoolEventMapping>}
     * @memberof SchoolEventMappingsResponse
     */
    mappings?: Array<SchoolEventMapping> | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkCreateRequest
 */
export interface SchoolLinkCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SchoolLinkCreateRequest
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    listId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkCreateRequest
     */
    url?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkDeleteRequest
 */
export interface SchoolLinkDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkDeleteRequest
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkDeleteRequest
     */
    listId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkDeleteRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface SchoolLinkFaviconResponse
 */
export interface SchoolLinkFaviconResponse {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkFaviconResponse
     */
    dataUrl?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkGetListRequest
 */
export interface SchoolLinkGetListRequest {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkGetListRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface SchoolLinkGetRequest
 */
export interface SchoolLinkGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkGetRequest
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkGetRequest
     */
    listId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkGetRequest
     */
    organizationId?: string;
}
/**
 * 
 * @export
 * @interface SchoolLinkListResponse
 */
export interface SchoolLinkListResponse {
    /**
     * 
     * @type {number}
     * @memberof SchoolLinkListResponse
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkListResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkListResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkListResponse
     */
    url?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkResponse
 */
export interface SchoolLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkResponse
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkResponse
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SchoolLinkResponse
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkResponse
     */
    url?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkUpdateRequest
 */
export interface SchoolLinkUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SchoolLinkUpdateRequest
     */
    isFavorite?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    listId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequest
     */
    id?: string | null;
}
/**
 * 
 * @export
 * @interface SchoolLinkUpdateRequestAllOf
 */
export interface SchoolLinkUpdateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof SchoolLinkUpdateRequestAllOf
     */
    id?: string | null;
}
/**
 * 
 * @export
 * @interface SeatEntry
 */
export interface SeatEntry {
    /**
     * 
     * @type {boolean}
     * @memberof SeatEntry
     */
    canMove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeatEntry
     */
    canSwap?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeatEntry
     */
    posX: number;
    /**
     * 
     * @type {number}
     * @memberof SeatEntry
     */
    posY: number;
    /**
     * 
     * @type {StudentIdOnly}
     * @memberof SeatEntry
     */
    student: StudentIdOnly;
}
/**
 * 
 * @export
 * @interface SeatEntryResponse
 */
export interface SeatEntryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SeatEntryResponse
     */
    canMove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeatEntryResponse
     */
    canSwap?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeatEntryResponse
     */
    posX: number;
    /**
     * 
     * @type {number}
     * @memberof SeatEntryResponse
     */
    posY: number;
    /**
     * 
     * @type {Person}
     * @memberof SeatEntryResponse
     */
    student: Person;
}
/**
 * 
 * @export
 * @interface SeatingPlanEntry
 */
export interface SeatingPlanEntry {
    /**
     * 
     * @type {BoardPosition}
     * @memberof SeatingPlanEntry
     */
    board: BoardPosition;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanEntry
     */
    dimensionX: number;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanEntry
     */
    dimensionY: number;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanEntry
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanEntry
     */
    name: string;
    /**
     * 
     * @type {Array<SeatEntry>}
     * @memberof SeatingPlanEntry
     */
    seats: Array<SeatEntry>;
}
/**
 * 
 * @export
 * @interface SeatingPlanNameResponse
 */
export interface SeatingPlanNameResponse {
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanNameResponse
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanNameResponse
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SeatingPlanResponse
 */
export interface SeatingPlanResponse {
    /**
     * 
     * @type {BoardPosition}
     * @memberof SeatingPlanResponse
     */
    board: BoardPosition;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanResponse
     */
    dimensionX: number;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanResponse
     */
    dimensionY: number;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanResponse
     */
    id: string;
    /**
     * 
     * @type {PlanLinkage}
     * @memberof SeatingPlanResponse
     */
    myRelation?: PlanLinkage;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanResponse
     */
    name: string;
    /**
     * 
     * @type {Array<SeatEntryResponse>}
     * @memberof SeatingPlanResponse
     */
    seats: Array<SeatEntryResponse>;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanResponse
     */
    predecessorId?: string | null;
}
/**
 * 
 * @export
 * @interface SeatingPlanUpdateEntry
 */
export interface SeatingPlanUpdateEntry {
    /**
     * 
     * @type {BoardPosition}
     * @memberof SeatingPlanUpdateEntry
     */
    board: BoardPosition;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanUpdateEntry
     */
    dimensionX: number;
    /**
     * 
     * @type {number}
     * @memberof SeatingPlanUpdateEntry
     */
    dimensionY: number;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanUpdateEntry
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanUpdateEntry
     */
    name: string;
    /**
     * 
     * @type {Array<SeatEntry>}
     * @memberof SeatingPlanUpdateEntry
     */
    seats: Array<SeatEntry>;
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanUpdateEntry
     */
    id: string;
}
/**
 * 
 * @export
 * @interface SeatingPlanUpdateEntryAllOf
 */
export interface SeatingPlanUpdateEntryAllOf {
    /**
     * 
     * @type {string}
     * @memberof SeatingPlanUpdateEntryAllOf
     */
    id: string;
}
/**
 * 
 * @export
 * @interface SecurityManager
 */
export interface SecurityManager {
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManager
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface SecurityManagerModel
 */
export interface SecurityManagerModel {
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerModel
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface SecurityManagerResponse
 */
export interface SecurityManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityManagerResponse
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Sequence {
    default = 'Default',
    descending = 'Descending',
    ascending = 'Ascending'
}

/**
 * 
 * @export
 * @interface SetPrimaryContactForWardBody
 */
export interface SetPrimaryContactForWardBody {
    /**
     * the student for which we shall set the primary contact
     * @type {string}
     * @memberof SetPrimaryContactForWardBody
     */
    wardId: string;
    /**
     * ID of the guardian contact to set as primary
     * @type {string}
     * @memberof SetPrimaryContactForWardBody
     */
    guardianContactId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Severity {
    unknown = 'Unknown',
    pending = 'Pending',
    running = 'Running',
    failed = 'Failed',
    succeeded = 'Succeeded'
}

/**
 * 
 * @export
 * @interface ShareContent
 */
export interface ShareContent {
    /**
     * 
     * @type {string}
     * @memberof ShareContent
     */
    fileId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareContent
     */
    recipients?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShareContent
     */
    shareWithOrganization: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SignLevel {
    all = 'All',
    classTeacher = 'ClassTeacher',
    gradeOwner = 'GradeOwner',
    schoolHead = 'SchoolHead'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SignOffRequirement {
    none = 'None',
    any = 'Any',
    all = 'All'
}

/**
 * 
 * @export
 * @interface SignOffsResponse
 */
export interface SignOffsResponse {
    /**
     * 
     * @type {SignatureWithRequirement}
     * @memberof SignOffsResponse
     */
    current: SignatureWithRequirement;
    /**
     * 
     * @type {Array<SignatureWithRequirement>}
     * @memberof SignOffsResponse
     */
    previous: Array<SignatureWithRequirement>;
}
/**
 * 
 * @export
 * @interface Signature
 */
export interface Signature {
    /**
     * 
     * @type {string}
     * @memberof Signature
     */
    signedAt?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof Signature
     */
    signer?: Person | null;
}
/**
 * 
 * @export
 * @interface SignatureWithRequirement
 */
export interface SignatureWithRequirement {
    /**
     * 
     * @type {boolean}
     * @memberof SignatureWithRequirement
     */
    fulfilled: boolean;
    /**
     * 
     * @type {Array<Signature>}
     * @memberof SignatureWithRequirement
     */
    signatures: Array<Signature>;
    /**
     * 
     * @type {SignOffRequirement}
     * @memberof SignatureWithRequirement
     */
    signOffRequirement: SignOffRequirement;
}
/**
 * 
 * @export
 * @interface SoftwareInquiryEmailEntry
 */
export interface SoftwareInquiryEmailEntry {
    /**
     * 
     * @type {string}
     * @memberof SoftwareInquiryEmailEntry
     */
    softwareName: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareInquiryEmailEntry
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareInquiryEmailEntry
     */
    os: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SoftwareInquiryEmailEntry
     */
    groupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SoftwareInquiryEmailEntry
     */
    downloadLink: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareInquiryEmailEntry
     */
    licenseInformation: string;
}
/**
 * 
 * @export
 * @interface SoftwareResponse
 */
export interface SoftwareResponse {
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    publisher?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    operatingSystem: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareResponse
     */
    category?: string | null;
    /**
     * 
     * @type {Array<BasicMdmGroupResponse>}
     * @memberof SoftwareResponse
     */
    mdmGroups?: Array<BasicMdmGroupResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SoftwareStatus {
    notApplicable = 'NotApplicable',
    installed = 'Installed',
    failed = 'Failed',
    notInstalled = 'NotInstalled',
    uninstallFailed = 'UninstallFailed',
    pendingInstall = 'PendingInstall',
    unknown = 'Unknown'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SortableBy {
    default = 'Default',
    firstName = 'FirstName',
    lastName = 'LastName',
    gradeName = 'GradeName',
    className = 'ClassName'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StandardButton {
    none = 'None',
    accepted = 'Accepted',
    declined = 'Declined'
}

/**
 * 
 * @export
 * @interface StoreLinkResponse
 */
export interface StoreLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof StoreLinkResponse
     */
    link?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StructuralChangeKind {
    unknown = 'Unknown',
    userImport = 'UserImport',
    timePeriodSwitch = 'TimePeriodSwitch',
    timetableImport = 'TimetableImport',
    azureGroupAssignment = 'AzureGroupAssignment',
    ownershipRepair = 'OwnershipRepair',
    hybridReconciliation = 'HybridReconciliation'
}

/**
 * Tells the frontend whether a structural change (user import, time period switch, timetable import, ...) is currently running for the organization. Used to show a hint that another change may take longer.
 * @export
 * @interface StructuralChangeStatusResponse
 */
export interface StructuralChangeStatusResponse {
    /**
     * True while a structural change is running.
     * @type {boolean}
     * @memberof StructuralChangeStatusResponse
     */
    isRunning?: boolean;
    /**
     * What is running. Only set when IsRunning is true.
     * @type {StructuralChangeKind}
     * @memberof StructuralChangeStatusResponse
     */
    kind?: StructuralChangeKind | null;
    /**
     * When the running change started (UTC). Only set when IsRunning is true.
     * @type {string}
     * @memberof StructuralChangeStatusResponse
     */
    startedAt?: string | null;
}
/**
 * 
 * @export
 * @interface Student
 */
export interface Student {
    /**
     * id of the student
     * @type {string}
     * @memberof Student
     */
    studentId: string;
    /**
     * first name of the student
     * @type {string}
     * @memberof Student
     */
    firstName: string;
    /**
     * last name of the student
     * @type {string}
     * @memberof Student
     */
    lastName: string;
    /**
     * grades of the student
     * @type {Array<Recipient>}
     * @memberof Student
     */
    grades?: Array<Recipient>;
    /**
     * classes of the student
     * @type {Array<Recipient>}
     * @memberof Student
     */
    classes?: Array<Recipient>;
}
/**
 * 
 * @export
 * @interface StudentAbsenceDetailed
 */
export interface StudentAbsenceDetailed {
    /**
     * 
     * @type {Array<ClassBasicResponse>}
     * @memberof StudentAbsenceDetailed
     */
    classes: Array<ClassBasicResponse>;
    /**
     * 
     * @type {Array<GradeBasicResponse>}
     * @memberof StudentAbsenceDetailed
     */
    grades: Array<GradeBasicResponse>;
    /**
     * 
     * @type {Array<MonthlyStatistics>}
     * @memberof StudentAbsenceDetailed
     */
    monthlyStatistics: Array<MonthlyStatistics>;
    /**
     * 
     * @type {Person}
     * @memberof StudentAbsenceDetailed
     */
    student: Person;
}
/**
 * 
 * @export
 * @interface StudentAbsenceOverview
 */
export interface StudentAbsenceOverview {
    /**
     * Meant for the most recent absence, not all
     * @type {AbsenceState}
     * @memberof StudentAbsenceOverview
     */
    absenceState?: AbsenceState;
    /**
     * 
     * @type {AbsenceReasonCategory}
     * @memberof StudentAbsenceOverview
     */
    absenceReasonCategory?: AbsenceReasonCategory;
    /**
     * 
     * @type {boolean}
     * @memberof StudentAbsenceOverview
     */
    includeInStatistics?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceOverview
     */
    className?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceOverview
     */
    gradeName?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof StudentAbsenceOverview
     */
    student: Person;
}
/**
 * 
 * @export
 * @interface StudentAbsenceTimetableFormatAbsenceResponse
 */
export interface StudentAbsenceTimetableFormatAbsenceResponse {
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    end?: string;
    /**
     * 
     * @type {Audit}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    created?: Audit | null;
    /**
     * 
     * @type {Audit}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    modified?: Audit | null;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    description?: string | null;
    /**
     * 
     * @type {AbsenceReasonEmbedded}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    reason?: AbsenceReasonEmbedded | null;
    /**
     * 
     * @type {AbsenceState}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    state?: AbsenceState;
    /**
     * 
     * @type {TimeSlot}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    timeSlotEnd?: TimeSlot | null;
    /**
     * 
     * @type {TimeSlot}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    timeSlotStart?: TimeSlot | null;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    offset?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    effectiveMissing?: string;
    /**
     * 
     * @type {number}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    effectiveMissingLessons?: number;
    /**
     * 
     * @type {Array<CourseBasicResponse>}
     * @memberof StudentAbsenceTimetableFormatAbsenceResponse
     */
    affectedCourses?: Array<CourseBasicResponse> | null;
}
/**
 * 
 * @export
 * @interface StudentAbsenceTimetableFormatResponse
 */
export interface StudentAbsenceTimetableFormatResponse {
    /**
     * 
     * @type {string}
     * @memberof StudentAbsenceTimetableFormatResponse
     */
    day?: string;
    /**
     * 
     * @type {Array<StudentAbsenceTimetableFormatAbsenceResponse>}
     * @memberof StudentAbsenceTimetableFormatResponse
     */
    absences?: Array<StudentAbsenceTimetableFormatAbsenceResponse> | null;
}
/**
 * 
 * @export
 * @interface StudentAbsenceTimetableResponse
 */
export interface StudentAbsenceTimetableResponse {
    /**
     * 
     * @type {Array<StudentAbsenceTimetableFormatResponse>}
     * @memberof StudentAbsenceTimetableResponse
     */
    timetable: Array<StudentAbsenceTimetableFormatResponse>;
    /**
     * 
     * @type {Person}
     * @memberof StudentAbsenceTimetableResponse
     */
    student: Person;
}
/**
 * 
 * @export
 * @interface StudentIdOnly
 */
export interface StudentIdOnly {
    /**
     * 
     * @type {string}
     * @memberof StudentIdOnly
     */
    id: string;
}
/**
 * Body of the student report request.
 * @export
 * @interface StudentReportRequest
 */
export interface StudentReportRequest {
    /**
     * ID of the student the report is generated for
     * @type {string}
     * @memberof StudentReportRequest
     */
    studentId: string;
    /**
     * Start of the report period
     * @type {string}
     * @memberof StudentReportRequest
     */
    from: string;
    /**
     * End of the report period
     * @type {string}
     * @memberof StudentReportRequest
     */
    to: string;
    /**
     * Time zone identifier, e.g. \"W. Europe Standard Time\" or \"Europe/Berlin\"
     * @type {string}
     * @memberof StudentReportRequest
     */
    timeZone: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StudentSortCriteria {
    firstName = 'FirstName',
    lastName = 'LastName'
}

/**
 * 
 * @export
 * @interface StudentWithGuardianContacts
 */
export interface StudentWithGuardianContacts {
    /**
     * id of the student
     * @type {string}
     * @memberof StudentWithGuardianContacts
     */
    studentId: string;
    /**
     * first name of the student
     * @type {string}
     * @memberof StudentWithGuardianContacts
     */
    firstName: string;
    /**
     * last name of the student
     * @type {string}
     * @memberof StudentWithGuardianContacts
     */
    lastName: string;
    /**
     * grades of the student
     * @type {Array<Recipient>}
     * @memberof StudentWithGuardianContacts
     */
    grades?: Array<Recipient>;
    /**
     * classes of the student
     * @type {Array<Recipient>}
     * @memberof StudentWithGuardianContacts
     */
    classes?: Array<Recipient>;
    /**
     * guardian contacts of the student
     * @type {Array<GuardianContact>}
     * @memberof StudentWithGuardianContacts
     */
    guardianContacts: Array<GuardianContact>;
}
/**
 * 
 * @export
 * @interface StudentWithGuardianContactsAllOf
 */
export interface StudentWithGuardianContactsAllOf {
    /**
     * guardian contacts of the student
     * @type {Array<GuardianContact>}
     * @memberof StudentWithGuardianContactsAllOf
     */
    guardianContacts: Array<GuardianContact>;
}
/**
 * 
 * @export
 * @interface StudentWithPrimaryGuardianContact
 */
export interface StudentWithPrimaryGuardianContact {
    /**
     * id of the student
     * @type {string}
     * @memberof StudentWithPrimaryGuardianContact
     */
    studentId: string;
    /**
     * first name of the student
     * @type {string}
     * @memberof StudentWithPrimaryGuardianContact
     */
    firstName: string;
    /**
     * last name of the student
     * @type {string}
     * @memberof StudentWithPrimaryGuardianContact
     */
    lastName: string;
    /**
     * grades of the student
     * @type {Array<Recipient>}
     * @memberof StudentWithPrimaryGuardianContact
     */
    grades?: Array<Recipient>;
    /**
     * classes of the student
     * @type {Array<Recipient>}
     * @memberof StudentWithPrimaryGuardianContact
     */
    classes?: Array<Recipient>;
    /**
     * primary guardian contact of the student
     * @type {GuardianContact}
     * @memberof StudentWithPrimaryGuardianContact
     */
    primaryGuardianContact?: GuardianContact | null;
    /**
     * 
     * @type {FitlerByConnectedGuardians}
     * @memberof StudentWithPrimaryGuardianContact
     */
    guardianConnectionStatus?: FitlerByConnectedGuardians;
}
/**
 * 
 * @export
 * @interface StudentWithPrimaryGuardianContactAllOf
 */
export interface StudentWithPrimaryGuardianContactAllOf {
    /**
     * primary guardian contact of the student
     * @type {GuardianContact}
     * @memberof StudentWithPrimaryGuardianContactAllOf
     */
    primaryGuardianContact?: GuardianContact | null;
    /**
     * 
     * @type {FitlerByConnectedGuardians}
     * @memberof StudentWithPrimaryGuardianContactAllOf
     */
    guardianConnectionStatus?: FitlerByConnectedGuardians;
}
/**
 * 
 * @export
 * @interface SubmitAbsenceDraftRequest
 */
export interface SubmitAbsenceDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    studentId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    end: string;
    /**
     * 
     * @type {number}
     * @memberof SubmitAbsenceDraftRequest
     */
    timeSlotStartCardinalNumber: number;
    /**
     * 
     * @type {number}
     * @memberof SubmitAbsenceDraftRequest
     */
    timeSlotEndCardinalNumber: number;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    parentDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitAbsenceDraftRequest
     */
    parentMailAddress: string;
}
/**
 * 
 * @export
 * @interface Substitution
 */
export interface Substitution {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof Substitution
     */
    day?: DayOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof Substitution
     */
    exam?: boolean;
    /**
     * 
     * @type {Array<SubstitutionMotive>}
     * @memberof Substitution
     */
    motive: Array<SubstitutionMotive>;
    /**
     * 
     * @type {TimeTableLesson}
     * @memberof Substitution
     */
    originLesson?: TimeTableLesson | null;
    /**
     * 
     * @type {number}
     * @memberof Substitution
     */
    cardinalNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof Substitution
     */
    remark?: string | null;
    /**
     * 
     * @type {LessonState}
     * @memberof Substitution
     */
    state?: LessonState;
    /**
     * 
     * @type {TimeTableLesson}
     * @memberof Substitution
     */
    substitutionLesson?: TimeTableLesson | null;
}
/**
 * 
 * @export
 * @interface SubstitutionCreate
 */
export interface SubstitutionCreate {
    /**
     * 
     * @type {Array<SubstitutionMotive>}
     * @memberof SubstitutionCreate
     */
    motive: Array<SubstitutionMotive>;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionCreate
     */
    remark?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionCreate
     */
    teacherId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionCreate
     */
    roomId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionCreate
     */
    moveTo?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SubstitutionMotive {
    unknown = 'Unknown',
    cancellation = 'Cancellation',
    supervision = 'Supervision',
    shiftedFrom = 'ShiftedFrom',
    release = 'Release',
    shiftedTo = 'ShiftedTo',
    standIn = 'StandIn',
    roomExchange = 'RoomExchange',
    noLesson = 'NoLesson',
    notOccurringMotives = 'NotOccurringMotives',
    exam = 'Exam'
}

/**
 * 
 * @export
 * @interface SubstitutionResponse
 */
export interface SubstitutionResponse {
    /**
     * 
     * @type {SubstitutionMotive}
     * @memberof SubstitutionResponse
     */
    motive: SubstitutionMotive;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionResponse
     */
    remark?: string | null;
    /**
     * 
     * @type {RoomResponse}
     * @memberof SubstitutionResponse
     */
    room?: RoomResponse | null;
    /**
     * 
     * @type {Person}
     * @memberof SubstitutionResponse
     */
    teacher?: Person | null;
}
/**
 * 
 * @export
 * @interface SubstitutionsGetRequest
 */
export interface SubstitutionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SubstitutionsGetRequest
     */
    start?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubstitutionsGetRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TaskState
 */
export interface TaskState {
    /**
     * 
     * @type {number}
     * @memberof TaskState
     */
    percentDone?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskState
     */
    message?: string | null;
    /**
     * 
     * @type {Severity}
     * @memberof TaskState
     */
    severity?: Severity;
    /**
     * 
     * @type {string}
     * @memberof TaskState
     */
    startTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskState
     */
    totalCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskState
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskState
     */
    jobName?: string | null;
}
/**
 * 
 * @export
 * @interface TaskStateGetRequest
 */
export interface TaskStateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TaskStateGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskStateGetRequest
     */
    organizationId?: string | null;
}
/**
 * 
 * @export
 * @interface TaskStateResponse
 */
export interface TaskStateResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskStateResponse
     */
    percentDone?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    message?: string | null;
    /**
     * 
     * @type {Severity}
     * @memberof TaskStateResponse
     */
    severity?: Severity;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    startTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskStateResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    jobName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponse
     */
    endTimeApprox?: string | null;
}
/**
 * 
 * @export
 * @interface TaskStateResponseAllOf
 */
export interface TaskStateResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponseAllOf
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskStateResponseAllOf
     */
    endTimeApprox?: string | null;
}
/**
 * 
 * @export
 * @interface TeamsProfileResponse
 */
export interface TeamsProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    userPrincipalName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    displayName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamsProfileResponse
     */
    role: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsProfileResponse
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface TemplateEmbedded
 */
export interface TemplateEmbedded {
    /**
     * 
     * @type {string}
     * @memberof TemplateEmbedded
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEmbedded
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface TenantCredentialsResponse
 */
export interface TenantCredentialsResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantCredentialsResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCredentialsResponse
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCredentialsResponse
     */
    resource: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCredentialsResponse
     */
    endpointUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCredentialsResponse
     */
    expirationDateUtc: string;
    /**
     * 
     * @type {Array<RecentRequest>}
     * @memberof TenantCredentialsResponse
     */
    recentRequests: Array<RecentRequest>;
}
/**
 * Result of starting tenant initialization. JobId equals the tenant id and is the value the client uses to poll api/v2/{organizationId}/TaskStates/{jobId}.
 * @export
 * @interface TenantInitResponse
 */
export interface TenantInitResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantInitResponse
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantInitResponse
     */
    jobId?: string;
}
/**
 * 
 * @export
 * @interface TenantResponse
 */
export interface TenantResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    partnerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantResponse
     */
    invitationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantResponse
     */
    organizations: Array<string>;
    /**
     * 
     * @type {Array<LicenseInfo>}
     * @memberof TenantResponse
     */
    availableLicenses: Array<LicenseInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantResponse
     */
    domains: Array<string>;
}
/**
 * 
 * @export
 * @interface TenantSearchResponse
 */
export interface TenantSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantSearchResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearchResponse
     */
    name?: string | null;
    /**
     * 
     * @type {InvitationSearchResponse}
     * @memberof TenantSearchResponse
     */
    invitation?: InvitationSearchResponse | null;
    /**
     * 
     * @type {Array<OrganizationSearchResponse>}
     * @memberof TenantSearchResponse
     */
    organizations?: Array<OrganizationSearchResponse> | null;
}
/**
 * 
 * @export
 * @interface TenantUpdateRequest
 */
export interface TenantUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateRequest
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantUpdateRequest
     */
    partnerId: string;
}
/**
 * 
 * @export
 * @interface TilePosition
 */
export interface TilePosition {
    /**
     * 
     * @type {string}
     * @memberof TilePosition
     */
    route?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TilePosition
     */
    routeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TilePosition
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof TilePosition
     */
    y?: number;
    /**
     * 
     * @type {number}
     * @memberof TilePosition
     */
    cols?: number;
    /**
     * 
     * @type {number}
     * @memberof TilePosition
     */
    rows?: number;
}
/**
 * 
 * @export
 * @interface TimePatternRequest
 */
export interface TimePatternRequest {
    /**
     * 
     * @type {Array<TimeSlotRequest>}
     * @memberof TimePatternRequest
     */
    breaks: Array<TimeSlotRequest>;
    /**
     * 
     * @type {Array<TimeSlotRequest>}
     * @memberof TimePatternRequest
     */
    slots: Array<TimeSlotRequest>;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof TimePatternRequest
     */
    weekdays: Array<DayOfWeek>;
}
/**
 * 
 * @export
 * @interface TimePatternRequestWithId
 */
export interface TimePatternRequestWithId {
    /**
     * 
     * @type {Array<TimeSlotRequest>}
     * @memberof TimePatternRequestWithId
     */
    breaks: Array<TimeSlotRequest>;
    /**
     * 
     * @type {Array<TimeSlotRequest>}
     * @memberof TimePatternRequestWithId
     */
    slots: Array<TimeSlotRequest>;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof TimePatternRequestWithId
     */
    weekdays: Array<DayOfWeek>;
    /**
     * 
     * @type {string}
     * @memberof TimePatternRequestWithId
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface TimePatternRequestWithIdAllOf
 */
export interface TimePatternRequestWithIdAllOf {
    /**
     * 
     * @type {string}
     * @memberof TimePatternRequestWithIdAllOf
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface TimePatternResponse
 */
export interface TimePatternResponse {
    /**
     * 
     * @type {string}
     * @memberof TimePatternResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TimePatternResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<TimeSlotResponse>}
     * @memberof TimePatternResponse
     */
    slots: Array<TimeSlotResponse>;
    /**
     * 
     * @type {TimePatternSource}
     * @memberof TimePatternResponse
     */
    source: TimePatternSource;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof TimePatternResponse
     */
    weekdays: Array<DayOfWeek>;
    /**
     * 
     * @type {string}
     * @memberof TimePatternResponse
     */
    predecessorId: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum TimePatternSource {
    unknown = 'Unknown',
    external = 'External',
    manual = 'Manual'
}

/**
 * 
 * @export
 * @interface TimeSlot
 */
export interface TimeSlot {
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlot
     */
    period?: number;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    start?: string;
}
/**
 * 
 * @export
 * @interface TimeSlotRequest
 */
export interface TimeSlotRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeSlotRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotRequest
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotRequest
     */
    end: string;
}
/**
 * 
 * @export
 * @interface TimeSlotResponse
 */
export interface TimeSlotResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeSlotResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotResponse
     */
    period: number;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotResponse
     */
    start: string;
}
/**
 * 
 * @export
 * @interface TimeTableAzureGroupNamesRequest
 */
export interface TimeTableAzureGroupNamesRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeTableAzureGroupNamesRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableAzureGroupNamesRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableClassRegisterNamesRequest
 */
export interface TimeTableClassRegisterNamesRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeTableClassRegisterNamesRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableClassRegisterNamesRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableGetAllRoomsRequest
 */
export interface TimeTableGetAllRoomsRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeTableGetAllRoomsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableGetAllRoomsRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableLesson
 */
export interface TimeTableLesson {
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    azureId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TimeTableLesson
     */
    classes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    to?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TimeTableLesson
     */
    exam?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TimeTableLesson
     */
    event?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    lessonId?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    multiLessonId?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof TimeTableLesson
     */
    cardinalNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    room?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    roomId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    from?: string;
    /**
     * 
     * @type {LessonState}
     * @memberof TimeTableLesson
     */
    state?: LessonState;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    teacher?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeTableLesson
     */
    teacherMail?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableLessonWithSubstitution
 */
export interface TimeTableLessonWithSubstitution {
    /**
     * 
     * @type {TimeTableLesson}
     * @memberof TimeTableLessonWithSubstitution
     */
    lesson: TimeTableLesson;
    /**
     * 
     * @type {Substitution}
     * @memberof TimeTableLessonWithSubstitution
     */
    substitution?: Substitution | null;
}
/**
 * 
 * @export
 * @interface TimeTableMappingsRequest
 */
export interface TimeTableMappingsRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeTableMappingsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableMappingsRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableOfGroupGetRequest
 */
export interface TimeTableOfGroupGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TimeTableOfGroupGetRequest
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfGroupGetRequest
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfGroupGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfGroupGetRequest
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfGroupGetRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableOfRoomGetRequest
 */
export interface TimeTableOfRoomGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TimeTableOfRoomGetRequest
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfRoomGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfRoomGetRequest
     */
    roomId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfRoomGetRequest
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfRoomGetRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableOfUserGetRequest
 */
export interface TimeTableOfUserGetRequest {
    /**
     * 
     * @type {number}
     * @memberof TimeTableOfUserGetRequest
     */
    days: number;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfUserGetRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfUserGetRequest
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfUserGetRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeTableOfUserGetRequest
     */
    timePeriod?: string | null;
}
/**
 * 
 * @export
 * @interface TimeTableOverview
 */
export interface TimeTableOverview {
    /**
     * 
     * @type {string}
     * @memberof TimeTableOverview
     */
    creationTimestamp?: string;
    /**
     * 
     * @type {Array<LessonsBreak>}
     * @memberof TimeTableOverview
     */
    breakInformation?: Array<LessonsBreak>;
    /**
     * 
     * @type {number}
     * @memberof TimeTableOverview
     */
    maxHoursOfWeek?: number;
    /**
     * 
     * @type {Array<LessonPattern>}
     * @memberof TimeTableOverview
     */
    scaffoldData?: Array<LessonPattern>;
    /**
     * 
     * @type {Array<RosterDay>}
     * @memberof TimeTableOverview
     */
    timeTableData?: Array<RosterDay>;
    /**
     * 
     * @type {Array<Substitution>}
     * @memberof TimeTableOverview
     */
    substitutions?: Array<Substitution>;
}
/**
 * 
 * @export
 * @interface TimeTableSettings
 */
export interface TimeTableSettings {
    /**
     * 
     * @type {number}
     * @memberof TimeTableSettings
     */
    maximumTimeTableForeseeingWeeks?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeTableSettings
     */
    maximumTimeTableForeseeingWeeksMaxValue?: number;
}
/**
 * 
 * @export
 * @interface TimeTableSubstitutionsOfMeResponse
 */
export interface TimeTableSubstitutionsOfMeResponse {
    /**
     * 
     * @type {string}
     * @memberof TimeTableSubstitutionsOfMeResponse
     */
    creationTimeStamp?: string;
    /**
     * 
     * @type {Array<Substitution>}
     * @memberof TimeTableSubstitutionsOfMeResponse
     */
    substitutions?: Array<Substitution> | null;
}
/**
 * 
 * @export
 * @interface TimeTableUpdateSettings
 */
export interface TimeTableUpdateSettings {
    /**
     * 
     * @type {number}
     * @memberof TimeTableUpdateSettings
     */
    maximumTimeTableForeseeingWeeks: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Type {
    class = 'Class',
    course = 'Course'
}

/**
 * 
 * @export
 * @interface UnclarifiedLessonResponse
 */
export interface UnclarifiedLessonResponse {
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    lessonId: string;
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    end: string;
    /**
     * 
     * @type {TimeSlot}
     * @memberof UnclarifiedLessonResponse
     */
    timeSlot: TimeSlot;
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    courseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    courseName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnclarifiedLessonResponse
     */
    multiLessonId?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum UnsignedFilterType {
    none = 'None',
    allUnsignedByGivenUser = 'AllUnsignedByGivenUser',
    allSignedExceptGivenUser = 'AllSignedExceptGivenUser',
    someMissingExceptGivenUser = 'SomeMissingExceptGivenUser',
    someMissingIgnoringGivenUser = 'SomeMissingIgnoringGivenUser'
}

/**
 * 
 * @export
 * @interface UpdateAppointmentRequestBody
 */
export interface UpdateAppointmentRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    end?: string;
    /**
     * Null if the whole school should be the recipient
     * @type {Array<string>}
     * @memberof UpdateAppointmentRequestBody
     */
    recipients?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequestBody
     */
    isAllDay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequestBody
     */
    timeZone: string;
}
/**
 * 
 * @export
 * @interface UpdateGuardianContactBody
 */
export interface UpdateGuardianContactBody {
    /**
     * display name of the guardian contact
     * @type {string}
     * @memberof UpdateGuardianContactBody
     */
    displayName: string;
    /**
     * email of the guardian contact
     * @type {string}
     * @memberof UpdateGuardianContactBody
     */
    email: string;
    /**
     * array of phonenumbers of the guardian contact
     * @type {Array<string>}
     * @memberof UpdateGuardianContactBody
     */
    phoneNumbers?: Array<string>;
    /**
     * address of the guardian contact
     * @type {string}
     * @memberof UpdateGuardianContactBody
     */
    address?: string | null;
    /**
     * relationship between the guardian contact and the user
     * @type {Relationship}
     * @memberof UpdateGuardianContactBody
     */
    relationship?: Relationship;
    /**
     * flag indicating if the guardian contact is the primary contact
     * @type {boolean}
     * @memberof UpdateGuardianContactBody
     */
    isPrimaryContact?: boolean;
    /**
     * Required together with CanAutoConnect.
     * @type {string}
     * @memberof UpdateGuardianContactBody
     */
    studentId?: string | null;
    /**
     * Null leaves the flag untouched.
     * @type {boolean}
     * @memberof UpdateGuardianContactBody
     */
    canAutoConnect?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateGuardianRequest
 */
export interface UpdateGuardianRequest {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UpdateGuardianRequest
     */
    organizationIdWithStudents?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof UpdateGuardianRequest
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGuardianRequest
     */
    mailAddress: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGuardianRequest
     */
    mobilePhoneNumbers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGuardianRequest
     */
    isEmergencyContact?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateNotificationBody
 */
export interface UpdateNotificationBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationBody
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationBody
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNotificationBody
     */
    recipients?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNotificationBody
     */
    attachments?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationBody
     */
    publishDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationBody
     */
    pushNotification?: boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof User
     */
    role?: Array<UserRole>;
    /**
     * 
     * @type {UserMailAddress}
     * @memberof User
     */
    mailAddress?: UserMailAddress;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    immutableId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    referenceId?: string;
    /**
     * 
     * @type {Array<Guardian>}
     * @memberof User
     */
    guardians?: Array<Guardian>;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    accountEnabled?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserCreateOptions
 */
export interface UserCreateOptions {
    /**
     * 
     * @type {string}
     * @memberof UserCreateOptions
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateOptions
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateOptions
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateOptions
     */
    logonName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCreateOptions
     */
    referenceId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCreateOptions
     */
    mailAliases?: Array<string>;
    /**
     * 
     * @type {Array<Guardian>}
     * @memberof UserCreateOptions
     */
    guardians?: Array<Guardian> | null;
    /**
     * 
     * @type {UserPasswordOptions}
     * @memberof UserCreateOptions
     */
    passwordOptions?: UserPasswordOptions | null;
}
/**
 * 
 * @export
 * @interface UserEmbedded
 */
export interface UserEmbedded {
    /**
     * 
     * @type {string}
     * @memberof UserEmbedded
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbedded
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbedded
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @interface UserEmbeddedTemplateWithAccess
 */
export interface UserEmbeddedTemplateWithAccess {
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    displayName?: string;
    /**
     * 
     * @type {TemplateEmbedded}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    templateEmbedded?: TemplateEmbedded;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    role?: Array<UserRole>;
    /**
     * 
     * @type {UserMailAddress}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    mailAddress?: UserMailAddress;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    immutableId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    referenceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    withAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEmbeddedTemplateWithAccess
     */
    accountEnabled?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserGroupBaseEntity
 */
export interface UserGroupBaseEntity {
    /**
     * 
     * @type {string}
     * @memberof UserGroupBaseEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupBaseEntity
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface UserGroupCreateRequestBody
 */
export interface UserGroupCreateRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UserGroupCreateRequestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupCreateRequestBody
     */
    mailNickName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGroupCreateRequestBody
     */
    users: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserGroupCreateRequestBody
     */
    templateId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGroupCreateRequestBody
     */
    owners?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserGroupCreateRequestBody
     */
    periodIdentifier?: string | null;
}
/**
 * 
 * @export
 * @interface UserGroupGroupResponse
 */
export interface UserGroupGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupGroupResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupGroupResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupGroupResponse
     */
    mail?: string | null;
    /**
     * 
     * @type {GroupRole}
     * @memberof UserGroupGroupResponse
     */
    role?: GroupRole;
}
/**
 * 
 * @export
 * @interface UserGroupJoinRequestBody
 */
export interface UserGroupJoinRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UserGroupJoinRequestBody
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface UserGroupMergeRequestBody
 */
export interface UserGroupMergeRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UserGroupMergeRequestBody
     */
    newGroup: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupMergeRequestBody
     */
    deleteOldGroups: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGroupMergeRequestBody
     */
    oldGroups: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserGroupMergeRequestBody
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupMergeRequestBody
     */
    period: string;
}
/**
 * 
 * @export
 * @interface UserGroupResponse
 */
export interface UserGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    name: string;
    /**
     * 
     * @type {Array<UserGroupUserResponse>}
     * @memberof UserGroupResponse
     */
    users: Array<UserGroupUserResponse>;
    /**
     * 
     * @type {Array<UserGroupUserResponse>}
     * @memberof UserGroupResponse
     */
    owners?: Array<UserGroupUserResponse>;
    /**
     * 
     * @type {Array<UserGroupsDeviceResponse>}
     * @memberof UserGroupResponse
     */
    devices?: Array<UserGroupsDeviceResponse>;
    /**
     * 
     * @type {Array<UserGroupGroupResponse>}
     * @memberof UserGroupResponse
     */
    groups?: Array<UserGroupGroupResponse>;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    mailNickname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    deletedDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    createdDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponse
     */
    isInProvisioningTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponse
     */
    isDynamicGroup?: boolean;
    /**
     * 
     * @type {GroupRole}
     * @memberof UserGroupResponse
     */
    role?: GroupRole;
    /**
     * 
     * @type {Origin}
     * @memberof UserGroupResponse
     */
    origin?: Origin;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponse
     */
    allowOwners: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupResponseAllOf
 */
export interface UserGroupResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    name: string;
    /**
     * 
     * @type {Array<UserGroupUserResponse>}
     * @memberof UserGroupResponseAllOf
     */
    users: Array<UserGroupUserResponse>;
    /**
     * 
     * @type {Array<UserGroupUserResponse>}
     * @memberof UserGroupResponseAllOf
     */
    owners?: Array<UserGroupUserResponse>;
    /**
     * 
     * @type {Array<UserGroupsDeviceResponse>}
     * @memberof UserGroupResponseAllOf
     */
    devices?: Array<UserGroupsDeviceResponse>;
    /**
     * 
     * @type {Array<UserGroupGroupResponse>}
     * @memberof UserGroupResponseAllOf
     */
    groups?: Array<UserGroupGroupResponse>;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    mailNickname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    timePeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    deletedDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponseAllOf
     */
    createdDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponseAllOf
     */
    isInProvisioningTimeWindow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponseAllOf
     */
    isDynamicGroup?: boolean;
    /**
     * 
     * @type {GroupRole}
     * @memberof UserGroupResponseAllOf
     */
    role?: GroupRole;
    /**
     * 
     * @type {Origin}
     * @memberof UserGroupResponseAllOf
     */
    origin?: Origin;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupResponseAllOf
     */
    allowOwners: boolean;
}
/**
 * 
 * @export
 * @interface UserGroupStartSharePointSiteRenamingRequest
 */
export interface UserGroupStartSharePointSiteRenamingRequest {
    /**
     * 
     * @type {string}
     * @memberof UserGroupStartSharePointSiteRenamingRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface UserGroupTemplateResponse
 */
export interface UserGroupTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupTemplateResponse
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTemplateResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTemplateResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupTemplateResponse
     */
    domain: string;
}
/**
 * 
 * @export
 * @interface UserGroupUpdateRequestBody
 */
export interface UserGroupUpdateRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUpdateRequestBody
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUpdateRequestBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUpdateRequestBody
     */
    mailAddress?: string | null;
    /**
     * 
     * @type {Array<UserGroupUpdateRequestChanges>}
     * @memberof UserGroupUpdateRequestBody
     */
    userUpdate?: Array<UserGroupUpdateRequestChanges> | null;
}
/**
 * Deleted - Das angegebene Objekt (Id) wird gelöscht. Kann User, Gruppe oder Device sein. User - Das angegebene Objekt (Id) wird der Gruppe als Mitglied hinzugefügt. Kann User, Gruppe oder Device sein. Owner - Das angegebene Objekt (Id) wird der Gruppe als Owner hinzugefügt. Kann User sein.
 * @export
 * @enum {string}
 */
export enum UserGroupUpdateRequestChangeType {
    deleted = 'Deleted',
    user = 'User',
    owner = 'Owner'
}

/**
 * 
 * @export
 * @interface UserGroupUpdateRequestChanges
 */
export interface UserGroupUpdateRequestChanges {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUpdateRequestChanges
     */
    id?: string;
    /**
     * 
     * @type {UserGroupUpdateRequestChangeType}
     * @memberof UserGroupUpdateRequestChanges
     */
    changeType?: UserGroupUpdateRequestChangeType;
}
/**
 * 
 * @export
 * @interface UserGroupUserResponse
 */
export interface UserGroupUserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserResponse
     */
    userPrincipalName: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupUserResponse
     */
    lastName: string;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof UserGroupUserResponse
     */
    userRole?: Array<UserRole>;
}
/**
 * 
 * @export
 * @interface UserGroupsDeviceResponse
 */
export interface UserGroupsDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    operatingSystem: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupsDeviceResponse
     */
    operatingSystemVersion: string;
}
/**
 * 
 * @export
 * @interface UserInformations
 */
export interface UserInformations {
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    userPrincipalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    immutableId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    deletedDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    createdDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    usageLocation?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserInformations
     */
    userMustChangePasswordOnNextLogon?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInformations
     */
    licenses?: Array<string> | null;
    /**
     * 
     * @type {UserRole}
     * @memberof UserInformations
     */
    role?: UserRole;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInformations
     */
    referenceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserInformations
     */
    accountEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInformations
     */
    mailAliases?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserMailAddress
 */
export interface UserMailAddress {
    /**
     * 
     * @type {string}
     * @memberof UserMailAddress
     */
    primaryAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof UserMailAddress
     */
    mailNickname?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserMailAddress
     */
    aliases?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserPasswordOptions
 */
export interface UserPasswordOptions {
    /**
     * 
     * @type {string}
     * @memberof UserPasswordOptions
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPasswordOptions
     */
    userMustChangePasswordOnNextLogon?: boolean;
}
/**
 * 
 * @export
 * @interface UserPermission
 */
export interface UserPermission {
    /**
     * 
     * @type {string}
     * @memberof UserPermission
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPermission
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPermission
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPermission
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPermission
     */
    templateName?: string;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    mailAddress?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum UserRole {
    /**
    * NO_ROLE_STATE
    */
    none = 'None',
    /**
    * TEACHER_ROLE_STATE
    */
    teacher = 'Teacher',
    /**
    * STUDENT_ROLE_STATE
    */
    student = 'Student',
    /**
    * INTUNE_ADMIN_ROLE_STATE
    */
    intuneAdmin = 'IntuneAdmin',
    /**
    * TENANT_ADMIN_ROLE_STATE
    */
    tenantAdmin = 'TenantAdmin'
}

/**
 * 
 * @export
 * @interface UserSettings
 */
export interface UserSettings {
    /**
     * 
     * @type {Array<TilePosition>}
     * @memberof UserSettings
     */
    dashboardTiles?: Array<TilePosition> | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    theme?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    teamsTheme?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSettings
     */
    fullfilledHomework?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface UserTemplateAvailableLicenseResponse
 */
export interface UserTemplateAvailableLicenseResponse {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateAvailableLicenseResponse
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserTemplateAvailableLicenseResponse
     */
    paid?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTemplateAvailableLicenseResponse
     */
    consumed?: number;
}
/**
 * 
 * @export
 * @interface UserTemplateBaseEntity
 */
export interface UserTemplateBaseEntity {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateBaseEntity
     */
    id: string;
}
/**
 * 
 * @export
 * @interface UserTemplateCreateRequest
 */
export interface UserTemplateCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    emailPrefixRule: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateCreateRequest
     */
    licenses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateCreateRequest
     */
    permissionRoles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    predefinedPassword?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateCreateRequest
     */
    role?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateCreateRequest
     */
    usageLocation?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateCreateRequest
     */
    userGroups?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTemplateCreateRequest
     */
    userMustChangePasswordOnNextLogon?: boolean;
}
/**
 * 
 * @export
 * @interface UserTemplateDeleteResponse
 */
export interface UserTemplateDeleteResponse {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateDeleteResponse
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserTemplateDeleteResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {Array<UserInformations>}
     * @memberof UserTemplateDeleteResponse
     */
    users?: Array<UserInformations> | null;
}
/**
 * 
 * @export
 * @interface UserTemplateGetRequest
 */
export interface UserTemplateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface UserTemplatePermissionRoleResponse
 */
export interface UserTemplatePermissionRoleResponse {
    /**
     * 
     * @type {string}
     * @memberof UserTemplatePermissionRoleResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplatePermissionRoleResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplatePermissionRoleResponse
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface UserTemplateResponse
 */
export interface UserTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    id?: string;
    /**
     * 
     * @type {AgeGroup}
     * @memberof UserTemplateResponse
     */
    ageGroup?: AgeGroup;
    /**
     * 
     * @type {ConsentProvidedForMinor}
     * @memberof UserTemplateResponse
     */
    consentProvidedForMinor?: ConsentProvidedForMinor;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    emailPrefixRule?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateResponse
     */
    licenses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateResponse
     */
    permissionRoles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    predefinedPassword?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateResponse
     */
    role?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    usageLocation?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateResponse
     */
    userGroups?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTemplateResponse
     */
    userMustChangePasswordOnNextLogon?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateResponse
     */
    updateUserMembershipsJobId?: string | null;
}
/**
 * 
 * @export
 * @interface UserTemplateUpdateRequest
 */
export interface UserTemplateUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    emailPrefixRule: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequest
     */
    licenses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequest
     */
    permissionRoles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    predefinedPassword?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequest
     */
    role?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequest
     */
    usageLocation?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequest
     */
    userGroups?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTemplateUpdateRequest
     */
    userMustChangePasswordOnNextLogon?: boolean;
}
/**
 * 
 * @export
 * @interface UserTemplateUpdateRequestAllOf
 */
export interface UserTemplateUpdateRequestAllOf {
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    emailPrefixRule: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    licenses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    permissionRoles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    predefinedPassword?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    role?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    usageLocation?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    userGroups?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTemplateUpdateRequestAllOf
     */
    userMustChangePasswordOnNextLogon?: boolean;
}
/**
 * 
 * @export
 * @interface UserUpdateOptions
 */
export interface UserUpdateOptions {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateOptions
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateOptions
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateOptions
     */
    templateId?: string;
    /**
     * 
     * @type {UserMailAddress}
     * @memberof UserUpdateOptions
     */
    mailAddress?: UserMailAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUpdateOptions
     */
    targetGroups?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateOptions
     */
    referenceId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUpdateOptions
     */
    groupsToAdd?: Array<string>;
    /**
     * 
     * @type {Array<Guardian>}
     * @memberof UserUpdateOptions
     */
    guardians?: Array<Guardian> | null;
}
/**
 * 
 * @export
 * @interface UserWithEmbeddedTemplate
 */
export interface UserWithEmbeddedTemplate {
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    displayName?: string;
    /**
     * 
     * @type {TemplateEmbedded}
     * @memberof UserWithEmbeddedTemplate
     */
    templateEmbedded?: TemplateEmbedded;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    organizationId?: string;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof UserWithEmbeddedTemplate
     */
    role?: Array<UserRole>;
    /**
     * 
     * @type {UserMailAddress}
     * @memberof UserWithEmbeddedTemplate
     */
    mailAddress?: UserMailAddress;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    immutableId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithEmbeddedTemplate
     */
    referenceId?: string;
    /**
     * 
     * @type {Array<Guardian>}
     * @memberof UserWithEmbeddedTemplate
     */
    guardians?: Array<Guardian>;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithEmbeddedTemplate
     */
    accountEnabled?: boolean | null;
}
/**
 * 
 * @export
 * @interface ValidatePasswordResponse
 */
export interface ValidatePasswordResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidatePasswordResponse
     */
    isValid: boolean;
    /**
     * 
     * @type {Array<ValidationResult>}
     * @memberof ValidatePasswordResponse
     */
    validationResults: Array<ValidationResult>;
}
/**
 * 
 * @export
 * @interface ValidationParameters
 */
export interface ValidationParameters {
    /**
     * 
     * @type {string}
     * @memberof ValidationParameters
     */
    password: string;
}
/**
 * 
 * @export
 * @interface ValidationResult
 */
export interface ValidationResult {
    /**
     * 
     * @type {string}
     * @memberof ValidationResult
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationResult
     */
    ruleName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationResult
     */
    validationPassed: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ValidationResult
     */
    messageArguments?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface WardConnectionDetail
 */
export interface WardConnectionDetail {
    /**
     * 
     * @type {string}
     * @memberof WardConnectionDetail
     */
    guardianMailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof WardConnectionDetail
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof WardConnectionDetail
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WardConnectionDetail
     */
    b2CDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WardConnectionDetail
     */
    azureB2CId?: string | null;
}
/**
 * 
 * @export
 * @interface WardConnectionsResponse
 */
export interface WardConnectionsResponse {
    /**
     * 
     * @type {string}
     * @memberof WardConnectionsResponse
     */
    wardId: string;
    /**
     * 
     * @type {Array<WardConnectionDetail>}
     * @memberof WardConnectionsResponse
     */
    connections: Array<WardConnectionDetail>;
}
/**
 * 
 * @export
 * @interface WebinarAixResponse
 */
export interface WebinarAixResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarAixResponse
     */
    attendees: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarAixResponse
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    id: string;
    /**
     * 
     * @type {Person}
     * @memberof WebinarAixResponse
     */
    presenter: Person;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    preview: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarAixResponse
     */
    title: string;
}
/**
 * 
 * @export
 * @interface WebinarCategory
 */
export interface WebinarCategory {
    /**
     * 
     * @type {string}
     * @memberof WebinarCategory
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarCategory
     */
    id: string;
}
/**
 * 
 * @export
 * @interface WebinarCategoryOptions
 */
export interface WebinarCategoryOptions {
    /**
     * 
     * @type {string}
     * @memberof WebinarCategoryOptions
     */
    displayName: string;
}
/**
 * 
 * @export
 * @interface WebinarPost
 */
export interface WebinarPost {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarPost
     */
    attendees: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarPost
     */
    categories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebinarPost
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPost
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPost
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPost
     */
    title: string;
}
/**
 * 
 * @export
 * @interface WebinarPut
 */
export interface WebinarPut {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarPut
     */
    attendees: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarPut
     */
    categories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebinarPut
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPut
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPut
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPut
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarPut
     */
    title: string;
}
/**
 * 
 * @export
 * @interface WebinarResponse
 */
export interface WebinarResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarResponse
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof WebinarResponse
     */
    isSubscribed: boolean;
    /**
     * 
     * @type {Person}
     * @memberof WebinarResponse
     */
    presenter: Person;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    preview: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarResponse
     */
    title: string;
}
/**
 * 
 * @export
 * @interface WebinarsSearchOptions
 */
export interface WebinarsSearchOptions {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebinarsSearchOptions
     */
    terms: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WeeklySchedule {
    userDefined = 'UserDefined',
    everyday = 'Everyday',
    sunday = 'Sunday',
    monday = 'Monday',
    tuesday = 'Tuesday',
    wednesday = 'Wednesday',
    thursday = 'Thursday',
    friday = 'Friday',
    saturday = 'Saturday'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum WiFiProxySetting {
    none = 'None',
    manual = 'Manual',
    automatic = 'Automatic'
}

/**
 * 
 * @export
 * @interface WindowsAdministrativeTemplatesEntry
 */
export interface WindowsAdministrativeTemplatesEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    description: string;
    /**
     * depending on the type of the group settings that will be set are either of classtype user or of classtype machine maybe check the incoming groupIds as well before just applying the settings ?
     * @type {MdmGroupEntityType}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    typeOfGroup: MdmGroupEntityType;
    /**
     * 
     * @type {ForceMinimumYouTubeRestrictedMode}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    forceMinimumYouTubeRestrictedMode?: ForceMinimumYouTubeRestrictedMode;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * includes: IncognitoModeAvailability - IncognitoModeAvailability - forced means 2 ConfigureInPrivateModeAvailability - ConfigureInPrivateModeAvailability - forced means 2
     * @type {ConfigureModeAvailability}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    configureModeAvailability?: ConfigureModeAvailability;
    /**
     * contains : EnforceBingSafeSearch  { get; set; }  = ConfigureStrictSearchRestrictionsInBing bei true ? means 2 EnforceGoogleSafeSearch { get; set; } = true; ForceGoogleSafeSearch { get; set; } = true;
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    enforceSafeSearch?: boolean | null;
    /**
     * google and edge separate settings with same name
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    configureTheHomePageURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    configureTheNewTabPageURL?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    specifyTheSystemSleepTimeoutOnBattery?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    specifyTheSystemSleepTimeoutPluggedIn?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    requirePasswordWhenComputerWakesPluggedIn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    requirePasswordWhenComputerWakesOnBattery?: boolean | null;
    /**
     * includes: Default search provider name Default search provider search URL Enable the default search provider
     * @type {DefaultSearchProvider}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    defaultSearchProvider?: DefaultSearchProvider;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    turnOffTheDisplayPluggedIn?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    turnOffTheDisplayOnBattery?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    sitesToOpenWhenTheBrowserStarts?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntry
     */
    allowMicrosoftNewsContentOnTheNewTabPage?: boolean | null;
}
/**
 * 
 * @export
 * @interface WindowsAdministrativeTemplatesEntryAllOf
 */
export interface WindowsAdministrativeTemplatesEntryAllOf {
    /**
     * depending on the type of the group settings that will be set are either of classtype user or of classtype machine maybe check the incoming groupIds as well before just applying the settings ?
     * @type {MdmGroupEntityType}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    typeOfGroup: MdmGroupEntityType;
    /**
     * 
     * @type {ForceMinimumYouTubeRestrictedMode}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    forceMinimumYouTubeRestrictedMode?: ForceMinimumYouTubeRestrictedMode;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * includes: IncognitoModeAvailability - IncognitoModeAvailability - forced means 2 ConfigureInPrivateModeAvailability - ConfigureInPrivateModeAvailability - forced means 2
     * @type {ConfigureModeAvailability}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    configureModeAvailability?: ConfigureModeAvailability;
    /**
     * contains : EnforceBingSafeSearch  { get; set; }  = ConfigureStrictSearchRestrictionsInBing bei true ? means 2 EnforceGoogleSafeSearch { get; set; } = true; ForceGoogleSafeSearch { get; set; } = true;
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    enforceSafeSearch?: boolean | null;
    /**
     * google and edge separate settings with same name
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    configureTheHomePageURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    configureTheNewTabPageURL?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    specifyTheSystemSleepTimeoutOnBattery?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    specifyTheSystemSleepTimeoutPluggedIn?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    requirePasswordWhenComputerWakesPluggedIn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    requirePasswordWhenComputerWakesOnBattery?: boolean | null;
    /**
     * includes: Default search provider name Default search provider search URL Enable the default search provider
     * @type {DefaultSearchProvider}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    defaultSearchProvider?: DefaultSearchProvider;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    turnOffTheDisplayPluggedIn?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    turnOffTheDisplayOnBattery?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    sitesToOpenWhenTheBrowserStarts?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesEntryAllOf
     */
    allowMicrosoftNewsContentOnTheNewTabPage?: boolean | null;
}
/**
 * 
 * @export
 * @interface WindowsAdministrativeTemplatesResponse
 */
export interface WindowsAdministrativeTemplatesResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * depending on the type of the group settings that will be set are either of classtype user or of classtype machine maybe check the incoming groupIds as well before just applying the settings ?
     * @type {MdmGroupEntityType}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    typeOfGroup: MdmGroupEntityType;
    /**
     * 
     * @type {ForceMinimumYouTubeRestrictedMode}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    forceMinimumYouTubeRestrictedMode?: ForceMinimumYouTubeRestrictedMode;
    /**
     * includes: IncognitoModeAvailability - IncognitoModeAvailability - forced means 2 ConfigureInPrivateModeAvailability - ConfigureInPrivateModeAvailability - forced means 2
     * @type {ConfigureModeAvailability}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    configureModeAvailability?: ConfigureModeAvailability;
    /**
     * contains : EnforceBingSafeSearch  { get; set; }  = ConfigureStrictSearchRestrictionsInBing bei true ? means 2 EnforceGoogleSafeSearch { get; set; } = true; ForceGoogleSafeSearch { get; set; } = true;
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    enforceSafeSearch?: boolean | null;
    /**
     * google and edge separate settings with same name
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    configureTheHomePageURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    configureTheNewTabPageURL?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    specifyTheSystemSleepTimeoutOnBattery?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    specifyTheSystemSleepTimeoutPluggedIn?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    requirePasswordWhenComputerWakesPluggedIn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    requirePasswordWhenComputerWakesOnBattery?: boolean | null;
    /**
     * includes: Default search provider name Default search provider search URL Enable the default search provider
     * @type {DefaultSearchProvider}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    defaultSearchProvider?: DefaultSearchProvider;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    turnOffTheDisplayPluggedIn?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    turnOffTheDisplayOnBattery?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    sitesToOpenWhenTheBrowserStarts?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponse
     */
    allowMicrosoftNewsContentOnTheNewTabPage?: boolean | null;
}
/**
 * 
 * @export
 * @interface WindowsAdministrativeTemplatesResponseAllOf
 */
export interface WindowsAdministrativeTemplatesResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * depending on the type of the group settings that will be set are either of classtype user or of classtype machine maybe check the incoming groupIds as well before just applying the settings ?
     * @type {MdmGroupEntityType}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    typeOfGroup: MdmGroupEntityType;
    /**
     * 
     * @type {ForceMinimumYouTubeRestrictedMode}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    forceMinimumYouTubeRestrictedMode?: ForceMinimumYouTubeRestrictedMode;
    /**
     * includes: IncognitoModeAvailability - IncognitoModeAvailability - forced means 2 ConfigureInPrivateModeAvailability - ConfigureInPrivateModeAvailability - forced means 2
     * @type {ConfigureModeAvailability}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    configureModeAvailability?: ConfigureModeAvailability;
    /**
     * contains : EnforceBingSafeSearch  { get; set; }  = ConfigureStrictSearchRestrictionsInBing bei true ? means 2 EnforceGoogleSafeSearch { get; set; } = true; ForceGoogleSafeSearch { get; set; } = true;
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    enforceSafeSearch?: boolean | null;
    /**
     * google and edge separate settings with same name
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    configureTheHomePageURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    configureTheNewTabPageURL?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    specifyTheSystemSleepTimeoutOnBattery?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    specifyTheSystemSleepTimeoutPluggedIn?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    requirePasswordWhenComputerWakesPluggedIn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    requirePasswordWhenComputerWakesOnBattery?: boolean | null;
    /**
     * includes: Default search provider name Default search provider search URL Enable the default search provider
     * @type {DefaultSearchProvider}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    defaultSearchProvider?: DefaultSearchProvider;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    turnOffTheDisplayPluggedIn?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    turnOffTheDisplayOnBattery?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    sitesToOpenWhenTheBrowserStarts?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsAdministrativeTemplatesResponseAllOf
     */
    allowMicrosoftNewsContentOnTheNewTabPage?: boolean | null;
}
/**
 * 
 * @export
 * @interface WindowsAutopilotDeploymentEntry
 */
export interface WindowsAutopilotDeploymentEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsAutopilotDeploymentEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentEntry
     */
    deviceNametemplate?: string;
}
/**
 * 
 * @export
 * @interface WindowsAutopilotDeploymentEntryAllOf
 */
export interface WindowsAutopilotDeploymentEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsAutopilotDeploymentEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentEntryAllOf
     */
    deviceNametemplate?: string;
}
/**
 * 
 * @export
 * @interface WindowsAutopilotDeploymentResponse
 */
export interface WindowsAutopilotDeploymentResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsAutopilotDeploymentResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentResponse
     */
    deviceNametemplate: string;
}
/**
 * 
 * @export
 * @interface WindowsAutopilotDeploymentResponseAllOf
 */
export interface WindowsAutopilotDeploymentResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsAutopilotDeploymentResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof WindowsAutopilotDeploymentResponseAllOf
     */
    deviceNametemplate: string;
}
/**
 * 
 * @export
 * @interface WindowsCustomConfigurationEntry
 */
export interface WindowsCustomConfigurationEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsCustomConfigurationEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsCustomConfigurationEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsCustomConfigurationEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<OmaSettings>}
     * @memberof WindowsCustomConfigurationEntry
     */
    omaSettings?: Array<OmaSettings> | null;
    /**
     * 
     * @type {Array<OmaSettingsXML>}
     * @memberof WindowsCustomConfigurationEntry
     */
    omaSettingsXML?: Array<OmaSettingsXML> | null;
}
/**
 * 
 * @export
 * @interface WindowsCustomConfigurationEntryAllOf
 */
export interface WindowsCustomConfigurationEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsCustomConfigurationEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<OmaSettings>}
     * @memberof WindowsCustomConfigurationEntryAllOf
     */
    omaSettings?: Array<OmaSettings> | null;
    /**
     * 
     * @type {Array<OmaSettingsXML>}
     * @memberof WindowsCustomConfigurationEntryAllOf
     */
    omaSettingsXML?: Array<OmaSettingsXML> | null;
}
/**
 * 
 * @export
 * @interface WindowsCustomConfigurationResponse
 */
export interface WindowsCustomConfigurationResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsCustomConfigurationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsCustomConfigurationResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsCustomConfigurationResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsCustomConfigurationResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {Array<OmaSettings>}
     * @memberof WindowsCustomConfigurationResponse
     */
    omaSettings: Array<OmaSettings>;
    /**
     * 
     * @type {Array<OmaSettingsXML>}
     * @memberof WindowsCustomConfigurationResponse
     */
    omaSettingsXML: Array<OmaSettingsXML>;
}
/**
 * 
 * @export
 * @interface WindowsCustomConfigurationResponseAllOf
 */
export interface WindowsCustomConfigurationResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsCustomConfigurationResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {Array<OmaSettings>}
     * @memberof WindowsCustomConfigurationResponseAllOf
     */
    omaSettings: Array<OmaSettings>;
    /**
     * 
     * @type {Array<OmaSettingsXML>}
     * @memberof WindowsCustomConfigurationResponseAllOf
     */
    omaSettingsXML: Array<OmaSettingsXML>;
}
/**
 * 
 * @export
 * @interface WindowsDeviceRestrictionsEntry
 */
export interface WindowsDeviceRestrictionsEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    energySaverOnBatteryThresholdPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    energySaverPluggedInThresholdPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    personalizationLockScreenImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    personalizationDesktopImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    authenticationPreferredAzureADTenantDomainName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    bluetoothBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    storageBlockRemovableStorage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntry
     */
    taskManagerBlockEndTask?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsDeviceRestrictionsEntryAllOf
 */
export interface WindowsDeviceRestrictionsEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    energySaverOnBatteryThresholdPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    energySaverPluggedInThresholdPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    personalizationLockScreenImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    personalizationDesktopImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    authenticationPreferredAzureADTenantDomainName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    bluetoothBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    storageBlockRemovableStorage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsEntryAllOf
     */
    taskManagerBlockEndTask?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsDeviceRestrictionsResponse
 */
export interface WindowsDeviceRestrictionsResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    energySaverOnBatteryThresholdPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    energySaverPluggedInThresholdPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    personalizationLockScreenImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    personalizationDesktopImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    authenticationPreferredAzureADTenantDomainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    bluetoothBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    storageBlockRemovableStorage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponse
     */
    taskManagerBlockEndTask?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsDeviceRestrictionsResponseAllOf
 */
export interface WindowsDeviceRestrictionsResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    energySaverOnBatteryThresholdPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    energySaverPluggedInThresholdPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    personalizationLockScreenImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    personalizationDesktopImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    authenticationPreferredAzureADTenantDomainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    bluetoothBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    cameraBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    storageBlockRemovableStorage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsDeviceRestrictionsResponseAllOf
     */
    taskManagerBlockEndTask?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsLocalUserGroupMembershipEntry
 */
export interface WindowsLocalUserGroupMembershipEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsLocalUserGroupMembershipEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsLocalUserGroupMembershipEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsLocalUserGroupMembershipEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<LocalUserGroupEntry>}
     * @memberof WindowsLocalUserGroupMembershipEntry
     */
    entries: Array<LocalUserGroupEntry>;
}
/**
 * 
 * @export
 * @interface WindowsLocalUserGroupMembershipEntryAllOf
 */
export interface WindowsLocalUserGroupMembershipEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsLocalUserGroupMembershipEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {Array<LocalUserGroupEntry>}
     * @memberof WindowsLocalUserGroupMembershipEntryAllOf
     */
    entries: Array<LocalUserGroupEntry>;
}
/**
 * 
 * @export
 * @interface WindowsLocalUserGroupMembershipResponse
 */
export interface WindowsLocalUserGroupMembershipResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsLocalUserGroupMembershipResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsLocalUserGroupMembershipResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsLocalUserGroupMembershipResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsLocalUserGroupMembershipResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {Array<LocalUserGroupEntry>}
     * @memberof WindowsLocalUserGroupMembershipResponse
     */
    entries: Array<LocalUserGroupEntry>;
}
/**
 * 
 * @export
 * @interface WindowsLocalUserGroupMembershipResponseAllOf
 */
export interface WindowsLocalUserGroupMembershipResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsLocalUserGroupMembershipResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {Array<LocalUserGroupEntry>}
     * @memberof WindowsLocalUserGroupMembershipResponseAllOf
     */
    entries: Array<LocalUserGroupEntry>;
}
/**
 * 
 * @export
 * @interface WindowsProfilesAbstractEntry
 */
export interface WindowsProfilesAbstractEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsProfilesAbstractEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsProfilesAbstractEntry
     */
    description: string;
}
/**
 * 
 * @export
 * @interface WindowsProfilesAbstractResponse
 */
export interface WindowsProfilesAbstractResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsProfilesAbstractResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsProfilesAbstractResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsProfilesAbstractResponse
     */
    description: string;
}
/**
 * 
 * @export
 * @interface WindowsSettingsCatalogueEntry
 */
export interface WindowsSettingsCatalogueEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsSettingsCatalogueEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSettingsCatalogueEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsSettingsCatalogueEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSettingsCatalogueEntry
     */
    allowWidgets?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsSettingsCatalogueEntryAllOf
 */
export interface WindowsSettingsCatalogueEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsSettingsCatalogueEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSettingsCatalogueEntryAllOf
     */
    allowWidgets?: boolean;
}
/**
 * 
 * @export
 * @interface WindowsSettingsCatalogueResponse
 */
export interface WindowsSettingsCatalogueResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsSettingsCatalogueResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSettingsCatalogueResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSettingsCatalogueResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsSettingsCatalogueResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSettingsCatalogueResponse
     */
    allowWidgets: boolean;
}
/**
 * 
 * @export
 * @interface WindowsSettingsCatalogueResponseAllOf
 */
export interface WindowsSettingsCatalogueResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsSettingsCatalogueResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSettingsCatalogueResponseAllOf
     */
    allowWidgets: boolean;
}
/**
 * 
 * @export
 * @interface WindowsSharedPolicyEntry
 */
export interface WindowsSharedPolicyEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsSharedPolicyEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSharedPolicyEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsSharedPolicyEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyEntry
     */
    setAccountManager?: MdmProfileChoiceOptions;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSharedPolicyEntry
     */
    disableAccountManager?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntry
     */
    cacheAccountsAboveDiskFreePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntry
     */
    inactiveThresholdDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntry
     */
    removeAccountsBelowDiskFreePercentage?: number | null;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyEntry
     */
    localStorage?: MdmProfileChoiceOptions;
    /**
     * 
     * @type {Array<GuestAccountTypes>}
     * @memberof WindowsSharedPolicyEntry
     */
    guestAccounts?: Array<GuestAccountTypes>;
}
/**
 * 
 * @export
 * @interface WindowsSharedPolicyEntryAllOf
 */
export interface WindowsSharedPolicyEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    setAccountManager?: MdmProfileChoiceOptions;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    disableAccountManager?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    cacheAccountsAboveDiskFreePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    inactiveThresholdDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    removeAccountsBelowDiskFreePercentage?: number | null;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    localStorage?: MdmProfileChoiceOptions;
    /**
     * 
     * @type {Array<GuestAccountTypes>}
     * @memberof WindowsSharedPolicyEntryAllOf
     */
    guestAccounts?: Array<GuestAccountTypes>;
}
/**
 * 
 * @export
 * @interface WindowsSharedPolicyResponse
 */
export interface WindowsSharedPolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsSharedPolicyResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSharedPolicyResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsSharedPolicyResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsSharedPolicyResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyResponse
     */
    setAccountManager: MdmProfileChoiceOptions;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponse
     */
    cacheAccountsAboveDiskFreePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponse
     */
    inactiveThresholdDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponse
     */
    removeAccountsBelowDiskFreePercentage?: number | null;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyResponse
     */
    localStorage: MdmProfileChoiceOptions;
    /**
     * 
     * @type {Array<GuestAccountTypes>}
     * @memberof WindowsSharedPolicyResponse
     */
    guestAccounts: Array<GuestAccountTypes>;
}
/**
 * 
 * @export
 * @interface WindowsSharedPolicyResponseAllOf
 */
export interface WindowsSharedPolicyResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    setAccountManager: MdmProfileChoiceOptions;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    cacheAccountsAboveDiskFreePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    inactiveThresholdDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    removeAccountsBelowDiskFreePercentage?: number | null;
    /**
     * 
     * @type {MdmProfileChoiceOptions}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    localStorage: MdmProfileChoiceOptions;
    /**
     * 
     * @type {Array<GuestAccountTypes>}
     * @memberof WindowsSharedPolicyResponseAllOf
     */
    guestAccounts: Array<GuestAccountTypes>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WindowsUpdateForBusinessUpdateWeeks {
    userDefined = 'UserDefined',
    firstWeek = 'FirstWeek',
    secondWeek = 'SecondWeek',
    thirdWeek = 'ThirdWeek',
    fourthWeek = 'FourthWeek',
    everyWeek = 'EveryWeek',
    unknownFutureValue = 'UnknownFutureValue'
}

/**
 * 
 * @export
 * @interface WindowsUpdatePolicyEntry
 */
export interface WindowsUpdatePolicyEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsUpdatePolicyEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntry
     */
    allowWindows11Upgrade?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntry
     */
    driversExcluded?: boolean;
    /**
     * 
     * @type {AutomaticUpdateMode}
     * @memberof WindowsUpdatePolicyEntry
     */
    automaticUpdateMode?: AutomaticUpdateMode;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntry
     */
    microsoftUpdateServiceAllowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntry
     */
    qualityUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntry
     */
    featureUpdatesPaused?: boolean;
    /**
     * The Installation Schedule. Possible values are: ActiveHoursStart, ActiveHoursEnd, ScheduledInstallDay, ScheduledInstallTime. Returned by default. Query parameters are not supported.
     * @type {WeeklySchedule}
     * @memberof WindowsUpdatePolicyEntry
     */
    scheduledInstallDay?: WeeklySchedule;
    /**
     * 
     * @type {Array<WindowsUpdateForBusinessUpdateWeeks>}
     * @memberof WindowsUpdatePolicyEntry
     */
    updateWeeks?: Array<WindowsUpdateForBusinessUpdateWeeks>;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntry
     */
    scheduledInstallTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyEntry
     */
    qualityUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyEntry
     */
    featureUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntry
     */
    activeHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntry
     */
    activeHoursEnd?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsUpdatePolicyEntryAllOf
 */
export interface WindowsUpdatePolicyEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    allowWindows11Upgrade?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    driversExcluded?: boolean;
    /**
     * 
     * @type {AutomaticUpdateMode}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    automaticUpdateMode?: AutomaticUpdateMode;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    microsoftUpdateServiceAllowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    qualityUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    featureUpdatesPaused?: boolean;
    /**
     * The Installation Schedule. Possible values are: ActiveHoursStart, ActiveHoursEnd, ScheduledInstallDay, ScheduledInstallTime. Returned by default. Query parameters are not supported.
     * @type {WeeklySchedule}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    scheduledInstallDay?: WeeklySchedule;
    /**
     * 
     * @type {Array<WindowsUpdateForBusinessUpdateWeeks>}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    updateWeeks?: Array<WindowsUpdateForBusinessUpdateWeeks>;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    scheduledInstallTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    qualityUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    featureUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    activeHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyEntryAllOf
     */
    activeHoursEnd?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsUpdatePolicyResponse
 */
export interface WindowsUpdatePolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsUpdatePolicyResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponse
     */
    allowWindows11Upgrade?: boolean;
    /**
     * 
     * @type {AutomaticUpdateMode}
     * @memberof WindowsUpdatePolicyResponse
     */
    automaticUpdateMode?: AutomaticUpdateMode;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponse
     */
    microsoftUpdateServiceAllowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponse
     */
    qualityUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponse
     */
    featureUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponse
     */
    driversExcluded?: boolean;
    /**
     * 
     * @type {Array<WindowsUpdateForBusinessUpdateWeeks>}
     * @memberof WindowsUpdatePolicyResponse
     */
    updateWeeks?: Array<WindowsUpdateForBusinessUpdateWeeks>;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyResponse
     */
    qualityUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyResponse
     */
    featureUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    activeHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    activeHoursEnd?: string | null;
    /**
     * 
     * @type {WeeklySchedule}
     * @memberof WindowsUpdatePolicyResponse
     */
    scheduledInstallDay?: WeeklySchedule | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponse
     */
    scheduledInstallTime?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsUpdatePolicyResponseAllOf
 */
export interface WindowsUpdatePolicyResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    allowWindows11Upgrade?: boolean;
    /**
     * 
     * @type {AutomaticUpdateMode}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    automaticUpdateMode?: AutomaticUpdateMode;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    microsoftUpdateServiceAllowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    qualityUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    featureUpdatesPaused?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    driversExcluded?: boolean;
    /**
     * 
     * @type {Array<WindowsUpdateForBusinessUpdateWeeks>}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    updateWeeks?: Array<WindowsUpdateForBusinessUpdateWeeks>;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    qualityUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    featureUpdatesDeferralPeriodInDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    activeHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    activeHoursEnd?: string | null;
    /**
     * 
     * @type {WeeklySchedule}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    scheduledInstallDay?: WeeklySchedule | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsUpdatePolicyResponseAllOf
     */
    scheduledInstallTime?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsWiFiEntry
 */
export interface WindowsWiFiEntry {
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsWiFiEntry
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    preSharedKey?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiEntry
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiEntry
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof WindowsWiFiEntry
     */
    proxySetting?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof WindowsWiFiEntry
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntry
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsWiFiEntryAllOf
 */
export interface WindowsWiFiEntryAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof WindowsWiFiEntryAllOf
     */
    mdmGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntryAllOf
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntryAllOf
     */
    preSharedKey?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiEntryAllOf
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiEntryAllOf
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof WindowsWiFiEntryAllOf
     */
    proxySetting?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof WindowsWiFiEntryAllOf
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntryAllOf
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiEntryAllOf
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsWiFiResponse
 */
export interface WindowsWiFiResponse {
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    description: string;
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsWiFiResponse
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    preSharedKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiResponse
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiResponse
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof WindowsWiFiResponse
     */
    proxySettings?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof WindowsWiFiResponse
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponse
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface WindowsWiFiResponseAllOf
 */
export interface WindowsWiFiResponseAllOf {
    /**
     * 
     * @type {GroupAssignments}
     * @memberof WindowsWiFiResponseAllOf
     */
    groupAssignments: GroupAssignments;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponseAllOf
     */
    ssid: string;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponseAllOf
     */
    preSharedKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiResponseAllOf
     */
    connectAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WindowsWiFiResponseAllOf
     */
    connectWhenNetworkNameIsHidden?: boolean;
    /**
     * 
     * @type {WiFiProxySetting}
     * @memberof WindowsWiFiResponseAllOf
     */
    proxySettings?: WiFiProxySetting;
    /**
     * 
     * @type {number}
     * @memberof WindowsWiFiResponseAllOf
     */
    proxyManualPort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponseAllOf
     */
    proxyManualAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WindowsWiFiResponseAllOf
     */
    proxyAutomaticConfigurationUrl?: string | null;
}
/**
 * 
 * @export
 * @interface Workgroup
 */
export interface Workgroup {
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    createdDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Workgroup
     */
    isInProvisioningTimeWindow: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    mailNickname: string;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    tenantId: string;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    isArchived?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    webUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workgroup
     */
    notebookJobId?: string | null;
}
/**
 * 
 * @export
 * @interface WorkgroupDriveItem
 */
export interface WorkgroupDriveItem {
    /**
     * 
     * @type {Array<DriveItem>}
     * @memberof WorkgroupDriveItem
     */
    children: Array<DriveItem>;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupDriveItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupDriveItem
     */
    driveId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupDriveItem
     */
    webUrl?: string | null;
}
/**
 * 
 * @export
 * @interface WorkgroupEvent
 */
export interface WorkgroupEvent {
    /**
     * 
     * @type {string}
     * @memberof WorkgroupEvent
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupEvent
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkgroupEvent
     */
    isAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupEvent
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupEvent
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupEvent
     */
    seriesMasterId?: string | null;
}
/**
 * 
 * @export
 * @interface WorkgroupGetAllForOrganizationRequest
 */
export interface WorkgroupGetAllForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetAllForOrganizationRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface WorkgroupGetEventsRequest
 */
export interface WorkgroupGetEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetEventsRequest
     */
    end?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetEventsRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetEventsRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetEventsRequest
     */
    start?: string | null;
}
/**
 * 
 * @export
 * @interface WorkgroupGetRequest
 */
export interface WorkgroupGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupGetRequest
     */
    organizationId: string;
}
/**
 * 
 * @export
 * @interface WorkgroupMember
 */
export interface WorkgroupMember {
    /**
     * 
     * @type {string}
     * @memberof WorkgroupMember
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupMember
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupMember
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupMember
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkgroupMember
     */
    mail: string;
    /**
     * 
     * @type {UserRole}
     * @memberof WorkgroupMember
     */
    role: UserRole;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ZipSourceType {
    personal = 'Personal',
    group = 'Group',
    schoolWide = 'SchoolWide'
}


/**
 * AbsencesApi - axios parameter creator
 * @export
 */
export const AbsencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence: async (organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAbsence', 'organizationId', organizationId)
            // verify required parameter 'absenceEntry' is not null or undefined
            assertParamExists('createAbsence', 'absenceEntry', absenceEntry)
            const localVarPath = `/api/V2/{organizationId}/Absences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceDrafts: async (organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceDrafts', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/drafts/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceDraftsCount: async (organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceDraftsCount', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/drafts/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceExcuseDefinitions: async (organizationId: string, enabledOnly?: boolean, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceExcuseDefinitions', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/definition`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceReasons: async (organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceReasons', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/reason`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (reasonDefinitionId !== undefined) {
                localVarQueryParameter['reasonDefinitionId'] = reasonDefinitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicCourses', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/courses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGrades: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicGrades', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/grades`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [studentName] 
         * @param {string} [className] 
         * @param {string} [gradeName] 
         * @param {AbsenceDraftState} [state] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedAbsenceDrafts: async (organizationId: string, timePeriod?: string, studentName?: string, className?: string, gradeName?: string, state?: AbsenceDraftState, page?: number, perPage?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getArchivedAbsenceDrafts', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/drafts/archived`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (studentName !== undefined) {
                localVarQueryParameter['studentName'] = studentName;
            }

            if (className !== undefined) {
                localVarQueryParameter['className'] = className;
            }

            if (gradeName !== undefined) {
                localVarQueryParameter['gradeName'] = gradeName;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedAbsenceDraftsAvailableFilters: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getArchivedAbsenceDraftsAvailableFilters', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/drafts/archived/available-filters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoursesOfStudent: async (organizationId: string, studentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCoursesOfStudent', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('getCoursesOfStudent', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/Absences/courses/of/student/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralSettings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGeneralSettings', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/generalSettings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTheActiveTimePattern', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Absences/pattern/active`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} absenceDraftId 
         * @param {string} body 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsenceDraftState: async (organizationId: string, absenceDraftId: string, body: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAbsenceDraftState', 'organizationId', organizationId)
            // verify required parameter 'absenceDraftId' is not null or undefined
            assertParamExists('updateAbsenceDraftState', 'absenceDraftId', absenceDraftId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateAbsenceDraftState', 'body', body)
            const localVarPath = `/api/V2/{organizationId}/Absences/draft/{absenceDraftId}/state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"absenceDraftId"}}`, encodeURIComponent(String(absenceDraftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsences: async (organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAbsences', 'organizationId', organizationId)
            // verify required parameter 'absencePutEntry' is not null or undefined
            assertParamExists('updateAbsences', 'absencePutEntry', absencePutEntry)
            const localVarPath = `/api/V2/{organizationId}/Absences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absencePutEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbsencesApi - functional programming interface
 * @export
 */
export const AbsencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbsencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbsence(organizationId, absenceEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceDrafts(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceDraftResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceDrafts(organizationId, timePeriod, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceDraftsCount(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceDraftsCount(organizationId, timePeriod, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExcuseDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfCourseBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfGradeBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [studentName] 
         * @param {string} [className] 
         * @param {string} [gradeName] 
         * @param {AbsenceDraftState} [state] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchivedAbsenceDrafts(organizationId: string, timePeriod?: string, studentName?: string, className?: string, gradeName?: string, state?: AbsenceDraftState, page?: number, perPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfArchivedAbsenceDraftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchivedAbsenceDrafts(organizationId, timePeriod, studentName, className, gradeName, state, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchivedAbsenceDraftsAvailableFilters(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchivedAbsenceDraftsAvailableFilters(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoursesOfStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfCourseBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoursesOfStudent(organizationId, studentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralSettings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralSettingsItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralSettings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheActiveTimePattern(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} absenceDraftId 
         * @param {string} body 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsenceDraftState(organizationId: string, absenceDraftId: string, body: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceDraftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsenceDraftState(organizationId, absenceDraftId, body, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsences(organizationId, absencePutEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbsencesApi - factory interface
 * @export
 */
export const AbsencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbsencesApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceResponse> {
            return localVarFp.createAbsence(organizationId, absenceEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceDrafts(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any): AxiosPromise<Array<AbsenceDraftResponse>> {
            return localVarFp.getAllAbsenceDrafts(organizationId, timePeriod, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {AbsenceDraftState} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceDraftsCount(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any): AxiosPromise<number> {
            return localVarFp.getAllAbsenceDraftsCount(organizationId, timePeriod, state, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any): AxiosPromise<Array<ExcuseDefinitionResponse>> {
            return localVarFp.getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceReasonResponse>> {
            return localVarFp.getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfCourseBasicResponse> {
            return localVarFp.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfGradeBasicResponse> {
            return localVarFp.getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [studentName] 
         * @param {string} [className] 
         * @param {string} [gradeName] 
         * @param {AbsenceDraftState} [state] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedAbsenceDrafts(organizationId: string, timePeriod?: string, studentName?: string, className?: string, gradeName?: string, state?: AbsenceDraftState, page?: number, perPage?: number, options?: any): AxiosPromise<PagedOfArchivedAbsenceDraftResponse> {
            return localVarFp.getArchivedAbsenceDrafts(organizationId, timePeriod, studentName, className, gradeName, state, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedAbsenceDraftsAvailableFilters(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<AvailableFiltersResponse> {
            return localVarFp.getArchivedAbsenceDraftsAvailableFilters(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoursesOfStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any): AxiosPromise<PaginatedOfCourseBasicResponse> {
            return localVarFp.getCoursesOfStudent(organizationId, studentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralSettings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<GeneralSettingsItem> {
            return localVarFp.getGeneralSettings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {string} absenceDraftId 
         * @param {string} body 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsenceDraftState(organizationId: string, absenceDraftId: string, body: string, timePeriod?: string, options?: any): AxiosPromise<AbsenceDraftResponse> {
            return localVarFp.updateAbsenceDraftState(organizationId, absenceDraftId, body, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceResponse> {
            return localVarFp.updateAbsences(organizationId, absencePutEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbsencesApi - object-oriented interface
 * @export
 * @class AbsencesApi
 * @extends {BaseAPI}
 */
export class AbsencesApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {AbsenceEntry} absenceEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).createAbsence(organizationId, absenceEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {AbsenceDraftState} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllAbsenceDrafts(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any) {
        return AbsencesApiFp(this.configuration).getAllAbsenceDrafts(organizationId, timePeriod, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {AbsenceDraftState} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllAbsenceDraftsCount(organizationId: string, timePeriod?: string, state?: AbsenceDraftState, options?: any) {
        return AbsencesApiFp(this.configuration).getAllAbsenceDraftsCount(organizationId, timePeriod, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {boolean} [enabledOnly] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {boolean} [enabledOnly] 
     * @param {string} [reasonDefinitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return AbsencesApiFp(this.configuration).getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return AbsencesApiFp(this.configuration).getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [studentName] 
     * @param {string} [className] 
     * @param {string} [gradeName] 
     * @param {AbsenceDraftState} [state] 
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getArchivedAbsenceDrafts(organizationId: string, timePeriod?: string, studentName?: string, className?: string, gradeName?: string, state?: AbsenceDraftState, page?: number, perPage?: number, options?: any) {
        return AbsencesApiFp(this.configuration).getArchivedAbsenceDrafts(organizationId, timePeriod, studentName, className, gradeName, state, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getArchivedAbsenceDraftsAvailableFilters(organizationId: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getArchivedAbsenceDraftsAvailableFilters(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getCoursesOfStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getCoursesOfStudent(organizationId, studentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getGeneralSettings(organizationId: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getGeneralSettings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {string} absenceDraftId 
     * @param {string} body 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public updateAbsenceDraftState(organizationId: string, absenceDraftId: string, body: string, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).updateAbsenceDraftState(organizationId, absenceDraftId, body, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {AbsencePutEntry} absencePutEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsencesApi
     */
    public updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any) {
        return AbsencesApiFp(this.configuration).updateAbsences(organizationId, absencePutEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnouncementsApi - axios parameter creator
 * @export
 */
export const AnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Announcements.WriteAll</li><li>Announcements.ShowModule</li></ul>
         * @summary Create a announcement. 🔒: Announcements.WriteAll, Announcements.ShowModule
         * @param {string} organizationId 
         * @param {AnnouncementCreate} announcementCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement: async (organizationId: string, announcementCreate: AnnouncementCreate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAnnouncement', 'organizationId', organizationId)
            // verify required parameter 'announcementCreate' is not null or undefined
            assertParamExists('createAnnouncement', 'announcementCreate', announcementCreate)
            const localVarPath = `/api/v2/Announcements/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(announcementCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Removes a announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} announcementId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncement: async (announcementId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'announcementId' is not null or undefined
            assertParamExists('deleteAnnouncement', 'announcementId', announcementId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAnnouncement', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Announcements/{organizationId}/{announcementId}`
                .replace(`{${"announcementId"}}`, encodeURIComponent(String(announcementId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnnouncements: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAnnouncements', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Announcements/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all announcements, filtered by recipient (group: user) and area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementsOfGroup: async (area: Area, groupId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'area' is not null or undefined
            assertParamExists('getAnnouncementsOfGroup', 'area', area)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAnnouncementsOfGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAnnouncementsOfGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Announcements/{organizationId}/group/{groupId}/{area}`
                .replace(`{${"area"}}`, encodeURIComponent(String(area)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all of my announcements, filtered by area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAnnouncements: async (area: Area, organizationId: string, timePeriod?: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'area' is not null or undefined
            assertParamExists('getMyAnnouncements', 'area', area)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyAnnouncements', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Announcements/{organizationId}/my/{area}`
                .replace(`{${"area"}}`, encodeURIComponent(String(area)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipients: async (organizationId: string, timePeriod?: string, type?: EntityType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRecipients', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Announcements/{organizationId}/recipients`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Update a given announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {AnnouncementUpdate} announcementUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncement: async (organizationId: string, announcementUpdate: AnnouncementUpdate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAnnouncement', 'organizationId', organizationId)
            // verify required parameter 'announcementUpdate' is not null or undefined
            assertParamExists('updateAnnouncement', 'announcementUpdate', announcementUpdate)
            const localVarPath = `/api/v2/Announcements/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(announcementUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnouncementsApi - functional programming interface
 * @export
 */
export const AnnouncementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnouncementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Announcements.WriteAll</li><li>Announcements.ShowModule</li></ul>
         * @summary Create a announcement. 🔒: Announcements.WriteAll, Announcements.ShowModule
         * @param {string} organizationId 
         * @param {AnnouncementCreate} announcementCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnouncement(organizationId: string, announcementCreate: AnnouncementCreate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnouncement(organizationId, announcementCreate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Removes a announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} announcementId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAnnouncement(announcementId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAnnouncement(announcementId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAnnouncements(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnouncementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAnnouncements(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all announcements, filtered by recipient (group: user) and area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnouncementsOfGroup(area: Area, groupId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnouncementBasicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnouncementsOfGroup(area, groupId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all of my announcements, filtered by area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAnnouncements(area: Area, organizationId: string, timePeriod?: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnouncementBasicResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAnnouncements(area, organizationId, timePeriod, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecipients(organizationId: string, timePeriod?: string, type?: EntityType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Recipients>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecipients(organizationId, timePeriod, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Update a given announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {AnnouncementUpdate} announcementUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAnnouncement(organizationId: string, announcementUpdate: AnnouncementUpdate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAnnouncement(organizationId, announcementUpdate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnouncementsApi - factory interface
 * @export
 */
export const AnnouncementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnouncementsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Announcements.WriteAll</li><li>Announcements.ShowModule</li></ul>
         * @summary Create a announcement. 🔒: Announcements.WriteAll, Announcements.ShowModule
         * @param {string} organizationId 
         * @param {AnnouncementCreate} announcementCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement(organizationId: string, announcementCreate: AnnouncementCreate, timePeriod?: string, options?: any): AxiosPromise<AnnouncementResponse> {
            return localVarFp.createAnnouncement(organizationId, announcementCreate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Removes a announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} announcementId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnnouncement(announcementId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAnnouncement(announcementId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAnnouncements(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AnnouncementResponse>> {
            return localVarFp.getAllAnnouncements(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all announcements, filtered by recipient (group: user) and area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncementsOfGroup(area: Area, groupId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AnnouncementBasicResponse>> {
            return localVarFp.getAnnouncementsOfGroup(area, groupId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all of my announcements, filtered by area. No rights necessary for this call.
         * @param {Area} area 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAnnouncements(area: Area, organizationId: string, timePeriod?: string, groupId?: string, options?: any): AxiosPromise<Array<AnnouncementBasicResponse>> {
            return localVarFp.getMyAnnouncements(area, organizationId, timePeriod, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {EntityType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipients(organizationId: string, timePeriod?: string, type?: EntityType, options?: any): AxiosPromise<Recipients> {
            return localVarFp.getRecipients(organizationId, timePeriod, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
         * @summary Update a given announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
         * @param {string} organizationId 
         * @param {AnnouncementUpdate} announcementUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnnouncement(organizationId: string, announcementUpdate: AnnouncementUpdate, timePeriod?: string, options?: any): AxiosPromise<AnnouncementResponse> {
            return localVarFp.updateAnnouncement(organizationId, announcementUpdate, timePeriod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnouncementsApi - object-oriented interface
 * @export
 * @class AnnouncementsApi
 * @extends {BaseAPI}
 */
export class AnnouncementsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Announcements.WriteAll</li><li>Announcements.ShowModule</li></ul>
     * @summary Create a announcement. 🔒: Announcements.WriteAll, Announcements.ShowModule
     * @param {string} organizationId 
     * @param {AnnouncementCreate} announcementCreate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public createAnnouncement(organizationId: string, announcementCreate: AnnouncementCreate, timePeriod?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).createAnnouncement(organizationId, announcementCreate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
     * @summary Removes a announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
     * @param {string} announcementId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public deleteAnnouncement(announcementId: string, organizationId: string, timePeriod?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).deleteAnnouncement(announcementId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
     * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public getAllAnnouncements(organizationId: string, timePeriod?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).getAllAnnouncements(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all announcements, filtered by recipient (group: user) and area. No rights necessary for this call.
     * @param {Area} area 
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public getAnnouncementsOfGroup(area: Area, groupId: string, organizationId: string, timePeriod?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).getAnnouncementsOfGroup(area, groupId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all of my announcements, filtered by area. No rights necessary for this call.
     * @param {Area} area 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public getMyAnnouncements(area: Area, organizationId: string, timePeriod?: string, groupId?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).getMyAnnouncements(area, organizationId, timePeriod, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
     * @summary Returns all announcements if user is allowed to see them / user has right Announcements.ShowModule. 🔒: Announcements.ShowModule, Announcements.WriteAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {EntityType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public getRecipients(organizationId: string, timePeriod?: string, type?: EntityType, options?: any) {
        return AnnouncementsApiFp(this.configuration).getRecipients(organizationId, timePeriod, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Announcements.ShowModule</li><li>Announcements.WriteAll</li></ul>
     * @summary Update a given announcement. 🔒: Announcements.ShowModule, Announcements.WriteAll
     * @param {string} organizationId 
     * @param {AnnouncementUpdate} announcementUpdate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementsApi
     */
    public updateAnnouncement(organizationId: string, announcementUpdate: AnnouncementUpdate, timePeriod?: string, options?: any) {
        return AnnouncementsApiFp(this.configuration).updateAnnouncement(organizationId, announcementUpdate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiKeysApi - axios parameter creator
 * @export
 */
export const ApiKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Creates the desired API key and returns the needed full value to use this key. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyCreateRequest} apiKeyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: async (apiKeyCreateRequest: ApiKeyCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyCreateRequest' is not null or undefined
            assertParamExists('createApiKey', 'apiKeyCreateRequest', apiKeyCreateRequest)
            const localVarPath = `/api/v2/ApiKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Deletes the specified API key, prevents any further usage of that key to access the REST API. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyDeleteRequest} apiKeyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: async (apiKeyDeleteRequest: ApiKeyDeleteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyDeleteRequest' is not null or undefined
            assertParamExists('deleteApiKey', 'apiKeyDeleteRequest', apiKeyDeleteRequest)
            const localVarPath = `/api/v2/ApiKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The returned API keys are scrambled and can only be read once on creation.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns all available API keys for the given organization to access our REST API by 3rd party applications. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllApiKeys: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllApiKeys', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ApiKeys/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The history can be returned paginated.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns the history of ApiKey-changes. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeysHistory: async (organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getApiKeysHistory', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ApiKeys/of/{organizationId}/history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeysApi - functional programming interface
 * @export
 */
export const ApiKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Creates the desired API key and returns the needed full value to use this key. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyCreateRequest} apiKeyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKey(apiKeyCreateRequest: ApiKeyCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKey(apiKeyCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Deletes the specified API key, prevents any further usage of that key to access the REST API. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyDeleteRequest} apiKeyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKey(apiKeyDeleteRequest: ApiKeyDeleteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKey(apiKeyDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The returned API keys are scrambled and can only be read once on creation.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns all available API keys for the given organization to access our REST API by 3rd party applications. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllApiKeys(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiKeyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllApiKeys(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The history can be returned paginated.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns the history of ApiKey-changes. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeysHistory(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfActivityLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeysHistory(organizationId, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiKeysApi - factory interface
 * @export
 */
export const ApiKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiKeysApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Creates the desired API key and returns the needed full value to use this key. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyCreateRequest} apiKeyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(apiKeyCreateRequest: ApiKeyCreateRequest, options?: any): AxiosPromise<ApiKeyResponse> {
            return localVarFp.createApiKey(apiKeyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Deletes the specified API key, prevents any further usage of that key to access the REST API. 🔒: Settings.WriteApiKeys
         * @param {ApiKeyDeleteRequest} apiKeyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(apiKeyDeleteRequest: ApiKeyDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteApiKey(apiKeyDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The returned API keys are scrambled and can only be read once on creation.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns all available API keys for the given organization to access our REST API by 3rd party applications. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllApiKeys(organizationId: string, options?: any): AxiosPromise<Array<ApiKeyResponse>> {
            return localVarFp.getAllApiKeys(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * The history can be returned paginated.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
         * @summary Returns the history of ApiKey-changes. 🔒: Settings.WriteApiKeys
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeysHistory(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfActivityLogResponse> {
            return localVarFp.getApiKeysHistory(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiKeysApi - object-oriented interface
 * @export
 * @class ApiKeysApi
 * @extends {BaseAPI}
 */
export class ApiKeysApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
     * @summary Creates the desired API key and returns the needed full value to use this key. 🔒: Settings.WriteApiKeys
     * @param {ApiKeyCreateRequest} apiKeyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public createApiKey(apiKeyCreateRequest: ApiKeyCreateRequest, options?: any) {
        return ApiKeysApiFp(this.configuration).createApiKey(apiKeyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
     * @summary Deletes the specified API key, prevents any further usage of that key to access the REST API. 🔒: Settings.WriteApiKeys
     * @param {ApiKeyDeleteRequest} apiKeyDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public deleteApiKey(apiKeyDeleteRequest: ApiKeyDeleteRequest, options?: any) {
        return ApiKeysApiFp(this.configuration).deleteApiKey(apiKeyDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The returned API keys are scrambled and can only be read once on creation.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
     * @summary Returns all available API keys for the given organization to access our REST API by 3rd party applications. 🔒: Settings.WriteApiKeys
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public getAllApiKeys(organizationId: string, options?: any) {
        return ApiKeysApiFp(this.configuration).getAllApiKeys(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The history can be returned paginated.<br>Any of the following permissions are required:<ul><li>Settings.WriteApiKeys</li></ul>
     * @summary Returns the history of ApiKey-changes. 🔒: Settings.WriteApiKeys
     * @param {string} organizationId 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public getApiKeysHistory(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ApiKeysApiFp(this.configuration).getApiKeysHistory(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BildungsloginApi - axios parameter creator
 * @export
 */
export const BildungsloginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.Register</li></ul>
         * @summary Creates a registration for \"Bildungslogin\" by storing the user\'s confirmation of the redirection to the registration process of \"Bildungslogin\". The confirmation may be given repeatedly, because the user is able to open the registration process again. 🔒: Bildungslogin.Register
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistration: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createRegistration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/{organizationId}/Bildungslogin`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Returns which group roles are visible to Bildungslogin. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCirclesOfLearning: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCirclesOfLearning', 'organizationId', organizationId)
            const localVarPath = `/api/v2/{organizationId}/Bildungslogin/circlesOfLearning`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ShowModule</li></ul>
         * @summary Gets the current registration of \"Bildungslogin\". If no registration exists yet, a \"NotFound (404)\" will be returned. 🔒: Bildungslogin.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistration: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRegistration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/{organizationId}/Bildungslogin`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuildCache: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebuildCache', 'organizationId', organizationId)
            const localVarPath = `/api/v2/{organizationId}/Bildungslogin/rebuildCache`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Update the list of visible group roles. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {Array<GroupRole>} groupRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCirclesOfLearning: async (organizationId: string, groupRole: Array<GroupRole>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCirclesOfLearning', 'organizationId', organizationId)
            // verify required parameter 'groupRole' is not null or undefined
            assertParamExists('updateCirclesOfLearning', 'groupRole', groupRole)
            const localVarPath = `/api/v2/{organizationId}/Bildungslogin/circlesOfLearning`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BildungsloginApi - functional programming interface
 * @export
 */
export const BildungsloginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BildungsloginApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.Register</li></ul>
         * @summary Creates a registration for \"Bildungslogin\" by storing the user\'s confirmation of the redirection to the registration process of \"Bildungslogin\". The confirmation may be given repeatedly, because the user is able to open the registration process again. 🔒: Bildungslogin.Register
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistration(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BildungsloginRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Returns which group roles are visible to Bildungslogin. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCirclesOfLearning(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BildungsloginCirclesOfLearningResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCirclesOfLearning(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ShowModule</li></ul>
         * @summary Gets the current registration of \"Bildungslogin\". If no registration exists yet, a \"NotFound (404)\" will be returned. 🔒: Bildungslogin.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistration(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BildungsloginRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebuildCache(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebuildCache(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Update the list of visible group roles. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {Array<GroupRole>} groupRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCirclesOfLearning(organizationId: string, groupRole: Array<GroupRole>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BildungsloginCirclesOfLearningResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCirclesOfLearning(organizationId, groupRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BildungsloginApi - factory interface
 * @export
 */
export const BildungsloginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BildungsloginApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.Register</li></ul>
         * @summary Creates a registration for \"Bildungslogin\" by storing the user\'s confirmation of the redirection to the registration process of \"Bildungslogin\". The confirmation may be given repeatedly, because the user is able to open the registration process again. 🔒: Bildungslogin.Register
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistration(organizationId: string, options?: any): AxiosPromise<BildungsloginRegistration> {
            return localVarFp.createRegistration(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Returns which group roles are visible to Bildungslogin. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCirclesOfLearning(organizationId: string, options?: any): AxiosPromise<BildungsloginCirclesOfLearningResponse> {
            return localVarFp.getCirclesOfLearning(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ShowModule</li></ul>
         * @summary Gets the current registration of \"Bildungslogin\". If no registration exists yet, a \"NotFound (404)\" will be returned. 🔒: Bildungslogin.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistration(organizationId: string, options?: any): AxiosPromise<BildungsloginRegistration> {
            return localVarFp.getRegistration(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebuildCache(organizationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.rebuildCache(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
         * @summary Update the list of visible group roles. 🔒: Bildungslogin.ManageLicenses
         * @param {string} organizationId 
         * @param {Array<GroupRole>} groupRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCirclesOfLearning(organizationId: string, groupRole: Array<GroupRole>, options?: any): AxiosPromise<BildungsloginCirclesOfLearningResponse> {
            return localVarFp.updateCirclesOfLearning(organizationId, groupRole, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BildungsloginApi - object-oriented interface
 * @export
 * @class BildungsloginApi
 * @extends {BaseAPI}
 */
export class BildungsloginApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Bildungslogin.Register</li></ul>
     * @summary Creates a registration for \"Bildungslogin\" by storing the user\'s confirmation of the redirection to the registration process of \"Bildungslogin\". The confirmation may be given repeatedly, because the user is able to open the registration process again. 🔒: Bildungslogin.Register
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BildungsloginApi
     */
    public createRegistration(organizationId: string, options?: any) {
        return BildungsloginApiFp(this.configuration).createRegistration(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
     * @summary Returns which group roles are visible to Bildungslogin. 🔒: Bildungslogin.ManageLicenses
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BildungsloginApi
     */
    public getCirclesOfLearning(organizationId: string, options?: any) {
        return BildungsloginApiFp(this.configuration).getCirclesOfLearning(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Bildungslogin.ShowModule</li></ul>
     * @summary Gets the current registration of \"Bildungslogin\". If no registration exists yet, a \"NotFound (404)\" will be returned. 🔒: Bildungslogin.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BildungsloginApi
     */
    public getRegistration(organizationId: string, options?: any) {
        return BildungsloginApiFp(this.configuration).getRegistration(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
     * @summary 🔒: Bildungslogin.ManageLicenses
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BildungsloginApi
     */
    public rebuildCache(organizationId: string, options?: any) {
        return BildungsloginApiFp(this.configuration).rebuildCache(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Bildungslogin.ManageLicenses</li></ul>
     * @summary Update the list of visible group roles. 🔒: Bildungslogin.ManageLicenses
     * @param {string} organizationId 
     * @param {Array<GroupRole>} groupRole 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BildungsloginApi
     */
    public updateCirclesOfLearning(organizationId: string, groupRole: Array<GroupRole>, options?: any) {
        return BildungsloginApiFp(this.configuration).updateCirclesOfLearning(organizationId, groupRole, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CalendarsApi - axios parameter creator
 * @export
 */
export const CalendarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all calendars of the given user.              This includes: - All personal calendars - All MNSpro Cloud group calendars matching the specified timeperiod - All MNSpro Cloud group calendars without a timeperiod.
         * @param {string} periodName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (periodName: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodName' is not null or undefined
            assertParamExists('getAll', 'periodName', periodName)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Calendars/{periodName}`
                .replace(`{${"periodName"}}`, encodeURIComponent(String(periodName)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Calendar.ShowModule</li></ul>
         * @summary Returns all the parental communication appointments where the teacher/student is involved.              A teacher/student can be involved if there are non specific recipients for the appointment or if he is a participant of a course/grade with an appointment. 🔒: Calendar.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalCommunicationAppointmentsOfMe: async (organizationId: string, timePeriod?: string, start?: string, end?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllParentalCommunicationAppointmentsOfMe', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Calendars/appointments/of/me`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarsApi - functional programming interface
 * @export
 */
export const CalendarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns all calendars of the given user.              This includes: - All personal calendars - All MNSpro Cloud group calendars matching the specified timeperiod - All MNSpro Cloud group calendars without a timeperiod.
         * @param {string} periodName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(periodName: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Calendar>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(periodName, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Calendar.ShowModule</li></ul>
         * @summary Returns all the parental communication appointments where the teacher/student is involved.              A teacher/student can be involved if there are non specific recipients for the appointment or if he is a participant of a course/grade with an appointment. 🔒: Calendar.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllParentalCommunicationAppointmentsOfMe(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Appointment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllParentalCommunicationAppointmentsOfMe(organizationId, timePeriod, start, end, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CalendarsApi - factory interface
 * @export
 */
export const CalendarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns all calendars of the given user.              This includes: - All personal calendars - All MNSpro Cloud group calendars matching the specified timeperiod - All MNSpro Cloud group calendars without a timeperiod.
         * @param {string} periodName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(periodName: string, organizationId: string, options?: any): AxiosPromise<Array<Calendar>> {
            return localVarFp.getAll(periodName, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Calendar.ShowModule</li></ul>
         * @summary Returns all the parental communication appointments where the teacher/student is involved.              A teacher/student can be involved if there are non specific recipients for the appointment or if he is a participant of a course/grade with an appointment. 🔒: Calendar.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalCommunicationAppointmentsOfMe(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any): AxiosPromise<Array<Appointment>> {
            return localVarFp.getAllParentalCommunicationAppointmentsOfMe(organizationId, timePeriod, start, end, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarsApi - object-oriented interface
 * @export
 * @class CalendarsApi
 * @extends {BaseAPI}
 */
export class CalendarsApi extends BaseAPI {
    /**
     * 
     * @summary Returns all calendars of the given user.              This includes: - All personal calendars - All MNSpro Cloud group calendars matching the specified timeperiod - All MNSpro Cloud group calendars without a timeperiod.
     * @param {string} periodName 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getAll(periodName: string, organizationId: string, options?: any) {
        return CalendarsApiFp(this.configuration).getAll(periodName, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Calendar.ShowModule</li></ul>
     * @summary Returns all the parental communication appointments where the teacher/student is involved.              A teacher/student can be involved if there are non specific recipients for the appointment or if he is a participant of a course/grade with an appointment. 🔒: Calendar.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarsApi
     */
    public getAllParentalCommunicationAppointmentsOfMe(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any) {
        return CalendarsApiFp(this.configuration).getAllParentalCommunicationAppointmentsOfMe(organizationId, timePeriod, start, end, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChangelogApi - axios parameter creator
 * @export
 */
export const ChangelogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Functions as a Webhook URL. When triggered, it deletes the changelog cache.
         * @param {string} [apiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        announceUpdates: async (apiKey?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Changelog/announce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiKey !== undefined) {
                localVarQueryParameter['apiKey'] = apiKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retries all available release notes filtered by the provided ChangelogSource. Default ChangelogSource: Production.
         * @param {ChangelogSource} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdates: async (source?: ChangelogSource, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Changelog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangelogApi - functional programming interface
 * @export
 */
export const ChangelogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChangelogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Functions as a Webhook URL. When triggered, it deletes the changelog cache.
         * @param {string} [apiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async announceUpdates(apiKey?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.announceUpdates(apiKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retries all available release notes filtered by the provided ChangelogSource. Default ChangelogSource: Production.
         * @param {ChangelogSource} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpdates(source?: ChangelogSource, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Changelog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpdates(source, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChangelogApi - factory interface
 * @export
 */
export const ChangelogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChangelogApiFp(configuration)
    return {
        /**
         * 
         * @summary Functions as a Webhook URL. When triggered, it deletes the changelog cache.
         * @param {string} [apiKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        announceUpdates(apiKey?: string, options?: any): AxiosPromise<void> {
            return localVarFp.announceUpdates(apiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retries all available release notes filtered by the provided ChangelogSource. Default ChangelogSource: Production.
         * @param {ChangelogSource} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdates(source?: ChangelogSource, options?: any): AxiosPromise<Changelog> {
            return localVarFp.getUpdates(source, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChangelogApi - object-oriented interface
 * @export
 * @class ChangelogApi
 * @extends {BaseAPI}
 */
export class ChangelogApi extends BaseAPI {
    /**
     * 
     * @summary Functions as a Webhook URL. When triggered, it deletes the changelog cache.
     * @param {string} [apiKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangelogApi
     */
    public announceUpdates(apiKey?: string, options?: any) {
        return ChangelogApiFp(this.configuration).announceUpdates(apiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retries all available release notes filtered by the provided ChangelogSource. Default ChangelogSource: Production.
     * @param {ChangelogSource} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangelogApi
     */
    public getUpdates(source?: ChangelogSource, options?: any) {
        return ChangelogApiFp(this.configuration).getUpdates(source, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClassRegisterApi - axios parameter creator
 * @export
 */
export const ClassRegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns student absences. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {AbsencesGetOfStudentRequestFilter} [filter] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {string} [courseId] 
         * @param {string} [absenceReasonId] 
         * @param {string} [timePeriod] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudent: async (organizationId: string, studentId: string, filter?: AbsencesGetOfStudentRequestFilter, start?: string, end?: string, courseId?: string, absenceReasonId?: string, timePeriod?: string, pageSize?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('absencesOfStudent', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('absencesOfStudent', 'studentId', studentId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/student/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (absenceReasonId !== undefined) {
                localVarQueryParameter['absenceReasonId'] = absenceReasonId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns detailed information about the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudentDetails: async (organizationId: string, studentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('absencesOfStudentDetails', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('absencesOfStudentDetails', 'studentId', studentId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/student/{studentId}/details`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns all absences between a given date range of the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} from 
         * @param {string} to 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudentTimetableFormatHandler: async (organizationId: string, studentId: string, from: string, to: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('absencesOfStudentTimetableFormatHandler', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('absencesOfStudentTimetableFormatHandler', 'studentId', studentId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('absencesOfStudentTimetableFormatHandler', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('absencesOfStudentTimetableFormatHandler', 'to', to)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/student/{studentId}/{from}/{to}/timetable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)))
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Add an attachment to the given absence-id 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} absenceId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment: async (organizationId: string, timePeriod: string, absenceId: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addAttachment', 'organizationId', organizationId)
            // verify required parameter 'timePeriod' is not null or undefined
            assertParamExists('addAttachment', 'timePeriod', timePeriod)
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('addAttachment', 'absenceId', absenceId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{timePeriod}/{absenceId}/attachment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"timePeriod"}}`, encodeURIComponent(String(timePeriod)))
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the given time pattern activation state.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {ActivationState} [activationState] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTimePatternActivationState: async (organizationId: string, timePatternId: string, activationState?: ActivationState, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeTimePatternActivationState', 'organizationId', organizationId)
            // verify required parameter 'timePatternId' is not null or undefined
            assertParamExists('changeTimePatternActivationState', 'timePatternId', timePatternId)
            const localVarPath = `/api/v2/ClassRegister/pattern/{organizationId}/activation/{timePatternId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"timePatternId"}}`, encodeURIComponent(String(timePatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (activationState !== undefined) {
                localVarQueryParameter['activationState'] = activationState;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single absence. Avoid using this when creating multiple absences at once. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence: async (organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAbsence', 'organizationId', organizationId)
            // verify required parameter 'absenceEntry' is not null or undefined
            assertParamExists('createAbsence', 'absenceEntry', absenceEntry)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionEntry} excuseDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsenceExcuseDefinition: async (organizationId: string, excuseDefinitionEntry: ExcuseDefinitionEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAbsenceExcuseDefinition', 'organizationId', organizationId)
            // verify required parameter 'excuseDefinitionEntry' is not null or undefined
            assertParamExists('createAbsenceExcuseDefinition', 'excuseDefinitionEntry', excuseDefinitionEntry)
            const localVarPath = `/api/v2/ClassRegister/absences/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(excuseDefinitionEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single absence reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonEntry} absenceReasonEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsencesReasons: async (organizationId: string, absenceReasonEntry: AbsenceReasonEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAbsencesReasons', 'organizationId', organizationId)
            // verify required parameter 'absenceReasonEntry' is not null or undefined
            assertParamExists('createAbsencesReasons', 'absenceReasonEntry', absenceReasonEntry)
            const localVarPath = `/api/v2/ClassRegister/absences/reasons/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceReasonEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates multiple absences in bulk. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a bunch of students at the same time that span over multiple courses. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceBulkRequestContainer} absenceBulkRequestContainer 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkAbsences: async (organizationId: string, absenceBulkRequestContainer: AbsenceBulkRequestContainer, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createBulkAbsences', 'organizationId', organizationId)
            // verify required parameter 'absenceBulkRequestContainer' is not null or undefined
            assertParamExists('createBulkAbsences', 'absenceBulkRequestContainer', absenceBulkRequestContainer)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/bulk`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceBulkRequestContainer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Class entry for the desired organization group. GradeId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassCreateEntry} classCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClass: async (gradeId: string, organizationId: string, classCreateEntry: ClassCreateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('createClass', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClass', 'organizationId', organizationId)
            // verify required parameter 'classCreateEntry' is not null or undefined
            assertParamExists('createClass', 'classCreateEntry', classCreateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/classes/{gradeId}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Creates the given class service. 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {ClassServicesEntry} classServicesEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassService: async (organizationId: string, classServicesEntry: ClassServicesEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClassService', 'organizationId', organizationId)
            // verify required parameter 'classServicesEntry' is not null or undefined
            assertParamExists('createClassService', 'classServicesEntry', classServicesEntry)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classServicesEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServicesDefinitionEntry} classServicesDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassServiceDefinition: async (organizationId: string, classServicesDefinitionEntry: ClassServicesDefinitionEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClassServiceDefinition', 'organizationId', organizationId)
            // verify required parameter 'classServicesDefinitionEntry' is not null or undefined
            assertParamExists('createClassServiceDefinition', 'classServicesDefinitionEntry', classServicesDefinitionEntry)
            const localVarPath = `/api/v2/ClassRegister/services/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classServicesDefinitionEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntry-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryRequest} classbookEntryCategoryRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntriesCategory: async (organizationId: string, classbookEntryCategoryRequest: ClassbookEntryCategoryRequest, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClassbookEntriesCategory', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryCategoryRequest' is not null or undefined
            assertParamExists('createClassbookEntriesCategory', 'classbookEntryCategoryRequest', classbookEntryCategoryRequest)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/category/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionEntry} classbookEntryDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntriesDefinition: async (organizationId: string, classbookEntryDefinitionEntry: ClassbookEntryDefinitionEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClassbookEntriesDefinition', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryDefinitionEntry' is not null or undefined
            assertParamExists('createClassbookEntriesDefinition', 'classbookEntryDefinitionEntry', classbookEntryDefinitionEntry)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryDefinitionEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single specified ClassbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryCreateRequest} classbookEntryCreateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntry: async (organizationId: string, classbookEntryCreateRequest: ClassbookEntryCreateRequest, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createClassbookEntry', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryCreateRequest' is not null or undefined
            assertParamExists('createClassbookEntry', 'classbookEntryCreateRequest', classbookEntryCreateRequest)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified course entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseCreateEntry} courseCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourse: async (organizationId: string, courseCreateEntry: CourseCreateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCourse', 'organizationId', organizationId)
            // verify required parameter 'courseCreateEntry' is not null or undefined
            assertParamExists('createCourse', 'courseCreateEntry', courseCreateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/courses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Grade entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeCreateEntry} gradeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrade: async (organizationId: string, gradeCreateEntry: GradeCreateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createGrade', 'organizationId', organizationId)
            // verify required parameter 'gradeCreateEntry' is not null or undefined
            assertParamExists('createGrade', 'gradeCreateEntry', gradeCreateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/grades`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gradeCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayEntry} holidayEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHoliday: async (organizationId: string, holidayEntry: HolidayEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createHoliday', 'organizationId', organizationId)
            // verify required parameter 'holidayEntry' is not null or undefined
            assertParamExists('createHoliday', 'holidayEntry', holidayEntry)
            const localVarPath = `/api/v2/ClassRegister/timeTable/holiday/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(holidayEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkCreate} homeworkCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHomework: async (organizationId: string, homeworkCreate: HomeworkCreate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createHomework', 'organizationId', organizationId)
            // verify required parameter 'homeworkCreate' is not null or undefined
            assertParamExists('createHomework', 'homeworkCreate', homeworkCreate)
            const localVarPath = `/api/v2/ClassRegister/homework/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeworkCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeCreateEntry} lessonThemeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLessonTheme: async (organizationId: string, lessonThemeCreateEntry: LessonThemeCreateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createLessonTheme', 'organizationId', organizationId)
            // verify required parameter 'lessonThemeCreateEntry' is not null or undefined
            assertParamExists('createLessonTheme', 'lessonThemeCreateEntry', lessonThemeCreateEntry)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lessonThemeCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given lessontheme-methodofteaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingEntry} methodOfTeachingEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMethodOfTeaching: async (organizationId: string, methodOfTeachingEntry: MethodOfTeachingEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createMethodOfTeaching', 'organizationId', organizationId)
            // verify required parameter 'methodOfTeachingEntry' is not null or undefined
            assertParamExists('createMethodOfTeaching', 'methodOfTeachingEntry', methodOfTeachingEntry)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/method/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(methodOfTeachingEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates OR updates multiple absences. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a course at once ! 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {AbsencesCreateOrUpdateLists} absencesCreateOrUpdateLists 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAbsences: async (lessonId: string, organizationId: string, absencesCreateOrUpdateLists: AbsencesCreateOrUpdateLists, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('createOrUpdateAbsences', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateAbsences', 'organizationId', organizationId)
            // verify required parameter 'absencesCreateOrUpdateLists' is not null or undefined
            assertParamExists('createOrUpdateAbsences', 'absencesCreateOrUpdateLists', absencesCreateOrUpdateLists)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absencesCreateOrUpdateLists, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified EditAndNotificationSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {EditAndNotificationSettingsItem} editAndNotificationSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateEditAndNotificationSettings: async (organizationId: string, editAndNotificationSettingsItem: EditAndNotificationSettingsItem, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateEditAndNotificationSettings', 'organizationId', organizationId)
            // verify required parameter 'editAndNotificationSettingsItem' is not null or undefined
            assertParamExists('createOrUpdateEditAndNotificationSettings', 'editAndNotificationSettingsItem', editAndNotificationSettingsItem)
            const localVarPath = `/api/v2/ClassRegister/settings/notification/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editAndNotificationSettingsItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified GeneralSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {GeneralSettingsItem} generalSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateGeneralSettings: async (organizationId: string, generalSettingsItem: GeneralSettingsItem, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateGeneralSettings', 'organizationId', organizationId)
            // verify required parameter 'generalSettingsItem' is not null or undefined
            assertParamExists('createOrUpdateGeneralSettings', 'generalSettingsItem', generalSettingsItem)
            const localVarPath = `/api/v2/ClassRegister/generalSettings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalSettingsItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or updates the given schoolData item, depending on if any item already exists.
         * @param {string} organizationId 
         * @param {SchoolContact} schoolContact 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolData: async (organizationId: string, schoolContact: SchoolContact, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateSchoolData', 'organizationId', organizationId)
            // verify required parameter 'schoolContact' is not null or undefined
            assertParamExists('createOrUpdateSchoolData', 'schoolContact', schoolContact)
            const localVarPath = `/api/v2/ClassRegister/contact/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schoolContact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of head teachers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolHeadTeachers: async (organizationId: string, requestBody: Array<string>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateSchoolHeadTeachers', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createOrUpdateSchoolHeadTeachers', 'requestBody', requestBody)
            const localVarPath = `/api/v2/ClassRegister/management/headTeachers/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of school managers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolManagers: async (organizationId: string, requestBody: Array<string>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateSchoolManagers', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createOrUpdateSchoolManagers', 'requestBody', requestBody)
            const localVarPath = `/api/v2/ClassRegister/management/managers/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanEntry} seatingPlanEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeatingPlan: async (organizationId: string, seatingPlanEntry: SeatingPlanEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanEntry' is not null or undefined
            assertParamExists('createSeatingPlan', 'seatingPlanEntry', seatingPlanEntry)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seatingPlanEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequest} timePatternRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimePattern: async (organizationId: string, timePatternRequest: TimePatternRequest, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createTimePattern', 'organizationId', organizationId)
            // verify required parameter 'timePatternRequest' is not null or undefined
            assertParamExists('createTimePattern', 'timePatternRequest', timePatternRequest)
            const localVarPath = `/api/v2/ClassRegister/pattern/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timePatternRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given class absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsence: async (absenceId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('deleteAbsence', 'absenceId', absenceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAbsence', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason-definition. 🔒: Settings.Classbook
         * @param {string} excuseDefinitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsenceExcuseDefinition: async (excuseDefinitionId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'excuseDefinitionId' is not null or undefined
            assertParamExists('deleteAbsenceExcuseDefinition', 'excuseDefinitionId', excuseDefinitionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAbsenceExcuseDefinition', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/definition/{organizationId}/{excuseDefinitionId}`
                .replace(`{${"excuseDefinitionId"}}`, encodeURIComponent(String(excuseDefinitionId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason. 🔒: Settings.Classbook
         * @param {string} absenceReasonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsenceReason: async (absenceReasonId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceReasonId' is not null or undefined
            assertParamExists('deleteAbsenceReason', 'absenceReasonId', absenceReasonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAbsenceReason', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/reason/{organizationId}/{absenceReasonId}`
                .replace(`{${"absenceReasonId"}}`, encodeURIComponent(String(absenceReasonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given attachment for the given absence-id. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (absenceId: string, organizationId: string, fileName: string, timePeriod: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('deleteAttachment', 'absenceId', absenceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAttachment', 'organizationId', organizationId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('deleteAttachment', 'fileName', fileName)
            // verify required parameter 'timePeriod' is not null or undefined
            assertParamExists('deleteAttachment', 'timePeriod', timePeriod)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{timePeriod}/{absenceId}/attachments/{fileName}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"timePeriod"}}`, encodeURIComponent(String(timePeriod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Class from the given organization. Checks if any Courses exists inside the class before the actual delete. 🔒: Settings.Classbook
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClass: async (classId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('deleteClass', 'classId', classId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClass', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/classes/{classId}`
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassService: async (organizationId: string, serviceId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClassService', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('deleteClassService', 'serviceId', serviceId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/{serviceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassServiceDefinition: async (organizationId: string, serviceId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClassServiceDefinition', 'organizationId', organizationId)
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('deleteClassServiceDefinition', 'serviceId', serviceId)
            const localVarPath = `/api/v2/ClassRegister/services/definition/{organizationId}/{serviceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The category won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified category from the given organization. 🔒: Settings.Classbook
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntriesCategory: async (categoryId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteClassbookEntriesCategory', 'categoryId', categoryId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClassbookEntriesCategory', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/category/{organizationId}/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The definition won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified definition from the given organization. 🔒: Settings.Classbook
         * @param {string} definitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntriesDefinition: async (definitionId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('deleteClassbookEntriesDefinition', 'definitionId', definitionId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClassbookEntriesDefinition', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/definition/{organizationId}/{definitionId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Deletes a ClassbookEntry 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} classbookEntryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntry: async (classbookEntryId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classbookEntryId' is not null or undefined
            assertParamExists('deleteClassbookEntry', 'classbookEntryId', classbookEntryId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteClassbookEntry', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/{organizationId}/{classbookEntryId}`
                .replace(`{${"classbookEntryId"}}`, encodeURIComponent(String(classbookEntryId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified course from the given organization. 🔒: Settings.Classbook
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourse: async (courseId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('deleteCourse', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCourse', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/courses/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Grade from the given organization. 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrade: async (gradeId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('deleteGrade', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteGrade', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/grades/{gradeId}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the specified homework entry from the given organization. 🔒: Classbook.ShowModule
         * @param {string} homeworkId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHomework: async (homeworkId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'homeworkId' is not null or undefined
            assertParamExists('deleteHomework', 'homeworkId', homeworkId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteHomework', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/homework/{organizationId}/{homeworkId}`
                .replace(`{${"homeworkId"}}`, encodeURIComponent(String(homeworkId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLessonTheme: async (lessonThemeId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonThemeId' is not null or undefined
            assertParamExists('deleteLessonTheme', 'lessonThemeId', lessonThemeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteLessonTheme', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}/{lessonThemeId}`
                .replace(`{${"lessonThemeId"}}`, encodeURIComponent(String(lessonThemeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given lesson theme - method of teaching. 🔒: Settings.Classbook
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMethodOfTeaching: async (methodOfTeachingId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'methodOfTeachingId' is not null or undefined
            assertParamExists('deleteMethodOfTeaching', 'methodOfTeachingId', methodOfTeachingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMethodOfTeaching', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/method/{organizationId}/{methodOfTeachingId}`
                .replace(`{${"methodOfTeachingId"}}`, encodeURIComponent(String(methodOfTeachingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes the given seating plan.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeatingPlan: async (organizationId: string, seatingPlanId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanId' is not null or undefined
            assertParamExists('deleteSeatingPlan', 'seatingPlanId', seatingPlanId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}/{seatingPlanId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"seatingPlanId"}}`, encodeURIComponent(String(seatingPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes the current time pattern.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimePattern: async (organizationId: string, timePatternId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteTimePattern', 'organizationId', organizationId)
            // verify required parameter 'timePatternId' is not null or undefined
            assertParamExists('deleteTimePattern', 'timePatternId', timePatternId)
            const localVarPath = `/api/v2/ClassRegister/pattern/{organizationId}/{timePatternId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"timePatternId"}}`, encodeURIComponent(String(timePatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given holiday. 🔒: Settings.Classbook
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletesAHoliday: async (holidayId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'holidayId' is not null or undefined
            assertParamExists('deletesAHoliday', 'holidayId', holidayId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletesAHoliday', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/holiday/{organizationId}/{holidayId}`
                .replace(`{${"holidayId"}}`, encodeURIComponent(String(holidayId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of the school. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [reasonId] 
         * @param {string} [searchForName] 
         * @param {Sequence} [sequence] 
         * @param {SortableBy} [sortBy] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceOverview: async (organizationId: string, skip: number, take: number, reasonId?: string, searchForName?: string, sequence?: Sequence, sortBy?: SortableBy, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAbsenceOverview', 'organizationId', organizationId)
            // verify required parameter 'skip' is not null or undefined
            assertParamExists('getAbsenceOverview', 'skip', skip)
            // verify required parameter 'take' is not null or undefined
            assertParamExists('getAbsenceOverview', 'take', take)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/overview/skip/{skip}/take/{take}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"skip"}}`, encodeURIComponent(String(skip)))
                .replace(`{${"take"}}`, encodeURIComponent(String(take)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (reasonId !== undefined) {
                localVarQueryParameter['reasonId'] = reasonId;
            }

            if (searchForName !== undefined) {
                localVarQueryParameter['searchForName'] = searchForName;
            }

            if (sequence !== undefined) {
                localVarQueryParameter['sequence'] = sequence;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Get all reasons which are using the given excuse definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} excuseDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasonsOfDefinition: async (organizationId: string, excuseDefinitionId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAbsenceReasonsOfDefinition', 'organizationId', organizationId)
            // verify required parameter 'excuseDefinitionId' is not null or undefined
            assertParamExists('getAbsenceReasonsOfDefinition', 'excuseDefinitionId', excuseDefinitionId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/reasons/of/definition/{excuseDefinitionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"excuseDefinitionId"}}`, encodeURIComponent(String(excuseDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Check the amount of absences in a given time period. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesCount: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAbsencesCount', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns excuse-definitions of the whole organization. Parameter isEnabled is optional. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceExcuseDefinitions: async (organizationId: string, enabledOnly?: boolean, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceExcuseDefinitions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absence-reasons of the whole organization. Parameter reasonDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceReasons: async (organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsenceReasons', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/reason/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (reasonDefinitionId !== undefined) {
                localVarQueryParameter['reasonDefinitionId'] = reasonDefinitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absences of all students in the given organization at the current time period between dayStart and dayEnd. ExcuseDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [excuseDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsences: async (dayEnd: string, dayStart: string, organizationId: string, excuseDefinitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllAbsences', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllAbsences', 'dayStart', dayStart)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAbsences', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{dayStart}/{dayEnd}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (excuseDefinitionId !== undefined) {
                localVarQueryParameter['excuseDefinitionId'] = excuseDefinitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary Returns all basicClasses the user effectively has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicClasses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicClasses', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/classes/basic`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basicClasses no matter if iam in that class or how the grade was 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicClassesOfSettings: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicClassesOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/classes/basic`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.ReadAll</li><li>Absences.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Classbook.ShowModule, Timetable.ReadAll, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicCourses', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/courses/basic`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basic courses no matter if the person which is requesting is part of that course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCoursesOfSettings: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicCoursesOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/courses/basic`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary By default this returns all basic grades the user effectivly has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGrades: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicGrades', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/grades`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all grades. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGradesOfSettings: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicGradesOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/grades`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns all definitions for the given organization group. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassServiceDefinitions: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllClassServiceDefinitions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/services/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization group of the given user, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id and or group id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassServicesByStudent: async (dayEnd: string, dayStart: string, organizationId: string, studentId: string, definitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllClassServicesByStudent', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllClassServicesByStudent', 'dayStart', dayStart)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllClassServicesByStudent', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('getAllClassServicesByStudent', 'studentId', studentId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/{dayStart}/{dayEnd}/{studentId}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (definitionId !== undefined) {
                localVarQueryParameter['definitionId'] = definitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries where the specified period matches. Optional, filter by Category beforehand. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntries: async (dayEnd: string, dayStart: string, organizationId: string, categoryId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllClassbookEntries', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllClassbookEntries', 'dayStart', dayStart)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllClassbookEntries', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/{organizationId}/{dayStart}/{dayEnd}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries for the given group where the specified date/time is greater or equal the given dates, range can be any time in this current time period. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntriesByGroup: async (end: string, groupId: string, organizationId: string, start: string, categoryId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getAllClassbookEntriesByGroup', 'end', end)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAllClassbookEntriesByGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllClassbookEntriesByGroup', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getAllClassbookEntriesByGroup', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/{organizationId}/{start}/{end}/group/{groupId}`
                .replace(`{${"end"}}`, encodeURIComponent(String(end)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all categories from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntriesCategories: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllClassbookEntriesCategories', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/category/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all definitions from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntryDefinitions: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllEntryDefinitions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all holidays for the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHolidays: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllHolidays', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/holiday/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given date range, where the start date is greater or equal the given day or the end date is less then the given day. Optional : filter by Deadline 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHomework: async (dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllHomework', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllHomework', 'dayStart', dayStart)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllHomework', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/homework/{organizationId}/{dayStart}/{dayEnd}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given course, where the start date is greater or equal the given day or the end date is less then the given day. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [dayEnd] 
         * @param {string} [dayStart] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHomeworkByCourse: async (courseId: string, organizationId: string, dayEnd?: string, dayStart?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getAllHomeworkByCourse', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllHomeworkByCourse', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/homework/{organizationId}/course/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dayEnd !== undefined) {
                localVarQueryParameter['dayEnd'] = (dayEnd as any instanceof Date) ?
                    (dayEnd as any).toISOString() :
                    dayEnd;
            }

            if (dayStart !== undefined) {
                localVarQueryParameter['dayStart'] = (dayStart as any instanceof Date) ?
                    (dayStart as any).toISOString() :
                    dayStart;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessonThemes for the given organization group, where the given date/time is greater or equal the lessonTheme start date or less then the lessonTheme end date. Optional filter by methodOfTeaching. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessonThemes: async (dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllLessonThemes', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllLessonThemes', 'dayStart', dayStart)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllLessonThemes', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}/{dayStart}/{dayEnd}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lesson themes for the given organization group, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessonThemesByGroup: async (dayEnd: string, dayStart: string, groupId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dayEnd' is not null or undefined
            assertParamExists('getAllLessonThemesByGroup', 'dayEnd', dayEnd)
            // verify required parameter 'dayStart' is not null or undefined
            assertParamExists('getAllLessonThemesByGroup', 'dayStart', dayStart)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAllLessonThemesByGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllLessonThemesByGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}/{dayStart}/{dayEnd}/group/{groupId}`
                .replace(`{${"dayEnd"}}`, encodeURIComponent(String(dayEnd)))
                .replace(`{${"dayStart"}}`, encodeURIComponent(String(dayStart)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all methods of teaching for the given organization group. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMethodsOfTeaching: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllMethodsOfTeaching', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/method/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all available seating plan (names and ids) in the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSeatingPlans: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllSeatingPlans', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all time patterns for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimePatterns: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllTimePatterns', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/pattern/all/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all rooms used by the timetable. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimetableRooms: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllTimetableRooms', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/rooms/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Get content for the given attachment. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} absenceId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment: async (organizationId: string, absenceId: string, fileName: string, timePeriod: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAttachment', 'organizationId', organizationId)
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('getAttachment', 'absenceId', absenceId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getAttachment', 'fileName', fileName)
            // verify required parameter 'timePeriod' is not null or undefined
            assertParamExists('getAttachment', 'timePeriod', timePeriod)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{timePeriod}/{absenceId}/attachment/{fileName}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)))
                .replace(`{${"timePeriod"}}`, encodeURIComponent(String(timePeriod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the specified group. Optional: Include group members. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {boolean} [includeMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzureGroup: async (groupId: string, organizationId: string, includeMembers?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAzureGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAzureGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/azuregroups/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (includeMembers !== undefined) {
                localVarQueryParameter['includeMembers'] = includeMembers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all azure groups of the tenant/organization with the specified role (optional). By default, only groups with the origin \"AixConcept\" will be returned. This means, groups will also get filtered by its \"OrganizationId\". 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Origin} [origin] 
         * @param {GroupRole} [role] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzureGroups: async (organizationId: string, origin?: Origin, role?: GroupRole, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAzureGroups', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/azuregroups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a class. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} classId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassAbsences: async (classId: string, month: number, organizationId: string, year: number, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('getClassAbsences', 'classId', classId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getClassAbsences', 'month', month)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClassAbsences', 'organizationId', organizationId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getClassAbsences', 'year', year)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/class/{classId}/{year}/{month}`
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services of the required group. This includes all services attached to corresponding classes. Note: Students will also see services not attached to themselves. 🔒: Courses.ShowModule
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassServicesOfGroup: async (groupId: string, organizationId: string, definitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getClassServicesOfGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClassServicesOfGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/of/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (definitionId !== undefined) {
                localVarQueryParameter['definitionId'] = definitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization groups lesson. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassServicesOfLesson: async (lessonId: string, organizationId: string, definitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getClassServicesOfLesson', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClassServicesOfLesson', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (definitionId !== undefined) {
                localVarQueryParameter['definitionId'] = definitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a course. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} courseId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseAbsences: async (courseId: string, month: number, organizationId: string, year: number, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getCourseAbsences', 'courseId', courseId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getCourseAbsences', 'month', month)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCourseAbsences', 'organizationId', organizationId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getCourseAbsences', 'year', year)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/course/{courseId}/{year}/{month}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the students of a course. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseStudents: async (courseId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getCourseStudents', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCourseStudents', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/courses/{courseId}/students`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns the edit and notification settings. 🔒: Settings.Classbook, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEditAndNotificationSettings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEditAndNotificationSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/settings/notification/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the general settings. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralSettings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGeneralSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/generalSettings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a grade. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} gradeId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGradeAbsences: async (gradeId: string, month: number, organizationId: string, year: number, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('getGradeAbsences', 'gradeId', gradeId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getGradeAbsences', 'month', month)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGradeAbsences', 'organizationId', organizationId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getGradeAbsences', 'year', year)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/grade/{gradeId}/{year}/{month}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the latest absence of the given absence-id 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAbsence: async (absenceId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'absenceId' is not null or undefined
            assertParamExists('getLatestAbsence', 'absenceId', absenceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestAbsence', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/{absenceId}`
                .replace(`{${"absenceId"}}`, encodeURIComponent(String(absenceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest service for the given organization group where the class-service-id matches 🔒: Classbook.ShowModule
         * @param {string} classServiceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassService: async (classServiceId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classServiceId' is not null or undefined
            assertParamExists('getLatestClassService', 'classServiceId', classServiceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestClassService', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/latest/{classServiceId}`
                .replace(`{${"classServiceId"}}`, encodeURIComponent(String(classServiceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the latest class-service-definition for the given organization group and the given class-service-definiton-id. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassServicesDefinition: async (organizationId: string, serviceDefinitionId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestClassServicesDefinition', 'organizationId', organizationId)
            // verify required parameter 'serviceDefinitionId' is not null or undefined
            assertParamExists('getLatestClassServicesDefinition', 'serviceDefinitionId', serviceDefinitionId)
            const localVarPath = `/api/v2/ClassRegister/services/definition/{organizationId}/latest/{serviceDefinitionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"serviceDefinitionId"}}`, encodeURIComponent(String(serviceDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest Class by id the user effectively has access to. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassWithBasicCourses: async (classId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('getLatestClassWithBasicCourses', 'classId', classId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestClassWithBasicCourses', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/classes/{classId}`
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Class by id 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassWithBasicCoursesOfSettings: async (classId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('getLatestClassWithBasicCoursesOfSettings', 'classId', classId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestClassWithBasicCoursesOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/classes/{classId}`
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest course by id the user has effectively access to. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestCourse: async (courseId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getLatestCourse', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestCourse', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/courses/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest course by id. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestCourseOfSettings: async (courseId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getLatestCourseOfSettings', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestCourseOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/courses/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Grade by id if the user effectively has access to it. Also returns basic of all corresponding classes. 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestGradeWithBasicClasses: async (gradeId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('getLatestGradeWithBasicClasses', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestGradeWithBasicClasses', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/grades/{gradeId}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns the latest Grade by id, also returns basic of all corresponding classes 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestGradeWithBasicClassesOfSettings: async (gradeId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('getLatestGradeWithBasicClassesOfSettings', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestGradeWithBasicClassesOfSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/grades/{gradeId}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the latest holiday for the given organization group where the holiday-id matches
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestHoliday: async (holidayId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'holidayId' is not null or undefined
            assertParamExists('getLatestHoliday', 'holidayId', holidayId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestHoliday', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/holiday/{organizationId}/latest/{holidayId}`
                .replace(`{${"holidayId"}}`, encodeURIComponent(String(holidayId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the lesson by LessonId. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLesson: async (lessonId: string, organizationId: string, timePeriod?: string, includeDrafts?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getLatestLesson', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestLesson', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (includeDrafts !== undefined) {
                localVarQueryParameter['includeDrafts'] = includeDrafts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest lessonThemes for the given organization group by lesson-theme-Id 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLessonTheme: async (lessonThemeId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonThemeId' is not null or undefined
            assertParamExists('getLatestLessonTheme', 'lessonThemeId', lessonThemeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestLessonTheme', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}/{lessonThemeId}`
                .replace(`{${"lessonThemeId"}}`, encodeURIComponent(String(lessonThemeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest methods of teaching for the given organization group by method-of-teaching-Id. 🔒: Classbook.ShowModule
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMethodOfTeaching: async (methodOfTeachingId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'methodOfTeachingId' is not null or undefined
            assertParamExists('getLatestMethodOfTeaching', 'methodOfTeachingId', methodOfTeachingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestMethodOfTeaching', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/method/{organizationId}/{methodOfTeachingId}`
                .replace(`{${"methodOfTeachingId"}}`, encodeURIComponent(String(methodOfTeachingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary Returns all draft absences that overlap the given lesson\'s time window for its students. Drafts that have already been accepted into a real absence are excluded. 🔒: Absences.ShowDrafts
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonDraftAbsences: async (lessonId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getLessonDraftAbsences', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonDraftAbsences', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/{lessonId}/absence-drafts`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the next lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [endOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonOfCourseNext: async (courseId: string, organizationId: string, endOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getLessonOfCourseNext', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonOfCourseNext', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/course/{courseId}/next`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (endOfCurrentLesson !== undefined) {
                localVarQueryParameter['endOfCurrentLesson'] = (endOfCurrentLesson as any instanceof Date) ?
                    (endOfCurrentLesson as any).toISOString() :
                    endOfCurrentLesson;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (includeDrafts !== undefined) {
                localVarQueryParameter['includeDrafts'] = includeDrafts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the previous lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [startOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonOfCoursePrevious: async (courseId: string, organizationId: string, startOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getLessonOfCoursePrevious', 'courseId', courseId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonOfCoursePrevious', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/course/{courseId}/previous`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startOfCurrentLesson !== undefined) {
                localVarQueryParameter['startOfCurrentLesson'] = (startOfCurrentLesson as any instanceof Date) ?
                    (startOfCurrentLesson as any).toISOString() :
                    startOfCurrentLesson;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (includeDrafts !== undefined) {
                localVarQueryParameter['includeDrafts'] = includeDrafts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons of the request-caller who have no assigned lessonTheme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonWithoutTheme: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonWithoutTheme', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/notheme/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all class lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfClassRange: async (classId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('getLessonsOfClassRange', 'classId', classId)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getLessonsOfClassRange', 'end', end)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonsOfClassRange', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getLessonsOfClassRange', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/class/{classId}/{start}/{end}`
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)))
                .replace(`{${"end"}}`, encodeURIComponent(String(end)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all course lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfCourseRange: async (courseId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getLessonsOfCourseRange', 'courseId', courseId)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getLessonsOfCourseRange', 'end', end)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonsOfCourseRange', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getLessonsOfCourseRange', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/course/{courseId}/{start}/{end}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"end"}}`, encodeURIComponent(String(end)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all gerade lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfGradeRange: async (end: string, gradeId: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getLessonsOfGradeRange', 'end', end)
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('getLessonsOfGradeRange', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonsOfGradeRange', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getLessonsOfGradeRange', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/grade/{gradeId}/{start}/{end}`
                .replace(`{${"end"}}`, encodeURIComponent(String(end)))
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all my lessons from the given start time for the next 24 hours. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start Defines date time of first item. Returns all items for the next 24 hours.
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfMyAgenda: async (organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonsOfMyAgenda', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getLessonsOfMyAgenda', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/lesson/my/agenda/{organizationId}/{start}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all next lessons from the start time for all my courses. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfMyCourses: async (organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonsOfMyCourses', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getLessonsOfMyCourses', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/lesson/my/courses/{organizationId}/{start}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the number of unsigned lessons of the request-caller and the number of lessons without an assigned lessonTheme as an array of two integers. Note: this method still consumes high amounts of RUs, use wisely. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingInformationsCount: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMissingInformationsCount', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/missing/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services for the requesting user, which are not deactivated by definition. Optional filter by definition id. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyClassServices: async (organizationId: string, definitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyClassServices', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}/my`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (definitionId !== undefined) {
                localVarQueryParameter['definitionId'] = definitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information.
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomework: async (timePeriod?: string, excludeTeamsAssignments?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ClassRegister/homework/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (excludeTeamsAssignments !== undefined) {
                localVarQueryParameter['excludeTeamsAssignments'] = excludeTeamsAssignments;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all specified homework for the given course if the user is member of the course. This will return everything for the current timePeriod.
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomeworkByCourse: async (courseId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getMyHomeworkByCourse', 'courseId', courseId)
            const localVarPath = `/api/v2/ClassRegister/homework/my/of/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the effictive lesson permissions 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLessonPermissions: async (lessonId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getMyLessonPermissions', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyLessonPermissions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/permissionsOf/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the substitutions for the current user.
         * @param {string} organizationId 
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySubstitutions: async (organizationId: string, start: string, dayCount?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMySubstitutions', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getMySubstitutions', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/timeTable/substitutions/{organizationId}/my/{start}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dayCount !== undefined) {
                localVarQueryParameter['dayCount'] = dayCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons that the provided user still has to sign, or that belong to a given group. At least the user id or the group id must be provided. Optional filterLessonTheme narrows the result to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoSignedLessonsByUserAndOrGroup: async (organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, filterLessonTheme?: LessonThemeFilterType, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getNoSignedLessonsByUserAndOrGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/unsigned/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }

            if (filterLessonTheme !== undefined) {
                localVarQueryParameter['filterLessonTheme'] = filterLessonTheme;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary Returns the import report of the reuqested organization. 🔒: Settings.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getReport', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/importReport/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the current school contact for the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolData: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSchoolData', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/contact/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Returns all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolEventMappings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSchoolEventMappings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/timeTable/schoolEventMappings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school head teachers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolHeadTeachers: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSchoolHeadTeachers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/management/headTeachers/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school managers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolManagers: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSchoolManagers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/management/managers/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the latest seating plan in the given organization by seating-plan-id.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeatingPlan: async (organizationId: string, seatingPlanId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanId' is not null or undefined
            assertParamExists('getSeatingPlan', 'seatingPlanId', seatingPlanId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}/latestOf/{seatingPlanId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"seatingPlanId"}}`, encodeURIComponent(String(seatingPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the seating plan of the desired course in the given organization.
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeatingPlanByGroup: async (groupId: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getSeatingPlanByGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSeatingPlanByGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutions: async (start?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ClassRegister/timeTable/substitutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the current active time pattern for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTheActiveTimePattern', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/pattern/active/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableSettings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimeTableSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/settings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available course names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableCourseNames: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableCourseNames', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/courseNames/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available lesson names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableLessonNames: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableLessonNames', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/lessonNames/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableMappings: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableMappings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/mappings/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified group starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfGroup: async (days: number, groupId: string, organizationId: string, start: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimetableOfGroup', 'days', days)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getTimetableOfGroup', 'groupId', groupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableOfGroup', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimetableOfGroup', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/timeTable/{start}/next/{days}/days/of/{organizationId}/group/{groupId}`
                .replace(`{${"days"}}`, encodeURIComponent(String(days)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified room starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfRoom: async (days: number, organizationId: string, roomId: string, start: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimetableOfRoom', 'days', days)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableOfRoom', 'organizationId', organizationId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getTimetableOfRoom', 'roomId', roomId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimetableOfRoom', 'start', start)
            const localVarPath = `/api/v2/ClassRegister/timeTable/{start}/next/{days}/days/of/{organizationId}/room/{roomId}`
                .replace(`{${"days"}}`, encodeURIComponent(String(days)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li></ul>
         * @summary Gets the time table for the specified user starting and ending at the given date and period. 🔒: Timetable.ShowModule
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfUser: async (days: number, organizationId: string, start: string, userId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimetableOfUser', 'days', days)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableOfUser', 'organizationId', organizationId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimetableOfUser', 'start', start)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTimetableOfUser', 'userId', userId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/{start}/next/{days}/days/of/{organizationId}/user/{userId}`
                .replace(`{${"days"}}`, encodeURIComponent(String(days)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current students within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableStudents: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableStudents', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/users/students/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current teachers within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableTeachers: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimetableTeachers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/timeTable/users/teachers/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Marks the given lessons of a student as attended. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {MarkLessonsPresent} markLessonsPresent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markLessonsPresent: async (organizationId: string, studentId: string, markLessonsPresent: MarkLessonsPresent, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('markLessonsPresent', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('markLessonsPresent', 'studentId', studentId)
            // verify required parameter 'markLessonsPresent' is not null or undefined
            assertParamExists('markLessonsPresent', 'markLessonsPresent', markLessonsPresent)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}/student/{studentId}/present`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markLessonsPresent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Signs the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signLesson: async (lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('signLesson', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('signLesson', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/sign/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (signLevel !== undefined) {
                localVarQueryParameter['signLevel'] = signLevel;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Signs multiple lessons based on filtering criteria. Optional filterLessonTheme restricts the bulk-sign operation to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {SignLevel} [signLevel] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signMultipleLessons: async (organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, signLevel?: SignLevel, filterLessonTheme?: LessonThemeFilterType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('signMultipleLessons', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/signmultiple`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filterType'] = filterType;
            }

            if (signLevel !== undefined) {
                localVarQueryParameter['signLevel'] = signLevel;
            }

            if (filterLessonTheme !== undefined) {
                localVarQueryParameter['filterLessonTheme'] = filterLessonTheme;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a subscriber to the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToSeatingPlan: async (myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'myGroupId' is not null or undefined
            assertParamExists('subscribeToSeatingPlan', 'myGroupId', myGroupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('subscribeToSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanId' is not null or undefined
            assertParamExists('subscribeToSeatingPlan', 'seatingPlanId', seatingPlanId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}/{myGroupId}/subscribe/{seatingPlanId}`
                .replace(`{${"myGroupId"}}`, encodeURIComponent(String(myGroupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"seatingPlanId"}}`, encodeURIComponent(String(seatingPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary UnSign the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unSignLesson: async (lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('unSignLesson', 'lessonId', lessonId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unSignLesson', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegister/lesson/{organizationId}/unsign/{lessonId}`
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (signLevel !== undefined) {
                localVarQueryParameter['signLevel'] = signLevel;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a subscriber from the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeFromSeatingPlan: async (myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'myGroupId' is not null or undefined
            assertParamExists('unsubscribeFromSeatingPlan', 'myGroupId', myGroupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unsubscribeFromSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanId' is not null or undefined
            assertParamExists('unsubscribeFromSeatingPlan', 'seatingPlanId', seatingPlanId)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}/{myGroupId}/unsubscribe/{seatingPlanId}`
                .replace(`{${"myGroupId"}}`, encodeURIComponent(String(myGroupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"seatingPlanId"}}`, encodeURIComponent(String(seatingPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayResponse} holidayResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAHoliday: async (organizationId: string, holidayResponse: HolidayResponse, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAHoliday', 'organizationId', organizationId)
            // verify required parameter 'holidayResponse' is not null or undefined
            assertParamExists('updateAHoliday', 'holidayResponse', holidayResponse)
            const localVarPath = `/api/v2/ClassRegister/timeTable/holiday/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(holidayResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single or multiple absence-reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonPutEntry} absenceReasonPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsenceReasons: async (organizationId: string, absenceReasonPutEntry: AbsenceReasonPutEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAbsenceReasons', 'organizationId', organizationId)
            // verify required parameter 'absenceReasonPutEntry' is not null or undefined
            assertParamExists('updateAbsenceReasons', 'absenceReasonPutEntry', absenceReasonPutEntry)
            const localVarPath = `/api/v2/ClassRegister/absences/reason/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absenceReasonPutEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsences: async (organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAbsences', 'organizationId', organizationId)
            // verify required parameter 'absencePutEntry' is not null or undefined
            assertParamExists('updateAbsences', 'absencePutEntry', absencePutEntry)
            const localVarPath = `/api/v2/ClassRegister/absences/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absencePutEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionUpdate} excuseDefinitionUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsencesExcuseDefinition: async (organizationId: string, excuseDefinitionUpdate: ExcuseDefinitionUpdate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAbsencesExcuseDefinition', 'organizationId', organizationId)
            // verify required parameter 'excuseDefinitionUpdate' is not null or undefined
            assertParamExists('updateAbsencesExcuseDefinition', 'excuseDefinitionUpdate', excuseDefinitionUpdate)
            const localVarPath = `/api/v2/ClassRegister/absences/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(excuseDefinitionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Class. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassUpdateEntry} classUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClass: async (gradeId: string, organizationId: string, classUpdateEntry: ClassUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradeId' is not null or undefined
            assertParamExists('updateClass', 'gradeId', gradeId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClass', 'organizationId', organizationId)
            // verify required parameter 'classUpdateEntry' is not null or undefined
            assertParamExists('updateClass', 'classUpdateEntry', classUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/classes/{gradeId}`
                .replace(`{${"gradeId"}}`, encodeURIComponent(String(gradeId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassServicesPutEntry} classServicesPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassService: async (organizationId: string, classServicesPutEntry: ClassServicesPutEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClassService', 'organizationId', organizationId)
            // verify required parameter 'classServicesPutEntry' is not null or undefined
            assertParamExists('updateClassService', 'classServicesPutEntry', classServicesPutEntry)
            const localVarPath = `/api/v2/ClassRegister/services/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classServicesPutEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServiceDefinitionResponse} classServiceDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassServiceDefinition: async (organizationId: string, classServiceDefinitionResponse: ClassServiceDefinitionResponse, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClassServiceDefinition', 'organizationId', organizationId)
            // verify required parameter 'classServiceDefinitionResponse' is not null or undefined
            assertParamExists('updateClassServiceDefinition', 'classServiceDefinitionResponse', classServiceDefinitionResponse)
            const localVarPath = `/api/v2/ClassRegister/services/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classServiceDefinitionResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryPutRequest} classbookEntryCategoryPutRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntriesCategory: async (organizationId: string, classbookEntryCategoryPutRequest: ClassbookEntryCategoryPutRequest, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClassbookEntriesCategory', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryCategoryPutRequest' is not null or undefined
            assertParamExists('updateClassbookEntriesCategory', 'classbookEntryCategoryPutRequest', classbookEntryCategoryPutRequest)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/category/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryCategoryPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionResponse} classbookEntryDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntriesDefinition: async (organizationId: string, classbookEntryDefinitionResponse: ClassbookEntryDefinitionResponse, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClassbookEntriesDefinition', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryDefinitionResponse' is not null or undefined
            assertParamExists('updateClassbookEntriesDefinition', 'classbookEntryDefinitionResponse', classbookEntryDefinitionResponse)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/definition/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryDefinitionResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single classbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryUpdateRequest} classbookEntryUpdateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntry: async (organizationId: string, classbookEntryUpdateRequest: ClassbookEntryUpdateRequest, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateClassbookEntry', 'organizationId', organizationId)
            // verify required parameter 'classbookEntryUpdateRequest' is not null or undefined
            assertParamExists('updateClassbookEntry', 'classbookEntryUpdateRequest', classbookEntryUpdateRequest)
            const localVarPath = `/api/v2/ClassRegister/classbookEntries/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classbookEntryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseUpdateEntry} courseUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourse: async (organizationId: string, courseUpdateEntry: CourseUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCourse', 'organizationId', organizationId)
            // verify required parameter 'courseUpdateEntry' is not null or undefined
            assertParamExists('updateCourse', 'courseUpdateEntry', courseUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/courses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ReadWriteAll</li></ul>
         * @summary Updates the dependent classes of a course. 🔒: Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {CourseClassDependenciesUpdate} courseClassDependenciesUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoursesClassDependencies: async (organizationId: string, courseClassDependenciesUpdate: CourseClassDependenciesUpdate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCoursesClassDependencies', 'organizationId', organizationId)
            // verify required parameter 'courseClassDependenciesUpdate' is not null or undefined
            assertParamExists('updateCoursesClassDependencies', 'courseClassDependenciesUpdate', courseClassDependenciesUpdate)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/courses/dependencies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseClassDependenciesUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Grade. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeUpdateEntry} gradeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGrade: async (organizationId: string, gradeUpdateEntry: GradeUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateGrade', 'organizationId', organizationId)
            // verify required parameter 'gradeUpdateEntry' is not null or undefined
            assertParamExists('updateGrade', 'gradeUpdateEntry', gradeUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/grades`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gradeUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkUpdate} homeworkUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHomework: async (organizationId: string, homeworkUpdate: HomeworkUpdate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateHomework', 'organizationId', organizationId)
            // verify required parameter 'homeworkUpdate' is not null or undefined
            assertParamExists('updateHomework', 'homeworkUpdate', homeworkUpdate)
            const localVarPath = `/api/v2/ClassRegister/homework/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeworkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeUpdateEntry} lessonThemeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLessonTheme: async (organizationId: string, lessonThemeUpdateEntry: LessonThemeUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateLessonTheme', 'organizationId', organizationId)
            // verify required parameter 'lessonThemeUpdateEntry' is not null or undefined
            assertParamExists('updateLessonTheme', 'lessonThemeUpdateEntry', lessonThemeUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lessonThemeUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given lessonTheme-methodOfTeaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingUpdateEntry} methodOfTeachingUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMethodOfTeaching: async (organizationId: string, methodOfTeachingUpdateEntry: MethodOfTeachingUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateMethodOfTeaching', 'organizationId', organizationId)
            // verify required parameter 'methodOfTeachingUpdateEntry' is not null or undefined
            assertParamExists('updateMethodOfTeaching', 'methodOfTeachingUpdateEntry', methodOfTeachingUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/lessonTheme/method/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(methodOfTeachingUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Creates or Updates all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<SchoolEventMapping>} schoolEventMapping 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchoolEventMappings: async (organizationId: string, schoolEventMapping: Array<SchoolEventMapping>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSchoolEventMappings', 'organizationId', organizationId)
            // verify required parameter 'schoolEventMapping' is not null or undefined
            assertParamExists('updateSchoolEventMappings', 'schoolEventMapping', schoolEventMapping)
            const localVarPath = `/api/v2/ClassRegister/{organizationId}/settings/timeTable/schoolEventMappings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schoolEventMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanUpdateEntry} seatingPlanUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeatingPlan: async (organizationId: string, seatingPlanUpdateEntry: SeatingPlanUpdateEntry, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSeatingPlan', 'organizationId', organizationId)
            // verify required parameter 'seatingPlanUpdateEntry' is not null or undefined
            assertParamExists('updateSeatingPlan', 'seatingPlanUpdateEntry', seatingPlanUpdateEntry)
            const localVarPath = `/api/v2/ClassRegister/seatingPlans/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seatingPlanUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequestWithId} timePatternRequestWithId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimePattern: async (organizationId: string, timePatternRequestWithId: TimePatternRequestWithId, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTimePattern', 'organizationId', organizationId)
            // verify required parameter 'timePatternRequestWithId' is not null or undefined
            assertParamExists('updateTimePattern', 'timePatternRequestWithId', timePatternRequestWithId)
            const localVarPath = `/api/v2/ClassRegister/pattern/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timePatternRequestWithId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {TimeTableUpdateSettings} timeTableUpdateSettings 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTableSettings: async (organizationId: string, timeTableUpdateSettings: TimeTableUpdateSettings, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTimeTableSettings', 'organizationId', organizationId)
            // verify required parameter 'timeTableUpdateSettings' is not null or undefined
            assertParamExists('updateTimeTableSettings', 'timeTableUpdateSettings', timeTableUpdateSettings)
            const localVarPath = `/api/v2/ClassRegister/timeTable/settings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeTableUpdateSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<AzureGroupAssignmentUpdateRequestItem>} azureGroupAssignmentUpdateRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimetableMappings: async (organizationId: string, azureGroupAssignmentUpdateRequestItem: Array<AzureGroupAssignmentUpdateRequestItem>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTimetableMappings', 'organizationId', organizationId)
            // verify required parameter 'azureGroupAssignmentUpdateRequestItem' is not null or undefined
            assertParamExists('updateTimetableMappings', 'azureGroupAssignmentUpdateRequestItem', azureGroupAssignmentUpdateRequestItem)
            const localVarPath = `/api/v2/ClassRegister/timeTable/mappings/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(azureGroupAssignmentUpdateRequestItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClassRegisterApi - functional programming interface
 * @export
 */
export const ClassRegisterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClassRegisterApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns student absences. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {AbsencesGetOfStudentRequestFilter} [filter] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {string} [courseId] 
         * @param {string} [absenceReasonId] 
         * @param {string} [timePeriod] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesOfStudent(organizationId: string, studentId: string, filter?: AbsencesGetOfStudentRequestFilter, start?: string, end?: string, courseId?: string, absenceReasonId?: string, timePeriod?: string, pageSize?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfAbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesOfStudent(organizationId, studentId, filter, start, end, courseId, absenceReasonId, timePeriod, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns detailed information about the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesOfStudentDetails(organizationId: string, studentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentAbsenceDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesOfStudentDetails(organizationId, studentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns all absences between a given date range of the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} from 
         * @param {string} to 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absencesOfStudentTimetableFormatHandler(organizationId: string, studentId: string, from: string, to: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentAbsenceTimetableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absencesOfStudentTimetableFormatHandler(organizationId, studentId, from, to, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Add an attachment to the given absence-id 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} absenceId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAttachment(organizationId: string, timePeriod: string, absenceId: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAttachment(organizationId, timePeriod, absenceId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes the given time pattern activation state.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {ActivationState} [activationState] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeTimePatternActivationState(organizationId: string, timePatternId: string, activationState?: ActivationState, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeTimePatternActivationState(organizationId, timePatternId, activationState, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single absence. Avoid using this when creating multiple absences at once. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbsence(organizationId, absenceEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionEntry} excuseDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbsenceExcuseDefinition(organizationId: string, excuseDefinitionEntry: ExcuseDefinitionEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcuseDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbsenceExcuseDefinition(organizationId, excuseDefinitionEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single absence reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonEntry} absenceReasonEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAbsencesReasons(organizationId: string, absenceReasonEntry: AbsenceReasonEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceReasonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAbsencesReasons(organizationId, absenceReasonEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates multiple absences in bulk. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a bunch of students at the same time that span over multiple courses. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceBulkRequestContainer} absenceBulkRequestContainer 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkAbsences(organizationId: string, absenceBulkRequestContainer: AbsenceBulkRequestContainer, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkAbsences(organizationId, absenceBulkRequestContainer, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Class entry for the desired organization group. GradeId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassCreateEntry} classCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClass(gradeId: string, organizationId: string, classCreateEntry: ClassCreateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClass(gradeId, organizationId, classCreateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Creates the given class service. 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {ClassServicesEntry} classServicesEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClassService(organizationId: string, classServicesEntry: ClassServicesEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClassService(organizationId, classServicesEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServicesDefinitionEntry} classServicesDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClassServiceDefinition(organizationId: string, classServicesDefinitionEntry: ClassServicesDefinitionEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServiceDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClassServiceDefinition(organizationId, classServicesDefinitionEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntry-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryRequest} classbookEntryCategoryRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClassbookEntriesCategory(organizationId: string, classbookEntryCategoryRequest: ClassbookEntryCategoryRequest, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClassbookEntriesCategory(organizationId, classbookEntryCategoryRequest, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionEntry} classbookEntryDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionEntry: ClassbookEntryDefinitionEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryDefinitionFullResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClassbookEntriesDefinition(organizationId, classbookEntryDefinitionEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single specified ClassbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryCreateRequest} classbookEntryCreateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClassbookEntry(organizationId: string, classbookEntryCreateRequest: ClassbookEntryCreateRequest, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClassbookEntry(organizationId, classbookEntryCreateRequest, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified course entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseCreateEntry} courseCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCourse(organizationId: string, courseCreateEntry: CourseCreateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCourse(organizationId, courseCreateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Grade entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeCreateEntry} gradeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGrade(organizationId: string, gradeCreateEntry: GradeCreateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrade(organizationId, gradeCreateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayEntry} holidayEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHoliday(organizationId: string, holidayEntry: HolidayEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHoliday(organizationId, holidayEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkCreate} homeworkCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHomework(organizationId: string, homeworkCreate: HomeworkCreate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeworkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHomework(organizationId, homeworkCreate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeCreateEntry} lessonThemeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLessonTheme(organizationId: string, lessonThemeCreateEntry: LessonThemeCreateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonThemeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLessonTheme(organizationId, lessonThemeCreateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given lessontheme-methodofteaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingEntry} methodOfTeachingEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMethodOfTeaching(organizationId: string, methodOfTeachingEntry: MethodOfTeachingEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MethodOfTeachingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMethodOfTeaching(organizationId, methodOfTeachingEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates OR updates multiple absences. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a course at once ! 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {AbsencesCreateOrUpdateLists} absencesCreateOrUpdateLists 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateAbsences(lessonId: string, organizationId: string, absencesCreateOrUpdateLists: AbsencesCreateOrUpdateLists, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateAbsences(lessonId, organizationId, absencesCreateOrUpdateLists, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified EditAndNotificationSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {EditAndNotificationSettingsItem} editAndNotificationSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateEditAndNotificationSettings(organizationId: string, editAndNotificationSettingsItem: EditAndNotificationSettingsItem, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditAndNotificationSettingsItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateEditAndNotificationSettings(organizationId, editAndNotificationSettingsItem, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified GeneralSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {GeneralSettingsItem} generalSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateGeneralSettings(organizationId: string, generalSettingsItem: GeneralSettingsItem, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralSettingsItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateGeneralSettings(organizationId, generalSettingsItem, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates or updates the given schoolData item, depending on if any item already exists.
         * @param {string} organizationId 
         * @param {SchoolContact} schoolContact 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateSchoolData(organizationId: string, schoolContact: SchoolContact, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateSchoolData(organizationId, schoolContact, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of head teachers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateSchoolHeadTeachers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateSchoolHeadTeachers(organizationId, requestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of school managers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateSchoolManagers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateSchoolManagers(organizationId, requestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanEntry} seatingPlanEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSeatingPlan(organizationId: string, seatingPlanEntry: SeatingPlanEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSeatingPlan(organizationId, seatingPlanEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequest} timePatternRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTimePattern(organizationId: string, timePatternRequest: TimePatternRequest, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTimePattern(organizationId, timePatternRequest, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given class absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAbsence(absenceId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason-definition. 🔒: Settings.Classbook
         * @param {string} excuseDefinitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAbsenceExcuseDefinition(excuseDefinitionId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAbsenceExcuseDefinition(excuseDefinitionId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason. 🔒: Settings.Classbook
         * @param {string} absenceReasonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAbsenceReason(absenceReasonId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAbsenceReason(absenceReasonId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given attachment for the given absence-id. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(absenceId: string, organizationId: string, fileName: string, timePeriod: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(absenceId, organizationId, fileName, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Class from the given organization. Checks if any Courses exists inside the class before the actual delete. 🔒: Settings.Classbook
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClass(classId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClass(classId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClassService(organizationId: string, serviceId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClassService(organizationId, serviceId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClassServiceDefinition(organizationId: string, serviceId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClassServiceDefinition(organizationId, serviceId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The category won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified category from the given organization. 🔒: Settings.Classbook
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClassbookEntriesCategory(categoryId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClassbookEntriesCategory(categoryId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The definition won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified definition from the given organization. 🔒: Settings.Classbook
         * @param {string} definitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClassbookEntriesDefinition(definitionId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClassbookEntriesDefinition(definitionId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Deletes a ClassbookEntry 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} classbookEntryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClassbookEntry(classbookEntryId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClassbookEntry(classbookEntryId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified course from the given organization. 🔒: Settings.Classbook
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCourse(courseId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Grade from the given organization. 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGrade(gradeId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGrade(gradeId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the specified homework entry from the given organization. 🔒: Classbook.ShowModule
         * @param {string} homeworkId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHomework(homeworkId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHomework(homeworkId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLessonTheme(lessonThemeId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given lesson theme - method of teaching. 🔒: Settings.Classbook
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes the given seating plan.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSeatingPlan(organizationId, seatingPlanId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes the current time pattern.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTimePattern(organizationId: string, timePatternId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTimePattern(organizationId, timePatternId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given holiday. 🔒: Settings.Classbook
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletesAHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletesAHoliday(holidayId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of the school. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [reasonId] 
         * @param {string} [searchForName] 
         * @param {Sequence} [sequence] 
         * @param {SortableBy} [sortBy] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsenceOverview(organizationId: string, skip: number, take: number, reasonId?: string, searchForName?: string, sequence?: Sequence, sortBy?: SortableBy, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsenceOverview(organizationId, skip, take, reasonId, searchForName, sequence, sortBy, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Get all reasons which are using the given excuse definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} excuseDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsenceReasonsOfDefinition(organizationId: string, excuseDefinitionId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsenceReasonsOfDefinition(organizationId, excuseDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Check the amount of absences in a given time period. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesCount(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsencesAmount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesCount(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns excuse-definitions of the whole organization. Parameter isEnabled is optional. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExcuseDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absence-reasons of the whole organization. Parameter reasonDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absences of all students in the given organization at the current time period between dayStart and dayEnd. ExcuseDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [excuseDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAbsences(dayEnd: string, dayStart: string, organizationId: string, excuseDefinitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAbsences(dayEnd, dayStart, organizationId, excuseDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary Returns all basicClasses the user effectively has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfClassBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basicClasses no matter if iam in that class or how the grade was 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicClassesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfClassBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicClassesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.ReadAll</li><li>Absences.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Classbook.ShowModule, Timetable.ReadAll, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfCourseBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basic courses no matter if the person which is requesting is part of that course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicCoursesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfCourseBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicCoursesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary By default this returns all basic grades the user effectivly has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfGradeBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all grades. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicGradesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfGradeBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicGradesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns all definitions for the given organization group. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClassServiceDefinitions(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassServiceDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClassServiceDefinitions(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization group of the given user, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id and or group id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClassServicesByStudent(dayEnd: string, dayStart: string, organizationId: string, studentId: string, definitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassServicesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClassServicesByStudent(dayEnd, dayStart, organizationId, studentId, definitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries where the specified period matches. Optional, filter by Category beforehand. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClassbookEntries(dayEnd: string, dayStart: string, organizationId: string, categoryId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassbookEntryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClassbookEntries(dayEnd, dayStart, organizationId, categoryId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries for the given group where the specified date/time is greater or equal the given dates, range can be any time in this current time period. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClassbookEntriesByGroup(end: string, groupId: string, organizationId: string, start: string, categoryId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassbookEntryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClassbookEntriesByGroup(end, groupId, organizationId, start, categoryId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all categories from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllClassbookEntriesCategories(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassbookEntryCategoryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllClassbookEntriesCategories(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all definitions from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntryDefinitions(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassbookEntryDefinitionFullResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntryDefinitions(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all holidays for the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHolidays(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HolidayResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHolidays(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given date range, where the start date is greater or equal the given day or the end date is less then the given day. Optional : filter by Deadline 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHomework(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHomework(dayEnd, dayStart, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given course, where the start date is greater or equal the given day or the end date is less then the given day. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [dayEnd] 
         * @param {string} [dayStart] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHomeworkByCourse(courseId: string, organizationId: string, dayEnd?: string, dayStart?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHomeworkByCourse(courseId, organizationId, dayEnd, dayStart, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessonThemes for the given organization group, where the given date/time is greater or equal the lessonTheme start date or less then the lessonTheme end date. Optional filter by methodOfTeaching. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLessonThemes(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LessonThemeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLessonThemes(dayEnd, dayStart, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lesson themes for the given organization group, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLessonThemesByGroup(dayEnd: string, dayStart: string, groupId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LessonThemeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLessonThemesByGroup(dayEnd, dayStart, groupId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all methods of teaching for the given organization group. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMethodsOfTeaching(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MethodOfTeachingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMethodsOfTeaching(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all available seating plan (names and ids) in the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSeatingPlans(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeatingPlanNameResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSeatingPlans(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all time patterns for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTimePatterns(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimePatternResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTimePatterns(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all rooms used by the timetable. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTimetableRooms(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTimetableRooms(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Get content for the given attachment. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} absenceId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachment(organizationId: string, absenceId: string, fileName: string, timePeriod: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachment(organizationId, absenceId, fileName, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the specified group. Optional: Include group members. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {boolean} [includeMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAzureGroup(groupId: string, organizationId: string, includeMembers?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAzureGroup(groupId, organizationId, includeMembers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all azure groups of the tenant/organization with the specified role (optional). By default, only groups with the origin \"AixConcept\" will be returned. This means, groups will also get filtered by its \"OrganizationId\". 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Origin} [origin] 
         * @param {GroupRole} [role] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAzureGroups(organizationId: string, origin?: Origin, role?: GroupRole, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupInformation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAzureGroups(organizationId, origin, role, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a class. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} classId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClassAbsences(classId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassAbsencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClassAbsences(classId, month, organizationId, year, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services of the required group. This includes all services attached to corresponding classes. Note: Students will also see services not attached to themselves. 🔒: Courses.ShowModule
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClassServicesOfGroup(groupId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassServicesResponseExtended>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClassServicesOfGroup(groupId, organizationId, definitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization groups lesson. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClassServicesOfLesson(lessonId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassServicesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClassServicesOfLesson(lessonId, organizationId, definitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a course. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} courseId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourseAbsences(courseId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseAbsencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourseAbsences(courseId, month, organizationId, year, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the students of a course. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourseStudents(courseId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourseStudents(courseId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns the edit and notification settings. 🔒: Settings.Classbook, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEditAndNotificationSettings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditAndNotificationSettingsItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEditAndNotificationSettings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the general settings. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralSettings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralSettingsItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralSettings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a grade. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} gradeId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGradeAbsences(gradeId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GradeAbsencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGradeAbsences(gradeId, month, organizationId, year, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the latest absence of the given absence-id 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAbsence(absenceId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest service for the given organization group where the class-service-id matches 🔒: Classbook.ShowModule
         * @param {string} classServiceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestClassService(classServiceId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestClassService(classServiceId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the latest class-service-definition for the given organization group and the given class-service-definiton-id. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestClassServicesDefinition(organizationId: string, serviceDefinitionId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServiceDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestClassServicesDefinition(organizationId, serviceDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest Class by id the user effectively has access to. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestClassWithBasicCourses(classId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestClassWithBasicCourses(classId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Class by id 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestClassWithBasicCoursesOfSettings(classId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestClassWithBasicCoursesOfSettings(classId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest course by id the user has effectively access to. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestCourse(courseId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest course by id. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestCourseOfSettings(courseId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestCourseOfSettings(courseId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Grade by id if the user effectively has access to it. Also returns basic of all corresponding classes. 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestGradeWithBasicClasses(gradeId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestGradeWithBasicClasses(gradeId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns the latest Grade by id, also returns basic of all corresponding classes 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestGradeWithBasicClassesOfSettings(gradeId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestGradeWithBasicClassesOfSettings(gradeId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the latest holiday for the given organization group where the holiday-id matches
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestHoliday(holidayId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the lesson by LessonId. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestLesson(lessonId: string, organizationId: string, timePeriod?: string, includeDrafts?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestLesson(lessonId, organizationId, timePeriod, includeDrafts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest lessonThemes for the given organization group by lesson-theme-Id 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonThemeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestLessonTheme(lessonThemeId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest methods of teaching for the given organization group by method-of-teaching-Id. 🔒: Classbook.ShowModule
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MethodOfTeachingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary Returns all draft absences that overlap the given lesson\'s time window for its students. Drafts that have already been accepted into a real absence are excluded. 🔒: Absences.ShowDrafts
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonDraftAbsences(lessonId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonDraftAbsences(lessonId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the next lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [endOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonOfCourseNext(courseId: string, organizationId: string, endOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonOfCourseNext(courseId, organizationId, endOfCurrentLesson, timePeriod, includeDrafts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the previous lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [startOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonOfCoursePrevious(courseId: string, organizationId: string, startOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonOfCoursePrevious(courseId, organizationId, startOfCurrentLesson, timePeriod, includeDrafts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons of the request-caller who have no assigned lessonTheme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonWithoutTheme(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonWithoutTheme(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all class lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonsOfClassRange(classId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonsOfClassRange(classId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all course lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonsOfCourseRange(courseId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonsOfCourseRange(courseId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all gerade lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonsOfGradeRange(end: string, gradeId: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonsOfGradeRange(end, gradeId, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all my lessons from the given start time for the next 24 hours. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start Defines date time of first item. Returns all items for the next 24 hours.
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonsOfMyAgenda(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonsOfMyAgenda(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all next lessons from the start time for all my courses. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonsOfMyCourses(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonsOfMyCourses(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the number of unsigned lessons of the request-caller and the number of lessons without an assigned lessonTheme as an array of two integers. Note: this method still consumes high amounts of RUs, use wisely. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMissingInformationsCount(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MissingQuantity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMissingInformationsCount(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services for the requesting user, which are not deactivated by definition. Optional filter by definition id. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyClassServices(organizationId: string, definitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassServicesResponseExtended>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyClassServices(organizationId, definitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information.
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyHomework(timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyHomework(timePeriod, excludeTeamsAssignments, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all specified homework for the given course if the user is member of the course. This will return everything for the current timePeriod.
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyHomeworkByCourse(courseId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyHomeworkByCourse(courseId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the effictive lesson permissions 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyLessonPermissions(lessonId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectiveLessonPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyLessonPermissions(lessonId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the substitutions for the current user.
         * @param {string} organizationId 
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySubstitutions(organizationId: string, start: string, dayCount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableSubstitutionsOfMeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySubstitutions(organizationId, start, dayCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons that the provided user still has to sign, or that belong to a given group. At least the user id or the group id must be provided. Optional filterLessonTheme narrows the result to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoSignedLessonsByUserAndOrGroup(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, filterLessonTheme?: LessonThemeFilterType, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfLessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoSignedLessonsByUserAndOrGroup(organizationId, timePeriod, groupId, userId, from, to, filterType, filterLessonTheme, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary Returns the import report of the reuqested organization. 🔒: Settings.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the current school contact for the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchoolData(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchoolData(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Returns all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchoolEventMappings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolEventMappingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchoolEventMappings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school head teachers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchoolHeadTeachers(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchoolHeadTeachers(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school managers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchoolManagers(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchoolManagers(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the latest seating plan in the given organization by seating-plan-id.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSeatingPlan(organizationId, seatingPlanId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the seating plan of the desired course in the given organization.
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSeatingPlanByGroup(groupId: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSeatingPlanByGroup(groupId, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubstitutions(start?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Substitution>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubstitutions(start, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the current active time pattern for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheActiveTimePattern(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTableSettings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTableSettings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available course names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableCourseNames(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureGroupInfoResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableCourseNames(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available lesson names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableLessonNames(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LessonNameAndType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableLessonNames(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableMappings(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureGroupAssignmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableMappings(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified group starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableOfGroup(days: number, groupId: string, organizationId: string, start: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableOfGroup(days, groupId, organizationId, start, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified room starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableOfRoom(days: number, organizationId: string, roomId: string, start: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableOfRoom(days, organizationId, roomId, start, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li></ul>
         * @summary Gets the time table for the specified user starting and ending at the given date and period. 🔒: Timetable.ShowModule
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableOfUser(days: number, organizationId: string, start: string, userId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableOfUser(days, organizationId, start, userId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current students within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableStudents(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableStudents(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current teachers within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimetableTeachers(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimetableTeachers(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Marks the given lessons of a student as attended. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {MarkLessonsPresent} markLessonsPresent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markLessonsPresent(organizationId: string, studentId: string, markLessonsPresent: MarkLessonsPresent, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markLessonsPresent(organizationId, studentId, markLessonsPresent, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Signs the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signLesson(lessonId, organizationId, signLevel, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Signs multiple lessons based on filtering criteria. Optional filterLessonTheme restricts the bulk-sign operation to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {SignLevel} [signLevel] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signMultipleLessons(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, signLevel?: SignLevel, filterLessonTheme?: LessonThemeFilterType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonsSignMultipleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signMultipleLessons(organizationId, timePeriod, groupId, userId, from, to, filterType, signLevel, filterLessonTheme, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a subscriber to the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary UnSign the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unSignLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unSignLesson(lessonId, organizationId, signLevel, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes a subscriber from the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeFromSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeFromSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayResponse} holidayResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAHoliday(organizationId: string, holidayResponse: HolidayResponse, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAHoliday(organizationId, holidayResponse, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single or multiple absence-reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonPutEntry} absenceReasonPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsenceReasons(organizationId: string, absenceReasonPutEntry: AbsenceReasonPutEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceReasonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsenceReasons(organizationId, absenceReasonPutEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbsenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsences(organizationId, absencePutEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionUpdate} excuseDefinitionUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAbsencesExcuseDefinition(organizationId: string, excuseDefinitionUpdate: ExcuseDefinitionUpdate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcuseDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAbsencesExcuseDefinition(organizationId, excuseDefinitionUpdate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Class. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassUpdateEntry} classUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClass(gradeId: string, organizationId: string, classUpdateEntry: ClassUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClass(gradeId, organizationId, classUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassServicesPutEntry} classServicesPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClassService(organizationId: string, classServicesPutEntry: ClassServicesPutEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClassService(organizationId, classServicesPutEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServiceDefinitionResponse} classServiceDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClassServiceDefinition(organizationId: string, classServiceDefinitionResponse: ClassServiceDefinitionResponse, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassServiceDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClassServiceDefinition(organizationId, classServiceDefinitionResponse, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryPutRequest} classbookEntryCategoryPutRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClassbookEntriesCategory(organizationId: string, classbookEntryCategoryPutRequest: ClassbookEntryCategoryPutRequest, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClassbookEntriesCategory(organizationId, classbookEntryCategoryPutRequest, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionResponse} classbookEntryDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionResponse: ClassbookEntryDefinitionResponse, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryDefinitionFullResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClassbookEntriesDefinition(organizationId, classbookEntryDefinitionResponse, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single classbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryUpdateRequest} classbookEntryUpdateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClassbookEntry(organizationId: string, classbookEntryUpdateRequest: ClassbookEntryUpdateRequest, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassbookEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClassbookEntry(organizationId, classbookEntryUpdateRequest, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseUpdateEntry} courseUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCourse(organizationId: string, courseUpdateEntry: CourseUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCourse(organizationId, courseUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ReadWriteAll</li></ul>
         * @summary Updates the dependent classes of a course. 🔒: Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {CourseClassDependenciesUpdate} courseClassDependenciesUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCoursesClassDependencies(organizationId: string, courseClassDependenciesUpdate: CourseClassDependenciesUpdate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCoursesClassDependencies(organizationId, courseClassDependenciesUpdate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Grade. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeUpdateEntry} gradeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGrade(organizationId: string, gradeUpdateEntry: GradeUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GradeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGrade(organizationId, gradeUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkUpdate} homeworkUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHomework(organizationId: string, homeworkUpdate: HomeworkUpdate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeworkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHomework(organizationId, homeworkUpdate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeUpdateEntry} lessonThemeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLessonTheme(organizationId: string, lessonThemeUpdateEntry: LessonThemeUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonThemeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLessonTheme(organizationId, lessonThemeUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given lessonTheme-methodOfTeaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingUpdateEntry} methodOfTeachingUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMethodOfTeaching(organizationId: string, methodOfTeachingUpdateEntry: MethodOfTeachingUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MethodOfTeachingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMethodOfTeaching(organizationId, methodOfTeachingUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Creates or Updates all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<SchoolEventMapping>} schoolEventMapping 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSchoolEventMappings(organizationId: string, schoolEventMapping: Array<SchoolEventMapping>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolEventMappingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSchoolEventMappings(organizationId, schoolEventMapping, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanUpdateEntry} seatingPlanUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeatingPlan(organizationId: string, seatingPlanUpdateEntry: SeatingPlanUpdateEntry, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatingPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSeatingPlan(organizationId, seatingPlanUpdateEntry, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequestWithId} timePatternRequestWithId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimePattern(organizationId: string, timePatternRequestWithId: TimePatternRequestWithId, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimePattern(organizationId, timePatternRequestWithId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {TimeTableUpdateSettings} timeTableUpdateSettings 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeTableSettings(organizationId: string, timeTableUpdateSettings: TimeTableUpdateSettings, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeTableSettings(organizationId, timeTableUpdateSettings, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<AzureGroupAssignmentUpdateRequestItem>} azureGroupAssignmentUpdateRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimetableMappings(organizationId: string, azureGroupAssignmentUpdateRequestItem: Array<AzureGroupAssignmentUpdateRequestItem>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimetableMappings(organizationId, azureGroupAssignmentUpdateRequestItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClassRegisterApi - factory interface
 * @export
 */
export const ClassRegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClassRegisterApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns student absences. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {AbsencesGetOfStudentRequestFilter} [filter] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {string} [courseId] 
         * @param {string} [absenceReasonId] 
         * @param {string} [timePeriod] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudent(organizationId: string, studentId: string, filter?: AbsencesGetOfStudentRequestFilter, start?: string, end?: string, courseId?: string, absenceReasonId?: string, timePeriod?: string, pageSize?: number, page?: number, options?: any): AxiosPromise<PagedOfAbsenceResponse> {
            return localVarFp.absencesOfStudent(organizationId, studentId, filter, start, end, courseId, absenceReasonId, timePeriod, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns detailed information about the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudentDetails(organizationId: string, studentId: string, timePeriod?: string, options?: any): AxiosPromise<StudentAbsenceDetailed> {
            return localVarFp.absencesOfStudentDetails(organizationId, studentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
         * @summary Returns all absences between a given date range of the student. 🔒: Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} from 
         * @param {string} to 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absencesOfStudentTimetableFormatHandler(organizationId: string, studentId: string, from: string, to: string, timePeriod?: string, options?: any): AxiosPromise<StudentAbsenceTimetableResponse> {
            return localVarFp.absencesOfStudentTimetableFormatHandler(organizationId, studentId, from, to, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Add an attachment to the given absence-id 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} absenceId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(organizationId: string, timePeriod: string, absenceId: string, file?: any, options?: any): AxiosPromise<void> {
            return localVarFp.addAttachment(organizationId, timePeriod, absenceId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the given time pattern activation state.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {ActivationState} [activationState] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTimePatternActivationState(organizationId: string, timePatternId: string, activationState?: ActivationState, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.changeTimePatternActivationState(organizationId, timePatternId, activationState, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single absence. Avoid using this when creating multiple absences at once. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceEntry} absenceEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceResponse> {
            return localVarFp.createAbsence(organizationId, absenceEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionEntry} excuseDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsenceExcuseDefinition(organizationId: string, excuseDefinitionEntry: ExcuseDefinitionEntry, timePeriod?: string, options?: any): AxiosPromise<ExcuseDefinitionResponse> {
            return localVarFp.createAbsenceExcuseDefinition(organizationId, excuseDefinitionEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates a single absence reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonEntry} absenceReasonEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAbsencesReasons(organizationId: string, absenceReasonEntry: AbsenceReasonEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceReasonResponse> {
            return localVarFp.createAbsencesReasons(organizationId, absenceReasonEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates multiple absences in bulk. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a bunch of students at the same time that span over multiple courses. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsenceBulkRequestContainer} absenceBulkRequestContainer 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkAbsences(organizationId: string, absenceBulkRequestContainer: AbsenceBulkRequestContainer, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceResponse>> {
            return localVarFp.createBulkAbsences(organizationId, absenceBulkRequestContainer, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Class entry for the desired organization group. GradeId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassCreateEntry} classCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClass(gradeId: string, organizationId: string, classCreateEntry: ClassCreateEntry, timePeriod?: string, options?: any): AxiosPromise<ClassResponse> {
            return localVarFp.createClass(gradeId, organizationId, classCreateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Creates the given class service. 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {ClassServicesEntry} classServicesEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassService(organizationId: string, classServicesEntry: ClassServicesEntry, timePeriod?: string, options?: any): AxiosPromise<ClassServicesResponse> {
            return localVarFp.createClassService(organizationId, classServicesEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServicesDefinitionEntry} classServicesDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassServiceDefinition(organizationId: string, classServicesDefinitionEntry: ClassServicesDefinitionEntry, timePeriod?: string, options?: any): AxiosPromise<ClassServiceDefinitionResponse> {
            return localVarFp.createClassServiceDefinition(organizationId, classServicesDefinitionEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntry-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryRequest} classbookEntryCategoryRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntriesCategory(organizationId: string, classbookEntryCategoryRequest: ClassbookEntryCategoryRequest, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryCategoryResponse> {
            return localVarFp.createClassbookEntriesCategory(organizationId, classbookEntryCategoryRequest, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionEntry} classbookEntryDefinitionEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionEntry: ClassbookEntryDefinitionEntry, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryDefinitionFullResponse> {
            return localVarFp.createClassbookEntriesDefinition(organizationId, classbookEntryDefinitionEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates a single specified ClassbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryCreateRequest} classbookEntryCreateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClassbookEntry(organizationId: string, classbookEntryCreateRequest: ClassbookEntryCreateRequest, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryResponse> {
            return localVarFp.createClassbookEntry(organizationId, classbookEntryCreateRequest, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified course entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseCreateEntry} courseCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourse(organizationId: string, courseCreateEntry: CourseCreateEntry, timePeriod?: string, options?: any): AxiosPromise<CourseResponse> {
            return localVarFp.createCourse(organizationId, courseCreateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Creates the specified Grade entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeCreateEntry} gradeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrade(organizationId: string, gradeCreateEntry: GradeCreateEntry, timePeriod?: string, options?: any): AxiosPromise<GradeResponse> {
            return localVarFp.createGrade(organizationId, gradeCreateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayEntry} holidayEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHoliday(organizationId: string, holidayEntry: HolidayEntry, timePeriod?: string, options?: any): AxiosPromise<HolidayResponse> {
            return localVarFp.createHoliday(organizationId, holidayEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkCreate} homeworkCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHomework(organizationId: string, homeworkCreate: HomeworkCreate, timePeriod?: string, options?: any): AxiosPromise<HomeworkResponse> {
            return localVarFp.createHomework(organizationId, homeworkCreate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Creates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeCreateEntry} lessonThemeCreateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLessonTheme(organizationId: string, lessonThemeCreateEntry: LessonThemeCreateEntry, timePeriod?: string, options?: any): AxiosPromise<LessonThemeResponse> {
            return localVarFp.createLessonTheme(organizationId, lessonThemeCreateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates the given lessontheme-methodofteaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingEntry} methodOfTeachingEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMethodOfTeaching(organizationId: string, methodOfTeachingEntry: MethodOfTeachingEntry, timePeriod?: string, options?: any): AxiosPromise<MethodOfTeachingResponse> {
            return localVarFp.createMethodOfTeaching(organizationId, methodOfTeachingEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Creates OR updates multiple absences. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a course at once ! 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {AbsencesCreateOrUpdateLists} absencesCreateOrUpdateLists 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAbsences(lessonId: string, organizationId: string, absencesCreateOrUpdateLists: AbsencesCreateOrUpdateLists, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceResponse>> {
            return localVarFp.createOrUpdateAbsences(lessonId, organizationId, absencesCreateOrUpdateLists, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified EditAndNotificationSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {EditAndNotificationSettingsItem} editAndNotificationSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateEditAndNotificationSettings(organizationId: string, editAndNotificationSettingsItem: EditAndNotificationSettingsItem, timePeriod?: string, options?: any): AxiosPromise<EditAndNotificationSettingsItem> {
            return localVarFp.createOrUpdateEditAndNotificationSettings(organizationId, editAndNotificationSettingsItem, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Create or updates the specified GeneralSettings entry for the desired organization group. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {GeneralSettingsItem} generalSettingsItem 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateGeneralSettings(organizationId: string, generalSettingsItem: GeneralSettingsItem, timePeriod?: string, options?: any): AxiosPromise<GeneralSettingsItem> {
            return localVarFp.createOrUpdateGeneralSettings(organizationId, generalSettingsItem, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or updates the given schoolData item, depending on if any item already exists.
         * @param {string} organizationId 
         * @param {SchoolContact} schoolContact 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolData(organizationId: string, schoolContact: SchoolContact, timePeriod?: string, options?: any): AxiosPromise<SchoolContact> {
            return localVarFp.createOrUpdateSchoolData(organizationId, schoolContact, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of head teachers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolHeadTeachers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.createOrUpdateSchoolHeadTeachers(organizationId, requestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Creates or updates the list of school managers. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSchoolManagers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.createOrUpdateSchoolManagers(organizationId, requestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanEntry} seatingPlanEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeatingPlan(organizationId: string, seatingPlanEntry: SeatingPlanEntry, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.createSeatingPlan(organizationId, seatingPlanEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequest} timePatternRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimePattern(organizationId: string, timePatternRequest: TimePatternRequest, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.createTimePattern(organizationId, timePatternRequest, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given class absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAbsence(absenceId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason-definition. 🔒: Settings.Classbook
         * @param {string} excuseDefinitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsenceExcuseDefinition(excuseDefinitionId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAbsenceExcuseDefinition(excuseDefinitionId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes a given class absence-reason. 🔒: Settings.Classbook
         * @param {string} absenceReasonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAbsenceReason(absenceReasonId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAbsenceReason(absenceReasonId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Removes a given attachment for the given absence-id. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(absenceId: string, organizationId: string, fileName: string, timePeriod: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAttachment(absenceId, organizationId, fileName, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Class from the given organization. Checks if any Courses exists inside the class before the actual delete. 🔒: Settings.Classbook
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClass(classId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteClass(classId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassService(organizationId: string, serviceId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClassService(organizationId, serviceId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassServiceDefinition(organizationId: string, serviceId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClassServiceDefinition(organizationId, serviceId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * The category won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified category from the given organization. 🔒: Settings.Classbook
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntriesCategory(categoryId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClassbookEntriesCategory(categoryId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * The definition won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified definition from the given organization. 🔒: Settings.Classbook
         * @param {string} definitionId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntriesDefinition(definitionId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClassbookEntriesDefinition(definitionId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
         * @summary Deletes a ClassbookEntry 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
         * @param {string} classbookEntryId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClassbookEntry(classbookEntryId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClassbookEntry(classbookEntryId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified course from the given organization. 🔒: Settings.Classbook
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteCourse(courseId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the specified Grade from the given organization. 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrade(gradeId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteGrade(gradeId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the specified homework entry from the given organization. 🔒: Classbook.ShowModule
         * @param {string} homeworkId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHomework(homeworkId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteHomework(homeworkId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Removes the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLessonTheme(lessonThemeId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given lesson theme - method of teaching. 🔒: Settings.Classbook
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes the given seating plan.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSeatingPlan(organizationId, seatingPlanId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes the current time pattern.
         * @param {string} organizationId 
         * @param {string} timePatternId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimePattern(organizationId: string, timePatternId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTimePattern(organizationId, timePatternId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Removes the given holiday. 🔒: Settings.Classbook
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletesAHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletesAHoliday(holidayId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of the school. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {number} skip 
         * @param {number} take 
         * @param {string} [reasonId] 
         * @param {string} [searchForName] 
         * @param {Sequence} [sequence] 
         * @param {SortableBy} [sortBy] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceOverview(organizationId: string, skip: number, take: number, reasonId?: string, searchForName?: string, sequence?: Sequence, sortBy?: SortableBy, timePeriod?: string, options?: any): AxiosPromise<AbsenceOverview> {
            return localVarFp.getAbsenceOverview(organizationId, skip, take, reasonId, searchForName, sequence, sortBy, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Get all reasons which are using the given excuse definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} excuseDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasonsOfDefinition(organizationId: string, excuseDefinitionId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceReasonResponse>> {
            return localVarFp.getAbsenceReasonsOfDefinition(organizationId, excuseDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Check the amount of absences in a given time period. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesCount(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<AbsencesAmount> {
            return localVarFp.getAbsencesCount(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns excuse-definitions of the whole organization. Parameter isEnabled is optional. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any): AxiosPromise<Array<ExcuseDefinitionResponse>> {
            return localVarFp.getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absence-reasons of the whole organization. Parameter reasonDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceReasonResponse>> {
            return localVarFp.getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns absences of all students in the given organization at the current time period between dayStart and dayEnd. ExcuseDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [excuseDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAbsences(dayEnd: string, dayStart: string, organizationId: string, excuseDefinitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceResponse>> {
            return localVarFp.getAllAbsences(dayEnd, dayStart, organizationId, excuseDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary Returns all basicClasses the user effectively has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfClassBasicResponse> {
            return localVarFp.getAllBasicClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basicClasses no matter if iam in that class or how the grade was 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicClassesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfClassBasicResponse> {
            return localVarFp.getAllBasicClassesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.ReadAll</li><li>Absences.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Classbook.ShowModule, Timetable.ReadAll, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfCourseBasicResponse> {
            return localVarFp.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all basic courses no matter if the person which is requesting is part of that course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCoursesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfCourseBasicResponse> {
            return localVarFp.getAllBasicCoursesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary By default this returns all basic grades the user effectivly has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfGradeBasicResponse> {
            return localVarFp.getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all grades. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicGradesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfGradeBasicResponse> {
            return localVarFp.getAllBasicGradesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns all definitions for the given organization group. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassServiceDefinitions(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassServiceDefinitionResponse>> {
            return localVarFp.getAllClassServiceDefinitions(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization group of the given user, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id and or group id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassServicesByStudent(dayEnd: string, dayStart: string, organizationId: string, studentId: string, definitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassServicesResponse>> {
            return localVarFp.getAllClassServicesByStudent(dayEnd, dayStart, organizationId, studentId, definitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries where the specified period matches. Optional, filter by Category beforehand. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntries(dayEnd: string, dayStart: string, organizationId: string, categoryId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassbookEntryResponse>> {
            return localVarFp.getAllClassbookEntries(dayEnd, dayStart, organizationId, categoryId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Gets all ClassbookEntries for the given group where the specified date/time is greater or equal the given dates, range can be any time in this current time period. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [categoryId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntriesByGroup(end: string, groupId: string, organizationId: string, start: string, categoryId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassbookEntryResponse>> {
            return localVarFp.getAllClassbookEntriesByGroup(end, groupId, organizationId, start, categoryId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all categories from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllClassbookEntriesCategories(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassbookEntryCategoryResponse>> {
            return localVarFp.getAllClassbookEntriesCategories(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Gets all definitions from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntryDefinitions(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassbookEntryDefinitionFullResponse>> {
            return localVarFp.getAllEntryDefinitions(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all holidays for the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHolidays(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<HolidayResponse>> {
            return localVarFp.getAllHolidays(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given date range, where the start date is greater or equal the given day or the end date is less then the given day. Optional : filter by Deadline 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHomework(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<HomeworkResponse>> {
            return localVarFp.getAllHomework(dayEnd, dayStart, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all specified homework for the given course, where the start date is greater or equal the given day or the end date is less then the given day. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [dayEnd] 
         * @param {string} [dayStart] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHomeworkByCourse(courseId: string, organizationId: string, dayEnd?: string, dayStart?: string, timePeriod?: string, options?: any): AxiosPromise<Array<HomeworkResponse>> {
            return localVarFp.getAllHomeworkByCourse(courseId, organizationId, dayEnd, dayStart, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessonThemes for the given organization group, where the given date/time is greater or equal the lessonTheme start date or less then the lessonTheme end date. Optional filter by methodOfTeaching. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessonThemes(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<LessonThemeResponse>> {
            return localVarFp.getAllLessonThemes(dayEnd, dayStart, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lesson themes for the given organization group, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} dayEnd 
         * @param {string} dayStart 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLessonThemesByGroup(dayEnd: string, dayStart: string, groupId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<LessonThemeResponse>> {
            return localVarFp.getAllLessonThemesByGroup(dayEnd, dayStart, groupId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all methods of teaching for the given organization group. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMethodsOfTeaching(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<MethodOfTeachingResponse>> {
            return localVarFp.getAllMethodsOfTeaching(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all available seating plan (names and ids) in the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSeatingPlans(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<SeatingPlanNameResponse>> {
            return localVarFp.getAllSeatingPlans(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all time patterns for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimePatterns(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<TimePatternResponse>> {
            return localVarFp.getAllTimePatterns(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all rooms used by the timetable. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTimetableRooms(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<ResourceResponse>> {
            return localVarFp.getAllTimetableRooms(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Get content for the given attachment. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} absenceId 
         * @param {string} fileName 
         * @param {string} timePeriod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment(organizationId: string, absenceId: string, fileName: string, timePeriod: string, options?: any): AxiosPromise<any> {
            return localVarFp.getAttachment(organizationId, absenceId, fileName, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the specified group. Optional: Include group members. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {boolean} [includeMembers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzureGroup(groupId: string, organizationId: string, includeMembers?: boolean, options?: any): AxiosPromise<GroupInformation> {
            return localVarFp.getAzureGroup(groupId, organizationId, includeMembers, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns all azure groups of the tenant/organization with the specified role (optional). By default, only groups with the origin \"AixConcept\" will be returned. This means, groups will also get filtered by its \"OrganizationId\". 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {Origin} [origin] 
         * @param {GroupRole} [role] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAzureGroups(organizationId: string, origin?: Origin, role?: GroupRole, timePeriod?: string, options?: any): AxiosPromise<Array<GroupInformation>> {
            return localVarFp.getAzureGroups(organizationId, origin, role, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a class. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} classId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassAbsences(classId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): AxiosPromise<ClassAbsencesResponse> {
            return localVarFp.getClassAbsences(classId, month, organizationId, year, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services of the required group. This includes all services attached to corresponding classes. Note: Students will also see services not attached to themselves. 🔒: Courses.ShowModule
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassServicesOfGroup(groupId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassServicesResponseExtended>> {
            return localVarFp.getClassServicesOfGroup(groupId, organizationId, definitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all services for the given organization groups lesson. Optional filter by definition id. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassServicesOfLesson(lessonId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassServicesResponse>> {
            return localVarFp.getClassServicesOfLesson(lessonId, organizationId, definitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a course. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} courseId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseAbsences(courseId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): AxiosPromise<CourseAbsencesResponse> {
            return localVarFp.getCourseAbsences(courseId, month, organizationId, year, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the students of a course. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseStudents(courseId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getCourseStudents(courseId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns the edit and notification settings. 🔒: Settings.Classbook, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEditAndNotificationSettings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<EditAndNotificationSettingsItem> {
            return localVarFp.getEditAndNotificationSettings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the general settings. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralSettings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<GeneralSettingsItem> {
            return localVarFp.getGeneralSettings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all students and their absences of a grade. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} gradeId 
         * @param {number} month 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGradeAbsences(gradeId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any): AxiosPromise<GradeAbsencesResponse> {
            return localVarFp.getGradeAbsences(gradeId, month, organizationId, year, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
         * @summary Returns the latest absence of the given absence-id 🔒: Classbook.ShowModule, Absences.ShowModule
         * @param {string} absenceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<AbsenceResponse> {
            return localVarFp.getLatestAbsence(absenceId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest service for the given organization group where the class-service-id matches 🔒: Classbook.ShowModule
         * @param {string} classServiceId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassService(classServiceId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<ClassServicesResponse> {
            return localVarFp.getLatestClassService(classServiceId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the latest class-service-definition for the given organization group and the given class-service-definiton-id. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} serviceDefinitionId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassServicesDefinition(organizationId: string, serviceDefinitionId: string, timePeriod?: string, options?: any): AxiosPromise<ClassServiceDefinitionResponse> {
            return localVarFp.getLatestClassServicesDefinition(organizationId, serviceDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest Class by id the user effectively has access to. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassWithBasicCourses(classId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<ClassResponse> {
            return localVarFp.getLatestClassWithBasicCourses(classId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Class by id 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} classId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestClassWithBasicCoursesOfSettings(classId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<ClassResponse> {
            return localVarFp.getLatestClassWithBasicCoursesOfSettings(classId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest course by id the user has effectively access to. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<CourseResponse> {
            return localVarFp.getLatestCourse(courseId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest course by id. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestCourseOfSettings(courseId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<CourseResponse> {
            return localVarFp.getLatestCourseOfSettings(courseId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns the latest Grade by id if the user effectively has access to it. Also returns basic of all corresponding classes. 🔒: Classbook.ShowModule, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestGradeWithBasicClasses(gradeId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<GradeResponse> {
            return localVarFp.getLatestGradeWithBasicClasses(gradeId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Returns the latest Grade by id, also returns basic of all corresponding classes 🔒: Settings.Classbook
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestGradeWithBasicClassesOfSettings(gradeId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<GradeResponse> {
            return localVarFp.getLatestGradeWithBasicClassesOfSettings(gradeId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the latest holiday for the given organization group where the holiday-id matches
         * @param {string} holidayId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<HolidayResponse> {
            return localVarFp.getLatestHoliday(holidayId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the lesson by LessonId. 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLesson(lessonId: string, organizationId: string, timePeriod?: string, includeDrafts?: boolean, options?: any): AxiosPromise<LessonResponse> {
            return localVarFp.getLatestLesson(lessonId, organizationId, timePeriod, includeDrafts, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest lessonThemes for the given organization group by lesson-theme-Id 🔒: Classbook.ShowModule
         * @param {string} lessonThemeId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<LessonThemeResponse> {
            return localVarFp.getLatestLessonTheme(lessonThemeId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the latest methods of teaching for the given organization group by method-of-teaching-Id. 🔒: Classbook.ShowModule
         * @param {string} methodOfTeachingId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<MethodOfTeachingResponse> {
            return localVarFp.getLatestMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
         * @summary Returns all draft absences that overlap the given lesson\'s time window for its students. Drafts that have already been accepted into a real absence are excluded. 🔒: Absences.ShowDrafts
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonDraftAbsences(lessonId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceResponse>> {
            return localVarFp.getLessonDraftAbsences(lessonId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the next lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [endOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonOfCourseNext(courseId: string, organizationId: string, endOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any): AxiosPromise<LessonResponse> {
            return localVarFp.getLessonOfCourseNext(courseId, organizationId, endOfCurrentLesson, timePeriod, includeDrafts, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the previous lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} organizationId 
         * @param {string} [startOfCurrentLesson] 
         * @param {string} [timePeriod] 
         * @param {boolean} [includeDrafts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonOfCoursePrevious(courseId: string, organizationId: string, startOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any): AxiosPromise<LessonResponse> {
            return localVarFp.getLessonOfCoursePrevious(courseId, organizationId, startOfCurrentLesson, timePeriod, includeDrafts, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons of the request-caller who have no assigned lessonTheme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonWithoutTheme(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonResponse> {
            return localVarFp.getLessonWithoutTheme(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all class lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} classId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfClassRange(classId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonResponse> {
            return localVarFp.getLessonsOfClassRange(classId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all course lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} courseId 
         * @param {string} end 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfCourseRange(courseId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonResponse> {
            return localVarFp.getLessonsOfCourseRange(courseId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all gerade lessons within the given time range. 🔒: Classbook.ShowModule
         * @param {string} end 
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfGradeRange(end: string, gradeId: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonResponse> {
            return localVarFp.getLessonsOfGradeRange(end, gradeId, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all my lessons from the given start time for the next 24 hours. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start Defines date time of first item. Returns all items for the next 24 hours.
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfMyAgenda(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonBasicResponse> {
            return localVarFp.getLessonsOfMyAgenda(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all next lessons from the start time for all my courses. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonsOfMyCourses(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonBasicResponse> {
            return localVarFp.getLessonsOfMyCourses(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the number of unsigned lessons of the request-caller and the number of lessons without an assigned lessonTheme as an array of two integers. Note: this method still consumes high amounts of RUs, use wisely. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingInformationsCount(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<MissingQuantity> {
            return localVarFp.getMissingInformationsCount(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all services for the requesting user, which are not deactivated by definition. Optional filter by definition id. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [definitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyClassServices(organizationId: string, definitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<ClassServicesResponseExtended>> {
            return localVarFp.getMyClassServices(organizationId, definitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information.
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomework(timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any): AxiosPromise<Array<HomeworkResponse>> {
            return localVarFp.getMyHomework(timePeriod, excludeTeamsAssignments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all specified homework for the given course if the user is member of the course. This will return everything for the current timePeriod.
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomeworkByCourse(courseId: string, timePeriod?: string, options?: any): AxiosPromise<Array<HomeworkResponse>> {
            return localVarFp.getMyHomeworkByCourse(courseId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns the effictive lesson permissions 🔒: Classbook.ShowModule
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyLessonPermissions(lessonId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<EffectiveLessonPermissions> {
            return localVarFp.getMyLessonPermissions(lessonId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the substitutions for the current user.
         * @param {string} organizationId 
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySubstitutions(organizationId: string, start: string, dayCount?: number, options?: any): AxiosPromise<TimeTableSubstitutionsOfMeResponse> {
            return localVarFp.getMySubstitutions(organizationId, start, dayCount, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Returns all lessons that the provided user still has to sign, or that belong to a given group. At least the user id or the group id must be provided. Optional filterLessonTheme narrows the result to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoSignedLessonsByUserAndOrGroup(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, filterLessonTheme?: LessonThemeFilterType, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfLessonResponse> {
            return localVarFp.getNoSignedLessonsByUserAndOrGroup(organizationId, timePeriod, groupId, userId, from, to, filterType, filterLessonTheme, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary Returns the import report of the reuqested organization. 🔒: Settings.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<ImportReportResponse> {
            return localVarFp.getReport(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the current school contact for the given organization.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolData(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<SchoolContact> {
            return localVarFp.getSchoolData(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Returns all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolEventMappings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<SchoolEventMappingsResponse> {
            return localVarFp.getSchoolEventMappings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school head teachers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolHeadTeachers(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getSchoolHeadTeachers(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
         * @summary Returns the current school managers. 🔒: Classbook.ShowModule, Settings.Classbook
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolManagers(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getSchoolManagers(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the latest seating plan in the given organization by seating-plan-id.
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.getSeatingPlan(organizationId, seatingPlanId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the seating plan of the desired course in the given organization.
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeatingPlanByGroup(groupId: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.getSeatingPlanByGroup(groupId, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [start] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutions(start?: string, timePeriod?: string, options?: any): AxiosPromise<Array<Substitution>> {
            return localVarFp.getSubstitutions(start, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the current active time pattern for  the given organization group
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableSettings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableSettings> {
            return localVarFp.getTimeTableSettings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available course names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableCourseNames(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureGroupInfoResponse>> {
            return localVarFp.getTimetableCourseNames(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table available lesson names for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableLessonNames(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<LessonNameAndType>> {
            return localVarFp.getTimetableLessonNames(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Gets the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableMappings(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureGroupAssignmentResponse>> {
            return localVarFp.getTimetableMappings(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified group starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} groupId 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfGroup(days: number, groupId: string, organizationId: string, start: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimetableOfGroup(days, groupId, organizationId, start, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets the time table for the specified room starting and ending at the given date and period. 🔒: Timetable.ReadAll
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfRoom(days: number, organizationId: string, roomId: string, start: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimetableOfRoom(days, organizationId, roomId, start, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li></ul>
         * @summary Gets the time table for the specified user starting and ending at the given date and period. 🔒: Timetable.ShowModule
         * @param {number} days 
         * @param {string} organizationId 
         * @param {string} start 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableOfUser(days: number, organizationId: string, start: string, userId: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimetableOfUser(days, organizationId, start, userId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current students within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableStudents(organizationId: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getTimetableStudents(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary Gets all current teachers within this organization. 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimetableTeachers(organizationId: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getTimetableTeachers(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Marks the given lessons of a student as attended. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {MarkLessonsPresent} markLessonsPresent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markLessonsPresent(organizationId: string, studentId: string, markLessonsPresent: MarkLessonsPresent, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceResponse>> {
            return localVarFp.markLessonsPresent(organizationId, studentId, markLessonsPresent, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Signs the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any): AxiosPromise<LessonResponse> {
            return localVarFp.signLesson(lessonId, organizationId, signLevel, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Signs multiple lessons based on filtering criteria. Optional filterLessonTheme restricts the bulk-sign operation to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [groupId] 
         * @param {string} [userId] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {UnsignedFilterType} [filterType] 
         * @param {SignLevel} [signLevel] 
         * @param {LessonThemeFilterType} [filterLessonTheme] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signMultipleLessons(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, signLevel?: SignLevel, filterLessonTheme?: LessonThemeFilterType, options?: any): AxiosPromise<LessonsSignMultipleResponse> {
            return localVarFp.signMultipleLessons(organizationId, timePeriod, groupId, userId, from, to, filterType, signLevel, filterLessonTheme, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a subscriber to the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.subscribeToSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary UnSign the given lesson.
         * @param {string} lessonId 
         * @param {string} organizationId 
         * @param {SignLevel} [signLevel] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unSignLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any): AxiosPromise<LessonResponse> {
            return localVarFp.unSignLesson(lessonId, organizationId, signLevel, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a subscriber from the seating plan of the desired organization.
         * @param {string} myGroupId 
         * @param {string} organizationId 
         * @param {string} seatingPlanId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeFromSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.unsubscribeFromSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given holiday. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {HolidayResponse} holidayResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAHoliday(organizationId: string, holidayResponse: HolidayResponse, timePeriod?: string, options?: any): AxiosPromise<HolidayResponse> {
            return localVarFp.updateAHoliday(organizationId, holidayResponse, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single or multiple absence-reasons. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {AbsenceReasonPutEntry} absenceReasonPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsenceReasons(organizationId: string, absenceReasonPutEntry: AbsenceReasonPutEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceReasonResponse> {
            return localVarFp.updateAbsenceReasons(organizationId, absenceReasonPutEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single absence. 🔒: Absences.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {AbsencePutEntry} absencePutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any): AxiosPromise<AbsenceResponse> {
            return localVarFp.updateAbsences(organizationId, absencePutEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates a single excuse-definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ExcuseDefinitionUpdate} excuseDefinitionUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAbsencesExcuseDefinition(organizationId: string, excuseDefinitionUpdate: ExcuseDefinitionUpdate, timePeriod?: string, options?: any): AxiosPromise<ExcuseDefinitionResponse> {
            return localVarFp.updateAbsencesExcuseDefinition(organizationId, excuseDefinitionUpdate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Class. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} gradeId 
         * @param {string} organizationId 
         * @param {ClassUpdateEntry} classUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClass(gradeId: string, organizationId: string, classUpdateEntry: ClassUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<ClassResponse> {
            return localVarFp.updateClass(gradeId, organizationId, classUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given class service. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassServicesPutEntry} classServicesPutEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassService(organizationId: string, classServicesPutEntry: ClassServicesPutEntry, timePeriod?: string, options?: any): AxiosPromise<ClassServicesResponse> {
            return localVarFp.updateClassService(organizationId, classServicesPutEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given class service definition. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassServiceDefinitionResponse} classServiceDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassServiceDefinition(organizationId: string, classServiceDefinitionResponse: ClassServiceDefinitionResponse, timePeriod?: string, options?: any): AxiosPromise<ClassServiceDefinitionResponse> {
            return localVarFp.updateClassServiceDefinition(organizationId, classServiceDefinitionResponse, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-category for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryCategoryPutRequest} classbookEntryCategoryPutRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntriesCategory(organizationId: string, classbookEntryCategoryPutRequest: ClassbookEntryCategoryPutRequest, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryCategoryResponse> {
            return localVarFp.updateClassbookEntriesCategory(organizationId, classbookEntryCategoryPutRequest, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {ClassbookEntryDefinitionResponse} classbookEntryDefinitionResponse 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionResponse: ClassbookEntryDefinitionResponse, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryDefinitionFullResponse> {
            return localVarFp.updateClassbookEntriesDefinition(organizationId, classbookEntryDefinitionResponse, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates a single classbookEntry for the given organization. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {ClassbookEntryUpdateRequest} classbookEntryUpdateRequest 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClassbookEntry(organizationId: string, classbookEntryUpdateRequest: ClassbookEntryUpdateRequest, timePeriod?: string, options?: any): AxiosPromise<ClassbookEntryResponse> {
            return localVarFp.updateClassbookEntry(organizationId, classbookEntryUpdateRequest, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified course. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {CourseUpdateEntry} courseUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourse(organizationId: string, courseUpdateEntry: CourseUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<CourseResponse> {
            return localVarFp.updateCourse(organizationId, courseUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ReadWriteAll</li></ul>
         * @summary Updates the dependent classes of a course. 🔒: Classbook.ReadWriteAll
         * @param {string} organizationId 
         * @param {CourseClassDependenciesUpdate} courseClassDependenciesUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoursesClassDependencies(organizationId: string, courseClassDependenciesUpdate: CourseClassDependenciesUpdate, timePeriod?: string, options?: any): AxiosPromise<CourseResponse> {
            return localVarFp.updateCoursesClassDependencies(organizationId, courseClassDependenciesUpdate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Updates the specified Grade. 🔒: Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GradeUpdateEntry} gradeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGrade(organizationId: string, gradeUpdateEntry: GradeUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<GradeResponse> {
            return localVarFp.updateGrade(organizationId, gradeUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the specified homework entry. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {HomeworkUpdate} homeworkUpdate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHomework(organizationId: string, homeworkUpdate: HomeworkUpdate, timePeriod?: string, options?: any): AxiosPromise<HomeworkResponse> {
            return localVarFp.updateHomework(organizationId, homeworkUpdate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
         * @summary Updates the given lesson theme. 🔒: Classbook.ShowModule
         * @param {string} organizationId 
         * @param {LessonThemeUpdateEntry} lessonThemeUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLessonTheme(organizationId: string, lessonThemeUpdateEntry: LessonThemeUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<LessonThemeResponse> {
            return localVarFp.updateLessonTheme(organizationId, lessonThemeUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
         * @summary Updates the given lessonTheme-methodOfTeaching. 🔒: Settings.Classbook
         * @param {string} organizationId 
         * @param {MethodOfTeachingUpdateEntry} methodOfTeachingUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMethodOfTeaching(organizationId: string, methodOfTeachingUpdateEntry: MethodOfTeachingUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<MethodOfTeachingResponse> {
            return localVarFp.updateMethodOfTeaching(organizationId, methodOfTeachingUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Creates or Updates all SchoolEventMappings. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<SchoolEventMapping>} schoolEventMapping 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchoolEventMappings(organizationId: string, schoolEventMapping: Array<SchoolEventMapping>, timePeriod?: string, options?: any): AxiosPromise<SchoolEventMappingsResponse> {
            return localVarFp.updateSchoolEventMappings(organizationId, schoolEventMapping, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the seating plan of the desired organization.
         * @param {string} organizationId 
         * @param {SeatingPlanUpdateEntry} seatingPlanUpdateEntry 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeatingPlan(organizationId: string, seatingPlanUpdateEntry: SeatingPlanUpdateEntry, timePeriod?: string, options?: any): AxiosPromise<SeatingPlanResponse> {
            return localVarFp.updateSeatingPlan(organizationId, seatingPlanUpdateEntry, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the given time pattern.
         * @param {string} organizationId 
         * @param {TimePatternRequestWithId} timePatternRequestWithId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimePattern(organizationId: string, timePatternRequestWithId: TimePatternRequestWithId, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.updateTimePattern(organizationId, timePatternRequestWithId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the time table settings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {TimeTableUpdateSettings} timeTableUpdateSettings 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTableSettings(organizationId: string, timeTableUpdateSettings: TimeTableUpdateSettings, timePeriod?: string, options?: any): AxiosPromise<TimeTableSettings> {
            return localVarFp.updateTimeTableSettings(organizationId, timeTableUpdateSettings, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
         * @summary Updates the current time table mappings for the specified organization. 🔒: Settings.Timetable
         * @param {string} organizationId 
         * @param {Array<AzureGroupAssignmentUpdateRequestItem>} azureGroupAssignmentUpdateRequestItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimetableMappings(organizationId: string, azureGroupAssignmentUpdateRequestItem: Array<AzureGroupAssignmentUpdateRequestItem>, options?: any): AxiosPromise<void> {
            return localVarFp.updateTimetableMappings(organizationId, azureGroupAssignmentUpdateRequestItem, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClassRegisterApi - object-oriented interface
 * @export
 * @class ClassRegisterApi
 * @extends {BaseAPI}
 */
export class ClassRegisterApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary Returns student absences. 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {AbsencesGetOfStudentRequestFilter} [filter] 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {string} [courseId] 
     * @param {string} [absenceReasonId] 
     * @param {string} [timePeriod] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public absencesOfStudent(organizationId: string, studentId: string, filter?: AbsencesGetOfStudentRequestFilter, start?: string, end?: string, courseId?: string, absenceReasonId?: string, timePeriod?: string, pageSize?: number, page?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).absencesOfStudent(organizationId, studentId, filter, start, end, courseId, absenceReasonId, timePeriod, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary Returns detailed information about the student. 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public absencesOfStudentDetails(organizationId: string, studentId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).absencesOfStudentDetails(organizationId, studentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li></ul>
     * @summary Returns all absences between a given date range of the student. 🔒: Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {string} from 
     * @param {string} to 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public absencesOfStudentTimetableFormatHandler(organizationId: string, studentId: string, from: string, to: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).absencesOfStudentTimetableFormatHandler(organizationId, studentId, from, to, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Add an attachment to the given absence-id 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} timePeriod 
     * @param {string} absenceId 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public addAttachment(organizationId: string, timePeriod: string, absenceId: string, file?: any, options?: any) {
        return ClassRegisterApiFp(this.configuration).addAttachment(organizationId, timePeriod, absenceId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the given time pattern activation state.
     * @param {string} organizationId 
     * @param {string} timePatternId 
     * @param {ActivationState} [activationState] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public changeTimePatternActivationState(organizationId: string, timePatternId: string, activationState?: ActivationState, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).changeTimePatternActivationState(organizationId, timePatternId, activationState, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Creates a single absence. Avoid using this when creating multiple absences at once. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {AbsenceEntry} absenceEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createAbsence(organizationId: string, absenceEntry: AbsenceEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createAbsence(organizationId, absenceEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates a single excuse-definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ExcuseDefinitionEntry} excuseDefinitionEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createAbsenceExcuseDefinition(organizationId: string, excuseDefinitionEntry: ExcuseDefinitionEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createAbsenceExcuseDefinition(organizationId, excuseDefinitionEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates a single absence reasons. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {AbsenceReasonEntry} absenceReasonEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createAbsencesReasons(organizationId: string, absenceReasonEntry: AbsenceReasonEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createAbsencesReasons(organizationId, absenceReasonEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Creates multiple absences in bulk. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a bunch of students at the same time that span over multiple courses. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {AbsenceBulkRequestContainer} absenceBulkRequestContainer 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createBulkAbsences(organizationId: string, absenceBulkRequestContainer: AbsenceBulkRequestContainer, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createBulkAbsences(organizationId, absenceBulkRequestContainer, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Creates the specified Class entry for the desired organization group. GradeId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {ClassCreateEntry} classCreateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClass(gradeId: string, organizationId: string, classCreateEntry: ClassCreateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClass(gradeId, organizationId, classCreateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
     * @summary Creates the given class service. 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
     * @param {string} organizationId 
     * @param {ClassServicesEntry} classServicesEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClassService(organizationId: string, classServicesEntry: ClassServicesEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClassService(organizationId, classServicesEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates the given class service definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassServicesDefinitionEntry} classServicesDefinitionEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClassServiceDefinition(organizationId: string, classServicesDefinitionEntry: ClassServicesDefinitionEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClassServiceDefinition(organizationId, classServicesDefinitionEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates one ClassbookEntry-category for the given organization. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassbookEntryCategoryRequest} classbookEntryCategoryRequest 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClassbookEntriesCategory(organizationId: string, classbookEntryCategoryRequest: ClassbookEntryCategoryRequest, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClassbookEntriesCategory(organizationId, classbookEntryCategoryRequest, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassbookEntryDefinitionEntry} classbookEntryDefinitionEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionEntry: ClassbookEntryDefinitionEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClassbookEntriesDefinition(organizationId, classbookEntryDefinitionEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Creates a single specified ClassbookEntry for the given organization. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {ClassbookEntryCreateRequest} classbookEntryCreateRequest 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createClassbookEntry(organizationId: string, classbookEntryCreateRequest: ClassbookEntryCreateRequest, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createClassbookEntry(organizationId, classbookEntryCreateRequest, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Creates the specified course entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {CourseCreateEntry} courseCreateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createCourse(organizationId: string, courseCreateEntry: CourseCreateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createCourse(organizationId, courseCreateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Creates the specified Grade entry for the desired organization group. ClassId is necessary for that. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {GradeCreateEntry} gradeCreateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createGrade(organizationId: string, gradeCreateEntry: GradeCreateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createGrade(organizationId, gradeCreateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates the given holiday. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {HolidayEntry} holidayEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createHoliday(organizationId: string, holidayEntry: HolidayEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createHoliday(organizationId, holidayEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Creates the specified homework entry. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {HomeworkCreate} homeworkCreate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createHomework(organizationId: string, homeworkCreate: HomeworkCreate, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createHomework(organizationId, homeworkCreate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Creates the given lesson theme. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {LessonThemeCreateEntry} lessonThemeCreateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createLessonTheme(organizationId: string, lessonThemeCreateEntry: LessonThemeCreateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createLessonTheme(organizationId, lessonThemeCreateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates the given lessontheme-methodofteaching. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {MethodOfTeachingEntry} methodOfTeachingEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createMethodOfTeaching(organizationId: string, methodOfTeachingEntry: MethodOfTeachingEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createMethodOfTeaching(organizationId, methodOfTeachingEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Creates OR updates multiple absences. Use this instead of CreateAbsence or UpdateAbsence when multiple absence have to be created or updated for a course at once ! 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {AbsencesCreateOrUpdateLists} absencesCreateOrUpdateLists 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateAbsences(lessonId: string, organizationId: string, absencesCreateOrUpdateLists: AbsencesCreateOrUpdateLists, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateAbsences(lessonId, organizationId, absencesCreateOrUpdateLists, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Create or updates the specified EditAndNotificationSettings entry for the desired organization group. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {EditAndNotificationSettingsItem} editAndNotificationSettingsItem 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateEditAndNotificationSettings(organizationId: string, editAndNotificationSettingsItem: EditAndNotificationSettingsItem, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateEditAndNotificationSettings(organizationId, editAndNotificationSettingsItem, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Create or updates the specified GeneralSettings entry for the desired organization group. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {GeneralSettingsItem} generalSettingsItem 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateGeneralSettings(organizationId: string, generalSettingsItem: GeneralSettingsItem, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateGeneralSettings(organizationId, generalSettingsItem, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or updates the given schoolData item, depending on if any item already exists.
     * @param {string} organizationId 
     * @param {SchoolContact} schoolContact 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateSchoolData(organizationId: string, schoolContact: SchoolContact, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateSchoolData(organizationId, schoolContact, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates or updates the list of head teachers. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateSchoolHeadTeachers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateSchoolHeadTeachers(organizationId, requestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Creates or updates the list of school managers. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createOrUpdateSchoolManagers(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createOrUpdateSchoolManagers(organizationId, requestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates the seating plan of the desired organization.
     * @param {string} organizationId 
     * @param {SeatingPlanEntry} seatingPlanEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createSeatingPlan(organizationId: string, seatingPlanEntry: SeatingPlanEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createSeatingPlan(organizationId, seatingPlanEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates the given time pattern.
     * @param {string} organizationId 
     * @param {TimePatternRequest} timePatternRequest 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public createTimePattern(organizationId: string, timePatternRequest: TimePatternRequest, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).createTimePattern(organizationId, timePatternRequest, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Removes a given class absence. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} absenceId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteAbsence(absenceId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes a given class absence-reason-definition. 🔒: Settings.Classbook
     * @param {string} excuseDefinitionId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteAbsenceExcuseDefinition(excuseDefinitionId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteAbsenceExcuseDefinition(excuseDefinitionId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes a given class absence-reason. 🔒: Settings.Classbook
     * @param {string} absenceReasonId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteAbsenceReason(absenceReasonId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteAbsenceReason(absenceReasonId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Removes a given attachment for the given absence-id. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} absenceId 
     * @param {string} organizationId 
     * @param {string} fileName 
     * @param {string} timePeriod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteAttachment(absenceId: string, organizationId: string, fileName: string, timePeriod: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteAttachment(absenceId, organizationId, fileName, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the specified Class from the given organization. Checks if any Courses exists inside the class before the actual delete. 🔒: Settings.Classbook
     * @param {string} classId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClass(classId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClass(classId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Removes the given class service. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} serviceId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClassService(organizationId: string, serviceId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClassService(organizationId, serviceId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the given class service definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {string} serviceId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClassServiceDefinition(organizationId: string, serviceId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClassServiceDefinition(organizationId, serviceId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The category won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the specified category from the given organization. 🔒: Settings.Classbook
     * @param {string} categoryId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClassbookEntriesCategory(categoryId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClassbookEntriesCategory(categoryId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The definition won\'t be really delete. Instead it is only marked as delete and can be resolved by administrators.<br>Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the specified definition from the given organization. 🔒: Settings.Classbook
     * @param {string} definitionId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClassbookEntriesDefinition(definitionId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClassbookEntriesDefinition(definitionId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Classbook.ReadWriteAll</li></ul>
     * @summary Deletes a ClassbookEntry 🔒: Classbook.ShowModule, Classbook.ReadWriteAll
     * @param {string} classbookEntryId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteClassbookEntry(classbookEntryId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteClassbookEntry(classbookEntryId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the specified course from the given organization. 🔒: Settings.Classbook
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteCourse(courseId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the specified Grade from the given organization. 🔒: Settings.Classbook
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteGrade(gradeId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteGrade(gradeId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Removes the specified homework entry from the given organization. 🔒: Classbook.ShowModule
     * @param {string} homeworkId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteHomework(homeworkId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteHomework(homeworkId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Removes the given lesson theme. 🔒: Classbook.ShowModule
     * @param {string} lessonThemeId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteLessonTheme(lessonThemeId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the given lesson theme - method of teaching. 🔒: Settings.Classbook
     * @param {string} methodOfTeachingId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes the given seating plan.
     * @param {string} organizationId 
     * @param {string} seatingPlanId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteSeatingPlan(organizationId, seatingPlanId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes the current time pattern.
     * @param {string} organizationId 
     * @param {string} timePatternId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deleteTimePattern(organizationId: string, timePatternId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deleteTimePattern(organizationId, timePatternId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Removes the given holiday. 🔒: Settings.Classbook
     * @param {string} holidayId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public deletesAHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).deletesAHoliday(holidayId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns all students and their absences of the school. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {number} skip 
     * @param {number} take 
     * @param {string} [reasonId] 
     * @param {string} [searchForName] 
     * @param {Sequence} [sequence] 
     * @param {SortableBy} [sortBy] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAbsenceOverview(organizationId: string, skip: number, take: number, reasonId?: string, searchForName?: string, sequence?: Sequence, sortBy?: SortableBy, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAbsenceOverview(organizationId, skip, take, reasonId, searchForName, sequence, sortBy, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Get all reasons which are using the given excuse definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {string} excuseDefinitionId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAbsenceReasonsOfDefinition(organizationId: string, excuseDefinitionId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAbsenceReasonsOfDefinition(organizationId, excuseDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Check the amount of absences in a given time period. 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAbsencesCount(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAbsencesCount(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Returns excuse-definitions of the whole organization. Parameter isEnabled is optional. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {boolean} [enabledOnly] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllAbsenceExcuseDefinitions(organizationId: string, enabledOnly?: boolean, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllAbsenceExcuseDefinitions(organizationId, enabledOnly, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Returns absence-reasons of the whole organization. Parameter reasonDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {boolean} [enabledOnly] 
     * @param {string} [reasonDefinitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Returns absences of all students in the given organization at the current time period between dayStart and dayEnd. ExcuseDefinitionId is optional. 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} organizationId 
     * @param {string} [excuseDefinitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllAbsences(dayEnd: string, dayStart: string, organizationId: string, excuseDefinitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllAbsences(dayEnd, dayStart, organizationId, excuseDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.ReadAll</li></ul>
     * @summary Returns all basicClasses the user effectively has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary Returns all basicClasses no matter if iam in that class or how the grade was 🔒: Classbook.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicClassesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicClassesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.ReadAll</li><li>Absences.ShowModule</li></ul>
     * @summary Returns all basic courses the user has effectively access to. 🔒: Classbook.ShowModule, Timetable.ReadAll, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Returns all basic courses no matter if the person which is requesting is part of that course. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicCoursesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicCoursesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary By default this returns all basic grades the user effectivly has access to. 🔒: Classbook.ShowModule, Absences.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicGrades(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicGrades(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Returns all grades. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllBasicGradesOfSettings(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllBasicGradesOfSettings(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Returns all definitions for the given organization group. 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllClassServiceDefinitions(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllClassServiceDefinitions(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all services for the given organization group of the given user, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id and or group id. 🔒: Classbook.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {string} [definitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllClassServicesByStudent(dayEnd: string, dayStart: string, organizationId: string, studentId: string, definitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllClassServicesByStudent(dayEnd, dayStart, organizationId, studentId, definitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Gets all ClassbookEntries where the specified period matches. Optional, filter by Category beforehand. 🔒: Classbook.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} organizationId 
     * @param {string} [categoryId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllClassbookEntries(dayEnd: string, dayStart: string, organizationId: string, categoryId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllClassbookEntries(dayEnd, dayStart, organizationId, categoryId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Gets all ClassbookEntries for the given group where the specified date/time is greater or equal the given dates, range can be any time in this current time period. 🔒: Classbook.ShowModule
     * @param {string} end 
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [categoryId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllClassbookEntriesByGroup(end: string, groupId: string, organizationId: string, start: string, categoryId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllClassbookEntriesByGroup(end, groupId, organizationId, start, categoryId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Gets all categories from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllClassbookEntriesCategories(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllClassbookEntriesCategories(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Gets all definitions from the organisation from a given school year/period 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllEntryDefinitions(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllEntryDefinitions(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all holidays for the given organization group
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllHolidays(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllHolidays(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all specified homework for the given date range, where the start date is greater or equal the given day or the end date is less then the given day. Optional : filter by Deadline 🔒: Classbook.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllHomework(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllHomework(dayEnd, dayStart, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all specified homework for the given course, where the start date is greater or equal the given day or the end date is less then the given day. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [dayEnd] 
     * @param {string} [dayStart] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllHomeworkByCourse(courseId: string, organizationId: string, dayEnd?: string, dayStart?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllHomeworkByCourse(courseId, organizationId, dayEnd, dayStart, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all lessonThemes for the given organization group, where the given date/time is greater or equal the lessonTheme start date or less then the lessonTheme end date. Optional filter by methodOfTeaching. 🔒: Classbook.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllLessonThemes(dayEnd: string, dayStart: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllLessonThemes(dayEnd, dayStart, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all lesson themes for the given organization group, where the given date/time is greater or equal the service start date or less then the service end date. Optional filter by definition id. 🔒: Classbook.ShowModule
     * @param {string} dayEnd 
     * @param {string} dayStart 
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllLessonThemesByGroup(dayEnd: string, dayStart: string, groupId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllLessonThemesByGroup(dayEnd, dayStart, groupId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all methods of teaching for the given organization group. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllMethodsOfTeaching(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllMethodsOfTeaching(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all available seating plan (names and ids) in the given organization.
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllSeatingPlans(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllSeatingPlans(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all time patterns for  the given organization group
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllTimePatterns(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllTimePatterns(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary Gets all rooms used by the timetable. 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAllTimetableRooms(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAllTimetableRooms(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Get content for the given attachment. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} absenceId 
     * @param {string} fileName 
     * @param {string} timePeriod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAttachment(organizationId: string, absenceId: string, fileName: string, timePeriod: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAttachment(organizationId, absenceId, fileName, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Returns the specified group. Optional: Include group members. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {boolean} [includeMembers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAzureGroup(groupId: string, organizationId: string, includeMembers?: boolean, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAzureGroup(groupId, organizationId, includeMembers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Returns all azure groups of the tenant/organization with the specified role (optional). By default, only groups with the origin \"AixConcept\" will be returned. This means, groups will also get filtered by its \"OrganizationId\". 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {Origin} [origin] 
     * @param {GroupRole} [role] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getAzureGroups(organizationId: string, origin?: Origin, role?: GroupRole, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getAzureGroups(organizationId, origin, role, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns all students and their absences of a class. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} classId 
     * @param {number} month 
     * @param {string} organizationId 
     * @param {number} year 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getClassAbsences(classId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getClassAbsences(classId, month, organizationId, year, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all services of the required group. This includes all services attached to corresponding classes. Note: Students will also see services not attached to themselves. 🔒: Courses.ShowModule
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} [definitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getClassServicesOfGroup(groupId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getClassServicesOfGroup(groupId, organizationId, definitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all services for the given organization groups lesson. Optional filter by definition id. 🔒: Classbook.ShowModule
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {string} [definitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getClassServicesOfLesson(lessonId: string, organizationId: string, definitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getClassServicesOfLesson(lessonId, organizationId, definitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns all students and their absences of a course. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} courseId 
     * @param {number} month 
     * @param {string} organizationId 
     * @param {number} year 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getCourseAbsences(courseId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getCourseAbsences(courseId, month, organizationId, year, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the students of a course. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getCourseStudents(courseId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getCourseStudents(courseId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns the edit and notification settings. 🔒: Settings.Classbook, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getEditAndNotificationSettings(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getEditAndNotificationSettings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Returns the general settings. 🔒: Settings.Classbook, Classbook.ShowModule, Absences.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getGeneralSettings(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getGeneralSettings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns all students and their absences of a grade. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} gradeId 
     * @param {number} month 
     * @param {string} organizationId 
     * @param {number} year 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getGradeAbsences(gradeId: string, month: number, organizationId: string, year: number, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getGradeAbsences(gradeId, month, organizationId, year, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowModule</li></ul>
     * @summary Returns the latest absence of the given absence-id 🔒: Classbook.ShowModule, Absences.ShowModule
     * @param {string} absenceId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestAbsence(absenceId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestAbsence(absenceId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the latest service for the given organization group where the class-service-id matches 🔒: Classbook.ShowModule
     * @param {string} classServiceId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestClassService(classServiceId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestClassService(classServiceId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Returns the latest class-service-definition for the given organization group and the given class-service-definiton-id. 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} serviceDefinitionId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestClassServicesDefinition(organizationId: string, serviceDefinitionId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestClassServicesDefinition(organizationId, serviceDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the latest Class by id the user effectively has access to. 🔒: Classbook.ShowModule
     * @param {string} classId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestClassWithBasicCourses(classId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestClassWithBasicCourses(classId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary Returns the latest Class by id 🔒: Classbook.ShowModule, Timetable.Planner
     * @param {string} classId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestClassWithBasicCoursesOfSettings(classId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestClassWithBasicCoursesOfSettings(classId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the latest course by id the user has effectively access to. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestCourse(courseId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestCourse(courseId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Returns the latest course by id. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestCourseOfSettings(courseId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestCourseOfSettings(courseId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary Returns the latest Grade by id if the user effectively has access to it. Also returns basic of all corresponding classes. 🔒: Classbook.ShowModule, Timetable.Planner
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestGradeWithBasicClasses(gradeId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestGradeWithBasicClasses(gradeId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Returns the latest Grade by id, also returns basic of all corresponding classes 🔒: Settings.Classbook
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestGradeWithBasicClassesOfSettings(gradeId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestGradeWithBasicClassesOfSettings(gradeId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the latest holiday for the given organization group where the holiday-id matches
     * @param {string} holidayId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestHoliday(holidayId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestHoliday(holidayId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the lesson by LessonId. 🔒: Classbook.ShowModule
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {boolean} [includeDrafts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestLesson(lessonId: string, organizationId: string, timePeriod?: string, includeDrafts?: boolean, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestLesson(lessonId, organizationId, timePeriod, includeDrafts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the latest lessonThemes for the given organization group by lesson-theme-Id 🔒: Classbook.ShowModule
     * @param {string} lessonThemeId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestLessonTheme(lessonThemeId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestLessonTheme(lessonThemeId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the latest methods of teaching for the given organization group by method-of-teaching-Id. 🔒: Classbook.ShowModule
     * @param {string} methodOfTeachingId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLatestMethodOfTeaching(methodOfTeachingId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLatestMethodOfTeaching(methodOfTeachingId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowDrafts</li></ul>
     * @summary Returns all draft absences that overlap the given lesson\'s time window for its students. Drafts that have already been accepted into a real absence are excluded. 🔒: Absences.ShowDrafts
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonDraftAbsences(lessonId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonDraftAbsences(lessonId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the next lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [endOfCurrentLesson] 
     * @param {string} [timePeriod] 
     * @param {boolean} [includeDrafts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonOfCourseNext(courseId: string, organizationId: string, endOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonOfCourseNext(courseId, organizationId, endOfCurrentLesson, timePeriod, includeDrafts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the previous lesson of the given course, either from now or by given time. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} organizationId 
     * @param {string} [startOfCurrentLesson] 
     * @param {string} [timePeriod] 
     * @param {boolean} [includeDrafts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonOfCoursePrevious(courseId: string, organizationId: string, startOfCurrentLesson?: string, timePeriod?: string, includeDrafts?: boolean, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonOfCoursePrevious(courseId, organizationId, startOfCurrentLesson, timePeriod, includeDrafts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all lessons of the request-caller who have no assigned lessonTheme. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonWithoutTheme(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonWithoutTheme(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all class lessons within the given time range. 🔒: Classbook.ShowModule
     * @param {string} classId 
     * @param {string} end 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonsOfClassRange(classId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonsOfClassRange(classId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all course lessons within the given time range. 🔒: Classbook.ShowModule
     * @param {string} courseId 
     * @param {string} end 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonsOfCourseRange(courseId: string, end: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonsOfCourseRange(courseId, end, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all gerade lessons within the given time range. 🔒: Classbook.ShowModule
     * @param {string} end 
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonsOfGradeRange(end: string, gradeId: string, organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonsOfGradeRange(end, gradeId, organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all my lessons from the given start time for the next 24 hours. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} start Defines date time of first item. Returns all items for the next 24 hours.
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonsOfMyAgenda(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonsOfMyAgenda(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all next lessons from the start time for all my courses. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getLessonsOfMyCourses(organizationId: string, start: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getLessonsOfMyCourses(organizationId, start, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the number of unsigned lessons of the request-caller and the number of lessons without an assigned lessonTheme as an array of two integers. Note: this method still consumes high amounts of RUs, use wisely. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMissingInformationsCount(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMissingInformationsCount(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all services for the requesting user, which are not deactivated by definition. Optional filter by definition id. 🔒: Courses.ShowModule
     * @param {string} organizationId 
     * @param {string} [definitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMyClassServices(organizationId: string, definitionId?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMyClassServices(organizationId, definitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information.
     * @param {string} [timePeriod] 
     * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMyHomework(timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMyHomework(timePeriod, excludeTeamsAssignments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all specified homework for the given course if the user is member of the course. This will return everything for the current timePeriod.
     * @param {string} courseId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMyHomeworkByCourse(courseId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMyHomeworkByCourse(courseId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns the effictive lesson permissions 🔒: Classbook.ShowModule
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMyLessonPermissions(lessonId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMyLessonPermissions(lessonId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the substitutions for the current user.
     * @param {string} organizationId 
     * @param {string} start 
     * @param {number} [dayCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getMySubstitutions(organizationId: string, start: string, dayCount?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getMySubstitutions(organizationId, start, dayCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Returns all lessons that the provided user still has to sign, or that belong to a given group. At least the user id or the group id must be provided. Optional filterLessonTheme narrows the result to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [groupId] 
     * @param {string} [userId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {UnsignedFilterType} [filterType] 
     * @param {LessonThemeFilterType} [filterLessonTheme] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getNoSignedLessonsByUserAndOrGroup(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, filterLessonTheme?: LessonThemeFilterType, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ClassRegisterApiFp(this.configuration).getNoSignedLessonsByUserAndOrGroup(organizationId, timePeriod, groupId, userId, from, to, filterType, filterLessonTheme, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
     * @summary Returns the import report of the reuqested organization. 🔒: Settings.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getReport(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getReport(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the current school contact for the given organization.
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSchoolData(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSchoolData(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Returns all SchoolEventMappings. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSchoolEventMappings(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSchoolEventMappings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Returns the current school head teachers. 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSchoolHeadTeachers(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSchoolHeadTeachers(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Settings.Classbook</li></ul>
     * @summary Returns the current school managers. 🔒: Classbook.ShowModule, Settings.Classbook
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSchoolManagers(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSchoolManagers(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the latest seating plan in the given organization by seating-plan-id.
     * @param {string} organizationId 
     * @param {string} seatingPlanId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSeatingPlan(organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSeatingPlan(organizationId, seatingPlanId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the seating plan of the desired course in the given organization.
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSeatingPlanByGroup(groupId: string, organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSeatingPlanByGroup(groupId, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [start] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getSubstitutions(start?: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getSubstitutions(start, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the current active time pattern for  the given organization group
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Gets the time table settings for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimeTableSettings(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimeTableSettings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Gets the current time table available course names for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableCourseNames(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableCourseNames(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Gets the current time table available lesson names for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableLessonNames(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableLessonNames(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Gets the current time table mappings for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableMappings(organizationId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableMappings(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary Gets the time table for the specified group starting and ending at the given date and period. 🔒: Timetable.ReadAll
     * @param {number} days 
     * @param {string} groupId 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableOfGroup(days: number, groupId: string, organizationId: string, start: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableOfGroup(days, groupId, organizationId, start, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary Gets the time table for the specified room starting and ending at the given date and period. 🔒: Timetable.ReadAll
     * @param {number} days 
     * @param {string} organizationId 
     * @param {string} roomId 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableOfRoom(days: number, organizationId: string, roomId: string, start: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableOfRoom(days, organizationId, roomId, start, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li></ul>
     * @summary Gets the time table for the specified user starting and ending at the given date and period. 🔒: Timetable.ShowModule
     * @param {number} days 
     * @param {string} organizationId 
     * @param {string} start 
     * @param {string} userId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableOfUser(days: number, organizationId: string, start: string, userId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableOfUser(days, organizationId, start, userId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary Gets all current students within this organization. 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableStudents(organizationId: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableStudents(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary Gets all current teachers within this organization. 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public getTimetableTeachers(organizationId: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).getTimetableTeachers(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Marks the given lessons of a student as attended. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {MarkLessonsPresent} markLessonsPresent 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public markLessonsPresent(organizationId: string, studentId: string, markLessonsPresent: MarkLessonsPresent, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).markLessonsPresent(organizationId, studentId, markLessonsPresent, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Signs the given lesson.
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {SignLevel} [signLevel] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public signLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).signLesson(lessonId, organizationId, signLevel, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Signs multiple lessons based on filtering criteria. Optional filterLessonTheme restricts the bulk-sign operation to lessons with or without an assigned lesson theme. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [groupId] 
     * @param {string} [userId] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {UnsignedFilterType} [filterType] 
     * @param {SignLevel} [signLevel] 
     * @param {LessonThemeFilterType} [filterLessonTheme] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public signMultipleLessons(organizationId: string, timePeriod?: string, groupId?: string, userId?: string, from?: string, to?: string, filterType?: UnsignedFilterType, signLevel?: SignLevel, filterLessonTheme?: LessonThemeFilterType, options?: any) {
        return ClassRegisterApiFp(this.configuration).signMultipleLessons(organizationId, timePeriod, groupId, userId, from, to, filterType, signLevel, filterLessonTheme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a subscriber to the seating plan of the desired organization.
     * @param {string} myGroupId 
     * @param {string} organizationId 
     * @param {string} seatingPlanId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public subscribeToSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).subscribeToSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary UnSign the given lesson.
     * @param {string} lessonId 
     * @param {string} organizationId 
     * @param {SignLevel} [signLevel] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public unSignLesson(lessonId: string, organizationId: string, signLevel?: SignLevel, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).unSignLesson(lessonId, organizationId, signLevel, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a subscriber from the seating plan of the desired organization.
     * @param {string} myGroupId 
     * @param {string} organizationId 
     * @param {string} seatingPlanId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public unsubscribeFromSeatingPlan(myGroupId: string, organizationId: string, seatingPlanId: string, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).unsubscribeFromSeatingPlan(myGroupId, organizationId, seatingPlanId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates the given holiday. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {HolidayResponse} holidayResponse 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateAHoliday(organizationId: string, holidayResponse: HolidayResponse, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateAHoliday(organizationId, holidayResponse, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates a single or multiple absence-reasons. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {AbsenceReasonPutEntry} absenceReasonPutEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateAbsenceReasons(organizationId: string, absenceReasonPutEntry: AbsenceReasonPutEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateAbsenceReasons(organizationId, absenceReasonPutEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Absences.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Updates a single absence. 🔒: Absences.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {AbsencePutEntry} absencePutEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateAbsences(organizationId: string, absencePutEntry: AbsencePutEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateAbsences(organizationId, absencePutEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates a single excuse-definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ExcuseDefinitionUpdate} excuseDefinitionUpdate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateAbsencesExcuseDefinition(organizationId: string, excuseDefinitionUpdate: ExcuseDefinitionUpdate, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateAbsencesExcuseDefinition(organizationId, excuseDefinitionUpdate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Updates the specified Class. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} gradeId 
     * @param {string} organizationId 
     * @param {ClassUpdateEntry} classUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClass(gradeId: string, organizationId: string, classUpdateEntry: ClassUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClass(gradeId, organizationId, classUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Updates the given class service. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {ClassServicesPutEntry} classServicesPutEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClassService(organizationId: string, classServicesPutEntry: ClassServicesPutEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClassService(organizationId, classServicesPutEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates the given class service definition. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassServiceDefinitionResponse} classServiceDefinitionResponse 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClassServiceDefinition(organizationId: string, classServiceDefinitionResponse: ClassServiceDefinitionResponse, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClassServiceDefinition(organizationId, classServiceDefinitionResponse, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates one ClassbookEntries-category for the given organization. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassbookEntryCategoryPutRequest} classbookEntryCategoryPutRequest 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClassbookEntriesCategory(organizationId: string, classbookEntryCategoryPutRequest: ClassbookEntryCategoryPutRequest, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClassbookEntriesCategory(organizationId, classbookEntryCategoryPutRequest, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates one ClassbookEntries-definition for the given organization. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {ClassbookEntryDefinitionResponse} classbookEntryDefinitionResponse 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClassbookEntriesDefinition(organizationId: string, classbookEntryDefinitionResponse: ClassbookEntryDefinitionResponse, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClassbookEntriesDefinition(organizationId, classbookEntryDefinitionResponse, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Updates a single classbookEntry for the given organization. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {ClassbookEntryUpdateRequest} classbookEntryUpdateRequest 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateClassbookEntry(organizationId: string, classbookEntryUpdateRequest: ClassbookEntryUpdateRequest, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateClassbookEntry(organizationId, classbookEntryUpdateRequest, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Updates the specified course. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {CourseUpdateEntry} courseUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateCourse(organizationId: string, courseUpdateEntry: CourseUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateCourse(organizationId, courseUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ReadWriteAll</li></ul>
     * @summary Updates the dependent classes of a course. 🔒: Classbook.ReadWriteAll
     * @param {string} organizationId 
     * @param {CourseClassDependenciesUpdate} courseClassDependenciesUpdate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateCoursesClassDependencies(organizationId: string, courseClassDependenciesUpdate: CourseClassDependenciesUpdate, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateCoursesClassDependencies(organizationId, courseClassDependenciesUpdate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Updates the specified Grade. 🔒: Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {GradeUpdateEntry} gradeUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateGrade(organizationId: string, gradeUpdateEntry: GradeUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateGrade(organizationId, gradeUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Updates the specified homework entry. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {HomeworkUpdate} homeworkUpdate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateHomework(organizationId: string, homeworkUpdate: HomeworkUpdate, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateHomework(organizationId, homeworkUpdate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li></ul>
     * @summary Updates the given lesson theme. 🔒: Classbook.ShowModule
     * @param {string} organizationId 
     * @param {LessonThemeUpdateEntry} lessonThemeUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateLessonTheme(organizationId: string, lessonThemeUpdateEntry: LessonThemeUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateLessonTheme(organizationId, lessonThemeUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Classbook</li></ul>
     * @summary Updates the given lessonTheme-methodOfTeaching. 🔒: Settings.Classbook
     * @param {string} organizationId 
     * @param {MethodOfTeachingUpdateEntry} methodOfTeachingUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateMethodOfTeaching(organizationId: string, methodOfTeachingUpdateEntry: MethodOfTeachingUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateMethodOfTeaching(organizationId, methodOfTeachingUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Creates or Updates all SchoolEventMappings. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {Array<SchoolEventMapping>} schoolEventMapping 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateSchoolEventMappings(organizationId: string, schoolEventMapping: Array<SchoolEventMapping>, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateSchoolEventMappings(organizationId, schoolEventMapping, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the seating plan of the desired organization.
     * @param {string} organizationId 
     * @param {SeatingPlanUpdateEntry} seatingPlanUpdateEntry 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateSeatingPlan(organizationId: string, seatingPlanUpdateEntry: SeatingPlanUpdateEntry, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateSeatingPlan(organizationId, seatingPlanUpdateEntry, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the given time pattern.
     * @param {string} organizationId 
     * @param {TimePatternRequestWithId} timePatternRequestWithId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateTimePattern(organizationId: string, timePatternRequestWithId: TimePatternRequestWithId, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateTimePattern(organizationId, timePatternRequestWithId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Updates the time table settings for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {TimeTableUpdateSettings} timeTableUpdateSettings 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateTimeTableSettings(organizationId: string, timeTableUpdateSettings: TimeTableUpdateSettings, timePeriod?: string, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateTimeTableSettings(organizationId, timeTableUpdateSettings, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Timetable</li></ul>
     * @summary Updates the current time table mappings for the specified organization. 🔒: Settings.Timetable
     * @param {string} organizationId 
     * @param {Array<AzureGroupAssignmentUpdateRequestItem>} azureGroupAssignmentUpdateRequestItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterApi
     */
    public updateTimetableMappings(organizationId: string, azureGroupAssignmentUpdateRequestItem: Array<AzureGroupAssignmentUpdateRequestItem>, options?: any) {
        return ClassRegisterApiFp(this.configuration).updateTimetableMappings(organizationId, azureGroupAssignmentUpdateRequestItem, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClassRegisterExportApi - axios parameter creator
 * @export
 */
export const ClassRegisterExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: async (organizationId: string, timePeriod: string, classId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createReport', 'organizationId', organizationId)
            // verify required parameter 'timePeriod' is not null or undefined
            assertParamExists('createReport', 'timePeriod', timePeriod)
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('createReport', 'classId', classId)
            const localVarPath = `/api/v2/ClassRegisterExport/{organizationId}/{timePeriod}/{classId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"timePeriod"}}`, encodeURIComponent(String(timePeriod)))
                .replace(`{${"classId"}}`, encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport: async (organizationId: string, reportName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadReport', 'organizationId', organizationId)
            // verify required parameter 'reportName' is not null or undefined
            assertParamExists('downloadReport', 'reportName', reportName)
            const localVarPath = `/api/v2/ClassRegisterExport/{organizationId}/{reportName}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportName"}}`, encodeURIComponent(String(reportName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ExportClassbooks</li></ul>
         * @summary Returns a list of already created reports for the organization. 🔒: Classbook.ExportClassbooks
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportsAvailable: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getReportsAvailable', 'organizationId', organizationId)
            const localVarPath = `/api/v2/ClassRegisterExport/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClassRegisterExportApi - functional programming interface
 * @export
 */
export const ClassRegisterExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClassRegisterExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReport(organizationId: string, timePeriod: string, classId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReport(organizationId, timePeriod, classId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadReport(organizationId: string, reportName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadReport(organizationId, reportName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ExportClassbooks</li></ul>
         * @summary Returns a list of already created reports for the organization. 🔒: Classbook.ExportClassbooks
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportsAvailable(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportAvailable>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportsAvailable(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClassRegisterExportApi - factory interface
 * @export
 */
export const ClassRegisterExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClassRegisterExportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} timePeriod 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(organizationId: string, timePeriod: string, classId: string, options?: any): AxiosPromise<void> {
            return localVarFp.createReport(organizationId, timePeriod, classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport(organizationId: string, reportName: string, options?: any): AxiosPromise<ReportResponse> {
            return localVarFp.downloadReport(organizationId, reportName, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ExportClassbooks</li></ul>
         * @summary Returns a list of already created reports for the organization. 🔒: Classbook.ExportClassbooks
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportsAvailable(organizationId: string, options?: any): AxiosPromise<Array<ReportAvailable>> {
            return localVarFp.getReportsAvailable(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClassRegisterExportApi - object-oriented interface
 * @export
 * @class ClassRegisterExportApi
 * @extends {BaseAPI}
 */
export class ClassRegisterExportApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationId 
     * @param {string} timePeriod 
     * @param {string} classId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterExportApi
     */
    public createReport(organizationId: string, timePeriod: string, classId: string, options?: any) {
        return ClassRegisterExportApiFp(this.configuration).createReport(organizationId, timePeriod, classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} reportName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterExportApi
     */
    public downloadReport(organizationId: string, reportName: string, options?: any) {
        return ClassRegisterExportApiFp(this.configuration).downloadReport(organizationId, reportName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ExportClassbooks</li></ul>
     * @summary Returns a list of already created reports for the organization. 🔒: Classbook.ExportClassbooks
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassRegisterExportApi
     */
    public getReportsAvailable(organizationId: string, options?: any) {
        return ClassRegisterExportApiFp(this.configuration).getReportsAvailable(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CockpitApi - axios parameter creator
 * @export
 */
export const CockpitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCockpitWidgetsConfiguration: async (organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateCockpitWidgetsConfiguration', 'organizationId', organizationId)
            // verify required parameter 'cockpitWidgetsConfigurationItem' is not null or undefined
            assertParamExists('createOrUpdateCockpitWidgetsConfiguration', 'cockpitWidgetsConfigurationItem', cockpitWidgetsConfigurationItem)
            const localVarPath = `/api/V2/{organizationId}/Cockpit/widgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cockpitWidgetsConfigurationItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the banner configuration for the cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitBanner: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCockpitBanner', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Cockpit/banner`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitWidgetsConfiguration: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCockpitWidgetsConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Cockpit/widgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns widgets visible for the current user.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCockpitWidgets: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyCockpitWidgets', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Cockpit/widgets/me`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CockpitApi - functional programming interface
 * @export
 */
export const CockpitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CockpitApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CockpitWidgetsConfigurationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the banner configuration for the cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCockpitBanner(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CockpitBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCockpitBanner(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCockpitWidgetsConfiguration(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CockpitWidgetsConfigurationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCockpitWidgetsConfiguration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns widgets visible for the current user.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCockpitWidgets(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCockpitWidgets(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CockpitApi - factory interface
 * @export
 */
export const CockpitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CockpitApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any): AxiosPromise<CockpitWidgetsConfigurationItem> {
            return localVarFp.createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the banner configuration for the cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitBanner(organizationId: string, options?: any): AxiosPromise<CockpitBannerResponse> {
            return localVarFp.getCockpitBanner(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitWidgetsConfiguration(organizationId: string, options?: any): AxiosPromise<CockpitWidgetsConfigurationItem> {
            return localVarFp.getCockpitWidgetsConfiguration(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns widgets visible for the current user.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCockpitWidgets(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getMyCockpitWidgets(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CockpitApi - object-oriented interface
 * @export
 * @class CockpitApi
 * @extends {BaseAPI}
 */
export class CockpitApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Creates or updates the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitApi
     */
    public createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any) {
        return CockpitApiFp(this.configuration).createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the banner configuration for the cockpit
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitApi
     */
    public getCockpitBanner(organizationId: string, options?: any) {
        return CockpitApiFp(this.configuration).getCockpitBanner(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Returns the cockpit widget configuration (admin endpoint) 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitApi
     */
    public getCockpitWidgetsConfiguration(organizationId: string, options?: any) {
        return CockpitApiFp(this.configuration).getCockpitWidgetsConfiguration(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns widgets visible for the current user.
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitApi
     */
    public getMyCockpitWidgets(organizationId: string, options?: any) {
        return CockpitApiFp(this.configuration).getMyCockpitWidgets(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CockpitSettingsApi - axios parameter creator
 * @export
 */
export const CockpitSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCockpitWidgetsConfiguration: async (organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateCockpitWidgetsConfiguration', 'organizationId', organizationId)
            // verify required parameter 'cockpitWidgetsConfigurationItem' is not null or undefined
            assertParamExists('createOrUpdateCockpitWidgetsConfiguration', 'cockpitWidgetsConfigurationItem', cockpitWidgetsConfigurationItem)
            const localVarPath = `/api/V2/{organizationId}/CockpitSettings/widgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cockpitWidgetsConfigurationItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Deletes the banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCockpitBanner: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCockpitBanner', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/CockpitSettings/banner`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitWidgetsConfiguration: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCockpitWidgetsConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/CockpitSettings/widgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Updates the disabled setting for the cockpit banner 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCockpitBannerDisabled: async (organizationId: string, body: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCockpitBannerDisabled', 'organizationId', organizationId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCockpitBannerDisabled', 'body', body)
            const localVarPath = `/api/V2/{organizationId}/CockpitSettings/banner/disabled`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Uploads a banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {string} [bannerImage] 
         * @param {any} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCockpitBanner: async (organizationId: string, bannerImage?: string, image?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadCockpitBanner', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/CockpitSettings/banner`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (bannerImage !== undefined) {
                localVarQueryParameter['bannerImage'] = bannerImage;
            }


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CockpitSettingsApi - functional programming interface
 * @export
 */
export const CockpitSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CockpitSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CockpitWidgetsConfigurationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Deletes the banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCockpitBanner(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCockpitBanner(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCockpitWidgetsConfiguration(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CockpitWidgetsConfigurationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCockpitWidgetsConfiguration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Updates the disabled setting for the cockpit banner 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCockpitBannerDisabled(organizationId: string, body: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCockpitBannerDisabled(organizationId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Uploads a banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {string} [bannerImage] 
         * @param {any} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCockpitBanner(organizationId: string, bannerImage?: string, image?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCockpitBanner(organizationId, bannerImage, image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CockpitSettingsApi - factory interface
 * @export
 */
export const CockpitSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CockpitSettingsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Creates or updates the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any): AxiosPromise<CockpitWidgetsConfigurationItem> {
            return localVarFp.createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Deletes the banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCockpitBanner(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCockpitBanner(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Returns the cockpit widget configuration 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitWidgetsConfiguration(organizationId: string, options?: any): AxiosPromise<CockpitWidgetsConfigurationItem> {
            return localVarFp.getCockpitWidgetsConfiguration(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Updates the disabled setting for the cockpit banner 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {boolean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCockpitBannerDisabled(organizationId: string, body: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.updateCockpitBannerDisabled(organizationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
         * @summary Uploads a banner image for the cockpit 🔒: Settings.Cockpit
         * @param {string} organizationId 
         * @param {string} [bannerImage] 
         * @param {any} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCockpitBanner(organizationId: string, bannerImage?: string, image?: any, options?: any): AxiosPromise<string> {
            return localVarFp.uploadCockpitBanner(organizationId, bannerImage, image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CockpitSettingsApi - object-oriented interface
 * @export
 * @class CockpitSettingsApi
 * @extends {BaseAPI}
 */
export class CockpitSettingsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Creates or updates the cockpit widget configuration 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {CockpitWidgetsConfigurationItem} cockpitWidgetsConfigurationItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitSettingsApi
     */
    public createOrUpdateCockpitWidgetsConfiguration(organizationId: string, cockpitWidgetsConfigurationItem: CockpitWidgetsConfigurationItem, options?: any) {
        return CockpitSettingsApiFp(this.configuration).createOrUpdateCockpitWidgetsConfiguration(organizationId, cockpitWidgetsConfigurationItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Deletes the banner image for the cockpit 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitSettingsApi
     */
    public deleteCockpitBanner(organizationId: string, options?: any) {
        return CockpitSettingsApiFp(this.configuration).deleteCockpitBanner(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Returns the cockpit widget configuration 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitSettingsApi
     */
    public getCockpitWidgetsConfiguration(organizationId: string, options?: any) {
        return CockpitSettingsApiFp(this.configuration).getCockpitWidgetsConfiguration(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Updates the disabled setting for the cockpit banner 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {boolean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitSettingsApi
     */
    public updateCockpitBannerDisabled(organizationId: string, body: boolean, options?: any) {
        return CockpitSettingsApiFp(this.configuration).updateCockpitBannerDisabled(organizationId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.Cockpit</li></ul>
     * @summary Uploads a banner image for the cockpit 🔒: Settings.Cockpit
     * @param {string} organizationId 
     * @param {string} [bannerImage] 
     * @param {any} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CockpitSettingsApi
     */
    public uploadCockpitBanner(organizationId: string, bannerImage?: string, image?: any, options?: any) {
        return CockpitSettingsApiFp(this.configuration).uploadCockpitBanner(organizationId, bannerImage, image, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConsentApi - axios parameter creator
 * @export
 */
export const ConsentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (organizationId: string, consentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('_delete', 'consentId', consentId)
            const localVarPath = `/api/V2/{organizationId}/Consent/{consentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {ConsentFilterState} consentState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByState: async (organizationId: string, consentState: ConsentFilterState, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteByState', 'organizationId', organizationId)
            // verify required parameter 'consentState' is not null or undefined
            assertParamExists('deleteByState', 'consentState', consentState)
            const localVarPath = `/api/V2/{organizationId}/Consent/byState/{consentState}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"consentState"}}`, encodeURIComponent(String(consentState)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents using a specific user template. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByTemplate: async (organizationId: string, templateId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteByTemplate', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteByTemplate', 'templateId', templateId)
            const localVarPath = `/api/V2/{organizationId}/Consent/byTemplate/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all open, declined and accepted consents for the given organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Consent`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Resends a consent mail. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConsentMail: async (organizationId: string, consentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resendConsentMail', 'organizationId', organizationId)
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('resendConsentMail', 'consentId', consentId)
            const localVarPath = `/api/V2/{organizationId}/Consent/resend/{consentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new consent, based on the given consent id and sends it on the specified new mail address if its th
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountAddress: async (organizationId: string, consentId: string, body: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAccountAddress', 'organizationId', organizationId)
            // verify required parameter 'consentId' is not null or undefined
            assertParamExists('updateAccountAddress', 'consentId', consentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateAccountAddress', 'body', body)
            const localVarPath = `/api/V2/{organizationId}/Consent/{consentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"consentId"}}`, encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Updates the fiven list of consents in the specified organization 🔒: Users.ShowModule
         * @param {string} organizationId2 
         * @param {Array<ConsentUserWithMailAddresses>} consentUserWithMailAddresses 
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAll: async (organizationId2: string, consentUserWithMailAddresses: Array<ConsentUserWithMailAddresses>, organizationId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId2' is not null or undefined
            assertParamExists('updateAll', 'organizationId2', organizationId2)
            // verify required parameter 'consentUserWithMailAddresses' is not null or undefined
            assertParamExists('updateAll', 'consentUserWithMailAddresses', consentUserWithMailAddresses)
            const localVarPath = `/api/V2/{organizationId}/Consent`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentUserWithMailAddresses, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentApi - functional programming interface
 * @export
 */
export const ConsentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsentApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(organizationId: string, consentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(organizationId, consentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {ConsentFilterState} consentState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByState(organizationId: string, consentState: ConsentFilterState, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByState(organizationId, consentState, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents using a specific user template. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByTemplate(organizationId: string, templateId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByTemplate(organizationId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all open, declined and accepted consents for the given organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConsentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Resends a consent mail. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendConsentMail(organizationId: string, consentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendConsentMail(organizationId, consentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new consent, based on the given consent id and sends it on the specified new mail address if its th
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountAddress(organizationId: string, consentId: string, body: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountAddress(organizationId, consentId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Updates the fiven list of consents in the specified organization 🔒: Users.ShowModule
         * @param {string} organizationId2 
         * @param {Array<ConsentUserWithMailAddresses>} consentUserWithMailAddresses 
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAll(organizationId2: string, consentUserWithMailAddresses: Array<ConsentUserWithMailAddresses>, organizationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAll(organizationId2, consentUserWithMailAddresses, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConsentApi - factory interface
 * @export
 */
export const ConsentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsentApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(organizationId: string, consentId: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(organizationId, consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {ConsentFilterState} consentState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByState(organizationId: string, consentState: ConsentFilterState, options?: any): AxiosPromise<void> {
            return localVarFp.deleteByState(organizationId, consentState, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes all open consents using a specific user template. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByTemplate(organizationId: string, templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteByTemplate(organizationId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all open, declined and accepted consents for the given organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, options?: any): AxiosPromise<Array<ConsentResponse>> {
            return localVarFp.getAll(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Resends a consent mail. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConsentMail(organizationId: string, consentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.resendConsentMail(organizationId, consentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new consent, based on the given consent id and sends it on the specified new mail address if its th
         * @param {string} organizationId 
         * @param {string} consentId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountAddress(organizationId: string, consentId: string, body: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateAccountAddress(organizationId, consentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Updates the fiven list of consents in the specified organization 🔒: Users.ShowModule
         * @param {string} organizationId2 
         * @param {Array<ConsentUserWithMailAddresses>} consentUserWithMailAddresses 
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAll(organizationId2: string, consentUserWithMailAddresses: Array<ConsentUserWithMailAddresses>, organizationId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateAll(organizationId2, consentUserWithMailAddresses, organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentApi - object-oriented interface
 * @export
 * @class ConsentApi
 * @extends {BaseAPI}
 */
export class ConsentApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Deletes all open consents. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} consentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public _delete(organizationId: string, consentId: string, options?: any) {
        return ConsentApiFp(this.configuration)._delete(organizationId, consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {ConsentFilterState} consentState 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public deleteByState(organizationId: string, consentState: ConsentFilterState, options?: any) {
        return ConsentApiFp(this.configuration).deleteByState(organizationId, consentState, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Deletes all open consents using a specific user template. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public deleteByTemplate(organizationId: string, templateId: string, options?: any) {
        return ConsentApiFp(this.configuration).deleteByTemplate(organizationId, templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Returns all open, declined and accepted consents for the given organization. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public getAll(organizationId: string, options?: any) {
        return ConsentApiFp(this.configuration).getAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Resends a consent mail. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} consentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public resendConsentMail(organizationId: string, consentId: string, options?: any) {
        return ConsentApiFp(this.configuration).resendConsentMail(organizationId, consentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new consent, based on the given consent id and sends it on the specified new mail address if its th
     * @param {string} organizationId 
     * @param {string} consentId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public updateAccountAddress(organizationId: string, consentId: string, body: string, options?: any) {
        return ConsentApiFp(this.configuration).updateAccountAddress(organizationId, consentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Updates the fiven list of consents in the specified organization 🔒: Users.ShowModule
     * @param {string} organizationId2 
     * @param {Array<ConsentUserWithMailAddresses>} consentUserWithMailAddresses 
     * @param {string} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentApi
     */
    public updateAll(organizationId2: string, consentUserWithMailAddresses: Array<ConsentUserWithMailAddresses>, organizationId?: string, options?: any) {
        return ConsentApiFp(this.configuration).updateAll(organizationId2, consentUserWithMailAddresses, organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CourseLinksApi - axios parameter creator
 * @export
 */
export const CourseLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Removes a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (organizationId: string, courseId: string, listId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('_delete', 'courseId', courseId)
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('_delete', 'listId', listId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks/{listId}/items/{id}/of/{courseId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkCreateRequest} courseLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (organizationId: string, courseLinkCreateRequest: CourseLinkCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('create', 'organizationId', organizationId)
            // verify required parameter 'courseLinkCreateRequest' is not null or undefined
            assertParamExists('create', 'courseLinkCreateRequest', courseLinkCreateRequest)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseLinkCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all web links from specified list within the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, courseId: string, listId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getAll', 'courseId', courseId)
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getAll', 'listId', listId)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks/{listId}/items/of/{courseId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all marked as favorite web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites: async (organizationId: string, courseId: string, listId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFavorites', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getFavorites', 'courseId', courseId)
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getFavorites', 'listId', listId)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks/{listId}/favorites/of/{courseId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: async (organizationId: string, courseId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getList', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getList', 'courseId', courseId)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks/of/{courseId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkUpdateRequest} courseLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (organizationId: string, courseLinkUpdateRequest: CourseLinkUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('update', 'organizationId', organizationId)
            // verify required parameter 'courseLinkUpdateRequest' is not null or undefined
            assertParamExists('update', 'courseLinkUpdateRequest', courseLinkUpdateRequest)
            const localVarPath = `/api/V2/{organizationId}/CourseLinks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseLinkUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseLinksApi - functional programming interface
 * @export
 */
export const CourseLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Removes a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(organizationId: string, courseId: string, listId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(organizationId, courseId, listId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkCreateRequest} courseLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(organizationId: string, courseLinkCreateRequest: CourseLinkCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(organizationId, courseLinkCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all web links from specified list within the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, courseId: string, listId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseLinkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, courseId, listId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all marked as favorite web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavorites(organizationId: string, courseId: string, listId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseLinkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavorites(organizationId, courseId, listId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getList(organizationId: string, courseId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseLinkListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getList(organizationId, courseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkUpdateRequest} courseLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(organizationId: string, courseLinkUpdateRequest: CourseLinkUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(organizationId, courseLinkUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CourseLinksApi - factory interface
 * @export
 */
export const CourseLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseLinksApiFp(configuration)
    return {
        /**
         * 
         * @summary Removes a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(organizationId: string, courseId: string, listId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(organizationId, courseId, listId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkCreateRequest} courseLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, courseLinkCreateRequest: CourseLinkCreateRequest, options?: any): AxiosPromise<CourseLinkResponse> {
            return localVarFp.create(organizationId, courseLinkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all web links from specified list within the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, courseId: string, listId: string, options?: any): AxiosPromise<Array<CourseLinkResponse>> {
            return localVarFp.getAll(organizationId, courseId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all marked as favorite web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} listId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(organizationId: string, courseId: string, listId: string, options?: any): AxiosPromise<Array<CourseLinkResponse>> {
            return localVarFp.getFavorites(organizationId, courseId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all web links for the specified group.
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(organizationId: string, courseId: string, options?: any): AxiosPromise<CourseLinkListResponse> {
            return localVarFp.getList(organizationId, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a web link in the specified list of the desired group.
         * @param {string} organizationId 
         * @param {CourseLinkUpdateRequest} courseLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(organizationId: string, courseLinkUpdateRequest: CourseLinkUpdateRequest, options?: any): AxiosPromise<CourseLinkResponse> {
            return localVarFp.update(organizationId, courseLinkUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseLinksApi - object-oriented interface
 * @export
 * @class CourseLinksApi
 * @extends {BaseAPI}
 */
export class CourseLinksApi extends BaseAPI {
    /**
     * 
     * @summary Removes a web link in the specified list of the desired group.
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {string} listId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public _delete(organizationId: string, courseId: string, listId: string, id: string, options?: any) {
        return CourseLinksApiFp(this.configuration)._delete(organizationId, courseId, listId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new web link in the specified list of the desired group.
     * @param {string} organizationId 
     * @param {CourseLinkCreateRequest} courseLinkCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public create(organizationId: string, courseLinkCreateRequest: CourseLinkCreateRequest, options?: any) {
        return CourseLinksApiFp(this.configuration).create(organizationId, courseLinkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all web links from specified list within the specified group.
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public getAll(organizationId: string, courseId: string, listId: string, options?: any) {
        return CourseLinksApiFp(this.configuration).getAll(organizationId, courseId, listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all marked as favorite web links for the specified group.
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {string} listId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public getFavorites(organizationId: string, courseId: string, listId: string, options?: any) {
        return CourseLinksApiFp(this.configuration).getFavorites(organizationId, courseId, listId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all web links for the specified group.
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public getList(organizationId: string, courseId: string, options?: any) {
        return CourseLinksApiFp(this.configuration).getList(organizationId, courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a web link in the specified list of the desired group.
     * @param {string} organizationId 
     * @param {CourseLinkUpdateRequest} courseLinkUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseLinksApi
     */
    public update(organizationId: string, courseLinkUpdateRequest: CourseLinkUpdateRequest, options?: any) {
        return CourseLinksApiFp(this.configuration).update(organizationId, courseLinkUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CoursesApi - axios parameter creator
 * @export
 */
export const CoursesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Creates notebooks for courses. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotebooks: async (organizationId: string, requestBody: Array<string>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createNotebooks', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createNotebooks', 'requestBody', requestBody)
            const localVarPath = `/api/v2/Courses/{organizationId}/notebooks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns the requested azure course. Returns 404 if course or organization was not found. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of the specified organization in a combined way. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/combined`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of which the user is member or owner in the specified organization in a combined way. 🔒: Courses.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCombined: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllCombined', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/my/combined`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Files.ReadGroupFiles</li></ul>
         * @summary Returns all azure courses of which the user is member or owner in the specified organization. 🔒: Courses.ShowModule, Files.ReadGroupFiles
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMemberships: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllMemberships', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all events of the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (id: string, organizationId: string, end?: string, start?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvents', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvents', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the folder \"Material\" within the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMaterial', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMaterial', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}/material`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the users one drive. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDrive: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyDrive', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyDrive', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}/MyDrive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Returns the class notebook for the specified course. If no notebook is found, checks for running creation and returns jobId with status. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotebook: async (organizationId: string, courseId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getNotebook', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getNotebook', 'courseId', courseId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{courseId}/notebook`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Get all azure courses with missing notebook. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithMissingNotebook: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWithMissingNotebook', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/notebooks/missing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Joins a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('join', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('join', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}/join`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Leaves a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leave: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('leave', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('leave', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Courses/{organizationId}/course/{id}/leave`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairTeamOwnerShip: async (organizationId: string, courseId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('repairTeamOwnerShip', 'organizationId', organizationId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('repairTeamOwnerShip', 'courseId', courseId)
            const localVarPath = `/api/v2/Courses/{organizationId}/repair/{courseId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ChangePasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Courses.ChangePasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword: async (organizationId: string, validationParameters: ValidationParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validatePassword', 'organizationId', organizationId)
            // verify required parameter 'validationParameters' is not null or undefined
            assertParamExists('validatePassword', 'validationParameters', validationParameters)
            const localVarPath = `/api/v2/Courses/{organizationId}/validatePassword`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoursesApi - functional programming interface
 * @export
 */
export const CoursesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoursesApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Creates notebooks for courses. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotebooks(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateNotebookResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotebooks(organizationId, requestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns the requested azure course. Returns 404 if course or organization was not found. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureCourse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of the specified organization in a combined way. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureCourse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of which the user is member or owner in the specified organization in a combined way. 🔒: Courses.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCombined(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureCourse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCombined(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Files.ReadGroupFiles</li></ul>
         * @summary Returns all azure courses of which the user is member or owner in the specified organization. 🔒: Courses.ShowModule, Files.ReadGroupFiles
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMemberships(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureCourse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMemberships(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all events of the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(id, organizationId, end, start, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the folder \"Material\" within the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterial(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseDriveItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterial(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the users one drive. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyDrive(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseDriveItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyDrive(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Returns the class notebook for the specified course. If no notebook is found, checks for running creation and returns jobId with status. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotebook(organizationId: string, courseId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseNotebookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotebook(organizationId, courseId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Get all azure courses with missing notebook. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureCourse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWithMissingNotebook(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Joins a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async join(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureCourse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.join(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Leaves a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leave(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureCourse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leave(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairTeamOwnerShip(organizationId: string, courseId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairTeamOwnerShip(organizationId, courseId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ChangePasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Courses.ChangePasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePassword(organizationId, validationParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CoursesApi - factory interface
 * @export
 */
export const CoursesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoursesApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Creates notebooks for courses. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotebooks(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any): AxiosPromise<Array<CreateNotebookResult>> {
            return localVarFp.createNotebooks(organizationId, requestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns the requested azure course. Returns 404 if course or organization was not found. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, organizationId: string, timePeriod?: string, options?: any): AxiosPromise<AzureCourse> {
            return localVarFp.get(id, organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of the specified organization in a combined way. 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureCourse>> {
            return localVarFp.getAll(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Classbook.ShowModule</li></ul>
         * @summary Returns all azure courses as well as classbook courses of which the user is member or owner in the specified organization in a combined way. 🔒: Courses.ShowModule, Classbook.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCombined(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureCourse>> {
            return localVarFp.getAllCombined(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Files.ReadGroupFiles</li></ul>
         * @summary Returns all azure courses of which the user is member or owner in the specified organization. 🔒: Courses.ShowModule, Files.ReadGroupFiles
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMemberships(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureCourse>> {
            return localVarFp.getAllMemberships(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all events of the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any): AxiosPromise<Array<CourseEventResponse>> {
            return localVarFp.getEvents(id, organizationId, end, start, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the folder \"Material\" within the specified azure course. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial(id: string, organizationId: string, options?: any): AxiosPromise<CourseDriveItemResponse> {
            return localVarFp.getMaterial(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary Returns all files within the users one drive. 🔒: Courses.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDrive(id: string, organizationId: string, options?: any): AxiosPromise<CourseDriveItemResponse> {
            return localVarFp.getMyDrive(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Returns the class notebook for the specified course. If no notebook is found, checks for running creation and returns jobId with status. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotebook(organizationId: string, courseId: string, timePeriod?: string, options?: any): AxiosPromise<CourseNotebookResponse> {
            return localVarFp.getNotebook(organizationId, courseId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
         * @summary Get all azure courses with missing notebook. 🔒: Courses.ShowModule, Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<AzureCourse>> {
            return localVarFp.getWithMissingNotebook(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Joins a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join(id: string, organizationId: string, options?: any): AxiosPromise<AzureCourse> {
            return localVarFp.join(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
         * @summary Leaves a course with the requested id. 🔒: Courses.JoinCourse
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leave(id: string, organizationId: string, options?: any): AxiosPromise<AzureCourse> {
            return localVarFp.leave(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
         * @summary 🔒: Courses.ShowModule
         * @param {string} organizationId 
         * @param {string} courseId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairTeamOwnerShip(organizationId: string, courseId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.repairTeamOwnerShip(organizationId, courseId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ChangePasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Courses.ChangePasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): AxiosPromise<ValidatePasswordResponse> {
            return localVarFp.validatePassword(organizationId, validationParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoursesApi - object-oriented interface
 * @export
 * @class CoursesApi
 * @extends {BaseAPI}
 */
export class CoursesApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
     * @summary Creates notebooks for courses. 🔒: Courses.ShowModule, Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public createNotebooks(organizationId: string, requestBody: Array<string>, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).createNotebooks(organizationId, requestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns the requested azure course. Returns 404 if course or organization was not found. 🔒: Courses.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public get(id: string, organizationId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).get(id, organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all azure courses as well as classbook courses of the specified organization in a combined way. 🔒: Courses.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getAll(organizationId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).getAll(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Classbook.ShowModule</li></ul>
     * @summary Returns all azure courses as well as classbook courses of which the user is member or owner in the specified organization in a combined way. 🔒: Courses.ShowModule, Classbook.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getAllCombined(organizationId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).getAllCombined(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Files.ReadGroupFiles</li></ul>
     * @summary Returns all azure courses of which the user is member or owner in the specified organization. 🔒: Courses.ShowModule, Files.ReadGroupFiles
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getAllMemberships(organizationId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).getAllMemberships(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all events of the specified azure course. 🔒: Courses.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {string} [end] 
     * @param {string} [start] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any) {
        return CoursesApiFp(this.configuration).getEvents(id, organizationId, end, start, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all files within the folder \"Material\" within the specified azure course. 🔒: Courses.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getMaterial(id: string, organizationId: string, options?: any) {
        return CoursesApiFp(this.configuration).getMaterial(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary Returns all files within the users one drive. 🔒: Courses.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getMyDrive(id: string, organizationId: string, options?: any) {
        return CoursesApiFp(this.configuration).getMyDrive(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
     * @summary Returns the class notebook for the specified course. If no notebook is found, checks for running creation and returns jobId with status. 🔒: Courses.ShowModule, Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getNotebook(organizationId: string, courseId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).getNotebook(organizationId, courseId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Workgroups.ShowModule</li></ul>
     * @summary Get all azure courses with missing notebook. 🔒: Courses.ShowModule, Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).getWithMissingNotebook(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
     * @summary Joins a course with the requested id. 🔒: Courses.JoinCourse
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public join(id: string, organizationId: string, options?: any) {
        return CoursesApiFp(this.configuration).join(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.JoinCourse</li></ul>
     * @summary Leaves a course with the requested id. 🔒: Courses.JoinCourse
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public leave(id: string, organizationId: string, options?: any) {
        return CoursesApiFp(this.configuration).leave(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li></ul>
     * @summary 🔒: Courses.ShowModule
     * @param {string} organizationId 
     * @param {string} courseId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public repairTeamOwnerShip(organizationId: string, courseId: string, timePeriod?: string, options?: any) {
        return CoursesApiFp(this.configuration).repairTeamOwnerShip(organizationId, courseId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ChangePasswords</li></ul>
     * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Courses.ChangePasswords
     * @param {string} organizationId 
     * @param {ValidationParameters} validationParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    public validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any) {
        return CoursesApiFp(this.configuration).validatePassword(organizationId, validationParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataImportApi - axios parameter creator
 * @export
 */
export const DataImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Imports the users.c 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import: async (organizationId: string, importRequest: ImportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_import', 'organizationId', organizationId)
            // verify required parameter 'importRequest' is not null or undefined
            assertParamExists('_import', 'importRequest', importRequest)
            const localVarPath = `/api/V2/{organizationId}/DataImport/import`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Analyze the given users for an import. 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {AnalyzeRequest} analyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyze: async (organizationId: string, analyzeRequest: AnalyzeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('analyze', 'organizationId', organizationId)
            // verify required parameter 'analyzeRequest' is not null or undefined
            assertParamExists('analyze', 'analyzeRequest', analyzeRequest)
            const localVarPath = `/api/V2/{organizationId}/DataImport/analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analyzeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataImportApi - functional programming interface
 * @export
 */
export const DataImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Imports the users.c 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _import(organizationId: string, importRequest: ImportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._import(organizationId, importRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Analyze the given users for an import. 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {AnalyzeRequest} analyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyze(organizationId: string, analyzeRequest: AnalyzeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyze(organizationId, analyzeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataImportApi - factory interface
 * @export
 */
export const DataImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataImportApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Imports the users.c 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {ImportRequest} importRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(organizationId: string, importRequest: ImportRequest, options?: any): AxiosPromise<string> {
            return localVarFp._import(organizationId, importRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Analyze the given users for an import. 🔒: Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {AnalyzeRequest} analyzeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyze(organizationId: string, analyzeRequest: AnalyzeRequest, options?: any): AxiosPromise<AnalyzeResponse> {
            return localVarFp.analyze(organizationId, analyzeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataImportApi - object-oriented interface
 * @export
 * @class DataImportApi
 * @extends {BaseAPI}
 */
export class DataImportApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
     * @summary Imports the users.c 🔒: Users.ImportUsersForUserTemplate
     * @param {string} organizationId 
     * @param {ImportRequest} importRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public _import(organizationId: string, importRequest: ImportRequest, options?: any) {
        return DataImportApiFp(this.configuration)._import(organizationId, importRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ImportUsersForUserTemplate</li></ul>
     * @summary Analyze the given users for an import. 🔒: Users.ImportUsersForUserTemplate
     * @param {string} organizationId 
     * @param {AnalyzeRequest} analyzeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public analyze(organizationId: string, analyzeRequest: AnalyzeRequest, options?: any) {
        return DataImportApiFp(this.configuration).analyze(organizationId, analyzeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Copies the desired items within the OneDrive. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} [itemIds] 
         * @param {string} [sourceDriveId] 
         * @param {string} [targetDriveId] 
         * @param {string} [targetFolderId] 
         * @param {CopyType} [copyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy: async (organizationId: string, itemIds?: Array<string>, sourceDriveId?: string, targetDriveId?: string, targetFolderId?: string, copyType?: CopyType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('copy', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Documents/copy`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (itemIds) {
                localVarQueryParameter['itemIds'] = itemIds;
            }

            if (sourceDriveId !== undefined) {
                localVarQueryParameter['sourceDriveId'] = sourceDriveId;
            }

            if (targetDriveId !== undefined) {
                localVarQueryParameter['targetDriveId'] = targetDriveId;
            }

            if (targetFolderId !== undefined) {
                localVarQueryParameter['targetFolderId'] = targetFolderId;
            }

            if (copyType !== undefined) {
                localVarQueryParameter['copyType'] = copyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Create a folder within the specified location. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {string} [name] 
         * @param {FolderWritePermissions} [permissions] 
         * @param {string} [parentFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (organizationId: string, groupId?: string, name?: string, permissions?: FolderWritePermissions, parentFolderId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createFolder', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Documents/createfolder`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (permissions !== undefined) {
                localVarQueryParameter['permissions'] = permissions;
            }

            if (parentFolderId !== undefined) {
                localVarQueryParameter['parentFolderId'] = parentFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get the download URL of a file by its ID. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrlOf: async (organizationId: string, fileId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDownloadUrlOf', 'organizationId', organizationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getDownloadUrlOf', 'fileId', fileId)
            const localVarPath = `/api/V2/{organizationId}/Documents/downloadUrl/of/{fileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get all files which are shared in the parental communication for this user. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesOfUser: async (organizationId: string, timePeriod?: string, folderId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFilesOfUser', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Documents/of/me`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Requests to provision the users onedrive if it doesn\'t exist yet. After successful provisioning, needed MNSpro Cloud default folder might be created. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provision: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('provision', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Documents/provision`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Starts building a ZIP archive from the selected files and folders. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {DocumentsZipSelection} documentsZipSelection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zip: async (organizationId: string, documentsZipSelection: DocumentsZipSelection, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('zip', 'organizationId', organizationId)
            // verify required parameter 'documentsZipSelection' is not null or undefined
            assertParamExists('zip', 'documentsZipSelection', documentsZipSelection)
            const localVarPath = `/api/V2/{organizationId}/Documents/zip`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentsZipSelection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Returns the archive URL once it is ready, otherwise the current job status. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipStatus: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('zipStatus', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('zipStatus', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/Documents/zip/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Copies the desired items within the OneDrive. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} [itemIds] 
         * @param {string} [sourceDriveId] 
         * @param {string} [targetDriveId] 
         * @param {string} [targetFolderId] 
         * @param {CopyType} [copyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copy(organizationId: string, itemIds?: Array<string>, sourceDriveId?: string, targetDriveId?: string, targetFolderId?: string, copyType?: CopyType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copy(organizationId, itemIds, sourceDriveId, targetDriveId, targetFolderId, copyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Create a folder within the specified location. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {string} [name] 
         * @param {FolderWritePermissions} [permissions] 
         * @param {string} [parentFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(organizationId: string, groupId?: string, name?: string, permissions?: FolderWritePermissions, parentFolderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentsGetFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(organizationId, groupId, name, permissions, parentFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get the download URL of a file by its ID. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadUrlOf(organizationId: string, fileId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUrlOf(organizationId, fileId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get all files which are shared in the parental communication for this user. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesOfUser(organizationId: string, timePeriod?: string, folderId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentsGetFilesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesOfUser(organizationId, timePeriod, folderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Requests to provision the users onedrive if it doesn\'t exist yet. After successful provisioning, needed MNSpro Cloud default folder might be created. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provision(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provision(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Starts building a ZIP archive from the selected files and folders. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {DocumentsZipSelection} documentsZipSelection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zip(organizationId: string, documentsZipSelection: DocumentsZipSelection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentsZipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zip(organizationId, documentsZipSelection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Returns the archive URL once it is ready, otherwise the current job status. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zipStatus(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentsZipStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zipStatus(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Copies the desired items within the OneDrive. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} [itemIds] 
         * @param {string} [sourceDriveId] 
         * @param {string} [targetDriveId] 
         * @param {string} [targetFolderId] 
         * @param {CopyType} [copyType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy(organizationId: string, itemIds?: Array<string>, sourceDriveId?: string, targetDriveId?: string, targetFolderId?: string, copyType?: CopyType, options?: any): AxiosPromise<void> {
            return localVarFp.copy(organizationId, itemIds, sourceDriveId, targetDriveId, targetFolderId, copyType, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Create a folder within the specified location. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {string} [name] 
         * @param {FolderWritePermissions} [permissions] 
         * @param {string} [parentFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(organizationId: string, groupId?: string, name?: string, permissions?: FolderWritePermissions, parentFolderId?: string, options?: any): AxiosPromise<DocumentsGetFilesResponse> {
            return localVarFp.createFolder(organizationId, groupId, name, permissions, parentFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get the download URL of a file by its ID. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrlOf(organizationId: string, fileId: string, timePeriod?: string, options?: any): AxiosPromise<FileDownload> {
            return localVarFp.getDownloadUrlOf(organizationId, fileId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Get all files which are shared in the parental communication for this user. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesOfUser(organizationId: string, timePeriod?: string, folderId?: string, options?: any): AxiosPromise<Array<DocumentsGetFilesResponse>> {
            return localVarFp.getFilesOfUser(organizationId, timePeriod, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Requests to provision the users onedrive if it doesn\'t exist yet. After successful provisioning, needed MNSpro Cloud default folder might be created. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provision(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.provision(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Starts building a ZIP archive from the selected files and folders. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {DocumentsZipSelection} documentsZipSelection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zip(organizationId: string, documentsZipSelection: DocumentsZipSelection, options?: any): AxiosPromise<DocumentsZipResponse> {
            return localVarFp.zip(organizationId, documentsZipSelection, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
         * @summary Returns the archive URL once it is ready, otherwise the current job status. 🔒: Files.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipStatus(organizationId: string, id: string, options?: any): AxiosPromise<DocumentsZipStatusResponse> {
            return localVarFp.zipStatus(organizationId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Copies the desired items within the OneDrive. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {Array<string>} [itemIds] 
     * @param {string} [sourceDriveId] 
     * @param {string} [targetDriveId] 
     * @param {string} [targetFolderId] 
     * @param {CopyType} [copyType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public copy(organizationId: string, itemIds?: Array<string>, sourceDriveId?: string, targetDriveId?: string, targetFolderId?: string, copyType?: CopyType, options?: any) {
        return DocumentsApiFp(this.configuration).copy(organizationId, itemIds, sourceDriveId, targetDriveId, targetFolderId, copyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Create a folder within the specified location. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {string} [groupId] 
     * @param {string} [name] 
     * @param {FolderWritePermissions} [permissions] 
     * @param {string} [parentFolderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public createFolder(organizationId: string, groupId?: string, name?: string, permissions?: FolderWritePermissions, parentFolderId?: string, options?: any) {
        return DocumentsApiFp(this.configuration).createFolder(organizationId, groupId, name, permissions, parentFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Get the download URL of a file by its ID. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {string} fileId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDownloadUrlOf(organizationId: string, fileId: string, timePeriod?: string, options?: any) {
        return DocumentsApiFp(this.configuration).getDownloadUrlOf(organizationId, fileId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Get all files which are shared in the parental communication for this user. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getFilesOfUser(organizationId: string, timePeriod?: string, folderId?: string, options?: any) {
        return DocumentsApiFp(this.configuration).getFilesOfUser(organizationId, timePeriod, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Requests to provision the users onedrive if it doesn\'t exist yet. After successful provisioning, needed MNSpro Cloud default folder might be created. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public provision(organizationId: string, options?: any) {
        return DocumentsApiFp(this.configuration).provision(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Starts building a ZIP archive from the selected files and folders. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {DocumentsZipSelection} documentsZipSelection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public zip(organizationId: string, documentsZipSelection: DocumentsZipSelection, options?: any) {
        return DocumentsApiFp(this.configuration).zip(organizationId, documentsZipSelection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Files.ShowModule</li></ul>
     * @summary Returns the archive URL once it is ready, otherwise the current job status. 🔒: Files.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public zipStatus(organizationId: string, id: string, options?: any) {
        return DocumentsApiFp(this.configuration).zipStatus(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EducationAssignmentsApi - axios parameter creator
 * @export
 */
export const EducationAssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds a web link to the desired assignment.
         * @param {EducationAssignmentAddLinkResourceRequest} educationAssignmentAddLinkResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLinkResourceToAssignment: async (educationAssignmentAddLinkResourceRequest: EducationAssignmentAddLinkResourceRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationAssignmentAddLinkResourceRequest' is not null or undefined
            assertParamExists('addLinkResourceToAssignment', 'educationAssignmentAddLinkResourceRequest', educationAssignmentAddLinkResourceRequest)
            const localVarPath = `/api/v2/EducationAssignments/addLinkResourceToAssignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentAddLinkResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a file to the desired assignment.
         * @param {EducationAssignmentAddResourceRequest} educationAssignmentAddResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResourceToAssignment: async (educationAssignmentAddResourceRequest: EducationAssignmentAddResourceRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationAssignmentAddResourceRequest' is not null or undefined
            assertParamExists('addResourceToAssignment', 'educationAssignmentAddResourceRequest', educationAssignmentAddResourceRequest)
            const localVarPath = `/api/v2/EducationAssignments/addResourceToAssignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentAddResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a student submission resource to the specified assignment.
         * @param {EducationAssignmentAddSubmissionResourceRequest} educationAssignmentAddSubmissionResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubmissionResourceForClass: async (educationAssignmentAddSubmissionResourceRequest: EducationAssignmentAddSubmissionResourceRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationAssignmentAddSubmissionResourceRequest' is not null or undefined
            assertParamExists('addSubmissionResourceForClass', 'educationAssignmentAddSubmissionResourceRequest', educationAssignmentAddSubmissionResourceRequest)
            const localVarPath = `/api/v2/EducationAssignments/addSubmissionResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentAddSubmissionResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new education assignment for the specified group.
         * @param {EducationAssignmentCreateRequest} educationAssignmentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEducationAssignmentForClass: async (educationAssignmentCreateRequest: EducationAssignmentCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationAssignmentCreateRequest' is not null or undefined
            assertParamExists('createEducationAssignmentForClass', 'educationAssignmentCreateRequest', educationAssignmentCreateRequest)
            const localVarPath = `/api/v2/EducationAssignments/createAssignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes an assignment from the specified group.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssignmentFromClass: async (groupId: string, assignmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteAssignmentFromClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('deleteAssignmentFromClass', 'assignmentId', assignmentId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/delete`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} driveItemId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssignmentResourceFromClass: async (groupId: string, assignmentId: string, resourceId: string, driveItemId: string, submissionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteAssignmentResourceFromClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('deleteAssignmentResourceFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteAssignmentResourceFromClass', 'resourceId', resourceId)
            // verify required parameter 'driveItemId' is not null or undefined
            assertParamExists('deleteAssignmentResourceFromClass', 'driveItemId', driveItemId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{resourceId}/{driveItemId}/delete`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
                .replace(`{${"driveItemId"}}`, encodeURIComponent(String(driveItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (submissionId !== undefined) {
                localVarQueryParameter['submissionId'] = submissionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a web link from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkResourceFromClass: async (groupId: string, assignmentId: string, resourceId: string, submissionId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteLinkResourceFromClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('deleteLinkResourceFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteLinkResourceFromClass', 'resourceId', resourceId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{resourceId}/delete`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (submissionId !== undefined) {
                localVarQueryParameter['submissionId'] = submissionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a students submission resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} submissionId 
         * @param {string} driveItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubmissionResourceFromClass: async (groupId: string, assignmentId: string, resourceId: string, submissionId: string, driveItemId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteSubmissionResourceFromClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('deleteSubmissionResourceFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteSubmissionResourceFromClass', 'resourceId', resourceId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('deleteSubmissionResourceFromClass', 'submissionId', submissionId)
            // verify required parameter 'driveItemId' is not null or undefined
            assertParamExists('deleteSubmissionResourceFromClass', 'driveItemId', driveItemId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{submissionId}/{resourceId}/{driveItemId}/delete`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"driveItemId"}}`, encodeURIComponent(String(driveItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all assignments for the given student. Pending on the property singleCourseMode either the assignments for the specified group id or all assignments of the user are returned. The latter only covers courses that are not archived and belong to the given time period (the active one when omitted).
         * @param {string} groupId 
         * @param {boolean} singleCourseMode 
         * @param {string} [timePeriod] Time period whose courses are listed when SingleCourseMode is false. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignmentFromClass: async (groupId: string, singleCourseMode: boolean, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getAllAssignmentFromClass', 'groupId', groupId)
            // verify required parameter 'singleCourseMode' is not null or undefined
            assertParamExists('getAllAssignmentFromClass', 'singleCourseMode', singleCourseMode)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{singleCourseMode}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"singleCourseMode"}}`, encodeURIComponent(String(singleCourseMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all students submissions to a given assignment.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubmissionFromClass: async (assignmentId: string, id: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('getAllSubmissionFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllSubmissionFromClass', 'id', id)
            const localVarPath = `/api/v2/EducationAssignments/class/{id}/{assignmentId}/submissions`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the desired assignment of the specified group.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentFromClass: async (assignmentId: string, id: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('getAssignmentFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssignmentFromClass', 'id', id)
            const localVarPath = `/api/v2/EducationAssignments/class/{id}/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Assignments.ShowModule</li></ul>
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information. 🔒: Assignments.ShowModule
         * @param {string} [organizationId] 
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomework: async (organizationId?: string, timePeriod?: string, excludeTeamsAssignments?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EducationAssignments/myHomework`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (excludeTeamsAssignments !== undefined) {
                localVarQueryParameter['excludeTeamsAssignments'] = excludeTeamsAssignments;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specified submission within the desired assignment.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionFromClass: async (assignmentId: string, submissionId: string, id: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('getSubmissionFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getSubmissionFromClass', 'submissionId', submissionId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSubmissionFromClass', 'id', id)
            const localVarPath = `/api/v2/EducationAssignments/class/{id}/{assignmentId}/submissions/{submissionId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all resources the student added to her submission.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionResourcesFromClass: async (assignmentId: string, submissionId: string, id: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('getSubmissionResourcesFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getSubmissionResourcesFromClass', 'submissionId', submissionId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSubmissionResourcesFromClass', 'id', id)
            const localVarPath = `/api/v2/EducationAssignments/class/{id}/{assignmentId}/submissions/{submissionId}/resources`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the state of an assignment to published.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishAssignmentForClass: async (groupId: string, assignmentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('publishAssignmentForClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('publishAssignmentForClass', 'assignmentId', assignmentId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/publish`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the state of a students submission to be returned to her.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnSubmissionForClass: async (groupId: string, assignmentId: string, submissionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('returnSubmissionForClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('returnSubmissionForClass', 'assignmentId', assignmentId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('returnSubmissionForClass', 'submissionId', submissionId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{submissionId}/return`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revokes a student submission result from a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertSubmissionForClass: async (groupId: string, assignmentId: string, submissionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('revertSubmissionForClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('revertSubmissionForClass', 'assignmentId', assignmentId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('revertSubmissionForClass', 'submissionId', submissionId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{submissionId}/revert`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allows a student to send her results to a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSubmissionForClass: async (groupId: string, assignmentId: string, submissionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('sendSubmissionForClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('sendSubmissionForClass', 'assignmentId', assignmentId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('sendSubmissionForClass', 'submissionId', submissionId)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{submissionId}/send`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"submissionId"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing assignment with the specified values.
         * @param {EducationAssignmentUpdateRequest} educationAssignmentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentFromClass: async (educationAssignmentUpdateRequest: EducationAssignmentUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationAssignmentUpdateRequest' is not null or undefined
            assertParamExists('updateAssignmentFromClass', 'educationAssignmentUpdateRequest', educationAssignmentUpdateRequest)
            const localVarPath = `/api/v2/EducationAssignments/updateAssignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the desired resource of an existing assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {EducationAssignmentResource} educationAssignmentResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentRecourceFromClass: async (groupId: string, assignmentId: string, resourceId: string, educationAssignmentResource: EducationAssignmentResource, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateAssignmentRecourceFromClass', 'groupId', groupId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('updateAssignmentRecourceFromClass', 'assignmentId', assignmentId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateAssignmentRecourceFromClass', 'resourceId', resourceId)
            // verify required parameter 'educationAssignmentResource' is not null or undefined
            assertParamExists('updateAssignmentRecourceFromClass', 'educationAssignmentResource', educationAssignmentResource)
            const localVarPath = `/api/v2/EducationAssignments/class/{groupId}/{assignmentId}/{resourceId}/update`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationAssignmentResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EducationAssignmentsApi - functional programming interface
 * @export
 */
export const EducationAssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EducationAssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds a web link to the desired assignment.
         * @param {EducationAssignmentAddLinkResourceRequest} educationAssignmentAddLinkResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest: EducationAssignmentAddLinkResourceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a file to the desired assignment.
         * @param {EducationAssignmentAddResourceRequest} educationAssignmentAddResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addResourceToAssignment(educationAssignmentAddResourceRequest: EducationAssignmentAddResourceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addResourceToAssignment(educationAssignmentAddResourceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a student submission resource to the specified assignment.
         * @param {EducationAssignmentAddSubmissionResourceRequest} educationAssignmentAddSubmissionResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest: EducationAssignmentAddSubmissionResourceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationSubmissionResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new education assignment for the specified group.
         * @param {EducationAssignmentCreateRequest} educationAssignmentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEducationAssignmentForClass(educationAssignmentCreateRequest: EducationAssignmentCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEducationAssignmentForClass(educationAssignmentCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes an assignment from the specified group.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssignmentFromClass(groupId: string, assignmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssignmentFromClass(groupId, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes a resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} driveItemId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssignmentResourceFromClass(groupId: string, assignmentId: string, resourceId: string, driveItemId: string, submissionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssignmentResourceFromClass(groupId, assignmentId, resourceId, driveItemId, submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes a web link from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLinkResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLinkResourceFromClass(groupId, assignmentId, resourceId, submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes a students submission resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} submissionId 
         * @param {string} driveItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubmissionResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId: string, driveItemId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubmissionResourceFromClass(groupId, assignmentId, resourceId, submissionId, driveItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all assignments for the given student. Pending on the property singleCourseMode either the assignments for the specified group id or all assignments of the user are returned. The latter only covers courses that are not archived and belong to the given time period (the active one when omitted).
         * @param {string} groupId 
         * @param {boolean} singleCourseMode 
         * @param {string} [timePeriod] Time period whose courses are listed when SingleCourseMode is false. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAssignmentFromClass(groupId: string, singleCourseMode: boolean, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EducationAssignmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAssignmentFromClass(groupId, singleCourseMode, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all students submissions to a given assignment.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSubmissionFromClass(assignmentId: string, id: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EducationSubmission>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSubmissionFromClass(assignmentId, id, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the desired assignment of the specified group.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignmentFromClass(assignmentId: string, id: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignmentFromClass(assignmentId, id, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Assignments.ShowModule</li></ul>
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information. 🔒: Assignments.ShowModule
         * @param {string} [organizationId] 
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyHomework(organizationId?: string, timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyHomework(organizationId, timePeriod, excludeTeamsAssignments, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specified submission within the desired assignment.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissionFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmissionFromClass(assignmentId, submissionId, id, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all resources the student added to her submission.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissionResourcesFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EducationAssignmentResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmissionResourcesFromClass(assignmentId, submissionId, id, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes the state of an assignment to published.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishAssignmentForClass(groupId: string, assignmentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishAssignmentForClass(groupId, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the state of a students submission to be returned to her.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnSubmissionForClass(groupId, assignmentId, submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Revokes a student submission result from a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revertSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertSubmissionForClass(groupId, assignmentId, submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Allows a student to send her results to a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSubmissionForClass(groupId, assignmentId, submissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing assignment with the specified values.
         * @param {EducationAssignmentUpdateRequest} educationAssignmentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssignmentFromClass(educationAssignmentUpdateRequest: EducationAssignmentUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssignmentFromClass(educationAssignmentUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes the desired resource of an existing assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {EducationAssignmentResource} educationAssignmentResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssignmentRecourceFromClass(groupId: string, assignmentId: string, resourceId: string, educationAssignmentResource: EducationAssignmentResource, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationAssignmentResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssignmentRecourceFromClass(groupId, assignmentId, resourceId, educationAssignmentResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EducationAssignmentsApi - factory interface
 * @export
 */
export const EducationAssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EducationAssignmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds a web link to the desired assignment.
         * @param {EducationAssignmentAddLinkResourceRequest} educationAssignmentAddLinkResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest: EducationAssignmentAddLinkResourceRequest, options?: any): AxiosPromise<EducationAssignmentResource> {
            return localVarFp.addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a file to the desired assignment.
         * @param {EducationAssignmentAddResourceRequest} educationAssignmentAddResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addResourceToAssignment(educationAssignmentAddResourceRequest: EducationAssignmentAddResourceRequest, options?: any): AxiosPromise<EducationAssignmentResource> {
            return localVarFp.addResourceToAssignment(educationAssignmentAddResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a student submission resource to the specified assignment.
         * @param {EducationAssignmentAddSubmissionResourceRequest} educationAssignmentAddSubmissionResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest: EducationAssignmentAddSubmissionResourceRequest, options?: any): AxiosPromise<EducationSubmissionResource> {
            return localVarFp.addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new education assignment for the specified group.
         * @param {EducationAssignmentCreateRequest} educationAssignmentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEducationAssignmentForClass(educationAssignmentCreateRequest: EducationAssignmentCreateRequest, options?: any): AxiosPromise<EducationAssignmentResponse> {
            return localVarFp.createEducationAssignmentForClass(educationAssignmentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes an assignment from the specified group.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssignmentFromClass(groupId: string, assignmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAssignmentFromClass(groupId, assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} driveItemId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssignmentResourceFromClass(groupId: string, assignmentId: string, resourceId: string, driveItemId: string, submissionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAssignmentResourceFromClass(groupId, assignmentId, resourceId, driveItemId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a web link from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} [submissionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLinkResourceFromClass(groupId, assignmentId, resourceId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes a students submission resource from the specified assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {string} submissionId 
         * @param {string} driveItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubmissionResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId: string, driveItemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSubmissionResourceFromClass(groupId, assignmentId, resourceId, submissionId, driveItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all assignments for the given student. Pending on the property singleCourseMode either the assignments for the specified group id or all assignments of the user are returned. The latter only covers courses that are not archived and belong to the given time period (the active one when omitted).
         * @param {string} groupId 
         * @param {boolean} singleCourseMode 
         * @param {string} [timePeriod] Time period whose courses are listed when SingleCourseMode is false. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignmentFromClass(groupId: string, singleCourseMode: boolean, timePeriod?: string, options?: any): AxiosPromise<Array<EducationAssignmentResponse>> {
            return localVarFp.getAllAssignmentFromClass(groupId, singleCourseMode, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all students submissions to a given assignment.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubmissionFromClass(assignmentId: string, id: string, groupId?: string, options?: any): AxiosPromise<Array<EducationSubmission>> {
            return localVarFp.getAllSubmissionFromClass(assignmentId, id, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the desired assignment of the specified group.
         * @param {string} assignmentId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentFromClass(assignmentId: string, id: string, groupId?: string, options?: any): AxiosPromise<EducationAssignmentResponse> {
            return localVarFp.getAssignmentFromClass(assignmentId, id, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Assignments.ShowModule</li></ul>
         * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information. 🔒: Assignments.ShowModule
         * @param {string} [organizationId] 
         * @param {string} [timePeriod] 
         * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomework(organizationId?: string, timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any): AxiosPromise<Array<HomeworkResponse>> {
            return localVarFp.getMyHomework(organizationId, timePeriod, excludeTeamsAssignments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specified submission within the desired assignment.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any): AxiosPromise<EducationSubmission> {
            return localVarFp.getSubmissionFromClass(assignmentId, submissionId, id, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all resources the student added to her submission.
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {string} id 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionResourcesFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any): AxiosPromise<Array<EducationAssignmentResource>> {
            return localVarFp.getSubmissionResourcesFromClass(assignmentId, submissionId, id, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the state of an assignment to published.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishAssignmentForClass(groupId: string, assignmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.publishAssignmentForClass(groupId, assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the state of a students submission to be returned to her.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.returnSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revokes a student submission result from a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revertSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allows a student to send her results to a given assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing assignment with the specified values.
         * @param {EducationAssignmentUpdateRequest} educationAssignmentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentFromClass(educationAssignmentUpdateRequest: EducationAssignmentUpdateRequest, options?: any): AxiosPromise<EducationAssignmentResponse> {
            return localVarFp.updateAssignmentFromClass(educationAssignmentUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the desired resource of an existing assignment.
         * @param {string} groupId 
         * @param {string} assignmentId 
         * @param {string} resourceId 
         * @param {EducationAssignmentResource} educationAssignmentResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignmentRecourceFromClass(groupId: string, assignmentId: string, resourceId: string, educationAssignmentResource: EducationAssignmentResource, options?: any): AxiosPromise<EducationAssignmentResource> {
            return localVarFp.updateAssignmentRecourceFromClass(groupId, assignmentId, resourceId, educationAssignmentResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EducationAssignmentsApi - object-oriented interface
 * @export
 * @class EducationAssignmentsApi
 * @extends {BaseAPI}
 */
export class EducationAssignmentsApi extends BaseAPI {
    /**
     * 
     * @summary Adds a web link to the desired assignment.
     * @param {EducationAssignmentAddLinkResourceRequest} educationAssignmentAddLinkResourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest: EducationAssignmentAddLinkResourceRequest, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).addLinkResourceToAssignment(educationAssignmentAddLinkResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a file to the desired assignment.
     * @param {EducationAssignmentAddResourceRequest} educationAssignmentAddResourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public addResourceToAssignment(educationAssignmentAddResourceRequest: EducationAssignmentAddResourceRequest, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).addResourceToAssignment(educationAssignmentAddResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a student submission resource to the specified assignment.
     * @param {EducationAssignmentAddSubmissionResourceRequest} educationAssignmentAddSubmissionResourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest: EducationAssignmentAddSubmissionResourceRequest, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).addSubmissionResourceForClass(educationAssignmentAddSubmissionResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new education assignment for the specified group.
     * @param {EducationAssignmentCreateRequest} educationAssignmentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public createEducationAssignmentForClass(educationAssignmentCreateRequest: EducationAssignmentCreateRequest, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).createEducationAssignmentForClass(educationAssignmentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes an assignment from the specified group.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public deleteAssignmentFromClass(groupId: string, assignmentId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).deleteAssignmentFromClass(groupId, assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a resource from the specified assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} resourceId 
     * @param {string} driveItemId 
     * @param {string} [submissionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public deleteAssignmentResourceFromClass(groupId: string, assignmentId: string, resourceId: string, driveItemId: string, submissionId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).deleteAssignmentResourceFromClass(groupId, assignmentId, resourceId, driveItemId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a web link from the specified assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} resourceId 
     * @param {string} [submissionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public deleteLinkResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).deleteLinkResourceFromClass(groupId, assignmentId, resourceId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes a students submission resource from the specified assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} resourceId 
     * @param {string} submissionId 
     * @param {string} driveItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public deleteSubmissionResourceFromClass(groupId: string, assignmentId: string, resourceId: string, submissionId: string, driveItemId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).deleteSubmissionResourceFromClass(groupId, assignmentId, resourceId, submissionId, driveItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all assignments for the given student. Pending on the property singleCourseMode either the assignments for the specified group id or all assignments of the user are returned. The latter only covers courses that are not archived and belong to the given time period (the active one when omitted).
     * @param {string} groupId 
     * @param {boolean} singleCourseMode 
     * @param {string} [timePeriod] Time period whose courses are listed when SingleCourseMode is false. Defaults to the active one.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getAllAssignmentFromClass(groupId: string, singleCourseMode: boolean, timePeriod?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getAllAssignmentFromClass(groupId, singleCourseMode, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all students submissions to a given assignment.
     * @param {string} assignmentId 
     * @param {string} id 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getAllSubmissionFromClass(assignmentId: string, id: string, groupId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getAllSubmissionFromClass(assignmentId, id, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the desired assignment of the specified group.
     * @param {string} assignmentId 
     * @param {string} id 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getAssignmentFromClass(assignmentId: string, id: string, groupId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getAssignmentFromClass(assignmentId, id, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Assignments.ShowModule</li></ul>
     * @summary Returns all specified homework the user who requested the homework. Does only work for students because the student dossier will be collected before retrieving any addtional information. 🔒: Assignments.ShowModule
     * @param {string} [organizationId] 
     * @param {string} [timePeriod] 
     * @param {boolean} [excludeTeamsAssignments] If set, only homework created without teams assignment will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getMyHomework(organizationId?: string, timePeriod?: string, excludeTeamsAssignments?: boolean, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getMyHomework(organizationId, timePeriod, excludeTeamsAssignments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specified submission within the desired assignment.
     * @param {string} assignmentId 
     * @param {string} submissionId 
     * @param {string} id 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getSubmissionFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getSubmissionFromClass(assignmentId, submissionId, id, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all resources the student added to her submission.
     * @param {string} assignmentId 
     * @param {string} submissionId 
     * @param {string} id 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public getSubmissionResourcesFromClass(assignmentId: string, submissionId: string, id: string, groupId?: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).getSubmissionResourcesFromClass(assignmentId, submissionId, id, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the state of an assignment to published.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public publishAssignmentForClass(groupId: string, assignmentId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).publishAssignmentForClass(groupId, assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the state of a students submission to be returned to her.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public returnSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).returnSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revokes a student submission result from a given assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public revertSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).revertSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allows a student to send her results to a given assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public sendSubmissionForClass(groupId: string, assignmentId: string, submissionId: string, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).sendSubmissionForClass(groupId, assignmentId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing assignment with the specified values.
     * @param {EducationAssignmentUpdateRequest} educationAssignmentUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public updateAssignmentFromClass(educationAssignmentUpdateRequest: EducationAssignmentUpdateRequest, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).updateAssignmentFromClass(educationAssignmentUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the desired resource of an existing assignment.
     * @param {string} groupId 
     * @param {string} assignmentId 
     * @param {string} resourceId 
     * @param {EducationAssignmentResource} educationAssignmentResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationAssignmentsApi
     */
    public updateAssignmentRecourceFromClass(groupId: string, assignmentId: string, resourceId: string, educationAssignmentResource: EducationAssignmentResource, options?: any) {
        return EducationAssignmentsApiFp(this.configuration).updateAssignmentRecourceFromClass(groupId, assignmentId, resourceId, educationAssignmentResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ElternBackendApiApi - axios parameter creator
 * @export
 */
export const ElternBackendApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AddParentRequest} addParentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParent: async (userId: string, addParentRequest: AddParentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addParent', 'userId', userId)
            // verify required parameter 'addParentRequest' is not null or undefined
            assertParamExists('addParent', 'addParentRequest', addParentRequest)
            const localVarPath = `/api/v2/ElternBackendApi/users/{userId}/parents`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addParentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AnswerParentalMailRequest} answerParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerParentalMail: async (answerParentalMailRequest: AnswerParentalMailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'answerParentalMailRequest' is not null or undefined
            assertParamExists('answerParentalMail', 'answerParentalMailRequest', answerParentalMailRequest)
            const localVarPath = `/api/v2/ElternBackendApi/parentalmails-answer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerParentalMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [organizationId] 
         * @param {string} [parentMailAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParent: async (userId: string, organizationId?: string, parentMailAddress?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteParent', 'userId', userId)
            const localVarPath = `/api/v2/ElternBackendApi/users/{userId}/parents`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (parentMailAddress !== undefined) {
                localVarQueryParameter['parentMailAddress'] = parentMailAddress;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindUsersRequest} findUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers: async (findUsersRequest: FindUsersRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'findUsersRequest' is not null or undefined
            assertParamExists('findUsers', 'findUsersRequest', findUsersRequest)
            const localVarPath = `/api/v2/ElternBackendApi/find/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAbsenceDraftsRequest} getAbsenceDraftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceDrafts: async (getAbsenceDraftsRequest: GetAbsenceDraftsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAbsenceDraftsRequest' is not null or undefined
            assertParamExists('getAbsenceDrafts', 'getAbsenceDraftsRequest', getAbsenceDraftsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/absence-drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAbsenceDraftsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAbsenceReasonsRequest} getAbsenceReasonsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasons: async (getAbsenceReasonsRequest: GetAbsenceReasonsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAbsenceReasonsRequest' is not null or undefined
            assertParamExists('getAbsenceReasons', 'getAbsenceReasonsRequest', getAbsenceReasonsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/absence-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAbsenceReasonsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAbsencesRequest} getAbsencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsences: async (getAbsencesRequest: GetAbsencesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAbsencesRequest' is not null or undefined
            assertParamExists('getAbsences', 'getAbsencesRequest', getAbsencesRequest)
            const localVarPath = `/api/v2/ElternBackendApi/absences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAbsencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAbsencesOverviewRequest} getAbsencesOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesOverview: async (getAbsencesOverviewRequest: GetAbsencesOverviewRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAbsencesOverviewRequest' is not null or undefined
            assertParamExists('getAbsencesOverview', 'getAbsencesOverviewRequest', getAbsencesOverviewRequest)
            const localVarPath = `/api/v2/ElternBackendApi/absences-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAbsencesOverviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAbsencesSettingsRequest} getAbsencesSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesSettings: async (getAbsencesSettingsRequest: GetAbsencesSettingsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAbsencesSettingsRequest' is not null or undefined
            assertParamExists('getAbsencesSettings', 'getAbsencesSettingsRequest', getAbsencesSettingsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/absences-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAbsencesSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAppointmentRequest} getAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: async (getAppointmentRequest: GetAppointmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAppointmentRequest' is not null or undefined
            assertParamExists('getAppointment', 'getAppointmentRequest', getAppointmentRequest)
            const localVarPath = `/api/v2/ElternBackendApi/appointments-single`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAppointmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAppointmentsRequest} getAppointmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointments: async (getAppointmentsRequest: GetAppointmentsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAppointmentsRequest' is not null or undefined
            assertParamExists('getAppointments', 'getAppointmentsRequest', getAppointmentsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAppointmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCourseEventRequest} getCourseEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseEvents: async (getCourseEventRequest: GetCourseEventRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCourseEventRequest' is not null or undefined
            assertParamExists('getCourseEvents', 'getCourseEventRequest', getCourseEventRequest)
            const localVarPath = `/api/v2/ElternBackendApi/course-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCourseEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCourseEventsRequest} getCourseEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseEventsAll: async (getCourseEventsRequest: GetCourseEventsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCourseEventsRequest' is not null or undefined
            assertParamExists('getCourseEventsAll', 'getCourseEventsRequest', getCourseEventsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/course-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCourseEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCoursesRequest} getCoursesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourses: async (getCoursesRequest: GetCoursesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCoursesRequest' is not null or undefined
            assertParamExists('getCourses', 'getCoursesRequest', getCoursesRequest)
            const localVarPath = `/api/v2/ElternBackendApi/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCoursesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFilesForOrganizationRequest} getFilesForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiles: async (getFilesForOrganizationRequest: GetFilesForOrganizationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getFilesForOrganizationRequest' is not null or undefined
            assertParamExists('getFiles', 'getFilesForOrganizationRequest', getFilesForOrganizationRequest)
            const localVarPath = `/api/v2/ElternBackendApi/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFilesForOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFileDownloadRequest} getFileDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesDownload: async (getFileDownloadRequest: GetFileDownloadRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getFileDownloadRequest' is not null or undefined
            assertParamExists('getFilesDownload', 'getFileDownloadRequest', getFileDownloadRequest)
            const localVarPath = `/api/v2/ElternBackendApi/files-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFileDownloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetHomeworksRequest} getHomeworksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeworks: async (getHomeworksRequest: GetHomeworksRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getHomeworksRequest' is not null or undefined
            assertParamExists('getHomeworks', 'getHomeworksRequest', getHomeworksRequest)
            const localVarPath = `/api/v2/ElternBackendApi/homeworks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHomeworksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetHomeworksOverviewRequest} getHomeworksOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeworksOverview: async (getHomeworksOverviewRequest: GetHomeworksOverviewRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getHomeworksOverviewRequest' is not null or undefined
            assertParamExists('getHomeworksOverview', 'getHomeworksOverviewRequest', getHomeworksOverviewRequest)
            const localVarPath = `/api/v2/ElternBackendApi/homeworks-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getHomeworksOverviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLatestLessonContentsRequest} getLatestLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLessonContents: async (getLatestLessonContentsRequest: GetLatestLessonContentsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLatestLessonContentsRequest' is not null or undefined
            assertParamExists('getLatestLessonContents', 'getLatestLessonContentsRequest', getLatestLessonContentsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/lesson-contents/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLatestLessonContentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLessonContentsRequest} getLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonContents: async (getLessonContentsRequest: GetLessonContentsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLessonContentsRequest' is not null or undefined
            assertParamExists('getLessonContents', 'getLessonContentsRequest', getLessonContentsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/lesson-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLessonContentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetNewsSingleRequest} getNewsSingleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews: async (getNewsSingleRequest: GetNewsSingleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getNewsSingleRequest' is not null or undefined
            assertParamExists('getNews', 'getNewsSingleRequest', getNewsSingleRequest)
            const localVarPath = `/api/v2/ElternBackendApi/news-single`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNewsSingleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetNewsRequest} getNewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsAll: async (getNewsRequest: GetNewsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getNewsRequest' is not null or undefined
            assertParamExists('getNewsAll', 'getNewsRequest', getNewsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNewsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetGuardianRequest} getGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParent: async (getGuardianRequest: GetGuardianRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getGuardianRequest' is not null or undefined
            assertParamExists('getParent', 'getGuardianRequest', getGuardianRequest)
            const localVarPath = `/api/v2/ElternBackendApi/get-parent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getGuardianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetParentalMailAttachmentDownloadRequest} getParentalMailAttachmentDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailAttachmentDownload: async (getParentalMailAttachmentDownloadRequest: GetParentalMailAttachmentDownloadRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getParentalMailAttachmentDownloadRequest' is not null or undefined
            assertParamExists('getParentalMailAttachmentDownload', 'getParentalMailAttachmentDownloadRequest', getParentalMailAttachmentDownloadRequest)
            const localVarPath = `/api/v2/ElternBackendApi/parentalmails-attachment-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getParentalMailAttachmentDownloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetParentalMailsRequest} getParentalMailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMails: async (getParentalMailsRequest: GetParentalMailsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getParentalMailsRequest' is not null or undefined
            assertParamExists('getParentalMails', 'getParentalMailsRequest', getParentalMailsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/parentalmails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getParentalMailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSchoolsRequest} getSchoolsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchools: async (getSchoolsRequest: GetSchoolsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSchoolsRequest' is not null or undefined
            assertParamExists('getSchools', 'getSchoolsRequest', getSchoolsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/schools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSchoolsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSettingsRequest} getSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (getSettingsRequest: GetSettingsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSettingsRequest' is not null or undefined
            assertParamExists('getSettings', 'getSettingsRequest', getSettingsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSingleParentalMailRequest} getSingleParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleParentalMails: async (getSingleParentalMailRequest: GetSingleParentalMailRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSingleParentalMailRequest' is not null or undefined
            assertParamExists('getSingleParentalMails', 'getSingleParentalMailRequest', getSingleParentalMailRequest)
            const localVarPath = `/api/v2/ElternBackendApi/parentalmails-single`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSingleParentalMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetSubstitutionsRequest} getSubstitutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutions: async (getSubstitutionsRequest: GetSubstitutionsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSubstitutionsRequest' is not null or undefined
            assertParamExists('getSubstitutions', 'getSubstitutionsRequest', getSubstitutionsRequest)
            const localVarPath = `/api/v2/ElternBackendApi/substitutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSubstitutionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTimePatternRequest} getTimePatternRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimePattern: async (getTimePatternRequest: GetTimePatternRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getTimePatternRequest' is not null or undefined
            assertParamExists('getTimePattern', 'getTimePatternRequest', getTimePatternRequest)
            const localVarPath = `/api/v2/ElternBackendApi/timepattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTimePatternRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetTimeTableRequest} getTimeTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTable: async (getTimeTableRequest: GetTimeTableRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getTimeTableRequest' is not null or undefined
            assertParamExists('getTimeTable', 'getTimeTableRequest', getTimeTableRequest)
            const localVarPath = `/api/v2/ElternBackendApi/timetable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTimeTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<GetUserRequestOption>} getUserRequestOption 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (getUserRequestOption: Array<GetUserRequestOption>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'getUserRequestOption' is not null or undefined
            assertParamExists('getUsers', 'getUserRequestOption', getUserRequestOption)
            const localVarPath = `/api/v2/ElternBackendApi/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUserRequestOption, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolveCourseRequest} resolveCourseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCourse: async (resolveCourseRequest: ResolveCourseRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveCourseRequest' is not null or undefined
            assertParamExists('resolveCourse', 'resolveCourseRequest', resolveCourseRequest)
            const localVarPath = `/api/v2/ElternBackendApi/course-resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveCourseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubmitAbsenceDraftRequest} submitAbsenceDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAbsenceDraft: async (submitAbsenceDraftRequest: SubmitAbsenceDraftRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitAbsenceDraftRequest' is not null or undefined
            assertParamExists('submitAbsenceDraft', 'submitAbsenceDraftRequest', submitAbsenceDraftRequest)
            const localVarPath = `/api/v2/ElternBackendApi/submit-absence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitAbsenceDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGuardianRequest} updateGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParent: async (updateGuardianRequest: UpdateGuardianRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGuardianRequest' is not null or undefined
            assertParamExists('updateParent', 'updateGuardianRequest', updateGuardianRequest)
            const localVarPath = `/api/v2/ElternBackendApi/update-parent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGuardianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ElternBackendApiApi - functional programming interface
 * @export
 */
export const ElternBackendApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ElternBackendApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AddParentRequest} addParentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addParent(userId: string, addParentRequest: AddParentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addParent(userId, addParentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AnswerParentalMailRequest} answerParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerParentalMail(answerParentalMailRequest: AnswerParentalMailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMailApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerParentalMail(answerParentalMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [organizationId] 
         * @param {string} [parentMailAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParent(userId: string, organizationId?: string, parentMailAddress?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParent(userId, organizationId, parentMailAddress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FindUsersRequest} findUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUsers(findUsersRequest: FindUsersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ElternappPerson>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUsers(findUsersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAbsenceDraftsRequest} getAbsenceDraftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsenceDrafts(getAbsenceDraftsRequest: GetAbsenceDraftsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ElternappAbsenceDraftResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsenceDrafts(getAbsenceDraftsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAbsenceReasonsRequest} getAbsenceReasonsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsenceReasons(getAbsenceReasonsRequest: GetAbsenceReasonsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAbsenceReasonsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsenceReasons(getAbsenceReasonsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAbsencesRequest} getAbsencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsences(getAbsencesRequest: GetAbsencesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAbsencesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsences(getAbsencesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAbsencesOverviewRequest} getAbsencesOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesOverview(getAbsencesOverviewRequest: GetAbsencesOverviewRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesOverview(getAbsencesOverviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAbsencesSettingsRequest} getAbsencesSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsencesSettings(getAbsencesSettingsRequest: GetAbsencesSettingsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAbsencesSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsencesSettings(getAbsencesSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAppointmentRequest} getAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointment(getAppointmentRequest: GetAppointmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAppointmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointment(getAppointmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetAppointmentsRequest} getAppointmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointments(getAppointmentsRequest: GetAppointmentsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAppointmentsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointments(getAppointmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetCourseEventRequest} getCourseEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourseEvents(getCourseEventRequest: GetCourseEventRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCourseEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourseEvents(getCourseEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetCourseEventsRequest} getCourseEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourseEventsAll(getCourseEventsRequest: GetCourseEventsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCourseEventsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourseEventsAll(getCourseEventsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetCoursesRequest} getCoursesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourses(getCoursesRequest: GetCoursesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourses(getCoursesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetFilesForOrganizationRequest} getFilesForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiles(getFilesForOrganizationRequest: GetFilesForOrganizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFilesForOrganizationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiles(getFilesForOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetFileDownloadRequest} getFileDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilesDownload(getFileDownloadRequest: GetFileDownloadRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileDownload>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilesDownload(getFileDownloadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetHomeworksRequest} getHomeworksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomeworks(getHomeworksRequest: GetHomeworksRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetHomeworkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomeworks(getHomeworksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetHomeworksOverviewRequest} getHomeworksOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomeworksOverview(getHomeworksOverviewRequest: GetHomeworksOverviewRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHomeworksOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomeworksOverview(getHomeworksOverviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetLatestLessonContentsRequest} getLatestLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestLessonContents(getLatestLessonContentsRequest: GetLatestLessonContentsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestLessonContentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestLessonContents(getLatestLessonContentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetLessonContentsRequest} getLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonContents(getLessonContentsRequest: GetLessonContentsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLessonContentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonContents(getLessonContentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetNewsSingleRequest} getNewsSingleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNews(getNewsSingleRequest: GetNewsSingleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNews(getNewsSingleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetNewsRequest} getNewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsAll(getNewsRequest: GetNewsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetNewsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsAll(getNewsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetGuardianRequest} getGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParent(getGuardianRequest: GetGuardianRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Parent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParent(getGuardianRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetParentalMailAttachmentDownloadRequest} getParentalMailAttachmentDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest: GetParentalMailAttachmentDownloadRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParentalMailAttachmentDownloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetParentalMailsRequest} getParentalMailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentalMails(getParentalMailsRequest: GetParentalMailsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParentalMailApiResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentalMails(getParentalMailsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetSchoolsRequest} getSchoolsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchools(getSchoolsRequest: GetSchoolsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSchoolsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchools(getSchoolsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetSettingsRequest} getSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(getSettingsRequest: GetSettingsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(getSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetSingleParentalMailRequest} getSingleParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleParentalMails(getSingleParentalMailRequest: GetSingleParentalMailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ParentalMailApiResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleParentalMails(getSingleParentalMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetSubstitutionsRequest} getSubstitutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubstitutions(getSubstitutionsRequest: GetSubstitutionsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSubstitutionsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubstitutions(getSubstitutionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetTimePatternRequest} getTimePatternRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimePattern(getTimePatternRequest: GetTimePatternRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimePatternResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimePattern(getTimePatternRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetTimeTableRequest} getTimeTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTable(getTimeTableRequest: GetTimeTableRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTable(getTimeTableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<GetUserRequestOption>} getUserRequestOption 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(getUserRequestOption: Array<GetUserRequestOption>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUsersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(getUserRequestOption, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResolveCourseRequest} resolveCourseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveCourse(resolveCourseRequest: ResolveCourseRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiResolvedCourse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveCourse(resolveCourseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SubmitAbsenceDraftRequest} submitAbsenceDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitAbsenceDraft(submitAbsenceDraftRequest: SubmitAbsenceDraftRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElternappAbsenceDraftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitAbsenceDraft(submitAbsenceDraftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateGuardianRequest} updateGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParent(updateGuardianRequest: UpdateGuardianRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Parent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParent(updateGuardianRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ElternBackendApiApi - factory interface
 * @export
 */
export const ElternBackendApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ElternBackendApiApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {AddParentRequest} addParentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParent(userId: string, addParentRequest: AddParentRequest, options?: any): AxiosPromise<ConfirmInvitationResponse> {
            return localVarFp.addParent(userId, addParentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AnswerParentalMailRequest} answerParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerParentalMail(answerParentalMailRequest: AnswerParentalMailRequest, options?: any): AxiosPromise<ParentalMailApiResponse> {
            return localVarFp.answerParentalMail(answerParentalMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} [organizationId] 
         * @param {string} [parentMailAddress] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParent(userId: string, organizationId?: string, parentMailAddress?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteParent(userId, organizationId, parentMailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FindUsersRequest} findUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers(findUsersRequest: FindUsersRequest, options?: any): AxiosPromise<Array<ElternappPerson>> {
            return localVarFp.findUsers(findUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAbsenceDraftsRequest} getAbsenceDraftsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceDrafts(getAbsenceDraftsRequest: GetAbsenceDraftsRequest, options?: any): AxiosPromise<Array<ElternappAbsenceDraftResponse>> {
            return localVarFp.getAbsenceDrafts(getAbsenceDraftsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAbsenceReasonsRequest} getAbsenceReasonsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasons(getAbsenceReasonsRequest: GetAbsenceReasonsRequest, options?: any): AxiosPromise<Array<GetAbsenceReasonsResponse>> {
            return localVarFp.getAbsenceReasons(getAbsenceReasonsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAbsencesRequest} getAbsencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsences(getAbsencesRequest: GetAbsencesRequest, options?: any): AxiosPromise<Array<GetAbsencesResponse>> {
            return localVarFp.getAbsences(getAbsencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAbsencesOverviewRequest} getAbsencesOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesOverview(getAbsencesOverviewRequest: GetAbsencesOverviewRequest, options?: any): AxiosPromise<GetSettingsResponse> {
            return localVarFp.getAbsencesOverview(getAbsencesOverviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAbsencesSettingsRequest} getAbsencesSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsencesSettings(getAbsencesSettingsRequest: GetAbsencesSettingsRequest, options?: any): AxiosPromise<GetAbsencesSettingsResponse> {
            return localVarFp.getAbsencesSettings(getAbsencesSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAppointmentRequest} getAppointmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(getAppointmentRequest: GetAppointmentRequest, options?: any): AxiosPromise<GetAppointmentsResponse> {
            return localVarFp.getAppointment(getAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAppointmentsRequest} getAppointmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointments(getAppointmentsRequest: GetAppointmentsRequest, options?: any): AxiosPromise<Array<GetAppointmentsResponse>> {
            return localVarFp.getAppointments(getAppointmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCourseEventRequest} getCourseEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseEvents(getCourseEventRequest: GetCourseEventRequest, options?: any): AxiosPromise<GetCourseEventsResponse> {
            return localVarFp.getCourseEvents(getCourseEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCourseEventsRequest} getCourseEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseEventsAll(getCourseEventsRequest: GetCourseEventsRequest, options?: any): AxiosPromise<Array<GetCourseEventsResponse>> {
            return localVarFp.getCourseEventsAll(getCourseEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCoursesRequest} getCoursesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourses(getCoursesRequest: GetCoursesRequest, options?: any): AxiosPromise<GetCoursesResponse> {
            return localVarFp.getCourses(getCoursesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFilesForOrganizationRequest} getFilesForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiles(getFilesForOrganizationRequest: GetFilesForOrganizationRequest, options?: any): AxiosPromise<Array<GetFilesForOrganizationResponse>> {
            return localVarFp.getFiles(getFilesForOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFileDownloadRequest} getFileDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesDownload(getFileDownloadRequest: GetFileDownloadRequest, options?: any): AxiosPromise<Array<FileDownload>> {
            return localVarFp.getFilesDownload(getFileDownloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetHomeworksRequest} getHomeworksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeworks(getHomeworksRequest: GetHomeworksRequest, options?: any): AxiosPromise<Array<GetHomeworkResponse>> {
            return localVarFp.getHomeworks(getHomeworksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetHomeworksOverviewRequest} getHomeworksOverviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeworksOverview(getHomeworksOverviewRequest: GetHomeworksOverviewRequest, options?: any): AxiosPromise<GetHomeworksOverviewResponse> {
            return localVarFp.getHomeworksOverview(getHomeworksOverviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLatestLessonContentsRequest} getLatestLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLessonContents(getLatestLessonContentsRequest: GetLatestLessonContentsRequest, options?: any): AxiosPromise<GetLatestLessonContentsResponse> {
            return localVarFp.getLatestLessonContents(getLatestLessonContentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLessonContentsRequest} getLessonContentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonContents(getLessonContentsRequest: GetLessonContentsRequest, options?: any): AxiosPromise<GetLessonContentsResponse> {
            return localVarFp.getLessonContents(getLessonContentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetNewsSingleRequest} getNewsSingleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(getNewsSingleRequest: GetNewsSingleRequest, options?: any): AxiosPromise<GetNewsResponse> {
            return localVarFp.getNews(getNewsSingleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetNewsRequest} getNewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsAll(getNewsRequest: GetNewsRequest, options?: any): AxiosPromise<Array<GetNewsResponse>> {
            return localVarFp.getNewsAll(getNewsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetGuardianRequest} getGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParent(getGuardianRequest: GetGuardianRequest, options?: any): AxiosPromise<Parent> {
            return localVarFp.getParent(getGuardianRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetParentalMailAttachmentDownloadRequest} getParentalMailAttachmentDownloadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest: GetParentalMailAttachmentDownloadRequest, options?: any): AxiosPromise<GetParentalMailAttachmentDownloadResponse> {
            return localVarFp.getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetParentalMailsRequest} getParentalMailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMails(getParentalMailsRequest: GetParentalMailsRequest, options?: any): AxiosPromise<Array<ParentalMailApiResponse>> {
            return localVarFp.getParentalMails(getParentalMailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSchoolsRequest} getSchoolsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchools(getSchoolsRequest: GetSchoolsRequest, options?: any): AxiosPromise<Array<GetSchoolsResponse>> {
            return localVarFp.getSchools(getSchoolsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSettingsRequest} getSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(getSettingsRequest: GetSettingsRequest, options?: any): AxiosPromise<GetSettingsResponse> {
            return localVarFp.getSettings(getSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSingleParentalMailRequest} getSingleParentalMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleParentalMails(getSingleParentalMailRequest: GetSingleParentalMailRequest, options?: any): AxiosPromise<Array<ParentalMailApiResponse>> {
            return localVarFp.getSingleParentalMails(getSingleParentalMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetSubstitutionsRequest} getSubstitutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubstitutions(getSubstitutionsRequest: GetSubstitutionsRequest, options?: any): AxiosPromise<Array<GetSubstitutionsResponse>> {
            return localVarFp.getSubstitutions(getSubstitutionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetTimePatternRequest} getTimePatternRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimePattern(getTimePatternRequest: GetTimePatternRequest, options?: any): AxiosPromise<Array<TimePatternResponse>> {
            return localVarFp.getTimePattern(getTimePatternRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetTimeTableRequest} getTimeTableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTable(getTimeTableRequest: GetTimeTableRequest, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimeTable(getTimeTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<GetUserRequestOption>} getUserRequestOption 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(getUserRequestOption: Array<GetUserRequestOption>, options?: any): AxiosPromise<Array<GetUsersResponse>> {
            return localVarFp.getUsers(getUserRequestOption, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResolveCourseRequest} resolveCourseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCourse(resolveCourseRequest: ResolveCourseRequest, options?: any): AxiosPromise<Array<ApiResolvedCourse>> {
            return localVarFp.resolveCourse(resolveCourseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubmitAbsenceDraftRequest} submitAbsenceDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAbsenceDraft(submitAbsenceDraftRequest: SubmitAbsenceDraftRequest, options?: any): AxiosPromise<ElternappAbsenceDraftResponse> {
            return localVarFp.submitAbsenceDraft(submitAbsenceDraftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateGuardianRequest} updateGuardianRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParent(updateGuardianRequest: UpdateGuardianRequest, options?: any): AxiosPromise<Parent> {
            return localVarFp.updateParent(updateGuardianRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ElternBackendApiApi - object-oriented interface
 * @export
 * @class ElternBackendApiApi
 * @extends {BaseAPI}
 */
export class ElternBackendApiApi extends BaseAPI {
    /**
     * 
     * @param {string} userId 
     * @param {AddParentRequest} addParentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public addParent(userId: string, addParentRequest: AddParentRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).addParent(userId, addParentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AnswerParentalMailRequest} answerParentalMailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public answerParentalMail(answerParentalMailRequest: AnswerParentalMailRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).answerParentalMail(answerParentalMailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} [organizationId] 
     * @param {string} [parentMailAddress] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public deleteParent(userId: string, organizationId?: string, parentMailAddress?: string, options?: any) {
        return ElternBackendApiApiFp(this.configuration).deleteParent(userId, organizationId, parentMailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FindUsersRequest} findUsersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public findUsers(findUsersRequest: FindUsersRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).findUsers(findUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAbsenceDraftsRequest} getAbsenceDraftsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAbsenceDrafts(getAbsenceDraftsRequest: GetAbsenceDraftsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAbsenceDrafts(getAbsenceDraftsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAbsenceReasonsRequest} getAbsenceReasonsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAbsenceReasons(getAbsenceReasonsRequest: GetAbsenceReasonsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAbsenceReasons(getAbsenceReasonsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAbsencesRequest} getAbsencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAbsences(getAbsencesRequest: GetAbsencesRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAbsences(getAbsencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAbsencesOverviewRequest} getAbsencesOverviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAbsencesOverview(getAbsencesOverviewRequest: GetAbsencesOverviewRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAbsencesOverview(getAbsencesOverviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAbsencesSettingsRequest} getAbsencesSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAbsencesSettings(getAbsencesSettingsRequest: GetAbsencesSettingsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAbsencesSettings(getAbsencesSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAppointmentRequest} getAppointmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAppointment(getAppointmentRequest: GetAppointmentRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAppointment(getAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAppointmentsRequest} getAppointmentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getAppointments(getAppointmentsRequest: GetAppointmentsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getAppointments(getAppointmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCourseEventRequest} getCourseEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getCourseEvents(getCourseEventRequest: GetCourseEventRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getCourseEvents(getCourseEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCourseEventsRequest} getCourseEventsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getCourseEventsAll(getCourseEventsRequest: GetCourseEventsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getCourseEventsAll(getCourseEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCoursesRequest} getCoursesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getCourses(getCoursesRequest: GetCoursesRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getCourses(getCoursesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFilesForOrganizationRequest} getFilesForOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getFiles(getFilesForOrganizationRequest: GetFilesForOrganizationRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getFiles(getFilesForOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFileDownloadRequest} getFileDownloadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getFilesDownload(getFileDownloadRequest: GetFileDownloadRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getFilesDownload(getFileDownloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetHomeworksRequest} getHomeworksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getHomeworks(getHomeworksRequest: GetHomeworksRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getHomeworks(getHomeworksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetHomeworksOverviewRequest} getHomeworksOverviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getHomeworksOverview(getHomeworksOverviewRequest: GetHomeworksOverviewRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getHomeworksOverview(getHomeworksOverviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetLatestLessonContentsRequest} getLatestLessonContentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getLatestLessonContents(getLatestLessonContentsRequest: GetLatestLessonContentsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getLatestLessonContents(getLatestLessonContentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetLessonContentsRequest} getLessonContentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getLessonContents(getLessonContentsRequest: GetLessonContentsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getLessonContents(getLessonContentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetNewsSingleRequest} getNewsSingleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getNews(getNewsSingleRequest: GetNewsSingleRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getNews(getNewsSingleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetNewsRequest} getNewsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getNewsAll(getNewsRequest: GetNewsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getNewsAll(getNewsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetGuardianRequest} getGuardianRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getParent(getGuardianRequest: GetGuardianRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getParent(getGuardianRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetParentalMailAttachmentDownloadRequest} getParentalMailAttachmentDownloadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest: GetParentalMailAttachmentDownloadRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getParentalMailAttachmentDownload(getParentalMailAttachmentDownloadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetParentalMailsRequest} getParentalMailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getParentalMails(getParentalMailsRequest: GetParentalMailsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getParentalMails(getParentalMailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSchoolsRequest} getSchoolsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getSchools(getSchoolsRequest: GetSchoolsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getSchools(getSchoolsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSettingsRequest} getSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getSettings(getSettingsRequest: GetSettingsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getSettings(getSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSingleParentalMailRequest} getSingleParentalMailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getSingleParentalMails(getSingleParentalMailRequest: GetSingleParentalMailRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getSingleParentalMails(getSingleParentalMailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetSubstitutionsRequest} getSubstitutionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getSubstitutions(getSubstitutionsRequest: GetSubstitutionsRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getSubstitutions(getSubstitutionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetTimePatternRequest} getTimePatternRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getTimePattern(getTimePatternRequest: GetTimePatternRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getTimePattern(getTimePatternRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetTimeTableRequest} getTimeTableRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getTimeTable(getTimeTableRequest: GetTimeTableRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getTimeTable(getTimeTableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<GetUserRequestOption>} getUserRequestOption 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public getUsers(getUserRequestOption: Array<GetUserRequestOption>, options?: any) {
        return ElternBackendApiApiFp(this.configuration).getUsers(getUserRequestOption, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResolveCourseRequest} resolveCourseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public resolveCourse(resolveCourseRequest: ResolveCourseRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).resolveCourse(resolveCourseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubmitAbsenceDraftRequest} submitAbsenceDraftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public submitAbsenceDraft(submitAbsenceDraftRequest: SubmitAbsenceDraftRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).submitAbsenceDraft(submitAbsenceDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateGuardianRequest} updateGuardianRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElternBackendApiApi
     */
    public updateParent(updateGuardianRequest: UpdateGuardianRequest, options?: any) {
        return ElternBackendApiApiFp(this.configuration).updateParent(updateGuardianRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EvacuationReportApi - axios parameter creator
 * @export
 */
export const EvacuationReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the evacuation list (Evakuierungsliste) of the organization as a PDF from live data, optionally as of an earlier point in time. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [pointInTime] Builds the list as of this point in time instead of now. Without an offset the value is read in the organization\&#39;s time zone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvacuationList: async (organizationId: string, pointInTime?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvacuationList', 'organizationId', organizationId)
            const localVarPath = `/api/v2/EvacuationReport/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pointInTime !== undefined) {
                localVarQueryParameter['pointInTime'] = (pointInTime as any instanceof Date) ?
                    (pointInTime as any).toISOString() :
                    pointInTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvacuationReportApi - functional programming interface
 * @export
 */
export const EvacuationReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvacuationReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the evacuation list (Evakuierungsliste) of the organization as a PDF from live data, optionally as of an earlier point in time. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [pointInTime] Builds the list as of this point in time instead of now. Without an offset the value is read in the organization\&#39;s time zone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvacuationList(organizationId: string, pointInTime?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvacuationList(organizationId, pointInTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EvacuationReportApi - factory interface
 * @export
 */
export const EvacuationReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvacuationReportApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the evacuation list (Evakuierungsliste) of the organization as a PDF from live data, optionally as of an earlier point in time. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [pointInTime] Builds the list as of this point in time instead of now. Without an offset the value is read in the organization\&#39;s time zone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvacuationList(organizationId: string, pointInTime?: string, options?: any): AxiosPromise<any> {
            return localVarFp.getEvacuationList(organizationId, pointInTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvacuationReportApi - object-oriented interface
 * @export
 * @class EvacuationReportApi
 * @extends {BaseAPI}
 */
export class EvacuationReportApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
     * @summary Generates the evacuation list (Evakuierungsliste) of the organization as a PDF from live data, optionally as of an earlier point in time. 🔒: Reports.ShowModule
     * @param {string} organizationId 
     * @param {string} [pointInTime] Builds the list as of this point in time instead of now. Without an offset the value is read in the organization\&#39;s time zone.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvacuationReportApi
     */
    public getEvacuationList(organizationId: string, pointInTime?: string, options?: any) {
        return EvacuationReportApiFp(this.configuration).getEvacuationList(organizationId, pointInTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all features of the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatures: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllFeatures', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Features/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} featureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasFeatureFlag: async (organizationId: string, featureFlag: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hasFeatureFlag', 'organizationId', organizationId)
            // verify required parameter 'featureFlag' is not null or undefined
            assertParamExists('hasFeatureFlag', 'featureFlag', featureFlag)
            const localVarPath = `/api/v2/Features/{organizationId}/hasFeatureFlag/{featureFlag}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"featureFlag"}}`, encodeURIComponent(String(featureFlag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given features for the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FeaturesUpdateRequest} featuresUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatures: async (organizationId: string, featuresUpdateRequest: FeaturesUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFeatures', 'organizationId', organizationId)
            // verify required parameter 'featuresUpdateRequest' is not null or undefined
            assertParamExists('updateFeatures', 'featuresUpdateRequest', featuresUpdateRequest)
            const localVarPath = `/api/v2/Features/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featuresUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all features of the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFeatures(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFeatures(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} featureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasFeatureFlag(organizationId: string, featureFlag: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasFeatureFlag(organizationId, featureFlag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given features for the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FeaturesUpdateRequest} featuresUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeatures(organizationId: string, featuresUpdateRequest: FeaturesUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeatures(organizationId, featuresUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all features of the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFeatures(organizationId: string, options?: any): AxiosPromise<Array<Feature>> {
            return localVarFp.getAllFeatures(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} featureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasFeatureFlag(organizationId: string, featureFlag: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.hasFeatureFlag(organizationId, featureFlag, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given features for the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FeaturesUpdateRequest} featuresUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeatures(organizationId: string, featuresUpdateRequest: FeaturesUpdateRequest, options?: any): AxiosPromise<Array<Feature>> {
            return localVarFp.updateFeatures(organizationId, featuresUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Returns all features of the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public getAllFeatures(organizationId: string, options?: any) {
        return FeaturesApiFp(this.configuration).getAllFeatures(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} featureFlag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public hasFeatureFlag(organizationId: string, featureFlag: string, options?: any) {
        return FeaturesApiFp(this.configuration).hasFeatureFlag(organizationId, featureFlag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates the given features for the given organization. IMPORTANT: This endpoint requires the user to have AixConcept Support or Chief Executive permissions. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {FeaturesUpdateRequest} featuresUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    public updateFeatures(organizationId: string, featuresUpdateRequest: FeaturesUpdateRequest, options?: any) {
        return FeaturesApiFp(this.configuration).updateFeatures(organizationId, featuresUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FrontendMigrationApi - axios parameter creator
 * @export
 */
export const FrontendMigrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the FrontendMigrationStatus for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontendMigrationStatus: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFrontendMigrationStatus', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/FrontendMigration/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Starts the Frontend Migration for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStartFrontendMigration: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postStartFrontendMigration', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/FrontendMigration/start`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the frontend migration status.
         * @param {string} organizationId 
         * @param {FrontendMigrationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (organizationId: string, status: FrontendMigrationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateStatus', 'organizationId', organizationId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStatus', 'status', status)
            const localVarPath = `/api/V2/{organizationId}/FrontendMigration/status/{status}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FrontendMigrationApi - functional programming interface
 * @export
 */
export const FrontendMigrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FrontendMigrationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the FrontendMigrationStatus for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontendMigrationStatus(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontendMigrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontendMigrationStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Starts the Frontend Migration for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postStartFrontendMigration(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontendMigrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postStartFrontendMigration(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the frontend migration status.
         * @param {string} organizationId 
         * @param {FrontendMigrationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(organizationId: string, status: FrontendMigrationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrontendMigrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(organizationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FrontendMigrationApi - factory interface
 * @export
 */
export const FrontendMigrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FrontendMigrationApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the FrontendMigrationStatus for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontendMigrationStatus(organizationId: string, options?: any): AxiosPromise<FrontendMigrationResponse> {
            return localVarFp.getFrontendMigrationStatus(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Starts the Frontend Migration for the given organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStartFrontendMigration(organizationId: string, options?: any): AxiosPromise<FrontendMigrationResponse> {
            return localVarFp.postStartFrontendMigration(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the frontend migration status.
         * @param {string} organizationId 
         * @param {FrontendMigrationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(organizationId: string, status: FrontendMigrationStatus, options?: any): AxiosPromise<FrontendMigrationResponse> {
            return localVarFp.updateStatus(organizationId, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FrontendMigrationApi - object-oriented interface
 * @export
 * @class FrontendMigrationApi
 * @extends {BaseAPI}
 */
export class FrontendMigrationApi extends BaseAPI {
    /**
     * 
     * @summary Gets the FrontendMigrationStatus for the given organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendMigrationApi
     */
    public getFrontendMigrationStatus(organizationId: string, options?: any) {
        return FrontendMigrationApiFp(this.configuration).getFrontendMigrationStatus(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Starts the Frontend Migration for the given organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendMigrationApi
     */
    public postStartFrontendMigration(organizationId: string, options?: any) {
        return FrontendMigrationApiFp(this.configuration).postStartFrontendMigration(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the frontend migration status.
     * @param {string} organizationId 
     * @param {FrontendMigrationStatus} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrontendMigrationApi
     */
    public updateStatus(organizationId: string, status: FrontendMigrationStatus, options?: any) {
        return FrontendMigrationApiFp(this.configuration).updateStatus(organizationId, status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GuardianChatApi - axios parameter creator
 * @export
 */
export const GuardianChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {Array<CreateChatParticipantRequest>} createChatParticipantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChatParticipants: async (organizationId: string, threadId: string, createChatParticipantRequest: Array<CreateChatParticipantRequest>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addChatParticipants', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('addChatParticipants', 'threadId', threadId)
            // verify required parameter 'createChatParticipantRequest' is not null or undefined
            assertParamExists('addChatParticipants', 'createChatParticipantRequest', createChatParticipantRequest)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/participants`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatParticipantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {GuardianChatCreateThreadRequestContent} guardianChatCreateThreadRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatThread: async (organizationId: string, guardianChatCreateThreadRequestContent: GuardianChatCreateThreadRequestContent, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createChatThread', 'organizationId', organizationId)
            // verify required parameter 'guardianChatCreateThreadRequestContent' is not null or undefined
            assertParamExists('createChatThread', 'guardianChatCreateThreadRequestContent', guardianChatCreateThreadRequestContent)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guardianChatCreateThreadRequestContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatThread: async (organizationId: string, threadId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteChatThread', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('deleteChatThread', 'threadId', threadId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatThreadMessages: async (organizationId: string, threadId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getChatThreadMessages', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getChatThreadMessages', 'threadId', threadId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatThreadsOfMe: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getChatThreadsOfMe', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/of/me`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownloadUrl: async (organizationId: string, threadId: string, fileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFileDownloadUrl', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getFileDownloadUrl', 'threadId', threadId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFileDownloadUrl', 'fileId', fileId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/files/{fileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantCandidates: async (organizationId: string, threadId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getParticipantCandidates', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/participants/candidates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (threadId !== undefined) {
                localVarQueryParameter['threadId'] = threadId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getToken', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/auth/token`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUnreadCount: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTotalUnreadCount', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/unread-count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead: async (organizationId: string, threadId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('markThreadAsRead', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('markThreadAsRead', 'threadId', threadId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/mark-read`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('refreshToken', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/auth/token/refresh`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeChatParticipant: async (organizationId: string, threadId: string, participantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeChatParticipant', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('removeChatParticipant', 'threadId', threadId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('removeChatParticipant', 'participantId', participantId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/participants/{participantId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {GuardianChatSendChatMessageRequestContent} guardianChatSendChatMessageRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChatMessage: async (organizationId: string, threadId: string, guardianChatSendChatMessageRequestContent: GuardianChatSendChatMessageRequestContent, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendChatMessage', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('sendChatMessage', 'threadId', threadId)
            // verify required parameter 'guardianChatSendChatMessageRequestContent' is not null or undefined
            assertParamExists('sendChatMessage', 'guardianChatSendChatMessageRequestContent', guardianChatSendChatMessageRequestContent)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/messages`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guardianChatSendChatMessageRequestContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {CreateChatLockRequest} createChatLockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatConfiguration: async (organizationId: string, threadId: string, createChatLockRequest: CreateChatLockRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateChatConfiguration', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('updateChatConfiguration', 'threadId', threadId)
            // verify required parameter 'createChatLockRequest' is not null or undefined
            assertParamExists('updateChatConfiguration', 'createChatLockRequest', createChatLockRequest)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatLockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (organizationId: string, threadId: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadFile', 'organizationId', organizationId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('uploadFile', 'threadId', threadId)
            const localVarPath = `/api/V2/{organizationId}/GuardianChat/threads/{threadId}/files`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GuardianChatApi - functional programming interface
 * @export
 */
export const GuardianChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GuardianChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {Array<CreateChatParticipantRequest>} createChatParticipantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addChatParticipants(organizationId: string, threadId: string, createChatParticipantRequest: Array<CreateChatParticipantRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatParticipantResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addChatParticipants(organizationId, threadId, createChatParticipantRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {GuardianChatCreateThreadRequestContent} guardianChatCreateThreadRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChatThread(organizationId: string, guardianChatCreateThreadRequestContent: GuardianChatCreateThreadRequestContent, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuardianChatThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChatThread(organizationId, guardianChatCreateThreadRequestContent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatThread(organizationId: string, threadId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatThread(organizationId, threadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatThreadMessages(organizationId: string, threadId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuardianChatThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatThreadMessages(organizationId, threadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatThreadsOfMe(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GuardianChatThreadItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatThreadsOfMe(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileDownloadUrl(organizationId: string, threadId: string, fileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatAttachmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileDownloadUrl(organizationId, threadId, fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParticipantCandidates(organizationId: string, threadId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GuardianChatParticipantCandidatesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParticipantCandidates(organizationId, threadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToken(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalUnreadCount(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalUnreadCount(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markThreadAsRead(organizationId: string, threadId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markThreadAsRead(organizationId, threadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeChatParticipant(organizationId: string, threadId: string, participantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeChatParticipant(organizationId, threadId, participantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {GuardianChatSendChatMessageRequestContent} guardianChatSendChatMessageRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendChatMessage(organizationId: string, threadId: string, guardianChatSendChatMessageRequestContent: GuardianChatSendChatMessageRequestContent, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuardianChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendChatMessage(organizationId, threadId, guardianChatSendChatMessageRequestContent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {CreateChatLockRequest} createChatLockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatConfiguration(organizationId: string, threadId: string, createChatLockRequest: CreateChatLockRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatLockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatConfiguration(organizationId, threadId, createChatLockRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(organizationId: string, threadId: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(organizationId, threadId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GuardianChatApi - factory interface
 * @export
 */
export const GuardianChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GuardianChatApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {Array<CreateChatParticipantRequest>} createChatParticipantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChatParticipants(organizationId: string, threadId: string, createChatParticipantRequest: Array<CreateChatParticipantRequest>, options?: any): AxiosPromise<Array<ChatParticipantResponse>> {
            return localVarFp.addChatParticipants(organizationId, threadId, createChatParticipantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {GuardianChatCreateThreadRequestContent} guardianChatCreateThreadRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChatThread(organizationId: string, guardianChatCreateThreadRequestContent: GuardianChatCreateThreadRequestContent, options?: any): AxiosPromise<GuardianChatThreadResponse> {
            return localVarFp.createChatThread(organizationId, guardianChatCreateThreadRequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatThread(organizationId: string, threadId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteChatThread(organizationId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatThreadMessages(organizationId: string, threadId: string, options?: any): AxiosPromise<GuardianChatThreadResponse> {
            return localVarFp.getChatThreadMessages(organizationId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatThreadsOfMe(organizationId: string, options?: any): AxiosPromise<Array<GuardianChatThreadItemResponse>> {
            return localVarFp.getChatThreadsOfMe(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownloadUrl(organizationId: string, threadId: string, fileId: string, options?: any): AxiosPromise<ChatAttachmentResponse> {
            return localVarFp.getFileDownloadUrl(organizationId, threadId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantCandidates(organizationId: string, threadId?: string, options?: any): AxiosPromise<Array<GuardianChatParticipantCandidatesResponse>> {
            return localVarFp.getParticipantCandidates(organizationId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken(organizationId: string, options?: any): AxiosPromise<ChatTokenResponse> {
            return localVarFp.getToken(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalUnreadCount(organizationId: string, options?: any): AxiosPromise<number> {
            return localVarFp.getTotalUnreadCount(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead(organizationId: string, threadId: string, options?: any): AxiosPromise<void> {
            return localVarFp.markThreadAsRead(organizationId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(organizationId: string, options?: any): AxiosPromise<ChatTokenResponse> {
            return localVarFp.refreshToken(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {string} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeChatParticipant(organizationId: string, threadId: string, participantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeChatParticipant(organizationId, threadId, participantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {GuardianChatSendChatMessageRequestContent} guardianChatSendChatMessageRequestContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChatMessage(organizationId: string, threadId: string, guardianChatSendChatMessageRequestContent: GuardianChatSendChatMessageRequestContent, options?: any): AxiosPromise<GuardianChatMessageResponse> {
            return localVarFp.sendChatMessage(organizationId, threadId, guardianChatSendChatMessageRequestContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {CreateChatLockRequest} createChatLockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatConfiguration(organizationId: string, threadId: string, createChatLockRequest: CreateChatLockRequest, options?: any): AxiosPromise<ChatLockResponse> {
            return localVarFp.updateChatConfiguration(organizationId, threadId, createChatLockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {string} threadId 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(organizationId: string, threadId: string, file?: any, options?: any): AxiosPromise<string> {
            return localVarFp.uploadFile(organizationId, threadId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GuardianChatApi - object-oriented interface
 * @export
 * @class GuardianChatApi
 * @extends {BaseAPI}
 */
export class GuardianChatApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {Array<CreateChatParticipantRequest>} createChatParticipantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public addChatParticipants(organizationId: string, threadId: string, createChatParticipantRequest: Array<CreateChatParticipantRequest>, options?: any) {
        return GuardianChatApiFp(this.configuration).addChatParticipants(organizationId, threadId, createChatParticipantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {GuardianChatCreateThreadRequestContent} guardianChatCreateThreadRequestContent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public createChatThread(organizationId: string, guardianChatCreateThreadRequestContent: GuardianChatCreateThreadRequestContent, options?: any) {
        return GuardianChatApiFp(this.configuration).createChatThread(organizationId, guardianChatCreateThreadRequestContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public deleteChatThread(organizationId: string, threadId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).deleteChatThread(organizationId, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getChatThreadMessages(organizationId: string, threadId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getChatThreadMessages(organizationId, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getChatThreadsOfMe(organizationId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getChatThreadsOfMe(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getFileDownloadUrl(organizationId: string, threadId: string, fileId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getFileDownloadUrl(organizationId, threadId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} [threadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getParticipantCandidates(organizationId: string, threadId?: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getParticipantCandidates(organizationId, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getToken(organizationId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getToken(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public getTotalUnreadCount(organizationId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).getTotalUnreadCount(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public markThreadAsRead(organizationId: string, threadId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).markThreadAsRead(organizationId, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public refreshToken(organizationId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).refreshToken(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {string} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public removeChatParticipant(organizationId: string, threadId: string, participantId: string, options?: any) {
        return GuardianChatApiFp(this.configuration).removeChatParticipant(organizationId, threadId, participantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {GuardianChatSendChatMessageRequestContent} guardianChatSendChatMessageRequestContent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public sendChatMessage(organizationId: string, threadId: string, guardianChatSendChatMessageRequestContent: GuardianChatSendChatMessageRequestContent, options?: any) {
        return GuardianChatApiFp(this.configuration).sendChatMessage(organizationId, threadId, guardianChatSendChatMessageRequestContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {CreateChatLockRequest} createChatLockRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public updateChatConfiguration(organizationId: string, threadId: string, createChatLockRequest: CreateChatLockRequest, options?: any) {
        return GuardianChatApiFp(this.configuration).updateChatConfiguration(organizationId, threadId, createChatLockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {string} threadId 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuardianChatApi
     */
    public uploadFile(organizationId: string, threadId: string, file?: any, options?: any) {
        return GuardianChatApiFp(this.configuration).uploadFile(organizationId, threadId, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HybridSyncSettingsApi - axios parameter creator
 * @export
 */
export const HybridSyncSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHybridSyncSettings: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getHybridSyncSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/HybridSyncSettings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {HybridSyncSettingsUpdate} hybridSyncSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHybridSyncSettings: async (organizationId: string, hybridSyncSettingsUpdate: HybridSyncSettingsUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateHybridSyncSettings', 'organizationId', organizationId)
            // verify required parameter 'hybridSyncSettingsUpdate' is not null or undefined
            assertParamExists('updateHybridSyncSettings', 'hybridSyncSettingsUpdate', hybridSyncSettingsUpdate)
            const localVarPath = `/api/v2/HybridSyncSettings/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hybridSyncSettingsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HybridSyncSettingsApi - functional programming interface
 * @export
 */
export const HybridSyncSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HybridSyncSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHybridSyncSettings(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HybridSyncSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHybridSyncSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {HybridSyncSettingsUpdate} hybridSyncSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHybridSyncSettings(organizationId: string, hybridSyncSettingsUpdate: HybridSyncSettingsUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HybridSyncSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHybridSyncSettings(organizationId, hybridSyncSettingsUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HybridSyncSettingsApi - factory interface
 * @export
 */
export const HybridSyncSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HybridSyncSettingsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHybridSyncSettings(organizationId: string, options?: any): AxiosPromise<HybridSyncSettingsResponse> {
            return localVarFp.getHybridSyncSettings(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {HybridSyncSettingsUpdate} hybridSyncSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHybridSyncSettings(organizationId: string, hybridSyncSettingsUpdate: HybridSyncSettingsUpdate, options?: any): AxiosPromise<HybridSyncSettingsResponse> {
            return localVarFp.updateHybridSyncSettings(organizationId, hybridSyncSettingsUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HybridSyncSettingsApi - object-oriented interface
 * @export
 * @class HybridSyncSettingsApi
 * @extends {BaseAPI}
 */
export class HybridSyncSettingsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HybridSyncSettingsApi
     */
    public getHybridSyncSettings(organizationId: string, options?: any) {
        return HybridSyncSettingsApiFp(this.configuration).getHybridSyncSettings(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {HybridSyncSettingsUpdate} hybridSyncSettingsUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HybridSyncSettingsApi
     */
    public updateHybridSyncSettings(organizationId: string, hybridSyncSettingsUpdate: HybridSyncSettingsUpdate, options?: any) {
        return HybridSyncSettingsApiFp(this.configuration).updateHybridSyncSettings(organizationId, hybridSyncSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvitationApi - axios parameter creator
 * @export
 */
export const InvitationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Adds an attachment to the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {any} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment: async (id: string, formFile?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addAttachment', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}/attachment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (formFile !== undefined) { 
                localVarFormParams.append('formFile', formFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new invitation 🔒: AixConcept.Only
         * @param {InvitationCreateRequest} invitationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (invitationCreateRequest: InvitationCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationCreateRequest' is not null or undefined
            assertParamExists('create', 'invitationCreateRequest', invitationCreateRequest)
            const localVarPath = `/api/v2/Invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAttachment', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}/attachment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the invitation given by the given id 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteInvitation', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the specific invitation given in the Request 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get all Invitations 🔒: AixConcept.Only
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAttachment', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}/attachment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the details of the given invitation
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (id: string, tenantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetails', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getDetails', 'tenantId', tenantId)
            const localVarPath = `/api/v2/Invitation/{id}/{tenantId}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Gets a default list of all features. 🔒: AixConcept.Only
         * @param {string} [invitationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures: async (invitationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Invitation/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (invitationId !== undefined) {
                localVarQueryParameter['invitationId'] = invitationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends a mail for the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {string} [returnUrl] Gibt die Base Url an, unter der die Einrichtung des Tenants stattfindet. Wird in der E-Mail im Link verwendet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail: async (id: string, returnUrl?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendMail', 'id', id)
            const localVarPath = `/api/v2/Invitation/{id}/sendMail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given invitation with all information 🔒: AixConcept.Only
         * @param {InvitationUpdateRequest} invitationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (invitationUpdateRequest: InvitationUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUpdateRequest' is not null or undefined
            assertParamExists('update', 'invitationUpdateRequest', invitationUpdateRequest)
            const localVarPath = `/api/v2/Invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitationApi - functional programming interface
 * @export
 */
export const InvitationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitationApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Adds an attachment to the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {any} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAttachment(id: string, formFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAttachment(id, formFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new invitation 🔒: AixConcept.Only
         * @param {InvitationCreateRequest} invitationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(invitationCreateRequest: InvitationCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(invitationCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the invitation given by the given id 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvitation(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvitation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the specific invitation given in the Request 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get all Invitations 🔒: AixConcept.Only
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachment(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the details of the given invitation
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(id: string, tenantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(id, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Gets a default list of all features. 🔒: AixConcept.Only
         * @param {string} [invitationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatures(invitationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationFeature>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatures(invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends a mail for the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {string} [returnUrl] Gibt die Base Url an, unter der die Einrichtung des Tenants stattfindet. Wird in der E-Mail im Link verwendet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMail(id: string, returnUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMail(id, returnUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given invitation with all information 🔒: AixConcept.Only
         * @param {InvitationUpdateRequest} invitationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(invitationUpdateRequest: InvitationUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(invitationUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvitationApi - factory interface
 * @export
 */
export const InvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitationApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Adds an attachment to the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {any} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAttachment(id: string, formFile?: any, options?: any): AxiosPromise<void> {
            return localVarFp.addAttachment(id, formFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new invitation 🔒: AixConcept.Only
         * @param {InvitationCreateRequest} invitationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(invitationCreateRequest: InvitationCreateRequest, options?: any): AxiosPromise<InvitationResponse> {
            return localVarFp.create(invitationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAttachment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the invitation given by the given id 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation(id: string, options?: any): AxiosPromise<ErrorResponse> {
            return localVarFp.deleteInvitation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the specific invitation given in the Request 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): AxiosPromise<Array<InvitationResponse>> {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get all Invitations 🔒: AixConcept.Only
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(request?: object, options?: any): AxiosPromise<Array<InvitationResponse>> {
            return localVarFp.getAll(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Get the attachment of the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.getAttachment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the details of the given invitation
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(id: string, tenantId: string, options?: any): AxiosPromise<InvitationDetailsResponse> {
            return localVarFp.getDetails(id, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Gets a default list of all features. 🔒: AixConcept.Only
         * @param {string} [invitationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures(invitationId?: string, options?: any): AxiosPromise<Array<InvitationFeature>> {
            return localVarFp.getFeatures(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends a mail for the given invitation 🔒: AixConcept.Only
         * @param {string} id 
         * @param {string} [returnUrl] Gibt die Base Url an, unter der die Einrichtung des Tenants stattfindet. Wird in der E-Mail im Link verwendet.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail(id: string, returnUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendMail(id, returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates the given invitation with all information 🔒: AixConcept.Only
         * @param {InvitationUpdateRequest} invitationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(invitationUpdateRequest: InvitationUpdateRequest, options?: any): AxiosPromise<InvitationResponse> {
            return localVarFp.update(invitationUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvitationApi - object-oriented interface
 * @export
 * @class InvitationApi
 * @extends {BaseAPI}
 */
export class InvitationApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Adds an attachment to the given invitation 🔒: AixConcept.Only
     * @param {string} id 
     * @param {any} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public addAttachment(id: string, formFile?: any, options?: any) {
        return InvitationApiFp(this.configuration).addAttachment(id, formFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a new invitation 🔒: AixConcept.Only
     * @param {InvitationCreateRequest} invitationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public create(invitationCreateRequest: InvitationCreateRequest, options?: any) {
        return InvitationApiFp(this.configuration).create(invitationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes the attachment of the given invitation 🔒: AixConcept.Only
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public deleteAttachment(id: string, options?: any) {
        return InvitationApiFp(this.configuration).deleteAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes the invitation given by the given id 🔒: AixConcept.Only
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public deleteInvitation(id: string, options?: any) {
        return InvitationApiFp(this.configuration).deleteInvitation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Get the specific invitation given in the Request 🔒: AixConcept.Only
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public get(id: string, options?: any) {
        return InvitationApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Get all Invitations 🔒: AixConcept.Only
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public getAll(request?: object, options?: any) {
        return InvitationApiFp(this.configuration).getAll(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Get the attachment of the given invitation 🔒: AixConcept.Only
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public getAttachment(id: string, options?: any) {
        return InvitationApiFp(this.configuration).getAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the details of the given invitation
     * @param {string} id 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public getDetails(id: string, tenantId: string, options?: any) {
        return InvitationApiFp(this.configuration).getDetails(id, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Gets a default list of all features. 🔒: AixConcept.Only
     * @param {string} [invitationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public getFeatures(invitationId?: string, options?: any) {
        return InvitationApiFp(this.configuration).getFeatures(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Sends a mail for the given invitation 🔒: AixConcept.Only
     * @param {string} id 
     * @param {string} [returnUrl] Gibt die Base Url an, unter der die Einrichtung des Tenants stattfindet. Wird in der E-Mail im Link verwendet.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public sendMail(id: string, returnUrl?: string, options?: any) {
        return InvitationApiFp(this.configuration).sendMail(id, returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates the given invitation with all information 🔒: AixConcept.Only
     * @param {InvitationUpdateRequest} invitationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationApi
     */
    public update(invitationUpdateRequest: InvitationUpdateRequest, options?: any) {
        return InvitationApiFp(this.configuration).update(invitationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MdmApi - axios parameter creator
 * @export
 */
export const MdmApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device description. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyChangeDescriptionAction: async (deviceId: string, organizationId: string, description?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyChangeDescriptionAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyChangeDescriptionAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/description`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - clean windows device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCleanWindowsDeviceAction: async (deviceId: string, organizationId: string, keepUserData?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyCleanWindowsDeviceAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyCleanWindowsDeviceAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/cleanWindowsDevice`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (keepUserData !== undefined) {
                localVarQueryParameter['keepUserData'] = keepUserData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.DeleteDevices</li></ul>
         * @summary Deletes a device from the device management, without resetting it. 🔒: DeviceManagement.DeleteDevices
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDeleteDevice: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyDeleteDevice', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyDeleteDevice', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/delete`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device owner. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {DeviceOwner} [deviceOwner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDeviceActionChangeOwnership: async (deviceId: string, organizationId: string, deviceOwner?: DeviceOwner, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyDeviceActionChangeOwnership', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyDeviceActionChangeOwnership', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/changeOwnership`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceOwner !== undefined) {
                localVarQueryParameter['deviceOwner'] = deviceOwner;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - disable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDisableLostModeAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyDisableLostModeAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyDisableLostModeAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/disableLostmode`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - enable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyEnableLostModeAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyEnableLostModeAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyEnableLostModeAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/enableLostmode`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Forwards the specified action - locateDevice, attention: lost mode has to be enabled before on ios devices. Does send a e-mail to the user who send the request. Returns position of device when found. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLocateDeviceAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyLocateDeviceAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyLocateDeviceAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/locate`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reboot device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRebootAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyRebootAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyRebootAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/reboot`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - remote lock device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRemoteLockDeviceAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyRemoteLockDeviceAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyRemoteLockDeviceAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/remoteLock`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change devices name. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRenameDeviceAction: async (organizationId: string, deviceId: string, name?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyRenameDeviceAction', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyRenameDeviceAction', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/rename`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reset passcode. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyResetPasscodeAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyResetPasscodeAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyResetPasscodeAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/resetPasscode`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - retire device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRetireAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyRetireAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyRetireAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/retire`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - sync device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applySyncAction: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applySyncAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applySyncAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/sync`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - wipe device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {string} [macOsUnlockCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWipeAction: async (deviceId: string, organizationId: string, keepUserData?: boolean, macOsUnlockCode?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('applyWipeAction', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('applyWipeAction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/wipe`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (keepUserData !== undefined) {
                localVarQueryParameter['keepUserData'] = keepUserData;
            }

            if (macOsUnlockCode !== undefined) {
                localVarQueryParameter['macOsUnlockCode'] = macOsUnlockCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign a device to a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDeviceToGroup: async (organizationId: string, deviceId: string, groupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignDeviceToGroup', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('assignDeviceToGroup', 'deviceId', deviceId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('assignDeviceToGroup', 'groupId', groupId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/assignTo/{groupId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a ios devices. DepOnboardingSettings and the enrollmentProfileId has to be asked beforehand by: GetOnboardSettings, GetDepIosEnrollmentProfilesOfOnboardProfile Devices SerialNumbers are necessary. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} enrollmentProfileId 
         * @param {string} depOnboardingSettingsId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEnrollmentProfileToIosDevices: async (organizationId: string, enrollmentProfileId: string, depOnboardingSettingsId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToIosDevices', 'organizationId', organizationId)
            // verify required parameter 'enrollmentProfileId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToIosDevices', 'enrollmentProfileId', enrollmentProfileId)
            // verify required parameter 'depOnboardingSettingsId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToIosDevices', 'depOnboardingSettingsId', depOnboardingSettingsId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignEnrollmentProfileToIosDevices', 'requestBody', requestBody)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/ios/assignEnrollmentProfile/{depOnboardingSettingsId}/{enrollmentProfileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"enrollmentProfileId"}}`, encodeURIComponent(String(enrollmentProfileId)))
                .replace(`{${"depOnboardingSettingsId"}}`, encodeURIComponent(String(depOnboardingSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEnrollmentProfileToWindowsDevice: async (enrollmentProfileId: string, organizationId: string, deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentProfileId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToWindowsDevice', 'enrollmentProfileId', enrollmentProfileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToWindowsDevice', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('assignEnrollmentProfileToWindowsDevice', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/windows/{deviceId}/assignEnrollmentProfile/{enrollmentProfileId}`
                .replace(`{${"enrollmentProfileId"}}`, encodeURIComponent(String(enrollmentProfileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign groups to a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [configurationProfileId] 
         * @param {Array<string>} [groupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMdmGroupConfigurationProfile: async (organizationId: string, configurationProfileId?: string, groupIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignMdmGroupConfigurationProfile', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/assignConfigurationProfile`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (configurationProfileId !== undefined) {
                localVarQueryParameter['configurationProfileId'] = configurationProfileId;
            }

            if (groupIds) {
                localVarQueryParameter['groupIds'] = groupIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assigns software to a group. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<Assignment>} assignment 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSoftware: async (organizationId: string, assignment: Array<Assignment>, appId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignSoftware', 'organizationId', organizationId)
            // verify required parameter 'assignment' is not null or undefined
            assertParamExists('assignSoftware', 'assignment', assignment)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/assign`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appId !== undefined) {
                localVarQueryParameter['appId'] = appId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assigns a given windows autopilot profile to x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWindowsAutopilotProfileToGroup: async (organizationId: string, profileId: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('assignWindowsAutopilotProfileToGroup', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('assignWindowsAutopilotProfileToGroup', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/assign/windowsAutopilot/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndroidDeviceRestriction: async (organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAndroidDeviceRestriction', 'organizationId', organizationId)
            // verify required parameter 'androidDeviceRestrictionsEntry' is not null or undefined
            assertParamExists('createAndroidDeviceRestriction', 'androidDeviceRestrictionsEntry', androidDeviceRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/restriction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(androidDeviceRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android wifi configuration profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidWifiConfigurationEntry} androidWifiConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndroidWifiConfiguration: async (organizationId: string, androidWifiConfigurationEntry: AndroidWifiConfigurationEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAndroidWifiConfiguration', 'organizationId', organizationId)
            // verify required parameter 'androidWifiConfigurationEntry' is not null or undefined
            assertParamExists('createAndroidWifiConfiguration', 'androidWifiConfigurationEntry', androidWifiConfigurationEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/wifi`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(androidWifiConfigurationEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosDeviceFeatures: async (organizationId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosDeviceFeatures', 'organizationId', organizationId)
            // verify required parameter 'iosProfilesFeaturesEntry' is not null or undefined
            assertParamExists('createIosDeviceFeatures', 'iosProfilesFeaturesEntry', iosProfilesFeaturesEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/features`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosProfilesFeaturesEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosDeviceRestrictions: async (organizationId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosDeviceRestrictions', 'organizationId', organizationId)
            // verify required parameter 'iosProfilesRestrictionsEntry' is not null or undefined
            assertParamExists('createIosDeviceRestrictions', 'iosProfilesRestrictionsEntry', iosProfilesRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosProfilesRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosNonBoundOnboard: async (onboardSettingsId: string, organizationId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('createIosNonBoundOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosNonBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'onboardIosNonBoundEntry' is not null or undefined
            assertParamExists('createIosNonBoundOnboard', 'onboardIosNonBoundEntry', onboardIosNonBoundEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/nonBound`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardIosNonBoundEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a standard shared app configuration policy profile (auto created when create device feature profile and enable shared is set) Can be assigned to multiple groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [mdmGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosSharedAppConfiguration: async (organizationId: string, mdmGroupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosSharedAppConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/sharedAppConfig`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (mdmGroupId !== undefined) {
                localVarQueryParameter['mdmGroupId'] = mdmGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosSharedOnboard: async (onboardSettingsId: string, organizationId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('createIosSharedOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosSharedOnboard', 'organizationId', organizationId)
            // verify required parameter 'onboardSharedIosEntry' is not null or undefined
            assertParamExists('createIosSharedOnboard', 'onboardSharedIosEntry', onboardSharedIosEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/shared`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardSharedIosEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosUpdateConfiguration: async (organizationId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosUpdateConfiguration', 'organizationId', organizationId)
            // verify required parameter 'iosUpdateConfigurationEntry' is not null or undefined
            assertParamExists('createIosUpdateConfiguration', 'iosUpdateConfigurationEntry', iosUpdateConfigurationEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosUpdateConfigurationEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosUserBoundOnboard: async (onboardSettingsId: string, organizationId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('createIosUserBoundOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosUserBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'onboardUserBoundIosEntry' is not null or undefined
            assertParamExists('createIosUserBoundOnboard', 'onboardUserBoundIosEntry', onboardUserBoundIosEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/userBound`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardUserBoundIosEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios w-lan profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosWlanEntry} iosWlanEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosWlan: async (organizationId: string, iosWlanEntry: IosWlanEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createIosWlan', 'organizationId', organizationId)
            // verify required parameter 'iosWlanEntry' is not null or undefined
            assertParamExists('createIosWlan', 'iosWlanEntry', iosWlanEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/wlan`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosWlanEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMdmFavourite: async (organizationId: string, favouriteEntry: FavouriteEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createMdmFavourite', 'organizationId', organizationId)
            // verify required parameter 'favouriteEntry' is not null or undefined
            assertParamExists('createMdmFavourite', 'favouriteEntry', favouriteEntry)
            const localVarPath = `/api/v2/Mdm/favourites/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favouriteEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Create a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupCreateEntry} mdmGroupCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMdmGroup: async (organizationId: string, mdmGroupCreateEntry: MdmGroupCreateEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createMdmGroup', 'organizationId', organizationId)
            // verify required parameter 'mdmGroupCreateEntry' is not null or undefined
            assertParamExists('createMdmGroup', 'mdmGroupCreateEntry', mdmGroupCreateEntry)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mdmGroupCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsAdministration: async (organizationId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsAdministration', 'organizationId', organizationId)
            // verify required parameter 'windowsAdministrativeTemplatesEntry' is not null or undefined
            assertParamExists('createWindowsAdministration', 'windowsAdministrativeTemplatesEntry', windowsAdministrativeTemplatesEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/administration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsAdministrativeTemplatesEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsAutopilotProfile: async (organizationId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsAutopilotProfile', 'organizationId', organizationId)
            // verify required parameter 'windowsAutopilotDeploymentEntry' is not null or undefined
            assertParamExists('createWindowsAutopilotProfile', 'windowsAutopilotDeploymentEntry', windowsAutopilotDeploymentEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/autopilot`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsAutopilotDeploymentEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsCustomConfiguration: async (organizationId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsCustomConfiguration', 'organizationId', organizationId)
            // verify required parameter 'windowsCustomConfigurationEntry' is not null or undefined
            assertParamExists('createWindowsCustomConfiguration', 'windowsCustomConfigurationEntry', windowsCustomConfigurationEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/custom`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsCustomConfigurationEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows device restrictions. Creates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsDeviceRestrictions: async (organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsDeviceRestrictions', 'organizationId', organizationId)
            // verify required parameter 'windowsDeviceRestrictionsEntry' is not null or undefined
            assertParamExists('createWindowsDeviceRestrictions', 'windowsDeviceRestrictionsEntry', windowsDeviceRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsDeviceRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsLocalUserGroupMembership: async (organizationId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsLocalUserGroupMembership', 'organizationId', organizationId)
            // verify required parameter 'windowsLocalUserGroupMembershipEntry' is not null or undefined
            assertParamExists('createWindowsLocalUserGroupMembership', 'windowsLocalUserGroupMembershipEntry', windowsLocalUserGroupMembershipEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/localUserGroupMembership`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsLocalUserGroupMembershipEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsSettingsCatalogue: async (organizationId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsSettingsCatalogue', 'organizationId', organizationId)
            // verify required parameter 'windowsSettingsCatalogueEntry' is not null or undefined
            assertParamExists('createWindowsSettingsCatalogue', 'windowsSettingsCatalogueEntry', windowsSettingsCatalogueEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsCatalogue`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsSettingsCatalogueEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsShared: async (organizationId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsShared', 'organizationId', organizationId)
            // verify required parameter 'windowsSharedPolicyEntry' is not null or undefined
            assertParamExists('createWindowsShared', 'windowsSharedPolicyEntry', windowsSharedPolicyEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/shared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsSharedPolicyEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsUpdatePolicy: async (organizationId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsUpdatePolicy', 'organizationId', organizationId)
            // verify required parameter 'windowsUpdatePolicyEntry' is not null or undefined
            assertParamExists('createWindowsUpdatePolicy', 'windowsUpdatePolicyEntry', windowsUpdatePolicyEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsUpdatePolicyEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows wifi profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsWiFiEntry} windowsWiFiEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsWiFi: async (organizationId: string, windowsWiFiEntry: WindowsWiFiEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWindowsWiFi', 'organizationId', organizationId)
            // verify required parameter 'windowsWiFiEntry' is not null or undefined
            assertParamExists('createWindowsWiFi', 'windowsWiFiEntry', windowsWiFiEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/wlan`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsWiFiEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android device restriction configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAndroidDeviceRestriction: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAndroidDeviceRestriction', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteAndroidDeviceRestriction', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/restriction/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android wifi configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAndroidWiFiConfiguration: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAndroidWiFiConfiguration', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteAndroidWiFiConfiguration', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/wifi/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing features. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosDeviceFeatures: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosDeviceFeatures', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosDeviceFeatures', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/features/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing restrictions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosDeviceRestrictions: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosDeviceRestrictions', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosDeviceRestrictions', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/restrictions/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for non bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosNonBoundOnboard: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosNonBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosNonBoundOnboard', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{profileId}/nonBound`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for shared devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosSharedOnboard: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosSharedOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosSharedOnboard', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{profileId}/shared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing update behavior - schedules. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosUpdateConfiguration: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosUpdateConfiguration', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosUpdateConfiguration', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/update/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for user bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosUserBoundOnboard: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosUserBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosUserBoundOnboard', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{profileId}/userBound`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios w-lan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosWlan: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteIosWlan', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteIosWlan', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/wlan/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [favouriteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMdmFavourite: async (organizationId: string, favouriteId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMdmFavourite', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/favourites/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (favouriteId !== undefined) {
                localVarQueryParameter['favouriteId'] = favouriteId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a mdm group.
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMdmGroup: async (organizationId: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMdmGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/deleteGroup`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows administration template. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsAdministration: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsAdministration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/administration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows autopilot profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsAutopilotRestrictions: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsAutopilotRestrictions', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteWindowsAutopilotRestrictions', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/autopilot/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows custom configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsCustomConfiguration: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsCustomConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/custom`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows device restriction. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsDeviceRestrictions: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsDeviceRestrictions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings-localusergroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsLocalUserGroupMembership: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsLocalUserGroupMembership', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsLocalUserGroup`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings catalogue. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsSettingsCatalogue: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsSettingsCatalogue', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsCatalogue`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows shared policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsShared: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsShared', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/shared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows update policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsUpdatePolicy: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsUpdatePolicy', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows wlan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsWlan: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWindowsWlan', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/wlan`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {DeviceRegistration} [registrationFilter] 
         * @param {string} [searchForNameOrSerial] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicDevices: async (organizationId: string, platformFilter?: PlatformType, registrationFilter?: DeviceRegistration, searchForNameOrSerial?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicDevices', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platformFilter !== undefined) {
                localVarQueryParameter['platformFilter'] = platformFilter;
            }

            if (registrationFilter !== undefined) {
                localVarQueryParameter['registrationFilter'] = registrationFilter;
            }

            if (searchForNameOrSerial !== undefined) {
                localVarQueryParameter['searchForNameOrSerial'] = searchForNameOrSerial;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm groups within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicMdmGroups: async (organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicMdmGroups', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {AssignedStatus} [assignedFilter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicSoftware: async (organizationId: string, platformFilter?: PlatformType, assignedFilter?: AssignedStatus, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicSoftware', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platformFilter !== undefined) {
                localVarQueryParameter['platformFilter'] = platformFilter;
            }

            if (assignedFilter !== undefined) {
                localVarQueryParameter['assignedFilter'] = assignedFilter;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all mdm favourites within a organisation. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMdmFavourites: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllMdmFavourites', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/favourites/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a android device restriction configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidDeviceRestriction: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getAndroidDeviceRestriction', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAndroidDeviceRestriction', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/restriction/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidManagedStoreApp: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getAndroidManagedStoreApp', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAndroidManagedStoreApp', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/managedStoreApp/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Android Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} hostName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidStoreLink: async (hostName: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'hostName' is not null or undefined
            assertParamExists('getAndroidStoreLink', 'hostName', hostName)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAndroidStoreLink', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/android/storeLink/{hostName}`
                .replace(`{${"hostName"}}`, encodeURIComponent(String(hostName)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns the needed token to open the Android play store. The Url to use the token is:  https://play.google.com/managed/browse?mode=SELECT&token={webToken} 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWebToken: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAndroidWebToken', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/androidWebToken`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWiFiConfiguration: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getAndroidWiFiConfiguration', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAndroidWiFiConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/wifiConfiguration/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all software assigned and assignable of requested mdmGroups. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedSoftwareOfMdmGroups: async (organizationId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAssignedSoftwareOfMdmGroups', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getAssignedSoftwareOfMdmGroups', 'requestBody', requestBody)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/softwareAssignment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Retrieves a list of available ios-update-versions to post in the versionToInstall field of the ios-update-policy-profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableIosUpdateVersionsForUpdatePolicy: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAvailableIosUpdateVersionsForUpdatePolicy', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/update/availableVersions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns all available BitLocker keys for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitlockerKeys: async (organizationId: string, deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBitlockerKeys', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getBitlockerKeys', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/bitlockerKeys`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all ios enrollment profiles of a depOnboardSettingProfile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} depOnboardSettingsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepIosEnrollmentProfilesOfOnboardProfile: async (organizationId: string, depOnboardSettingsId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepIosEnrollmentProfilesOfOnboardProfile', 'organizationId', organizationId)
            // verify required parameter 'depOnboardSettingsId' is not null or undefined
            assertParamExists('getDepIosEnrollmentProfilesOfOnboardProfile', 'depOnboardSettingsId', depOnboardSettingsId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/depEnrollmentProfiles/{depOnboardSettingsId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depOnboardSettingsId"}}`, encodeURIComponent(String(depOnboardSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single device with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: async (deviceId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getDevice', 'deviceId', deviceId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDevice', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices which has been just imported and needs to be (manually) registered. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesWithoutRegistrationProfile: async (organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDevicesWithoutRegistrationProfile', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/withoutRegistrationProfile`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosAppConfiguration: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getIosAppConfiguration', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosAppConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/appConfiguration/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns the Ios-ActivationlockBypassCode for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosBypassCode: async (organizationId: string, deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosBypassCode', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getIosBypassCode', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/iosBypassCode`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing features. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosDeviceFeatures: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getIosDeviceFeatures', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosDeviceFeatures', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/features/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing restrictions. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosDeviceRestrictions: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getIosDeviceRestrictions', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosDeviceRestrictions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/restrictions/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Ios Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosStoreLink: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosStoreLink', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/ios/storeLink`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing update schedules. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosUpdateConfiguration: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getIosUpdateConfiguration', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosUpdateConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/update/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios w-lan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosWlan: async (profileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getIosWlan', 'profileId', profileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIosWlan', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/wlan/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm group with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} mdmGroupId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMdmGroup: async (mdmGroupId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mdmGroupId' is not null or undefined
            assertParamExists('getMdmGroup', 'mdmGroupId', mdmGroupId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMdmGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/{mdmGroupId}`
                .replace(`{${"mdmGroupId"}}`, encodeURIComponent(String(mdmGroupId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software that is not assigned. Attention: top does not do anything here, return the default top value from mc and returns a token if there is more to take 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotAssignedBasicSoftware: async (organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getNotAssignedBasicSoftware', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/notAssigned`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all onboard ios-settings of a organization. Ids are necessary to create onboard profiles for a setting 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardSettings: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOnboardSettings', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/depOnboardSettings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm software with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} softwareId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftware: async (softwareId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'softwareId' is not null or undefined
            assertParamExists('getSoftware', 'softwareId', softwareId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSoftware', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/{softwareId}`
                .replace(`{${"softwareId"}}`, encodeURIComponent(String(softwareId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows administration template. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAdministration: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsAdministration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/administration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all windows autopilot profiles. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAutopilotProfiles: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsAutopilotProfiles', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/autopilot`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows autopilot profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAutopilotRestrictions: async (organizationId: string, profileId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsAutopilotRestrictions', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getWindowsAutopilotRestrictions', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/autopilot/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows custom configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsCustomConfiguration: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsCustomConfiguration', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/custom`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows device restriction. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsDeviceRestrictions: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsDeviceRestrictions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows settings-localusergroup. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsLocalUserGroupMembership: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsLocalUserGroupMembership', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsLocalUserGroup`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows settings catalogue. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsSettingsCatalogue: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsSettingsCatalogue', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsCatalogue`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows shared policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsShared: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsShared', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/shared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Windows Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsStoreLink: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsStoreLink', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/windows/storeLink`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows update policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsUpdatePolicy: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsUpdatePolicy', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows wlan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsWlan: async (organizationId: string, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWindowsWlan', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/wlan`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Accepts a .CSV file which will be forwarded via mail to support for importing. Multipart request     - csvFile FILE     - GroupIds [Guid] 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {any} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDevicesRequest: async (organizationId: string, groupIds?: Array<string>, csvFile?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importDevicesRequest', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/import`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupIds) {
                localVarQueryParameter['groupIds'] = groupIds;
            }


            if (csvFile !== undefined) { 
                localVarFormParams.append('CsvFile', csvFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates device-assignment of a ios enrollment profile. Needed when wanting to delete a enrollment profile where devices are still assigned to. Needs old enrollmentProfile Id and new profile Id. Will auto transfer all devices to new profile. 🔒: AixConcept.Only
         * @param {string} oldProfileId 
         * @param {string} newProfileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reAssignIosDevicesToOtherEnrollmentProfile: async (oldProfileId: string, newProfileId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'oldProfileId' is not null or undefined
            assertParamExists('reAssignIosDevicesToOtherEnrollmentProfile', 'oldProfileId', oldProfileId)
            // verify required parameter 'newProfileId' is not null or undefined
            assertParamExists('reAssignIosDevicesToOtherEnrollmentProfile', 'newProfileId', newProfileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('reAssignIosDevicesToOtherEnrollmentProfile', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/reAssign/{oldProfileId}/to/{newProfileId}`
                .replace(`{${"oldProfileId"}}`, encodeURIComponent(String(oldProfileId)))
                .replace(`{${"newProfileId"}}`, encodeURIComponent(String(newProfileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes groups from a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {string} [configurationProfileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConfigurationProfileOfMdmGroup: async (organizationId: string, groupIds?: Array<string>, configurationProfileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeConfigurationProfileOfMdmGroup', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/removeConfigurationProfile`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupIds) {
                localVarQueryParameter['groupIds'] = groupIds;
            }

            if (configurationProfileId !== undefined) {
                localVarQueryParameter['configurationProfileId'] = configurationProfileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Removes a enrollment profile from a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be removed from that group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEnrollmentProfileToWindowsDevice: async (enrollmentProfileId: string, organizationId: string, deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollmentProfileId' is not null or undefined
            assertParamExists('removeEnrollmentProfileToWindowsDevice', 'enrollmentProfileId', enrollmentProfileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeEnrollmentProfileToWindowsDevice', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('removeEnrollmentProfileToWindowsDevice', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/windows/{deviceId}/removeEnrollmentProfile/{enrollmentProfileId}`
                .replace(`{${"enrollmentProfileId"}}`, encodeURIComponent(String(enrollmentProfileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes a given windows autopilot profile from x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWindowsAutopilotProfileFromGroup: async (organizationId: string, profileId: string, groupId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeWindowsAutopilotProfileFromGroup', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('removeWindowsAutopilotProfileFromGroup', 'profileId', profileId)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}/remove/windowsAutopilot/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends PPGK-Inquiry email with all attachments uploaded before. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<PPGKInquiryEntry>} pPGKInquiryEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPPGKInquiry: async (organizationId: string, pPGKInquiryEntry: Array<PPGKInquiryEntry>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendPPGKInquiry', 'organizationId', organizationId)
            // verify required parameter 'pPGKInquiryEntry' is not null or undefined
            assertParamExists('sendPPGKInquiry', 'pPGKInquiryEntry', pPGKInquiryEntry)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/import/ppgk/inquiry`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pPGKInquiryEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Sends Software-Inquiry email with all attachments uploaded before. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<SoftwareInquiryEmailEntry>} softwareInquiryEmailEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSoftwareInquiry: async (organizationId: string, softwareInquiryEmailEntry: Array<SoftwareInquiryEmailEntry>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendSoftwareInquiry', 'organizationId', organizationId)
            // verify required parameter 'softwareInquiryEmailEntry' is not null or undefined
            assertParamExists('sendSoftwareInquiry', 'softwareInquiryEmailEntry', softwareInquiryEmailEntry)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/inquiry`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(softwareInquiryEmailEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} newEnrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchDevicesEnrollmentProfile: async (newEnrollmentProfileId: string, organizationId: string, deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'newEnrollmentProfileId' is not null or undefined
            assertParamExists('switchDevicesEnrollmentProfile', 'newEnrollmentProfileId', newEnrollmentProfileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('switchDevicesEnrollmentProfile', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('switchDevicesEnrollmentProfile', 'deviceId', deviceId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/windows/{deviceId}/switchEnrollmentProfileTo/{newEnrollmentProfileId}`
                .replace(`{${"newEnrollmentProfileId"}}`, encodeURIComponent(String(newEnrollmentProfileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSoftwareStores: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncSoftwareStores', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/software/{organizationId}/stores/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Unassign a device from a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignDeviceFromGroup: async (organizationId: string, deviceId: string, groupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unassignDeviceFromGroup', 'organizationId', organizationId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('unassignDeviceFromGroup', 'deviceId', deviceId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('unassignDeviceFromGroup', 'groupId', groupId)
            const localVarPath = `/api/v2/Mdm/devices/{organizationId}/{deviceId}/assignTo/{groupId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAndroidDeviceRestriction: async (organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAndroidDeviceRestriction', 'organizationId', organizationId)
            // verify required parameter 'androidDeviceRestrictionsEntry' is not null or undefined
            assertParamExists('updateAndroidDeviceRestriction', 'androidDeviceRestrictionsEntry', androidDeviceRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/android/restriction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(androidDeviceRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosDeviceFeatures: async (organizationId: string, profileId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosDeviceFeatures', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosDeviceFeatures', 'profileId', profileId)
            // verify required parameter 'iosProfilesFeaturesEntry' is not null or undefined
            assertParamExists('updateIosDeviceFeatures', 'iosProfilesFeaturesEntry', iosProfilesFeaturesEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/features/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosProfilesFeaturesEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosDeviceRestrictions: async (organizationId: string, profileId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosDeviceRestrictions', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosDeviceRestrictions', 'profileId', profileId)
            // verify required parameter 'iosProfilesRestrictionsEntry' is not null or undefined
            assertParamExists('updateIosDeviceRestrictions', 'iosProfilesRestrictionsEntry', iosProfilesRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/restrictions/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosProfilesRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosNonBoundOnboard: async (onboardSettingsId: string, organizationId: string, profileId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('updateIosNonBoundOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosNonBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosNonBoundOnboard', 'profileId', profileId)
            // verify required parameter 'onboardIosNonBoundEntry' is not null or undefined
            assertParamExists('updateIosNonBoundOnboard', 'onboardIosNonBoundEntry', onboardIosNonBoundEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/nonBound/{profileId}`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardIosNonBoundEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosSharedOnboard: async (onboardSettingsId: string, organizationId: string, profileId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('updateIosSharedOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosSharedOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosSharedOnboard', 'profileId', profileId)
            // verify required parameter 'onboardSharedIosEntry' is not null or undefined
            assertParamExists('updateIosSharedOnboard', 'onboardSharedIosEntry', onboardSharedIosEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/shared/{profileId}`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardSharedIosEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosUpdateConfiguration: async (organizationId: string, profileId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosUpdateConfiguration', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosUpdateConfiguration', 'profileId', profileId)
            // verify required parameter 'iosUpdateConfigurationEntry' is not null or undefined
            assertParamExists('updateIosUpdateConfiguration', 'iosUpdateConfigurationEntry', iosUpdateConfigurationEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/update/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iosUpdateConfigurationEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosUserBoundOnboard: async (onboardSettingsId: string, organizationId: string, profileId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardSettingsId' is not null or undefined
            assertParamExists('updateIosUserBoundOnboard', 'onboardSettingsId', onboardSettingsId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateIosUserBoundOnboard', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateIosUserBoundOnboard', 'profileId', profileId)
            // verify required parameter 'onboardUserBoundIosEntry' is not null or undefined
            assertParamExists('updateIosUserBoundOnboard', 'onboardUserBoundIosEntry', onboardUserBoundIosEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/onboarding/{onboardSettingsId}/userBound/{profileId}`
                .replace(`{${"onboardSettingsId"}}`, encodeURIComponent(String(onboardSettingsId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardUserBoundIosEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} favouriteId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMdmFavourite: async (organizationId: string, favouriteId: string, favouriteEntry: FavouriteEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateMdmFavourite', 'organizationId', organizationId)
            // verify required parameter 'favouriteId' is not null or undefined
            assertParamExists('updateMdmFavourite', 'favouriteId', favouriteId)
            // verify required parameter 'favouriteEntry' is not null or undefined
            assertParamExists('updateMdmFavourite', 'favouriteEntry', favouriteEntry)
            const localVarPath = `/api/v2/Mdm/favourites/{organizationId}/{favouriteId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"favouriteId"}}`, encodeURIComponent(String(favouriteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favouriteEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Update a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupUpdateEntry} mdmGroupUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMdmGroup: async (organizationId: string, mdmGroupUpdateEntry: MdmGroupUpdateEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateMdmGroup', 'organizationId', organizationId)
            // verify required parameter 'mdmGroupUpdateEntry' is not null or undefined
            assertParamExists('updateMdmGroup', 'mdmGroupUpdateEntry', mdmGroupUpdateEntry)
            const localVarPath = `/api/v2/Mdm/groups/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mdmGroupUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsAdministration: async (organizationId: string, profileId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsAdministration', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsAdministration', 'profileId', profileId)
            // verify required parameter 'windowsAdministrativeTemplatesEntry' is not null or undefined
            assertParamExists('updateWindowsAdministration', 'windowsAdministrativeTemplatesEntry', windowsAdministrativeTemplatesEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/administration/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsAdministrativeTemplatesEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsAutopilotProfile: async (organizationId: string, profileId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsAutopilotProfile', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsAutopilotProfile', 'profileId', profileId)
            // verify required parameter 'windowsAutopilotDeploymentEntry' is not null or undefined
            assertParamExists('updateWindowsAutopilotProfile', 'windowsAutopilotDeploymentEntry', windowsAutopilotDeploymentEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/autopilot/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsAutopilotDeploymentEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsCustomConfiguration: async (organizationId: string, profileId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsCustomConfiguration', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsCustomConfiguration', 'profileId', profileId)
            // verify required parameter 'windowsCustomConfigurationEntry' is not null or undefined
            assertParamExists('updateWindowsCustomConfiguration', 'windowsCustomConfigurationEntry', windowsCustomConfigurationEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/custom/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsCustomConfigurationEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsDeviceRestrictions: async (organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, profileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsDeviceRestrictions', 'organizationId', organizationId)
            // verify required parameter 'windowsDeviceRestrictionsEntry' is not null or undefined
            assertParamExists('updateWindowsDeviceRestrictions', 'windowsDeviceRestrictionsEntry', windowsDeviceRestrictionsEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/restrictions/profileId`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (profileId !== undefined) {
                localVarQueryParameter['profileId'] = profileId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsDeviceRestrictionsEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsLocalUserGroupMembership: async (organizationId: string, profileId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsLocalUserGroupMembership', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsLocalUserGroupMembership', 'profileId', profileId)
            // verify required parameter 'windowsLocalUserGroupMembershipEntry' is not null or undefined
            assertParamExists('updateWindowsLocalUserGroupMembership', 'windowsLocalUserGroupMembershipEntry', windowsLocalUserGroupMembershipEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/localUserGroupMembership/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsLocalUserGroupMembershipEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsSettingsCatalogue: async (organizationId: string, profileId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsSettingsCatalogue', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsSettingsCatalogue', 'profileId', profileId)
            // verify required parameter 'windowsSettingsCatalogueEntry' is not null or undefined
            assertParamExists('updateWindowsSettingsCatalogue', 'windowsSettingsCatalogueEntry', windowsSettingsCatalogueEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/settingsCatalogue/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsSettingsCatalogueEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsShared: async (organizationId: string, profileId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsShared', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsShared', 'profileId', profileId)
            // verify required parameter 'windowsSharedPolicyEntry' is not null or undefined
            assertParamExists('updateWindowsShared', 'windowsSharedPolicyEntry', windowsSharedPolicyEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/shared/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsSharedPolicyEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsUpdatePolicy: async (organizationId: string, profileId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWindowsUpdatePolicy', 'organizationId', organizationId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateWindowsUpdatePolicy', 'profileId', profileId)
            // verify required parameter 'windowsUpdatePolicyEntry' is not null or undefined
            assertParamExists('updateWindowsUpdatePolicy', 'windowsUpdatePolicyEntry', windowsUpdatePolicyEntry)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/windows/update/{profileId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(windowsUpdatePolicyEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} iosFeatureProfileId 
         * @param {string} organizationId 
         * @param {any} [deviceFeatureWallpaper] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDeviceFeatureWallpaper: async (iosFeatureProfileId: string, organizationId: string, deviceFeatureWallpaper?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'iosFeatureProfileId' is not null or undefined
            assertParamExists('uploadDeviceFeatureWallpaper', 'iosFeatureProfileId', iosFeatureProfileId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadDeviceFeatureWallpaper', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Mdm/profiles/{organizationId}/ios/features/wallpaper/{iosFeatureProfileId}`
                .replace(`{${"iosFeatureProfileId"}}`, encodeURIComponent(String(iosFeatureProfileId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (deviceFeatureWallpaper !== undefined) { 
                localVarFormParams.append('DeviceFeatureWallpaper', deviceFeatureWallpaper as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MdmApi - functional programming interface
 * @export
 */
export const MdmApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MdmApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device description. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyChangeDescriptionAction(deviceId: string, organizationId: string, description?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyChangeDescriptionAction(deviceId, organizationId, description, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - clean windows device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyCleanWindowsDeviceAction(deviceId: string, organizationId: string, keepUserData?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyCleanWindowsDeviceAction(deviceId, organizationId, keepUserData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.DeleteDevices</li></ul>
         * @summary Deletes a device from the device management, without resetting it. 🔒: DeviceManagement.DeleteDevices
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyDeleteDevice(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyDeleteDevice(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device owner. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {DeviceOwner} [deviceOwner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyDeviceActionChangeOwnership(deviceId: string, organizationId: string, deviceOwner?: DeviceOwner, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyDeviceActionChangeOwnership(deviceId, organizationId, deviceOwner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - disable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyDisableLostModeAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyDisableLostModeAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - enable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyEnableLostModeAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyEnableLostModeAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Forwards the specified action - locateDevice, attention: lost mode has to be enabled before on ios devices. Does send a e-mail to the user who send the request. Returns position of device when found. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyLocateDeviceAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PositionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyLocateDeviceAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reboot device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyRebootAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyRebootAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - remote lock device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyRemoteLockDeviceAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyRemoteLockDeviceAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change devices name. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyRenameDeviceAction(organizationId: string, deviceId: string, name?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyRenameDeviceAction(organizationId, deviceId, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reset passcode. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyResetPasscodeAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyResetPasscodeAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - retire device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyRetireAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyRetireAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - sync device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applySyncAction(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applySyncAction(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - wipe device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {string} [macOsUnlockCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyWipeAction(deviceId: string, organizationId: string, keepUserData?: boolean, macOsUnlockCode?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceActionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyWipeAction(deviceId, organizationId, keepUserData, macOsUnlockCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign a device to a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDeviceToGroup(organizationId: string, deviceId: string, groupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDeviceToGroup(organizationId, deviceId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a ios devices. DepOnboardingSettings and the enrollmentProfileId has to be asked beforehand by: GetOnboardSettings, GetDepIosEnrollmentProfilesOfOnboardProfile Devices SerialNumbers are necessary. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} enrollmentProfileId 
         * @param {string} depOnboardingSettingsId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEnrollmentProfileToIosDevices(organizationId: string, enrollmentProfileId: string, depOnboardingSettingsId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEnrollmentProfileToIosDevices(organizationId, enrollmentProfileId, depOnboardingSettingsId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign groups to a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [configurationProfileId] 
         * @param {Array<string>} [groupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignMdmGroupConfigurationProfile(organizationId: string, configurationProfileId?: string, groupIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMdmGroupConfigurationProfile(organizationId, configurationProfileId, groupIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assigns software to a group. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<Assignment>} assignment 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSoftware(organizationId: string, assignment: Array<Assignment>, appId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSoftware(organizationId, assignment, appId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assigns a given windows autopilot profile to x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWindowsAutopilotProfileToGroup(organizationId: string, profileId: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignWindowsAutopilotProfileToGroup(organizationId, profileId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android wifi configuration profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidWifiConfigurationEntry} androidWifiConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndroidWifiConfiguration(organizationId: string, androidWifiConfigurationEntry: AndroidWifiConfigurationEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidWiFiConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndroidWifiConfiguration(organizationId, androidWifiConfigurationEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosDeviceFeatures(organizationId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosDeviceFeatures(organizationId, iosProfilesFeaturesEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosDeviceRestrictions(organizationId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosDeviceRestrictions(organizationId, iosProfilesRestrictionsEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosNonBoundOnboard(onboardSettingsId, organizationId, onboardIosNonBoundEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a standard shared app configuration policy profile (auto created when create device feature profile and enable shared is set) Can be assigned to multiple groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [mdmGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosSharedAppConfiguration(organizationId: string, mdmGroupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosSharedAppConfiguration(organizationId, mdmGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosSharedOnboard(onboardSettingsId: string, organizationId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosSharedOnboard(onboardSettingsId, organizationId, onboardSharedIosEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosUpdateConfiguration(organizationId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosUpdateConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosUpdateConfiguration(organizationId, iosUpdateConfigurationEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosUserBoundOnboard(onboardSettingsId, organizationId, onboardUserBoundIosEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios w-lan profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosWlanEntry} iosWlanEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIosWlan(organizationId: string, iosWlanEntry: IosWlanEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosWlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIosWlan(organizationId, iosWlanEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMdmFavourite(organizationId: string, favouriteEntry: FavouriteEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favourite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMdmFavourite(organizationId, favouriteEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Create a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupCreateEntry} mdmGroupCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMdmGroup(organizationId: string, mdmGroupCreateEntry: MdmGroupCreateEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MdmGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMdmGroup(organizationId, mdmGroupCreateEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsAdministration(organizationId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAdministrativeTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsAdministration(organizationId, windowsAdministrativeTemplatesEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsAutopilotProfile(organizationId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAutopilotDeploymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsAutopilotProfile(organizationId, windowsAutopilotDeploymentEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsCustomConfiguration(organizationId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsCustomConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsCustomConfiguration(organizationId, windowsCustomConfigurationEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows device restrictions. Creates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsLocalUserGroupMembership(organizationId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsLocalUserGroupMembershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsLocalUserGroupMembership(organizationId, windowsLocalUserGroupMembershipEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsSettingsCatalogue(organizationId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSettingsCatalogueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsSettingsCatalogue(organizationId, windowsSettingsCatalogueEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsShared(organizationId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSharedPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsShared(organizationId, windowsSharedPolicyEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsUpdatePolicy(organizationId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsUpdatePolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsUpdatePolicy(organizationId, windowsUpdatePolicyEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows wifi profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsWiFiEntry} windowsWiFiEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWindowsWiFi(organizationId: string, windowsWiFiEntry: WindowsWiFiEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsWiFiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWindowsWiFi(organizationId, windowsWiFiEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android device restriction configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAndroidDeviceRestriction(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAndroidDeviceRestriction(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android wifi configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAndroidWiFiConfiguration(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAndroidWiFiConfiguration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing features. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosDeviceFeatures(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosDeviceFeatures(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing restrictions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosDeviceRestrictions(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosDeviceRestrictions(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for non bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosNonBoundOnboard(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosNonBoundOnboard(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for shared devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosSharedOnboard(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosSharedOnboard(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing update behavior - schedules. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosUpdateConfiguration(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosUpdateConfiguration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for user bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosUserBoundOnboard(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosUserBoundOnboard(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios w-lan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIosWlan(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIosWlan(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [favouriteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMdmFavourite(organizationId: string, favouriteId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMdmFavourite(organizationId, favouriteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes a mdm group.
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMdmGroup(organizationId: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMdmGroup(organizationId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows administration template. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsAdministration(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsAdministration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows autopilot profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsAutopilotRestrictions(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows custom configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsCustomConfiguration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows device restriction. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsDeviceRestrictions(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings-localusergroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsLocalUserGroupMembership(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings catalogue. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsSettingsCatalogue(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows shared policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsShared(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsShared(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows update policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsUpdatePolicy(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows wlan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWindowsWlan(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWindowsWlan(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {DeviceRegistration} [registrationFilter] 
         * @param {string} [searchForNameOrSerial] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicDevices(organizationId: string, platformFilter?: PlatformType, registrationFilter?: DeviceRegistration, searchForNameOrSerial?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfBasicDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicDevices(organizationId, platformFilter, registrationFilter, searchForNameOrSerial, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm groups within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicMdmGroups(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfBasicMdmGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicMdmGroups(organizationId, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {AssignedStatus} [assignedFilter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicSoftware(organizationId: string, platformFilter?: PlatformType, assignedFilter?: AssignedStatus, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfBasicSoftwareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicSoftware(organizationId, platformFilter, assignedFilter, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all mdm favourites within a organisation. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMdmFavourites(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Favourite>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMdmFavourites(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a android device restriction configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidDeviceRestriction(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidDeviceRestriction(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidManagedStoreApp(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidManagedStoreAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidManagedStoreApp(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Android Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} hostName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidStoreLink(hostName: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidStoreLink(hostName, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns the needed token to open the Android play store. The Url to use the token is:  https://play.google.com/managed/browse?mode=SELECT&token={webToken} 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidWebToken(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidWebToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidWiFiConfiguration(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidWiFiConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidWiFiConfiguration(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all software assigned and assignable of requested mdmGroups. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignedSoftwareOfMdmGroups(organizationId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignableSoftwareResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignedSoftwareOfMdmGroups(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Retrieves a list of available ios-update-versions to post in the versionToInstall field of the ios-update-policy-profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableIosUpdateVersionsForUpdatePolicy(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableIosUpdateVersionsForUpdatePolicy(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns all available BitLocker keys for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBitlockerKeys(organizationId: string, deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BitLockerRecoveryKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBitlockerKeys(organizationId, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all ios enrollment profiles of a depOnboardSettingProfile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} depOnboardSettingsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepIosEnrollmentProfilesOfOnboardProfile(organizationId: string, depOnboardSettingsId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnboardSettingsProfileResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepIosEnrollmentProfilesOfOnboardProfile(organizationId, depOnboardSettingsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single device with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevice(deviceId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevice(deviceId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices which has been just imported and needs to be (manually) registered. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevicesWithoutRegistrationProfile(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfBasicDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevicesWithoutRegistrationProfile(organizationId, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosAppConfiguration(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesAppConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosAppConfiguration(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns the Ios-ActivationlockBypassCode for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosBypassCode(organizationId: string, deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosActivationLockBypassCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosBypassCode(organizationId, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing features. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosDeviceFeatures(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosDeviceFeatures(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing restrictions. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosDeviceRestrictions(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosDeviceRestrictions(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Ios Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosStoreLink(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosStoreLink(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing update schedules. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosUpdateConfiguration(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosUpdateConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosUpdateConfiguration(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios w-lan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIosWlan(profileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosWlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIosWlan(profileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm group with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} mdmGroupId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMdmGroup(mdmGroupId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MdmGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMdmGroup(mdmGroupId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software that is not assigned. Attention: top does not do anything here, return the default top value from mc and returns a token if there is more to take 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotAssignedBasicSoftware(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfBasicSoftwareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotAssignedBasicSoftware(organizationId, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all onboard ios-settings of a organization. Ids are necessary to create onboard profiles for a setting 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardSettings(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepOnboardSettingsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm software with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} softwareId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftware(softwareId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoftwareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftware(softwareId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows administration template. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsAdministration(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAdministrativeTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsAdministration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all windows autopilot profiles. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsAutopilotProfiles(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WindowsAutopilotDeploymentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsAutopilotProfiles(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows autopilot profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAutopilotDeploymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsAutopilotRestrictions(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows custom configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsCustomConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsCustomConfiguration(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows device restriction. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsDeviceRestrictions(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows settings-localusergroup. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsLocalUserGroupMembershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsLocalUserGroupMembership(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows settings catalogue. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSettingsCatalogueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsSettingsCatalogue(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows shared policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsShared(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSharedPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsShared(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Windows Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsStoreLink(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsStoreLink(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows update policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsUpdatePolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsUpdatePolicy(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows wlan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWindowsWlan(organizationId: string, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsWiFiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWindowsWlan(organizationId, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Accepts a .CSV file which will be forwarded via mail to support for importing. Multipart request     - csvFile FILE     - GroupIds [Guid] 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {any} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDevicesRequest(organizationId: string, groupIds?: Array<string>, csvFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDevicesRequest(organizationId, groupIds, csvFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates device-assignment of a ios enrollment profile. Needed when wanting to delete a enrollment profile where devices are still assigned to. Needs old enrollmentProfile Id and new profile Id. Will auto transfer all devices to new profile. 🔒: AixConcept.Only
         * @param {string} oldProfileId 
         * @param {string} newProfileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId: string, newProfileId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId, newProfileId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes groups from a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {string} [configurationProfileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeConfigurationProfileOfMdmGroup(organizationId: string, groupIds?: Array<string>, configurationProfileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeConfigurationProfileOfMdmGroup(organizationId, groupIds, configurationProfileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Removes a enrollment profile from a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be removed from that group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes a given windows autopilot profile from x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWindowsAutopilotProfileFromGroup(organizationId: string, profileId: string, groupId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWindowsAutopilotProfileFromGroup(organizationId, profileId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends PPGK-Inquiry email with all attachments uploaded before. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<PPGKInquiryEntry>} pPGKInquiryEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPPGKInquiry(organizationId: string, pPGKInquiryEntry: Array<PPGKInquiryEntry>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPPGKInquiry(organizationId, pPGKInquiryEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Sends Software-Inquiry email with all attachments uploaded before. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<SoftwareInquiryEmailEntry>} softwareInquiryEmailEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSoftwareInquiry(organizationId: string, softwareInquiryEmailEntry: Array<SoftwareInquiryEmailEntry>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSoftwareInquiry(organizationId, softwareInquiryEmailEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} newEnrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchDevicesEnrollmentProfile(newEnrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchDevicesEnrollmentProfile(newEnrollmentProfileId, organizationId, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncSoftwareStores(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncSoftwareStores(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Unassign a device from a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignDeviceFromGroup(organizationId: string, deviceId: string, groupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignDeviceFromGroup(organizationId, deviceId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosDeviceFeatures(organizationId: string, profileId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosDeviceFeatures(organizationId, profileId, iosProfilesFeaturesEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosDeviceRestrictions(organizationId: string, profileId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosProfilesRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosDeviceRestrictions(organizationId, profileId, iosProfilesRestrictionsEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosNonBoundOnboard(onboardSettingsId, organizationId, profileId, onboardIosNonBoundEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosSharedOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosSharedOnboard(onboardSettingsId, organizationId, profileId, onboardSharedIosEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosUpdateConfiguration(organizationId: string, profileId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IosUpdateConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosUpdateConfiguration(organizationId, profileId, iosUpdateConfigurationEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardSettingsProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIosUserBoundOnboard(onboardSettingsId, organizationId, profileId, onboardUserBoundIosEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} favouriteId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMdmFavourite(organizationId: string, favouriteId: string, favouriteEntry: FavouriteEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favourite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMdmFavourite(organizationId, favouriteId, favouriteEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Update a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupUpdateEntry} mdmGroupUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMdmGroup(organizationId: string, mdmGroupUpdateEntry: MdmGroupUpdateEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MdmGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMdmGroup(organizationId, mdmGroupUpdateEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsAdministration(organizationId: string, profileId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAdministrativeTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsAdministration(organizationId, profileId, windowsAdministrativeTemplatesEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsAutopilotProfile(organizationId: string, profileId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsAutopilotDeploymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsAutopilotProfile(organizationId, profileId, windowsAutopilotDeploymentEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsCustomConfiguration(organizationId: string, profileId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsCustomConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsCustomConfiguration(organizationId, profileId, windowsCustomConfigurationEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, profileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsDeviceRestrictionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, profileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsLocalUserGroupMembership(organizationId: string, profileId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsLocalUserGroupMembershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsLocalUserGroupMembership(organizationId, profileId, windowsLocalUserGroupMembershipEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsSettingsCatalogue(organizationId: string, profileId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSettingsCatalogueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsSettingsCatalogue(organizationId, profileId, windowsSettingsCatalogueEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsShared(organizationId: string, profileId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsSharedPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsShared(organizationId, profileId, windowsSharedPolicyEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWindowsUpdatePolicy(organizationId: string, profileId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WindowsUpdatePolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWindowsUpdatePolicy(organizationId, profileId, windowsUpdatePolicyEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} iosFeatureProfileId 
         * @param {string} organizationId 
         * @param {any} [deviceFeatureWallpaper] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDeviceFeatureWallpaper(iosFeatureProfileId: string, organizationId: string, deviceFeatureWallpaper?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MimeContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDeviceFeatureWallpaper(iosFeatureProfileId, organizationId, deviceFeatureWallpaper, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MdmApi - factory interface
 * @export
 */
export const MdmApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MdmApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device description. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyChangeDescriptionAction(deviceId: string, organizationId: string, description?: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyChangeDescriptionAction(deviceId, organizationId, description, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - clean windows device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCleanWindowsDeviceAction(deviceId: string, organizationId: string, keepUserData?: boolean, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyCleanWindowsDeviceAction(deviceId, organizationId, keepUserData, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.DeleteDevices</li></ul>
         * @summary Deletes a device from the device management, without resetting it. 🔒: DeviceManagement.DeleteDevices
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDeleteDevice(deviceId: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.applyDeleteDevice(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change device owner. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {DeviceOwner} [deviceOwner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDeviceActionChangeOwnership(deviceId: string, organizationId: string, deviceOwner?: DeviceOwner, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyDeviceActionChangeOwnership(deviceId, organizationId, deviceOwner, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - disable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDisableLostModeAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyDisableLostModeAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - enable lost mode of device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyEnableLostModeAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyEnableLostModeAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Forwards the specified action - locateDevice, attention: lost mode has to be enabled before on ios devices. Does send a e-mail to the user who send the request. Returns position of device when found. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLocateDeviceAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<PositionResponse>> {
            return localVarFp.applyLocateDeviceAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reboot device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRebootAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyRebootAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - remote lock device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRemoteLockDeviceAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyRemoteLockDeviceAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - change devices name. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRenameDeviceAction(organizationId: string, deviceId: string, name?: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyRenameDeviceAction(organizationId, deviceId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - reset passcode. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyResetPasscodeAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyResetPasscodeAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - retire device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyRetireAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyRetireAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - sync device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applySyncAction(deviceId: string, organizationId: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applySyncAction(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Forwards the specified action - wipe device. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {boolean} [keepUserData] 
         * @param {string} [macOsUnlockCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWipeAction(deviceId: string, organizationId: string, keepUserData?: boolean, macOsUnlockCode?: string, options?: any): AxiosPromise<Array<DeviceActionResponse>> {
            return localVarFp.applyWipeAction(deviceId, organizationId, keepUserData, macOsUnlockCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign a device to a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDeviceToGroup(organizationId: string, deviceId: string, groupId: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignDeviceToGroup(organizationId, deviceId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a ios devices. DepOnboardingSettings and the enrollmentProfileId has to be asked beforehand by: GetOnboardSettings, GetDepIosEnrollmentProfilesOfOnboardProfile Devices SerialNumbers are necessary. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} enrollmentProfileId 
         * @param {string} depOnboardingSettingsId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEnrollmentProfileToIosDevices(organizationId: string, enrollmentProfileId: string, depOnboardingSettingsId: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.assignEnrollmentProfileToIosDevices(organizationId, enrollmentProfileId, depOnboardingSettingsId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assign groups to a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [configurationProfileId] 
         * @param {Array<string>} [groupIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMdmGroupConfigurationProfile(organizationId: string, configurationProfileId?: string, groupIds?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.assignMdmGroupConfigurationProfile(organizationId, configurationProfileId, groupIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assigns software to a group. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<Assignment>} assignment 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSoftware(organizationId: string, assignment: Array<Assignment>, appId?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.assignSoftware(organizationId, assignment, appId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Assigns a given windows autopilot profile to x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWindowsAutopilotProfileToGroup(organizationId: string, profileId: string, groupId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignWindowsAutopilotProfileToGroup(organizationId, profileId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, options?: any): AxiosPromise<AndroidDeviceRestrictionsResponse> {
            return localVarFp.createAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a android wifi configuration profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidWifiConfigurationEntry} androidWifiConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndroidWifiConfiguration(organizationId: string, androidWifiConfigurationEntry: AndroidWifiConfigurationEntry, options?: any): AxiosPromise<AndroidWiFiConfigurationResponse> {
            return localVarFp.createAndroidWifiConfiguration(organizationId, androidWifiConfigurationEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosDeviceFeatures(organizationId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any): AxiosPromise<IosProfilesFeaturesResponse> {
            return localVarFp.createIosDeviceFeatures(organizationId, iosProfilesFeaturesEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosDeviceRestrictions(organizationId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any): AxiosPromise<IosProfilesRestrictionsResponse> {
            return localVarFp.createIosDeviceRestrictions(organizationId, iosProfilesRestrictionsEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.createIosNonBoundOnboard(onboardSettingsId, organizationId, onboardIosNonBoundEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a standard shared app configuration policy profile (auto created when create device feature profile and enable shared is set) Can be assigned to multiple groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [mdmGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosSharedAppConfiguration(organizationId: string, mdmGroupId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.createIosSharedAppConfiguration(organizationId, mdmGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosSharedOnboard(onboardSettingsId: string, organizationId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.createIosSharedOnboard(onboardSettingsId, organizationId, onboardSharedIosEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosUpdateConfiguration(organizationId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any): AxiosPromise<IosUpdateConfigurationResponse> {
            return localVarFp.createIosUpdateConfiguration(organizationId, iosUpdateConfigurationEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.createIosUserBoundOnboard(onboardSettingsId, organizationId, onboardUserBoundIosEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a ios w-lan profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {IosWlanEntry} iosWlanEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIosWlan(organizationId: string, iosWlanEntry: IosWlanEntry, options?: any): AxiosPromise<IosWlanResponse> {
            return localVarFp.createIosWlan(organizationId, iosWlanEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMdmFavourite(organizationId: string, favouriteEntry: FavouriteEntry, options?: any): AxiosPromise<Favourite> {
            return localVarFp.createMdmFavourite(organizationId, favouriteEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Create a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupCreateEntry} mdmGroupCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMdmGroup(organizationId: string, mdmGroupCreateEntry: MdmGroupCreateEntry, options?: any): AxiosPromise<MdmGroupResponse> {
            return localVarFp.createMdmGroup(organizationId, mdmGroupCreateEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsAdministration(organizationId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any): AxiosPromise<WindowsAdministrativeTemplatesResponse> {
            return localVarFp.createWindowsAdministration(organizationId, windowsAdministrativeTemplatesEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsAutopilotProfile(organizationId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any): AxiosPromise<WindowsAutopilotDeploymentResponse> {
            return localVarFp.createWindowsAutopilotProfile(organizationId, windowsAutopilotDeploymentEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsCustomConfiguration(organizationId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any): AxiosPromise<WindowsCustomConfigurationResponse> {
            return localVarFp.createWindowsCustomConfiguration(organizationId, windowsCustomConfigurationEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows device restrictions. Creates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, options?: any): AxiosPromise<WindowsDeviceRestrictionsResponse> {
            return localVarFp.createWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsLocalUserGroupMembership(organizationId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any): AxiosPromise<WindowsLocalUserGroupMembershipResponse> {
            return localVarFp.createWindowsLocalUserGroupMembership(organizationId, windowsLocalUserGroupMembershipEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsSettingsCatalogue(organizationId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any): AxiosPromise<WindowsSettingsCatalogueResponse> {
            return localVarFp.createWindowsSettingsCatalogue(organizationId, windowsSettingsCatalogueEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsShared(organizationId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any): AxiosPromise<WindowsSharedPolicyResponse> {
            return localVarFp.createWindowsShared(organizationId, windowsSharedPolicyEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsUpdatePolicy(organizationId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any): AxiosPromise<WindowsUpdatePolicyResponse> {
            return localVarFp.createWindowsUpdatePolicy(organizationId, windowsUpdatePolicyEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows wifi profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsWiFiEntry} windowsWiFiEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWindowsWiFi(organizationId: string, windowsWiFiEntry: WindowsWiFiEntry, options?: any): AxiosPromise<WindowsWiFiResponse> {
            return localVarFp.createWindowsWiFi(organizationId, windowsWiFiEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android device restriction configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAndroidDeviceRestriction(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAndroidDeviceRestriction(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a android wifi configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAndroidWiFiConfiguration(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAndroidWiFiConfiguration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing features. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosDeviceFeatures(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosDeviceFeatures(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing restrictions. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosDeviceRestrictions(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosDeviceRestrictions(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for non bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosNonBoundOnboard(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosNonBoundOnboard(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for shared devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosSharedOnboard(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosSharedOnboard(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios configuration profile overall containing update behavior - schedules. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosUpdateConfiguration(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosUpdateConfiguration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios registration profile for user bound devices. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosUserBoundOnboard(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosUserBoundOnboard(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a ios w-lan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIosWlan(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIosWlan(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [favouriteId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMdmFavourite(organizationId: string, favouriteId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMdmFavourite(organizationId, favouriteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a mdm group.
         * @param {string} organizationId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMdmGroup(organizationId: string, groupId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMdmGroup(organizationId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows administration template. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsAdministration(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsAdministration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows autopilot profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsAutopilotRestrictions(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows custom configuration. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsCustomConfiguration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows device restriction. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsDeviceRestrictions(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings-localusergroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsLocalUserGroupMembership(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows settings catalogue. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsSettingsCatalogue(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a windows shared policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsShared(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsShared(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows update policy. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsUpdatePolicy(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a specific windows wlan profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWindowsWlan(organizationId: string, profileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWindowsWlan(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {DeviceRegistration} [registrationFilter] 
         * @param {string} [searchForNameOrSerial] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicDevices(organizationId: string, platformFilter?: PlatformType, registrationFilter?: DeviceRegistration, searchForNameOrSerial?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfBasicDeviceResponse> {
            return localVarFp.getAllBasicDevices(organizationId, platformFilter, registrationFilter, searchForNameOrSerial, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm groups within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicMdmGroups(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfBasicMdmGroupResponse> {
            return localVarFp.getAllBasicMdmGroups(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software within a organization. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {PlatformType} [platformFilter] 
         * @param {AssignedStatus} [assignedFilter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicSoftware(organizationId: string, platformFilter?: PlatformType, assignedFilter?: AssignedStatus, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfBasicSoftwareResponse> {
            return localVarFp.getAllBasicSoftware(organizationId, platformFilter, assignedFilter, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all mdm favourites within a organisation. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMdmFavourites(organizationId: string, options?: any): AxiosPromise<Array<Favourite>> {
            return localVarFp.getAllMdmFavourites(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a android device restriction configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidDeviceRestriction(profileId: string, organizationId: string, options?: any): AxiosPromise<AndroidDeviceRestrictionsResponse> {
            return localVarFp.getAndroidDeviceRestriction(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidManagedStoreApp(profileId: string, organizationId: string, options?: any): AxiosPromise<AndroidManagedStoreAppResponse> {
            return localVarFp.getAndroidManagedStoreApp(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Android Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} hostName 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidStoreLink(hostName: string, organizationId: string, options?: any): AxiosPromise<StoreLinkResponse> {
            return localVarFp.getAndroidStoreLink(hostName, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns the needed token to open the Android play store. The Url to use the token is:  https://play.google.com/managed/browse?mode=SELECT&token={webToken} 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWebToken(organizationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAndroidWebToken(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWiFiConfiguration(profileId: string, organizationId: string, options?: any): AxiosPromise<AndroidWiFiConfigurationResponse> {
            return localVarFp.getAndroidWiFiConfiguration(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all software assigned and assignable of requested mdmGroups. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedSoftwareOfMdmGroups(organizationId: string, requestBody: Array<string>, options?: any): AxiosPromise<Array<AssignableSoftwareResponse>> {
            return localVarFp.getAssignedSoftwareOfMdmGroups(organizationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Retrieves a list of available ios-update-versions to post in the versionToInstall field of the ios-update-policy-profile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableIosUpdateVersionsForUpdatePolicy(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableIosUpdateVersionsForUpdatePolicy(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns all available BitLocker keys for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitlockerKeys(organizationId: string, deviceId: string, options?: any): AxiosPromise<BitLockerRecoveryKeyResponse> {
            return localVarFp.getBitlockerKeys(organizationId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all ios enrollment profiles of a depOnboardSettingProfile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} depOnboardSettingsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepIosEnrollmentProfilesOfOnboardProfile(organizationId: string, depOnboardSettingsId: string, options?: any): AxiosPromise<Array<OnboardSettingsProfileResponse>> {
            return localVarFp.getDepIosEnrollmentProfilesOfOnboardProfile(organizationId, depOnboardSettingsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single device with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} deviceId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice(deviceId: string, organizationId: string, options?: any): AxiosPromise<DeviceResponse> {
            return localVarFp.getDevice(deviceId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all devices which has been just imported and needs to be (manually) registered. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesWithoutRegistrationProfile(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfBasicDeviceResponse> {
            return localVarFp.getDevicesWithoutRegistrationProfile(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosAppConfiguration(profileId: string, organizationId: string, options?: any): AxiosPromise<IosProfilesAppConfigurationResponse> {
            return localVarFp.getIosAppConfiguration(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
         * @summary Returns the Ios-ActivationlockBypassCode for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosBypassCode(organizationId: string, deviceId: string, options?: any): AxiosPromise<IosActivationLockBypassCodeResponse> {
            return localVarFp.getIosBypassCode(organizationId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing features. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosDeviceFeatures(profileId: string, organizationId: string, options?: any): AxiosPromise<IosProfilesFeaturesResponse> {
            return localVarFp.getIosDeviceFeatures(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing restrictions. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosDeviceRestrictions(profileId: string, organizationId: string, options?: any): AxiosPromise<IosProfilesRestrictionsResponse> {
            return localVarFp.getIosDeviceRestrictions(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Ios Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosStoreLink(organizationId: string, options?: any): AxiosPromise<StoreLinkResponse> {
            return localVarFp.getIosStoreLink(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios configuration profile of overall containing update schedules. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosUpdateConfiguration(profileId: string, organizationId: string, options?: any): AxiosPromise<IosUpdateConfigurationResponse> {
            return localVarFp.getIosUpdateConfiguration(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a ios w-lan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} profileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIosWlan(profileId: string, organizationId: string, options?: any): AxiosPromise<IosWlanResponse> {
            return localVarFp.getIosWlan(profileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm group with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} mdmGroupId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMdmGroup(mdmGroupId: string, organizationId: string, options?: any): AxiosPromise<MdmGroupResponse> {
            return localVarFp.getMdmGroup(mdmGroupId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns all mdm software that is not assigned. Attention: top does not do anything here, return the default top value from mc and returns a token if there is more to take 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotAssignedBasicSoftware(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfBasicSoftwareResponse> {
            return localVarFp.getNotAssignedBasicSoftware(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all onboard ios-settings of a organization. Ids are necessary to create onboard profiles for a setting 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardSettings(organizationId: string, options?: any): AxiosPromise<Array<DepOnboardSettingsResponse>> {
            return localVarFp.getOnboardSettings(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Returns a single mdm software with specific details. 🔒: DeviceManagement.ShowModule
         * @param {string} softwareId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftware(softwareId: string, organizationId: string, options?: any): AxiosPromise<SoftwareResponse> {
            return localVarFp.getSoftware(softwareId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows administration template. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAdministration(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsAdministrativeTemplatesResponse> {
            return localVarFp.getWindowsAdministration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets all windows autopilot profiles. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAutopilotProfiles(organizationId: string, options?: any): AxiosPromise<Array<WindowsAutopilotDeploymentResponse>> {
            return localVarFp.getWindowsAutopilotProfiles(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows autopilot profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any): AxiosPromise<WindowsAutopilotDeploymentResponse> {
            return localVarFp.getWindowsAutopilotRestrictions(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows custom configuration. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsCustomConfigurationResponse> {
            return localVarFp.getWindowsCustomConfiguration(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows device restriction. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsDeviceRestrictionsResponse> {
            return localVarFp.getWindowsDeviceRestrictions(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get windows settings-localusergroup. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsLocalUserGroupMembershipResponse> {
            return localVarFp.getWindowsLocalUserGroupMembership(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows settings catalogue. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsSettingsCatalogueResponse> {
            return localVarFp.getWindowsSettingsCatalogue(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows shared policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsShared(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsSharedPolicyResponse> {
            return localVarFp.getWindowsShared(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets Windows Store Link 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsStoreLink(organizationId: string, options?: any): AxiosPromise<StoreLinkResponse> {
            return localVarFp.getWindowsStoreLink(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Gets a windows update policy. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsUpdatePolicyResponse> {
            return localVarFp.getWindowsUpdatePolicy(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Get a windows wlan profile. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWindowsWlan(organizationId: string, profileId?: string, options?: any): AxiosPromise<WindowsWiFiResponse> {
            return localVarFp.getWindowsWlan(organizationId, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Accepts a .CSV file which will be forwarded via mail to support for importing. Multipart request     - csvFile FILE     - GroupIds [Guid] 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {any} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDevicesRequest(organizationId: string, groupIds?: Array<string>, csvFile?: any, options?: any): AxiosPromise<string> {
            return localVarFp.importDevicesRequest(organizationId, groupIds, csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates device-assignment of a ios enrollment profile. Needed when wanting to delete a enrollment profile where devices are still assigned to. Needs old enrollmentProfile Id and new profile Id. Will auto transfer all devices to new profile. 🔒: AixConcept.Only
         * @param {string} oldProfileId 
         * @param {string} newProfileId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId: string, newProfileId: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId, newProfileId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes groups from a configurationProfile. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [groupIds] 
         * @param {string} [configurationProfileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeConfigurationProfileOfMdmGroup(organizationId: string, groupIds?: Array<string>, configurationProfileId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeConfigurationProfileOfMdmGroup(organizationId, groupIds, configurationProfileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Removes a enrollment profile from a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be removed from that group. 🔒: DeviceManagement.ShowModule
         * @param {string} enrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes a given windows autopilot profile from x groups 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {string} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWindowsAutopilotProfileFromGroup(organizationId: string, profileId: string, groupId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeWindowsAutopilotProfileFromGroup(organizationId, profileId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Sends PPGK-Inquiry email with all attachments uploaded before. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<PPGKInquiryEntry>} pPGKInquiryEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPPGKInquiry(organizationId: string, pPGKInquiryEntry: Array<PPGKInquiryEntry>, options?: any): AxiosPromise<void> {
            return localVarFp.sendPPGKInquiry(organizationId, pPGKInquiryEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Sends Software-Inquiry email with all attachments uploaded before. 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {Array<SoftwareInquiryEmailEntry>} softwareInquiryEmailEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSoftwareInquiry(organizationId: string, softwareInquiryEmailEntry: Array<SoftwareInquiryEmailEntry>, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendSoftwareInquiry(organizationId, softwareInquiryEmailEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
         * @param {string} newEnrollmentProfileId 
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchDevicesEnrollmentProfile(newEnrollmentProfileId: string, organizationId: string, deviceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.switchDevicesEnrollmentProfile(newEnrollmentProfileId, organizationId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncSoftwareStores(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.syncSoftwareStores(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Unassign a device from a group. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} deviceId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignDeviceFromGroup(organizationId: string, deviceId: string, groupId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unassignDeviceFromGroup(organizationId, deviceId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, profileId?: string, options?: any): AxiosPromise<AndroidDeviceRestrictionsResponse> {
            return localVarFp.updateAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosDeviceFeatures(organizationId: string, profileId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any): AxiosPromise<IosProfilesFeaturesResponse> {
            return localVarFp.updateIosDeviceFeatures(organizationId, profileId, iosProfilesFeaturesEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosDeviceRestrictions(organizationId: string, profileId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any): AxiosPromise<IosProfilesRestrictionsResponse> {
            return localVarFp.updateIosDeviceRestrictions(organizationId, profileId, iosProfilesRestrictionsEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.updateIosNonBoundOnboard(onboardSettingsId, organizationId, profileId, onboardIosNonBoundEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosSharedOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.updateIosSharedOnboard(onboardSettingsId, organizationId, profileId, onboardSharedIosEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosUpdateConfiguration(organizationId: string, profileId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any): AxiosPromise<IosUpdateConfigurationResponse> {
            return localVarFp.updateIosUpdateConfiguration(organizationId, profileId, iosUpdateConfigurationEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
         * @param {string} onboardSettingsId 
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any): AxiosPromise<OnboardSettingsProfileResponse> {
            return localVarFp.updateIosUserBoundOnboard(onboardSettingsId, organizationId, profileId, onboardUserBoundIosEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a mdm-favourite. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} favouriteId 
         * @param {FavouriteEntry} favouriteEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMdmFavourite(organizationId: string, favouriteId: string, favouriteEntry: FavouriteEntry, options?: any): AxiosPromise<Favourite> {
            return localVarFp.updateMdmFavourite(organizationId, favouriteId, favouriteEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Update a MdmGroup. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {MdmGroupUpdateEntry} mdmGroupUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMdmGroup(organizationId: string, mdmGroupUpdateEntry: MdmGroupUpdateEntry, options?: any): AxiosPromise<MdmGroupResponse> {
            return localVarFp.updateMdmGroup(organizationId, mdmGroupUpdateEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsAdministration(organizationId: string, profileId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any): AxiosPromise<WindowsAdministrativeTemplatesResponse> {
            return localVarFp.updateWindowsAdministration(organizationId, profileId, windowsAdministrativeTemplatesEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsAutopilotProfile(organizationId: string, profileId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any): AxiosPromise<WindowsAutopilotDeploymentResponse> {
            return localVarFp.updateWindowsAutopilotProfile(organizationId, profileId, windowsAutopilotDeploymentEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsCustomConfiguration(organizationId: string, profileId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any): AxiosPromise<WindowsCustomConfigurationResponse> {
            return localVarFp.updateWindowsCustomConfiguration(organizationId, profileId, windowsCustomConfigurationEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
         * @param {string} [profileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, profileId?: string, options?: any): AxiosPromise<WindowsDeviceRestrictionsResponse> {
            return localVarFp.updateWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsLocalUserGroupMembership(organizationId: string, profileId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any): AxiosPromise<WindowsLocalUserGroupMembershipResponse> {
            return localVarFp.updateWindowsLocalUserGroupMembership(organizationId, profileId, windowsLocalUserGroupMembershipEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsSettingsCatalogue(organizationId: string, profileId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any): AxiosPromise<WindowsSettingsCatalogueResponse> {
            return localVarFp.updateWindowsSettingsCatalogue(organizationId, profileId, windowsSettingsCatalogueEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsShared(organizationId: string, profileId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any): AxiosPromise<WindowsSharedPolicyResponse> {
            return localVarFp.updateWindowsShared(organizationId, profileId, windowsSharedPolicyEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} profileId 
         * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWindowsUpdatePolicy(organizationId: string, profileId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any): AxiosPromise<WindowsUpdatePolicyResponse> {
            return localVarFp.updateWindowsUpdatePolicy(organizationId, profileId, windowsUpdatePolicyEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} iosFeatureProfileId 
         * @param {string} organizationId 
         * @param {any} [deviceFeatureWallpaper] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDeviceFeatureWallpaper(iosFeatureProfileId: string, organizationId: string, deviceFeatureWallpaper?: any, options?: any): AxiosPromise<MimeContent> {
            return localVarFp.uploadDeviceFeatureWallpaper(iosFeatureProfileId, organizationId, deviceFeatureWallpaper, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MdmApi - object-oriented interface
 * @export
 * @class MdmApi
 * @extends {BaseAPI}
 */
export class MdmApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - change device description. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {string} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyChangeDescriptionAction(deviceId: string, organizationId: string, description?: string, options?: any) {
        return MdmApiFp(this.configuration).applyChangeDescriptionAction(deviceId, organizationId, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - clean windows device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {boolean} [keepUserData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyCleanWindowsDeviceAction(deviceId: string, organizationId: string, keepUserData?: boolean, options?: any) {
        return MdmApiFp(this.configuration).applyCleanWindowsDeviceAction(deviceId, organizationId, keepUserData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.DeleteDevices</li></ul>
     * @summary Deletes a device from the device management, without resetting it. 🔒: DeviceManagement.DeleteDevices
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyDeleteDevice(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyDeleteDevice(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - change device owner. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {DeviceOwner} [deviceOwner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyDeviceActionChangeOwnership(deviceId: string, organizationId: string, deviceOwner?: DeviceOwner, options?: any) {
        return MdmApiFp(this.configuration).applyDeviceActionChangeOwnership(deviceId, organizationId, deviceOwner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - disable lost mode of device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyDisableLostModeAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyDisableLostModeAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - enable lost mode of device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyEnableLostModeAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyEnableLostModeAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
     * @summary Forwards the specified action - locateDevice, attention: lost mode has to be enabled before on ios devices. Does send a e-mail to the user who send the request. Returns position of device when found. 🔒: DeviceManagement.ShowSensibleInfo
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyLocateDeviceAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyLocateDeviceAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - reboot device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyRebootAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyRebootAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - remote lock device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyRemoteLockDeviceAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyRemoteLockDeviceAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - change devices name. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyRenameDeviceAction(organizationId: string, deviceId: string, name?: string, options?: any) {
        return MdmApiFp(this.configuration).applyRenameDeviceAction(organizationId, deviceId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - reset passcode. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyResetPasscodeAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyResetPasscodeAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - retire device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyRetireAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applyRetireAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - sync device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applySyncAction(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).applySyncAction(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Forwards the specified action - wipe device. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {boolean} [keepUserData] 
     * @param {string} [macOsUnlockCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public applyWipeAction(deviceId: string, organizationId: string, keepUserData?: boolean, macOsUnlockCode?: string, options?: any) {
        return MdmApiFp(this.configuration).applyWipeAction(deviceId, organizationId, keepUserData, macOsUnlockCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Assign a device to a group. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignDeviceToGroup(organizationId: string, deviceId: string, groupId: string, options?: any) {
        return MdmApiFp(this.configuration).assignDeviceToGroup(organizationId, deviceId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Assign a enrollment profile to a ios devices. DepOnboardingSettings and the enrollmentProfileId has to be asked beforehand by: GetOnboardSettings, GetDepIosEnrollmentProfilesOfOnboardProfile Devices SerialNumbers are necessary. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} enrollmentProfileId 
     * @param {string} depOnboardingSettingsId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignEnrollmentProfileToIosDevices(organizationId: string, enrollmentProfileId: string, depOnboardingSettingsId: string, requestBody: Array<string>, options?: any) {
        return MdmApiFp(this.configuration).assignEnrollmentProfileToIosDevices(organizationId, enrollmentProfileId, depOnboardingSettingsId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
     * @param {string} enrollmentProfileId 
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any) {
        return MdmApiFp(this.configuration).assignEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Assign groups to a configurationProfile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [configurationProfileId] 
     * @param {Array<string>} [groupIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignMdmGroupConfigurationProfile(organizationId: string, configurationProfileId?: string, groupIds?: Array<string>, options?: any) {
        return MdmApiFp(this.configuration).assignMdmGroupConfigurationProfile(organizationId, configurationProfileId, groupIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Assigns software to a group. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {Array<Assignment>} assignment 
     * @param {string} [appId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignSoftware(organizationId: string, assignment: Array<Assignment>, appId?: string, options?: any) {
        return MdmApiFp(this.configuration).assignSoftware(organizationId, assignment, appId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Assigns a given windows autopilot profile to x groups 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public assignWindowsAutopilotProfileToGroup(organizationId: string, profileId: string, groupId?: string, options?: any) {
        return MdmApiFp(this.configuration).assignWindowsAutopilotProfileToGroup(organizationId, profileId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, options?: any) {
        return MdmApiFp(this.configuration).createAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a android wifi configuration profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {AndroidWifiConfigurationEntry} androidWifiConfigurationEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createAndroidWifiConfiguration(organizationId: string, androidWifiConfigurationEntry: AndroidWifiConfigurationEntry, options?: any) {
        return MdmApiFp(this.configuration).createAndroidWifiConfiguration(organizationId, androidWifiConfigurationEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosDeviceFeatures(organizationId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosDeviceFeatures(organizationId, iosProfilesFeaturesEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosDeviceRestrictions(organizationId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosDeviceRestrictions(organizationId, iosProfilesRestrictionsEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosNonBoundOnboard(onboardSettingsId, organizationId, onboardIosNonBoundEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a standard shared app configuration policy profile (auto created when create device feature profile and enable shared is set) Can be assigned to multiple groups 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [mdmGroupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosSharedAppConfiguration(organizationId: string, mdmGroupId?: string, options?: any) {
        return MdmApiFp(this.configuration).createIosSharedAppConfiguration(organizationId, mdmGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosSharedOnboard(onboardSettingsId: string, organizationId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosSharedOnboard(onboardSettingsId, organizationId, onboardSharedIosEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosUpdateConfiguration(organizationId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosUpdateConfiguration(organizationId, iosUpdateConfigurationEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosUserBoundOnboard(onboardSettingsId, organizationId, onboardUserBoundIosEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a ios w-lan profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {IosWlanEntry} iosWlanEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createIosWlan(organizationId: string, iosWlanEntry: IosWlanEntry, options?: any) {
        return MdmApiFp(this.configuration).createIosWlan(organizationId, iosWlanEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a mdm-favourite. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {FavouriteEntry} favouriteEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createMdmFavourite(organizationId: string, favouriteEntry: FavouriteEntry, options?: any) {
        return MdmApiFp(this.configuration).createMdmFavourite(organizationId, favouriteEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Create a MdmGroup. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {MdmGroupCreateEntry} mdmGroupCreateEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createMdmGroup(organizationId: string, mdmGroupCreateEntry: MdmGroupCreateEntry, options?: any) {
        return MdmApiFp(this.configuration).createMdmGroup(organizationId, mdmGroupCreateEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsAdministration(organizationId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsAdministration(organizationId, windowsAdministrativeTemplatesEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsAutopilotProfile(organizationId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsAutopilotProfile(organizationId, windowsAutopilotDeploymentEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsCustomConfiguration(organizationId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsCustomConfiguration(organizationId, windowsCustomConfigurationEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows device restrictions. Creates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsLocalUserGroupMembership(organizationId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsLocalUserGroupMembership(organizationId, windowsLocalUserGroupMembershipEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsSettingsCatalogue(organizationId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsSettingsCatalogue(organizationId, windowsSettingsCatalogueEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsShared(organizationId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsShared(organizationId, windowsSharedPolicyEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsUpdatePolicy(organizationId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsUpdatePolicy(organizationId, windowsUpdatePolicyEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows wifi profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsWiFiEntry} windowsWiFiEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public createWindowsWiFi(organizationId: string, windowsWiFiEntry: WindowsWiFiEntry, options?: any) {
        return MdmApiFp(this.configuration).createWindowsWiFi(organizationId, windowsWiFiEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a android device restriction configuration. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteAndroidDeviceRestriction(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteAndroidDeviceRestriction(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a android wifi configuration. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteAndroidWiFiConfiguration(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteAndroidWiFiConfiguration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios configuration profile overall containing features. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosDeviceFeatures(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosDeviceFeatures(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios configuration profile overall containing restrictions. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosDeviceRestrictions(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosDeviceRestrictions(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios registration profile for non bound devices. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosNonBoundOnboard(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosNonBoundOnboard(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios registration profile for shared devices. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosSharedOnboard(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosSharedOnboard(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios configuration profile overall containing update behavior - schedules. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosUpdateConfiguration(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosUpdateConfiguration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios registration profile for user bound devices. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosUserBoundOnboard(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosUserBoundOnboard(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a ios w-lan profile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteIosWlan(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteIosWlan(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a mdm-favourite. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [favouriteId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteMdmFavourite(organizationId: string, favouriteId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteMdmFavourite(organizationId, favouriteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a mdm group.
     * @param {string} organizationId 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteMdmGroup(organizationId: string, groupId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteMdmGroup(organizationId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a specific windows administration template. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsAdministration(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsAdministration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a windows autopilot profile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsAutopilotRestrictions(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a windows custom configuration. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsCustomConfiguration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a windows device restriction. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsDeviceRestrictions(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a specific windows settings-localusergroup. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsLocalUserGroupMembership(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a specific windows settings catalogue. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsSettingsCatalogue(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a windows shared policy. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsShared(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsShared(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a specific windows update policy. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsUpdatePolicy(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a specific windows wlan profile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public deleteWindowsWlan(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).deleteWindowsWlan(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all devices within a organization. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {PlatformType} [platformFilter] 
     * @param {DeviceRegistration} [registrationFilter] 
     * @param {string} [searchForNameOrSerial] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAllBasicDevices(organizationId: string, platformFilter?: PlatformType, registrationFilter?: DeviceRegistration, searchForNameOrSerial?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return MdmApiFp(this.configuration).getAllBasicDevices(organizationId, platformFilter, registrationFilter, searchForNameOrSerial, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all mdm groups within a organization. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAllBasicMdmGroups(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return MdmApiFp(this.configuration).getAllBasicMdmGroups(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all mdm software within a organization. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {PlatformType} [platformFilter] 
     * @param {AssignedStatus} [assignedFilter] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAllBasicSoftware(organizationId: string, platformFilter?: PlatformType, assignedFilter?: AssignedStatus, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return MdmApiFp(this.configuration).getAllBasicSoftware(organizationId, platformFilter, assignedFilter, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Returns all mdm favourites within a organisation. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAllMdmFavourites(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAllMdmFavourites(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a android device restriction configuration. 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAndroidDeviceRestriction(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAndroidDeviceRestriction(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAndroidManagedStoreApp(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAndroidManagedStoreApp(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets Android Store Link 🔒: DeviceManagement.ShowModule
     * @param {string} hostName 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAndroidStoreLink(hostName: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAndroidStoreLink(hostName, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns the needed token to open the Android play store. The Url to use the token is:  https://play.google.com/managed/browse?mode=SELECT&token={webToken} 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAndroidWebToken(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAndroidWebToken(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAndroidWiFiConfiguration(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAndroidWiFiConfiguration(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all software assigned and assignable of requested mdmGroups. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAssignedSoftwareOfMdmGroups(organizationId: string, requestBody: Array<string>, options?: any) {
        return MdmApiFp(this.configuration).getAssignedSoftwareOfMdmGroups(organizationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Retrieves a list of available ios-update-versions to post in the versionToInstall field of the ios-update-policy-profile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getAvailableIosUpdateVersionsForUpdatePolicy(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getAvailableIosUpdateVersionsForUpdatePolicy(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
     * @summary Returns all available BitLocker keys for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getBitlockerKeys(organizationId: string, deviceId: string, options?: any) {
        return MdmApiFp(this.configuration).getBitlockerKeys(organizationId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets all ios enrollment profiles of a depOnboardSettingProfile. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} depOnboardSettingsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getDepIosEnrollmentProfilesOfOnboardProfile(organizationId: string, depOnboardSettingsId: string, options?: any) {
        return MdmApiFp(this.configuration).getDepIosEnrollmentProfilesOfOnboardProfile(organizationId, depOnboardSettingsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns a single device with specific details. 🔒: DeviceManagement.ShowModule
     * @param {string} deviceId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getDevice(deviceId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getDevice(deviceId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all devices which has been just imported and needs to be (manually) registered. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getDevicesWithoutRegistrationProfile(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return MdmApiFp(this.configuration).getDevicesWithoutRegistrationProfile(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosAppConfiguration(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosAppConfiguration(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowSensibleInfo</li></ul>
     * @summary Returns the Ios-ActivationlockBypassCode for the specified device. 🔒: DeviceManagement.ShowSensibleInfo
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosBypassCode(organizationId: string, deviceId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosBypassCode(organizationId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a ios configuration profile of overall containing features. 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosDeviceFeatures(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosDeviceFeatures(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a ios configuration profile of overall containing restrictions. 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosDeviceRestrictions(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosDeviceRestrictions(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets Ios Store Link 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosStoreLink(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosStoreLink(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a ios configuration profile of overall containing update schedules. 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosUpdateConfiguration(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosUpdateConfiguration(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a ios w-lan profile. 🔒: DeviceManagement.ShowModule
     * @param {string} profileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getIosWlan(profileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getIosWlan(profileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns a single mdm group with specific details. 🔒: DeviceManagement.ShowModule
     * @param {string} mdmGroupId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getMdmGroup(mdmGroupId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getMdmGroup(mdmGroupId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns all mdm software that is not assigned. Attention: top does not do anything here, return the default top value from mc and returns a token if there is more to take 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getNotAssignedBasicSoftware(organizationId: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return MdmApiFp(this.configuration).getNotAssignedBasicSoftware(organizationId, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets all onboard ios-settings of a organization. Ids are necessary to create onboard profiles for a setting 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getOnboardSettings(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getOnboardSettings(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Returns a single mdm software with specific details. 🔒: DeviceManagement.ShowModule
     * @param {string} softwareId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getSoftware(softwareId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getSoftware(softwareId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a windows administration template. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsAdministration(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsAdministration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets all windows autopilot profiles. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsAutopilotProfiles(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsAutopilotProfiles(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a windows autopilot profile. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsAutopilotRestrictions(organizationId: string, profileId: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsAutopilotRestrictions(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Get a windows custom configuration. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsCustomConfiguration(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsCustomConfiguration(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Get windows device restriction. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsDeviceRestrictions(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsDeviceRestrictions(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Get windows settings-localusergroup. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsLocalUserGroupMembership(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsLocalUserGroupMembership(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Get a windows settings catalogue. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsSettingsCatalogue(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsSettingsCatalogue(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a windows shared policy. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsShared(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsShared(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets Windows Store Link 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsStoreLink(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsStoreLink(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Gets a windows update policy. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsUpdatePolicy(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsUpdatePolicy(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Get a windows wlan profile. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public getWindowsWlan(organizationId: string, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).getWindowsWlan(organizationId, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Accepts a .CSV file which will be forwarded via mail to support for importing. Multipart request     - csvFile FILE     - GroupIds [Guid] 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {Array<string>} [groupIds] 
     * @param {any} [csvFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public importDevicesRequest(organizationId: string, groupIds?: Array<string>, csvFile?: any, options?: any) {
        return MdmApiFp(this.configuration).importDevicesRequest(organizationId, groupIds, csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates device-assignment of a ios enrollment profile. Needed when wanting to delete a enrollment profile where devices are still assigned to. Needs old enrollmentProfile Id and new profile Id. Will auto transfer all devices to new profile. 🔒: AixConcept.Only
     * @param {string} oldProfileId 
     * @param {string} newProfileId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId: string, newProfileId: string, organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).reAssignIosDevicesToOtherEnrollmentProfile(oldProfileId, newProfileId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Removes groups from a configurationProfile. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {Array<string>} [groupIds] 
     * @param {string} [configurationProfileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public removeConfigurationProfileOfMdmGroup(organizationId: string, groupIds?: Array<string>, configurationProfileId?: string, options?: any) {
        return MdmApiFp(this.configuration).removeConfigurationProfileOfMdmGroup(organizationId, groupIds, configurationProfileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Removes a enrollment profile from a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be removed from that group. 🔒: DeviceManagement.ShowModule
     * @param {string} enrollmentProfileId 
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public removeEnrollmentProfileToWindowsDevice(enrollmentProfileId: string, organizationId: string, deviceId: string, options?: any) {
        return MdmApiFp(this.configuration).removeEnrollmentProfileToWindowsDevice(enrollmentProfileId, organizationId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Removes a given windows autopilot profile from x groups 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {string} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public removeWindowsAutopilotProfileFromGroup(organizationId: string, profileId: string, groupId?: string, options?: any) {
        return MdmApiFp(this.configuration).removeWindowsAutopilotProfileFromGroup(organizationId, profileId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Sends PPGK-Inquiry email with all attachments uploaded before. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {Array<PPGKInquiryEntry>} pPGKInquiryEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public sendPPGKInquiry(organizationId: string, pPGKInquiryEntry: Array<PPGKInquiryEntry>, options?: any) {
        return MdmApiFp(this.configuration).sendPPGKInquiry(organizationId, pPGKInquiryEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Sends Software-Inquiry email with all attachments uploaded before. 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {Array<SoftwareInquiryEmailEntry>} softwareInquiryEmailEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public sendSoftwareInquiry(organizationId: string, softwareInquiryEmailEntry: Array<SoftwareInquiryEmailEntry>, options?: any) {
        return MdmApiFp(this.configuration).sendSoftwareInquiry(organizationId, softwareInquiryEmailEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary Assign a enrollment profile to a windows device. Therefore a group which contains that enrollment profile will be searched and the device will be added to the group. 🔒: DeviceManagement.ShowModule
     * @param {string} newEnrollmentProfileId 
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public switchDevicesEnrollmentProfile(newEnrollmentProfileId: string, organizationId: string, deviceId: string, options?: any) {
        return MdmApiFp(this.configuration).switchDevicesEnrollmentProfile(newEnrollmentProfileId, organizationId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public syncSoftwareStores(organizationId: string, options?: any) {
        return MdmApiFp(this.configuration).syncSoftwareStores(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Unassign a device from a group. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} deviceId 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public unassignDeviceFromGroup(organizationId: string, deviceId: string, groupId: string, options?: any) {
        return MdmApiFp(this.configuration).unassignDeviceFromGroup(organizationId, deviceId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a android device restriction configuration. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {AndroidDeviceRestrictionsEntry} androidDeviceRestrictionsEntry 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateAndroidDeviceRestriction(organizationId: string, androidDeviceRestrictionsEntry: AndroidDeviceRestrictionsEntry, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).updateAndroidDeviceRestriction(organizationId, androidDeviceRestrictionsEntry, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios configuration profile overall containing features. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {IosProfilesFeaturesEntry} iosProfilesFeaturesEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosDeviceFeatures(organizationId: string, profileId: string, iosProfilesFeaturesEntry: IosProfilesFeaturesEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosDeviceFeatures(organizationId, profileId, iosProfilesFeaturesEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios configuration profile overall containing restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {IosProfilesRestrictionsEntry} iosProfilesRestrictionsEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosDeviceRestrictions(organizationId: string, profileId: string, iosProfilesRestrictionsEntry: IosProfilesRestrictionsEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosDeviceRestrictions(organizationId, profileId, iosProfilesRestrictionsEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios registration profile for non bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {OnboardIosNonBoundEntry} onboardIosNonBoundEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosNonBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardIosNonBoundEntry: OnboardIosNonBoundEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosNonBoundOnboard(onboardSettingsId, organizationId, profileId, onboardIosNonBoundEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios registration profile for shared devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {OnboardSharedIosEntry} onboardSharedIosEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosSharedOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardSharedIosEntry: OnboardSharedIosEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosSharedOnboard(onboardSettingsId, organizationId, profileId, onboardSharedIosEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios configuration profile overall containing update behavior - schedules. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {IosUpdateConfigurationEntry} iosUpdateConfigurationEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosUpdateConfiguration(organizationId: string, profileId: string, iosUpdateConfigurationEntry: IosUpdateConfigurationEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosUpdateConfiguration(organizationId, profileId, iosUpdateConfigurationEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a ios registration profile for user bound devices. Can only be assigned to one device. 🔒: AixConcept.Only
     * @param {string} onboardSettingsId 
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {OnboardUserBoundIosEntry} onboardUserBoundIosEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateIosUserBoundOnboard(onboardSettingsId: string, organizationId: string, profileId: string, onboardUserBoundIosEntry: OnboardUserBoundIosEntry, options?: any) {
        return MdmApiFp(this.configuration).updateIosUserBoundOnboard(onboardSettingsId, organizationId, profileId, onboardUserBoundIosEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a mdm-favourite. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} favouriteId 
     * @param {FavouriteEntry} favouriteEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateMdmFavourite(organizationId: string, favouriteId: string, favouriteEntry: FavouriteEntry, options?: any) {
        return MdmApiFp(this.configuration).updateMdmFavourite(organizationId, favouriteId, favouriteEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Update a MdmGroup. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {MdmGroupUpdateEntry} mdmGroupUpdateEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateMdmGroup(organizationId: string, mdmGroupUpdateEntry: MdmGroupUpdateEntry, options?: any) {
        return MdmApiFp(this.configuration).updateMdmGroup(organizationId, mdmGroupUpdateEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows administration template. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsAdministrativeTemplatesEntry} windowsAdministrativeTemplatesEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsAdministration(organizationId: string, profileId: string, windowsAdministrativeTemplatesEntry: WindowsAdministrativeTemplatesEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsAdministration(organizationId, profileId, windowsAdministrativeTemplatesEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows autopilot profile. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsAutopilotDeploymentEntry} windowsAutopilotDeploymentEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsAutopilotProfile(organizationId: string, profileId: string, windowsAutopilotDeploymentEntry: WindowsAutopilotDeploymentEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsAutopilotProfile(organizationId, profileId, windowsAutopilotDeploymentEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows custom configuration. Can be assigned to multiple mdm groups. A default setting is available. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsCustomConfigurationEntry} windowsCustomConfigurationEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsCustomConfiguration(organizationId: string, profileId: string, windowsCustomConfigurationEntry: WindowsCustomConfigurationEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsCustomConfiguration(organizationId, profileId, windowsCustomConfigurationEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows device restrictions. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WindowsDeviceRestrictionsEntry} windowsDeviceRestrictionsEntry 
     * @param {string} [profileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsDeviceRestrictions(organizationId: string, windowsDeviceRestrictionsEntry: WindowsDeviceRestrictionsEntry, profileId?: string, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsDeviceRestrictions(organizationId, windowsDeviceRestrictionsEntry, profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows localusergroupmembership policy. Can be assigned to multiple USER groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsLocalUserGroupMembershipEntry} windowsLocalUserGroupMembershipEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsLocalUserGroupMembership(organizationId: string, profileId: string, windowsLocalUserGroupMembershipEntry: WindowsLocalUserGroupMembershipEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsLocalUserGroupMembership(organizationId, profileId, windowsLocalUserGroupMembershipEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a windows settings catalogue (just do enable/disable widgets). Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsSettingsCatalogueEntry} windowsSettingsCatalogueEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsSettingsCatalogue(organizationId: string, profileId: string, windowsSettingsCatalogueEntry: WindowsSettingsCatalogueEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsSettingsCatalogue(organizationId, profileId, windowsSettingsCatalogueEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows shared policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsSharedPolicyEntry} windowsSharedPolicyEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsShared(organizationId: string, profileId: string, windowsSharedPolicyEntry: WindowsSharedPolicyEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsShared(organizationId, profileId, windowsSharedPolicyEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a windows update policy. Can be assigned to multiple mdm groups. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} profileId 
     * @param {WindowsUpdatePolicyEntry} windowsUpdatePolicyEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public updateWindowsUpdatePolicy(organizationId: string, profileId: string, windowsUpdatePolicyEntry: WindowsUpdatePolicyEntry, options?: any) {
        return MdmApiFp(this.configuration).updateWindowsUpdatePolicy(organizationId, profileId, windowsUpdatePolicyEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} iosFeatureProfileId 
     * @param {string} organizationId 
     * @param {any} [deviceFeatureWallpaper] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdmApi
     */
    public uploadDeviceFeatureWallpaper(iosFeatureProfileId: string, organizationId: string, deviceFeatureWallpaper?: any, options?: any) {
        return MdmApiFp(this.configuration).uploadDeviceFeatureWallpaper(iosFeatureProfileId, organizationId, deviceFeatureWallpaper, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the specified organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ActivateTimePeriod</li></ul>
         * @summary Sets the given timePeriod to active. 🔒: Organization.ActivateTimePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePeriod: async (organizationId: string, periodId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('activatePeriod', 'organizationId', organizationId)
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('activatePeriod', 'periodId', periodId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods/{periodId}/activate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new organization withing the given tenant. 🔒: AixConcept.Only
         * @param {OrganizationCreateRequest} organizationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (organizationCreateRequest: OrganizationCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreateRequest' is not null or undefined
            assertParamExists('create', 'organizationCreateRequest', organizationCreateRequest)
            const localVarPath = `/api/v2/Organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.CreatePeriods</li></ul>
         * @summary Creates a new period for the requested organization. 🔒: Organization.CreatePeriods
         * @param {string} organizationId 
         * @param {PeriodCreate} periodCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriod: async (organizationId: string, periodCreate: PeriodCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPeriod', 'organizationId', organizationId)
            // verify required parameter 'periodCreate' is not null or undefined
            assertParamExists('createPeriod', 'periodCreate', periodCreate)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes meta information from all groups of the specified organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformation: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMetaInformation', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/metaInformation`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.DeletePeriod</li></ul>
         * @summary Deletes the specified period. 🔒: Organization.DeletePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriod: async (organizationId: string, periodId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePeriod', 'organizationId', organizationId)
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('deletePeriod', 'periodId', periodId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods/{periodId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary Gets the active period of the organization. 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePeriod: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getActivePeriod', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods/active`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all organizations of the specified tenant.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (tenantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getAll', 'tenantId', tenantId)
            const localVarPath = `/api/v2/Organizations/of/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} name 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleSyncFile: async (name: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getAppleSyncFile', 'name', name)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAppleSyncFile', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/appleSync/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleSyncFileNames: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAppleSyncFileNames', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/appleSync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the organization id of the specified user.
         * @param {string} tenantId 
         * @param {string} userPrincipalName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUser: async (tenantId: string, userPrincipalName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getByUser', 'tenantId', tenantId)
            // verify required parameter 'userPrincipalName' is not null or undefined
            assertParamExists('getByUser', 'userPrincipalName', userPrincipalName)
            const localVarPath = `/api/v2/Organizations/for/{tenantId}/{userPrincipalName}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"userPrincipalName"}}`, encodeURIComponent(String(userPrincipalName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomains: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDomains', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/domains`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFeatures', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/features`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Reports.ShowModule</li></ul>
         * @summary Gets all periods of the organization. 🔒: Organization.ShowModule, Reports.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodsAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPeriodsAll', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User import, time period switch, timetable import and the other structural jobs are serialized per organization. The frontend uses this endpoint to tell the user that a change is already running and that a new one may therefore take longer.<br>Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Users.ShowModule</li><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Gets the structural change that is currently running for the organization. 🔒: Organization.ShowModule, Users.ShowModule, Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructuralChange: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getStructuralChange', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/structural-change`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairOwnerships: async (organizationId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Organizations/repairOwnerships`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can only be called from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Resets the passwords of all users of the specified user role. 🔒: AixConcept.Only
         * @param {OrganizationResetPasswordsRequest} organizationResetPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswords: async (organizationResetPasswordsRequest: OrganizationResetPasswordsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationResetPasswordsRequest' is not null or undefined
            assertParamExists('resetPasswords', 'organizationResetPasswordsRequest', organizationResetPasswordsRequest)
            const localVarPath = `/api/v2/Organizations/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationResetPasswordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAppleSync: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('startAppleSync', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Organizations/{organizationId}/appleSync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Changes an existing organization entry. 🔒: AixConcept.Only
         * @param {OrganizationUpdateRequest} organizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (organizationUpdateRequest: OrganizationUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUpdateRequest' is not null or undefined
            assertParamExists('update', 'organizationUpdateRequest', organizationUpdateRequest)
            const localVarPath = `/api/v2/Organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the organization contact informatin. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationContactUpdateRequest} organizationContactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (organizationId: string, organizationContactUpdateRequest: OrganizationContactUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateContact', 'organizationId', organizationId)
            // verify required parameter 'organizationContactUpdateRequest' is not null or undefined
            assertParamExists('updateContact', 'organizationContactUpdateRequest', organizationContactUpdateRequest)
            const localVarPath = `/api/v2/Organizations/{organizationId}/contact`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationContactUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ChangePeriod</li></ul>
         * @summary Updates the Period for the requested Organization. 🔒: Organization.ChangePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {PeriodUpdate} periodUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriod: async (organizationId: string, periodId: string, periodUpdate: PeriodUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePeriod', 'organizationId', organizationId)
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('updatePeriod', 'periodId', periodId)
            // verify required parameter 'periodUpdate' is not null or undefined
            assertParamExists('updatePeriod', 'periodUpdate', periodUpdate)
            const localVarPath = `/api/v2/Organizations/{organizationId}/periods/{periodId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(periodUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the time table options for the given organization. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationTimeTableOptionsUpdateRequest} organizationTimeTableOptionsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTableOptions: async (organizationId: string, organizationTimeTableOptionsUpdateRequest: OrganizationTimeTableOptionsUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTimeTableOptions', 'organizationId', organizationId)
            // verify required parameter 'organizationTimeTableOptionsUpdateRequest' is not null or undefined
            assertParamExists('updateTimeTableOptions', 'organizationTimeTableOptionsUpdateRequest', organizationTimeTableOptionsUpdateRequest)
            const localVarPath = `/api/v2/Organizations/{organizationId}/timeTableOptions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationTimeTableOptionsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the specified organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ActivateTimePeriod</li></ul>
         * @summary Sets the given timePeriod to active. 🔒: Organization.ActivateTimePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activatePeriod(organizationId: string, periodId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activatePeriod(organizationId, periodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new organization withing the given tenant. 🔒: AixConcept.Only
         * @param {OrganizationCreateRequest} organizationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(organizationCreateRequest: OrganizationCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(organizationCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.CreatePeriods</li></ul>
         * @summary Creates a new period for the requested organization. 🔒: Organization.CreatePeriods
         * @param {string} organizationId 
         * @param {PeriodCreate} periodCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPeriod(organizationId: string, periodCreate: PeriodCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Period>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPeriod(organizationId, periodCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes meta information from all groups of the specified organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMetaInformation(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMetaInformation(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.DeletePeriod</li></ul>
         * @summary Deletes the specified period. 🔒: Organization.DeletePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePeriod(organizationId: string, periodId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePeriod(organizationId, periodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary Gets the active period of the organization. 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivePeriod(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Period>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivePeriod(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all organizations of the specified tenant.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(tenantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} name 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppleSyncFile(name: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppleSyncFile(name, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppleSyncFileNames(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppleSyncFileNames(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the organization id of the specified user.
         * @param {string} tenantId 
         * @param {string} userPrincipalName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUser(tenantId: string, userPrincipalName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUser(tenantId, userPrincipalName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDomains(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomains(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatures(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatures(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Reports.ShowModule</li></ul>
         * @summary Gets all periods of the organization. 🔒: Organization.ShowModule, Reports.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodsAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Period>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodsAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User import, time period switch, timetable import and the other structural jobs are serialized per organization. The frontend uses this endpoint to tell the user that a change is already running and that a new one may therefore take longer.<br>Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Users.ShowModule</li><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Gets the structural change that is currently running for the organization. 🔒: Organization.ShowModule, Users.ShowModule, Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStructuralChange(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructuralChangeStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStructuralChange(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairOwnerships(organizationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairOwnerships(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can only be called from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Resets the passwords of all users of the specified user role. 🔒: AixConcept.Only
         * @param {OrganizationResetPasswordsRequest} organizationResetPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswords(organizationResetPasswordsRequest: OrganizationResetPasswordsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswords(organizationResetPasswordsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAppleSync(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAppleSync(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Changes an existing organization entry. 🔒: AixConcept.Only
         * @param {OrganizationUpdateRequest} organizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(organizationUpdateRequest: OrganizationUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(organizationUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the organization contact informatin. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationContactUpdateRequest} organizationContactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(organizationId: string, organizationContactUpdateRequest: OrganizationContactUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(organizationId, organizationContactUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ChangePeriod</li></ul>
         * @summary Updates the Period for the requested Organization. 🔒: Organization.ChangePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {PeriodUpdate} periodUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePeriod(organizationId: string, periodId: string, periodUpdate: PeriodUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Period>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePeriod(organizationId, periodId, periodUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the time table options for the given organization. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationTimeTableOptionsUpdateRequest} organizationTimeTableOptionsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeTableOptions(organizationId: string, organizationTimeTableOptionsUpdateRequest: OrganizationTimeTableOptionsUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeTableOptions(organizationId, organizationTimeTableOptionsUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes the specified organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ActivateTimePeriod</li></ul>
         * @summary Sets the given timePeriod to active. 🔒: Organization.ActivateTimePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activatePeriod(organizationId: string, periodId: string, options?: any): AxiosPromise<string> {
            return localVarFp.activatePeriod(organizationId, periodId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a new organization withing the given tenant. 🔒: AixConcept.Only
         * @param {OrganizationCreateRequest} organizationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationCreateRequest: OrganizationCreateRequest, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.create(organizationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.CreatePeriods</li></ul>
         * @summary Creates a new period for the requested organization. 🔒: Organization.CreatePeriods
         * @param {string} organizationId 
         * @param {PeriodCreate} periodCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriod(organizationId: string, periodCreate: PeriodCreate, options?: any): AxiosPromise<Period> {
            return localVarFp.createPeriod(organizationId, periodCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Removes meta information from all groups of the specified organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformation(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMetaInformation(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.DeletePeriod</li></ul>
         * @summary Deletes the specified period. 🔒: Organization.DeletePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePeriod(organizationId: string, periodId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePeriod(organizationId, periodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(organizationId: string, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.get(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary Gets the active period of the organization. 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePeriod(organizationId: string, options?: any): AxiosPromise<Period> {
            return localVarFp.getActivePeriod(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all organizations of the specified tenant.
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(tenantId: string, options?: any): AxiosPromise<Array<OrganizationResponse>> {
            return localVarFp.getAll(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} name 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleSyncFile(name: string, organizationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getAppleSyncFile(name, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppleSyncFileNames(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAppleSyncFileNames(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the organization id of the specified user.
         * @param {string} tenantId 
         * @param {string} userPrincipalName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUser(tenantId: string, userPrincipalName: string, options?: any): AxiosPromise<string> {
            return localVarFp.getByUser(tenantId, userPrincipalName, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
         * @summary 🔒: Organization.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomains(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getDomains(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatures(organizationId: string, options?: any): AxiosPromise<Array<FeatureResponse>> {
            return localVarFp.getFeatures(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Reports.ShowModule</li></ul>
         * @summary Gets all periods of the organization. 🔒: Organization.ShowModule, Reports.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodsAll(organizationId: string, options?: any): AxiosPromise<Array<Period>> {
            return localVarFp.getPeriodsAll(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * User import, time period switch, timetable import and the other structural jobs are serialized per organization. The frontend uses this endpoint to tell the user that a change is already running and that a new one may therefore take longer.<br>Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Users.ShowModule</li><li>Users.ImportUsersForUserTemplate</li></ul>
         * @summary Gets the structural change that is currently running for the organization. 🔒: Organization.ShowModule, Users.ShowModule, Users.ImportUsersForUserTemplate
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructuralChange(organizationId: string, options?: any): AxiosPromise<StructuralChangeStatusResponse> {
            return localVarFp.getStructuralChange(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairOwnerships(organizationId?: string, options?: any): AxiosPromise<string> {
            return localVarFp.repairOwnerships(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Can only be called from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Resets the passwords of all users of the specified user role. 🔒: AixConcept.Only
         * @param {OrganizationResetPasswordsRequest} organizationResetPasswordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswords(organizationResetPasswordsRequest: OrganizationResetPasswordsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.resetPasswords(organizationResetPasswordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
         * @summary 🔒: DeviceManagement.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAppleSync(organizationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.startAppleSync(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Changes an existing organization entry. 🔒: AixConcept.Only
         * @param {OrganizationUpdateRequest} organizationUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(organizationUpdateRequest: OrganizationUpdateRequest, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.update(organizationUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the organization contact informatin. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationContactUpdateRequest} organizationContactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(organizationId: string, organizationContactUpdateRequest: OrganizationContactUpdateRequest, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.updateContact(organizationId, organizationContactUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.ChangePeriod</li></ul>
         * @summary Updates the Period for the requested Organization. 🔒: Organization.ChangePeriod
         * @param {string} organizationId 
         * @param {string} periodId 
         * @param {PeriodUpdate} periodUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePeriod(organizationId: string, periodId: string, periodUpdate: PeriodUpdate, options?: any): AxiosPromise<Period> {
            return localVarFp.updatePeriod(organizationId, periodId, periodUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
         * @summary Changes the time table options for the given organization. 🔒: Organization.Manage
         * @param {string} organizationId 
         * @param {OrganizationTimeTableOptionsUpdateRequest} organizationTimeTableOptionsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTableOptions(organizationId: string, organizationTimeTableOptionsUpdateRequest: OrganizationTimeTableOptionsUpdateRequest, options?: any): AxiosPromise<OrganizationResponse> {
            return localVarFp.updateTimeTableOptions(organizationId, organizationTimeTableOptionsUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes the specified organization. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public _delete(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration)._delete(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.ActivateTimePeriod</li></ul>
     * @summary Sets the given timePeriod to active. 🔒: Organization.ActivateTimePeriod
     * @param {string} organizationId 
     * @param {string} periodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public activatePeriod(organizationId: string, periodId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).activatePeriod(organizationId, periodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a new organization withing the given tenant. 🔒: AixConcept.Only
     * @param {OrganizationCreateRequest} organizationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public create(organizationCreateRequest: OrganizationCreateRequest, options?: any) {
        return OrganizationsApiFp(this.configuration).create(organizationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.CreatePeriods</li></ul>
     * @summary Creates a new period for the requested organization. 🔒: Organization.CreatePeriods
     * @param {string} organizationId 
     * @param {PeriodCreate} periodCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createPeriod(organizationId: string, periodCreate: PeriodCreate, options?: any) {
        return OrganizationsApiFp(this.configuration).createPeriod(organizationId, periodCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Removes meta information from all groups of the specified organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteMetaInformation(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).deleteMetaInformation(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.DeletePeriod</li></ul>
     * @summary Deletes the specified period. 🔒: Organization.DeletePeriod
     * @param {string} organizationId 
     * @param {string} periodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deletePeriod(organizationId: string, periodId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).deletePeriod(organizationId, periodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the specified organization.
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public get(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).get(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
     * @summary Gets the active period of the organization. 🔒: Organization.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getActivePeriod(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getActivePeriod(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all organizations of the specified tenant.
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getAll(tenantId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getAll(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} name 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getAppleSyncFile(name: string, organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getAppleSyncFile(name, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getAppleSyncFileNames(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getAppleSyncFileNames(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the organization id of the specified user.
     * @param {string} tenantId 
     * @param {string} userPrincipalName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getByUser(tenantId: string, userPrincipalName: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getByUser(tenantId, userPrincipalName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.ShowModule</li></ul>
     * @summary 🔒: Organization.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getDomains(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getDomains(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getFeatures(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getFeatures(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Reports.ShowModule</li></ul>
     * @summary Gets all periods of the organization. 🔒: Organization.ShowModule, Reports.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getPeriodsAll(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getPeriodsAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User import, time period switch, timetable import and the other structural jobs are serialized per organization. The frontend uses this endpoint to tell the user that a change is already running and that a new one may therefore take longer.<br>Any of the following permissions are required:<ul><li>Organization.ShowModule</li><li>Users.ShowModule</li><li>Users.ImportUsersForUserTemplate</li></ul>
     * @summary Gets the structural change that is currently running for the organization. 🔒: Organization.ShowModule, Users.ShowModule, Users.ImportUsersForUserTemplate
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getStructuralChange(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getStructuralChange(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public repairOwnerships(organizationId?: string, options?: any) {
        return OrganizationsApiFp(this.configuration).repairOwnerships(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can only be called from AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Resets the passwords of all users of the specified user role. 🔒: AixConcept.Only
     * @param {OrganizationResetPasswordsRequest} organizationResetPasswordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public resetPasswords(organizationResetPasswordsRequest: OrganizationResetPasswordsRequest, options?: any) {
        return OrganizationsApiFp(this.configuration).resetPasswords(organizationResetPasswordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>DeviceManagement.ShowModule</li></ul>
     * @summary 🔒: DeviceManagement.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public startAppleSync(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).startAppleSync(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Changes an existing organization entry. 🔒: AixConcept.Only
     * @param {OrganizationUpdateRequest} organizationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public update(organizationUpdateRequest: OrganizationUpdateRequest, options?: any) {
        return OrganizationsApiFp(this.configuration).update(organizationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
     * @summary Changes the organization contact informatin. 🔒: Organization.Manage
     * @param {string} organizationId 
     * @param {OrganizationContactUpdateRequest} organizationContactUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateContact(organizationId: string, organizationContactUpdateRequest: OrganizationContactUpdateRequest, options?: any) {
        return OrganizationsApiFp(this.configuration).updateContact(organizationId, organizationContactUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.ChangePeriod</li></ul>
     * @summary Updates the Period for the requested Organization. 🔒: Organization.ChangePeriod
     * @param {string} organizationId 
     * @param {string} periodId 
     * @param {PeriodUpdate} periodUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updatePeriod(organizationId: string, periodId: string, periodUpdate: PeriodUpdate, options?: any) {
        return OrganizationsApiFp(this.configuration).updatePeriod(organizationId, periodId, periodUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Organization.Manage</li></ul>
     * @summary Changes the time table options for the given organization. 🔒: Organization.Manage
     * @param {string} organizationId 
     * @param {OrganizationTimeTableOptionsUpdateRequest} organizationTimeTableOptionsUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateTimeTableOptions(organizationId: string, organizationTimeTableOptionsUpdateRequest: OrganizationTimeTableOptionsUpdateRequest, options?: any) {
        return OrganizationsApiFp(this.configuration).updateTimeTableOptions(organizationId, organizationTimeTableOptionsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ParentalCommunicationApi - axios parameter creator
 * @export
 */
export const ParentalCommunicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Ban a given guardian for the specified ward id 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banGuardianContact: async (organizationId: string, guardianMail: string, studentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('banGuardianContact', 'organizationId', organizationId)
            // verify required parameter 'guardianMail' is not null or undefined
            assertParamExists('banGuardianContact', 'guardianMail', guardianMail)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('banGuardianContact', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/ban/{guardianMail}/for/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"guardianMail"}}`, encodeURIComponent(String(guardianMail)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Shares a file with a list of recipients 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {ShareContent} shareContent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFileSharingList: async (organizationId: string, shareContent: ShareContent, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeFileSharingList', 'organizationId', organizationId)
            // verify required parameter 'shareContent' is not null or undefined
            assertParamExists('changeFileSharingList', 'shareContent', shareContent)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files/share`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Completes a parental mail draft and sends it. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeParentalMail: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('completeParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeParentalMail', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/complete`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Creates a appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {CreateAppointmentRequestBody} createAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment: async (organizationId: string, createAppointmentRequestBody: CreateAppointmentRequestBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createAppointment', 'organizationId', organizationId)
            // verify required parameter 'createAppointmentRequestBody' is not null or undefined
            assertParamExists('createAppointment', 'createAppointmentRequestBody', createAppointmentRequestBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/appointment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppointmentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Upload a file into our blob storage. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [contentFolderId] 
         * @param {Array<string>} [contentRecipients] 
         * @param {boolean} [contentShareWithOrganization] 
         * @param {boolean} [contentOverwrite] 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile: async (organizationId: string, contentFolderId?: string, contentRecipients?: Array<string>, contentShareWithOrganization?: boolean, contentOverwrite?: boolean, timePeriod?: string, contentFile?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createFile', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (contentFolderId !== undefined) {
                localVarQueryParameter['content.FolderId'] = contentFolderId;
            }

            if (contentRecipients) {
                localVarQueryParameter['content.Recipients'] = contentRecipients;
            }

            if (contentShareWithOrganization !== undefined) {
                localVarQueryParameter['content.ShareWithOrganization'] = contentShareWithOrganization;
            }

            if (contentOverwrite !== undefined) {
                localVarQueryParameter['content.Overwrite'] = contentOverwrite;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


            if (contentFile !== undefined) { 
                localVarFormParams.append('Content.File', contentFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Create a folder in the specified path. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [optionsFolderName] 
         * @param {string} [optionsFolderId] 
         * @param {Array<string>} [optionsRecipients] 
         * @param {boolean} [optionsShareWithOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (organizationId: string, optionsFolderName?: string, optionsFolderId?: string, optionsRecipients?: Array<string>, optionsShareWithOrganization?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createFolder', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files/folder`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (optionsFolderName !== undefined) {
                localVarQueryParameter['options.FolderName'] = optionsFolderName;
            }

            if (optionsFolderId !== undefined) {
                localVarQueryParameter['options.FolderId'] = optionsFolderId;
            }

            if (optionsRecipients) {
                localVarQueryParameter['options.Recipients'] = optionsRecipients;
            }

            if (optionsShareWithOrganization !== undefined) {
                localVarQueryParameter['options.ShareWithOrganization'] = optionsShareWithOrganization;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary creates a new guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId the organization id for which we shall create the guardian contact
         * @param {CreateGuardianContactBody} createGuardianContactBody The content of the request
         * @param {string} [timePeriod] the current timePeriod so we can get the correct grades and classes for the student
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGuardianContact: async (organizationId: string, createGuardianContactBody: CreateGuardianContactBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createGuardianContact', 'organizationId', organizationId)
            // verify required parameter 'createGuardianContactBody' is not null or undefined
            assertParamExists('createGuardianContact', 'createGuardianContactBody', createGuardianContactBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGuardianContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts a mail merge to create invitations for the specified wards 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {GuardianContactCreateMailMergeBody} guardianContactCreateMailMergeBody 
         * @param {string} [culture] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailMerge: async (organizationId: string, guardianContactCreateMailMergeBody: GuardianContactCreateMailMergeBody, culture?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createMailMerge', 'organizationId', organizationId)
            // verify required parameter 'guardianContactCreateMailMergeBody' is not null or undefined
            assertParamExists('createMailMerge', 'guardianContactCreateMailMergeBody', guardianContactCreateMailMergeBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/createMailMerge`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guardianContactCreateMailMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Creates a new notification for the given organization and period. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {CreateEventBody} createEventBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews: async (organizationId: string, createEventBody: CreateEventBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createNews', 'organizationId', organizationId)
            // verify required parameter 'createEventBody' is not null or undefined
            assertParamExists('createNews', 'createEventBody', createEventBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/news`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Creates or updates the settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSettings: async (organizationId: string, requestBody: { [key: string]: any; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createOrUpdateSettings', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createOrUpdateSettings', 'requestBody', requestBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li></ul>
         * @summary Creates a new linking invitation to a specified child, including a direct link, and a QR code. 🔒: ParentalCommunication.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {CreateParentInvitationRequest} createParentInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParentInvitation: async (organizationId: string, studentId: string, createParentInvitationRequest: CreateParentInvitationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createParentInvitation', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('createParentInvitation', 'studentId', studentId)
            // verify required parameter 'createParentInvitationRequest' is not null or undefined
            assertParamExists('createParentInvitation', 'createParentInvitationRequest', createParentInvitationRequest)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/children/{studentId}/invitations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createParentInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Creates a new parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParentalMail: async (organizationId: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createParentalMail', 'organizationId', organizationId)
            // verify required parameter 'parentalMailCreateBody' is not null or undefined
            assertParamExists('createParentalMail', 'parentalMailCreateBody', parentalMailCreateBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parentalMailCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Deletes the given appointment. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteAppointment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAppointment', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/appointment/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Delete a file or folder. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (organizationId: string, fileId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteFile', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Removes the connection between a guardian and a single ward (child) instead of banning the guardian. Other children of the guardian remain intact and the child can be re-linked later via a QR code. Idempotent: succeeds even when no active connection exists. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuardianConnection: async (organizationId: string, guardianMail: string, studentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteGuardianConnection', 'organizationId', organizationId)
            // verify required parameter 'guardianMail' is not null or undefined
            assertParamExists('deleteGuardianConnection', 'guardianMail', guardianMail)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('deleteGuardianConnection', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/connection/{guardianMail}/for/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"guardianMail"}}`, encodeURIComponent(String(guardianMail)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary deletes the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId OrganizationId 
         * @param {string} guardianId id of the guardian contact to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuardianContact: async (organizationId: string, guardianId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteGuardianContact', 'organizationId', organizationId)
            // verify required parameter 'guardianId' is not null or undefined
            assertParamExists('deleteGuardianContact', 'guardianId', guardianId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/{guardianId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"guardianId"}}`, encodeURIComponent(String(guardianId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Deletes the given notification 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteNews', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteNews', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/news/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParentalMail: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteParentalMail', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParentalMailAttachment: async (organizationId: string, id: string, attachmentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteParentalMailAttachment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteParentalMailAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteParentalMailAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/attachments/{attachmentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Downloads an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (organizationId: string, id: string, attachmentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadAttachment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/attachments/{attachmentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Generates and Downloads the CSV file of all responses of a parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadResponsesCsv: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadResponsesCsv', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadResponsesCsv', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/responses-csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasons: async (organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAbsenceReasons', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/settings/absences/reasons`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enabledOnly !== undefined) {
                localVarQueryParameter['enabledOnly'] = enabledOnly;
            }

            if (reasonDefinitionId !== undefined) {
                localVarQueryParameter['reasonDefinitionId'] = reasonDefinitionId;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets all appointments of the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments: async (organizationId: string, timePeriod?: string, start?: string, end?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllAppointments', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/appointments/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Gets all metadata of files in the specified folder. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [folderId] 
         * @param {string} [search] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFilesMetadata: async (organizationId: string, folderId?: string, search?: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllFilesMetadata', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets the guardian contacts, which are listed in the parental communication, for the given organization and the given filter 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId OrganizationId for which to get the guardian contacts
         * @param {string} [timePeriod] TimePeriod for which to get the guardian contacts Necessary to resolve the grades or classes and filter on them
         * @param {Array<string>} [filterByGradesOrClasses] list of revision ids of the grades or classes to filter the relevant students for which we shall get the guardian contacts
         * @param {string} [filterByName] string to filter the relevant students by name for which we shall get the guardian contacts
         * @param {FitlerByConnectedGuardians} [filterByConnectedGuardians] Defines how guardians should be filtered.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGuardianContacts: async (organizationId: string, timePeriod?: string, filterByGradesOrClasses?: Array<string>, filterByName?: string, filterByConnectedGuardians?: FitlerByConnectedGuardians, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllGuardianContacts', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (filterByGradesOrClasses) {
                localVarQueryParameter['filterByGradesOrClasses'] = filterByGradesOrClasses;
            }

            if (filterByName !== undefined) {
                localVarQueryParameter['filterByName'] = filterByName;
            }

            if (filterByConnectedGuardians !== undefined) {
                localVarQueryParameter['filterByConnectedGuardians'] = filterByConnectedGuardians;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.News</li></ul>
         * @summary Gets all notifications of the given organization for the given period 🔒: ParentalCommunication.News
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includePlanned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNews: async (organizationId: string, timePeriod?: string, includePlanned?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllNews', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/news/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (includePlanned !== undefined) {
                localVarQueryParameter['includePlanned'] = includePlanned;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all potential group recipients of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {ParentalMailGroupRecipientType} [entityType] 
         * @param {string} [search] 
         * @param {string} [courseId] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalMailGroupRecipients: async (organizationId: string, timePeriod?: string, entityType?: ParentalMailGroupRecipientType, search?: string, courseId?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllParentalMailGroupRecipients', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/recipients`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all parental mails of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [courseId] 
         * @param {GetAllParentalMailSortBy} [sortBy] 
         * @param {GetAllParentalMailSortDirection} [sortDirection] 
         * @param {string} [sentFrom] 
         * @param {string} [sentTo] 
         * @param {boolean} [preloadStats] 
         * @param {string} [search] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalMails: async (organizationId: string, timePeriod?: string, courseId?: string, sortBy?: GetAllParentalMailSortBy, sortDirection?: GetAllParentalMailSortDirection, sentFrom?: string, sentTo?: string, preloadStats?: boolean, search?: string, pageSize?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllParentalMails', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (sentFrom !== undefined) {
                localVarQueryParameter['sentFrom'] = (sentFrom as any instanceof Date) ?
                    (sentFrom as any).toISOString() :
                    sentFrom;
            }

            if (sentTo !== undefined) {
                localVarQueryParameter['sentTo'] = (sentTo as any instanceof Date) ?
                    (sentTo as any).toISOString() :
                    sentTo;
            }

            if (preloadStats !== undefined) {
                localVarQueryParameter['preloadStats'] = preloadStats;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all grades and classes
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecipients: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllRecipients', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/recipients`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets the appointment based on the given id and the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAppointment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointment', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/appointment/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getB2CUserFor: async (organizationId: string, studentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getB2CUserFor', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('getB2CUserFor', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/b2cUsers/for/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts the process to create the invitation mails for the given student 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadLinkForMailMerge: async (organizationId: string, jobId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDownloadLinkForMailMerge', 'organizationId', organizationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getDownloadLinkForMailMerge', 'jobId', jobId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/createMailMerge/{jobId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Generate a download link for a specific file. Has availability of 60 minutes. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (organizationId: string, fileId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFile', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/files-download`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Get alle guardian contacts for the specified stuudent 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId organization id for the student we shall get the guardian contacts for
         * @param {string} studentId student if for which we shall get the guardian contacts for
         * @param {string} [timePeriod] time period for which we shall get the guardian contacts for - necessary for the grades and classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuardianContactsForStudent: async (organizationId: string, studentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuardianContactsForStudent', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('getGuardianContactsForStudent', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/for/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsFor: async (organizationId: string, studentId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInvitationsFor', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('getInvitationsFor', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/invitations/for/{studentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Role-scoped counterpart of GetAllNews: teachers get the news they published or received, students the news of their own classes and grades. Serves the cockpit news widget and returns the same payload as the Teams cockpit endpoint.
         * @summary Gets the newest news of the calling user for the given period.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNews: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyNews', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/news/my`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMail: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParentalMail', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets the responses of a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailResponses: async (organizationId: string, id: string, timePeriod?: string, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getParentalMailResponses', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParentalMailResponses', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/responses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all wards of a parental mail for the given organization and period paged 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {boolean} [filterOnlyMissingContacts] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailWards: async (organizationId: string, id: string, timePeriod?: string, filterOnlyMissingContacts?: boolean, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getParentalMailWards', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getParentalMailWards', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/wards`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (filterOnlyMissingContacts !== undefined) {
                localVarQueryParameter['filterOnlyMissingContacts'] = filterOnlyMissingContacts;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Gets all settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSettings', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets all ward connections for the specified ward 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId The organization ID
         * @param {string} wardId The ID of the ward to get connections for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWardConnectionsFor: async (organizationId: string, wardId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWardConnectionsFor', 'organizationId', organizationId)
            // verify required parameter 'wardId' is not null or undefined
            assertParamExists('getWardConnectionsFor', 'wardId', wardId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/relations/wardConnections/{wardId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"wardId"}}`, encodeURIComponent(String(wardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Refreshes the parents and mails of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshParentalMail: async (organizationId: string, id: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('refreshParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshParentalMail', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/refresh`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Resends a parental mail to a set of given email addresses 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendParentalMail: async (organizationId: string, id: string, requestBody: Array<string>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resendParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resendParentalMail', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('resendParentalMail', 'requestBody', requestBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/resend`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary Invalidates ALL QR-code invitations generated for the given ward, so existing codes can no longer be used to (re-)link the child. 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllInvitationsForWard: async (organizationId: string, studentId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('revokeAllInvitationsForWard', 'organizationId', organizationId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('revokeAllInvitationsForWard', 'studentId', studentId)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/invitations/for/{studentId}/revoke-all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"studentId"}}`, encodeURIComponent(String(studentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('revokeInvitation', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeInvitation', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/invitations/{id}/revoke`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Set a guardian contact as the primary contact for a specific ward. Automatically removes primary status from other contacts for this ward. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {SetPrimaryContactForWardBody} setPrimaryContactForWardBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryContactForWard: async (organizationId: string, setPrimaryContactForWardBody: SetPrimaryContactForWardBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setPrimaryContactForWard', 'organizationId', organizationId)
            // verify required parameter 'setPrimaryContactForWardBody' is not null or undefined
            assertParamExists('setPrimaryContactForWard', 'setPrimaryContactForWardBody', setPrimaryContactForWardBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/set-primary-contact`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPrimaryContactForWardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Updates the given appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {UpdateAppointmentRequestBody} updateAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment: async (organizationId: string, updateAppointmentRequestBody: UpdateAppointmentRequestBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateAppointment', 'organizationId', organizationId)
            // verify required parameter 'updateAppointmentRequestBody' is not null or undefined
            assertParamExists('updateAppointment', 'updateAppointmentRequestBody', updateAppointmentRequestBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/appointment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppointmentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary updates the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId organizationId of the organization the student of the guardian contact belongs to
         * @param {string} id Id of the guardian contact to update
         * @param {UpdateGuardianContactBody} updateGuardianContactBody the content of the reqeust
         * @param {string} [timePeriod] timePeriod of the organization the student of the guardian contact belongs to - necessary for classes and grades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuardianContact: async (organizationId: string, id: string, updateGuardianContactBody: UpdateGuardianContactBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateGuardianContact', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGuardianContact', 'id', id)
            // verify required parameter 'updateGuardianContactBody' is not null or undefined
            assertParamExists('updateGuardianContact', 'updateGuardianContactBody', updateGuardianContactBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/guardianContacts/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGuardianContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Updates a notification. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {UpdateNotificationBody} updateNotificationBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNews: async (organizationId: string, id: string, updateNotificationBody: UpdateNotificationBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateNews', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNews', 'id', id)
            // verify required parameter 'updateNotificationBody' is not null or undefined
            assertParamExists('updateNews', 'updateNotificationBody', updateNotificationBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/news/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParentalMail: async (organizationId: string, id: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateParentalMail', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateParentalMail', 'id', id)
            // verify required parameter 'parentalMailCreateBody' is not null or undefined
            assertParamExists('updateParentalMail', 'parentalMailCreateBody', parentalMailCreateBody)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parentalMailCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates the additional mails of a parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<ParentalMailAdditionalMailUpdateOptions>} parentalMailAdditionalMailUpdateOptions 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParentalMailAdditionalMails: async (organizationId: string, id: string, parentalMailAdditionalMailUpdateOptions: Array<ParentalMailAdditionalMailUpdateOptions>, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateParentalMailAdditionalMails', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateParentalMailAdditionalMails', 'id', id)
            // verify required parameter 'parentalMailAdditionalMailUpdateOptions' is not null or undefined
            assertParamExists('updateParentalMailAdditionalMails', 'parentalMailAdditionalMailUpdateOptions', parentalMailAdditionalMailUpdateOptions)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/additionalMails`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parentalMailAdditionalMailUpdateOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Uploads an attachment to an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadParentalMailAttachment: async (organizationId: string, id: string, timePeriod?: string, contentFile?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadParentalMailAttachment', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadParentalMailAttachment', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/ParentalCommunication/parentalMail/{id}/attachments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


            if (contentFile !== undefined) { 
                localVarFormParams.append('Content.File', contentFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParentalCommunicationApi - functional programming interface
 * @export
 */
export const ParentalCommunicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParentalCommunicationApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Ban a given guardian for the specified ward id 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banGuardianContact(organizationId: string, guardianMail: string, studentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banGuardianContact(organizationId, guardianMail, studentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Shares a file with a list of recipients 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {ShareContent} shareContent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeFileSharingList(organizationId: string, shareContent: ShareContent, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeFileSharingList(organizationId, shareContent, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Completes a parental mail draft and sends it. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeParentalMail(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Creates a appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {CreateAppointmentRequestBody} createAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppointment(organizationId: string, createAppointmentRequestBody: CreateAppointmentRequestBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Appointment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppointment(organizationId, createAppointmentRequestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Upload a file into our blob storage. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [contentFolderId] 
         * @param {Array<string>} [contentRecipients] 
         * @param {boolean} [contentShareWithOrganization] 
         * @param {boolean} [contentOverwrite] 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFile(organizationId: string, contentFolderId?: string, contentRecipients?: Array<string>, contentShareWithOrganization?: boolean, contentOverwrite?: boolean, timePeriod?: string, contentFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFile(organizationId, contentFolderId, contentRecipients, contentShareWithOrganization, contentOverwrite, timePeriod, contentFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Create a folder in the specified path. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [optionsFolderName] 
         * @param {string} [optionsFolderId] 
         * @param {Array<string>} [optionsRecipients] 
         * @param {boolean} [optionsShareWithOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(organizationId: string, optionsFolderName?: string, optionsFolderId?: string, optionsRecipients?: Array<string>, optionsShareWithOrganization?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(organizationId, optionsFolderName, optionsFolderId, optionsRecipients, optionsShareWithOrganization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary creates a new guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId the organization id for which we shall create the guardian contact
         * @param {CreateGuardianContactBody} createGuardianContactBody The content of the request
         * @param {string} [timePeriod] the current timePeriod so we can get the correct grades and classes for the student
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGuardianContact(organizationId: string, createGuardianContactBody: CreateGuardianContactBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuardianContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGuardianContact(organizationId, createGuardianContactBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts a mail merge to create invitations for the specified wards 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {GuardianContactCreateMailMergeBody} guardianContactCreateMailMergeBody 
         * @param {string} [culture] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMailMerge(organizationId: string, guardianContactCreateMailMergeBody: GuardianContactCreateMailMergeBody, culture?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMailMerge(organizationId, guardianContactCreateMailMergeBody, culture, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Creates a new notification for the given organization and period. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {CreateEventBody} createEventBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNews(organizationId: string, createEventBody: CreateEventBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<News>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNews(organizationId, createEventBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Creates or updates the settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateSettings(organizationId: string, requestBody: { [key: string]: any; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalCommunicationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateSettings(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li></ul>
         * @summary Creates a new linking invitation to a specified child, including a direct link, and a QR code. 🔒: ParentalCommunication.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {CreateParentInvitationRequest} createParentInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParentInvitation(organizationId: string, studentId: string, createParentInvitationRequest: CreateParentInvitationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateParentInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParentInvitation(organizationId, studentId, createParentInvitationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Creates a new parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParentalMail(organizationId: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParentalMail(organizationId, parentalMailCreateBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Deletes the given appointment. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAppointment(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAppointment(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Delete a file or folder. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(organizationId: string, fileId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(organizationId, fileId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Removes the connection between a guardian and a single ward (child) instead of banning the guardian. Other children of the guardian remain intact and the child can be re-linked later via a QR code. Idempotent: succeeds even when no active connection exists. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGuardianConnection(organizationId: string, guardianMail: string, studentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGuardianConnection(organizationId, guardianMail, studentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary deletes the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId OrganizationId 
         * @param {string} guardianId id of the guardian contact to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGuardianContact(organizationId: string, guardianId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGuardianContact(organizationId, guardianId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Deletes the given notification 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNews(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNews(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParentalMail(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteParentalMailAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteParentalMailAttachment(organizationId, id, attachmentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Downloads an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMailAttachmentDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(organizationId, id, attachmentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Generates and Downloads the CSV file of all responses of a parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadResponsesCsv(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMailAttachmentDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadResponsesCsv(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AbsenceReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets all appointments of the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAppointments(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Appointment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAppointments(organizationId, timePeriod, start, end, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Gets all metadata of files in the specified folder. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [folderId] 
         * @param {string} [search] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFilesMetadata(organizationId: string, folderId?: string, search?: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileMetadata>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFilesMetadata(organizationId, folderId, search, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets the guardian contacts, which are listed in the parental communication, for the given organization and the given filter 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId OrganizationId for which to get the guardian contacts
         * @param {string} [timePeriod] TimePeriod for which to get the guardian contacts Necessary to resolve the grades or classes and filter on them
         * @param {Array<string>} [filterByGradesOrClasses] list of revision ids of the grades or classes to filter the relevant students for which we shall get the guardian contacts
         * @param {string} [filterByName] string to filter the relevant students by name for which we shall get the guardian contacts
         * @param {FitlerByConnectedGuardians} [filterByConnectedGuardians] Defines how guardians should be filtered.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGuardianContacts(organizationId: string, timePeriod?: string, filterByGradesOrClasses?: Array<string>, filterByName?: string, filterByConnectedGuardians?: FitlerByConnectedGuardians, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StudentWithPrimaryGuardianContact>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGuardianContacts(organizationId, timePeriod, filterByGradesOrClasses, filterByName, filterByConnectedGuardians, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.News</li></ul>
         * @summary Gets all notifications of the given organization for the given period 🔒: ParentalCommunication.News
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includePlanned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNews(organizationId: string, timePeriod?: string, includePlanned?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<News>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNews(organizationId, timePeriod, includePlanned, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all potential group recipients of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {ParentalMailGroupRecipientType} [entityType] 
         * @param {string} [search] 
         * @param {string} [courseId] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllParentalMailGroupRecipients(organizationId: string, timePeriod?: string, entityType?: ParentalMailGroupRecipientType, search?: string, courseId?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfParentalMailGroupRecipient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllParentalMailGroupRecipients(organizationId, timePeriod, entityType, search, courseId, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all parental mails of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [courseId] 
         * @param {GetAllParentalMailSortBy} [sortBy] 
         * @param {GetAllParentalMailSortDirection} [sortDirection] 
         * @param {string} [sentFrom] 
         * @param {string} [sentTo] 
         * @param {boolean} [preloadStats] 
         * @param {string} [search] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllParentalMails(organizationId: string, timePeriod?: string, courseId?: string, sortBy?: GetAllParentalMailSortBy, sortDirection?: GetAllParentalMailSortDirection, sentFrom?: string, sentTo?: string, preloadStats?: boolean, search?: string, pageSize?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllParentalMails(organizationId, timePeriod, courseId, sortBy, sortDirection, sentFrom, sentTo, preloadStats, search, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all grades and classes
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRecipients(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Recipient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRecipients(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets the appointment based on the given id and the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointment(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Appointment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppointment(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getB2CUserFor(organizationId: string, studentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<B2CUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getB2CUserFor(organizationId, studentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts the process to create the invitation mails for the given student 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadLinkForMailMerge(organizationId: string, jobId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailMergeWithDownloadLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadLinkForMailMerge(organizationId, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Generate a download link for a specific file. Has availability of 60 minutes. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(organizationId: string, fileId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(organizationId, fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Get alle guardian contacts for the specified stuudent 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId organization id for the student we shall get the guardian contacts for
         * @param {string} studentId student if for which we shall get the guardian contacts for
         * @param {string} [timePeriod] time period for which we shall get the guardian contacts for - necessary for the grades and classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuardianContactsForStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentWithGuardianContacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuardianContactsForStudent(organizationId, studentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitationsFor(organizationId: string, studentId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GuardianContactInvitationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitationsFor(organizationId, studentId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Role-scoped counterpart of GetAllNews: teachers get the news they published or received, students the news of their own classes and grades. Serves the cockpit news widget and returns the same payload as the Teams cockpit endpoint.
         * @summary Gets the newest news of the calling user for the given period.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyNews(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<News>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyNews(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentalMail(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets the responses of a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentalMailResponses(organizationId: string, id: string, timePeriod?: string, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfParentalMailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentalMailResponses(organizationId, id, timePeriod, sortBy, sortDirection, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all wards of a parental mail for the given organization and period paged 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {boolean} [filterOnlyMissingContacts] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParentalMailWards(organizationId: string, id: string, timePeriod?: string, filterOnlyMissingContacts?: boolean, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfParentalMailWardParents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParentalMailWards(organizationId, id, timePeriod, filterOnlyMissingContacts, sortBy, sortDirection, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Gets all settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalCommunicationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets all ward connections for the specified ward 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId The organization ID
         * @param {string} wardId The ID of the ward to get connections for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWardConnectionsFor(organizationId: string, wardId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WardConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWardConnectionsFor(organizationId, wardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Refreshes the parents and mails of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshParentalMail(organizationId, id, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Resends a parental mail to a set of given email addresses 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendParentalMail(organizationId: string, id: string, requestBody: Array<string>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendParentalMail(organizationId, id, requestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary Invalidates ALL QR-code invitations generated for the given ward, so existing codes can no longer be used to (re-)link the child. 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAllInvitationsForWard(organizationId: string, studentId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAllInvitationsForWard(organizationId, studentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitation(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitation(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Set a guardian contact as the primary contact for a specific ward. Automatically removes primary status from other contacts for this ward. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {SetPrimaryContactForWardBody} setPrimaryContactForWardBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryContactForWard(organizationId: string, setPrimaryContactForWardBody: SetPrimaryContactForWardBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryContactForWard(organizationId, setPrimaryContactForWardBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Updates the given appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {UpdateAppointmentRequestBody} updateAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAppointment(organizationId: string, updateAppointmentRequestBody: UpdateAppointmentRequestBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Appointment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAppointment(organizationId, updateAppointmentRequestBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary updates the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId organizationId of the organization the student of the guardian contact belongs to
         * @param {string} id Id of the guardian contact to update
         * @param {UpdateGuardianContactBody} updateGuardianContactBody the content of the reqeust
         * @param {string} [timePeriod] timePeriod of the organization the student of the guardian contact belongs to - necessary for classes and grades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGuardianContact(organizationId: string, id: string, updateGuardianContactBody: UpdateGuardianContactBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuardianContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGuardianContact(organizationId, id, updateGuardianContactBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Updates a notification. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {UpdateNotificationBody} updateNotificationBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNews(organizationId: string, id: string, updateNotificationBody: UpdateNotificationBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<News>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNews(organizationId, id, updateNotificationBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParentalMail(organizationId: string, id: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParentalMail(organizationId, id, parentalMailCreateBody, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates the additional mails of a parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<ParentalMailAdditionalMailUpdateOptions>} parentalMailAdditionalMailUpdateOptions 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateParentalMailAdditionalMails(organizationId: string, id: string, parentalMailAdditionalMailUpdateOptions: Array<ParentalMailAdditionalMailUpdateOptions>, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateParentalMailAdditionalMails(organizationId, id, parentalMailAdditionalMailUpdateOptions, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Uploads an attachment to an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadParentalMailAttachment(organizationId: string, id: string, timePeriod?: string, contentFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParentalMailAttachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadParentalMailAttachment(organizationId, id, timePeriod, contentFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ParentalCommunicationApi - factory interface
 * @export
 */
export const ParentalCommunicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParentalCommunicationApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Ban a given guardian for the specified ward id 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banGuardianContact(organizationId: string, guardianMail: string, studentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.banGuardianContact(organizationId, guardianMail, studentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Shares a file with a list of recipients 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {ShareContent} shareContent 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFileSharingList(organizationId: string, shareContent: ShareContent, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.changeFileSharingList(organizationId, shareContent, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Completes a parental mail draft and sends it. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.completeParentalMail(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Creates a appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {CreateAppointmentRequestBody} createAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(organizationId: string, createAppointmentRequestBody: CreateAppointmentRequestBody, timePeriod?: string, options?: any): AxiosPromise<Appointment> {
            return localVarFp.createAppointment(organizationId, createAppointmentRequestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Upload a file into our blob storage. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [contentFolderId] 
         * @param {Array<string>} [contentRecipients] 
         * @param {boolean} [contentShareWithOrganization] 
         * @param {boolean} [contentOverwrite] 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile(organizationId: string, contentFolderId?: string, contentRecipients?: Array<string>, contentShareWithOrganization?: boolean, contentOverwrite?: boolean, timePeriod?: string, contentFile?: any, options?: any): AxiosPromise<FileMetadata> {
            return localVarFp.createFile(organizationId, contentFolderId, contentRecipients, contentShareWithOrganization, contentOverwrite, timePeriod, contentFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Create a folder in the specified path. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [optionsFolderName] 
         * @param {string} [optionsFolderId] 
         * @param {Array<string>} [optionsRecipients] 
         * @param {boolean} [optionsShareWithOrganization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(organizationId: string, optionsFolderName?: string, optionsFolderId?: string, optionsRecipients?: Array<string>, optionsShareWithOrganization?: boolean, options?: any): AxiosPromise<FileMetadata> {
            return localVarFp.createFolder(organizationId, optionsFolderName, optionsFolderId, optionsRecipients, optionsShareWithOrganization, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary creates a new guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId the organization id for which we shall create the guardian contact
         * @param {CreateGuardianContactBody} createGuardianContactBody The content of the request
         * @param {string} [timePeriod] the current timePeriod so we can get the correct grades and classes for the student
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGuardianContact(organizationId: string, createGuardianContactBody: CreateGuardianContactBody, timePeriod?: string, options?: any): AxiosPromise<GuardianContact> {
            return localVarFp.createGuardianContact(organizationId, createGuardianContactBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts a mail merge to create invitations for the specified wards 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {GuardianContactCreateMailMergeBody} guardianContactCreateMailMergeBody 
         * @param {string} [culture] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMailMerge(organizationId: string, guardianContactCreateMailMergeBody: GuardianContactCreateMailMergeBody, culture?: string, timePeriod?: string, options?: any): AxiosPromise<string> {
            return localVarFp.createMailMerge(organizationId, guardianContactCreateMailMergeBody, culture, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Creates a new notification for the given organization and period. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {CreateEventBody} createEventBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNews(organizationId: string, createEventBody: CreateEventBody, timePeriod?: string, options?: any): AxiosPromise<News> {
            return localVarFp.createNews(organizationId, createEventBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Creates or updates the settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateSettings(organizationId: string, requestBody: { [key: string]: any; }, options?: any): AxiosPromise<ParentalCommunicationSettings> {
            return localVarFp.createOrUpdateSettings(organizationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li></ul>
         * @summary Creates a new linking invitation to a specified child, including a direct link, and a QR code. 🔒: ParentalCommunication.ShowModule
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {CreateParentInvitationRequest} createParentInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParentInvitation(organizationId: string, studentId: string, createParentInvitationRequest: CreateParentInvitationRequest, options?: any): AxiosPromise<CreateParentInvitationResponse> {
            return localVarFp.createParentInvitation(organizationId, studentId, createParentInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Creates a new parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParentalMail(organizationId: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any): AxiosPromise<ParentalMail> {
            return localVarFp.createParentalMail(organizationId, parentalMailCreateBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Deletes the given appointment. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAppointment(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteAppointment(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
         * @summary Delete a file or folder. 🔒: ParentalCommunication.FilesWriteAll
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(organizationId: string, fileId?: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFile(organizationId, fileId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Removes the connection between a guardian and a single ward (child) instead of banning the guardian. Other children of the guardian remain intact and the child can be re-linked later via a QR code. Idempotent: succeeds even when no active connection exists. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {string} guardianMail 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuardianConnection(organizationId: string, guardianMail: string, studentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGuardianConnection(organizationId, guardianMail, studentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary deletes the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId OrganizationId 
         * @param {string} guardianId id of the guardian contact to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuardianContact(organizationId: string, guardianId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGuardianContact(organizationId, guardianId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Deletes the given notification 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteNews(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<ParentalMail> {
            return localVarFp.deleteParentalMail(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Deletes an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParentalMailAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteParentalMailAttachment(organizationId, id, attachmentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Downloads an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} attachmentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any): AxiosPromise<ParentalMailAttachmentDownload> {
            return localVarFp.downloadAttachment(organizationId, id, attachmentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Generates and Downloads the CSV file of all responses of a parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadResponsesCsv(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<ParentalMailAttachmentDownload> {
            return localVarFp.downloadResponsesCsv(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowDrafts</li></ul>
         * @summary 🔒: Classbook.ShowModule, Absences.ShowDrafts
         * @param {string} organizationId 
         * @param {boolean} [enabledOnly] 
         * @param {string} [reasonDefinitionId] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any): AxiosPromise<Array<AbsenceReasonResponse>> {
            return localVarFp.getAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets all appointments of the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAppointments(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any): AxiosPromise<Array<Appointment>> {
            return localVarFp.getAllAppointments(organizationId, timePeriod, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Gets all metadata of files in the specified folder. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [folderId] 
         * @param {string} [search] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFilesMetadata(organizationId: string, folderId?: string, search?: string, timePeriod?: string, options?: any): AxiosPromise<Array<FileMetadata>> {
            return localVarFp.getAllFilesMetadata(organizationId, folderId, search, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets the guardian contacts, which are listed in the parental communication, for the given organization and the given filter 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId OrganizationId for which to get the guardian contacts
         * @param {string} [timePeriod] TimePeriod for which to get the guardian contacts Necessary to resolve the grades or classes and filter on them
         * @param {Array<string>} [filterByGradesOrClasses] list of revision ids of the grades or classes to filter the relevant students for which we shall get the guardian contacts
         * @param {string} [filterByName] string to filter the relevant students by name for which we shall get the guardian contacts
         * @param {FitlerByConnectedGuardians} [filterByConnectedGuardians] Defines how guardians should be filtered.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGuardianContacts(organizationId: string, timePeriod?: string, filterByGradesOrClasses?: Array<string>, filterByName?: string, filterByConnectedGuardians?: FitlerByConnectedGuardians, options?: any): AxiosPromise<Array<StudentWithPrimaryGuardianContact>> {
            return localVarFp.getAllGuardianContacts(organizationId, timePeriod, filterByGradesOrClasses, filterByName, filterByConnectedGuardians, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.News</li></ul>
         * @summary Gets all notifications of the given organization for the given period 🔒: ParentalCommunication.News
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {boolean} [includePlanned] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNews(organizationId: string, timePeriod?: string, includePlanned?: boolean, options?: any): AxiosPromise<Array<News>> {
            return localVarFp.getAllNews(organizationId, timePeriod, includePlanned, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all potential group recipients of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {ParentalMailGroupRecipientType} [entityType] 
         * @param {string} [search] 
         * @param {string} [courseId] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalMailGroupRecipients(organizationId: string, timePeriod?: string, entityType?: ParentalMailGroupRecipientType, search?: string, courseId?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfParentalMailGroupRecipient> {
            return localVarFp.getAllParentalMailGroupRecipients(organizationId, timePeriod, entityType, search, courseId, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all parental mails of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [courseId] 
         * @param {GetAllParentalMailSortBy} [sortBy] 
         * @param {GetAllParentalMailSortDirection} [sortDirection] 
         * @param {string} [sentFrom] 
         * @param {string} [sentTo] 
         * @param {boolean} [preloadStats] 
         * @param {string} [search] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParentalMails(organizationId: string, timePeriod?: string, courseId?: string, sortBy?: GetAllParentalMailSortBy, sortDirection?: GetAllParentalMailSortDirection, sentFrom?: string, sentTo?: string, preloadStats?: boolean, search?: string, pageSize?: number, page?: number, options?: any): AxiosPromise<PagedOfParentalMail> {
            return localVarFp.getAllParentalMails(organizationId, timePeriod, courseId, sortBy, sortDirection, sentFrom, sentTo, preloadStats, search, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all grades and classes
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRecipients(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Recipient>> {
            return localVarFp.getAllRecipients(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Gets the appointment based on the given id and the given organization. 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<Appointment> {
            return localVarFp.getAppointment(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getB2CUserFor(organizationId: string, studentId: string, options?: any): AxiosPromise<Array<B2CUser>> {
            return localVarFp.getB2CUserFor(organizationId, studentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary starts the process to create the invitation mails for the given student 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadLinkForMailMerge(organizationId: string, jobId: string, options?: any): AxiosPromise<MailMergeWithDownloadLink> {
            return localVarFp.getDownloadLinkForMailMerge(organizationId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
         * @summary Generate a download link for a specific file. Has availability of 60 minutes. 🔒: ParentalCommunication.Files
         * @param {string} organizationId 
         * @param {string} [fileId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(organizationId: string, fileId?: string, options?: any): AxiosPromise<FileDownload> {
            return localVarFp.getFile(organizationId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Get alle guardian contacts for the specified stuudent 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId organization id for the student we shall get the guardian contacts for
         * @param {string} studentId student if for which we shall get the guardian contacts for
         * @param {string} [timePeriod] time period for which we shall get the guardian contacts for - necessary for the grades and classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuardianContactsForStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any): AxiosPromise<StudentWithGuardianContacts> {
            return localVarFp.getGuardianContactsForStudent(organizationId, studentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsFor(organizationId: string, studentId: string, timePeriod?: string, options?: any): AxiosPromise<Array<GuardianContactInvitationResponse>> {
            return localVarFp.getInvitationsFor(organizationId, studentId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Role-scoped counterpart of GetAllNews: teachers get the news they published or received, students the news of their own classes and grades. Serves the cockpit news widget and returns the same payload as the Teams cockpit endpoint.
         * @summary Gets the newest news of the calling user for the given period.
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNews(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<News>> {
            return localVarFp.getMyNews(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<ParentalMail> {
            return localVarFp.getParentalMail(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets the responses of a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailResponses(organizationId: string, id: string, timePeriod?: string, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any): AxiosPromise<PagedOfParentalMailResponse> {
            return localVarFp.getParentalMailResponses(organizationId, id, timePeriod, sortBy, sortDirection, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Gets all wards of a parental mail for the given organization and period paged 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {boolean} [filterOnlyMissingContacts] 
         * @param {GetAllParentalMailWardsSortBy} [sortBy] 
         * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParentalMailWards(organizationId: string, id: string, timePeriod?: string, filterOnlyMissingContacts?: boolean, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any): AxiosPromise<PagedOfParentalMailWardParents> {
            return localVarFp.getParentalMailWards(organizationId, id, timePeriod, filterOnlyMissingContacts, sortBy, sortDirection, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
         * @summary Gets all settings of the parental communication 🔒: ParentalCommunication.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(organizationId: string, options?: any): AxiosPromise<ParentalCommunicationSettings> {
            return localVarFp.getSettings(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
         * @summary Gets all ward connections for the specified ward 🔒: ParentalCommunication.GuardianContacts
         * @param {string} organizationId The organization ID
         * @param {string} wardId The ID of the ward to get connections for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWardConnectionsFor(organizationId: string, wardId: string, options?: any): AxiosPromise<WardConnectionsResponse> {
            return localVarFp.getWardConnectionsFor(organizationId, wardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Refreshes the parents and mails of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.refreshParentalMail(organizationId, id, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Resends a parental mail to a set of given email addresses 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<string>} requestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendParentalMail(organizationId: string, id: string, requestBody: Array<string>, timePeriod?: string, options?: any): AxiosPromise<ParentalMail> {
            return localVarFp.resendParentalMail(organizationId, id, requestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary Invalidates ALL QR-code invitations generated for the given ward, so existing codes can no longer be used to (re-)link the child. 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} studentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAllInvitationsForWard(organizationId: string, studentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeAllInvitationsForWard(organizationId, studentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
         * @summary 🔒: ParentalCommunication.GuardianContactsInvitations
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(organizationId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeInvitation(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary Set a guardian contact as the primary contact for a specific ward. Automatically removes primary status from other contacts for this ward. 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId 
         * @param {SetPrimaryContactForWardBody} setPrimaryContactForWardBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryContactForWard(organizationId: string, setPrimaryContactForWardBody: SetPrimaryContactForWardBody, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.setPrimaryContactForWard(organizationId, setPrimaryContactForWardBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
         * @summary Updates the given appointment 🔒: ParentalCommunication.Calendar
         * @param {string} organizationId 
         * @param {UpdateAppointmentRequestBody} updateAppointmentRequestBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment(organizationId: string, updateAppointmentRequestBody: UpdateAppointmentRequestBody, timePeriod?: string, options?: any): AxiosPromise<Appointment> {
            return localVarFp.updateAppointment(organizationId, updateAppointmentRequestBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
         * @summary updates the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
         * @param {string} organizationId organizationId of the organization the student of the guardian contact belongs to
         * @param {string} id Id of the guardian contact to update
         * @param {UpdateGuardianContactBody} updateGuardianContactBody the content of the reqeust
         * @param {string} [timePeriod] timePeriod of the organization the student of the guardian contact belongs to - necessary for classes and grades
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuardianContact(organizationId: string, id: string, updateGuardianContactBody: UpdateGuardianContactBody, timePeriod?: string, options?: any): AxiosPromise<GuardianContact> {
            return localVarFp.updateGuardianContact(organizationId, id, updateGuardianContactBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
         * @summary Updates a notification. 🔒: ParentalCommunication.NewsWriteAll
         * @param {string} organizationId 
         * @param {string} id 
         * @param {UpdateNotificationBody} updateNotificationBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNews(organizationId: string, id: string, updateNotificationBody: UpdateNotificationBody, timePeriod?: string, options?: any): AxiosPromise<News> {
            return localVarFp.updateNews(organizationId, id, updateNotificationBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {ParentalMailCreateBody} parentalMailCreateBody 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParentalMail(organizationId: string, id: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any): AxiosPromise<ParentalMail> {
            return localVarFp.updateParentalMail(organizationId, id, parentalMailCreateBody, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Updates the additional mails of a parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {Array<ParentalMailAdditionalMailUpdateOptions>} parentalMailAdditionalMailUpdateOptions 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateParentalMailAdditionalMails(organizationId: string, id: string, parentalMailAdditionalMailUpdateOptions: Array<ParentalMailAdditionalMailUpdateOptions>, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateParentalMailAdditionalMails(organizationId, id, parentalMailAdditionalMailUpdateOptions, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
         * @summary Uploads an attachment to an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
         * @param {string} organizationId 
         * @param {string} id 
         * @param {string} [timePeriod] 
         * @param {any} [contentFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadParentalMailAttachment(organizationId: string, id: string, timePeriod?: string, contentFile?: any, options?: any): AxiosPromise<ParentalMailAttachment> {
            return localVarFp.uploadParentalMailAttachment(organizationId, id, timePeriod, contentFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParentalCommunicationApi - object-oriented interface
 * @export
 * @class ParentalCommunicationApi
 * @extends {BaseAPI}
 */
export class ParentalCommunicationApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary Ban a given guardian for the specified ward id 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId 
     * @param {string} guardianMail 
     * @param {string} studentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public banGuardianContact(organizationId: string, guardianMail: string, studentId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).banGuardianContact(organizationId, guardianMail, studentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
     * @summary Shares a file with a list of recipients 🔒: ParentalCommunication.FilesWriteAll
     * @param {string} organizationId 
     * @param {ShareContent} shareContent 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public changeFileSharingList(organizationId: string, shareContent: ShareContent, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).changeFileSharingList(organizationId, shareContent, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Completes a parental mail draft and sends it. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public completeParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).completeParentalMail(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
     * @summary Creates a appointment 🔒: ParentalCommunication.Calendar
     * @param {string} organizationId 
     * @param {CreateAppointmentRequestBody} createAppointmentRequestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createAppointment(organizationId: string, createAppointmentRequestBody: CreateAppointmentRequestBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createAppointment(organizationId, createAppointmentRequestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
     * @summary Upload a file into our blob storage. 🔒: ParentalCommunication.FilesWriteAll
     * @param {string} organizationId 
     * @param {string} [contentFolderId] 
     * @param {Array<string>} [contentRecipients] 
     * @param {boolean} [contentShareWithOrganization] 
     * @param {boolean} [contentOverwrite] 
     * @param {string} [timePeriod] 
     * @param {any} [contentFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createFile(organizationId: string, contentFolderId?: string, contentRecipients?: Array<string>, contentShareWithOrganization?: boolean, contentOverwrite?: boolean, timePeriod?: string, contentFile?: any, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createFile(organizationId, contentFolderId, contentRecipients, contentShareWithOrganization, contentOverwrite, timePeriod, contentFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
     * @summary Create a folder in the specified path. 🔒: ParentalCommunication.FilesWriteAll
     * @param {string} organizationId 
     * @param {string} [optionsFolderName] 
     * @param {string} [optionsFolderId] 
     * @param {Array<string>} [optionsRecipients] 
     * @param {boolean} [optionsShareWithOrganization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createFolder(organizationId: string, optionsFolderName?: string, optionsFolderId?: string, optionsRecipients?: Array<string>, optionsShareWithOrganization?: boolean, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createFolder(organizationId, optionsFolderName, optionsFolderId, optionsRecipients, optionsShareWithOrganization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary creates a new guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId the organization id for which we shall create the guardian contact
     * @param {CreateGuardianContactBody} createGuardianContactBody The content of the request
     * @param {string} [timePeriod] the current timePeriod so we can get the correct grades and classes for the student
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createGuardianContact(organizationId: string, createGuardianContactBody: CreateGuardianContactBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createGuardianContact(organizationId, createGuardianContactBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
     * @summary starts a mail merge to create invitations for the specified wards 🔒: ParentalCommunication.GuardianContactsInvitations
     * @param {string} organizationId 
     * @param {GuardianContactCreateMailMergeBody} guardianContactCreateMailMergeBody 
     * @param {string} [culture] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createMailMerge(organizationId: string, guardianContactCreateMailMergeBody: GuardianContactCreateMailMergeBody, culture?: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createMailMerge(organizationId, guardianContactCreateMailMergeBody, culture, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
     * @summary Creates a new notification for the given organization and period. 🔒: ParentalCommunication.NewsWriteAll
     * @param {string} organizationId 
     * @param {CreateEventBody} createEventBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createNews(organizationId: string, createEventBody: CreateEventBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createNews(organizationId, createEventBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
     * @summary Creates or updates the settings of the parental communication 🔒: ParentalCommunication.Settings
     * @param {string} organizationId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createOrUpdateSettings(organizationId: string, requestBody: { [key: string]: any; }, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createOrUpdateSettings(organizationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li></ul>
     * @summary Creates a new linking invitation to a specified child, including a direct link, and a QR code. 🔒: ParentalCommunication.ShowModule
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {CreateParentInvitationRequest} createParentInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createParentInvitation(organizationId: string, studentId: string, createParentInvitationRequest: CreateParentInvitationRequest, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createParentInvitation(organizationId, studentId, createParentInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Creates a new parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {ParentalMailCreateBody} parentalMailCreateBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public createParentalMail(organizationId: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).createParentalMail(organizationId, parentalMailCreateBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
     * @summary Deletes the given appointment. 🔒: ParentalCommunication.Calendar
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteAppointment(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteAppointment(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.FilesWriteAll</li></ul>
     * @summary Delete a file or folder. 🔒: ParentalCommunication.FilesWriteAll
     * @param {string} organizationId 
     * @param {string} [fileId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteFile(organizationId: string, fileId?: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteFile(organizationId, fileId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary Removes the connection between a guardian and a single ward (child) instead of banning the guardian. Other children of the guardian remain intact and the child can be re-linked later via a QR code. Idempotent: succeeds even when no active connection exists. 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId 
     * @param {string} guardianMail 
     * @param {string} studentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteGuardianConnection(organizationId: string, guardianMail: string, studentId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteGuardianConnection(organizationId, guardianMail, studentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary deletes the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId OrganizationId 
     * @param {string} guardianId id of the guardian contact to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteGuardianContact(organizationId: string, guardianId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteGuardianContact(organizationId, guardianId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
     * @summary Deletes the given notification 🔒: ParentalCommunication.NewsWriteAll
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteNews(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteNews(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Deletes an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteParentalMail(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Deletes an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} attachmentId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public deleteParentalMailAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).deleteParentalMailAttachment(organizationId, id, attachmentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Downloads an attachment of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} attachmentId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public downloadAttachment(organizationId: string, id: string, attachmentId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).downloadAttachment(organizationId, id, attachmentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Generates and Downloads the CSV file of all responses of a parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public downloadResponsesCsv(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).downloadResponsesCsv(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Classbook.ShowModule</li><li>Absences.ShowDrafts</li></ul>
     * @summary 🔒: Classbook.ShowModule, Absences.ShowDrafts
     * @param {string} organizationId 
     * @param {boolean} [enabledOnly] 
     * @param {string} [reasonDefinitionId] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAbsenceReasons(organizationId: string, enabledOnly?: boolean, reasonDefinitionId?: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAbsenceReasons(organizationId, enabledOnly, reasonDefinitionId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
     * @summary Gets all appointments of the given organization. 🔒: ParentalCommunication.Calendar
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllAppointments(organizationId: string, timePeriod?: string, start?: string, end?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllAppointments(organizationId, timePeriod, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
     * @summary Gets all metadata of files in the specified folder. 🔒: ParentalCommunication.Files
     * @param {string} organizationId 
     * @param {string} [folderId] 
     * @param {string} [search] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllFilesMetadata(organizationId: string, folderId?: string, search?: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllFilesMetadata(organizationId, folderId, search, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
     * @summary Gets the guardian contacts, which are listed in the parental communication, for the given organization and the given filter 🔒: ParentalCommunication.GuardianContacts
     * @param {string} organizationId OrganizationId for which to get the guardian contacts
     * @param {string} [timePeriod] TimePeriod for which to get the guardian contacts Necessary to resolve the grades or classes and filter on them
     * @param {Array<string>} [filterByGradesOrClasses] list of revision ids of the grades or classes to filter the relevant students for which we shall get the guardian contacts
     * @param {string} [filterByName] string to filter the relevant students by name for which we shall get the guardian contacts
     * @param {FitlerByConnectedGuardians} [filterByConnectedGuardians] Defines how guardians should be filtered.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllGuardianContacts(organizationId: string, timePeriod?: string, filterByGradesOrClasses?: Array<string>, filterByName?: string, filterByConnectedGuardians?: FitlerByConnectedGuardians, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllGuardianContacts(organizationId, timePeriod, filterByGradesOrClasses, filterByName, filterByConnectedGuardians, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.News</li></ul>
     * @summary Gets all notifications of the given organization for the given period 🔒: ParentalCommunication.News
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {boolean} [includePlanned] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllNews(organizationId: string, timePeriod?: string, includePlanned?: boolean, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllNews(organizationId, timePeriod, includePlanned, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Gets all potential group recipients of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {ParentalMailGroupRecipientType} [entityType] 
     * @param {string} [search] 
     * @param {string} [courseId] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllParentalMailGroupRecipients(organizationId: string, timePeriod?: string, entityType?: ParentalMailGroupRecipientType, search?: string, courseId?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllParentalMailGroupRecipients(organizationId, timePeriod, entityType, search, courseId, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Gets all parental mails of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [courseId] 
     * @param {GetAllParentalMailSortBy} [sortBy] 
     * @param {GetAllParentalMailSortDirection} [sortDirection] 
     * @param {string} [sentFrom] 
     * @param {string} [sentTo] 
     * @param {boolean} [preloadStats] 
     * @param {string} [search] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllParentalMails(organizationId: string, timePeriod?: string, courseId?: string, sortBy?: GetAllParentalMailSortBy, sortDirection?: GetAllParentalMailSortDirection, sentFrom?: string, sentTo?: string, preloadStats?: boolean, search?: string, pageSize?: number, page?: number, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllParentalMails(organizationId, timePeriod, courseId, sortBy, sortDirection, sentFrom, sentTo, preloadStats, search, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all grades and classes
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAllRecipients(organizationId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAllRecipients(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
     * @summary Gets the appointment based on the given id and the given organization. 🔒: ParentalCommunication.Calendar
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getAppointment(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getAppointment(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
     * @summary 🔒: ParentalCommunication.GuardianContacts
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getB2CUserFor(organizationId: string, studentId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getB2CUserFor(organizationId, studentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
     * @summary starts the process to create the invitation mails for the given student 🔒: ParentalCommunication.GuardianContactsInvitations
     * @param {string} organizationId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getDownloadLinkForMailMerge(organizationId: string, jobId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getDownloadLinkForMailMerge(organizationId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Files</li></ul>
     * @summary Generate a download link for a specific file. Has availability of 60 minutes. 🔒: ParentalCommunication.Files
     * @param {string} organizationId 
     * @param {string} [fileId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getFile(organizationId: string, fileId?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getFile(organizationId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
     * @summary Get alle guardian contacts for the specified stuudent 🔒: ParentalCommunication.GuardianContacts
     * @param {string} organizationId organization id for the student we shall get the guardian contacts for
     * @param {string} studentId student if for which we shall get the guardian contacts for
     * @param {string} [timePeriod] time period for which we shall get the guardian contacts for - necessary for the grades and classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getGuardianContactsForStudent(organizationId: string, studentId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getGuardianContactsForStudent(organizationId, studentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
     * @summary 🔒: ParentalCommunication.GuardianContacts
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getInvitationsFor(organizationId: string, studentId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getInvitationsFor(organizationId, studentId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Role-scoped counterpart of GetAllNews: teachers get the news they published or received, students the news of their own classes and grades. Serves the cockpit news widget and returns the same payload as the Teams cockpit endpoint.
     * @summary Gets the newest news of the calling user for the given period.
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getMyNews(organizationId: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getMyNews(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Gets a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getParentalMail(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Gets the responses of a single parental mail of the given organization for the given period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {GetAllParentalMailWardsSortBy} [sortBy] 
     * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getParentalMailResponses(organizationId: string, id: string, timePeriod?: string, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getParentalMailResponses(organizationId, id, timePeriod, sortBy, sortDirection, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Gets all wards of a parental mail for the given organization and period paged 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {boolean} [filterOnlyMissingContacts] 
     * @param {GetAllParentalMailWardsSortBy} [sortBy] 
     * @param {GetAllParentalMailWardsSortDirection} [sortDirection] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getParentalMailWards(organizationId: string, id: string, timePeriod?: string, filterOnlyMissingContacts?: boolean, sortBy?: GetAllParentalMailWardsSortBy, sortDirection?: GetAllParentalMailWardsSortDirection, pageSize?: number, page?: number, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getParentalMailWards(organizationId, id, timePeriod, filterOnlyMissingContacts, sortBy, sortDirection, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Settings</li></ul>
     * @summary Gets all settings of the parental communication 🔒: ParentalCommunication.Settings
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getSettings(organizationId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getSettings(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContacts</li></ul>
     * @summary Gets all ward connections for the specified ward 🔒: ParentalCommunication.GuardianContacts
     * @param {string} organizationId The organization ID
     * @param {string} wardId The ID of the ward to get connections for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public getWardConnectionsFor(organizationId: string, wardId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).getWardConnectionsFor(organizationId, wardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Refreshes the parents and mails of an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public refreshParentalMail(organizationId: string, id: string, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).refreshParentalMail(organizationId, id, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Resends a parental mail to a set of given email addresses 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {Array<string>} requestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public resendParentalMail(organizationId: string, id: string, requestBody: Array<string>, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).resendParentalMail(organizationId, id, requestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
     * @summary Invalidates ALL QR-code invitations generated for the given ward, so existing codes can no longer be used to (re-)link the child. 🔒: ParentalCommunication.GuardianContactsInvitations
     * @param {string} organizationId 
     * @param {string} studentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public revokeAllInvitationsForWard(organizationId: string, studentId: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).revokeAllInvitationsForWard(organizationId, studentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsInvitations</li></ul>
     * @summary 🔒: ParentalCommunication.GuardianContactsInvitations
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public revokeInvitation(organizationId: string, id: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).revokeInvitation(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary Set a guardian contact as the primary contact for a specific ward. Automatically removes primary status from other contacts for this ward. 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId 
     * @param {SetPrimaryContactForWardBody} setPrimaryContactForWardBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public setPrimaryContactForWard(organizationId: string, setPrimaryContactForWardBody: SetPrimaryContactForWardBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).setPrimaryContactForWard(organizationId, setPrimaryContactForWardBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.Calendar</li></ul>
     * @summary Updates the given appointment 🔒: ParentalCommunication.Calendar
     * @param {string} organizationId 
     * @param {UpdateAppointmentRequestBody} updateAppointmentRequestBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public updateAppointment(organizationId: string, updateAppointmentRequestBody: UpdateAppointmentRequestBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).updateAppointment(organizationId, updateAppointmentRequestBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.GuardianContactsWriteAll</li></ul>
     * @summary updates the specified guardian contact 🔒: ParentalCommunication.GuardianContactsWriteAll
     * @param {string} organizationId organizationId of the organization the student of the guardian contact belongs to
     * @param {string} id Id of the guardian contact to update
     * @param {UpdateGuardianContactBody} updateGuardianContactBody the content of the reqeust
     * @param {string} [timePeriod] timePeriod of the organization the student of the guardian contact belongs to - necessary for classes and grades
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public updateGuardianContact(organizationId: string, id: string, updateGuardianContactBody: UpdateGuardianContactBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).updateGuardianContact(organizationId, id, updateGuardianContactBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.NewsWriteAll</li></ul>
     * @summary Updates a notification. 🔒: ParentalCommunication.NewsWriteAll
     * @param {string} organizationId 
     * @param {string} id 
     * @param {UpdateNotificationBody} updateNotificationBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public updateNews(organizationId: string, id: string, updateNotificationBody: UpdateNotificationBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).updateNews(organizationId, id, updateNotificationBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Updates an existing parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {ParentalMailCreateBody} parentalMailCreateBody 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public updateParentalMail(organizationId: string, id: string, parentalMailCreateBody: ParentalMailCreateBody, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).updateParentalMail(organizationId, id, parentalMailCreateBody, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Updates the additional mails of a parental mail for the given organization and period 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {Array<ParentalMailAdditionalMailUpdateOptions>} parentalMailAdditionalMailUpdateOptions 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public updateParentalMailAdditionalMails(organizationId: string, id: string, parentalMailAdditionalMailUpdateOptions: Array<ParentalMailAdditionalMailUpdateOptions>, timePeriod?: string, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).updateParentalMailAdditionalMails(organizationId, id, parentalMailAdditionalMailUpdateOptions, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ParentalCommunication.ShowModule</li><li>Courses.ParentalLettersReadWrite</li></ul>
     * @summary Uploads an attachment to an existing parental mail. 🔒: ParentalCommunication.ShowModule, Courses.ParentalLettersReadWrite
     * @param {string} organizationId 
     * @param {string} id 
     * @param {string} [timePeriod] 
     * @param {any} [contentFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParentalCommunicationApi
     */
    public uploadParentalMailAttachment(organizationId: string, id: string, timePeriod?: string, contentFile?: any, options?: any) {
        return ParentalCommunicationApiFp(this.configuration).uploadParentalMailAttachment(organizationId, id, timePeriod, contentFile, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordsApi - axios parameter creator
 * @export
 */
export const PasswordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of a specified user. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordParameters} changeUserPasswordParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPassword: async (organizationId: string, changeUserPasswordParameters: ChangeUserPasswordParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeUserPassword', 'organizationId', organizationId)
            // verify required parameter 'changeUserPasswordParameters' is not null or undefined
            assertParamExists('changeUserPassword', 'changeUserPasswordParameters', changeUserPasswordParameters)
            const localVarPath = `/api/v2/Passwords/{organizationId}/changeUserPassword`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserPasswordParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of multiple users in a single request. All targets receive the same new password and it is always issued as a one-time password (PasswordIsPermanentValid is forced to false). Per-user failures are reported via the returned list; the batch never aborts on the first error. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordsParameters} changeUserPasswordsParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPasswords: async (organizationId: string, changeUserPasswordsParameters: ChangeUserPasswordsParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeUserPasswords', 'organizationId', organizationId)
            // verify required parameter 'changeUserPasswordsParameters' is not null or undefined
            assertParamExists('changeUserPasswords', 'changeUserPasswordsParameters', changeUserPasswordsParameters)
            const localVarPath = `/api/v2/Passwords/{organizationId}/changeUserPasswords`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserPasswordsParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllBasicCourses', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Passwords/{organizationId}/courses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllUsers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Passwords/{organizationId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all workgroups the user has effective access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkgroups: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllWorkgroups', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Passwords/{organizationId}/workgroups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword: async (organizationId: string, validationParameters: ValidationParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validatePassword', 'organizationId', organizationId)
            // verify required parameter 'validationParameters' is not null or undefined
            assertParamExists('validatePassword', 'validationParameters', validationParameters)
            const localVarPath = `/api/v2/Passwords/{organizationId}/validatePassword`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordsApi - functional programming interface
 * @export
 */
export const PasswordsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of a specified user. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordParameters} changeUserPasswordParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserPassword(organizationId: string, changeUserPasswordParameters: ChangeUserPasswordParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserPassword(organizationId, changeUserPasswordParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of multiple users in a single request. All targets receive the same new password and it is always issued as a one-time password (PasswordIsPermanentValid is forced to false). Per-user failures are reported via the returned list; the batch never aborts on the first error. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordsParameters} changeUserPasswordsParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserPasswords(organizationId: string, changeUserPasswordsParameters: ChangeUserPasswordsParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChangePasswordResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserPasswords(organizationId, changeUserPasswordsParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfPasswordsCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PasswordsUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all workgroups the user has effective access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWorkgroups(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfPasswordsWorkgroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWorkgroups(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePassword(organizationId, validationParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordsApi - factory interface
 * @export
 */
export const PasswordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of a specified user. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordParameters} changeUserPasswordParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPassword(organizationId: string, changeUserPasswordParameters: ChangeUserPasswordParameters, options?: any): AxiosPromise<ChangePasswordResponse> {
            return localVarFp.changeUserPassword(organizationId, changeUserPasswordParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Changes the password of multiple users in a single request. All targets receive the same new password and it is always issued as a one-time password (PasswordIsPermanentValid is forced to false). Per-user failures are reported via the returned list; the batch never aborts on the first error. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ChangeUserPasswordsParameters} changeUserPasswordsParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPasswords(organizationId: string, changeUserPasswordsParameters: ChangeUserPasswordsParameters, options?: any): AxiosPromise<Array<ChangePasswordResponse>> {
            return localVarFp.changeUserPasswords(organizationId, changeUserPasswordsParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all basic courses the user has effectively access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfPasswordsCoursesResponse> {
            return localVarFp.getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(organizationId: string, options?: any): AxiosPromise<Array<PasswordsUserResponse>> {
            return localVarFp.getAllUsers(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
         * @summary Returns all workgroups the user has effective access to. 🔒: Passwords.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkgroups(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfPasswordsWorkgroupsResponse> {
            return localVarFp.getAllWorkgroups(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): AxiosPromise<ValidatePasswordResponse> {
            return localVarFp.validatePassword(organizationId, validationParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordsApi - object-oriented interface
 * @export
 * @class PasswordsApi
 * @extends {BaseAPI}
 */
export class PasswordsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
     * @summary Changes the password of a specified user. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
     * @param {string} organizationId 
     * @param {ChangeUserPasswordParameters} changeUserPasswordParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public changeUserPassword(organizationId: string, changeUserPasswordParameters: ChangeUserPasswordParameters, options?: any) {
        return PasswordsApiFp(this.configuration).changeUserPassword(organizationId, changeUserPasswordParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
     * @summary Changes the password of multiple users in a single request. All targets receive the same new password and it is always issued as a one-time password (PasswordIsPermanentValid is forced to false). Per-user failures are reported via the returned list; the batch never aborts on the first error. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
     * @param {string} organizationId 
     * @param {ChangeUserPasswordsParameters} changeUserPasswordsParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public changeUserPasswords(organizationId: string, changeUserPasswordsParameters: ChangeUserPasswordsParameters, options?: any) {
        return PasswordsApiFp(this.configuration).changeUserPasswords(organizationId, changeUserPasswordsParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
     * @summary Returns all basic courses the user has effectively access to. 🔒: Passwords.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public getAllBasicCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return PasswordsApiFp(this.configuration).getAllBasicCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
     * @summary 🔒: Passwords.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public getAllUsers(organizationId: string, options?: any) {
        return PasswordsApiFp(this.configuration).getAllUsers(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Passwords.ShowModule</li></ul>
     * @summary Returns all workgroups the user has effective access to. 🔒: Passwords.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public getAllWorkgroups(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return PasswordsApiFp(this.configuration).getAllWorkgroups(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Passwords.ChangeGroupMemberPasswords</li><li>Passwords.ChangeUserPasswords</li><li>Courses.ChangePasswords</li><li>Users.ChangeStudentsPasswords</li><li>Users.ChangePasswordsForUserTemplate</li></ul>
     * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Passwords.ChangeGroupMemberPasswords, Passwords.ChangeUserPasswords, Courses.ChangePasswords, Users.ChangeStudentsPasswords, Users.ChangePasswordsForUserTemplate
     * @param {string} organizationId 
     * @param {ValidationParameters} validationParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordsApi
     */
    public validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any) {
        return PasswordsApiFp(this.configuration).validatePassword(organizationId, validationParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsCreateEntry} rolePermissionsCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermissionsRole: async (organizationId: string, rolePermissionsCreateEntry: RolePermissionsCreateEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPermissionsRole', 'organizationId', organizationId)
            // verify required parameter 'rolePermissionsCreateEntry' is not null or undefined
            assertParamExists('createPermissionsRole', 'rolePermissionsCreateEntry', rolePermissionsCreateEntry)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rolePermissionsCreateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsCache: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePermissionsCache', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/cache`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsRole: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePermissionsRole', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePermissionsRole', 'id', id)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedActions: async (organizationId: string, name: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllowedActions', 'organizationId', organizationId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getAllowedActions', 'name', name)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/allowedActions/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedActionsSyncState: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllowedActionsSyncState', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/allowedActions/checkSyncState`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary Returns that state of the current app permission consent. A url to consent to the permissions is also provided. 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent: async (organizationId: string, appId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getConsent', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/consent`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appId !== undefined) {
                localVarQueryParameter['appId'] = appId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the state of the consent of a specific required app permission.
         * @param {string} organizationId 
         * @param {string} permissionId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentOfPermission: async (organizationId: string, permissionId: string, appId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getConsentOfPermission', 'organizationId', organizationId)
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('getConsentOfPermission', 'permissionId', permissionId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/consent/{permissionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"permissionId"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (appId !== undefined) {
                localVarQueryParameter['appId'] = appId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsOfMyself: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEffectivePermissionsOfMyself', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/effective`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsOfUser: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEffectivePermissionsOfUser', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEffectivePermissionsOfUser', 'userId', userId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/effective/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsModules: async (organizationId: string, name: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermissionsModules', 'organizationId', organizationId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getPermissionsModules', 'name', name)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/modules/{name}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsModulesAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermissionsModulesAll', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/modules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRole: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPermissionsRole', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermissionsRole', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRoleMembers: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermissionsRoleMembers', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPermissionsRoleMembers', 'id', id)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles/{id}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRoles: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermissionsRoles', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllowedActions: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncAllowedActions', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/allowedActions/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsUpdateEntry} rolePermissionsUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionsRole: async (organizationId: string, rolePermissionsUpdateEntry: RolePermissionsUpdateEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePermissionsRole', 'organizationId', organizationId)
            // verify required parameter 'rolePermissionsUpdateEntry' is not null or undefined
            assertParamExists('updatePermissionsRole', 'rolePermissionsUpdateEntry', rolePermissionsUpdateEntry)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rolePermissionsUpdateEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.WriteRoleMembers
         * @param {string} id 
         * @param {string} organizationId 
         * @param {MemberUpdateChanges} memberUpdateChanges 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionsRoleMembers: async (id: string, organizationId: string, memberUpdateChanges: MemberUpdateChanges, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePermissionsRoleMembers', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePermissionsRoleMembers', 'organizationId', organizationId)
            // verify required parameter 'memberUpdateChanges' is not null or undefined
            assertParamExists('updatePermissionsRoleMembers', 'memberUpdateChanges', memberUpdateChanges)
            const localVarPath = `/api/v2/Permissions/of/{organizationId}/roles/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberUpdateChanges, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsCreateEntry} rolePermissionsCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPermissionsRole(organizationId: string, rolePermissionsCreateEntry: RolePermissionsCreateEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPermissionsRole(organizationId, rolePermissionsCreateEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePermissionsCache(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePermissionsCache(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePermissionsRole(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePermissionsRole(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllowedActions(organizationId: string, name: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllowedActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllowedActions(organizationId, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllowedActionsSyncState(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllowedActionsSyncState(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary Returns that state of the current app permission consent. A url to consent to the permissions is also provided. 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsent(organizationId: string, appId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppConsent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsent(organizationId, appId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the state of the consent of a specific required app permission.
         * @param {string} organizationId 
         * @param {string} permissionId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentOfPermission(organizationId: string, permissionId: string, appId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionConsent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentOfPermission(organizationId, permissionId, appId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEffectivePermissionsOfMyself(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectivePermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEffectivePermissionsOfMyself(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEffectivePermissionsOfUser(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEffectivePermissionsOfUser(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsModules(organizationId: string, name: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModulePermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsModules(organizationId, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsModulesAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModulePermissions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsModulesAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsRole(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsRole(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsRoleMembers(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsRoleMembers(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionsRoles(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RolePermissions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionsRoles(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllowedActions(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllowedActions(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsUpdateEntry} rolePermissionsUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissionsRole(organizationId: string, rolePermissionsUpdateEntry: RolePermissionsUpdateEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissionsRole(organizationId, rolePermissionsUpdateEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.WriteRoleMembers
         * @param {string} id 
         * @param {string} organizationId 
         * @param {MemberUpdateChanges} memberUpdateChanges 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissionsRoleMembers(id: string, organizationId: string, memberUpdateChanges: MemberUpdateChanges, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissionsRoleMembers(id, organizationId, memberUpdateChanges, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsCreateEntry} rolePermissionsCreateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermissionsRole(organizationId: string, rolePermissionsCreateEntry: RolePermissionsCreateEntry, options?: any): AxiosPromise<RolePermissions> {
            return localVarFp.createPermissionsRole(organizationId, rolePermissionsCreateEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsCache(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePermissionsCache(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionsRole(organizationId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePermissionsRole(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedActions(organizationId: string, name: string, options?: any): AxiosPromise<AllowedActionsResponse> {
            return localVarFp.getAllowedActions(organizationId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllowedActionsSyncState(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllowedActionsSyncState(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary Returns that state of the current app permission consent. A url to consent to the permissions is also provided. 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsent(organizationId: string, appId?: string, options?: any): AxiosPromise<AppConsent> {
            return localVarFp.getConsent(organizationId, appId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the state of the consent of a specific required app permission.
         * @param {string} organizationId 
         * @param {string} permissionId 
         * @param {string} [appId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentOfPermission(organizationId: string, permissionId: string, appId?: string, options?: any): AxiosPromise<PermissionConsent> {
            return localVarFp.getConsentOfPermission(organizationId, permissionId, appId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsOfMyself(organizationId: string, options?: any): AxiosPromise<EffectivePermissionsResponse> {
            return localVarFp.getEffectivePermissionsOfMyself(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectivePermissionsOfUser(organizationId: string, userId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getEffectivePermissionsOfUser(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsModules(organizationId: string, name: string, options?: any): AxiosPromise<ModulePermissions> {
            return localVarFp.getPermissionsModules(organizationId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsModulesAll(organizationId: string, options?: any): AxiosPromise<Array<ModulePermissions>> {
            return localVarFp.getPermissionsModulesAll(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRole(id: string, organizationId: string, options?: any): AxiosPromise<RolePermissions> {
            return localVarFp.getPermissionsRole(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRoleMembers(organizationId: string, id: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getPermissionsRoleMembers(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
         * @summary 🔒: ModuleRights.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsRoles(organizationId: string, options?: any): AxiosPromise<Array<RolePermissions>> {
            return localVarFp.getPermissionsRoles(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllowedActions(organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.syncAllowedActions(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
         * @summary 🔒: ModuleRights.ReadWriteRoles
         * @param {string} organizationId 
         * @param {RolePermissionsUpdateEntry} rolePermissionsUpdateEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionsRole(organizationId: string, rolePermissionsUpdateEntry: RolePermissionsUpdateEntry, options?: any): AxiosPromise<RolePermissions> {
            return localVarFp.updatePermissionsRole(organizationId, rolePermissionsUpdateEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>ModuleRights.WriteRoleMembers</li></ul>
         * @summary 🔒: ModuleRights.WriteRoleMembers
         * @param {string} id 
         * @param {string} organizationId 
         * @param {MemberUpdateChanges} memberUpdateChanges 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionsRoleMembers(id: string, organizationId: string, memberUpdateChanges: MemberUpdateChanges, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.updatePermissionsRoleMembers(id, organizationId, memberUpdateChanges, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
     * @summary 🔒: ModuleRights.ReadWriteRoles
     * @param {string} organizationId 
     * @param {RolePermissionsCreateEntry} rolePermissionsCreateEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public createPermissionsRole(organizationId: string, rolePermissionsCreateEntry: RolePermissionsCreateEntry, options?: any) {
        return PermissionsApiFp(this.configuration).createPermissionsRole(organizationId, rolePermissionsCreateEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public deletePermissionsCache(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).deletePermissionsCache(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
     * @summary 🔒: ModuleRights.ReadWriteRoles
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public deletePermissionsRole(organizationId: string, id: string, options?: any) {
        return PermissionsApiFp(this.configuration).deletePermissionsRole(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getAllowedActions(organizationId: string, name: string, options?: any) {
        return PermissionsApiFp(this.configuration).getAllowedActions(organizationId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
     * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getAllowedActionsSyncState(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getAllowedActionsSyncState(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary Returns that state of the current app permission consent. A url to consent to the permissions is also provided. 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {string} [appId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getConsent(organizationId: string, appId?: string, options?: any) {
        return PermissionsApiFp(this.configuration).getConsent(organizationId, appId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the state of the consent of a specific required app permission.
     * @param {string} organizationId 
     * @param {string} permissionId 
     * @param {string} [appId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getConsentOfPermission(organizationId: string, permissionId: string, appId?: string, options?: any) {
        return PermissionsApiFp(this.configuration).getConsentOfPermission(organizationId, permissionId, appId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getEffectivePermissionsOfMyself(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getEffectivePermissionsOfMyself(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getEffectivePermissionsOfUser(organizationId: string, userId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getEffectivePermissionsOfUser(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissionsModules(organizationId: string, name: string, options?: any) {
        return PermissionsApiFp(this.configuration).getPermissionsModules(organizationId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissionsModulesAll(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getPermissionsModulesAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissionsRole(id: string, organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getPermissionsRole(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissionsRoleMembers(organizationId: string, id: string, options?: any) {
        return PermissionsApiFp(this.configuration).getPermissionsRoleMembers(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ShowModule</li></ul>
     * @summary 🔒: ModuleRights.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getPermissionsRoles(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).getPermissionsRoles(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li><li>ModuleRights.WriteRoleMembers</li></ul>
     * @summary 🔒: ModuleRights.ReadWriteRoles, ModuleRights.WriteRoleMembers
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public syncAllowedActions(organizationId: string, options?: any) {
        return PermissionsApiFp(this.configuration).syncAllowedActions(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.ReadWriteRoles</li></ul>
     * @summary 🔒: ModuleRights.ReadWriteRoles
     * @param {string} organizationId 
     * @param {RolePermissionsUpdateEntry} rolePermissionsUpdateEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public updatePermissionsRole(organizationId: string, rolePermissionsUpdateEntry: RolePermissionsUpdateEntry, options?: any) {
        return PermissionsApiFp(this.configuration).updatePermissionsRole(organizationId, rolePermissionsUpdateEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>ModuleRights.WriteRoleMembers</li></ul>
     * @summary 🔒: ModuleRights.WriteRoleMembers
     * @param {string} id 
     * @param {string} organizationId 
     * @param {MemberUpdateChanges} memberUpdateChanges 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public updatePermissionsRoleMembers(id: string, organizationId: string, memberUpdateChanges: MemberUpdateChanges, options?: any) {
        return PermissionsApiFp(this.configuration).updatePermissionsRoleMembers(id, organizationId, memberUpdateChanges, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The report covers the given period and contains the class\'s master data, classbook entries, services, absence statistics and absences for all students of the class.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Klassenbericht\" for one class as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {ClassReportRequest} classReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClassReport: async (organizationId: string, classReportRequest: ClassReportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateClassReport', 'organizationId', organizationId)
            // verify required parameter 'classReportRequest' is not null or undefined
            assertParamExists('generateClassReport', 'classReportRequest', classReportRequest)
            const localVarPath = `/api/v2/{organizationId}/reports/class`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The report covers the given period and contains the course\'s master data, classbook entries, services, absence statistics and absences for all students of the course.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Kursbericht\" for one course as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {CourseReportRequest} courseReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCourseReport: async (organizationId: string, courseReportRequest: CourseReportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateCourseReport', 'organizationId', organizationId)
            // verify required parameter 'courseReportRequest' is not null or undefined
            assertParamExists('generateCourseReport', 'courseReportRequest', courseReportRequest)
            const localVarPath = `/api/v2/{organizationId}/reports/course`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(courseReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The report covers the given period and contains the student\'s master data, courses, classbook entries, services, absence statistics and absences.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Schülerbericht\" for one student as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {StudentReportRequest} studentReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateStudentReport: async (organizationId: string, studentReportRequest: StudentReportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateStudentReport', 'organizationId', organizationId)
            // verify required parameter 'studentReportRequest' is not null or undefined
            assertParamExists('generateStudentReport', 'studentReportRequest', studentReportRequest)
            const localVarPath = `/api/v2/{organizationId}/reports/student`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * The report covers the given period and contains the class\'s master data, classbook entries, services, absence statistics and absences for all students of the class.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Klassenbericht\" for one class as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {ClassReportRequest} classReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClassReport(organizationId: string, classReportRequest: ClassReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClassReport(organizationId, classReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The report covers the given period and contains the course\'s master data, classbook entries, services, absence statistics and absences for all students of the course.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Kursbericht\" for one course as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {CourseReportRequest} courseReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCourseReport(organizationId: string, courseReportRequest: CourseReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCourseReport(organizationId, courseReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The report covers the given period and contains the student\'s master data, courses, classbook entries, services, absence statistics and absences.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Schülerbericht\" for one student as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {StudentReportRequest} studentReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateStudentReport(organizationId: string, studentReportRequest: StudentReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateStudentReport(organizationId, studentReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * The report covers the given period and contains the class\'s master data, classbook entries, services, absence statistics and absences for all students of the class.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Klassenbericht\" for one class as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {ClassReportRequest} classReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClassReport(organizationId: string, classReportRequest: ClassReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.generateClassReport(organizationId, classReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The report covers the given period and contains the course\'s master data, classbook entries, services, absence statistics and absences for all students of the course.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Kursbericht\" for one course as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {CourseReportRequest} courseReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCourseReport(organizationId: string, courseReportRequest: CourseReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.generateCourseReport(organizationId, courseReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * The report covers the given period and contains the student\'s master data, courses, classbook entries, services, absence statistics and absences.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Generates the \"Schülerbericht\" for one student as a PDF. 🔒: Reports.ShowModule
         * @param {string} organizationId Organization ID
         * @param {StudentReportRequest} studentReportRequest Report parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateStudentReport(organizationId: string, studentReportRequest: StudentReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.generateStudentReport(organizationId, studentReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * The report covers the given period and contains the class\'s master data, classbook entries, services, absence statistics and absences for all students of the class.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
     * @summary Generates the \"Klassenbericht\" for one class as a PDF. 🔒: Reports.ShowModule
     * @param {string} organizationId Organization ID
     * @param {ClassReportRequest} classReportRequest Report parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generateClassReport(organizationId: string, classReportRequest: ClassReportRequest, options?: any) {
        return ReportsApiFp(this.configuration).generateClassReport(organizationId, classReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The report covers the given period and contains the course\'s master data, classbook entries, services, absence statistics and absences for all students of the course.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
     * @summary Generates the \"Kursbericht\" for one course as a PDF. 🔒: Reports.ShowModule
     * @param {string} organizationId Organization ID
     * @param {CourseReportRequest} courseReportRequest Report parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generateCourseReport(organizationId: string, courseReportRequest: CourseReportRequest, options?: any) {
        return ReportsApiFp(this.configuration).generateCourseReport(organizationId, courseReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The report covers the given period and contains the student\'s master data, courses, classbook entries, services, absence statistics and absences.<br>Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
     * @summary Generates the \"Schülerbericht\" for one student as a PDF. 🔒: Reports.ShowModule
     * @param {string} organizationId Organization ID
     * @param {StudentReportRequest} studentReportRequest Report parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public generateStudentReport(organizationId: string, studentReportRequest: StudentReportRequest, options?: any) {
        return ReportsApiFp(this.configuration).generateStudentReport(organizationId, studentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResourcesApi - axios parameter creator
 * @export
 */
export const ResourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new equipment as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipment: async (organizationId: string, equipmentOptions: EquipmentOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createEquipment', 'organizationId', organizationId)
            // verify required parameter 'equipmentOptions' is not null or undefined
            assertParamExists('createEquipment', 'equipmentOptions', equipmentOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new equipment booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipmentBooking: async (organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createEquipmentBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('createEquipmentBooking', 'resourceId', resourceId)
            // verify required parameter 'bookingOptions' is not null or undefined
            assertParamExists('createEquipmentBooking', 'bookingOptions', bookingOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}/bookings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (onBehalfOfUserId !== undefined) {
                localVarQueryParameter['onBehalfOfUserId'] = onBehalfOfUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new room as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom: async (organizationId: string, roomOptions: RoomOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createRoom', 'organizationId', organizationId)
            // verify required parameter 'roomOptions' is not null or undefined
            assertParamExists('createRoom', 'roomOptions', roomOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new room booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomBooking: async (organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createRoomBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('createRoomBooking', 'resourceId', resourceId)
            // verify required parameter 'bookingOptions' is not null or undefined
            assertParamExists('createRoomBooking', 'bookingOptions', bookingOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}/bookings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (onBehalfOfUserId !== undefined) {
                localVarQueryParameter['onBehalfOfUserId'] = onBehalfOfUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipment: async (organizationId: string, resourceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteEquipment', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteEquipment', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipmentBooking: async (bookingId: string, organizationId: string, resourceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteEquipmentBooking', 'bookingId', bookingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteEquipmentBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteEquipmentBooking', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom: async (organizationId: string, resourceId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteRoom', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteRoom', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomBooking: async (bookingId: string, organizationId: string, resourceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteRoomBooking', 'bookingId', bookingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteRoomBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteRoomBooking', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing equipments. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllEquipment', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing rooms. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRooms: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllRooms', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Gets all people that are allowed to get chosen for a booking. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingPeople: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBookingPeople', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/people`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific equipment. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipment: async (organizationId: string, resourceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEquipment', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getEquipment', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given equipment for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipmentBookings: async (organizationId: string, resourceId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEquipmentBookings', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getEquipmentBookings', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}/bookings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings related to the requesting user. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [from] 
         * @param {string} [timePeriod] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBookings: async (organizationId: string, from?: string, timePeriod?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyBookings', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/me/bookings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific room. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom: async (organizationId: string, resourceId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRoom', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRoom', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given room for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomBookings: async (organizationId: string, resourceId: string, from?: string, to?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRoomBookings', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRoomBookings', 'resourceId', resourceId)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}/bookings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Gets the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSettings', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Resources.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTheActiveTimePattern', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Resources/pattern/active`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEquipment: async (organizationId: string, resourceId: string, equipmentOptions: EquipmentOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEquipment', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateEquipment', 'resourceId', resourceId)
            // verify required parameter 'equipmentOptions' is not null or undefined
            assertParamExists('updateEquipment', 'equipmentOptions', equipmentOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(equipmentOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEquipmentBooking: async (bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('updateEquipmentBooking', 'bookingId', bookingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEquipmentBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateEquipmentBooking', 'resourceId', resourceId)
            // verify required parameter 'bookingOptions' is not null or undefined
            assertParamExists('updateEquipmentBooking', 'bookingOptions', bookingOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/equipment/{resourceId}/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom: async (organizationId: string, resourceId: string, roomOptions: RoomOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateRoom', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateRoom', 'resourceId', resourceId)
            // verify required parameter 'roomOptions' is not null or undefined
            assertParamExists('updateRoom', 'roomOptions', roomOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomBooking: async (bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('updateRoomBooking', 'bookingId', bookingId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateRoomBooking', 'organizationId', organizationId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateRoomBooking', 'resourceId', resourceId)
            // verify required parameter 'bookingOptions' is not null or undefined
            assertParamExists('updateRoomBooking', 'bookingOptions', bookingOptions)
            const localVarPath = `/api/V2/{organizationId}/Resources/rooms/{resourceId}/bookings/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Updates the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {ResourcesSettings} resourcesSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: async (organizationId: string, resourcesSettings: ResourcesSettings, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSettings', 'organizationId', organizationId)
            // verify required parameter 'resourcesSettings' is not null or undefined
            assertParamExists('updateSettings', 'resourcesSettings', resourcesSettings)
            const localVarPath = `/api/V2/{organizationId}/Resources/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resourcesSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourcesApi - functional programming interface
 * @export
 */
export const ResourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new equipment as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEquipment(organizationId: string, equipmentOptions: EquipmentOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Equipment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEquipment(organizationId, equipmentOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new equipment booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEquipmentBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEquipmentBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new room as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoom(organizationId: string, roomOptions: RoomOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoom(organizationId, roomOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new room booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEquipment(organizationId: string, resourceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEquipment(organizationId, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEquipmentBooking(bookingId, organizationId, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoom(organizationId, resourceId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoomBooking(bookingId: string, organizationId: string, resourceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoomBooking(bookingId, organizationId, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing equipments. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEquipment(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Equipment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEquipment(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing rooms. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRooms(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Room>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRooms(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Gets all people that are allowed to get chosen for a booking. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingPeople(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingPerson>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingPeople(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific equipment. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEquipment(organizationId: string, resourceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Equipment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEquipment(organizationId, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given equipment for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEquipmentBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEquipmentBookings(organizationId, resourceId, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings related to the requesting user. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [from] 
         * @param {string} [timePeriod] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyBookings(organizationId: string, from?: string, timePeriod?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyBookings(organizationId, from, timePeriod, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific room. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoom(organizationId, resourceId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given room for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Booking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomBookings(organizationId, resourceId, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Gets the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourcesSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Resources.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheActiveTimePattern(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEquipment(organizationId: string, resourceId: string, equipmentOptions: EquipmentOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Equipment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEquipment(organizationId, resourceId, equipmentOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEquipmentBooking(bookingId, organizationId, resourceId, bookingOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoom(organizationId: string, resourceId: string, roomOptions: RoomOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoom(organizationId, resourceId, roomOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoomBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Booking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoomBooking(bookingId, organizationId, resourceId, bookingOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Updates the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {ResourcesSettings} resourcesSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettings(organizationId: string, resourcesSettings: ResourcesSettings, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourcesSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettings(organizationId, resourcesSettings, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResourcesApi - factory interface
 * @export
 */
export const ResourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourcesApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new equipment as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipment(organizationId: string, equipmentOptions: EquipmentOptions, options?: any): AxiosPromise<Equipment> {
            return localVarFp.createEquipment(organizationId, equipmentOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new equipment booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipmentBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.createEquipmentBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Creates a new room as exchange resource. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom(organizationId: string, roomOptions: RoomOptions, options?: any): AxiosPromise<Room> {
            return localVarFp.createRoom(organizationId, roomOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Creates a new room booking. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {string} [onBehalfOfUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any): AxiosPromise<Booking> {
            return localVarFp.createRoomBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipment(organizationId: string, resourceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEquipment(organizationId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEquipmentBooking(bookingId, organizationId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Removes an existing room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRoom(organizationId, resourceId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Deletes an existing room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomBooking(bookingId: string, organizationId: string, resourceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRoomBooking(bookingId, organizationId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing equipments. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEquipment(organizationId: string, options?: any): AxiosPromise<Array<Equipment>> {
            return localVarFp.getAllEquipment(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all existing rooms. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRooms(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Room>> {
            return localVarFp.getAllRooms(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Gets all people that are allowed to get chosen for a booking. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingPeople(organizationId: string, options?: any): AxiosPromise<Array<BookingPerson>> {
            return localVarFp.getBookingPeople(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific equipment. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipment(organizationId: string, resourceId: string, options?: any): AxiosPromise<Equipment> {
            return localVarFp.getEquipment(organizationId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given equipment for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEquipmentBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any): AxiosPromise<Array<Booking>> {
            return localVarFp.getEquipmentBookings(organizationId, resourceId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings related to the requesting user. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} [from] 
         * @param {string} [timePeriod] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBookings(organizationId: string, from?: string, timePeriod?: string, to?: string, options?: any): AxiosPromise<Array<Booking>> {
            return localVarFp.getMyBookings(organizationId, from, timePeriod, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets a specific room. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any): AxiosPromise<Room> {
            return localVarFp.getRoom(organizationId, resourceId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Gets all bookings of the given room for a specified time period. 🔒: Resources.ShowModule
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any): AxiosPromise<Array<Booking>> {
            return localVarFp.getRoomBookings(organizationId, resourceId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Gets the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(organizationId: string, options?: any): AxiosPromise<ResourcesSettings> {
            return localVarFp.getSettings(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Resources.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific equipment. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {EquipmentOptions} equipmentOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEquipment(organizationId: string, resourceId: string, equipmentOptions: EquipmentOptions, options?: any): AxiosPromise<Equipment> {
            return localVarFp.updateEquipment(organizationId, resourceId, equipmentOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific equipment booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any): AxiosPromise<Booking> {
            return localVarFp.updateEquipmentBooking(bookingId, organizationId, resourceId, bookingOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
         * @summary Updates a specific room. 🔒: Resources.Administrator
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {RoomOptions} roomOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom(organizationId: string, resourceId: string, roomOptions: RoomOptions, options?: any): AxiosPromise<Room> {
            return localVarFp.updateRoom(organizationId, resourceId, roomOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
         * @summary Updates a specific room booking. 🔒: Resources.ShowModule
         * @param {string} bookingId 
         * @param {string} organizationId 
         * @param {string} resourceId 
         * @param {BookingOptions} bookingOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any): AxiosPromise<Booking> {
            return localVarFp.updateRoomBooking(bookingId, organizationId, resourceId, bookingOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
         * @summary Updates the existing resources settings. 🔒: Resources.Settings
         * @param {string} organizationId 
         * @param {ResourcesSettings} resourcesSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(organizationId: string, resourcesSettings: ResourcesSettings, options?: any): AxiosPromise<ResourcesSettings> {
            return localVarFp.updateSettings(organizationId, resourcesSettings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
export class ResourcesApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Creates a new equipment as exchange resource. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {EquipmentOptions} equipmentOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public createEquipment(organizationId: string, equipmentOptions: EquipmentOptions, options?: any) {
        return ResourcesApiFp(this.configuration).createEquipment(organizationId, equipmentOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Creates a new equipment booking. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {BookingOptions} bookingOptions 
     * @param {string} [onBehalfOfUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public createEquipmentBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any) {
        return ResourcesApiFp(this.configuration).createEquipmentBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Creates a new room as exchange resource. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {RoomOptions} roomOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public createRoom(organizationId: string, roomOptions: RoomOptions, options?: any) {
        return ResourcesApiFp(this.configuration).createRoom(organizationId, roomOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Creates a new room booking. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {BookingOptions} bookingOptions 
     * @param {string} [onBehalfOfUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public createRoomBooking(organizationId: string, resourceId: string, bookingOptions: BookingOptions, onBehalfOfUserId?: string, options?: any) {
        return ResourcesApiFp(this.configuration).createRoomBooking(organizationId, resourceId, bookingOptions, onBehalfOfUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Removes an existing equipment. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public deleteEquipment(organizationId: string, resourceId: string, options?: any) {
        return ResourcesApiFp(this.configuration).deleteEquipment(organizationId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Deletes an existing equipment booking. 🔒: Resources.ShowModule
     * @param {string} bookingId 
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public deleteEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, options?: any) {
        return ResourcesApiFp(this.configuration).deleteEquipmentBooking(bookingId, organizationId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Removes an existing room. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public deleteRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any) {
        return ResourcesApiFp(this.configuration).deleteRoom(organizationId, resourceId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Deletes an existing room booking. 🔒: Resources.ShowModule
     * @param {string} bookingId 
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public deleteRoomBooking(bookingId: string, organizationId: string, resourceId: string, options?: any) {
        return ResourcesApiFp(this.configuration).deleteRoomBooking(bookingId, organizationId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets all existing equipments. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getAllEquipment(organizationId: string, options?: any) {
        return ResourcesApiFp(this.configuration).getAllEquipment(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets all existing rooms. This includes exchange resources and timetable only entities as well. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getAllRooms(organizationId: string, timePeriod?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getAllRooms(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Gets all people that are allowed to get chosen for a booking. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getBookingPeople(organizationId: string, options?: any) {
        return ResourcesApiFp(this.configuration).getBookingPeople(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets a specific equipment. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getEquipment(organizationId: string, resourceId: string, options?: any) {
        return ResourcesApiFp(this.configuration).getEquipment(organizationId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets all bookings of the given equipment for a specified time period. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getEquipmentBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getEquipmentBookings(organizationId, resourceId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets all bookings related to the requesting user. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} [from] 
     * @param {string} [timePeriod] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getMyBookings(organizationId: string, from?: string, timePeriod?: string, to?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getMyBookings(organizationId, from, timePeriod, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets a specific room. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getRoom(organizationId: string, resourceId: string, timePeriod?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getRoom(organizationId, resourceId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Gets all bookings of the given room for a specified time period. 🔒: Resources.ShowModule
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getRoomBookings(organizationId: string, resourceId: string, from?: string, to?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getRoomBookings(organizationId, resourceId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
     * @summary Gets the existing resources settings. 🔒: Resources.Settings
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getSettings(organizationId: string, options?: any) {
        return ResourcesApiFp(this.configuration).getSettings(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary 🔒: Resources.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public getTheActiveTimePattern(organizationId: string, timePeriod?: string, options?: any) {
        return ResourcesApiFp(this.configuration).getTheActiveTimePattern(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Updates a specific equipment. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {EquipmentOptions} equipmentOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public updateEquipment(organizationId: string, resourceId: string, equipmentOptions: EquipmentOptions, options?: any) {
        return ResourcesApiFp(this.configuration).updateEquipment(organizationId, resourceId, equipmentOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Updates a specific equipment booking. 🔒: Resources.ShowModule
     * @param {string} bookingId 
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {BookingOptions} bookingOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public updateEquipmentBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any) {
        return ResourcesApiFp(this.configuration).updateEquipmentBooking(bookingId, organizationId, resourceId, bookingOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Administrator</li></ul>
     * @summary Updates a specific room. 🔒: Resources.Administrator
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {RoomOptions} roomOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public updateRoom(organizationId: string, resourceId: string, roomOptions: RoomOptions, options?: any) {
        return ResourcesApiFp(this.configuration).updateRoom(organizationId, resourceId, roomOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.ShowModule</li></ul>
     * @summary Updates a specific room booking. 🔒: Resources.ShowModule
     * @param {string} bookingId 
     * @param {string} organizationId 
     * @param {string} resourceId 
     * @param {BookingOptions} bookingOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public updateRoomBooking(bookingId: string, organizationId: string, resourceId: string, bookingOptions: BookingOptions, options?: any) {
        return ResourcesApiFp(this.configuration).updateRoomBooking(bookingId, organizationId, resourceId, bookingOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Resources.Settings</li></ul>
     * @summary Updates the existing resources settings. 🔒: Resources.Settings
     * @param {string} organizationId 
     * @param {ResourcesSettings} resourcesSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourcesApi
     */
    public updateSettings(organizationId: string, resourcesSettings: ResourcesSettings, options?: any) {
        return ResourcesApiFp(this.configuration).updateSettings(organizationId, resourcesSettings, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchoolLinksApi - axios parameter creator
 * @export
 */
export const SchoolLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Removes an existing school link from the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, listId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('_delete', 'listId', listId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/{listId}/items/{id}/of/{organizationId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Creates a new school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkCreateRequest} schoolLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (schoolLinkCreateRequest: SchoolLinkCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'schoolLinkCreateRequest' is not null or undefined
            assertParamExists('create', 'schoolLinkCreateRequest', schoolLinkCreateRequest)
            const localVarPath = `/api/v2/SchoolLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schoolLinkCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns the specified school link from the given list. 🔒: SchoolLinks.ShowModule
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, listId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('get', 'listId', listId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/{listId}/items/{id}/of/{organizationId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns all school links from the specified list. 🔒: SchoolLinks.ShowModule
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (listId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getAll', 'listId', listId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/{listId}/items/of/{organizationId}`
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Retrieves a favicon for the given URL. 🔒: SchoolLinks.ShowModule
         * @param {string} organizationId 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavicon: async (organizationId: string, url?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFavicon', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/{organizationId}/geticonfromurl`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns all as favorite marked school links from the specified list. 🔒: SchoolLinks.ReadFavorites
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites: async (listId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listId' is not null or undefined
            assertParamExists('getFavorites', 'listId', listId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFavorites', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/{listId}/favorites/of/{organizationId}`
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns the school links information for the specified organization. 🔒: SchoolLinks.ShowModule, SchoolLinks.ReadFavorites
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getList', 'organizationId', organizationId)
            const localVarPath = `/api/v2/SchoolLinks/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Updates an existing school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkUpdateRequest} schoolLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (schoolLinkUpdateRequest: SchoolLinkUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'schoolLinkUpdateRequest' is not null or undefined
            assertParamExists('update', 'schoolLinkUpdateRequest', schoolLinkUpdateRequest)
            const localVarPath = `/api/v2/SchoolLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schoolLinkUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchoolLinksApi - functional programming interface
 * @export
 */
export const SchoolLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchoolLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Removes an existing school link from the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, listId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, listId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Creates a new school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkCreateRequest} schoolLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(schoolLinkCreateRequest: SchoolLinkCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(schoolLinkCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns the specified school link from the given list. 🔒: SchoolLinks.ShowModule
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, listId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, listId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns all school links from the specified list. 🔒: SchoolLinks.ShowModule
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(listId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchoolLinkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(listId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Retrieves a favicon for the given URL. 🔒: SchoolLinks.ShowModule
         * @param {string} organizationId 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavicon(organizationId: string, url?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolLinkFaviconResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavicon(organizationId, url, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns all as favorite marked school links from the specified list. 🔒: SchoolLinks.ReadFavorites
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavorites(listId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchoolLinkResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavorites(listId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns the school links information for the specified organization. 🔒: SchoolLinks.ShowModule, SchoolLinks.ReadFavorites
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getList(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolLinkListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Updates an existing school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkUpdateRequest} schoolLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(schoolLinkUpdateRequest: SchoolLinkUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(schoolLinkUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchoolLinksApi - factory interface
 * @export
 */
export const SchoolLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchoolLinksApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Removes an existing school link from the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, listId: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, listId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Creates a new school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkCreateRequest} schoolLinkCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(schoolLinkCreateRequest: SchoolLinkCreateRequest, options?: any): AxiosPromise<SchoolLinkResponse> {
            return localVarFp.create(schoolLinkCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns the specified school link from the given list. 🔒: SchoolLinks.ShowModule
         * @param {string} id 
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, listId: string, organizationId: string, options?: any): AxiosPromise<SchoolLinkResponse> {
            return localVarFp.get(id, listId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Returns all school links from the specified list. 🔒: SchoolLinks.ShowModule
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(listId: string, organizationId: string, options?: any): AxiosPromise<Array<SchoolLinkResponse>> {
            return localVarFp.getAll(listId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
         * @summary Retrieves a favicon for the given URL. 🔒: SchoolLinks.ShowModule
         * @param {string} organizationId 
         * @param {string} [url] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavicon(organizationId: string, url?: string, options?: any): AxiosPromise<SchoolLinkFaviconResponse> {
            return localVarFp.getFavicon(organizationId, url, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns all as favorite marked school links from the specified list. 🔒: SchoolLinks.ReadFavorites
         * @param {string} listId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(listId: string, organizationId: string, options?: any): AxiosPromise<Array<SchoolLinkResponse>> {
            return localVarFp.getFavorites(listId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li><li>SchoolLinks.ReadFavorites</li></ul>
         * @summary Returns the school links information for the specified organization. 🔒: SchoolLinks.ShowModule, SchoolLinks.ReadFavorites
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(organizationId: string, options?: any): AxiosPromise<SchoolLinkListResponse> {
            return localVarFp.getList(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
         * @summary Updates an existing school link in the specified list. 🔒: SchoolLinks.ReadWrite
         * @param {SchoolLinkUpdateRequest} schoolLinkUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(schoolLinkUpdateRequest: SchoolLinkUpdateRequest, options?: any): AxiosPromise<SchoolLinkResponse> {
            return localVarFp.update(schoolLinkUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchoolLinksApi - object-oriented interface
 * @export
 * @class SchoolLinksApi
 * @extends {BaseAPI}
 */
export class SchoolLinksApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
     * @summary Removes an existing school link from the specified list. 🔒: SchoolLinks.ReadWrite
     * @param {string} id 
     * @param {string} listId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public _delete(id: string, listId: string, organizationId: string, options?: any) {
        return SchoolLinksApiFp(this.configuration)._delete(id, listId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
     * @summary Creates a new school link in the specified list. 🔒: SchoolLinks.ReadWrite
     * @param {SchoolLinkCreateRequest} schoolLinkCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public create(schoolLinkCreateRequest: SchoolLinkCreateRequest, options?: any) {
        return SchoolLinksApiFp(this.configuration).create(schoolLinkCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
     * @summary Returns the specified school link from the given list. 🔒: SchoolLinks.ShowModule
     * @param {string} id 
     * @param {string} listId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public get(id: string, listId: string, organizationId: string, options?: any) {
        return SchoolLinksApiFp(this.configuration).get(id, listId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
     * @summary Returns all school links from the specified list. 🔒: SchoolLinks.ShowModule
     * @param {string} listId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public getAll(listId: string, organizationId: string, options?: any) {
        return SchoolLinksApiFp(this.configuration).getAll(listId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li></ul>
     * @summary Retrieves a favicon for the given URL. 🔒: SchoolLinks.ShowModule
     * @param {string} organizationId 
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public getFavicon(organizationId: string, url?: string, options?: any) {
        return SchoolLinksApiFp(this.configuration).getFavicon(organizationId, url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ReadFavorites</li></ul>
     * @summary Returns all as favorite marked school links from the specified list. 🔒: SchoolLinks.ReadFavorites
     * @param {string} listId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public getFavorites(listId: string, organizationId: string, options?: any) {
        return SchoolLinksApiFp(this.configuration).getFavorites(listId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ShowModule</li><li>SchoolLinks.ReadFavorites</li></ul>
     * @summary Returns the school links information for the specified organization. 🔒: SchoolLinks.ShowModule, SchoolLinks.ReadFavorites
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public getList(organizationId: string, options?: any) {
        return SchoolLinksApiFp(this.configuration).getList(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>SchoolLinks.ReadWrite</li></ul>
     * @summary Updates an existing school link in the specified list. 🔒: SchoolLinks.ReadWrite
     * @param {SchoolLinkUpdateRequest} schoolLinkUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolLinksApi
     */
    public update(schoolLinkUpdateRequest: SchoolLinkUpdateRequest, options?: any) {
        return SchoolLinksApiFp(this.configuration).update(schoolLinkUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchesApi - axios parameter creator
 * @export
 */
export const SearchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Can only be used by AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all tenants, that matches the given search value. 🔒: AixConcept.Only
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        any: async (search: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('any', 'search', search)
            const localVarPath = `/api/V2/Searches/any/{search}`
                .replace(`{${"search"}}`, encodeURIComponent(String(search)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchesApi - functional programming interface
 * @export
 */
export const SearchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Can only be used by AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all tenants, that matches the given search value. 🔒: AixConcept.Only
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async any(search: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantSearchResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.any(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchesApi - factory interface
 * @export
 */
export const SearchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchesApiFp(configuration)
    return {
        /**
         * Can only be used by AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all tenants, that matches the given search value. 🔒: AixConcept.Only
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        any(search: string, options?: any): AxiosPromise<Array<TenantSearchResponse>> {
            return localVarFp.any(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchesApi - object-oriented interface
 * @export
 * @class SearchesApi
 * @extends {BaseAPI}
 */
export class SearchesApi extends BaseAPI {
    /**
     * Can only be used by AixConcept users.<br>Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Returns all tenants, that matches the given search value. 🔒: AixConcept.Only
     * @param {string} search 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesApi
     */
    public any(search: string, options?: any) {
        return SearchesApiFp(this.configuration).any(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SignUpApi - axios parameter creator
 * @export
 */
export const SignUpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the ordered list of Azure AD applications the admin still has to grant consent for, for the given invitation. Called anonymously by the sign-up frontend at the very start of the flow (only the invitation id is known yet) so the consent-app list no longer has to be hard-coded in the frontend configuration.
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentApps: async (invitationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('consentApps', 'invitationId', invitationId)
            const localVarPath = `/api/v2/signUp/consentApps/{invitationId}`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates the tenant and organization for the given invitation, enqueues the Hangfire tenant initialization job, and returns the organization id together with the job id the client uses to poll api/v2/{organizationId}/TaskStates/{jobId}.
         * @param {string} invitationId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeTenant: async (invitationId: string, tenantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('initializeTenant', 'invitationId', invitationId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('initializeTenant', 'tenantId', tenantId)
            const localVarPath = `/api/v2/signUp/{invitationId}/{tenantId}`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates the parameters returned by Azure AD on the admin-consent redirect. Called server-to-server from the sign-up frontend before the user is fully signed in.
         * @param {boolean} adminConsent 
         * @param {string} tenant 
         * @param {string} state 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConsent: async (adminConsent: boolean, tenant: string, state: string, error?: string, errorDescription?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminConsent' is not null or undefined
            assertParamExists('validateConsent', 'adminConsent', adminConsent)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('validateConsent', 'tenant', tenant)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('validateConsent', 'state', state)
            const localVarPath = `/api/v2/signUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminConsent !== undefined) {
                localVarQueryParameter['admin_consent'] = adminConsent;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignUpApi - functional programming interface
 * @export
 */
export const SignUpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignUpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the ordered list of Azure AD applications the admin still has to grant consent for, for the given invitation. Called anonymously by the sign-up frontend at the very start of the flow (only the invitation id is known yet) so the consent-app list no longer has to be hard-coded in the frontend configuration.
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentApps(invitationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConsentApp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentApps(invitationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates the tenant and organization for the given invitation, enqueues the Hangfire tenant initialization job, and returns the organization id together with the job id the client uses to poll api/v2/{organizationId}/TaskStates/{jobId}.
         * @param {string} invitationId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeTenant(invitationId: string, tenantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantInitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeTenant(invitationId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validates the parameters returned by Azure AD on the admin-consent redirect. Called server-to-server from the sign-up frontend before the user is fully signed in.
         * @param {boolean} adminConsent 
         * @param {string} tenant 
         * @param {string} state 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateConsent(adminConsent: boolean, tenant: string, state: string, error?: string, errorDescription?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateConsent(adminConsent, tenant, state, error, errorDescription, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignUpApi - factory interface
 * @export
 */
export const SignUpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignUpApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the ordered list of Azure AD applications the admin still has to grant consent for, for the given invitation. Called anonymously by the sign-up frontend at the very start of the flow (only the invitation id is known yet) so the consent-app list no longer has to be hard-coded in the frontend configuration.
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentApps(invitationId: string, options?: any): AxiosPromise<Array<ConsentApp>> {
            return localVarFp.consentApps(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates the tenant and organization for the given invitation, enqueues the Hangfire tenant initialization job, and returns the organization id together with the job id the client uses to poll api/v2/{organizationId}/TaskStates/{jobId}.
         * @param {string} invitationId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeTenant(invitationId: string, tenantId: string, options?: any): AxiosPromise<TenantInitResponse> {
            return localVarFp.initializeTenant(invitationId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates the parameters returned by Azure AD on the admin-consent redirect. Called server-to-server from the sign-up frontend before the user is fully signed in.
         * @param {boolean} adminConsent 
         * @param {string} tenant 
         * @param {string} state 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConsent(adminConsent: boolean, tenant: string, state: string, error?: string, errorDescription?: string, options?: any): AxiosPromise<void> {
            return localVarFp.validateConsent(adminConsent, tenant, state, error, errorDescription, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignUpApi - object-oriented interface
 * @export
 * @class SignUpApi
 * @extends {BaseAPI}
 */
export class SignUpApi extends BaseAPI {
    /**
     * 
     * @summary Returns the ordered list of Azure AD applications the admin still has to grant consent for, for the given invitation. Called anonymously by the sign-up frontend at the very start of the flow (only the invitation id is known yet) so the consent-app list no longer has to be hard-coded in the frontend configuration.
     * @param {string} invitationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignUpApi
     */
    public consentApps(invitationId: string, options?: any) {
        return SignUpApiFp(this.configuration).consentApps(invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates the tenant and organization for the given invitation, enqueues the Hangfire tenant initialization job, and returns the organization id together with the job id the client uses to poll api/v2/{organizationId}/TaskStates/{jobId}.
     * @param {string} invitationId 
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignUpApi
     */
    public initializeTenant(invitationId: string, tenantId: string, options?: any) {
        return SignUpApiFp(this.configuration).initializeTenant(invitationId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates the parameters returned by Azure AD on the admin-consent redirect. Called server-to-server from the sign-up frontend before the user is fully signed in.
     * @param {boolean} adminConsent 
     * @param {string} tenant 
     * @param {string} state 
     * @param {string} [error] 
     * @param {string} [errorDescription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignUpApi
     */
    public validateConsent(adminConsent: boolean, tenant: string, state: string, error?: string, errorDescription?: string, options?: any) {
        return SignUpApiFp(this.configuration).validateConsent(adminConsent, tenant, state, error, errorDescription, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskStatesApi - axios parameter creator
 * @export
 */
export const TaskStatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the state of the specified task.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TaskStates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all available task states for the given organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TaskStates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskStatesApi - functional programming interface
 * @export
 */
export const TaskStatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskStatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the state of the specified task.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all available task states for the given organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskStatesApi - factory interface
 * @export
 */
export const TaskStatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskStatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the state of the specified task.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, organizationId: string, options?: any): AxiosPromise<TaskStateResponse> {
            return localVarFp.get(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all available task states for the given organization. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, options?: any): AxiosPromise<Array<JobResponse>> {
            return localVarFp.getAll(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskStatesApi - object-oriented interface
 * @export
 * @class TaskStatesApi
 * @extends {BaseAPI}
 */
export class TaskStatesApi extends BaseAPI {
    /**
     * 
     * @summary Returns the state of the specified task.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskStatesApi
     */
    public get(id: string, organizationId: string, options?: any) {
        return TaskStatesApiFp(this.configuration).get(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Returns all available task states for the given organization. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskStatesApi
     */
    public getAll(organizationId: string, options?: any) {
        return TaskStatesApiFp(this.configuration).getAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TeamsApiApi - axios parameter creator
 * @export
 */
export const TeamsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ruft alle Ankündigungen für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft das Cockpit-Banner für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitBanner: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/settings/cockpit/banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft das Profil des aktuell authentifizierten Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/users/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft den Stundenplan (Agenda) des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAgenda: async (start: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getMyAgenda', 'start', start)
            const localVarPath = `/api/v2/TeamsApi/lessons/my/agenda/{start}`
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Kurse des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCourses: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/courses/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Hausaufgaben des Benutzers aus MNSpro Cloud ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomeworkAssignments: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/educationAssignments/homework/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Vertretungen des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySubstitutions: async (start: string, dayCount?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getMySubstitutions', 'start', start)
            const localVarPath = `/api/v2/TeamsApi/substitutions/my/{start}`
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dayCount !== undefined) {
                localVarQueryParameter['dayCount'] = dayCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Microsoft Teams Aufgaben des Benutzers ab.
         * @param {string} [timePeriod] Time period whose courses are listed. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTeamsAssignments: async (timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/educationAssignments/teams/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft alle Neuigkeiten für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft das Foto einer Gruppe ab.
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoOfGroup: async (groupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getPhotoOfGroup', 'groupId', groupId)
            const localVarPath = `/api/v2/TeamsApi/groups/{groupId}/photo`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die favorisierten Schullinks des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolLinks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/schoolLinks/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Cockpit-Einstellungen für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/settings/cockpit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeachers: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/users/teachers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft die Tenant Id für die Organisation ab.
         * @param {string} organizationId Identifikation der Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantByOrganization: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTenantByOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/v2/TeamsApi/tenant/of/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruft mehrere Benutzerprofile ab.
         * @param {Array<string>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (userIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TeamsApi/users/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApiApi - functional programming interface
 * @export
 */
export const TeamsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ruft alle Ankündigungen für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnouncements(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnouncements(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft das Cockpit-Banner für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCockpitBanner(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCockpitBanner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft das Profil des aktuell authentifizierten Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft den Stundenplan (Agenda) des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAgenda(start: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAgenda(start, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Kurse des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCourses(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCourses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Hausaufgaben des Benutzers aus MNSpro Cloud ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyHomeworkAssignments(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyHomeworkAssignments(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Vertretungen des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySubstitutions(start: string, dayCount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySubstitutions(start, dayCount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Microsoft Teams Aufgaben des Benutzers ab.
         * @param {string} [timePeriod] Time period whose courses are listed. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTeamsAssignments(timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTeamsAssignments(timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft alle Neuigkeiten für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNews(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNews(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft das Foto einer Gruppe ab.
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhotoOfGroup(groupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhotoOfGroup(groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die favorisierten Schullinks des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchoolLinks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchoolLinks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Cockpit-Einstellungen für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeachers(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamsProfileResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeachers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft die Tenant Id für die Organisation ab.
         * @param {string} organizationId Identifikation der Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantByOrganization(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantByOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ruft mehrere Benutzerprofile ab.
         * @param {Array<string>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(userIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(userIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TeamsApiApi - factory interface
 * @export
 */
export const TeamsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Ruft alle Ankündigungen für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements(request?: object, options?: any): AxiosPromise<any> {
            return localVarFp.getAnnouncements(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft das Cockpit-Banner für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCockpitBanner(options?: any): AxiosPromise<any> {
            return localVarFp.getCockpitBanner(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft das Profil des aktuell authentifizierten Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: any): AxiosPromise<any> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft den Stundenplan (Agenda) des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAgenda(start: string, options?: any): AxiosPromise<any> {
            return localVarFp.getMyAgenda(start, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Kurse des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCourses(options?: any): AxiosPromise<any> {
            return localVarFp.getMyCourses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Hausaufgaben des Benutzers aus MNSpro Cloud ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyHomeworkAssignments(request?: object, options?: any): AxiosPromise<any> {
            return localVarFp.getMyHomeworkAssignments(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Vertretungen des Benutzers ab einem bestimmten Datum ab.
         * @param {string} start 
         * @param {number} [dayCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySubstitutions(start: string, dayCount?: number, options?: any): AxiosPromise<any> {
            return localVarFp.getMySubstitutions(start, dayCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Microsoft Teams Aufgaben des Benutzers ab.
         * @param {string} [timePeriod] Time period whose courses are listed. Defaults to the active one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTeamsAssignments(timePeriod?: string, options?: any): AxiosPromise<any> {
            return localVarFp.getMyTeamsAssignments(timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft alle Neuigkeiten für den Benutzer ab.
         * @param {object} [request] Anfrage mit optionalen Filterparametern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(request?: object, options?: any): AxiosPromise<any> {
            return localVarFp.getNews(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft das Foto einer Gruppe ab.
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhotoOfGroup(groupId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getPhotoOfGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die favorisierten Schullinks des Benutzers ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchoolLinks(options?: any): AxiosPromise<any> {
            return localVarFp.getSchoolLinks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Cockpit-Einstellungen für den authentifizierten Benutzer ab.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: any): AxiosPromise<any> {
            return localVarFp.getSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeachers(options?: any): AxiosPromise<Array<TeamsProfileResponse>> {
            return localVarFp.getTeachers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft die Tenant Id für die Organisation ab.
         * @param {string} organizationId Identifikation der Organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantByOrganization(organizationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.getTenantByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruft mehrere Benutzerprofile ab.
         * @param {Array<string>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(userIds?: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.getUsers(userIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsApiApi - object-oriented interface
 * @export
 * @class TeamsApiApi
 * @extends {BaseAPI}
 */
export class TeamsApiApi extends BaseAPI {
    /**
     * 
     * @summary Ruft alle Ankündigungen für den Benutzer ab.
     * @param {object} [request] Anfrage mit optionalen Filterparametern.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getAnnouncements(request?: object, options?: any) {
        return TeamsApiApiFp(this.configuration).getAnnouncements(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft das Cockpit-Banner für den authentifizierten Benutzer ab.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getCockpitBanner(options?: any) {
        return TeamsApiApiFp(this.configuration).getCockpitBanner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft das Profil des aktuell authentifizierten Benutzers ab.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMe(options?: any) {
        return TeamsApiApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft den Stundenplan (Agenda) des Benutzers ab einem bestimmten Datum ab.
     * @param {string} start 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMyAgenda(start: string, options?: any) {
        return TeamsApiApiFp(this.configuration).getMyAgenda(start, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Kurse des Benutzers ab.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMyCourses(options?: any) {
        return TeamsApiApiFp(this.configuration).getMyCourses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Hausaufgaben des Benutzers aus MNSpro Cloud ab.
     * @param {object} [request] Anfrage mit optionalen Filterparametern.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMyHomeworkAssignments(request?: object, options?: any) {
        return TeamsApiApiFp(this.configuration).getMyHomeworkAssignments(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Vertretungen des Benutzers ab einem bestimmten Datum ab.
     * @param {string} start 
     * @param {number} [dayCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMySubstitutions(start: string, dayCount?: number, options?: any) {
        return TeamsApiApiFp(this.configuration).getMySubstitutions(start, dayCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Microsoft Teams Aufgaben des Benutzers ab.
     * @param {string} [timePeriod] Time period whose courses are listed. Defaults to the active one.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getMyTeamsAssignments(timePeriod?: string, options?: any) {
        return TeamsApiApiFp(this.configuration).getMyTeamsAssignments(timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft alle Neuigkeiten für den Benutzer ab.
     * @param {object} [request] Anfrage mit optionalen Filterparametern.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getNews(request?: object, options?: any) {
        return TeamsApiApiFp(this.configuration).getNews(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft das Foto einer Gruppe ab.
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getPhotoOfGroup(groupId: string, options?: any) {
        return TeamsApiApiFp(this.configuration).getPhotoOfGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die favorisierten Schullinks des Benutzers ab.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getSchoolLinks(options?: any) {
        return TeamsApiApiFp(this.configuration).getSchoolLinks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Cockpit-Einstellungen für den authentifizierten Benutzer ab.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getSettings(options?: any) {
        return TeamsApiApiFp(this.configuration).getSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getTeachers(options?: any) {
        return TeamsApiApiFp(this.configuration).getTeachers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft die Tenant Id für die Organisation ab.
     * @param {string} organizationId Identifikation der Organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getTenantByOrganization(organizationId: string, options?: any) {
        return TeamsApiApiFp(this.configuration).getTenantByOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruft mehrere Benutzerprofile ab.
     * @param {Array<string>} [userIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApiApi
     */
    public getUsers(userIds?: Array<string>, options?: any) {
        return TeamsApiApiFp(this.configuration).getUsers(userIds, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Deletes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/Templates/users/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Creates a new user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateCreateRequest} userTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (organizationId: string, userTemplateCreateRequest: UserTemplateCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('create', 'organizationId', organizationId)
            // verify required parameter 'userTemplateCreateRequest' is not null or undefined
            assertParamExists('create', 'userTemplateCreateRequest', userTemplateCreateRequest)
            const localVarPath = `/api/V2/{organizationId}/Templates/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Createts a new group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateCreateRequest} groupTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupTemplate: async (organizationId: string, groupTemplateCreateRequest: GroupTemplateCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createGroupTemplate', 'organizationId', organizationId)
            // verify required parameter 'groupTemplateCreateRequest' is not null or undefined
            assertParamExists('createGroupTemplate', 'groupTemplateCreateRequest', groupTemplateCreateRequest)
            const localVarPath = `/api/V2/{organizationId}/Templates/group`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Delete an existing group etmplae 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupTemplate: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteGroupTemplate', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteGroupTemplate', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/Templates/group/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/Templates/users/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns all user templates for the given organization. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDomains: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllDomains', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/domains`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all group templates for the given organization 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupTemplates: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllGroupTemplates', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/group/all`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroups: async (organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllGroups', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/users/groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupRole !== undefined) {
                localVarQueryParameter['groupRole'] = groupRole;
            }

            if (resultOrigin !== undefined) {
                localVarQueryParameter['resultOrigin'] = resultOrigin;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPermissions: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllPermissions', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/users/permissionRoles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableLicenses: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAvailableLicenses', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Templates/users/availableLicenses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupTemplate: async (organizationId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGroupTemplate', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroupTemplate', 'id', id)
            const localVarPath = `/api/V2/{organizationId}/Templates/group/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateUpdateRequest} userTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (organizationId: string, userTemplateUpdateRequest: UserTemplateUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('update', 'organizationId', organizationId)
            // verify required parameter 'userTemplateUpdateRequest' is not null or undefined
            assertParamExists('update', 'userTemplateUpdateRequest', userTemplateUpdateRequest)
            const localVarPath = `/api/V2/{organizationId}/Templates/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateUpdateRequest} groupTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupTemplate: async (organizationId: string, groupTemplateUpdateRequest: GroupTemplateUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateGroupTemplate', 'organizationId', organizationId)
            // verify required parameter 'groupTemplateUpdateRequest' is not null or undefined
            assertParamExists('updateGroupTemplate', 'groupTemplateUpdateRequest', groupTemplateUpdateRequest)
            const localVarPath = `/api/V2/{organizationId}/Templates/group`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Deletes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Creates a new user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateCreateRequest} userTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(organizationId: string, userTemplateCreateRequest: UserTemplateCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(organizationId, userTemplateCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Createts a new group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateCreateRequest} groupTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroupTemplate(organizationId: string, groupTemplateCreateRequest: GroupTemplateCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroupTemplate(organizationId, groupTemplateCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Delete an existing group etmplae 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupTemplate(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupTemplate(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns all user templates for the given organization. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDomains(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDomains(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all group templates for the given organization 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGroupTemplates(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGroupTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGroups(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGroups(organizationId, groupRole, resultOrigin, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPermissions(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTemplatePermissionRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPermissions(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableLicenses(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTemplateAvailableLicenseResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableLicenses(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupTemplate(organizationId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupTemplate(organizationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateUpdateRequest} userTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(organizationId: string, userTemplateUpdateRequest: UserTemplateUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(organizationId, userTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateUpdateRequest} groupTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupTemplate(organizationId: string, groupTemplateUpdateRequest: GroupTemplateUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupTemplate(organizationId, groupTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplatesApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Deletes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(organizationId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Creates a new user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateCreateRequest} userTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, userTemplateCreateRequest: UserTemplateCreateRequest, options?: any): AxiosPromise<UserTemplateResponse> {
            return localVarFp.create(organizationId, userTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Createts a new group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateCreateRequest} groupTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupTemplate(organizationId: string, groupTemplateCreateRequest: GroupTemplateCreateRequest, options?: any): AxiosPromise<GroupTemplateResponse> {
            return localVarFp.createGroupTemplate(organizationId, groupTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Delete an existing group etmplae 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupTemplate(organizationId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGroupTemplate(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(organizationId: string, id: string, options?: any): AxiosPromise<UserTemplateResponse> {
            return localVarFp.get(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns all user templates for the given organization. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, options?: any): AxiosPromise<Array<UserTemplateResponse>> {
            return localVarFp.getAll(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDomains(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllDomains(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary Returns all group templates for the given organization 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroupTemplates(organizationId: string, options?: any): AxiosPromise<Array<GroupTemplateResponse>> {
            return localVarFp.getAllGroupTemplates(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroups(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any): AxiosPromise<Array<UserGroupResponse>> {
            return localVarFp.getAllGroups(organizationId, groupRole, resultOrigin, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPermissions(organizationId: string, options?: any): AxiosPromise<Array<UserTemplatePermissionRoleResponse>> {
            return localVarFp.getAllPermissions(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
         * @summary 🔒: Templates.ShowModule, Timetable.Planner
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableLicenses(organizationId: string, options?: any): AxiosPromise<Array<UserTemplateAvailableLicenseResponse>> {
            return localVarFp.getAvailableLicenses(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Returns the specified group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupTemplate(organizationId: string, id: string, options?: any): AxiosPromise<GroupTemplateResponse> {
            return localVarFp.getGroupTemplate(organizationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing user template. 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {UserTemplateUpdateRequest} userTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(organizationId: string, userTemplateUpdateRequest: UserTemplateUpdateRequest, options?: any): AxiosPromise<UserTemplateResponse> {
            return localVarFp.update(organizationId, userTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
         * @summary Changes an existing group template 🔒: Templates.ShowModule
         * @param {string} organizationId 
         * @param {GroupTemplateUpdateRequest} groupTemplateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupTemplate(organizationId: string, groupTemplateUpdateRequest: GroupTemplateUpdateRequest, options?: any): AxiosPromise<GroupTemplateResponse> {
            return localVarFp.updateGroupTemplate(organizationId, groupTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Deletes an existing user template. 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public _delete(organizationId: string, id: string, options?: any) {
        return TemplatesApiFp(this.configuration)._delete(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Creates a new user template. 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {UserTemplateCreateRequest} userTemplateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public create(organizationId: string, userTemplateCreateRequest: UserTemplateCreateRequest, options?: any) {
        return TemplatesApiFp(this.configuration).create(organizationId, userTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Createts a new group template 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {GroupTemplateCreateRequest} groupTemplateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public createGroupTemplate(organizationId: string, groupTemplateCreateRequest: GroupTemplateCreateRequest, options?: any) {
        return TemplatesApiFp(this.configuration).createGroupTemplate(organizationId, groupTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Delete an existing group etmplae 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public deleteGroupTemplate(organizationId: string, id: string, options?: any) {
        return TemplatesApiFp(this.configuration).deleteGroupTemplate(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Returns the specified user template. 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public get(organizationId: string, id: string, options?: any) {
        return TemplatesApiFp(this.configuration).get(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Returns all user templates for the given organization. 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAll(organizationId: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary 🔒: Templates.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAllDomains(organizationId: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAllDomains(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary Returns all group templates for the given organization 🔒: Templates.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAllGroupTemplates(organizationId: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAllGroupTemplates(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary 🔒: Templates.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {GroupRole} [groupRole] 
     * @param {Origin} [resultOrigin] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAllGroups(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAllGroups(organizationId, groupRole, resultOrigin, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary 🔒: Templates.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAllPermissions(organizationId: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAllPermissions(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li><li>Timetable.Planner</li></ul>
     * @summary 🔒: Templates.ShowModule, Timetable.Planner
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getAvailableLicenses(organizationId: string, options?: any) {
        return TemplatesApiFp(this.configuration).getAvailableLicenses(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Returns the specified group template 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public getGroupTemplate(organizationId: string, id: string, options?: any) {
        return TemplatesApiFp(this.configuration).getGroupTemplate(organizationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Changes an existing user template. 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {UserTemplateUpdateRequest} userTemplateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public update(organizationId: string, userTemplateUpdateRequest: UserTemplateUpdateRequest, options?: any) {
        return TemplatesApiFp(this.configuration).update(organizationId, userTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Templates.ShowModule</li></ul>
     * @summary Changes an existing group template 🔒: Templates.ShowModule
     * @param {string} organizationId 
     * @param {GroupTemplateUpdateRequest} groupTemplateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    public updateGroupTemplate(organizationId: string, groupTemplateUpdateRequest: GroupTemplateUpdateRequest, options?: any) {
        return TemplatesApiFp(this.configuration).updateGroupTemplate(organizationId, groupTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {boolean} [deleteInvitation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (tenantId: string, deleteInvitation?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('_delete', 'tenantId', tenantId)
            const localVarPath = `/api/V2/Tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteInvitation !== undefined) {
                localVarQueryParameter['deleteInvitation'] = deleteInvitation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (tenantId: string, request?: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('get', 'tenantId', tenantId)
            const localVarPath = `/api/V2/Tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/V2/Tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} templateId 
         * @param {string} [organizationId] 
         * @param {boolean} [replaceGroups] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassicImport: async (tenantId: string, templateId: string, organizationId?: string, replaceGroups?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getClassicImport', 'tenantId', tenantId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getClassicImport', 'templateId', templateId)
            const localVarPath = `/api/V2/Tenants/{tenantId}/classicImport/{templateId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (replaceGroups !== undefined) {
                localVarQueryParameter['replaceGroups'] = replaceGroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentials: async (tenantId: string, reason?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCredentials', 'tenantId', tenantId)
            const localVarPath = `/api/V2/Tenants/{tenantId}/credentials`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtToken: async (tenantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getJwtToken', 'tenantId', tenantId)
            const localVarPath = `/api/V2/Tenants/{tenantId}/jwt`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary 🔒: Settings.ShowModule
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenses: async (tenantId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getLicenses', 'tenantId', tenantId)
            const localVarPath = `/api/V2/Tenants/{tenantId}/licenses`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasPaid: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/V2/Tenants/hasPaid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {TenantUpdateRequest} tenantUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (tenantUpdateRequest: TenantUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantUpdateRequest' is not null or undefined
            assertParamExists('update', 'tenantUpdateRequest', tenantUpdateRequest)
            const localVarPath = `/api/V2/Tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {boolean} [deleteInvitation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(tenantId: string, deleteInvitation?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(tenantId, deleteInvitation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(tenantId: string, request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(tenantId, request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} templateId 
         * @param {string} [organizationId] 
         * @param {boolean} [replaceGroups] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClassicImport(tenantId: string, templateId: string, organizationId?: string, replaceGroups?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClassicImport(tenantId, templateId, organizationId, replaceGroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCredentials(tenantId: string, reason?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantCredentialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCredentials(tenantId, reason, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJwtToken(tenantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJwtToken(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary 🔒: Settings.ShowModule
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicenses(tenantId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LicenseInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicenses(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasPaid(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasPaid(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {TenantUpdateRequest} tenantUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(tenantUpdateRequest: TenantUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(tenantUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {boolean} [deleteInvitation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(tenantId: string, deleteInvitation?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp._delete(tenantId, deleteInvitation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(tenantId: string, request?: object, options?: any): AxiosPromise<TenantResponse> {
            return localVarFp.get(tenantId, request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<Array<TenantResponse>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} templateId 
         * @param {string} [organizationId] 
         * @param {boolean} [replaceGroups] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassicImport(tenantId: string, templateId: string, organizationId?: string, replaceGroups?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.getClassicImport(tenantId, templateId, organizationId, replaceGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {string} [reason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentials(tenantId: string, reason?: string, options?: any): AxiosPromise<TenantCredentialsResponse> {
            return localVarFp.getCredentials(tenantId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtToken(tenantId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getJwtToken(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
         * @summary 🔒: Settings.ShowModule
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenses(tenantId: string, options?: any): AxiosPromise<Array<LicenseInfo>> {
            return localVarFp.getLicenses(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasPaid(options?: any): AxiosPromise<void> {
            return localVarFp.hasPaid(options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary 🔒: AixConcept.Only
         * @param {TenantUpdateRequest} tenantUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(tenantUpdateRequest: TenantUpdateRequest, options?: any): AxiosPromise<TenantResponse> {
            return localVarFp.update(tenantUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} tenantId 
     * @param {boolean} [deleteInvitation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public _delete(tenantId: string, deleteInvitation?: boolean, options?: any) {
        return TenantsApiFp(this.configuration)._delete(tenantId, deleteInvitation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenantId 
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public get(tenantId: string, request?: object, options?: any) {
        return TenantsApiFp(this.configuration).get(tenantId, request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getAll(options?: any) {
        return TenantsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} tenantId 
     * @param {string} templateId 
     * @param {string} [organizationId] 
     * @param {boolean} [replaceGroups] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getClassicImport(tenantId: string, templateId: string, organizationId?: string, replaceGroups?: boolean, options?: any) {
        return TenantsApiFp(this.configuration).getClassicImport(tenantId, templateId, organizationId, replaceGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} tenantId 
     * @param {string} [reason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getCredentials(tenantId: string, reason?: string, options?: any) {
        return TenantsApiFp(this.configuration).getCredentials(tenantId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getJwtToken(tenantId: string, options?: any) {
        return TenantsApiFp(this.configuration).getJwtToken(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Settings.ShowModule</li></ul>
     * @summary 🔒: Settings.ShowModule
     * @param {string} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public getLicenses(tenantId: string, options?: any) {
        return TenantsApiFp(this.configuration).getLicenses(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public hasPaid(options?: any) {
        return TenantsApiFp(this.configuration).hasPaid(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary 🔒: AixConcept.Only
     * @param {TenantUpdateRequest} tenantUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public update(tenantUpdateRequest: TenantUpdateRequest, options?: any) {
        return TenantsApiFp(this.configuration).update(tenantUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TimeTableApi - axios parameter creator
 * @export
 */
export const TimeTableApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {SubstitutionCreate} substitutionCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLessonSubstitution: async (organizationId: string, lessonId: string, substitutionCreate: SubstitutionCreate, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createLessonSubstitution', 'organizationId', organizationId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('createLessonSubstitution', 'lessonId', lessonId)
            // verify required parameter 'substitutionCreate' is not null or undefined
            assertParamExists('createLessonSubstitution', 'substitutionCreate', substitutionCreate)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/substitutions/{lessonId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(substitutionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLessonSubstitution: async (organizationId: string, lessonId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteLessonSubstitution', 'organizationId', organizationId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('deleteLessonSubstitution', 'lessonId', lessonId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/substitutions/{lessonId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClasses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getClasses', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/classes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourses: async (organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCourses', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/coures`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonWithSubstitution: async (organizationId: string, lessonId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLessonWithSubstitution', 'organizationId', organizationId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('getLessonWithSubstitution', 'lessonId', lessonId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/lessons/{lessonId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"lessonId"}}`, encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRooms', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/rooms`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudents: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getStudents', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/users/students`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeachers: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeachers', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/teachers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimePattern: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimePattern', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/pattern`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfGroup: async (organizationId: string, groupId: string, days: number, start: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimeTableOfGroup', 'organizationId', organizationId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getTimeTableOfGroup', 'groupId', groupId)
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimeTableOfGroup', 'days', days)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimeTableOfGroup', 'start', start)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/{start}/next/{days}/days/of/group/{groupId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"days"}}`, encodeURIComponent(String(days)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {number} days 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfRoom: async (organizationId: string, roomId: string, start: string, days: number, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimeTableOfRoom', 'organizationId', organizationId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getTimeTableOfRoom', 'roomId', roomId)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimeTableOfRoom', 'start', start)
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimeTableOfRoom', 'days', days)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/{start}/next/{days}/days/of/room/{roomId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)))
                .replace(`{${"days"}}`, encodeURIComponent(String(days)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfUser: async (organizationId: string, userId: string, days: number, start: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTimeTableOfUser', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTimeTableOfUser', 'userId', userId)
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTimeTableOfUser', 'days', days)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getTimeTableOfUser', 'start', start)
            const localVarPath = `/api/V2/{organizationId}/TimeTable/{start}/next/{days}/days/of/user/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"days"}}`, encodeURIComponent(String(days)))
                .replace(`{${"start"}}`, encodeURIComponent(String(start)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeTableApi - functional programming interface
 * @export
 */
export const TimeTableApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeTableApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {SubstitutionCreate} substitutionCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLessonSubstitution(organizationId: string, lessonId: string, substitutionCreate: SubstitutionCreate, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Substitution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLessonSubstitution(organizationId, lessonId, substitutionCreate, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLessonSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLessonSubstitution(organizationId, lessonId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfClassBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfCourseBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLessonWithSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableLessonWithSubstitution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLessonWithSubstitution(organizationId, lessonId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRooms(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRooms(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudents(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudents(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeachers(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeachers(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimePattern(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimePatternResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimePattern(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTableOfGroup(organizationId: string, groupId: string, days: number, start: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTableOfGroup(organizationId, groupId, days, start, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {number} days 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTableOfRoom(organizationId: string, roomId: string, start: string, days: number, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTableOfRoom(organizationId, roomId, start, days, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTableOfUser(organizationId: string, userId: string, days: number, start: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeTableOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTableOfUser(organizationId, userId, days, start, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeTableApi - factory interface
 * @export
 */
export const TimeTableApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeTableApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {SubstitutionCreate} substitutionCreate 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLessonSubstitution(organizationId: string, lessonId: string, substitutionCreate: SubstitutionCreate, timePeriod?: string, options?: any): AxiosPromise<Substitution> {
            return localVarFp.createLessonSubstitution(organizationId, lessonId, substitutionCreate, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLessonSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLessonSubstitution(organizationId, lessonId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfClassBasicResponse> {
            return localVarFp.getClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfCourseBasicResponse> {
            return localVarFp.getCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} lessonId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLessonWithSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableLessonWithSubstitution> {
            return localVarFp.getLessonWithSubstitution(organizationId, lessonId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRooms(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<ResourceResponse>> {
            return localVarFp.getRooms(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudents(organizationId: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getStudents(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeachers(organizationId: string, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.getTeachers(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
         * @summary 🔒: Timetable.ManageSubstitutions
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimePattern(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<TimePatternResponse> {
            return localVarFp.getTimePattern(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfGroup(organizationId: string, groupId: string, days: number, start: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimeTableOfGroup(organizationId, groupId, days, start, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} roomId 
         * @param {string} start 
         * @param {number} days 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfRoom(organizationId: string, roomId: string, start: string, days: number, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimeTableOfRoom(organizationId, roomId, start, days, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li><li>Timetable.ReadAll</li></ul>
         * @summary 🔒: Timetable.ShowModule, Timetable.ReadAll
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {number} days 
         * @param {string} start 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTableOfUser(organizationId: string, userId: string, days: number, start: string, timePeriod?: string, options?: any): AxiosPromise<TimeTableOverview> {
            return localVarFp.getTimeTableOfUser(organizationId, userId, days, start, timePeriod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeTableApi - object-oriented interface
 * @export
 * @class TimeTableApi
 * @extends {BaseAPI}
 */
export class TimeTableApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
     * @summary 🔒: Timetable.ManageSubstitutions
     * @param {string} organizationId 
     * @param {string} lessonId 
     * @param {SubstitutionCreate} substitutionCreate 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public createLessonSubstitution(organizationId: string, lessonId: string, substitutionCreate: SubstitutionCreate, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).createLessonSubstitution(organizationId, lessonId, substitutionCreate, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
     * @summary 🔒: Timetable.ManageSubstitutions
     * @param {string} organizationId 
     * @param {string} lessonId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public deleteLessonSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).deleteLessonSubstitution(organizationId, lessonId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getClasses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return TimeTableApiFp(this.configuration).getClasses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getCourses(organizationId: string, timePeriod?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return TimeTableApiFp(this.configuration).getCourses(organizationId, timePeriod, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
     * @summary 🔒: Timetable.ManageSubstitutions
     * @param {string} organizationId 
     * @param {string} lessonId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getLessonWithSubstitution(organizationId: string, lessonId: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getLessonWithSubstitution(organizationId, lessonId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getRooms(organizationId: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getRooms(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getStudents(organizationId: string, options?: any) {
        return TimeTableApiFp(this.configuration).getStudents(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getTeachers(organizationId: string, options?: any) {
        return TimeTableApiFp(this.configuration).getTeachers(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ManageSubstitutions</li></ul>
     * @summary 🔒: Timetable.ManageSubstitutions
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getTimePattern(organizationId: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getTimePattern(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} groupId 
     * @param {number} days 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getTimeTableOfGroup(organizationId: string, groupId: string, days: number, start: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getTimeTableOfGroup(organizationId, groupId, days, start, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} roomId 
     * @param {string} start 
     * @param {number} days 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getTimeTableOfRoom(organizationId: string, roomId: string, start: string, days: number, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getTimeTableOfRoom(organizationId, roomId, start, days, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Timetable.ShowModule</li><li>Timetable.ReadAll</li></ul>
     * @summary 🔒: Timetable.ShowModule, Timetable.ReadAll
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {number} days 
     * @param {string} start 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeTableApi
     */
    public getTimeTableOfUser(organizationId: string, userId: string, days: number, start: string, timePeriod?: string, options?: any) {
        return TimeTableApiFp(this.configuration).getTimeTableOfUser(organizationId, userId, days, start, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupsApi - axios parameter creator
 * @export
 */
export const UserGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Deletes the given group in the specified organization. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Sets the group image to the given picture. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [photo] 
         * @param {any} [photo2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdatePhoto: async (id: string, organizationId: string, photo?: string, photo2?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addOrUpdatePhoto', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addOrUpdatePhoto', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/{id}/photo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (photo !== undefined) {
                localVarQueryParameter['photo'] = photo;
            }


            if (photo2 !== undefined) { 
                localVarFormParams.append('photo', photo2 as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets the archived flag for the specified groups and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to archive groups, or must be owner of the groups to archive them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archive: async (organizationId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('archive', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('archive', 'requestBody', requestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/archive`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li><li>Timetable.Planner</li></ul>
         * @summary Creates a new group within the specified organization. 🔒: Groups.WriteAll, Timetable.Planner
         * @param {string} organizationId 
         * @param {UserGroupCreateRequestBody} userGroupCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (organizationId: string, userGroupCreateRequestBody: UserGroupCreateRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('create', 'organizationId', organizationId)
            // verify required parameter 'userGroupCreateRequestBody' is not null or undefined
            assertParamExists('create', 'userGroupCreateRequestBody', userGroupCreateRequestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupCreateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from specified group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformation: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMetaInformation', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/metaInformation`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from a single group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformationOf: async (organizationId: string, groupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteMetaInformationOf', 'organizationId', organizationId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteMetaInformationOf', 'groupId', groupId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/metaInformation/of/{groupId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li><li>Passwords.ChangeGroupMemberPasswords</li></ul>
         * @summary Returns the specified group within the given organization. 🔒: Groups.ShowModule, Passwords.ChangeGroupMemberPasswords
         * @param {string} id 
         * @param {string} organizationId 
         * @param {boolean} [checkIsDeleted] If set, it will be checked if the given group was deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, organizationId: string, checkIsDeleted?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (checkIsDeleted !== undefined) {
                localVarQueryParameter['checkIsDeleted'] = checkIsDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Groups.ShowModule</li><li>Classbook.ShowModule</li><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all groups of the specified organization. Filters additionally by the role if specified. 🔒: Courses.ShowModule, Groups.ShowModule, Classbook.ShowModule, Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (groupRole !== undefined) {
                localVarQueryParameter['groupRole'] = groupRole;
            }

            if (resultOrigin !== undefined) {
                localVarQueryParameter['resultOrigin'] = resultOrigin;
            }

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {string} [filter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices: async (organizationId: string, filter?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllDevices', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/devices`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all archived groups of the specified organization. If requesting user has the \"Groups.WriteAll\" permission, all archived groups are returned, otherwise only archived groups where the user is owner.
         * @param {string} organizationId 
         * @param {string} [filterBy] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchived: async (organizationId: string, filterBy?: string, pageSize?: number, page?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getArchived', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/archived`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns all deleted groups, which can be restored. 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeleted: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeleted', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/deleted`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupTemplatets: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGroupTemplatets', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/groupTemplates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermittedUsersForUser: async (organizationId: string, period: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPermittedUsersForUser', 'organizationId', organizationId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getPermittedUsersForUser', 'period', period)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/permittedUsers/for/{period}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"period"}}`, encodeURIComponent(String(period)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns the current image of the specified group. 🔒: Groups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPhoto', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPhoto', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/{id}/photo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the specified user as member to the desired group. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupJoinRequestBody} userGroupJoinRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join: async (organizationId: string, userGroupJoinRequestBody: UserGroupJoinRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('join', 'organizationId', organizationId)
            // verify required parameter 'userGroupJoinRequestBody' is not null or undefined
            assertParamExists('join', 'userGroupJoinRequestBody', userGroupJoinRequestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/join`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupJoinRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new group with all members and owners of the specified groups. Additionally the source group can be deleted or not. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupMergeRequestBody} userGroupMergeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge: async (organizationId: string, userGroupMergeRequestBody: UserGroupMergeRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('merge', 'organizationId', organizationId)
            // verify required parameter 'userGroupMergeRequestBody' is not null or undefined
            assertParamExists('merge', 'userGroupMergeRequestBody', userGroupMergeRequestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/merge`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupMergeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Instructs OneNote to start a notebook repair.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairNotebook: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repairNotebook', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('repairNotebook', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/notebook/{id}/repair`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.RestoreDeleted</li></ul>
         * @summary Tries to restore the specified group. 🔒: Groups.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeleted: async (organizationId: string, groupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('restoreDeleted', 'organizationId', organizationId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('restoreDeleted', 'groupId', groupId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/deleted/{groupId}/restore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restores the specified groups from archive and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to restore groups, or must be owner of the groups to restore them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreFromArchive: async (organizationId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('restoreFromArchive', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('restoreFromArchive', 'requestBody', requestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/archived/restore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the tenants service user to the owner of the specified group if needed. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setServiceUserAsOwner: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setServiceUserAsOwner', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setServiceUserAsOwner', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/owners/{id}/serviceUser`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new job to align SharePoint site base url with corresponding group name in the specified tenant. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupStartSharePointSiteRenamingRequest} userGroupStartSharePointSiteRenamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSharePointSiteRenaming: async (organizationId: string, userGroupStartSharePointSiteRenamingRequest: UserGroupStartSharePointSiteRenamingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('startSharePointSiteRenaming', 'organizationId', organizationId)
            // verify required parameter 'userGroupStartSharePointSiteRenamingRequest' is not null or undefined
            assertParamExists('startSharePointSiteRenaming', 'userGroupStartSharePointSiteRenamingRequest', userGroupStartSharePointSiteRenamingRequest)
            const localVarPath = `/api/V2/{organizationId}/UserGroups/sharePoint/startRenaming`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupStartSharePointSiteRenamingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes the specified group. Members and owners must be provided as delta lists about which users should be added or removed. User must be owner of the group or 🔒: Groups.WriteAll, Timetable.Designer
         * @param {string} organizationId 
         * @param {UserGroupUpdateRequestBody} userGroupUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (organizationId: string, userGroupUpdateRequestBody: UserGroupUpdateRequestBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('update', 'organizationId', organizationId)
            // verify required parameter 'userGroupUpdateRequestBody' is not null or undefined
            assertParamExists('update', 'userGroupUpdateRequestBody', userGroupUpdateRequestBody)
            const localVarPath = `/api/V2/{organizationId}/UserGroups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupsApi - functional programming interface
 * @export
 */
export const UserGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Deletes the given group in the specified organization. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Sets the group image to the given picture. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [photo] 
         * @param {any} [photo2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdatePhoto(id: string, organizationId: string, photo?: string, photo2?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdatePhoto(id, organizationId, photo, photo2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sets the archived flag for the specified groups and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to archive groups, or must be owner of the groups to archive them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archive(organizationId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archive(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li><li>Timetable.Planner</li></ul>
         * @summary Creates a new group within the specified organization. 🔒: Groups.WriteAll, Timetable.Planner
         * @param {string} organizationId 
         * @param {UserGroupCreateRequestBody} userGroupCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(organizationId: string, userGroupCreateRequestBody: UserGroupCreateRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(organizationId, userGroupCreateRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from specified group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMetaInformation(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMetaInformation(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from a single group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMetaInformationOf(organizationId: string, groupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMetaInformationOf(organizationId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li><li>Passwords.ChangeGroupMemberPasswords</li></ul>
         * @summary Returns the specified group within the given organization. 🔒: Groups.ShowModule, Passwords.ChangeGroupMemberPasswords
         * @param {string} id 
         * @param {string} organizationId 
         * @param {boolean} [checkIsDeleted] If set, it will be checked if the given group was deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, organizationId: string, checkIsDeleted?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, organizationId, checkIsDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Groups.ShowModule</li><li>Classbook.ShowModule</li><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all groups of the specified organization. Filters additionally by the role if specified. 🔒: Courses.ShowModule, Groups.ShowModule, Classbook.ShowModule, Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, groupRole, resultOrigin, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {string} [filter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDevices(organizationId: string, filter?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfUserGroupsDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDevices(organizationId, filter, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all archived groups of the specified organization. If requesting user has the \"Groups.WriteAll\" permission, all archived groups are returned, otherwise only archived groups where the user is owner.
         * @param {string} organizationId 
         * @param {string} [filterBy] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchived(organizationId: string, filterBy?: string, pageSize?: number, page?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOfUserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchived(organizationId, filterBy, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns all deleted groups, which can be restored. 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeleted(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeleted(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupTemplatets(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroupTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupTemplatets(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermittedUsersForUser(organizationId: string, period: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGroupUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermittedUsersForUser(organizationId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns the current image of the specified group. 🔒: Groups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoto(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoto(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the specified user as member to the desired group. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupJoinRequestBody} userGroupJoinRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async join(organizationId: string, userGroupJoinRequestBody: UserGroupJoinRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.join(organizationId, userGroupJoinRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new group with all members and owners of the specified groups. Additionally the source group can be deleted or not. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupMergeRequestBody} userGroupMergeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merge(organizationId: string, userGroupMergeRequestBody: UserGroupMergeRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merge(organizationId, userGroupMergeRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Instructs OneNote to start a notebook repair.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairNotebook(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairNotebook(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.RestoreDeleted</li></ul>
         * @summary Tries to restore the specified group. 🔒: Groups.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreDeleted(organizationId: string, groupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreDeleted(organizationId, groupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Restores the specified groups from archive and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to restore groups, or must be owner of the groups to restore them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreFromArchive(organizationId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreFromArchive(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the tenants service user to the owner of the specified group if needed. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setServiceUserAsOwner(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setServiceUserAsOwner(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new job to align SharePoint site base url with corresponding group name in the specified tenant. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupStartSharePointSiteRenamingRequest} userGroupStartSharePointSiteRenamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSharePointSiteRenaming(organizationId: string, userGroupStartSharePointSiteRenamingRequest: UserGroupStartSharePointSiteRenamingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSharePointSiteRenaming(organizationId, userGroupStartSharePointSiteRenamingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes the specified group. Members and owners must be provided as delta lists about which users should be added or removed. User must be owner of the group or 🔒: Groups.WriteAll, Timetable.Designer
         * @param {string} organizationId 
         * @param {UserGroupUpdateRequestBody} userGroupUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(organizationId: string, userGroupUpdateRequestBody: UserGroupUpdateRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(organizationId, userGroupUpdateRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupsApi - factory interface
 * @export
 */
export const UserGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Deletes the given group in the specified organization. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Sets the group image to the given picture. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [photo] 
         * @param {any} [photo2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdatePhoto(id: string, organizationId: string, photo?: string, photo2?: any, options?: any): AxiosPromise<string> {
            return localVarFp.addOrUpdatePhoto(id, organizationId, photo, photo2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets the archived flag for the specified groups and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to archive groups, or must be owner of the groups to archive them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archive(organizationId: string, requestBody: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.archive(organizationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li><li>Timetable.Planner</li></ul>
         * @summary Creates a new group within the specified organization. 🔒: Groups.WriteAll, Timetable.Planner
         * @param {string} organizationId 
         * @param {UserGroupCreateRequestBody} userGroupCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, userGroupCreateRequestBody: UserGroupCreateRequestBody, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.create(organizationId, userGroupCreateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from specified group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformation(organizationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteMetaInformation(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Removes meta information from a single group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMetaInformationOf(organizationId: string, groupId: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteMetaInformationOf(organizationId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li><li>Passwords.ChangeGroupMemberPasswords</li></ul>
         * @summary Returns the specified group within the given organization. 🔒: Groups.ShowModule, Passwords.ChangeGroupMemberPasswords
         * @param {string} id 
         * @param {string} organizationId 
         * @param {boolean} [checkIsDeleted] If set, it will be checked if the given group was deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, organizationId: string, checkIsDeleted?: boolean, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.get(id, organizationId, checkIsDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Groups.ShowModule</li><li>Classbook.ShowModule</li><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
         * @summary Returns all groups of the specified organization. Filters additionally by the role if specified. 🔒: Courses.ShowModule, Groups.ShowModule, Classbook.ShowModule, Settings.Classbook, Timetable.Planner
         * @param {string} organizationId 
         * @param {GroupRole} [groupRole] 
         * @param {Origin} [resultOrigin] 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any): AxiosPromise<Array<UserGroupResponse>> {
            return localVarFp.getAll(organizationId, groupRole, resultOrigin, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {string} [filter] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices(organizationId: string, filter?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfUserGroupsDeviceResponse> {
            return localVarFp.getAllDevices(organizationId, filter, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all archived groups of the specified organization. If requesting user has the \"Groups.WriteAll\" permission, all archived groups are returned, otherwise only archived groups where the user is owner.
         * @param {string} organizationId 
         * @param {string} [filterBy] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchived(organizationId: string, filterBy?: string, pageSize?: number, page?: number, options?: any): AxiosPromise<PagedOfUserGroupResponse> {
            return localVarFp.getArchived(organizationId, filterBy, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns all deleted groups, which can be restored. 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeleted(organizationId: string, options?: any): AxiosPromise<Array<UserGroupResponse>> {
            return localVarFp.getDeleted(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary 🔒: Groups.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupTemplatets(organizationId: string, options?: any): AxiosPromise<Array<UserGroupTemplateResponse>> {
            return localVarFp.getGroupTemplatets(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermittedUsersForUser(organizationId: string, period: string, options?: any): AxiosPromise<Array<UserGroupUserResponse>> {
            return localVarFp.getPermittedUsersForUser(organizationId, period, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
         * @summary Returns the current image of the specified group. 🔒: Groups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(id: string, organizationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPhoto(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the specified user as member to the desired group. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupJoinRequestBody} userGroupJoinRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join(organizationId: string, userGroupJoinRequestBody: UserGroupJoinRequestBody, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.join(organizationId, userGroupJoinRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new group with all members and owners of the specified groups. Additionally the source group can be deleted or not. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupMergeRequestBody} userGroupMergeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(organizationId: string, userGroupMergeRequestBody: UserGroupMergeRequestBody, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.merge(organizationId, userGroupMergeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Instructs OneNote to start a notebook repair.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairNotebook(id: string, organizationId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.repairNotebook(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.RestoreDeleted</li></ul>
         * @summary Tries to restore the specified group. 🔒: Groups.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeleted(organizationId: string, groupId: string, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.restoreDeleted(organizationId, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restores the specified groups from archive and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to restore groups, or must be owner of the groups to restore them.
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreFromArchive(organizationId: string, requestBody: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.restoreFromArchive(organizationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Adds the tenants service user to the owner of the specified group if needed. 🔒: Groups.WriteAll
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setServiceUserAsOwner(id: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.setServiceUserAsOwner(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
         * @summary Creates a new job to align SharePoint site base url with corresponding group name in the specified tenant. 🔒: Groups.WriteAll
         * @param {string} organizationId 
         * @param {UserGroupStartSharePointSiteRenamingRequest} userGroupStartSharePointSiteRenamingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSharePointSiteRenaming(organizationId: string, userGroupStartSharePointSiteRenamingRequest: UserGroupStartSharePointSiteRenamingRequest, options?: any): AxiosPromise<string> {
            return localVarFp.startSharePointSiteRenaming(organizationId, userGroupStartSharePointSiteRenamingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes the specified group. Members and owners must be provided as delta lists about which users should be added or removed. User must be owner of the group or 🔒: Groups.WriteAll, Timetable.Designer
         * @param {string} organizationId 
         * @param {UserGroupUpdateRequestBody} userGroupUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(organizationId: string, userGroupUpdateRequestBody: UserGroupUpdateRequestBody, options?: any): AxiosPromise<UserGroupResponse> {
            return localVarFp.update(organizationId, userGroupUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupsApi - object-oriented interface
 * @export
 * @class UserGroupsApi
 * @extends {BaseAPI}
 */
export class UserGroupsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Deletes the given group in the specified organization. 🔒: Groups.WriteAll
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public _delete(id: string, organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration)._delete(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Sets the group image to the given picture. 🔒: Groups.WriteAll
     * @param {string} id 
     * @param {string} organizationId 
     * @param {string} [photo] 
     * @param {any} [photo2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public addOrUpdatePhoto(id: string, organizationId: string, photo?: string, photo2?: any, options?: any) {
        return UserGroupsApiFp(this.configuration).addOrUpdatePhoto(id, organizationId, photo, photo2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets the archived flag for the specified groups and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to archive groups, or must be owner of the groups to archive them.
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public archive(organizationId: string, requestBody: Array<string>, options?: any) {
        return UserGroupsApiFp(this.configuration).archive(organizationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li><li>Timetable.Planner</li></ul>
     * @summary Creates a new group within the specified organization. 🔒: Groups.WriteAll, Timetable.Planner
     * @param {string} organizationId 
     * @param {UserGroupCreateRequestBody} userGroupCreateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public create(organizationId: string, userGroupCreateRequestBody: UserGroupCreateRequestBody, options?: any) {
        return UserGroupsApiFp(this.configuration).create(organizationId, userGroupCreateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Removes meta information from specified group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public deleteMetaInformation(organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).deleteMetaInformation(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Can only by used from AixConcept users.<br>Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Removes meta information from a single group of the given organization to break linkage to MNSpro Cloud. (Especially needed for hybrid sync detachment) 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public deleteMetaInformationOf(organizationId: string, groupId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).deleteMetaInformationOf(organizationId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.ShowModule</li><li>Passwords.ChangeGroupMemberPasswords</li></ul>
     * @summary Returns the specified group within the given organization. 🔒: Groups.ShowModule, Passwords.ChangeGroupMemberPasswords
     * @param {string} id 
     * @param {string} organizationId 
     * @param {boolean} [checkIsDeleted] If set, it will be checked if the given group was deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public get(id: string, organizationId: string, checkIsDeleted?: boolean, options?: any) {
        return UserGroupsApiFp(this.configuration).get(id, organizationId, checkIsDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Courses.ShowModule</li><li>Groups.ShowModule</li><li>Classbook.ShowModule</li><li>Settings.Classbook</li><li>Timetable.Planner</li></ul>
     * @summary Returns all groups of the specified organization. Filters additionally by the role if specified. 🔒: Courses.ShowModule, Groups.ShowModule, Classbook.ShowModule, Settings.Classbook, Timetable.Planner
     * @param {string} organizationId 
     * @param {GroupRole} [groupRole] 
     * @param {Origin} [resultOrigin] 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getAll(organizationId: string, groupRole?: GroupRole, resultOrigin?: Origin, timePeriod?: string, options?: any) {
        return UserGroupsApiFp(this.configuration).getAll(organizationId, groupRole, resultOrigin, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
     * @summary 🔒: Groups.ShowModule
     * @param {string} organizationId 
     * @param {string} [filter] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getAllDevices(organizationId: string, filter?: string, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return UserGroupsApiFp(this.configuration).getAllDevices(organizationId, filter, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all archived groups of the specified organization. If requesting user has the \"Groups.WriteAll\" permission, all archived groups are returned, otherwise only archived groups where the user is owner.
     * @param {string} organizationId 
     * @param {string} [filterBy] 
     * @param {number} [pageSize] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getArchived(organizationId: string, filterBy?: string, pageSize?: number, page?: number, options?: any) {
        return UserGroupsApiFp(this.configuration).getArchived(organizationId, filterBy, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
     * @summary Returns all deleted groups, which can be restored. 🔒: Groups.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getDeleted(organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).getDeleted(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
     * @summary 🔒: Groups.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getGroupTemplatets(organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).getGroupTemplatets(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getPermittedUsersForUser(organizationId: string, period: string, options?: any) {
        return UserGroupsApiFp(this.configuration).getPermittedUsersForUser(organizationId, period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.ShowModule</li></ul>
     * @summary Returns the current image of the specified group. 🔒: Groups.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public getPhoto(id: string, organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).getPhoto(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Adds the specified user as member to the desired group. 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {UserGroupJoinRequestBody} userGroupJoinRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public join(organizationId: string, userGroupJoinRequestBody: UserGroupJoinRequestBody, options?: any) {
        return UserGroupsApiFp(this.configuration).join(organizationId, userGroupJoinRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Creates a new group with all members and owners of the specified groups. Additionally the source group can be deleted or not. 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {UserGroupMergeRequestBody} userGroupMergeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public merge(organizationId: string, userGroupMergeRequestBody: UserGroupMergeRequestBody, options?: any) {
        return UserGroupsApiFp(this.configuration).merge(organizationId, userGroupMergeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Instructs OneNote to start a notebook repair.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public repairNotebook(id: string, organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).repairNotebook(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.RestoreDeleted</li></ul>
     * @summary Tries to restore the specified group. 🔒: Groups.RestoreDeleted
     * @param {string} organizationId 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public restoreDeleted(organizationId: string, groupId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).restoreDeleted(organizationId, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restores the specified groups from archive and if available the underlying Microsoft team. User needs the \"Groups.WriteAll\" permission to restore groups, or must be owner of the groups to restore them.
     * @param {string} organizationId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public restoreFromArchive(organizationId: string, requestBody: Array<string>, options?: any) {
        return UserGroupsApiFp(this.configuration).restoreFromArchive(organizationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Adds the tenants service user to the owner of the specified group if needed. 🔒: Groups.WriteAll
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public setServiceUserAsOwner(id: string, organizationId: string, options?: any) {
        return UserGroupsApiFp(this.configuration).setServiceUserAsOwner(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Groups.WriteAll</li></ul>
     * @summary Creates a new job to align SharePoint site base url with corresponding group name in the specified tenant. 🔒: Groups.WriteAll
     * @param {string} organizationId 
     * @param {UserGroupStartSharePointSiteRenamingRequest} userGroupStartSharePointSiteRenamingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public startSharePointSiteRenaming(organizationId: string, userGroupStartSharePointSiteRenamingRequest: UserGroupStartSharePointSiteRenamingRequest, options?: any) {
        return UserGroupsApiFp(this.configuration).startSharePointSiteRenaming(organizationId, userGroupStartSharePointSiteRenamingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes the specified group. Members and owners must be provided as delta lists about which users should be added or removed. User must be owner of the group or 🔒: Groups.WriteAll, Timetable.Designer
     * @param {string} organizationId 
     * @param {UserGroupUpdateRequestBody} userGroupUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public update(organizationId: string, userGroupUpdateRequestBody: UserGroupUpdateRequestBody, options?: any) {
        return UserGroupsApiFp(this.configuration).update(organizationId, userGroupUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPreferencesApi - axios parameter creator
 * @export
 */
export const UserPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets user preferences for a specific module
         * @param {string} moduleName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (moduleName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleName' is not null or undefined
            assertParamExists('get', 'moduleName', moduleName)
            const localVarPath = `/api/v2/UserPreferences/{moduleName}`
                .replace(`{${"moduleName"}}`, encodeURIComponent(String(moduleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all user preferences for the user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/UserPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patches user preferences for a module.              Sample:              Current Settings-Objectt \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     },     \"foo2\": \"bar2\" }              If you try to patch a sub object of a settingsKey for example you want to update \"foo\" in \"General\".\"theme\" you also have to send the property \"other\". Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     }     \"foo2\": \"bar2\" }              Payload: \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     } }              If you try to patch \"foo2\" as property of \"General\" you just need to send \"foo2\" as payload. Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     }     \"foo2\": \"newBar\" }              Payload: \"General\": {     \"foo2\": \"newBar\" }
         * @param {string} moduleName The module name to patch.
         * @param {{ [key: string]: any; }} [requestBody] The settings to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchModule: async (moduleName: string, requestBody?: { [key: string]: any; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleName' is not null or undefined
            assertParamExists('patchModule', 'moduleName', moduleName)
            const localVarPath = `/api/v2/UserPreferences/{moduleName}`
                .replace(`{${"moduleName"}}`, encodeURIComponent(String(moduleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPreferencesApi - functional programming interface
 * @export
 */
export const UserPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets user preferences for a specific module
         * @param {string} moduleName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(moduleName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(moduleName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all user preferences for the user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patches user preferences for a module.              Sample:              Current Settings-Objectt \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     },     \"foo2\": \"bar2\" }              If you try to patch a sub object of a settingsKey for example you want to update \"foo\" in \"General\".\"theme\" you also have to send the property \"other\". Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     }     \"foo2\": \"bar2\" }              Payload: \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     } }              If you try to patch \"foo2\" as property of \"General\" you just need to send \"foo2\" as payload. Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     }     \"foo2\": \"newBar\" }              Payload: \"General\": {     \"foo2\": \"newBar\" }
         * @param {string} moduleName The module name to patch.
         * @param {{ [key: string]: any; }} [requestBody] The settings to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchModule(moduleName: string, requestBody?: { [key: string]: any; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchModule(moduleName, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPreferencesApi - factory interface
 * @export
 */
export const UserPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets user preferences for a specific module
         * @param {string} moduleName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(moduleName: string, options?: any): AxiosPromise<any> {
            return localVarFp.get(moduleName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all user preferences for the user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(request?: object, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getAll(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patches user preferences for a module.              Sample:              Current Settings-Objectt \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     },     \"foo2\": \"bar2\" }              If you try to patch a sub object of a settingsKey for example you want to update \"foo\" in \"General\".\"theme\" you also have to send the property \"other\". Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     }     \"foo2\": \"bar2\" }              Payload: \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     } }              If you try to patch \"foo2\" as property of \"General\" you just need to send \"foo2\" as payload. Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     }     \"foo2\": \"newBar\" }              Payload: \"General\": {     \"foo2\": \"newBar\" }
         * @param {string} moduleName The module name to patch.
         * @param {{ [key: string]: any; }} [requestBody] The settings to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchModule(moduleName: string, requestBody?: { [key: string]: any; }, options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.patchModule(moduleName, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPreferencesApi - object-oriented interface
 * @export
 * @class UserPreferencesApi
 * @extends {BaseAPI}
 */
export class UserPreferencesApi extends BaseAPI {
    /**
     * 
     * @summary Gets user preferences for a specific module
     * @param {string} moduleName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesApi
     */
    public get(moduleName: string, options?: any) {
        return UserPreferencesApiFp(this.configuration).get(moduleName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all user preferences for the user.
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesApi
     */
    public getAll(request?: object, options?: any) {
        return UserPreferencesApiFp(this.configuration).getAll(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patches user preferences for a module.              Sample:              Current Settings-Objectt \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     },     \"foo2\": \"bar2\" }              If you try to patch a sub object of a settingsKey for example you want to update \"foo\" in \"General\".\"theme\" you also have to send the property \"other\". Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     }     \"foo2\": \"bar2\" }              Payload: \"General\": {     \"theme\": {         \"other\": \"creation\",         \"foo\": \"bar\"     } }              If you try to patch \"foo2\" as property of \"General\" you just need to send \"foo2\" as payload. Should Settings-Object \"General\": {     \"theme\": {         \"other\": \"value\",         \"foo\": \"bar\"     }     \"foo2\": \"newBar\" }              Payload: \"General\": {     \"foo2\": \"newBar\" }
     * @param {string} moduleName The module name to patch.
     * @param {{ [key: string]: any; }} [requestBody] The settings to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesApi
     */
    public patchModule(moduleName: string, requestBody?: { [key: string]: any; }, options?: any) {
        return UserPreferencesApiFp(this.configuration).patchModule(moduleName, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('_delete', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('_delete', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Creates a new user with the specified options. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {UserCreateOptions} userCreateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (organizationId: string, userCreateOptions: UserCreateOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('create', 'organizationId', organizationId)
            // verify required parameter 'userCreateOptions' is not null or undefined
            assertParamExists('create', 'userCreateOptions', userCreateOptions)
            const localVarPath = `/api/V2/{organizationId}/Users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('get', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all users of the desired organization.
         * @param {string} organizationId 
         * @param {string} [nextLink] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, nextLink?: string, take?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (nextLink !== undefined) {
                localVarQueryParameter['nextLink'] = nextLink;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Get all deleted users 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeleted: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllDeleted', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/deleted`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDomains: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllDomains', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/domains`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all groups 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroups: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAllGroups', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all available user templates specified for the provided organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTemplates: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAvailableTemplates', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all courses of the specified user for the provided organization and time period. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsUserCourses: async (organizationId: string, userId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDetailsUserCourses', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDetailsUserCourses', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/courses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsUserPermissions: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDetailsUserPermissions', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDetailsUserPermissions', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/permissions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Gets users groups. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsOfUser: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGroupsOfUser', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getGroupsOfUser', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns whether or not a mail/alias is available 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} [mailOrAlias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailAliasAvailable: async (organizationId: string, mailOrAlias?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMailAliasAvailable', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/mail-alias-available`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (mailOrAlias !== undefined) {
                localVarQueryParameter['mailOrAlias'] = mailOrAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the photo of the desired user
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPhoto', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPhoto', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/photo`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the profile of the current user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (request?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/users/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (request !== undefined) {
                localVarQueryParameter['request'] = request;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Gets all students of the desired organization sourced from StudentDossiers (ClassRegister V3). Returns the same shape as GetAll, but the data originates from IStudentDossiersServiceRead.GetAll instead of Azure / Microsoft Graph. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentsFromDossiers: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getStudentsFromDossiers', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/dossiers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary create a unique universal principial name 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {GetUpnRequest} getUpnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpn: async (organizationId: string, getUpnRequest: GetUpnRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUpn', 'organizationId', organizationId)
            // verify required parameter 'getUpnRequest' is not null or undefined
            assertParamExists('getUpn', 'getUpnRequest', getUpnRequest)
            const localVarPath = `/api/V2/{organizationId}/Users/upn`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUpnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.MigrateReferenceIds</li></ul>
         * @summary Migrates user reference IDs from SchILD NRW V2 (GUID) to SchILD NRW V3 based on the mapping CSV produced by the SchILD export tool. The CSV can be sent either as a multipart/form-data file upload or as a JSON body (MigrateReferenceIdsCsvBody); the string body is preferred when both are present. Without ?apply=true only a preview of the migration is returned; with ?apply=true the new reference IDs are written to the Microsoft Graph schema extension and the returned list reflects the state after the migration. 🔒: Users.MigrateReferenceIds
         * @param {string} organizationId The organization ID.
         * @param {boolean} [apply] When false, only a preview of the migration is returned. When true, the new reference IDs are written to the Microsoft Graph schema extension and the returned states reflect the situation after the migration.
         * @param {string} [csvContent] Raw CSV content; preferred over the file when both are supplied
         * @param {any} [file] The SchILD migration CSV file (text/csv, max. 4 MiB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateReferenceIds: async (organizationId: string, apply?: boolean, csvContent?: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('migrateReferenceIds', 'organizationId', organizationId)
            const localVarPath = `/api/V2/{organizationId}/Users/reference-ids/migrate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (apply !== undefined) {
                localVarQueryParameter['apply'] = apply;
            }


            if (csvContent !== undefined) { 
                localVarFormParams.append('csvContent', csvContent as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.RestoreDeleted</li></ul>
         * @summary Restore a deleted user by id 🔒: Users.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreUser: async (organizationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('restoreUser', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('restoreUser', 'userId', userId)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/restore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Updates a user with the specified id. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UserUpdateOptions} userUpdateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (organizationId: string, userId: string, userUpdateOptions: UserUpdateOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('update', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('update', 'userId', userId)
            // verify required parameter 'userUpdateOptions' is not null or undefined
            assertParamExists('update', 'userUpdateOptions', userUpdateOptions)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Changes personal MNSpro Cloud settings of the specified user. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {UserSettings} userSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: async (organizationId: string, userSettings: UserSettings, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSettings', 'organizationId', organizationId)
            // verify required parameter 'userSettings' is not null or undefined
            assertParamExists('updateSettings', 'userSettings', userSettings)
            const localVarPath = `/api/V2/{organizationId}/Users/settings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary enables or disables a user 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {AccountEnabledOptions} accountEnabledOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountEnabled: async (organizationId: string, userId: string, accountEnabledOptions: AccountEnabledOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateUserAccountEnabled', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserAccountEnabled', 'userId', userId)
            // verify required parameter 'accountEnabledOptions' is not null or undefined
            assertParamExists('updateUserAccountEnabled', 'accountEnabledOptions', accountEnabledOptions)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/enabled`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountEnabledOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Updates users groups. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserGroups: async (organizationId: string, userId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateUserGroups', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserGroups', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateUserGroups', 'requestBody', requestBody)
            const localVarPath = `/api/V2/{organizationId}/Users/{userId}/groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ChangeStudentsPasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Users.ChangeStudentsPasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword: async (organizationId: string, validationParameters: ValidationParameters, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validatePassword', 'organizationId', organizationId)
            // verify required parameter 'validationParameters' is not null or undefined
            assertParamExists('validatePassword', 'validationParameters', validationParameters)
            const localVarPath = `/api/V2/{organizationId}/Users/validatePassword`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Creates a new user with the specified options. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {UserCreateOptions} userCreateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(organizationId: string, userCreateOptions: UserCreateOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(organizationId, userCreateOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithEmbeddedTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all users of the desired organization.
         * @param {string} organizationId 
         * @param {string} [nextLink] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, nextLink?: string, take?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedUsersWithEmbeddedTemplateWithAccessDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, nextLink, take, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Get all deleted users 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeleted(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEmbeddedTemplateWithAccess>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDeleted(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDomains(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDomains(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all groups 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllGroups(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupInformation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllGroups(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all available user templates specified for the provided organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTemplates(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableUserTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all courses of the specified user for the provided organization and time period. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailsUserCourses(organizationId: string, userId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseCombined>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailsUserCourses(organizationId, userId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailsUserPermissions(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModuleWithUserPermissions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailsUserPermissions(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Gets users groups. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupsOfUser(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupAssignment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupsOfUser(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns whether or not a mail/alias is available 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} [mailOrAlias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailAliasAvailable(organizationId: string, mailOrAlias?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailAliasAvailable(organizationId, mailOrAlias, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the photo of the desired user
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPhoto(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPhoto(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the profile of the current user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(request?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Gets all students of the desired organization sourced from StudentDossiers (ClassRegister V3). Returns the same shape as GetAll, but the data originates from IStudentDossiersServiceRead.GetAll instead of Azure / Microsoft Graph. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudentsFromDossiers(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudentsFromDossiers(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary create a unique universal principial name 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {GetUpnRequest} getUpnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpn(organizationId: string, getUpnRequest: GetUpnRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpn(organizationId, getUpnRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.MigrateReferenceIds</li></ul>
         * @summary Migrates user reference IDs from SchILD NRW V2 (GUID) to SchILD NRW V3 based on the mapping CSV produced by the SchILD export tool. The CSV can be sent either as a multipart/form-data file upload or as a JSON body (MigrateReferenceIdsCsvBody); the string body is preferred when both are present. Without ?apply=true only a preview of the migration is returned; with ?apply=true the new reference IDs are written to the Microsoft Graph schema extension and the returned list reflects the state after the migration. 🔒: Users.MigrateReferenceIds
         * @param {string} organizationId The organization ID.
         * @param {boolean} [apply] When false, only a preview of the migration is returned. When true, the new reference IDs are written to the Microsoft Graph schema extension and the returned states reflect the situation after the migration.
         * @param {string} [csvContent] Raw CSV content; preferred over the file when both are supplied
         * @param {any} [file] The SchILD migration CSV file (text/csv, max. 4 MiB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateReferenceIds(organizationId: string, apply?: boolean, csvContent?: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReferenceIdMigrationEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateReferenceIds(organizationId, apply, csvContent, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.RestoreDeleted</li></ul>
         * @summary Restore a deleted user by id 🔒: Users.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreUser(organizationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreUser(organizationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Updates a user with the specified id. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UserUpdateOptions} userUpdateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(organizationId: string, userId: string, userUpdateOptions: UserUpdateOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(organizationId, userId, userUpdateOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Changes personal MNSpro Cloud settings of the specified user. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {UserSettings} userSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettings(organizationId: string, userSettings: UserSettings, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettings(organizationId, userSettings, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary enables or disables a user 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {AccountEnabledOptions} accountEnabledOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccountEnabled(organizationId: string, userId: string, accountEnabledOptions: AccountEnabledOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccountEnabled(organizationId, userId, accountEnabledOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Updates users groups. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserGroups(organizationId: string, userId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserGroups(organizationId, userId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ChangeStudentsPasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Users.ChangeStudentsPasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePasswordResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePassword(organizationId, validationParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Deletes a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(organizationId: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp._delete(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Creates a new user with the specified options. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {UserCreateOptions} userCreateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, userCreateOptions: UserCreateOptions, options?: any): AxiosPromise<CreatedUserDTO> {
            return localVarFp.create(organizationId, userCreateOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets a specific user with the provided id. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(organizationId: string, userId: string, options?: any): AxiosPromise<UserWithEmbeddedTemplate> {
            return localVarFp.get(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all users of the desired organization.
         * @param {string} organizationId 
         * @param {string} [nextLink] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, nextLink?: string, take?: number, options?: any): AxiosPromise<PagedUsersWithEmbeddedTemplateWithAccessDTO> {
            return localVarFp.getAll(organizationId, nextLink, take, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Get all deleted users 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeleted(organizationId: string, options?: any): AxiosPromise<Array<UserEmbeddedTemplateWithAccess>> {
            return localVarFp.getAllDeleted(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDomains(organizationId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getAllDomains(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns all groups 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGroups(organizationId: string, options?: any): AxiosPromise<Array<GroupInformation>> {
            return localVarFp.getAllGroups(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all available user templates specified for the provided organization. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTemplates(organizationId: string, options?: any): AxiosPromise<Array<AvailableUserTemplate>> {
            return localVarFp.getAvailableTemplates(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Gets all courses of the specified user for the provided organization and time period. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsUserCourses(organizationId: string, userId: string, timePeriod?: string, options?: any): AxiosPromise<Array<CourseCombined>> {
            return localVarFp.getDetailsUserCourses(organizationId, userId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailsUserPermissions(organizationId: string, userId: string, options?: any): AxiosPromise<Array<ModuleWithUserPermissions>> {
            return localVarFp.getDetailsUserPermissions(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Gets users groups. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsOfUser(organizationId: string, userId: string, options?: any): AxiosPromise<Array<GroupAssignment>> {
            return localVarFp.getGroupsOfUser(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Returns whether or not a mail/alias is available 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {string} [mailOrAlias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailAliasAvailable(organizationId: string, mailOrAlias?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.getMailAliasAvailable(organizationId, mailOrAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the photo of the desired user
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoto(organizationId: string, userId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPhoto(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the profile of the current user.
         * @param {object} [request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(request?: object, options?: any): AxiosPromise<ProfileResponse> {
            return localVarFp.getProfile(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
         * @summary Gets all students of the desired organization sourced from StudentDossiers (ClassRegister V3). Returns the same shape as GetAll, but the data originates from IStudentDossiersServiceRead.GetAll instead of Azure / Microsoft Graph. 🔒: Reports.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentsFromDossiers(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<User>> {
            return localVarFp.getStudentsFromDossiers(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary create a unique universal principial name 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {GetUpnRequest} getUpnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpn(organizationId: string, getUpnRequest: GetUpnRequest, options?: any): AxiosPromise<string> {
            return localVarFp.getUpn(organizationId, getUpnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.MigrateReferenceIds</li></ul>
         * @summary Migrates user reference IDs from SchILD NRW V2 (GUID) to SchILD NRW V3 based on the mapping CSV produced by the SchILD export tool. The CSV can be sent either as a multipart/form-data file upload or as a JSON body (MigrateReferenceIdsCsvBody); the string body is preferred when both are present. Without ?apply=true only a preview of the migration is returned; with ?apply=true the new reference IDs are written to the Microsoft Graph schema extension and the returned list reflects the state after the migration. 🔒: Users.MigrateReferenceIds
         * @param {string} organizationId The organization ID.
         * @param {boolean} [apply] When false, only a preview of the migration is returned. When true, the new reference IDs are written to the Microsoft Graph schema extension and the returned states reflect the situation after the migration.
         * @param {string} [csvContent] Raw CSV content; preferred over the file when both are supplied
         * @param {any} [file] The SchILD migration CSV file (text/csv, max. 4 MiB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateReferenceIds(organizationId: string, apply?: boolean, csvContent?: string, file?: any, options?: any): AxiosPromise<Array<ReferenceIdMigrationEntryDto>> {
            return localVarFp.migrateReferenceIds(organizationId, apply, csvContent, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.RestoreDeleted</li></ul>
         * @summary Restore a deleted user by id 🔒: Users.RestoreDeleted
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreUser(organizationId: string, userId: string, options?: any): AxiosPromise<User> {
            return localVarFp.restoreUser(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
         * @summary Updates a user with the specified id. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UserUpdateOptions} userUpdateOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(organizationId: string, userId: string, userUpdateOptions: UserUpdateOptions, options?: any): AxiosPromise<User> {
            return localVarFp.update(organizationId, userId, userUpdateOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
         * @summary Changes personal MNSpro Cloud settings of the specified user. 🔒: Users.ShowModule
         * @param {string} organizationId 
         * @param {UserSettings} userSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(organizationId: string, userSettings: UserSettings, options?: any): AxiosPromise<UserSettings> {
            return localVarFp.updateSettings(organizationId, userSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary enables or disables a user 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {AccountEnabledOptions} accountEnabledOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountEnabled(organizationId: string, userId: string, accountEnabledOptions: AccountEnabledOptions, options?: any): AxiosPromise<User> {
            return localVarFp.updateUserAccountEnabled(organizationId, userId, accountEnabledOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
         * @summary Updates users groups. 🔒: Users.ReadWriteUsersForUserTemplate
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserGroups(organizationId: string, userId: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserGroups(organizationId, userId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Users.ChangeStudentsPasswords</li></ul>
         * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Users.ChangeStudentsPasswords
         * @param {string} organizationId 
         * @param {ValidationParameters} validationParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any): AxiosPromise<ValidatePasswordResponse> {
            return localVarFp.validatePassword(organizationId, validationParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Deletes a specific user with the provided id. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public _delete(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration)._delete(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
     * @summary Creates a new user with the specified options. 🔒: Users.ReadWriteUsersForUserTemplate
     * @param {string} organizationId 
     * @param {UserCreateOptions} userCreateOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public create(organizationId: string, userCreateOptions: UserCreateOptions, options?: any) {
        return UsersApiFp(this.configuration).create(organizationId, userCreateOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Gets a specific user with the provided id. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public get(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration).get(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all users of the desired organization.
     * @param {string} organizationId 
     * @param {string} [nextLink] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAll(organizationId: string, nextLink?: string, take?: number, options?: any) {
        return UsersApiFp(this.configuration).getAll(organizationId, nextLink, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Get all deleted users 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllDeleted(organizationId: string, options?: any) {
        return UsersApiFp(this.configuration).getAllDeleted(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllDomains(organizationId: string, options?: any) {
        return UsersApiFp(this.configuration).getAllDomains(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Returns all groups 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllGroups(organizationId: string, options?: any) {
        return UsersApiFp(this.configuration).getAllGroups(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Gets all available user templates specified for the provided organization. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAvailableTemplates(organizationId: string, options?: any) {
        return UsersApiFp(this.configuration).getAvailableTemplates(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Gets all courses of the specified user for the provided organization and time period. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getDetailsUserCourses(organizationId: string, userId: string, timePeriod?: string, options?: any) {
        return UsersApiFp(this.configuration).getDetailsUserCourses(organizationId, userId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getDetailsUserPermissions(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration).getDetailsUserPermissions(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
     * @summary Gets users groups. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getGroupsOfUser(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration).getGroupsOfUser(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Returns whether or not a mail/alias is available 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {string} [mailOrAlias] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMailAliasAvailable(organizationId: string, mailOrAlias?: string, options?: any) {
        return UsersApiFp(this.configuration).getMailAliasAvailable(organizationId, mailOrAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the photo of the desired user
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPhoto(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration).getPhoto(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the profile of the current user.
     * @param {object} [request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getProfile(request?: object, options?: any) {
        return UsersApiFp(this.configuration).getProfile(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Reports.ShowModule</li></ul>
     * @summary Gets all students of the desired organization sourced from StudentDossiers (ClassRegister V3). Returns the same shape as GetAll, but the data originates from IStudentDossiersServiceRead.GetAll instead of Azure / Microsoft Graph. 🔒: Reports.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getStudentsFromDossiers(organizationId: string, timePeriod?: string, options?: any) {
        return UsersApiFp(this.configuration).getStudentsFromDossiers(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary create a unique universal principial name 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {GetUpnRequest} getUpnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUpn(organizationId: string, getUpnRequest: GetUpnRequest, options?: any) {
        return UsersApiFp(this.configuration).getUpn(organizationId, getUpnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.MigrateReferenceIds</li></ul>
     * @summary Migrates user reference IDs from SchILD NRW V2 (GUID) to SchILD NRW V3 based on the mapping CSV produced by the SchILD export tool. The CSV can be sent either as a multipart/form-data file upload or as a JSON body (MigrateReferenceIdsCsvBody); the string body is preferred when both are present. Without ?apply=true only a preview of the migration is returned; with ?apply=true the new reference IDs are written to the Microsoft Graph schema extension and the returned list reflects the state after the migration. 🔒: Users.MigrateReferenceIds
     * @param {string} organizationId The organization ID.
     * @param {boolean} [apply] When false, only a preview of the migration is returned. When true, the new reference IDs are written to the Microsoft Graph schema extension and the returned states reflect the situation after the migration.
     * @param {string} [csvContent] Raw CSV content; preferred over the file when both are supplied
     * @param {any} [file] The SchILD migration CSV file (text/csv, max. 4 MiB)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public migrateReferenceIds(organizationId: string, apply?: boolean, csvContent?: string, file?: any, options?: any) {
        return UsersApiFp(this.configuration).migrateReferenceIds(organizationId, apply, csvContent, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.RestoreDeleted</li></ul>
     * @summary Restore a deleted user by id 🔒: Users.RestoreDeleted
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public restoreUser(organizationId: string, userId: string, options?: any) {
        return UsersApiFp(this.configuration).restoreUser(organizationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li><li>Users.EditStudents</li></ul>
     * @summary Updates a user with the specified id. 🔒: Users.ReadWriteUsersForUserTemplate, Users.EditStudents
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {UserUpdateOptions} userUpdateOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public update(organizationId: string, userId: string, userUpdateOptions: UserUpdateOptions, options?: any) {
        return UsersApiFp(this.configuration).update(organizationId, userId, userUpdateOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ShowModule</li></ul>
     * @summary Changes personal MNSpro Cloud settings of the specified user. 🔒: Users.ShowModule
     * @param {string} organizationId 
     * @param {UserSettings} userSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateSettings(organizationId: string, userSettings: UserSettings, options?: any) {
        return UsersApiFp(this.configuration).updateSettings(organizationId, userSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
     * @summary enables or disables a user 🔒: Users.ReadWriteUsersForUserTemplate
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {AccountEnabledOptions} accountEnabledOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserAccountEnabled(organizationId: string, userId: string, accountEnabledOptions: AccountEnabledOptions, options?: any) {
        return UsersApiFp(this.configuration).updateUserAccountEnabled(organizationId, userId, accountEnabledOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ReadWriteUsersForUserTemplate</li></ul>
     * @summary Updates users groups. 🔒: Users.ReadWriteUsersForUserTemplate
     * @param {string} organizationId 
     * @param {string} userId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserGroups(organizationId: string, userId: string, requestBody: Array<string>, options?: any) {
        return UsersApiFp(this.configuration).updateUserGroups(organizationId, userId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Users.ChangeStudentsPasswords</li></ul>
     * @summary Validates a password by respecting the requirements of the specified azure organization/tenant. 🔒: Users.ChangeStudentsPasswords
     * @param {string} organizationId 
     * @param {ValidationParameters} validationParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public validatePassword(organizationId: string, validationParameters: ValidationParameters, options?: any) {
        return UsersApiFp(this.configuration).validatePassword(organizationId, validationParameters, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebinarsApi - axios parameter creator
 * @export
 */
export const WebinarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a category. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarCategoryOptions} [webinarCategoryOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (organizationId: string, webinarCategoryOptions?: WebinarCategoryOptions, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCategory', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/categories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarCategoryOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPost} webinarPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebinar: async (organizationId: string, webinarPost: WebinarPost, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createWebinar', 'organizationId', organizationId)
            // verify required parameter 'webinarPost' is not null or undefined
            assertParamExists('createWebinar', 'webinarPost', webinarPost)
            const localVarPath = `/api/v2/Webinars/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a category. 🔒: AixConcept.Only
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (categoryId: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteCategory', 'categoryId', categoryId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCategory', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a webinar. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebinar: async (organizationId: string, webinarId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteWebinar', 'organizationId', organizationId)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('deleteWebinar', 'webinarId', webinarId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/{webinarId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all categories.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCategories', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/categories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all webinars for this organization.
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebinars: async (organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWebinars', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Webinars/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all webinars for this organization. Aix-Only. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebinarsAix: async (organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWebinarsAix', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/aix`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Searches for webinars containing the provided terms in the title of the webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {WebinarsSearchOptions} webinarsSearchOptions 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (organizationId: string, webinarsSearchOptions: WebinarsSearchOptions, continuationToken?: string, maxSize?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('search', 'organizationId', organizationId)
            // verify required parameter 'webinarsSearchOptions' is not null or undefined
            assertParamExists('search', 'webinarsSearchOptions', webinarsSearchOptions)
            const localVarPath = `/api/v2/Webinars/{organizationId}/search`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (continuationToken !== undefined) {
                localVarQueryParameter['continuationToken'] = continuationToken;
            }

            if (maxSize !== undefined) {
                localVarQueryParameter['maxSize'] = maxSize;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarsSearchOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Subscribe myself to a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebinar: async (organizationId: string, webinarId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('subscribeWebinar', 'organizationId', organizationId)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('subscribeWebinar', 'webinarId', webinarId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/me/{webinarId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Unsubscribe myself from a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebinar: async (organizationId: string, webinarId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unsubscribeWebinar', 'organizationId', organizationId)
            // verify required parameter 'webinarId' is not null or undefined
            assertParamExists('unsubscribeWebinar', 'webinarId', webinarId)
            const localVarPath = `/api/v2/Webinars/{organizationId}/me/{webinarId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"webinarId"}}`, encodeURIComponent(String(webinarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPut} webinarPut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebinar: async (organizationId: string, webinarPut: WebinarPut, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateWebinar', 'organizationId', organizationId)
            // verify required parameter 'webinarPut' is not null or undefined
            assertParamExists('updateWebinar', 'webinarPut', webinarPut)
            const localVarPath = `/api/v2/Webinars/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarPut, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebinarsApi - functional programming interface
 * @export
 */
export const WebinarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebinarsApiAxiosParamCreator(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a category. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarCategoryOptions} [webinarCategoryOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(organizationId: string, webinarCategoryOptions?: WebinarCategoryOptions, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(organizationId, webinarCategoryOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPost} webinarPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWebinar(organizationId: string, webinarPost: WebinarPost, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWebinar(organizationId, webinarPost, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a category. 🔒: AixConcept.Only
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(categoryId: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(categoryId, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a webinar. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebinar(organizationId: string, webinarId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebinar(organizationId, webinarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all categories.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebinarCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all webinars for this organization.
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebinars(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfWebinarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebinars(organizationId, category, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all webinars for this organization. Aix-Only. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebinarsAix(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfWebinarAixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebinarsAix(organizationId, category, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Searches for webinars containing the provided terms in the title of the webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {WebinarsSearchOptions} webinarsSearchOptions 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(organizationId: string, webinarsSearchOptions: WebinarsSearchOptions, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOfWebinarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(organizationId, webinarsSearchOptions, continuationToken, maxSize, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Subscribe myself to a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeWebinar(organizationId: string, webinarId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeWebinar(organizationId, webinarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Unsubscribe myself from a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeWebinar(organizationId: string, webinarId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeWebinar(organizationId, webinarId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPut} webinarPut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWebinar(organizationId: string, webinarPut: WebinarPut, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWebinar(organizationId, webinarPut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebinarsApi - factory interface
 * @export
 */
export const WebinarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebinarsApiFp(configuration)
    return {
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a category. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarCategoryOptions} [webinarCategoryOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(organizationId: string, webinarCategoryOptions?: WebinarCategoryOptions, options?: any): AxiosPromise<WebinarCategory> {
            return localVarFp.createCategory(organizationId, webinarCategoryOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Creates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPost} webinarPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebinar(organizationId: string, webinarPost: WebinarPost, options?: any): AxiosPromise<WebinarAixResponse> {
            return localVarFp.createWebinar(organizationId, webinarPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a category. 🔒: AixConcept.Only
         * @param {string} categoryId 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(categoryId: string, organizationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCategory(categoryId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Deletes a webinar. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebinar(organizationId: string, webinarId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWebinar(organizationId, webinarId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all categories.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(organizationId: string, options?: any): AxiosPromise<Array<WebinarCategory>> {
            return localVarFp.getCategories(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all webinars for this organization.
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebinars(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfWebinarResponse> {
            return localVarFp.getWebinars(organizationId, category, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Returns all webinars for this organization. Aix-Only. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {Array<string>} [category] 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebinarsAix(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfWebinarAixResponse> {
            return localVarFp.getWebinarsAix(organizationId, category, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Searches for webinars containing the provided terms in the title of the webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {WebinarsSearchOptions} webinarsSearchOptions 
         * @param {string} [continuationToken] 
         * @param {number} [maxSize] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(organizationId: string, webinarsSearchOptions: WebinarsSearchOptions, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedOfWebinarResponse> {
            return localVarFp.search(organizationId, webinarsSearchOptions, continuationToken, maxSize, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Subscribe myself to a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeWebinar(organizationId: string, webinarId: string, options?: any): AxiosPromise<WebinarResponse> {
            return localVarFp.subscribeWebinar(organizationId, webinarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
         * @summary Unsubscribe myself from a webinar. 🔒: Webinars.ShowModule
         * @param {string} organizationId 
         * @param {string} webinarId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeWebinar(organizationId: string, webinarId: string, options?: any): AxiosPromise<WebinarResponse> {
            return localVarFp.unsubscribeWebinar(organizationId, webinarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
         * @summary Updates a webinar and its subscribers. 🔒: AixConcept.Only
         * @param {string} organizationId 
         * @param {WebinarPut} webinarPut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebinar(organizationId: string, webinarPut: WebinarPut, options?: any): AxiosPromise<WebinarAixResponse> {
            return localVarFp.updateWebinar(organizationId, webinarPut, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebinarsApi - object-oriented interface
 * @export
 * @class WebinarsApi
 * @extends {BaseAPI}
 */
export class WebinarsApi extends BaseAPI {
    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a category. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WebinarCategoryOptions} [webinarCategoryOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public createCategory(organizationId: string, webinarCategoryOptions?: WebinarCategoryOptions, options?: any) {
        return WebinarsApiFp(this.configuration).createCategory(organizationId, webinarCategoryOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Creates a webinar and its subscribers. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WebinarPost} webinarPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public createWebinar(organizationId: string, webinarPost: WebinarPost, options?: any) {
        return WebinarsApiFp(this.configuration).createWebinar(organizationId, webinarPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a category. 🔒: AixConcept.Only
     * @param {string} categoryId 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public deleteCategory(categoryId: string, organizationId: string, options?: any) {
        return WebinarsApiFp(this.configuration).deleteCategory(categoryId, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Deletes a webinar. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {string} webinarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public deleteWebinar(organizationId: string, webinarId: string, options?: any) {
        return WebinarsApiFp(this.configuration).deleteWebinar(organizationId, webinarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all categories.
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public getCategories(organizationId: string, options?: any) {
        return WebinarsApiFp(this.configuration).getCategories(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all webinars for this organization.
     * @param {string} organizationId 
     * @param {Array<string>} [category] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public getWebinars(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return WebinarsApiFp(this.configuration).getWebinars(organizationId, category, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Returns all webinars for this organization. Aix-Only. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {Array<string>} [category] 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public getWebinarsAix(organizationId: string, category?: Array<string>, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return WebinarsApiFp(this.configuration).getWebinarsAix(organizationId, category, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
     * @summary Searches for webinars containing the provided terms in the title of the webinar. 🔒: Webinars.ShowModule
     * @param {string} organizationId 
     * @param {WebinarsSearchOptions} webinarsSearchOptions 
     * @param {string} [continuationToken] 
     * @param {number} [maxSize] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public search(organizationId: string, webinarsSearchOptions: WebinarsSearchOptions, continuationToken?: string, maxSize?: number, pageSize?: number, options?: any) {
        return WebinarsApiFp(this.configuration).search(organizationId, webinarsSearchOptions, continuationToken, maxSize, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
     * @summary Subscribe myself to a webinar. 🔒: Webinars.ShowModule
     * @param {string} organizationId 
     * @param {string} webinarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public subscribeWebinar(organizationId: string, webinarId: string, options?: any) {
        return WebinarsApiFp(this.configuration).subscribeWebinar(organizationId, webinarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Webinars.ShowModule</li></ul>
     * @summary Unsubscribe myself from a webinar. 🔒: Webinars.ShowModule
     * @param {string} organizationId 
     * @param {string} webinarId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public unsubscribeWebinar(organizationId: string, webinarId: string, options?: any) {
        return WebinarsApiFp(this.configuration).unsubscribeWebinar(organizationId, webinarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>AixConcept.Only</li></ul>
     * @summary Updates a webinar and its subscribers. 🔒: AixConcept.Only
     * @param {string} organizationId 
     * @param {WebinarPut} webinarPut 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarsApi
     */
    public updateWebinar(organizationId: string, webinarPut: WebinarPut, options?: any) {
        return WebinarsApiFp(this.configuration).updateWebinar(organizationId, webinarPut, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkgroupsApi - axios parameter creator
 * @export
 */
export const WorkgroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds members to the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMembers: async (id: string, organizationId: string, members?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addMembers', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addMembers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/members/add`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (members) {
                localVarQueryParameter['members'] = members;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Demotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoteMember: async (organizationId: string, workGroupId: string, memberIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('demoteMember', 'organizationId', organizationId)
            // verify required parameter 'workGroupId' is not null or undefined
            assertParamExists('demoteMember', 'workGroupId', workGroupId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{workGroupId}/members/demote`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"workGroupId"}}`, encodeURIComponent(String(workGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (memberIds) {
                localVarQueryParameter['memberIds'] = memberIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the requested Azure Workgroup. Returns 404 if workgroup or organization was not found.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('get', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all azure workgroups of which the user is member or owner in the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAll', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all events of the specified workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (id: string, organizationId: string, end?: string, start?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvents', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvents', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all items within the root drive of the workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMaterial', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMaterial', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/material`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all members of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMembers', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMembers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Returns all files within the work groups one drive. 🔒: Workgroups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDrive: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyDrive', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMyDrive', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/MyDrive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all owners of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners: async (id: string, organizationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOwners', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOwners', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/owners`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Get all workgroups with missing notebook. 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithMissingNotebook: async (organizationId: string, timePeriod?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getWithMissingNotebook', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/notebooks/missing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timePeriod !== undefined) {
                localVarQueryParameter['timePeriod'] = timePeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary PRomotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteMember: async (organizationId: string, workGroupId: string, memberIds?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('promoteMember', 'organizationId', organizationId)
            // verify required parameter 'workGroupId' is not null or undefined
            assertParamExists('promoteMember', 'workGroupId', workGroupId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{workGroupId}/members/promote`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"workGroupId"}}`, encodeURIComponent(String(workGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (memberIds) {
                localVarQueryParameter['memberIds'] = memberIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes members from the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMembers: async (id: string, organizationId: string, members?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeMembers', 'id', id)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeMembers', 'organizationId', organizationId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/workgroup/{id}/members/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (members) {
                localVarQueryParameter['members'] = members;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairTeamOwnerShip: async (organizationId: string, workgroupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('repairTeamOwnerShip', 'organizationId', organizationId)
            // verify required parameter 'workgroupId' is not null or undefined
            assertParamExists('repairTeamOwnerShip', 'workgroupId', workgroupId)
            const localVarPath = `/api/v2/Workgroups/{organizationId}/repair/{workgroupId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"workgroupId"}}`, encodeURIComponent(String(workgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkgroupsApi - functional programming interface
 * @export
 */
export const WorkgroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkgroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds members to the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMembers(id: string, organizationId: string, members?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMembers(id, organizationId, members, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Demotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demoteMember(organizationId, workGroupId, memberIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the requested Azure Workgroup. Returns 404 if workgroup or organization was not found.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workgroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all azure workgroups of which the user is member or owner in the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Workgroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all events of the specified workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkgroupEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(id, organizationId, end, start, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all items within the root drive of the workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaterial(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkgroupDriveItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaterial(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all members of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembers(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkgroupMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembers(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Returns all files within the work groups one drive. 🔒: Workgroups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyDrive(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkgroupDriveItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyDrive(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all owners of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwners(id: string, organizationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkgroupMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwners(id, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Get all workgroups with missing notebook. 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Workgroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWithMissingNotebook(organizationId, timePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary PRomotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteMember(organizationId, workGroupId, memberIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes members from the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMembers(id: string, organizationId: string, members?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMembers(id, organizationId, members, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repairTeamOwnerShip(organizationId: string, workgroupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repairTeamOwnerShip(organizationId, workgroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkgroupsApi - factory interface
 * @export
 */
export const WorkgroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkgroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds members to the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMembers(id: string, organizationId: string, members?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.addMembers(id, organizationId, members, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Demotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.demoteMember(organizationId, workGroupId, memberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the requested Azure Workgroup. Returns 404 if workgroup or organization was not found.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, organizationId: string, options?: any): AxiosPromise<Workgroup> {
            return localVarFp.get(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all azure workgroups of which the user is member or owner in the specified organization.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(organizationId: string, options?: any): AxiosPromise<Array<Workgroup>> {
            return localVarFp.getAll(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all events of the specified workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {string} [end] 
         * @param {string} [start] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any): AxiosPromise<Array<WorkgroupEvent>> {
            return localVarFp.getEvents(id, organizationId, end, start, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all items within the root drive of the workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaterial(id: string, organizationId: string, options?: any): AxiosPromise<WorkgroupDriveItem> {
            return localVarFp.getMaterial(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all members of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers(id: string, organizationId: string, options?: any): AxiosPromise<Array<WorkgroupMember>> {
            return localVarFp.getMembers(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Returns all files within the work groups one drive. 🔒: Workgroups.ShowModule
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDrive(id: string, organizationId: string, options?: any): AxiosPromise<WorkgroupDriveItem> {
            return localVarFp.getMyDrive(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all owners of the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwners(id: string, organizationId: string, options?: any): AxiosPromise<Array<WorkgroupMember>> {
            return localVarFp.getOwners(id, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary Get all workgroups with missing notebook. 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} [timePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any): AxiosPromise<Array<Workgroup>> {
            return localVarFp.getWithMissingNotebook(organizationId, timePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary PRomotes members for the given workgroup 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workGroupId 
         * @param {Array<string>} [memberIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.promoteMember(organizationId, workGroupId, memberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes members from the given workgroup.
         * @param {string} id 
         * @param {string} organizationId 
         * @param {Array<string>} [members] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMembers(id: string, organizationId: string, members?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.removeMembers(id, organizationId, members, options).then((request) => request(axios, basePath));
        },
        /**
         * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
         * @summary 🔒: Workgroups.ShowModule
         * @param {string} organizationId 
         * @param {string} workgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repairTeamOwnerShip(organizationId: string, workgroupId: string, options?: any): AxiosPromise<void> {
            return localVarFp.repairTeamOwnerShip(organizationId, workgroupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkgroupsApi - object-oriented interface
 * @export
 * @class WorkgroupsApi
 * @extends {BaseAPI}
 */
export class WorkgroupsApi extends BaseAPI {
    /**
     * 
     * @summary Adds members to the given workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {Array<string>} [members] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public addMembers(id: string, organizationId: string, members?: Array<string>, options?: any) {
        return WorkgroupsApiFp(this.configuration).addMembers(id, organizationId, members, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
     * @summary Demotes members for the given workgroup 🔒: Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} workGroupId 
     * @param {Array<string>} [memberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public demoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any) {
        return WorkgroupsApiFp(this.configuration).demoteMember(organizationId, workGroupId, memberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the requested Azure Workgroup. Returns 404 if workgroup or organization was not found.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public get(id: string, organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).get(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all azure workgroups of which the user is member or owner in the specified organization.
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getAll(organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getAll(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all events of the specified workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {string} [end] 
     * @param {string} [start] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getEvents(id: string, organizationId: string, end?: string, start?: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getEvents(id, organizationId, end, start, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all items within the root drive of the workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getMaterial(id: string, organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getMaterial(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all members of the given workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getMembers(id: string, organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getMembers(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
     * @summary Returns all files within the work groups one drive. 🔒: Workgroups.ShowModule
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getMyDrive(id: string, organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getMyDrive(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all owners of the given workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getOwners(id: string, organizationId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getOwners(id, organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
     * @summary Get all workgroups with missing notebook. 🔒: Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} [timePeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public getWithMissingNotebook(organizationId: string, timePeriod?: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).getWithMissingNotebook(organizationId, timePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
     * @summary PRomotes members for the given workgroup 🔒: Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} workGroupId 
     * @param {Array<string>} [memberIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public promoteMember(organizationId: string, workGroupId: string, memberIds?: Array<string>, options?: any) {
        return WorkgroupsApiFp(this.configuration).promoteMember(organizationId, workGroupId, memberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes members from the given workgroup.
     * @param {string} id 
     * @param {string} organizationId 
     * @param {Array<string>} [members] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public removeMembers(id: string, organizationId: string, members?: Array<string>, options?: any) {
        return WorkgroupsApiFp(this.configuration).removeMembers(id, organizationId, members, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Any of the following permissions are required:<ul><li>Workgroups.ShowModule</li></ul>
     * @summary 🔒: Workgroups.ShowModule
     * @param {string} organizationId 
     * @param {string} workgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkgroupsApi
     */
    public repairTeamOwnerShip(organizationId: string, workgroupId: string, options?: any) {
        return WorkgroupsApiFp(this.configuration).repairTeamOwnerShip(organizationId, workgroupId, options).then((request) => request(this.axios, this.basePath));
    }
}


